/** NOTE: This file has been autogenerated. Do not edit this file.
 *
 * To update this file, perform following steps:
 *  1. ensure that your local cls-api and fapi are working
 *  2. run `npm run generate` in scripts directory.
 */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: Date; output: Date };
  JSON: { input: any; output: any };
  Second: { input: any; output: any };
  Time: { input: Date; output: Date };
  URL: { input: any; output: any };
  URN: { input: string; output: string };
  URNV2: { input: any; output: any };
  UUID: { input: any; output: any };
  Upload: { input: any; output: any };
  UserID: { input: any; output: any };
  bigint: { input: any; output: any };
  catalog_item_type: { input: any; output: any };
  float8: { input: any; output: any };
  json: { input: any; output: any };
  jsonb: { input: any; output: any };
  learning_journey_completion_criteria: { input: any; output: any };
  learning_journey_status: { input: any; output: any };
  learning_status: { input: any; output: any };
  learning_type: { input: any; output: any };
  learning_visibility: { input: any; output: any };
  numeric: { input: any; output: any };
  timestamptz: { input: any; output: any };
  uuid: { input: any; output: any };
};

export enum RAccountStatus {
  Deactivated = 'deactivated',
  Incomplete = 'incomplete',
  Pending = 'pending',
  Registered = 'registered',
}

export type RAddAssignmentUserSurveyResult = {
  __typename?: 'AddAssignmentUserSurveyResult';
  success: Scalars['Boolean']['output'];
};

export type RAddSelfTrackedLearningToLearningLoopInput = {
  description: Scalars['String']['input'];
  effort: Scalars['Int']['input'];
  learningLoopId: Scalars['String']['input'];
  link: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: RSelfTrackedLearningType;
  userId: Scalars['Int']['input'];
};

export type RAddSelfTrackedLearningToLearningLoopResult = {
  __typename?: 'AddSelfTrackedLearningToLearningLoopResult';
  learningLoop: RLearningLoop;
  learningSelfTracked: RSelfTrackedLearning;
  success: Scalars['Boolean']['output'];
};

export type RAddSpaceContentOriginInput = {
  contentOriginId: Scalars['String']['input'];
  spaceId: Scalars['Int']['input'];
};

export type RAggregation = {
  __typename?: 'Aggregation';
  data?: Maybe<Scalars['JSON']['output']>;
};

export type RAggregationNameInput = {
  name: Scalars['String']['input'];
};

export type RAnalyticsProgress = {
  __typename?: 'AnalyticsProgress';
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  learning_id?: Maybe<Scalars['Int']['output']>;
};

export enum RAnalyticsUserSortField {
  Completed = 'COMPLETED',
  CompletedNotExpired = 'COMPLETED_NOT_EXPIRED',
  Effort = 'EFFORT',
  Started = 'STARTED',
}

export type RAnalyticsUserSortInput = {
  field: RAnalyticsUserSortField;
  order?: RSortOrder;
};

export type RArticleRedirect = {
  __typename?: 'ArticleRedirect';
  learningId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RAssignmentAssignmentsV3UsersFilter = {
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  statusIN?: InputMaybe<Array<RAssignmentUserCompletionStatus>>;
  userIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  userTeamIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RAssignmentStandardV3 = RAssignmentV3 & {
  __typename?: 'AssignmentStandardV3';
  automated: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  learnings: RAssignmentV3LearningPage;
  name: Scalars['String']['output'];
  progress: RAssignmentV3Progress;
  rules?: Maybe<RAssignmentsV3Rule>;
  spaceId: Scalars['Int']['output'];
  status?: Maybe<RAssignmentV3Status>;
  surveyId?: Maybe<Scalars['String']['output']>;
  teaser: Scalars['String']['output'];
  templateId?: Maybe<Scalars['Int']['output']>;
  type: RAssignmentV3Type;
  updatedAt: Scalars['DateTime']['output'];
  users: RAssignmentV3UsersPage;
};

export type RAssignmentStandardV3LearningsArgs = {
  pagination?: InputMaybe<RPagination>;
};

export type RAssignmentStandardV3ProgressArgs = {
  filter: RAssignmentV3ProgressFilter;
};

export type RAssignmentStandardV3UsersArgs = {
  filter?: InputMaybe<RAssignmentAssignmentsV3UsersFilter>;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RAssignmentUsersV3Sort>;
};

export type RAssignmentStandardV3Learning = RAssignmentV3Learning & {
  __typename?: 'AssignmentStandardV3Learning';
  assignmentGroupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  learningId?: Maybe<Scalars['Int']['output']>;
  learningPathId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  type: RAssignmentStandardV3LearningType;
};

export type RAssignmentStandardV3LearningPage = RAssignmentV3LearningPage & {
  __typename?: 'AssignmentStandardV3LearningPage';
  data: Array<RAssignmentStandardV3Learning>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum RAssignmentStandardV3LearningType {
  Mandatory = 'MANDATORY',
  Suggested = 'SUGGESTED',
}

export type RAssignmentStandardV3User = RAssignmentV3User & {
  __typename?: 'AssignmentStandardV3User';
  agent: RAssignmentV3UserAgent;
  assignmentId: Scalars['Int']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  progress: RAssignmentStandardV3UserProgress;
  user: RUserV2;
  userId: Scalars['Int']['output'];
};

export type RAssignmentStandardV3UserParticipation = {
  __typename?: 'AssignmentStandardV3UserParticipation';
  assignmentLearningId: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  participationId: Scalars['Int']['output'];
  progress: Scalars['Float']['output'];
};

export type RAssignmentStandardV3UserProgress = {
  __typename?: 'AssignmentStandardV3UserProgress';
  completed: Scalars['Boolean']['output'];
  estimatedEffort: Scalars['Float']['output'];
  participations: Array<RAssignmentStandardV3UserParticipation>;
  requiredItemsCompletedCount: Scalars['Float']['output'];
  requiredItemsCount: Scalars['Float']['output'];
};

export type RAssignmentStandardV3UsersPage = RAssignmentV3UsersPage & {
  __typename?: 'AssignmentStandardV3UsersPage';
  data: Array<RAssignmentStandardV3User>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RAssignmentStrategicV3 = RAssignmentV3 & {
  __typename?: 'AssignmentStrategicV3';
  automated: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  learningLoopRecommendedEffort: Scalars['Int']['output'];
  learnings: RAssignmentV3LearningPage;
  name: Scalars['String']['output'];
  progress: RAssignmentStrategicV3Progress;
  rules?: Maybe<RAssignmentsV3Rule>;
  spaceId: Scalars['Int']['output'];
  startAt: Scalars['DateTime']['output'];
  status?: Maybe<RAssignmentV3Status>;
  surveyId?: Maybe<Scalars['String']['output']>;
  teaser: Scalars['String']['output'];
  templateId?: Maybe<Scalars['Int']['output']>;
  totalThresholdEffort: Scalars['Int']['output'];
  type: RAssignmentV3Type;
  updatedAt: Scalars['DateTime']['output'];
  users: RAssignmentV3UsersPage;
};

export type RAssignmentStrategicV3LearningsArgs = {
  pagination?: InputMaybe<RPagination>;
};

export type RAssignmentStrategicV3ProgressArgs = {
  filter: RAssignmentStrategicV3ProgressFilter;
};

export type RAssignmentStrategicV3UsersArgs = {
  filter?: InputMaybe<RAssignmentAssignmentsV3UsersFilter>;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RAssignmentUsersV3Sort>;
};

export type RAssignmentStrategicV3LearnersProgress = {
  __typename?: 'AssignmentStrategicV3LearnersProgress';
  activeCount: Scalars['Int']['output'];
  completedCount: Scalars['Int']['output'];
};

export type RAssignmentStrategicV3Learning = RAssignmentV3Learning & {
  __typename?: 'AssignmentStrategicV3Learning';
  assignmentGroupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  learningId?: Maybe<Scalars['Int']['output']>;
  learningPathId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type RAssignmentStrategicV3LearningPage = RAssignmentV3LearningPage & {
  __typename?: 'AssignmentStrategicV3LearningPage';
  data: Array<RAssignmentStrategicV3Learning>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RAssignmentStrategicV3Progress = {
  __typename?: 'AssignmentStrategicV3Progress';
  estimatedEffort: Scalars['Float']['output'];
  learners: RAssignmentStrategicV3LearnersProgress;
  reflections: RAssignmentStrategicV3ReflectionsProgress;
};

export type RAssignmentStrategicV3ProgressFilter = {
  periodIN?: InputMaybe<Array<RPeriodFilter>>;
  statusIN?: InputMaybe<Array<RAssignmentUserCompletionStatus>>;
  userTeamIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RAssignmentStrategicV3ReflectionsProgress = {
  __typename?: 'AssignmentStrategicV3ReflectionsProgress';
  completedCount: Scalars['Int']['output'];
  completedThreshold: Scalars['Int']['output'];
};

export type RAssignmentStrategicV3User = RAssignmentV3User & {
  __typename?: 'AssignmentStrategicV3User';
  agent: RAssignmentV3UserAgent;
  assignmentId: Scalars['Int']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  progress: RAssignmentStrategicV3UserProgress;
  user: RUserV2;
  userId: Scalars['Int']['output'];
};

export type RAssignmentStrategicV3UserProgressArgs = {
  filter?: InputMaybe<RAssignmentsV3UserStrategicProgressFilter>;
};

export type RAssignmentStrategicV3UserProgress = {
  __typename?: 'AssignmentStrategicV3UserProgress';
  active: Scalars['Boolean']['output'];
  competencyAssessment: RAssignmentStrategicV3UserSurveyProgress;
  /** @deprecated Use status field */
  completed: Scalars['Boolean']['output'];
  estimatedEffort: Scalars['Float']['output'];
  estimatedEffortProgress: Scalars['Float']['output'];
  reflectionsCompleted: Scalars['Int']['output'];
  reflectionsLimit: Scalars['Int']['output'];
  userCompletionStatus: RAssignmentUserCompletionStatus;
  weeklyCompletion: Scalars['Boolean']['output'];
};

export type RAssignmentStrategicV3UserSurveyProgress = {
  __typename?: 'AssignmentStrategicV3UserSurveyProgress';
  canTake: Scalars['Boolean']['output'];
  isTakenAtEnd: Scalars['Boolean']['output'];
  isTakenAtStart: Scalars['Boolean']['output'];
};

export type RAssignmentStrategicV3UsersPage = RAssignmentV3UsersPage & {
  __typename?: 'AssignmentStrategicV3UsersPage';
  data: Array<RAssignmentStrategicV3User>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Kind of artefact a learner submitted for an assignment activity. */
export enum RAssignmentSubmissionType {
  Document = 'DOCUMENT',
}

export type RAssignmentTemplate = {
  __typename?: 'AssignmentTemplate';
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  teaser: Scalars['String']['output'];
};

export enum RAssignmentUserCompletionStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  NotCompleted = 'NOT_COMPLETED',
}

export type RAssignmentUserSurveyInput = {
  assignmentId: Scalars['Int']['input'];
  surveyId: Scalars['String']['input'];
  surveyResponseId: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type RAssignmentUsersV3Sort = {
  field?: InputMaybe<RAssignmentUsersV3SortField>;
  order?: InputMaybe<RSortOrder>;
};

export enum RAssignmentUsersV3SortField {
  Id = 'ID',
  Name = 'NAME',
}

export type RAssignmentV3 = {
  automated: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  learnings: RAssignmentV3LearningPage;
  name: Scalars['String']['output'];
  rules?: Maybe<RAssignmentsV3Rule>;
  spaceId: Scalars['Int']['output'];
  status?: Maybe<RAssignmentV3Status>;
  surveyId?: Maybe<Scalars['String']['output']>;
  teaser: Scalars['String']['output'];
  templateId?: Maybe<Scalars['Int']['output']>;
  type: RAssignmentV3Type;
  updatedAt: Scalars['DateTime']['output'];
  users: RAssignmentV3UsersPage;
};

export type RAssignmentV3LearningsArgs = {
  pagination?: InputMaybe<RPagination>;
};

export type RAssignmentV3UsersArgs = {
  filter?: InputMaybe<RAssignmentAssignmentsV3UsersFilter>;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RAssignmentUsersV3Sort>;
};

export type RAssignmentV3Learning = {
  assignmentGroupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  learningId?: Maybe<Scalars['Int']['output']>;
  learningPathId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type RAssignmentV3LearningPage = {
  data: Array<RAssignmentV3Learning>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RAssignmentV3Progress = {
  __typename?: 'AssignmentV3Progress';
  completedCount: Scalars['Int']['output'];
  completionRate: Scalars['Float']['output'];
};

export type RAssignmentV3ProgressFilter = {
  userTeamIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum RAssignmentV3Status {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED',
}

export enum RAssignmentV3Type {
  Standard = 'STANDARD',
  Strategic = 'STRATEGIC',
}

export type RAssignmentV3User = {
  agent: RAssignmentV3UserAgent;
  assignmentId: Scalars['Int']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  user: RUserV2;
  userId: Scalars['Int']['output'];
};

export enum RAssignmentV3UserAgent {
  Manual = 'MANUAL',
  Rule = 'RULE',
}

export type RAssignmentV3UsersFilter = {
  assignmentGroupId: Scalars['Int']['input'];
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  statusIN?: InputMaybe<Array<RAssignmentUserCompletionStatus>>;
  userIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  userTeamIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RAssignmentV3UsersPage = {
  data: Array<RAssignmentV3User>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RAssignmentsV3Filter = {
  idIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  spacedIdsIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<RAssignmentV3Status>;
  type?: InputMaybe<RAssignmentV3Type>;
  userIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  userTeamIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RAssignmentsV3Page = {
  __typename?: 'AssignmentsV3Page';
  data: Array<RAssignmentV3>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RAssignmentsV3Result = {
  __typename?: 'AssignmentsV3Result';
  assignment?: Maybe<RAssignmentV3>;
  success: Scalars['Boolean']['output'];
};

export type RAssignmentsV3Rule = {
  __typename?: 'AssignmentsV3Rule';
  expressions: Array<RAssignmentsV3RuleExpression>;
  operator: RAssignmentsV3RuleOperator;
};

export enum RAssignmentsV3RuleCompareOperator {
  Equal = 'EQUAL',
  GreaterOrEqual = 'GREATER_OR_EQUAL',
  NotEqual = 'NOT_EQUAL',
}

export type RAssignmentsV3RuleCondition = {
  __typename?: 'AssignmentsV3RuleCondition';
  column: RAssignmentsV3RuleField;
  compare: RAssignmentsV3RuleCompareOperator;
  selections?: Maybe<Array<Scalars['String']['output']>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type RAssignmentsV3RuleConditionInput = {
  column: RAssignmentsV3RuleField;
  compare: RAssignmentsV3RuleCompareOperator;
  selections?: InputMaybe<Array<Scalars['String']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RAssignmentsV3RuleExpression = {
  __typename?: 'AssignmentsV3RuleExpression';
  conditions: Array<RAssignmentsV3RuleCondition>;
  operator: RAssignmentsV3RuleOperator;
};

export type RAssignmentsV3RuleExpressionInput = {
  conditions: Array<RAssignmentsV3RuleConditionInput>;
  operator: RAssignmentsV3RuleOperator;
};

export enum RAssignmentsV3RuleField {
  BusinessArea = 'BUSINESS_AREA',
  BusinessUnit = 'BUSINESS_UNIT',
  CompanyId = 'COMPANY_ID',
  Country = 'COUNTRY',
  DepartmentName = 'DEPARTMENT_NAME',
  DeptId = 'DEPT_ID',
  Division = 'DIVISION',
  Indicator = 'INDICATOR',
  JobCode = 'JOB_CODE',
  JobEntryDate = 'JOB_ENTRY_DATE',
  JobFamily = 'JOB_FAMILY',
  JobFunct = 'JOB_FUNCT',
  MgrEmail = 'MGR_EMAIL',
  OrgRelation = 'ORG_RELATION',
  PayStatus = 'PAY_STATUS',
  Product = 'PRODUCT',
  ProductArea = 'PRODUCT_AREA',
  StartDate = 'START_DATE',
  Subfunction = 'SUBFUNCTION',
  SupervisorLvl = 'SUPERVISOR_LVL',
}

export type RAssignmentsV3RuleInput = {
  expressions: Array<RAssignmentsV3RuleExpressionInput>;
  operator: RAssignmentsV3RuleOperator;
};

export enum RAssignmentsV3RuleOperator {
  And = 'AND',
  Or = 'OR',
}

export type RAssignmentsV3Sort = {
  field?: InputMaybe<RAssignmentsV3SortField>;
  order?: InputMaybe<RSortOrder>;
};

export enum RAssignmentsV3SortField {
  Id = 'ID',
  Name = 'NAME',
  TypeV2 = 'TYPE_V2',
}

export type RAssignmentsV3UserRuleField = {
  __typename?: 'AssignmentsV3UserRuleField';
  field: Scalars['String']['output'];
  values: Array<Maybe<Scalars['String']['output']>>;
};

export type RAssignmentsV3UserRuleFieldFilter = {
  rules?: InputMaybe<RAssignmentsV3RuleInput>;
  spaceId: Scalars['Int']['input'];
};

export type RAssignmentsV3UserRulePreview = {
  __typename?: 'AssignmentsV3UserRulePreview';
  users: Array<RAssignmentsV3UserRulePreviewUser>;
};

export type RAssignmentsV3UserRulePreviewFilter = {
  rules: RAssignmentsV3RuleInput;
  spaceId: Scalars['Int']['input'];
};

export type RAssignmentsV3UserRulePreviewUser = {
  __typename?: 'AssignmentsV3UserRulePreviewUser';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  profileImage?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type RAssignmentsV3UserStrategicProgressFilter = {
  periodIN?: InputMaybe<Array<RPeriodFilter>>;
};

export enum RAttendedType {
  Attended = 'ATTENDED',
  Enrolled = 'ENROLLED',
  NotAttended = 'NOT_ATTENDED',
  Waitlisted = 'WAITLISTED',
}

export type RBabelonNotification = {
  __typename?: 'BabelonNotification';
  id: Scalars['ID']['output'];
  notificationType?: Maybe<RBabelonNotificationType>;
  postId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productTitle?: Maybe<Scalars['String']['output']>;
  replyId?: Maybe<Scalars['Int']['output']>;
  respondentName?: Maybe<Scalars['String']['output']>;
  sectionPath?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  topLevelPostId?: Maybe<Scalars['Int']['output']>;
  topLevelPostTitle?: Maybe<Scalars['String']['output']>;
};

export enum RBabelonNotificationType {
  Like = 'LIKE',
  Reply = 'REPLY',
}

export type RBatchEnrollmentResponse = {
  __typename?: 'BatchEnrollmentResponse';
  created?: Maybe<Array<Maybe<RLocationEnrollment>>>;
  skipped?: Maybe<Array<Maybe<RFailedEnrollmentMessage>>>;
};

export type RBlock = {
  __typename?: 'Block';
  created?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
};

export type RBlockInput = {
  created?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
};

export type RBlockV2 = {
  __typename?: 'BlockV2';
  data: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  pageId: Scalars['Int']['output'];
  type: RBlockV2Type;
  urn: Scalars['String']['output'];
};

export type RBlockV2Input = {
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
  pageId: Scalars['Int']['input'];
  type: RBlockV2Type;
};

export enum RBlockV2Type {
  Audio = 'AUDIO',
  Image = 'IMAGE',
  PracticalAssessmentTask = 'PRACTICAL_ASSESSMENT_TASK',
  Question = 'QUESTION',
  Reflection = 'REFLECTION',
  Resource = 'RESOURCE',
  Text = 'TEXT',
  Video = 'VIDEO',
  VideoLink = 'VIDEO_LINK',
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type RBoolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type RCatalog = {
  __typename?: 'Catalog';
  cards?: Maybe<Array<Maybe<RCourseCard>>>;
};

export enum RCatalogCardType {
  Collection = 'collection',
  Journey = 'journey',
  Learning = 'learning',
  Product = 'product',
}

export type RCatalogItems = {
  entity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type RCategory = {
  __typename?: 'Category';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subjects?: Maybe<Array<Maybe<RSubject>>>;
  urlKey?: Maybe<Scalars['String']['output']>;
};

export type RCertificateLogo = {
  __typename?: 'CertificateLogo';
  logoUrl?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  organisationText?: Maybe<Scalars['String']['output']>;
};

export type RCertificateLogoInput = {
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  organisationText?: InputMaybe<Scalars['String']['input']>;
};

export type RCertificateProperties = {
  __typename?: 'CertificateProperties';
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  logos: Array<RCertificateLogo>;
  signatures: Array<RCertificateSignature>;
  templateType: RCertificateTemplateType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['Int']['output'];
  urn: Scalars['URN']['output'];
};

export type RCertificateSignature = {
  __typename?: 'CertificateSignature';
  institution?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  signatureUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RCertificateSignatureInput = {
  institution?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  signatureUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum RCertificateTemplateType {
  Classic = 'CLASSIC',
  Professional = 'PROFESSIONAL',
}

export type RChangeEnrollmentLocationInput = {
  enrollmentId: Scalars['Int']['input'];
  newLocationId: Scalars['Int']['input'];
};

export type RCloneLearningInput = {
  learningId: Scalars['Int']['input'];
  spaceId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RCloneLearningJourneyInput = {
  id: Scalars['Int']['input'];
  spaceId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type RCollectionCard = RCourseCard & {
  __typename?: 'CollectionCard';
  archived?: Maybe<Scalars['Boolean']['output']>;
  available?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  entity: Scalars['String']['output'];
  entityId: Scalars['Int']['output'];
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<RCollectionItemShort>>>;
  language?: Maybe<Scalars['String']['output']>;
  languageId?: Maybe<Scalars['Int']['output']>;
  participation?: Maybe<RParticipation>;
  provider?: Maybe<Scalars['String']['output']>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  subjects?: Maybe<Array<Maybe<RLearningSubject>>>;
  teaser?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<RLearningVisibility>;
};

export type RCollectionItemInput = {
  learningId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<RLearningVisibility>;
};

export type RCollectionItemShort = {
  __typename?: 'CollectionItemShort';
  learningId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<RLearningVisibility>;
};

export type RCompletionPerElearning = {
  __typename?: 'CompletionPerElearning';
  completed: Scalars['Boolean']['output'];
  learning_id: Scalars['Int']['output'];
};

export type RCompletionRatePerCourse = {
  __typename?: 'CompletionRatePerCourse';
  completed?: Maybe<Scalars['Int']['output']>;
  completion_rate?: Maybe<Scalars['Float']['output']>;
  object_id?: Maybe<Scalars['String']['output']>;
  object_name?: Maybe<Scalars['String']['output']>;
  object_type?: Maybe<Scalars['String']['output']>;
  progressed?: Maybe<Scalars['Int']['output']>;
};

export type RCourseCard = {
  archived?: Maybe<Scalars['Boolean']['output']>;
  available?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  entity: Scalars['String']['output'];
  entityId: Scalars['Int']['output'];
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  languageId?: Maybe<Scalars['Int']['output']>;
  participation?: Maybe<RParticipation>;
  provider?: Maybe<Scalars['String']['output']>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  subjects?: Maybe<Array<Maybe<RLearningSubject>>>;
  teaser?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<RLearningVisibility>;
};

export type RCreateAssignmentFromTemplateInput = {
  assignmentTemplateId: Scalars['Int']['input'];
  createExportWebinar: Scalars['Boolean']['input'];
  createGetStartedLearning: Scalars['Boolean']['input'];
  createKickOffWebinar: Scalars['Boolean']['input'];
  createManagerCheckIn: Scalars['Boolean']['input'];
  createTeamsChannel: Scalars['Boolean']['input'];
  endAt: Scalars['DateTime']['input'];
  spaceId: Scalars['Int']['input'];
  startAt: Scalars['DateTime']['input'];
};

export type RCreateCollection = {
  contentOwner?: InputMaybe<Scalars['Int']['input']>;
  creator?: InputMaybe<Scalars['Int']['input']>;
  imageUrl: Scalars['String']['input'];
  languageId: Scalars['Int']['input'];
  spaceId: Scalars['Int']['input'];
  status: RLearningStatus;
  subjectId: Scalars['Int']['input'];
  teaser: Scalars['String']['input'];
  title: Scalars['String']['input'];
  visibility: RLearningVisibility;
};

export type RCreateLearningJourneyFromTemplateInput = {
  engagementLearnings?: InputMaybe<REngagementLearnings>;
  sourceTemplateId: Scalars['Int']['input'];
  spaceId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type RCreateLearningJourneyInput = {
  spaceId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type RCreateLearningJourneyLiveEventInput = {
  bannerURL?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  locations: Array<RCreateLearningJourneyLiveEventLocationInput>;
  plannedDuration: Scalars['Int']['input'];
  spaceId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type RCreateLearningJourneyLiveEventLocationInput = {
  address: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['Int']['input']>;
  type: RLocationType;
};

export type RCreateLearningJourneyPracticalAssessmentsInput = {
  practicalAssessmentTemplateIdsIN: Array<Scalars['Int']['input']>;
  spaceId: Scalars['Int']['input'];
};

export type RCreateLearningLoopReflectionInput = {
  applied: RLearningLoopReflectionApplied;
  description: Scalars['String']['input'];
  learningLoopId: Scalars['String']['input'];
};

export type RCreateLearningLoopReflectionResult = {
  __typename?: 'CreateLearningLoopReflectionResult';
  learningLoop?: Maybe<RLearningLoopReflection>;
  success: Scalars['Boolean']['output'];
};

export type RCreateSectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  path: Array<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RCreateSelfTrackedLearningInput = {
  description: Scalars['String']['input'];
  effort: Scalars['Int']['input'];
  link: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: RSelfTrackedLearningType;
  userId: Scalars['Int']['input'];
};

export type RCreateSpaceV2Input = {
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type RCreateSpaceV2RoleAssignInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
  role: RSpaceV2Role;
  roleDisplayName?: InputMaybe<Scalars['String']['input']>;
  spaceId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type RCreateTourCompleteUserInput = {
  tourId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type RCreateUser = {
  email: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type RCreateUserInput = {
  sendInvites?: InputMaybe<Scalars['Boolean']['input']>;
  users: Array<RCreateUser>;
};

export type RCreateUserLearningSubmissionInput = {
  data: Scalars['JSON']['input'];
  learningId: Scalars['Int']['input'];
  pageId: Scalars['Int']['input'];
  type: RUserLearningSubmissionType;
  userId: Scalars['Int']['input'];
};

export type RCreateUserLearningSubmissionReviewInput = {
  data: Scalars['JSON']['input'];
  pageId: Scalars['Int']['input'];
  reviewerId: Scalars['Int']['input'];
  submissionId: Scalars['Int']['input'];
  type: RUserLearningSubmissionReviewType;
};

export type RCreateUsersResponse = {
  __typename?: 'CreateUsersResponse';
  realm: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type RCurationFilter = {
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  spacedIdsIN: Array<Scalars['Int']['input']>;
};

export type RDataItem = {
  __typename?: 'DataItem';
  name: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type RDeleteEnrollmentInput = {
  enrollmentId: Scalars['Int']['input'];
};

export type RDeleteSpaceContentOriginInput = {
  contentOriginId: Scalars['String']['input'];
  spaceId: Scalars['Int']['input'];
};

export type REffortForRealm = {
  __typename?: 'EffortForRealm';
  average_effort_per_user?: Maybe<Scalars['Float']['output']>;
  p50?: Maybe<Scalars['Float']['output']>;
  p60?: Maybe<Scalars['Float']['output']>;
  p70?: Maybe<Scalars['Float']['output']>;
  p80?: Maybe<Scalars['Float']['output']>;
  p90?: Maybe<Scalars['Float']['output']>;
  total_effort_for_realm?: Maybe<Scalars['Float']['output']>;
};

export type REffortForRealmOverTime = {
  __typename?: 'EffortForRealmOverTime';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type REffortPerProvider = {
  __typename?: 'EffortPerProvider';
  effort: Scalars['Float']['output'];
  provider: Scalars['String']['output'];
};

export type REngagementLearnings = {
  expertWebinar?: InputMaybe<Scalars['Boolean']['input']>;
  getStarted?: InputMaybe<Scalars['Boolean']['input']>;
  kickOffWebinar?: InputMaybe<Scalars['Boolean']['input']>;
  managerCheckin?: InputMaybe<Scalars['Boolean']['input']>;
  teamsChannel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type REnrollByEmailInput = {
  emails: Array<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

export type REnrollSelfInput = {
  locationId: Scalars['Int']['input'];
};

export type REnrollment = {
  __typename?: 'Enrollment';
  attended: RAttendedType;
  enrolledAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  user?: Maybe<RUserV2>;
  userId: Scalars['Int']['output'];
};

export type REnrollmentsInput = {
  locationIds: Array<Scalars['Int']['input']>;
};

export type REventEnrollment = {
  __typename?: 'EventEnrollment';
  address?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  learningId: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  room?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  teaser: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RFailedEnrollmentMessage = {
  __typename?: 'FailedEnrollmentMessage';
  email?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type RFeatureToggle = {
  __typename?: 'FeatureToggle';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  enabledRealms: Array<RFeatureToggleRealm>;
  enabledUsers: Array<RFeatureToggleUser>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  public: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RFeatureToggleEnableRealmInput = {
  featureId: Scalars['Int']['input'];
  realmId: Scalars['Int']['input'];
};

export type RFeatureToggleEnableUserInput = {
  featureId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type RFeatureToggleFilter = {
  idIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  publicEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RFeatureTogglePage = {
  __typename?: 'FeatureTogglePage';
  data: Array<RFeatureToggle>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RFeatureToggleRealm = {
  __typename?: 'FeatureToggleRealm';
  createdAt: Scalars['DateTime']['output'];
  featureId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  realm: RRealmV2;
  realmId: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RFeatureToggleSort = {
  field?: InputMaybe<RFindFtSortField>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type RFeatureToggleUser = {
  __typename?: 'FeatureToggleUser';
  createdAt: Scalars['DateTime']['output'];
  featureId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: RUserV2;
  userId: Scalars['Float']['output'];
};

export type RFeedbackTicket = {
  __typename?: 'FeedbackTicket';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  priority: RFeedbackTicketPriority;
  status: RFeedbackTicketStatus;
  subject: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export enum RFeedbackTicketPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT',
}

export enum RFeedbackTicketStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Pending = 'PENDING',
  Resolved = 'RESOLVED',
}

export type RFile = {
  __typename?: 'File';
  path: Scalars['String']['output'];
};

export type RFilteredOrdersFlatResult = {
  __typename?: 'FilteredOrdersFlatResult';
  productOrders?: Maybe<Array<Maybe<ROrderRowFlat>>>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export enum RFindFtSortField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
}

export type RFindLearningJourneyItemFilter = {
  /** The URN of the curation to find */
  itemURN: Scalars['URN']['input'];
  /** The ID of the journey to find, if not provided, all journeys will be searched */
  journeyId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type RFoundLearningJourneyItemUnion = RLearningJourneyItem | RLearningSectionItem;

export type RGenerateLearningActivityQuizCsvInput = {
  /** urn should be in version 02 */
  activityURN: Scalars['URN']['input'];
  spaceId?: InputMaybe<Scalars['Int']['input']>;
  teamIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RGenerateLearningJourneyReportCsvInput = {
  spaceId?: InputMaybe<Scalars['Int']['input']>;
  teamIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** urn should be in version 02 */
  urn: Scalars['URN']['input'];
};

export type RGenerateLearningJourneyReportCsvResult = {
  __typename?: 'GenerateLearningJourneyReportCSVResult';
  presignedURL?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RGenerateLearningReportCsvInput = {
  expectedUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  spaceId?: InputMaybe<Scalars['Int']['input']>;
  teamIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** urn should be in version 01 */
  urn: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RGenerateLearningReportCsvResult = {
  __typename?: 'GenerateLearningReportCSVResult';
  presignedURL?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RHistoricCompletedCourse = {
  __typename?: 'HistoricCompletedCourse';
  completed?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RIdResponse = {
  __typename?: 'IdResponse';
  id: Scalars['Int']['output'];
};

export type RImportLearningContentToSpaceInput = {
  learningContentIdIN: Array<Scalars['URN']['input']>;
  originId: Scalars['URN']['input'];
  spaceId: Scalars['Int']['input'];
};

export type RImportLearningContentToSpaceResult = {
  __typename?: 'ImportLearningContentToSpaceResult';
  content?: Maybe<Array<RLearningContent>>;
  failedIds?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type RInt_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RInventory = {
  __typename?: 'Inventory';
  completed?: Maybe<Array<Maybe<RInventoryItem>>>;
  ongoing?: Maybe<Array<Maybe<RInventoryItem>>>;
};

export type RInventoryItem = {
  __typename?: 'InventoryItem';
  accessLink?: Maybe<Scalars['String']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  customLink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  isApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  isCancellable?: Maybe<Scalars['Boolean']['output']>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  journeyId?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<RProductMeta>;
  name?: Maybe<Scalars['String']['output']>;
  objectId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  participation?: Maybe<RParticipation>;
  productId?: Maybe<Scalars['Int']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  providerAccess?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Maybe<RService>>>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subjects?: Maybe<Array<Maybe<RLearningSubject>>>;
  teaser?: Maybe<Scalars['String']['output']>;
  totalEffort?: Maybe<Scalars['Int']['output']>;
  totalLearningsCount?: Maybe<Scalars['Int']['output']>;
  userSelfTrackedLearningId?: Maybe<Scalars['Int']['output']>;
  variant?: Maybe<RVariant>;
};

export type RIssuedLicense = {
  __typename?: 'IssuedLicense';
  businessArea?: Maybe<Scalars['String']['output']>;
  businessUnit?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  division?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastRequestedAt?: Maybe<Scalars['String']['output']>;
  orgLicenseId?: Maybe<Scalars['Int']['output']>;
  sId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RLicenseStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<RUser>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type RJourneyCard = RCourseCard & {
  __typename?: 'JourneyCard';
  archived?: Maybe<Scalars['Boolean']['output']>;
  available?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  entity: Scalars['String']['output'];
  entityId: Scalars['Int']['output'];
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  languageId?: Maybe<Scalars['Int']['output']>;
  participation?: Maybe<RParticipation>;
  provider?: Maybe<Scalars['String']['output']>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  subjects?: Maybe<Array<Maybe<RLearningSubject>>>;
  teaser?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalEffort?: Maybe<Scalars['Int']['output']>;
  totalLearningsCount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<RLearningVisibility>;
};

export type RJourneyItemBreadcrumb = {
  __typename?: 'JourneyItemBreadcrumb';
  content?: Maybe<RLearningContent>;
  urn: Scalars['URN']['output'];
};

export type RLanguage = {
  __typename?: 'Language';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RLanguageV2 = {
  __typename?: 'LanguageV2';
  isoCode: Scalars['String']['output'];
  languageId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nativeName: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type RLaunchUrl = {
  __typename?: 'LaunchURL';
  baseURL?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  rawURL?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type RLearnifierCourse = {
  __typename?: 'LearnifierCourse';
  adminLink?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RLearnifierCourseInput = {
  adminLink?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RLearning = {
  __typename?: 'Learning';
  archived?: Maybe<Scalars['String']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  contentOwner?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  creatorEmail?: Maybe<Scalars['String']['output']>;
  effort?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  languageId?: Maybe<Scalars['Int']['output']>;
  locations?: Maybe<Array<Maybe<RLocation>>>;
  meta?: Maybe<Scalars['JSON']['output']>;
  modules?: Maybe<Array<Maybe<RModule>>>;
  parents: Array<RLearningContent>;
  preamble?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<RLearningProgress>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<RLearningStatus>;
  subjects?: Maybe<Array<Maybe<RLearningSubject>>>;
  teaser?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<RLearningType>;
  updated?: Maybe<Scalars['String']['output']>;
  updatedByEmail?: Maybe<Scalars['String']['output']>;
  urnV2?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<RLearningVisibility>;
};

export type RLearningParentsArgs = {
  filter: RLearningParentsFilter;
};

export type RLearningActivityDto = {
  __typename?: 'LearningActivityDto';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  learningId?: Maybe<Scalars['Int']['output']>;
  order: Scalars['Int']['output'];
  parentActivityId?: Maybe<Scalars['Int']['output']>;
  type: RLearningActivityType;
  updatedAt: Scalars['DateTime']['output'];
  urn: Scalars['String']['output'];
};

export type RLearningActivityInput = {
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  learningId?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
  parentActivityId?: InputMaybe<Scalars['Int']['input']>;
  type: RLearningActivityType;
};

export type RLearningActivityInputDto = {
  children: Array<RLearningActivityInput>;
  parent?: InputMaybe<RLearningActivityInput>;
};

export enum RLearningActivityType {
  Assignment = 'ASSIGNMENT',
  Module = 'MODULE',
  Page = 'PAGE',
  PracticalAssessmentTask = 'PRACTICAL_ASSESSMENT_TASK',
  Question = 'QUESTION',
  Quiz = 'QUIZ',
  Reflection = 'REFLECTION',
}

export type RLearningCard = RCourseCard & {
  __typename?: 'LearningCard';
  archived?: Maybe<Scalars['Boolean']['output']>;
  attributes?: Maybe<Scalars['JSON']['output']>;
  available?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  entity: Scalars['String']['output'];
  entityId: Scalars['Int']['output'];
  featured?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  languageId?: Maybe<Scalars['Int']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<RLearningCardLocation>>>;
  participation?: Maybe<RParticipation>;
  provider?: Maybe<Scalars['String']['output']>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  subjects?: Maybe<Array<Maybe<RLearningSubject>>>;
  teaser?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalEffort?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<RLearningVisibility>;
};

export type RLearningCardLocation = {
  __typename?: 'LearningCardLocation';
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  learningId: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
};

export type RLearningCollection = {
  __typename?: 'LearningCollection';
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  contentOwner?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Scalars['Int']['output']>;
  creatorEmail?: Maybe<Scalars['String']['output']>;
  editLink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<RCourseCard>>>;
  languageId?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  previewLink?: Maybe<Scalars['String']['output']>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<RLearningStatus>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<RLearningType>;
  updated?: Maybe<Scalars['String']['output']>;
  updatedByEmail?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<RLearningVisibility>;
};

export type RLearningCollectionFilter = {
  categoryIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  idIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  spaceIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  statusIN?: InputMaybe<Array<RLearningV2Status>>;
  subjectIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  titleLIKE?: InputMaybe<Scalars['String']['input']>;
  visibilityIN?: InputMaybe<Array<RLearningV2Visibility>>;
};

export type RLearningCollectionItem = {
  __typename?: 'LearningCollectionItem';
  collectionId: Scalars['Int']['output'];
  content?: Maybe<RLearningContent>;
  contentURNV1: Scalars['String']['output'];
  curationURNV1: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
};

export type RLearningCollectionItemPage = {
  __typename?: 'LearningCollectionItemPage';
  data: Array<RLearningCollectionItem>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type RLearningCollectionPage = {
  __typename?: 'LearningCollectionPage';
  data: Array<RLearningCollectionV2>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RLearningCollectionSort = {
  field: RLearningCollectionSortField;
  order: RSortOrder;
};

export enum RLearningCollectionSortField {
  Id = 'ID',
  SpaceId = 'SPACE_ID',
  SpaceName = 'SPACE_NAME',
  Status = 'STATUS',
  Title = 'TITLE',
  TotalCount = 'TOTAL_COUNT',
  Visibility = 'VISIBILITY',
}

export type RLearningCollectionV2 = {
  __typename?: 'LearningCollectionV2';
  contentOwnerId: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creatorId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  imageURL?: Maybe<Scalars['String']['output']>;
  items: RLearningCollectionItemPage;
  languageId: Scalars['Int']['output'];
  space?: Maybe<RSpaceV2>;
  spaceId: Scalars['Int']['output'];
  status: RLearningV2Status;
  subject?: Maybe<RSubjectCategoryV2>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedById?: Maybe<Scalars['Int']['output']>;
  updatedByUser?: Maybe<RUserV2>;
  urn: Scalars['String']['output'];
  visibility: RLearningV2Visibility;
};

export type RLearningContent = {
  __typename?: 'LearningContent';
  curations: Array<RLearningCuration>;
  description: Scalars['String']['output'];
  /** When the content expired at the partner; null means it is not expired */
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['URN']['output'];
  idV1: Scalars['String']['output'];
  imageURL?: Maybe<Scalars['String']['output']>;
  launchURL?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<RLearningContentLocationData>>;
  metadata?: Maybe<RLearningContentMetadata>;
  /** @deprecated Use origins instead */
  originIds: Array<Scalars['URN']['output']>;
  origins?: Maybe<Array<ROrigin>>;
  plannedDuration?: Maybe<Scalars['Int']['output']>;
  plannedLearningsCount?: Maybe<Scalars['Int']['output']>;
  provider: RLearningContentProvider;
  title: Scalars['String']['output'];
  userLastParticipation?: Maybe<RParticipationV2>;
};

export type RLearningContentCurationsArgs = {
  filter: RLearningCurationFilter;
};

export type RLearningContentUserLastParticipationArgs = {
  userId: Scalars['Int']['input'];
};

export enum RLearningContentContentType {
  Article = 'ARTICLE',
  Audio = 'AUDIO',
  Collection = 'COLLECTION',
  Course = 'COURSE',
  ELearning = 'E_LEARNING',
  Journey = 'JOURNEY',
  LiveEvent = 'LIVE_EVENT',
  OnlineLearning = 'ONLINE_LEARNING',
  Path = 'PATH',
  PracticalAssessment = 'PRACTICAL_ASSESSMENT',
  Quiz = 'QUIZ',
  Reflection = 'REFLECTION',
  Resource = 'RESOURCE',
  Section = 'SECTION',
  Seminar = 'SEMINAR',
  Survey = 'SURVEY',
  Video = 'VIDEO',
  Webinar = 'WEBINAR',
}

export type RLearningContentLocationData = {
  __typename?: 'LearningContentLocationData';
  address?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  recordingURL?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  timezone?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<RLocationType>;
  userLocationEnrollment?: Maybe<Array<REnrollment>>;
};

export type RLearningContentLocationDataUserLocationEnrollmentArgs = {
  userIds: Array<Scalars['Int']['input']>;
};

export type RLearningContentMetadata = {
  __typename?: 'LearningContentMetadata';
  language?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use curations[]systemGenerated instead */
  systemGenerated?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<RLearningContentContentType>;
};

export enum RLearningContentProvider {
  Collegial = 'COLLEGIAL',
  CombientTwin = 'COMBIENT_TWIN',
  Coursera = 'COURSERA',
  CustomLink = 'CUSTOM_LINK',
  Finanskompetens = 'FINANSKOMPETENS',
  Imd = 'IMD',
  Imparta = 'IMPARTA',
  Learnifier = 'LEARNIFIER',
  Linkedin = 'LINKEDIN',
  Lumesse = 'LUMESSE',
  Pluralsight = 'PLURALSIGHT',
  Udacity = 'UDACITY',
}

export type RLearningContentsPage = {
  __typename?: 'LearningContentsPage';
  data: Array<RLearningContent>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RLearningCuration = {
  __typename?: 'LearningCuration';
  /** @deprecated Temporary measure to get the editPathURL relevant content type */
  contentType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editURLPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['URN']['output'];
  imageURL?: Maybe<Scalars['String']['output']>;
  launchURL?: Maybe<Scalars['String']['output']>;
  launchURLPath?: Maybe<Scalars['String']['output']>;
  learningContentId: Scalars['URN']['output'];
  /** available values are COLLECTION, LEARNING, LINKED_CONTENT, LEARNING_JOURNEY */
  source: Scalars['String']['output'];
  space?: Maybe<RSpaceV2>;
  spaceId: Scalars['Int']['output'];
  systemGenerated?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updateByUser?: Maybe<RUserV2>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedById?: Maybe<Scalars['Int']['output']>;
};

export type RLearningCurationLaunchUrlArgs = {
  realm?: InputMaybe<Scalars['String']['input']>;
};

export type RLearningCurationLaunchUrlPathArgs = {
  realm?: InputMaybe<Scalars['String']['input']>;
};

export type RLearningCurationFilter = {
  spacedIdsIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type RLearningInput = {
  archived?: InputMaybe<Scalars['String']['input']>;
  contentOwner?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['String']['input']>;
  effort: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  languageId?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<InputMaybe<RLocationInput>>>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  modules?: InputMaybe<Array<InputMaybe<RModuleInput>>>;
  preamble?: InputMaybe<Scalars['String']['input']>;
  spaceId: Scalars['Int']['input'];
  subjects: Array<Scalars['Int']['input']>;
  teaser: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: RLearningType;
  updated?: InputMaybe<Scalars['String']['input']>;
  visibility: RLearningVisibility;
};

/** Defines the availability type of a learning item */
export enum RLearningItemAvailabilityType {
  AlwaysAvailable = 'ALWAYS_AVAILABLE',
  OnPreviousItemCompletion = 'ON_PREVIOUS_ITEM_COMPLETION',
  OnSchedule = 'ON_SCHEDULE',
}

export type RLearningItemCard = RLearningCard | RProductCard;

export type RLearningJourney = {
  __typename?: 'LearningJourney';
  allUpcomingItemsLocked: Scalars['Boolean']['output'];
  bannerURL?: Maybe<Scalars['String']['output']>;
  businessGoalV2: Scalars['JSON']['output'];
  certificateEnabled: Scalars['Boolean']['output'];
  cohortTeams?: Maybe<Array<RTeam>>;
  completionCriteria?: Maybe<RLearningJourneyCompletionStatus>;
  completionInvestTimeSec?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  descriptionV2: Scalars['JSON']['output'];
  discussionEnabled: Scalars['Boolean']['output'];
  discussionForumSectionPath: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** @deprecated This field is deprecated and will be removed in the future. */
  isLinear: Scalars['Boolean']['output'];
  items: RLearningJourneyItemPage;
  myCertificateURL?: Maybe<RPresignedUrl>;
  sessions: Array<RLearningJourneySession>;
  sourceTemplateId?: Maybe<Scalars['Int']['output']>;
  spaceFeatured: Scalars['Boolean']['output'];
  spaceId: Scalars['Int']['output'];
  status: RLearningJourneyStatus;
  subject?: Maybe<RSubjectCategoryV2>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updateByUser?: Maybe<RUserV2>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
  urn: Scalars['String']['output'];
};

export type RLearningJourneyItemsArgs = {
  filter?: InputMaybe<RLearningJourneyItemsFilter>;
  pagination?: InputMaybe<RPagination>;
};

export type RLearningJourneyCohort = {
  __typename?: 'LearningJourneyCohort';
  learners: Array<RLearningJourneyLearner>;
  teams: Array<RTeam>;
};

/** Lifecycle status of an asynchronous import batch. */
export enum RLearningJourneyCohortImportBatchStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
}

export type RLearningJourneyCohortImportBatchStatusResult = {
  __typename?: 'LearningJourneyCohortImportBatchStatusResult';
  /** Rows added to the cohort so far. */
  added: Scalars['Int']['output'];
  /** Identifier of the import batch. */
  batchId: Scalars['ID']['output'];
  /** Rows that errored so far. */
  errorCount: Scalars['Int']['output'];
  /** Rows processed so far. */
  processed: Scalars['Int']['output'];
  /** Rows skipped (already present) so far. */
  skipped: Scalars['Int']['output'];
  /** Current lifecycle status of the batch. */
  status: RLearningJourneyCohortImportBatchStatus;
  /** Total rows to process in this batch. */
  totalRows: Scalars['Int']['output'];
};

export type RLearningJourneyCohortImportFileError = {
  __typename?: 'LearningJourneyCohortImportFileError';
  /** Which file-level validation failed (invalid CSV, template mismatch, or too large). */
  code: RLearningJourneyCohortImportFileErrorCode;
};

/** File-level validation error for a cohort import CSV upload (invalid CSV, wrong template column, or over the row cap). */
export enum RLearningJourneyCohortImportFileErrorCode {
  InvalidCsv = 'INVALID_CSV',
  TemplateMismatch = 'TEMPLATE_MISMATCH',
  TooLarge = 'TOO_LARGE',
}

export type RLearningJourneyCohortImportInput = {
  file: Scalars['Upload']['input'];
  journeyId: Scalars['Int']['input'];
};

export type RLearningJourneyCohortImportPreview = {
  __typename?: 'LearningJourneyCohortImportPreview';
  /** Per-row preview, optionally filtered by outcome. Omitting the filter (or an empty outcomeIN) returns every row. */
  rows: Array<RLearningJourneyCohortImportRowPreview>;
  /** Aggregate counts per outcome. */
  stats: RLearningJourneyCohortImportPreviewStats;
};

export type RLearningJourneyCohortImportPreviewRowsArgs = {
  filter?: InputMaybe<RLearningJourneyCohortImportRowFilter>;
};

export type RLearningJourneyCohortImportPreviewResult = {
  __typename?: 'LearningJourneyCohortImportPreviewResult';
  /** The preview buckets when success is true; null on a file-level error. */
  data?: Maybe<RLearningJourneyCohortImportPreview>;
  /** The file-level error cause when success is false; null on success. */
  errorCause?: Maybe<RLearningJourneyCohortImportFileError>;
  /** True when the CSV parsed and a preview is available; false when a file-level validation failed. */
  success: Scalars['Boolean']['output'];
};

export type RLearningJourneyCohortImportPreviewStats = {
  __typename?: 'LearningJourneyCohortImportPreviewStats';
  /** Rows already present in the journey cohort, skipped (ALREADY_IN_COHORT). */
  alreadyInCohort: Scalars['Int']['output'];
  /** Rows rejected as a duplicate email within the file (DUPLICATE_IN_FILE). */
  duplicateInFile: Scalars['Int']['output'];
  /** Rows rejected because the email is malformed (INVALID_EMAIL). */
  invalidEmail: Scalars['Int']['output'];
  /** Total number of data rows parsed from the CSV. */
  total: Scalars['Int']['output'];
  /** Rows whose email is not found in the realm (USER_NOT_FOUND). */
  userNotFound: Scalars['Int']['output'];
  /** Rows that will be added to the journey cohort (WILL_ADD). */
  willAdd: Scalars['Int']['output'];
};

export type RLearningJourneyCohortImportResult = {
  __typename?: 'LearningJourneyCohortImportResult';
  /** Whether the cohort import job was accepted and enqueued. */
  accepted: Scalars['Boolean']['output'];
  /** Identifier of the created import batch, used to poll status. */
  batchId: Scalars['ID']['output'];
  /** Number of rows that will be added by the background job. */
  willAddCount: Scalars['Int']['output'];
};

export type RLearningJourneyCohortImportRowFilter = {
  /** Restrict to these outcomes. Omitted, null, or empty returns all rows. */
  outcomeIN?: InputMaybe<Array<RLearningJourneyCohortImportRowOutcome>>;
};

/** Outcome of a single CSV row in a cohort import preview. */
export enum RLearningJourneyCohortImportRowOutcome {
  AlreadyInCohort = 'ALREADY_IN_COHORT',
  DuplicateInFile = 'DUPLICATE_IN_FILE',
  InvalidEmail = 'INVALID_EMAIL',
  UserNotFound = 'USER_NOT_FOUND',
  WillAdd = 'WILL_ADD',
}

export type RLearningJourneyCohortImportRowPreview = {
  __typename?: 'LearningJourneyCohortImportRowPreview';
  /** How this row was classified. */
  outcome: RLearningJourneyCohortImportRowOutcome;
  /** The source CSV row. */
  row: RLearningJourneyCohortImportSourceRow;
};

export type RLearningJourneyCohortImportSourceRow = {
  __typename?: 'LearningJourneyCohortImportSourceRow';
  /** Normalized (lowercased, trimmed) email address from the CSV row. */
  email: Scalars['String']['output'];
  /** Physical 1-based line number of this row in the source CSV (the header is line 1, counting blank lines), for traceback when the same email appears more than once. */
  sourceLine: Scalars['Int']['output'];
};

export enum RLearningJourneyCompletionStatus {
  CompleteAllItems = 'COMPLETE_ALL_ITEMS',
  InvestTime = 'INVEST_TIME',
}

export type RLearningJourneyFilter = {
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  spaceIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  statusIN?: InputMaybe<Array<RLearningJourneyStatus>>;
};

export type RLearningJourneyItem = {
  __typename?: 'LearningJourneyItem';
  availabilityScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  availabilityScheduledAtTimezone?: Maybe<Scalars['Int']['output']>;
  availabilityType: RLearningItemAvailabilityType;
  breadcrumbs: Array<RJourneyItemBreadcrumb>;
  /** @deprecated Use query learningContentById.plannedLearningsCount instead */
  childrenItems?: Maybe<Array<RLearningContent>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isLocked: Scalars['Boolean']['output'];
  isOptional: Scalars['Boolean']['output'];
  journeyId: Scalars['Int']['output'];
  learningItem?: Maybe<RLearningContent>;
  learningItemURNV2: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  realms: Array<Scalars['String']['output']>;
};

export type RLearningJourneyItemIsLockedArgs = {
  userId: Scalars['Int']['input'];
};

export type RLearningJourneyItemPage = {
  __typename?: 'LearningJourneyItemPage';
  data: Array<RLearningJourneyItem>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RLearningJourneyItemsCatalogFilter = {
  id: Scalars['Int']['input'];
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
};

export type RLearningJourneyItemsFilter = {
  realmVisibility?: InputMaybe<Scalars['String']['input']>;
};

export type RLearningJourneyLearner = {
  __typename?: 'LearningJourneyLearner';
  progress?: Maybe<RParticipationV2>;
  sessionId: Scalars['Int']['output'];
  user: RUserV2;
  userId: Scalars['Int']['output'];
};

export type RLearningJourneyPage = {
  __typename?: 'LearningJourneyPage';
  data: Array<RLearningJourney>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RLearningJourneyResult = {
  __typename?: 'LearningJourneyResult';
  journey?: Maybe<RLearningJourney>;
  success: Scalars['Boolean']['output'];
};

export type RLearningJourneySession = {
  __typename?: 'LearningJourneySession';
  cohort: RLearningJourneyCohort;
  discussionTeams?: Maybe<Array<RLearningJourneySessionDiscussionTeam>>;
  id: Scalars['Int']['output'];
  journey?: Maybe<RLearningJourney>;
  journeyId: Scalars['Int']['output'];
  registration: Scalars['String']['output'];
  spaceId: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  urn: Scalars['String']['output'];
};

export type RLearningJourneySessionCohortArgs = {
  teamIdsIN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RLearningJourneySessionDiscussionTeam = {
  __typename?: 'LearningJourneySessionDiscussionTeam';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  members: Array<RLearningJourneySessionDiscussionTeamMember>;
  name: Scalars['String']['output'];
  sessionId: Scalars['Int']['output'];
  teamSize: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RLearningJourneySessionDiscussionTeamMember = {
  __typename?: 'LearningJourneySessionDiscussionTeamMember';
  createdAt: Scalars['DateTime']['output'];
  teamId: Scalars['Int']['output'];
  user: RUserV2;
  userId: Scalars['Int']['output'];
};

export type RLearningJourneySessionPage = {
  __typename?: 'LearningJourneySessionPage';
  data: Array<RLearningJourneySession>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RLearningJourneySessionResult = {
  __typename?: 'LearningJourneySessionResult';
  learnersAdded?: Maybe<Array<Scalars['Int']['output']>>;
  session?: Maybe<RLearningJourneySession>;
  success: Scalars['Boolean']['output'];
};

export type RLearningJourneySort = {
  field?: InputMaybe<RLearningJourneySortField>;
  order?: InputMaybe<RSortOrder>;
};

export enum RLearningJourneySortField {
  Id = 'ID',
  SpaceId = 'SPACE_ID',
  Status = 'STATUS',
  Title = 'TITLE',
}

export enum RLearningJourneyStatus {
  Deleted = 'DELETED',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED',
}

export type RLearningJourneyTeamImportFileError = {
  __typename?: 'LearningJourneyTeamImportFileError';
  code: RLearningJourneyTeamImportFileErrorCode;
};

/** File-level validation error for a team-import CSV upload. */
export enum RLearningJourneyTeamImportFileErrorCode {
  InvalidCsv = 'INVALID_CSV',
  NotCsv = 'NOT_CSV',
  TemplateMismatch = 'TEMPLATE_MISMATCH',
  TooLarge = 'TOO_LARGE',
}

export type RLearningJourneyTeamImportInput = {
  file: Scalars['Upload']['input'];
  journeyId: Scalars['Int']['input'];
};

export type RLearningJourneyTeamImportMissingLearner = {
  __typename?: 'LearningJourneyTeamImportMissingLearner';
  email: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
};

export type RLearningJourneyTeamImportPreview = {
  __typename?: 'LearningJourneyTeamImportPreview';
  /** True when every journey learner is assigned a team (missingLearners is empty). */
  allJourneyLearnersAssigned: Scalars['Boolean']['output'];
  missingLearners: Array<RLearningJourneyTeamImportMissingLearner>;
  /** Per-row preview, optionally filtered by outcome. Omitted or empty filter returns every row. */
  rows: Array<RLearningJourneyTeamImportRowPreview>;
  stats: RLearningJourneyTeamImportPreviewStats;
};

export type RLearningJourneyTeamImportPreviewRowsArgs = {
  filter?: InputMaybe<RLearningJourneyTeamImportRowFilter>;
};

export type RLearningJourneyTeamImportPreviewResult = {
  __typename?: 'LearningJourneyTeamImportPreviewResult';
  data?: Maybe<RLearningJourneyTeamImportPreview>;
  errorCause?: Maybe<RLearningJourneyTeamImportFileError>;
  success: Scalars['Boolean']['output'];
};

export type RLearningJourneyTeamImportPreviewStats = {
  __typename?: 'LearningJourneyTeamImportPreviewStats';
  duplicateInFile: Scalars['Int']['output'];
  invalidEmail: Scalars['Int']['output'];
  missingRequiredField: Scalars['Int']['output'];
  missingTeam: Scalars['Int']['output'];
  notInJourney: Scalars['Int']['output'];
  ready: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RLearningJourneyTeamImportResult = {
  __typename?: 'LearningJourneyTeamImportResult';
  learnersAssigned: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  teamsCreated: Scalars['Int']['output'];
};

export type RLearningJourneyTeamImportRowFilter = {
  /** Restrict to these outcomes; omitted, null, or empty returns all rows. */
  outcomeIN?: InputMaybe<Array<RLearningJourneyTeamImportRowOutcome>>;
};

/** Outcome of a single CSV row in a team-import preview. */
export enum RLearningJourneyTeamImportRowOutcome {
  DuplicateInFile = 'DUPLICATE_IN_FILE',
  InvalidEmail = 'INVALID_EMAIL',
  MissingRequiredField = 'MISSING_REQUIRED_FIELD',
  MissingTeam = 'MISSING_TEAM',
  NotInJourney = 'NOT_IN_JOURNEY',
  Ready = 'READY',
}

export type RLearningJourneyTeamImportRowPreview = {
  __typename?: 'LearningJourneyTeamImportRowPreview';
  outcome: RLearningJourneyTeamImportRowOutcome;
  row: RLearningJourneyTeamImportSourceRow;
};

export type RLearningJourneyTeamImportSourceRow = {
  __typename?: 'LearningJourneyTeamImportSourceRow';
  /** Normalized (lowercased, trimmed) email. */
  email: Scalars['String']['output'];
  /** 1-based line in the source CSV (header is line 1). */
  sourceLine: Scalars['Int']['output'];
  /** Team name, trimmed; empty when the row omits it. */
  teamName: Scalars['String']['output'];
};

export type RLearningJourneyTemplateDto = {
  __typename?: 'LearningJourneyTemplateDto';
  bannerURL: Scalars['String']['output'];
  businessGoal: Scalars['String']['output'];
  businessGoalV2: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  descriptionV2: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  teaser: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type RLearningJourneyUpcomingItem = {
  __typename?: 'LearningJourneyUpcomingItem';
  availabilityScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  availabilityScheduledAtTimezone?: Maybe<Scalars['Int']['output']>;
  availabilityType: RLearningItemAvailabilityType;
  isLocked: Scalars['Boolean']['output'];
  isOptional: Scalars['Boolean']['output'];
  journeyId?: Maybe<Scalars['Int']['output']>;
  journeyItemId?: Maybe<Scalars['Int']['output']>;
  learningId?: Maybe<Scalars['Int']['output']>;
  learningItem?: Maybe<RLearningContent>;
  learningItemId?: Maybe<Scalars['Int']['output']>;
  learningItemURNV2: Scalars['String']['output'];
};

export type RLearningJourneyUpcomingItemIsLockedArgs = {
  userId: Scalars['Int']['input'];
};

export type RLearningLoop = {
  __typename?: 'LearningLoop';
  activitiesAggregated: Array<RLearningLoopActivityAggregated>;
  assignmentId: Scalars['Int']['output'];
  canReflect: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  endAt: Scalars['DateTime']['output'];
  estimatedEffort: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  recommendedEffort: Scalars['Int']['output'];
  reflection?: Maybe<RLearningLoopReflection>;
  startAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type RLearningLoopActivityAggregated = {
  __typename?: 'LearningLoopActivityAggregated';
  estimatedEffortSum: Scalars['Int']['output'];
  participation: RParticipationV2;
};

export type RLearningLoopFilter = {
  assignmentId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type RLearningLoopPage = {
  __typename?: 'LearningLoopPage';
  data: Array<RLearningLoop>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RLearningLoopReflection = {
  __typename?: 'LearningLoopReflection';
  applied: RLearningLoopReflectionApplied;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  learningLoopId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum RLearningLoopReflectionApplied {
  Applied = 'APPLIED',
  NotSure = 'NOT_SURE',
  PlannedNextMonth = 'PLANNED_NEXT_MONTH',
  PlannedNextSixMonths = 'PLANNED_NEXT_SIX_MONTHS',
}

export type RLearningParentCurationsFilter = {
  spaceIdIN: Array<Scalars['Int']['input']>;
};

export type RLearningParentsFilter = {
  curation: RLearningParentCurationsFilter;
};

export type RLearningPinned = {
  __typename?: 'LearningPinned';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  learningCollectionId?: Maybe<Scalars['Int']['output']>;
  learningId?: Maybe<Scalars['Int']['output']>;
  learningJourneyId?: Maybe<Scalars['Int']['output']>;
  learningPathId?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  realm: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RLearningPinnedUpdateInput = {
  entity: RCatalogCardType;
  entityId: Scalars['Int']['input'];
  realm: Scalars['String']['input'];
};

export type RLearningProgress = {
  __typename?: 'LearningProgress';
  completed?: Maybe<Scalars['Boolean']['output']>;
  completedPercentage?: Maybe<Scalars['Float']['output']>;
  expiredAt?: Maybe<Scalars['String']['output']>;
  historical?: Maybe<Scalars['Boolean']['output']>;
};

export type RLearningSectionItem = {
  __typename?: 'LearningSectionItem';
  availabilityScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  availabilityScheduledAtTimezone?: Maybe<Scalars['Int']['output']>;
  availabilityType: RLearningItemAvailabilityType;
  breadcrumbs: Array<RJourneyItemBreadcrumb>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isLocked: Scalars['Boolean']['output'];
  isOptional: Scalars['Boolean']['output'];
  learningId: Scalars['Int']['output'];
  learningItem?: Maybe<RLearningContent>;
  learningItemURNV2: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  realms: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RLearningSectionItemIsLockedArgs = {
  userId: Scalars['Int']['input'];
};

export type RLearningSectionItemPage = {
  __typename?: 'LearningSectionItemPage';
  data: Array<RLearningSectionItem>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RLearningSectionItemsCatalogFilter = {
  id: Scalars['Int']['input'];
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
};

export type RLearningSectionItemsFilter = {
  realmVisibility?: InputMaybe<Scalars['String']['input']>;
};

export enum RLearningStatus {
  Archived = 'ARCHIVED',
  Available = 'AVAILABLE',
  Deleted = 'DELETED',
}

export type RLearningSubject = {
  __typename?: 'LearningSubject';
  category?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['Int']['output']>;
};

export enum RLearningType {
  Article = 'ARTICLE',
  Audio = 'AUDIO',
  Course = 'COURSE',
  ELearning = 'E_LEARNING',
  LearningPath = 'LEARNING_PATH',
  LiveEvent = 'LIVE_EVENT',
  OnlineLearning = 'ONLINE_LEARNING',
  PracticalAssessment = 'PRACTICAL_ASSESSMENT',
  Resource = 'RESOURCE',
  Section = 'SECTION',
  Seminar = 'SEMINAR',
  Survey = 'SURVEY',
  Video = 'VIDEO',
  Webinar = 'WEBINAR',
}

export type RLearningV2 = {
  __typename?: 'LearningV2';
  activities?: Maybe<Array<RLearningActivityDto>>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  contentOwner?: Maybe<RUserV2>;
  contentOwnerId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creator?: Maybe<RUserV2>;
  creatorId?: Maybe<Scalars['Int']['output']>;
  effort?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  language?: Maybe<RLanguageV2>;
  languageId?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  modules: Array<RModuleV2>;
  preamble: Scalars['String']['output'];
  sectionItems: RLearningSectionItemPage;
  spaceId: Scalars['Int']['output'];
  status: RLearningV2Status;
  subjects?: Maybe<Array<RSubjectCategory>>;
  teaser: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: RLearningV2Type;
  updateByUser?: Maybe<RUserV2>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByUserId?: Maybe<Scalars['Int']['output']>;
  urn: Scalars['String']['output'];
  userLastParticipation?: Maybe<RParticipationV2>;
  visibility?: Maybe<RLearningV2Visibility>;
};

export type RLearningV2SectionItemsArgs = {
  filter?: InputMaybe<RLearningSectionItemsFilter>;
  pagination?: InputMaybe<RPagination>;
};

export type RLearningV2UserLastParticipationArgs = {
  userId: Scalars['Int']['input'];
};

export type RLearningV2Input = {
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contentOwnerId?: InputMaybe<Scalars['Int']['input']>;
  creatorId?: InputMaybe<Scalars['Int']['input']>;
  effort?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  languageId: Scalars['Int']['input'];
  meta?: InputMaybe<Scalars['JSON']['input']>;
  preamble: Scalars['String']['input'];
  spaceId: Scalars['Int']['input'];
  status: RLearningV2Status;
  teaser: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: RLearningV2Type;
  updatedByUserId?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<RLearningV2Visibility>;
};

export enum RLearningV2Status {
  Archived = 'ARCHIVED',
  Available = 'AVAILABLE',
  Deleted = 'DELETED',
}

export enum RLearningV2Type {
  Article = 'ARTICLE',
  Audio = 'AUDIO',
  Course = 'COURSE',
  ELearning = 'E_LEARNING',
  LiveEvent = 'LIVE_EVENT',
  OnlineLearning = 'ONLINE_LEARNING',
  PracticalAssessment = 'PRACTICAL_ASSESSMENT',
  Resource = 'RESOURCE',
  Section = 'SECTION',
  Seminar = 'SEMINAR',
  Survey = 'SURVEY',
  Video = 'VIDEO',
  Webinar = 'WEBINAR',
}

export enum RLearningV2Visibility {
  Featured = 'FEATURED',
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE',
}

export enum RLearningVisibility {
  Featured = 'FEATURED',
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE',
}

export enum RLicenseStatus {
  Approved = 'APPROVED',
  NotApproved = 'NOT_APPROVED',
  PendingApproval = 'PENDING_APPROVAL',
}

export type RLocation = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  hasEnrollments: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  learning?: Maybe<RLearning>;
  learningContent?: Maybe<RLearningContent>;
  learningId: Scalars['Int']['output'];
  myEnrollment?: Maybe<REnrollment>;
  recordingURL?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  stats?: Maybe<RLocationStats>;
  timezone?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<RLocationType>;
  updated: Scalars['DateTime']['output'];
  waitlistType: RWaitlistType;
};

export type RLocationEnrollment = {
  __typename?: 'LocationEnrollment';
  attended?: Maybe<RAttendedType>;
  email?: Maybe<Scalars['String']['output']>;
  enrolledAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type RLocationInput = {
  address: Scalars['String']['input'];
  archived?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  learningId?: InputMaybe<Scalars['Int']['input']>;
  room?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  type?: InputMaybe<RLocationType>;
  waitlistType?: InputMaybe<RWaitlistType>;
};

export type RLocationStats = {
  __typename?: 'LocationStats';
  attendedCount: Scalars['Int']['output'];
  enrolledCount: Scalars['Int']['output'];
  isFinished: Scalars['Boolean']['output'];
  notAttendedCount: Scalars['Int']['output'];
  waitlistedCount: Scalars['Int']['output'];
};

export enum RLocationType {
  InPerson = 'IN_PERSON',
  Online = 'ONLINE',
}

export type RLocationV2Input = {
  address: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['Int']['input']>;
  type: RLocationType;
};

export type RMe = {
  __typename?: 'Me';
  acceptedExtraTerms: Scalars['Boolean']['output'];
  acceptedGdpr: Scalars['Boolean']['output'];
  acceptedTos: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isDebugging: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  passwordExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  permissions: RMePermissions;
  profileImage?: Maybe<Scalars['String']['output']>;
  realm: Scalars['String']['output'];
  status: RUserStatus;
  username?: Maybe<Scalars['String']['output']>;
};

export type RMePermissions = {
  __typename?: 'MePermissions';
  hasViewAccessToAdminPanel: Scalars['Boolean']['output'];
  hasViewAccessToManagerDashboard: Scalars['Boolean']['output'];
  hasWriteAccessToInternals: Scalars['Boolean']['output'];
};

export type RModule = {
  __typename?: 'Module';
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  learningId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  pages?: Maybe<Array<Maybe<RPage>>>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
};

export type RModuleInput = {
  created?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  learningId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  pages?: InputMaybe<Array<InputMaybe<RPageInput>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
};

export type RModuleV2 = {
  __typename?: 'ModuleV2';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  learningId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  pages: Array<RPageV2>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  urn: Scalars['String']['output'];
};

export type RModuleV2Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  learningId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  pages: Array<RPageV2Input>;
};

/** mutation root */
export type RMutation = {
  __typename?: 'Mutation';
  _blank?: Maybe<Scalars['Boolean']['output']>;
  acceptExtraTerms?: Maybe<Scalars['ID']['output']>;
  acceptGdpr?: Maybe<Scalars['ID']['output']>;
  acceptTos?: Maybe<Scalars['ID']['output']>;
  addAssignmentUserSurvey: RAddAssignmentUserSurveyResult;
  addSelfTrackedLearningToLearningLoop: RAddSelfTrackedLearningToLearningLoopResult;
  /** Adds a content origin to a space */
  addSpaceContentOrigin: RProviderContentOrigin;
  addTeamsToLearningJourneyCohort: RLearningJourneySessionResult;
  addUsersToLearningJourneyCohort: RLearningJourneySessionResult;
  applyOrderRules?: Maybe<RUpdateResponse>;
  approveLicense?: Maybe<Scalars['Boolean']['output']>;
  archiveLearning?: Maybe<RLearning>;
  bootstrapLearningJourneySesssionDiscussionTeams: RLearningJourneySessionResult;
  cancel?: Maybe<RReturnData>;
  changeEnrollmentLocation: REnrollment;
  changePassword?: Maybe<Scalars['ID']['output']>;
  cloneLearning: RLearningV2;
  cloneLearningActivities: RLearningActivityDto;
  cloneLearningJourney: RLearningJourneyResult;
  completeLearning: Scalars['Boolean']['output'];
  completeLearningPath?: Maybe<Scalars['Boolean']['output']>;
  completeObject?: Maybe<Scalars['ID']['output']>;
  createAssignmentFromTemplate: RAssignmentsV3Result;
  createCollection?: Maybe<RLearningCollection>;
  createLearningJourney: RLearningJourneyResult;
  createLearningJourneyFromTemplate: RLearningJourneyResult;
  createLearningJourneyLiveEvent: RLearningV2;
  createLearningJourneyPracticalAssessments: Array<RLearningV2>;
  createLearningLoopReflection: RCreateLearningLoopReflectionResult;
  createOrUpdate?: Maybe<RProduct>;
  createPost?: Maybe<RPost>;
  createSection?: Maybe<RSection>;
  createSelfTrackedLearning: RSelfTrackedLearningResult;
  /** Creates a new space */
  createSpace: RSpaceV2Result;
  createSpaceRoleAssignment: RSpaceV2RoleAssignResultDto;
  createUserLearningSubmission: RUserLearningSubmissionResult;
  createUserLearningSubmissionReview: RUserLearningSubmissionReviewResult;
  createUsers?: Maybe<Array<Maybe<RCreateUsersResponse>>>;
  createVariant?: Maybe<RVariant>;
  deleteAssignmentV3: RAssignmentsV3Result;
  deleteEnrollment: Scalars['Boolean']['output'];
  deleteFeatureToggle: RFeatureToggle;
  deleteLearning?: Maybe<RLearning>;
  deleteLearningJourneys: Array<RLearningJourney>;
  deletePost?: Maybe<RPost>;
  /** Delete a provider */
  deleteProvider: Scalars['Boolean']['output'];
  /** Deletes a content origin from a space */
  deleteSpaceContentOrigin: Scalars['Boolean']['output'];
  deleteSpaceRoleAssignment: RSpaceV2RoleAssignResultDto;
  deleteXAPIState?: Maybe<Scalars['ID']['output']>;
  /** delete data from the table: "clsapi.learning" */
  delete_clsapi_learning?: Maybe<RClsapi_Learning_Mutation_Response>;
  /** delete single row from the table: "clsapi.learning" */
  delete_clsapi_learning_by_pk?: Maybe<RClsapi_Learning>;
  /** delete data from the table: "clsapi.learning_journeys" */
  delete_clsapi_learning_journeys?: Maybe<RClsapi_Learning_Journeys_Mutation_Response>;
  /** delete single row from the table: "clsapi.learning_journeys" */
  delete_clsapi_learning_journeys_by_pk?: Maybe<RClsapi_Learning_Journeys>;
  disableFeatureToggleForRealm: RFeatureToggleRealm;
  disableFeatureToggleForUser: RFeatureToggleUser;
  enableFeatureToggleForRealm: RFeatureToggleRealm;
  enableFeatureToggleForUser: RFeatureToggleUser;
  enrollSelf: REnrollment;
  enrollmentCreateByEmails: Array<REnrollment>;
  /** Generate the learning activities (pages) insights CSV for an authored learning and return a presigned download URL. */
  generateLearningActivitiesCSV: RGenerateLearningReportCsvResult;
  generateLearningActivityQuizCSV: RGenerateLearningReportCsvResult;
  generateLearningItemLearnersCSV: RGenerateLearningReportCsvResult;
  generateLearningJourneyItemsCSV: RGenerateLearningJourneyReportCsvResult;
  generateLearningJourneyLearnersCSV: RGenerateLearningJourneyReportCsvResult;
  generateLiveLearningItemLearnersCSV: RGenerateLearningReportCsvResult;
  generateSectionItemsCSV: RGenerateLearningReportCsvResult;
  generateSectionLearnersCSV: RGenerateLearningReportCsvResult;
  importLearningContentToSpace: RImportLearningContentToSpaceResult;
  /** insert data into the table: "clsapi.learning" */
  insert_clsapi_learning?: Maybe<RClsapi_Learning_Mutation_Response>;
  /** insert data into the table: "clsapi.learning_journeys" */
  insert_clsapi_learning_journeys?: Maybe<RClsapi_Learning_Journeys_Mutation_Response>;
  /** insert a single row into the table: "clsapi.learning_journeys" */
  insert_clsapi_learning_journeys_one?: Maybe<RClsapi_Learning_Journeys>;
  /** insert a single row into the table: "clsapi.learning" */
  insert_clsapi_learning_one?: Maybe<RClsapi_Learning>;
  joinLearningJourneyCohort: RLearningJourneySessionResult;
  /** Confirm a cohort import: re-validate the uploaded CSV, persist the batch snapshot, and enqueue the async apply job, returning immediately. Asynchronous. */
  learningJourneyConfirmCohortImport: RLearningJourneyCohortImportResult;
  /** Confirm a team import: apply the teams synchronously (wipe-and-replace), returning the applied counts. Mocked until PT-6089. */
  learningJourneyConfirmTeamImport: RLearningJourneyTeamImportResult;
  /** Preview a cohort import: parse and validate the uploaded CSV, returning aggregate stats plus the per-row preview, or a file-level error. Synchronous, read-only. */
  learningJourneyPreviewCohortImport: RLearningJourneyCohortImportPreviewResult;
  /** Preview a team import: bucketed rows, counts, the missing-learner list, and a gate flag, or a file-level error. Synchronous, read-only. Mocked until PT-6088. */
  learningJourneyPreviewTeamImport: RLearningJourneyTeamImportPreviewResult;
  learningPinnedUpdate: Array<RLearningPinned>;
  markAllNotificationsAsSeen?: Maybe<Array<Maybe<RBabelonNotification>>>;
  markNotificationAsSeen?: Maybe<Array<Maybe<RBabelonNotification>>>;
  migrateOnDemandLearningToCourses: RLearningV2;
  purchase?: Maybe<RPurchaseResponse>;
  registerToLearning: RXapiSession;
  removeSelfTrackedLearning: RSelfTrackedLearningResult;
  removeUsersFromLearningJourneyCohort: RLearningJourneySessionResult;
  removeVariant?: Maybe<RVariantResponse>;
  requestLicense?: Maybe<Scalars['Boolean']['output']>;
  /** Resets a session's discussion teams. Delete-only: clears the teams and lets member rows drop through ON DELETE CASCADE. Does not recreate teams. */
  resetLearningJourneySessionDiscussionTeams: RLearningJourneySessionResult;
  restoreLearning?: Maybe<RLearning>;
  revokeLicense?: Maybe<Scalars['Boolean']['output']>;
  sadminPurchase?: Maybe<RSadminPurchaseResponse>;
  saveLearning?: Maybe<RLearning>;
  setBulkEnrollmentAttendance: Array<REnrollment>;
  setEnrollmentAttendance: REnrollment;
  setLanguage?: Maybe<Scalars['ID']['output']>;
  setProgressPerCourseByUser?: Maybe<Scalars['Boolean']['output']>;
  setUserStatus?: Maybe<Scalars['ID']['output']>;
  setUsername?: Maybe<Scalars['ID']['output']>;
  /** Submit feedback from the current user */
  submitFeedback: RSubmitFeedbackResult;
  /** Submit or replace the learner's PDF for an assignment activity. The new file overwrites the previous one. */
  submitLearningActivityAssignment: RUserLearningActivityAssignmentSubmission;
  submitLearningActivityQuizAnswers: RUserLearningActivityQuizSubmission;
  /** Creates team */
  teamCreate: RTeam;
  /** Deletes team */
  teamDelete: Scalars['Boolean']['output'];
  /** Updates team */
  teamUpdate: RTeam;
  /** Changes users role in team */
  teamUserChangeRole: RTeamUser;
  /** Removes user from team */
  teamUserRemove: Scalars['Boolean']['output'];
  /** Adds users to team */
  teamUsersAdd: Array<RTeamUser>;
  toggleAction?: Maybe<RPost>;
  updateCollection?: Maybe<RLearningCollection>;
  updateCollectionItems?: Maybe<RLearningCollection>;
  /** Updates a learning journey and optionally suppresses learner-facing notifications. */
  updateLearningJourney: RLearningJourneyResult;
  updateLocationRecordingURL: RLocation;
  updateMeta?: Maybe<RUserMeta>;
  updateOrder?: Maybe<RUpdateResponse>;
  updatePost?: Maybe<RPost>;
  updateSection?: Maybe<RSection>;
  updateSelfTrackedLearning: RSelfTrackedLearningResult;
  /** Updates an existing space */
  updateSpace: RSpaceV2Result;
  updateSpaceRoleAssignment: RSpaceV2RoleAssignResultDto;
  updateUser: RUserV2;
  updateVariant?: Maybe<RVariant>;
  /** update data of the table: "clsapi.learning" */
  update_clsapi_learning?: Maybe<RClsapi_Learning_Mutation_Response>;
  /** update single row of the table: "clsapi.learning" */
  update_clsapi_learning_by_pk?: Maybe<RClsapi_Learning>;
  /** update data of the table: "clsapi.learning_journeys" */
  update_clsapi_learning_journeys?: Maybe<RClsapi_Learning_Journeys_Mutation_Response>;
  /** update single row of the table: "clsapi.learning_journeys" */
  update_clsapi_learning_journeys_by_pk?: Maybe<RClsapi_Learning_Journeys>;
  /** update multiples rows of table: "clsapi.learning_journeys" */
  update_clsapi_learning_journeys_many?: Maybe<Array<Maybe<RClsapi_Learning_Journeys_Mutation_Response>>>;
  /** update multiples rows of table: "clsapi.learning" */
  update_clsapi_learning_many?: Maybe<Array<Maybe<RClsapi_Learning_Mutation_Response>>>;
  uploadProfileImage: RFile;
  upsertAssignmentV3: RAssignmentsV3Result;
  upsertCertificateProperties: RCertificateProperties;
  upsertFeatureToggle: RFeatureToggle;
  upsertLearning: RLearningV2;
  upsertLearningJourneyCohorts: RLearningJourneySessionResult;
  upsertLearningJourneyItems: RLearningJourneyResult;
  upsertLearningJourneySessionDiscussionTeamMembers: RLearningJourneySessionResult;
  /** Upsert a provider */
  upsertProvider: RProvider;
  userChangeRealmRole: RUserV2;
  userCompleteTour: RTourUserCompletions;
  /** Confirm a user invite import: re-validate the uploaded CSV, persist the batch snapshot, and enqueue the async apply job, returning immediately. Asynchronous. */
  userConfirmInviteImport: RUserInviteImportResult;
  /** Preview a user invite import: parse and validate the uploaded CSV, returning aggregate stats plus the per-row preview, or a file-level error. Synchronous, read-only. */
  userPreviewInviteImport: RUserInviteImportPreviewResult;
  voidObject?: Maybe<Scalars['ID']['output']>;
};

/** mutation root */
export type RMutationAddAssignmentUserSurveyArgs = {
  input: RAssignmentUserSurveyInput;
};

/** mutation root */
export type RMutationAddSelfTrackedLearningToLearningLoopArgs = {
  input: RAddSelfTrackedLearningToLearningLoopInput;
};

/** mutation root */
export type RMutationAddSpaceContentOriginArgs = {
  input: RAddSpaceContentOriginInput;
};

/** mutation root */
export type RMutationAddTeamsToLearningJourneyCohortArgs = {
  input: RUpdateLearningJourneyCohortTeamsInput;
};

/** mutation root */
export type RMutationAddUsersToLearningJourneyCohortArgs = {
  journeyId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};

/** mutation root */
export type RMutationApplyOrderRulesArgs = {
  orderId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationApproveLicenseArgs = {
  licenseId?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
};

/** mutation root */
export type RMutationArchiveLearningArgs = {
  learningId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationBootstrapLearningJourneySesssionDiscussionTeamsArgs = {
  sessionId: Scalars['Int']['input'];
  teamSize: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationCancelArgs = {
  orderId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationChangeEnrollmentLocationArgs = {
  input: RChangeEnrollmentLocationInput;
};

/** mutation root */
export type RMutationCloneLearningArgs = {
  input: RCloneLearningInput;
};

/** mutation root */
export type RMutationCloneLearningActivitiesArgs = {
  activityId: Scalars['Float']['input'];
};

/** mutation root */
export type RMutationCloneLearningJourneyArgs = {
  input: RCloneLearningJourneyInput;
};

/** mutation root */
export type RMutationCompleteLearningArgs = {
  learningId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationCompleteLearningPathArgs = {
  learningPathId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationCompleteObjectArgs = {
  objectId: Scalars['String']['input'];
  registration: Scalars['String']['input'];
  targetUserId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationCreateAssignmentFromTemplateArgs = {
  input: RCreateAssignmentFromTemplateInput;
};

/** mutation root */
export type RMutationCreateCollectionArgs = {
  payload: RCreateCollection;
};

/** mutation root */
export type RMutationCreateLearningJourneyArgs = {
  input: RCreateLearningJourneyInput;
};

/** mutation root */
export type RMutationCreateLearningJourneyFromTemplateArgs = {
  input: RCreateLearningJourneyFromTemplateInput;
};

/** mutation root */
export type RMutationCreateLearningJourneyLiveEventArgs = {
  input: RCreateLearningJourneyLiveEventInput;
};

/** mutation root */
export type RMutationCreateLearningJourneyPracticalAssessmentsArgs = {
  input: RCreateLearningJourneyPracticalAssessmentsInput;
};

/** mutation root */
export type RMutationCreateLearningLoopReflectionArgs = {
  input: RCreateLearningLoopReflectionInput;
};

/** mutation root */
export type RMutationCreateOrUpdateArgs = {
  product: RProductInput;
};

/** mutation root */
export type RMutationCreatePostArgs = {
  path: Array<Scalars['String']['input']>;
  payload?: InputMaybe<RPostInput>;
};

/** mutation root */
export type RMutationCreateSectionArgs = {
  payload?: InputMaybe<RCreateSectionInput>;
};

/** mutation root */
export type RMutationCreateSelfTrackedLearningArgs = {
  input: RCreateSelfTrackedLearningInput;
};

/** mutation root */
export type RMutationCreateSpaceArgs = {
  input: RCreateSpaceV2Input;
};

/** mutation root */
export type RMutationCreateSpaceRoleAssignmentArgs = {
  input: RCreateSpaceV2RoleAssignInput;
};

/** mutation root */
export type RMutationCreateUserLearningSubmissionArgs = {
  input: RCreateUserLearningSubmissionInput;
};

/** mutation root */
export type RMutationCreateUserLearningSubmissionReviewArgs = {
  input: RCreateUserLearningSubmissionReviewInput;
};

/** mutation root */
export type RMutationCreateUsersArgs = {
  payload?: InputMaybe<RCreateUserInput>;
};

/** mutation root */
export type RMutationCreateVariantArgs = {
  productId: Scalars['Int']['input'];
  variant: RVariantInput;
};

/** mutation root */
export type RMutationDeleteAssignmentV3Args = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationDeleteEnrollmentArgs = {
  input: RDeleteEnrollmentInput;
};

/** mutation root */
export type RMutationDeleteFeatureToggleArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationDeleteLearningArgs = {
  learningId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationDeleteLearningJourneysArgs = {
  journeyIds: Array<Scalars['Int']['input']>;
};

/** mutation root */
export type RMutationDeletePostArgs = {
  path: Array<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type RMutationDeleteProviderArgs = {
  id: Scalars['String']['input'];
};

/** mutation root */
export type RMutationDeleteSpaceContentOriginArgs = {
  input: RDeleteSpaceContentOriginInput;
};

/** mutation root */
export type RMutationDeleteSpaceRoleAssignmentArgs = {
  input: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationDeleteXapiStateArgs = {
  objectId: Scalars['String']['input'];
  registration: Scalars['String']['input'];
  targetUserId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationDelete_Clsapi_LearningArgs = {
  where: RClsapi_Learning_Bool_Exp;
};

/** mutation root */
export type RMutationDelete_Clsapi_Learning_By_PkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationDelete_Clsapi_Learning_JourneysArgs = {
  where: RClsapi_Learning_Journeys_Bool_Exp;
};

/** mutation root */
export type RMutationDelete_Clsapi_Learning_Journeys_By_PkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationDisableFeatureToggleForRealmArgs = {
  input: RFeatureToggleEnableRealmInput;
};

/** mutation root */
export type RMutationDisableFeatureToggleForUserArgs = {
  input: RFeatureToggleEnableUserInput;
};

/** mutation root */
export type RMutationEnableFeatureToggleForRealmArgs = {
  input: RFeatureToggleEnableRealmInput;
};

/** mutation root */
export type RMutationEnableFeatureToggleForUserArgs = {
  input: RFeatureToggleEnableUserInput;
};

/** mutation root */
export type RMutationEnrollSelfArgs = {
  input: REnrollSelfInput;
};

/** mutation root */
export type RMutationEnrollmentCreateByEmailsArgs = {
  input: REnrollByEmailInput;
};

/** mutation root */
export type RMutationGenerateLearningActivitiesCsvArgs = {
  input: RGenerateLearningReportCsvInput;
};

/** mutation root */
export type RMutationGenerateLearningActivityQuizCsvArgs = {
  input: RGenerateLearningActivityQuizCsvInput;
};

/** mutation root */
export type RMutationGenerateLearningItemLearnersCsvArgs = {
  input: RGenerateLearningReportCsvInput;
};

/** mutation root */
export type RMutationGenerateLearningJourneyItemsCsvArgs = {
  input: RGenerateLearningJourneyReportCsvInput;
};

/** mutation root */
export type RMutationGenerateLearningJourneyLearnersCsvArgs = {
  input: RGenerateLearningJourneyReportCsvInput;
};

/** mutation root */
export type RMutationGenerateLiveLearningItemLearnersCsvArgs = {
  input: RGenerateLearningReportCsvInput;
};

/** mutation root */
export type RMutationGenerateSectionItemsCsvArgs = {
  input: RGenerateLearningReportCsvInput;
};

/** mutation root */
export type RMutationGenerateSectionLearnersCsvArgs = {
  input: RGenerateLearningReportCsvInput;
};

/** mutation root */
export type RMutationImportLearningContentToSpaceArgs = {
  input: RImportLearningContentToSpaceInput;
};

/** mutation root */
export type RMutationInsert_Clsapi_LearningArgs = {
  objects: Array<RClsapi_Learning_Insert_Input>;
  on_conflict?: InputMaybe<RClsapi_Learning_On_Conflict>;
};

/** mutation root */
export type RMutationInsert_Clsapi_Learning_JourneysArgs = {
  objects: Array<RClsapi_Learning_Journeys_Insert_Input>;
  on_conflict?: InputMaybe<RClsapi_Learning_Journeys_On_Conflict>;
};

/** mutation root */
export type RMutationInsert_Clsapi_Learning_Journeys_OneArgs = {
  object: RClsapi_Learning_Journeys_Insert_Input;
  on_conflict?: InputMaybe<RClsapi_Learning_Journeys_On_Conflict>;
};

/** mutation root */
export type RMutationInsert_Clsapi_Learning_OneArgs = {
  object: RClsapi_Learning_Insert_Input;
  on_conflict?: InputMaybe<RClsapi_Learning_On_Conflict>;
};

/** mutation root */
export type RMutationJoinLearningJourneyCohortArgs = {
  sessionId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationLearningJourneyConfirmCohortImportArgs = {
  input: RLearningJourneyCohortImportInput;
};

/** mutation root */
export type RMutationLearningJourneyConfirmTeamImportArgs = {
  input: RLearningJourneyTeamImportInput;
};

/** mutation root */
export type RMutationLearningJourneyPreviewCohortImportArgs = {
  input: RLearningJourneyCohortImportInput;
};

/** mutation root */
export type RMutationLearningJourneyPreviewTeamImportArgs = {
  input: RLearningJourneyTeamImportInput;
};

/** mutation root */
export type RMutationLearningPinnedUpdateArgs = {
  input: Array<RLearningPinnedUpdateInput>;
  realm: Scalars['String']['input'];
};

/** mutation root */
export type RMutationMarkNotificationAsSeenArgs = {
  postId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationMigrateOnDemandLearningToCoursesArgs = {
  learningId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationPurchaseArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  products: Array<InputMaybe<RPurchaseProduct>>;
};

/** mutation root */
export type RMutationRegisterToLearningArgs = {
  learningId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationRemoveSelfTrackedLearningArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationRemoveUsersFromLearningJourneyCohortArgs = {
  journeyId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};

/** mutation root */
export type RMutationRemoveVariantArgs = {
  productId: Scalars['Int']['input'];
  variantId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationRequestLicenseArgs = {
  provider?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
};

/** mutation root */
export type RMutationResetLearningJourneySessionDiscussionTeamsArgs = {
  input: RResetLearningJourneySessionDiscussionTeamsInput;
};

/** mutation root */
export type RMutationRestoreLearningArgs = {
  learningId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationRevokeLicenseArgs = {
  licenseId?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type RMutationSadminPurchaseArgs = {
  emails: Array<InputMaybe<Scalars['String']['input']>>;
  note?: InputMaybe<Scalars['String']['input']>;
  product: RSadminPurchaseProduct;
};

/** mutation root */
export type RMutationSaveLearningArgs = {
  payload: RLearningInput;
};

/** mutation root */
export type RMutationSetBulkEnrollmentAttendanceArgs = {
  input: Array<RSetEnrollmentAttendanceInput>;
};

/** mutation root */
export type RMutationSetEnrollmentAttendanceArgs = {
  input: RSetEnrollmentAttendanceInput;
};

/** mutation root */
export type RMutationSetLanguageArgs = {
  payload?: InputMaybe<RSetLanguageInput>;
};

/** mutation root */
export type RMutationSetProgressPerCourseByUserArgs = {
  learningId: Scalars['String']['input'];
};

/** mutation root */
export type RMutationSetUserStatusArgs = {
  payload?: InputMaybe<RSetUserStatusInput>;
};

/** mutation root */
export type RMutationSetUsernameArgs = {
  payload?: InputMaybe<RSetUsernameInput>;
};

/** mutation root */
export type RMutationSubmitFeedbackArgs = {
  input: RSubmitFeedbackInput;
};

/** mutation root */
export type RMutationSubmitLearningActivityAssignmentArgs = {
  input: RSubmitLearningActivityAssignmentInput;
};

/** mutation root */
export type RMutationSubmitLearningActivityQuizAnswersArgs = {
  input: RUserLearningActivityQuizSubmissionInput;
};

/** mutation root */
export type RMutationTeamCreateArgs = {
  input: RTeamCreateInput;
};

/** mutation root */
export type RMutationTeamDeleteArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationTeamUpdateArgs = {
  input: RTeamUpdateInput;
};

/** mutation root */
export type RMutationTeamUserChangeRoleArgs = {
  input: RTeamUserChangeRoleInput;
};

/** mutation root */
export type RMutationTeamUserRemoveArgs = {
  input: RTeamUserRemoveInput;
};

/** mutation root */
export type RMutationTeamUsersAddArgs = {
  input: Array<RTeamUsersAddInput>;
};

/** mutation root */
export type RMutationToggleActionArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  path: Array<Scalars['String']['input']>;
  payload?: InputMaybe<RPostActionInput>;
  postId?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type RMutationUpdateCollectionArgs = {
  payload: RUpdateCollection;
};

/** mutation root */
export type RMutationUpdateCollectionItemsArgs = {
  payload: RUpdateCollectionItems;
};

/** mutation root */
export type RMutationUpdateLearningJourneyArgs = {
  input: RUpdateLearningJourneyInput;
  options?: InputMaybe<RUpdateLearningJourneyOptionsInput>;
};

/** mutation root */
export type RMutationUpdateLocationRecordingUrlArgs = {
  input: RUpdateLocationRecordingUrlInput;
};

/** mutation root */
export type RMutationUpdateMetaArgs = {
  meta: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

/** mutation root */
export type RMutationUpdateOrderArgs = {
  orderId: Scalars['Int']['input'];
  stateId: Scalars['Int']['input'];
};

/** mutation root */
export type RMutationUpdatePostArgs = {
  path: Array<Scalars['String']['input']>;
  payload?: InputMaybe<RPostInput>;
  postId?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type RMutationUpdateSectionArgs = {
  payload?: InputMaybe<RUpdateSectionInput>;
};

/** mutation root */
export type RMutationUpdateSelfTrackedLearningArgs = {
  input: RUpdateSelfTrackedLearningInput;
};

/** mutation root */
export type RMutationUpdateSpaceArgs = {
  input: RUpdateSpaceV2Input;
};

/** mutation root */
export type RMutationUpdateSpaceRoleAssignmentArgs = {
  input: RUpdateSpaceV2RoleAssignInput;
};

/** mutation root */
export type RMutationUpdateUserArgs = {
  input: RUserChangeInput;
};

/** mutation root */
export type RMutationUpdateVariantArgs = {
  productId: Scalars['Int']['input'];
  variant: RVariantInput;
};

/** mutation root */
export type RMutationUpdate_Clsapi_LearningArgs = {
  _inc?: InputMaybe<RClsapi_Learning_Inc_Input>;
  _set?: InputMaybe<RClsapi_Learning_Set_Input>;
  where: RClsapi_Learning_Bool_Exp;
};

/** mutation root */
export type RMutationUpdate_Clsapi_Learning_By_PkArgs = {
  _inc?: InputMaybe<RClsapi_Learning_Inc_Input>;
  _set?: InputMaybe<RClsapi_Learning_Set_Input>;
  pk_columns: RClsapi_Learning_Pk_Columns_Input;
};

/** mutation root */
export type RMutationUpdate_Clsapi_Learning_JourneysArgs = {
  _append?: InputMaybe<RClsapi_Learning_Journeys_Append_Input>;
  _delete_at_path?: InputMaybe<RClsapi_Learning_Journeys_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RClsapi_Learning_Journeys_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RClsapi_Learning_Journeys_Delete_Key_Input>;
  _inc?: InputMaybe<RClsapi_Learning_Journeys_Inc_Input>;
  _prepend?: InputMaybe<RClsapi_Learning_Journeys_Prepend_Input>;
  _set?: InputMaybe<RClsapi_Learning_Journeys_Set_Input>;
  where: RClsapi_Learning_Journeys_Bool_Exp;
};

/** mutation root */
export type RMutationUpdate_Clsapi_Learning_Journeys_By_PkArgs = {
  _append?: InputMaybe<RClsapi_Learning_Journeys_Append_Input>;
  _delete_at_path?: InputMaybe<RClsapi_Learning_Journeys_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RClsapi_Learning_Journeys_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RClsapi_Learning_Journeys_Delete_Key_Input>;
  _inc?: InputMaybe<RClsapi_Learning_Journeys_Inc_Input>;
  _prepend?: InputMaybe<RClsapi_Learning_Journeys_Prepend_Input>;
  _set?: InputMaybe<RClsapi_Learning_Journeys_Set_Input>;
  pk_columns: RClsapi_Learning_Journeys_Pk_Columns_Input;
};

/** mutation root */
export type RMutationUpdate_Clsapi_Learning_Journeys_ManyArgs = {
  updates: Array<RClsapi_Learning_Journeys_Updates>;
};

/** mutation root */
export type RMutationUpdate_Clsapi_Learning_ManyArgs = {
  updates: Array<RClsapi_Learning_Updates>;
};

/** mutation root */
export type RMutationUploadProfileImageArgs = {
  file: Scalars['Upload']['input'];
};

/** mutation root */
export type RMutationUpsertAssignmentV3Args = {
  input: RUpsertAssignmentInput;
};

/** mutation root */
export type RMutationUpsertCertificatePropertiesArgs = {
  input: RUpsertCertificatePropertiesInput;
};

/** mutation root */
export type RMutationUpsertFeatureToggleArgs = {
  input: RUpsertFeatureToggleInput;
};

/** mutation root */
export type RMutationUpsertLearningArgs = {
  input: RUpsertLearningInput;
};

/** mutation root */
export type RMutationUpsertLearningJourneyCohortsArgs = {
  input: RUpsertLearningJourneyCohortsInput;
};

/** mutation root */
export type RMutationUpsertLearningJourneyItemsArgs = {
  input: RUpsertLearningJourneyItemsInput;
};

/** mutation root */
export type RMutationUpsertLearningJourneySessionDiscussionTeamMembersArgs = {
  sessionId: Scalars['Int']['input'];
  teamMembers: Array<RUpsertLearningJourneySessionDiscussionTeamMembersInput>;
};

/** mutation root */
export type RMutationUpsertProviderArgs = {
  input: RProviderUpsertInput;
};

/** mutation root */
export type RMutationUserChangeRealmRoleArgs = {
  input: RUserChangeRealmRoleInput;
};

/** mutation root */
export type RMutationUserCompleteTourArgs = {
  input: RCreateTourCompleteUserInput;
};

/** mutation root */
export type RMutationUserConfirmInviteImportArgs = {
  input: RUserInviteImportConfirmInput;
};

/** mutation root */
export type RMutationUserPreviewInviteImportArgs = {
  input: RUserInviteImportPreviewInput;
};

/** mutation root */
export type RMutationVoidObjectArgs = {
  objectId: Scalars['String']['input'];
  registration: Scalars['String']['input'];
  targetUserId: Scalars['Int']['input'];
};

export type RMutationResponse = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RMyLocationEnrollment = {
  __typename?: 'MyLocationEnrollment';
  enrolled?: Maybe<Scalars['Boolean']['output']>;
  enrollmentStatus?: Maybe<RAttendedType>;
};

export type ROrder = {
  __typename?: 'Order';
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Maybe<RProductRow>>>;
  rowHistory?: Maybe<Array<Maybe<ROrderRow>>>;
  stateName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<RUser>;
};

export enum ROrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type ROrderHistory = {
  __typename?: 'OrderHistory';
  error?: Maybe<Scalars['String']['output']>;
  orderRowId?: Maybe<Scalars['String']['output']>;
  stateId?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<RUser>;
};

export type ROrderRow = {
  __typename?: 'OrderRow';
  product?: Maybe<RProductRow>;
  state?: Maybe<RState>;
  stateName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<RUser>;
};

export type ROrderRowFlat = {
  __typename?: 'OrderRowFlat';
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productVariantId?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<RProductRow>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  stateId?: Maybe<Scalars['Int']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<RUser>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ROrderSearch = {
  __typename?: 'OrderSearch';
  orders?: Maybe<Array<Maybe<ROrder>>>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type ROrderSearchQuery = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ROrderSearchTotal = {
  __typename?: 'OrderSearchTotal';
  total?: Maybe<Scalars['Int']['output']>;
};

export type ROrigin = {
  __typename?: 'Origin';
  id: Scalars['URN']['output'];
  launchURL?: Maybe<RLaunchUrl>;
};

export type RPage = {
  __typename?: 'Page';
  blocks?: Maybe<Array<Maybe<RBlock>>>;
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  moduleId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
};

export type RPageInfo = {
  __typename?: 'PageInfo';
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RPageInput = {
  blocks?: InputMaybe<Array<InputMaybe<RBlockInput>>>;
  created?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  moduleId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
};

export type RPageV2 = {
  __typename?: 'PageV2';
  blocks: Array<RBlockV2>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  moduleId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  urn: Scalars['String']['output'];
};

export type RPageV2Input = {
  blocks: RBlockV2Input;
  id?: InputMaybe<Scalars['Int']['input']>;
  moduleId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type RPagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RPaginationInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type RParticipant = {
  __typename?: 'Participant';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type RParticipantsResult = {
  __typename?: 'ParticipantsResult';
  participants?: Maybe<Array<Maybe<RParticipant>>>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type RParticipation = {
  __typename?: 'Participation';
  catalogObjectId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['Time']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['Time']['output']>;
  firstActivity?: Maybe<Scalars['Time']['output']>;
  firstStatement: Scalars['Time']['output'];
  id: Scalars['Int']['output'];
  isCompleted: Scalars['Boolean']['output'];
  lastActivity?: Maybe<Scalars['Time']['output']>;
  lastStatement: Scalars['Time']['output'];
  objectId: Scalars['String']['output'];
  objectName?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  plannedDuration?: Maybe<Scalars['Int']['output']>;
  platform: Scalars['String']['output'];
  progress: Scalars['Float']['output'];
  registeredAt?: Maybe<Scalars['Time']['output']>;
  registration: Scalars['String']['output'];
  userEffort?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['Int']['output'];
};

export type RParticipationAggregate = {
  __typename?: 'ParticipationAggregate';
  completed: Scalars['Int']['output'];
  completedNotExpired: Scalars['Int']['output'];
  effort: Scalars['Second']['output'];
  firstActivity?: Maybe<Scalars['Time']['output']>;
  lastActivity?: Maybe<Scalars['Time']['output']>;
  started: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RParticipationFilterInput = {
  activityFrom?: InputMaybe<Scalars['Time']['input']>;
  activityTo?: InputMaybe<Scalars['Time']['input']>;
  objectIds?: InputMaybe<Array<Scalars['URN']['input']>>;
  platforms?: InputMaybe<Array<RPlatform>>;
};

export type RParticipationGroup = {
  __typename?: 'ParticipationGroup';
  catalogObjectId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['String']['output']>;
  firstActivity?: Maybe<Scalars['String']['output']>;
  firstStatement: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCompleted: Scalars['Boolean']['output'];
  lastActivity?: Maybe<Scalars['String']['output']>;
  lastStatement: Scalars['String']['output'];
  objectId: Scalars['String']['output'];
  objectName?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  plannedDuration?: Maybe<Scalars['Int']['output']>;
  platform: Scalars['String']['output'];
  previousParticipations?: Maybe<Array<RParticipation>>;
  progress: Scalars['Float']['output'];
  registration: Scalars['String']['output'];
  userEffort?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['Int']['output'];
};

export type RParticipationResult = {
  __typename?: 'ParticipationResult';
  data: Array<RParticipation>;
  pageInfo: RPageInfo;
};

export enum RParticipationSortField {
  FirstActivity = 'FIRST_ACTIVITY',
  LastActivity = 'LAST_ACTIVITY',
  ObjectId = 'OBJECT_ID',
  Platform = 'PLATFORM',
}

export type RParticipationSortInput = {
  field: RParticipationSortField;
  order?: RSortOrder;
};

export type RParticipationV2 = {
  __typename?: 'ParticipationV2';
  catalogObjectId?: Maybe<Scalars['URN']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  expiryAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  lastActivity?: Maybe<Scalars['DateTime']['output']>;
  objectId: Scalars['URN']['output'];
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  plannedLearningsCount?: Maybe<Scalars['Int']['output']>;
  progress: Scalars['Float']['output'];
  userEffort?: Maybe<Scalars['Float']['output']>;
  userId: Scalars['Int']['output'];
};

export type RParticipationsInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  includeCatalogData?: InputMaybe<Scalars['Boolean']['input']>;
  isCompletedEq?: InputMaybe<Scalars['Boolean']['input']>;
  objectIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectTypeNin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  userIdEq?: InputMaybe<Scalars['Int']['input']>;
  userTeamIdIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  usersPool?: InputMaybe<RUsersPool>;
};

export type RPeriodFilter = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type RPeriodInput = {
  from: Scalars['Time']['input'];
  to: Scalars['Time']['input'];
};

export type RPermissionsRole = {
  __typename?: 'PermissionsRole';
  admin?: Maybe<Scalars['Boolean']['output']>;
  guest?: Maybe<Scalars['Boolean']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  member?: Maybe<Scalars['Boolean']['output']>;
  moderator?: Maybe<Scalars['Boolean']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<RSectionPermissions>;
};

export enum RPlatform {
  Collegial = 'collegial',
  Coursera = 'coursera',
  Finanskompetens = 'finanskompetens',
  Learnifier = 'learnifier',
  Linkedin = 'linkedin',
  Lumesse = 'lumesse',
  Pluralsight = 'pluralsight',
}

export type RPost = {
  __typename?: 'Post';
  ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  content?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  depth?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<RPostMedia>;
  path?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<RPostPermissions>;
  publishDate?: Maybe<Scalars['String']['output']>;
  replies?: Maybe<Array<Maybe<RPost>>>;
  section?: Maybe<RSection>;
  stats?: Maybe<RStats>;
  sticky?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
  user?: Maybe<RPostUser>;
  you?: Maybe<RYou>;
};

export type RPostActionInput = {
  scalar?: InputMaybe<Scalars['Int']['input']>;
};

export type RPostInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<RPostMediaInput>;
  originProductId?: InputMaybe<Scalars['Int']['input']>;
  pid?: InputMaybe<Scalars['Int']['input']>;
  propagates?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate?: InputMaybe<Scalars['String']['input']>;
  shouldSendNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RPostMedia = {
  __typename?: 'PostMedia';
  type?: Maybe<RPostMediaType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RPostMediaInput = {
  type?: InputMaybe<RPostMediaType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum RPostMediaType {
  Image = 'image',
  Resource = 'resource',
  Video = 'video',
}

export type RPostPermissions = {
  __typename?: 'PostPermissions';
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  canLock?: Maybe<Scalars['Boolean']['output']>;
  canPurge?: Maybe<Scalars['Boolean']['output']>;
  canReply?: Maybe<Scalars['Boolean']['output']>;
  canRestore?: Maybe<Scalars['Boolean']['output']>;
  canSticky?: Maybe<Scalars['Boolean']['output']>;
  canUnlock?: Maybe<Scalars['Boolean']['output']>;
  canUnsticky?: Maybe<Scalars['Boolean']['output']>;
  canViewReflectionReplies?: Maybe<Scalars['Boolean']['output']>;
};

export type RPostUser = {
  __typename?: 'PostUser';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RPostUserRole>;
  username?: Maybe<Scalars['String']['output']>;
};

export type RPostUserRole = {
  __typename?: 'PostUserRole';
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RPostsMeta = {
  __typename?: 'PostsMeta';
  items?: Maybe<Array<Maybe<RPost>>>;
  lastUpdate?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  pages?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RPresignedUrl = {
  __typename?: 'PresignedURL';
  expiresAfter: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type RProduct = {
  __typename?: 'Product';
  contentOwner?: Maybe<Scalars['Int']['output']>;
  costCenter?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<RProductFlags>;
  id?: Maybe<Scalars['Int']['output']>;
  isPending?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  learnifierCourseName?: Maybe<Scalars['String']['output']>;
  learningContentUrnV2?: Maybe<Scalars['URNV2']['output']>;
  legalEntity?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<RProductMeta>;
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  parents: Array<RLearningContent>;
  price?: Maybe<Scalars['Int']['output']>;
  productVariantId?: Maybe<Scalars['Int']['output']>;
  rowId?: Maybe<Scalars['Int']['output']>;
  services?: Maybe<Array<Maybe<RService>>>;
  space?: Maybe<RSpace>;
  state?: Maybe<RState>;
  status?: Maybe<RLearningStatus>;
  stocks?: Maybe<Array<Maybe<RStock>>>;
  subjects?: Maybe<Array<Maybe<RLearningSubject>>>;
  timestamp?: Maybe<Scalars['String']['output']>;
  variants?: Maybe<Array<Maybe<RVariant>>>;
};

export type RProductParentsArgs = {
  filter: RProductParentsFilter;
};

export type RProductCard = RCourseCard & {
  __typename?: 'ProductCard';
  archived?: Maybe<Scalars['Boolean']['output']>;
  attributes?: Maybe<Scalars['JSON']['output']>;
  available?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  customLink?: Maybe<Scalars['String']['output']>;
  entity: Scalars['String']['output'];
  entityId: Scalars['Int']['output'];
  featured?: Maybe<Scalars['Boolean']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  languageId?: Maybe<Scalars['Int']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  objectId?: Maybe<Scalars['String']['output']>;
  participation?: Maybe<RParticipation>;
  provider?: Maybe<Scalars['String']['output']>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subjects?: Maybe<Array<Maybe<RLearningSubject>>>;
  teaser?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalEffort?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<RLearningVisibility>;
};

export type RProductFlags = {
  __typename?: 'ProductFlags';
  approvalRequired?: Maybe<Scalars['Boolean']['output']>;
  available?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  enrollmentDisabled?: Maybe<Scalars['Boolean']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  globalMandatoryTraining?: Maybe<Scalars['Boolean']['output']>;
  hasTeams?: Maybe<Scalars['Boolean']['output']>;
  reflectionsEnabled?: Maybe<Scalars['Boolean']['output']>;
  requiresApplication?: Maybe<Scalars['Boolean']['output']>;
  socialFeaturesEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type RProductFlagsInput = {
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  canEdit?: InputMaybe<Scalars['Boolean']['input']>;
  enrollmentDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  globalMandatoryTraining?: InputMaybe<Scalars['Boolean']['input']>;
  hasTeams?: InputMaybe<Scalars['Boolean']['input']>;
  reflectionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  requiresApplication?: InputMaybe<Scalars['Boolean']['input']>;
  socialFeaturesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RProductInput = {
  contentOwner?: InputMaybe<Scalars['Int']['input']>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  creator?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<RProductFlagsInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  learnifierCourseName?: InputMaybe<Scalars['String']['input']>;
  legalEntity?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<RProductMetaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  rowId?: InputMaybe<Scalars['Int']['input']>;
  services?: InputMaybe<Array<InputMaybe<RServiceInput>>>;
  space?: InputMaybe<RSpaceInput>;
  state?: InputMaybe<RStateInput>;
  status?: InputMaybe<RLearningStatus>;
  stocks?: InputMaybe<Array<InputMaybe<RStockInput>>>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  variants?: InputMaybe<Array<InputMaybe<RVariantInput>>>;
};

export type RProductLabel = {
  __typename?: 'ProductLabel';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RProductMeta = {
  __typename?: 'ProductMeta';
  ATTRIBUTES?: Maybe<Scalars['String']['output']>;
  CONFIRM_MESSAGE?: Maybe<Scalars['String']['output']>;
  CONNECTIONS?: Maybe<Scalars['String']['output']>;
  CUSTOM_LINK?: Maybe<Scalars['String']['output']>;
  DESCRIPTION?: Maybe<Scalars['String']['output']>;
  DISCUSSION_SECTION?: Maybe<Scalars['String']['output']>;
  EFFORT?: Maybe<Scalars['String']['output']>;
  ENROLL_BUTTON_TEXT?: Maybe<Scalars['String']['output']>;
  FORMAT?: Maybe<Scalars['String']['output']>;
  IMAGE?: Maybe<Scalars['String']['output']>;
  INSTITUTION?: Maybe<Scalars['String']['output']>;
  INSTRUCTORS?: Maybe<Scalars['String']['output']>;
  LANGUAGE?: Maybe<Scalars['String']['output']>;
  LENGTH?: Maybe<Scalars['String']['output']>;
  LEVEL?: Maybe<Scalars['String']['output']>;
  LOCATION?: Maybe<Scalars['String']['output']>;
  METHOD?: Maybe<Scalars['String']['output']>;
  OBJECT_ID?: Maybe<Scalars['String']['output']>;
  PROVIDER?: Maybe<Scalars['String']['output']>;
  PROVIDER_ACCESS?: Maybe<Scalars['String']['output']>;
  REFLECTION_SECTION?: Maybe<Scalars['String']['output']>;
  TEAMS?: Maybe<Scalars['String']['output']>;
  TEAMSIZE?: Maybe<Scalars['String']['output']>;
  TEASER?: Maybe<Scalars['String']['output']>;
  TOTAL_EFFORT?: Maybe<Scalars['String']['output']>;
};

export type RProductMetaInput = {
  ATTRIBUTES?: InputMaybe<Scalars['String']['input']>;
  CATEGORY?: InputMaybe<Scalars['String']['input']>;
  CONFIRM_MESSAGE?: InputMaybe<Scalars['String']['input']>;
  CONNECTIONS?: InputMaybe<Scalars['String']['input']>;
  CUSTOM_LINK?: InputMaybe<Scalars['String']['input']>;
  DESCRIPTION?: InputMaybe<Scalars['String']['input']>;
  DISCUSSION_SECTION?: InputMaybe<Scalars['String']['input']>;
  EFFORT?: InputMaybe<Scalars['String']['input']>;
  ENROLL_BUTTON_TEXT?: InputMaybe<Scalars['String']['input']>;
  FORMAT?: InputMaybe<Scalars['String']['input']>;
  IMAGE?: InputMaybe<Scalars['String']['input']>;
  INSTITUTION?: InputMaybe<Scalars['String']['input']>;
  INSTRUCTORS?: InputMaybe<Scalars['String']['input']>;
  LANGUAGE?: InputMaybe<Scalars['String']['input']>;
  LENGTH?: InputMaybe<Scalars['String']['input']>;
  LEVEL?: InputMaybe<Scalars['String']['input']>;
  LOCATION?: InputMaybe<Scalars['String']['input']>;
  METHOD?: InputMaybe<Scalars['String']['input']>;
  OBJECT_ID?: InputMaybe<Scalars['String']['input']>;
  PROVIDER?: InputMaybe<Scalars['String']['input']>;
  PROVIDER_ACCESS?: InputMaybe<Scalars['String']['input']>;
  REFLECTION_SECTION?: InputMaybe<Scalars['String']['input']>;
  SUBJECT?: InputMaybe<Scalars['String']['input']>;
  TEAMS?: InputMaybe<Scalars['String']['input']>;
  TEAMSIZE?: InputMaybe<Scalars['String']['input']>;
  TEASER?: InputMaybe<Scalars['String']['input']>;
  TOTAL_EFFORT?: InputMaybe<Scalars['String']['input']>;
};

export type RProductOrder = {
  __typename?: 'ProductOrder';
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Maybe<RProductRow>>>;
  rows?: Maybe<Array<Maybe<RProductOrderRow>>>;
  user?: Maybe<RProductOrderUser>;
};

export type RProductOrderRow = {
  __typename?: 'ProductOrderRow';
  active?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<RProductOrderRowProduct>;
  quantity?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<RProductOrderState>;
};

export type RProductOrderRowProduct = {
  __typename?: 'ProductOrderRowProduct';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<RVariant>;
};

export type RProductOrderState = {
  __typename?: 'ProductOrderState';
  drawStock?: Maybe<Scalars['Boolean']['output']>;
  endState?: Maybe<Scalars['Boolean']['output']>;
  entitlement?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RProductOrderUser = {
  __typename?: 'ProductOrderUser';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type RProductOrdersFlat = {
  __typename?: 'ProductOrdersFlat';
  email?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productVariantId?: Maybe<Scalars['Int']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  stateId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type RProductOrdersFlatResult = {
  __typename?: 'ProductOrdersFlatResult';
  productOrders?: Maybe<Array<Maybe<RProductOrdersFlat>>>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type RProductParentCurationsFilter = {
  spaceIdIN: Array<Scalars['Int']['input']>;
};

export type RProductParentsFilter = {
  curation: RProductParentCurationsFilter;
};

export type RProductRow = {
  __typename?: 'ProductRow';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<RState>;
  variant?: Maybe<RVariantRow>;
};

export type RProgressPerCourse = {
  __typename?: 'ProgressPerCourse';
  course_id?: Maybe<Scalars['String']['output']>;
  course_name?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['String']['output']>;
};

export type RProvider = {
  __typename?: 'Provider';
  /** Get the content origins for a provider */
  contentOrigins: Array<RProviderContentOrigin>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: RLearningContentProvider;
  updatedAt: Scalars['DateTime']['output'];
};

export type RProviderContentOrigin = {
  __typename?: 'ProviderContentOrigin';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  metadata: RProviderContentOriginMetadata;
  provider: RProvider;
  providerId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RProviderContentOriginMetadata = {
  __typename?: 'ProviderContentOriginMetadata';
  programId?: Maybe<Scalars['String']['output']>;
  programSlug?: Maybe<Scalars['String']['output']>;
};

export type RProviderContentOriginPage = {
  __typename?: 'ProviderContentOriginPage';
  data: Array<RProviderContentOrigin>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RProviderFilter = {
  contentOriginIN?: InputMaybe<Array<Scalars['String']['input']>>;
  idIN?: InputMaybe<Array<Scalars['String']['input']>>;
  typeEQ?: InputMaybe<RLearningContentProvider>;
};

export type RProviderPage = {
  __typename?: 'ProviderPage';
  data: Array<RProvider>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RProviderUpsertInput = {
  credentials?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  owningRealm?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RLearningContentProvider>;
};

export type RPurchaseProduct = {
  id: Scalars['Int']['input'];
  productVariantId?: InputMaybe<Scalars['Int']['input']>;
};

export type RPurchaseResponse = {
  __typename?: 'PurchaseResponse';
  orderId: Scalars['Int']['output'];
};

export type RQuery = {
  __typename?: 'Query';
  _blank?: Maybe<Scalars['Boolean']['output']>;
  articleRedirect?: Maybe<RArticleRedirect>;
  assignmentTemplates: Array<RAssignmentTemplate>;
  assignmentV3?: Maybe<RAssignmentV3>;
  assignmentV3Learnings: RAssignmentV3LearningPage;
  assignmentV3Users: RAssignmentV3UsersPage;
  assignmentsV3: RAssignmentsV3Page;
  assignmentsV3UserRuleFields: Array<RAssignmentsV3UserRuleField>;
  assignmentsV3UserRulePreview: RAssignmentsV3UserRulePreview;
  blockV2: RBlockV2;
  catalog?: Maybe<RCatalog>;
  catalogJSON?: Maybe<Scalars['JSON']['output']>;
  certificateProperties?: Maybe<RCertificateProperties>;
  /** fetch data from the table: "clsapi.learning" */
  clsapi_learning: Array<RClsapi_Learning>;
  /** fetch aggregated fields from the table: "clsapi.learning" */
  clsapi_learning_aggregate: RClsapi_Learning_Aggregate;
  /** fetch data from the table: "clsapi.learning" using primary key columns */
  clsapi_learning_by_pk?: Maybe<RClsapi_Learning>;
  /** fetch data from the table: "clsapi.learning_journeys" */
  clsapi_learning_journeys: Array<RClsapi_Learning_Journeys>;
  /** fetch aggregated fields from the table: "clsapi.learning_journeys" */
  clsapi_learning_journeys_aggregate: RClsapi_Learning_Journeys_Aggregate;
  /** fetch data from the table: "clsapi.learning_journeys" using primary key columns */
  clsapi_learning_journeys_by_pk?: Maybe<RClsapi_Learning_Journeys>;
  enrollments: Array<REnrollment>;
  exportLicenses?: Maybe<Array<Maybe<RIssuedLicense>>>;
  featureToggle: RFeatureToggle;
  featureToggles: RFeatureTogglePage;
  findLearningJourneyItem: Array<RFoundLearningJourneyItemUnion>;
  getAggregationByName?: Maybe<RAggregation>;
  getAllOrdersByState?: Maybe<Array<Maybe<ROrderRowFlat>>>;
  getAllOrdersFiltered?: Maybe<RFilteredOrdersFlatResult>;
  getAllProductsShort?: Maybe<Array<Maybe<RProductLabel>>>;
  getApprovalsFiltered?: Maybe<RFilteredOrdersFlatResult>;
  getCategories?: Maybe<Array<Maybe<RCategory>>>;
  getCompletionRatePerCourse?: Maybe<Array<RCompletionRatePerCourse>>;
  getCompletionsOverTime?: Maybe<Array<Maybe<RDataItem>>>;
  getCurrentUserFeatureToggles?: Maybe<Array<RUserFeatureToggle>>;
  getEffortForRealm?: Maybe<Array<Maybe<REffortForRealm>>>;
  getEffortForRealmOverTime?: Maybe<Array<Maybe<REffortForRealmOverTime>>>;
  getElearningCompletionPerLearningIdByUserId?: Maybe<Array<Maybe<RCompletionPerElearning>>>;
  getHistoricCompletedCourses?: Maybe<Array<Maybe<RHistoricCompletedCourse>>>;
  getInventory?: Maybe<RInventory>;
  getLanguages?: Maybe<Array<Maybe<RLanguage>>>;
  getLearnifierCourses?: Maybe<Array<Maybe<RLearnifierCourse>>>;
  getLearningProgress?: Maybe<Array<Maybe<RAnalyticsProgress>>>;
  getMeta?: Maybe<RUserMeta>;
  getOrderHistoryById?: Maybe<Array<Maybe<ROrderHistory>>>;
  getOrders?: Maybe<ROrderSearch>;
  getParticipants?: Maybe<RParticipantsResult>;
  getParticipations: Array<RParticipationGroup>;
  getPost?: Maybe<RPost>;
  getProduct?: Maybe<RProduct>;
  getProductOrdersFlat?: Maybe<RProductOrdersFlatResult>;
  getProducts?: Maybe<Array<Maybe<RProduct>>>;
  getProgressPerCourseByUser?: Maybe<Array<Maybe<RProgressPerCourse>>>;
  getReplies?: Maybe<RReplies>;
  getSebUsersEmpAndActive?: Maybe<RSebUsersEmpAndActive>;
  getSection?: Maybe<RSection>;
  getSectionConversation?: Maybe<RSection>;
  getSpaces?: Maybe<Array<Maybe<RSpace>>>;
  getTotalTimeSpentPerProvider?: Maybe<Array<Maybe<REffortPerProvider>>>;
  getUserActivitySummary?: Maybe<Array<Maybe<RUserActivitySummary>>>;
  getUserById?: Maybe<RUser>;
  getUserEffort: RUserEffort;
  getUserEffortForRealmOverTime?: Maybe<RUserEffortOverTime>;
  getUserReplies?: Maybe<RReplies>;
  getUserStatuses?: Maybe<Array<Maybe<RDataItem>>>;
  getUsersByEmail?: Maybe<Array<Maybe<RUser>>>;
  getUsersPerVerb?: Maybe<Array<Maybe<RDataItem>>>;
  getVariants?: Maybe<Array<Maybe<RVariant>>>;
  getXAPISession: RXapiSession;
  isLearningCompleted: Scalars['Boolean']['output'];
  isLearningPathCompleted?: Maybe<Scalars['Boolean']['output']>;
  issuedLicense?: Maybe<RIssuedLicense>;
  issuedLicenses?: Maybe<Array<Maybe<RIssuedLicense>>>;
  learning?: Maybe<RLearning>;
  learningCollection?: Maybe<RLearningCollection>;
  learningCollectionV2: RLearningCollectionV2;
  learningCollections?: Maybe<Array<Maybe<RLearningCollection>>>;
  learningCollectionsV2: RLearningCollectionPage;
  learningContentById: RLearningContent;
  learningContentByIdV1: RLearningContent;
  learningContentByIds: Array<RLearningContent>;
  learningContentByIdsV1: Array<RLearningContent>;
  learningJourney: RLearningJourney;
  /** Poll the lifecycle status and progress of an import batch by id. */
  learningJourneyCohortImportBatchStatus: RLearningJourneyCohortImportBatchStatusResult;
  learningJourneyItemsCatalog: RLearningContentsPage;
  learningJourneyParticipantsByUserIds: Array<RLearningJourneyLearner>;
  learningJourneySession: RLearningJourneySession;
  learningJourneySessions: RLearningJourneySessionPage;
  learningJourneyTemplates: Array<RLearningJourneyTemplateDto>;
  /** @deprecated Use myLearningJourneyUpcomingEventLocation instead */
  learningJourneyUpcomingEventLocation?: Maybe<RLocation>;
  learningJourneyUpcomingItem?: Maybe<RLearningJourneyUpcomingItem>;
  learningJourneys: RLearningJourneyPage;
  learningLoop: RLearningLoop;
  learningLoopReflectionByLearningLoopId?: Maybe<RLearningLoopReflection>;
  learningLoops: RLearningLoopPage;
  learningSectionItemsCatalog: RLearningContentsPage;
  learningV2: RLearningV2;
  learningsPinned: Array<RLearningPinned>;
  me: RMe;
  moduleV2: RModuleV2;
  modules?: Maybe<Array<Maybe<RModule>>>;
  myEnrollments: Array<REventEnrollment>;
  /** The current user's assignment submissions for the given activities. Only activities with a submission are returned, so an empty list means nothing was submitted. */
  myLearningActivityAssignmentSubmissions: Array<RUserLearningActivityAssignmentSubmission>;
  myLearningActivityQuizSubmissions: Array<RUserLearningActivityQuizSubmission>;
  myLearningJourneyUpcomingEventLocation?: Maybe<RLocation>;
  /** Retrieves spaces that the current user has access to */
  mySpaces: RSpaceV2Page;
  notifications?: Maybe<Array<Maybe<RBabelonNotification>>>;
  overLicenseLimit?: Maybe<Scalars['Boolean']['output']>;
  pageV2: RPageV2;
  pages?: Maybe<Array<Maybe<RPage>>>;
  /** Get a provider by id */
  provider: RProvider;
  providerAccessProductId?: Maybe<RIdResponse>;
  /** Get a paginated list of providers */
  providers: RProviderPage;
  realmConfig?: Maybe<RRealmConfig>;
  realmFeatureToggles?: Maybe<Array<RRealmFeatureToggle>>;
  realmProviderLicensesSummary?: Maybe<RRealmProviderLicenseSummary>;
  realmV2?: Maybe<RRealmV2>;
  realmV2BySlug?: Maybe<RRealmV2>;
  realms: Array<RRealm>;
  realmsV2: RRealmsV2Page;
  /** fetch data from the table: "reporting.mv_aggregation_effort_for_realm" */
  reportingAggregationEffortForRealm: Array<RReportingAggregationEffortForRealm>;
  /** fetch aggregated fields from the table: "reporting.mv_aggregation_effort_for_realm" */
  reportingAggregationEffortForRealmAggregate: RReportingAggregationEffortForRealm_Aggregate;
  /** fetch data from the table: "reporting.mv_learning_activities_insights" */
  reportingLearningActivitiesInsights: Array<RReportingLearningActivitiesInsights>;
  /** fetch aggregated fields from the table: "reporting.mv_learning_activities_insights" */
  reportingLearningActivitiesInsightsAggregate: RReportingLearningActivitiesInsights_Aggregate;
  reportingLearningActivitiesInsightsV2: Array<RLearning_Activities_Insights>;
  reportingLearningActivitiesInsightsV2TotalCount: Array<RTotal_Count>;
  /** fetch data from the table: "reporting.mv_learning_journey_content_insights" */
  reportingLearningJourneyContentInsights: Array<RReportingLearningJourneyContentInsights>;
  /** fetch aggregated fields from the table: "reporting.mv_learning_journey_content_insights" */
  reportingLearningJourneyContentInsightsAggregate: RReportingLearningJourneyContentInsights_Aggregate;
  reportingLearningJourneysItems: Array<RLearning_Journeys_Items>;
  reportingLearningJourneysItemsInsights: Array<RLearning_Journeys_Items_Insights>;
  reportingLearningJourneysItemsTotalCount: Array<RTotal_Count>;
  reportingLearningSummary: Array<RLearning_Summary>;
  reportingLearnings: Array<RLearnings>;
  reportingLearningsInsights: Array<RLearningsInsights>;
  reportingLearningsTotalCount: Array<RTotal_Count>;
  reportingMyLearningJourneyDetails: Array<RLearning_Journey_Details>;
  reportingMyLearningJourneysInsightsV2: Array<RLearning_Journeys_Insights_V2>;
  reportingMyLearningJourneysLearners: Array<RLearning_Journey_Learners>;
  reportingMyLearningJourneysLearnersTotalCount: Array<RTotal_Count>;
  reportingMyLearningJourneysTotalCount: Array<RTotal_Count>;
  reportingMyLearningJourneysV2: Array<RLearning_Journeys_V2>;
  reportingMyLearningsLearners: Array<RLearners>;
  reportingMyLearningsLearnersTotalCount: Array<RTotal_Count>;
  reportingMyLearningsPracticalAssessment: Array<RPractical_Assessment>;
  reportingMyLearningsQuiz: Array<RQuiz>;
  reportingMyLiveLearningsLearners: Array<RLive_Learnings_Learners>;
  reportingMyLiveLearningsLearnersTotalCount: Array<RTotal_Count>;
  /** fetch data from the table: "reporting.mv_participants_insights" */
  reportingParticipantsInsights: Array<RReportingParticipantsInsights>;
  /** fetch aggregated fields from the table: "reporting.mv_participants_insights" */
  reportingParticipantsInsightsAggregate: RReportingParticipantsInsights_Aggregate;
  /** fetch data from the table: "reporting.mv_practical_assessment_insights" */
  reportingPracticalAssessmentInsights: Array<RReportingPracticalAssessmentInsights>;
  /** fetch aggregated fields from the table: "reporting.mv_practical_assessment_insights" */
  reportingPracticalAssessmentInsightsAggregate: RReportingPracticalAssessmentInsights_Aggregate;
  /** fetch data from the table: "reporting.mv_quiz_questions_insights" */
  reportingQuizQuestionsInsights: Array<RReportingQuizQuestionsInsights>;
  /** fetch aggregated fields from the table: "reporting.mv_quiz_questions_insights" */
  reportingQuizQuestionsInsightsAggregate: RReportingQuizQuestionsInsights_Aggregate;
  /** fetch data from the table: "reporting.mv_quiz_summary_insights" */
  reportingQuizSummaryInsights: Array<RReportingQuizSummaryInsights>;
  /** fetch aggregated fields from the table: "reporting.mv_quiz_summary_insights" */
  reportingQuizSummaryInsightsAggregate: RReportingQuizSummaryInsights_Aggregate;
  reportingSectionsItems: Array<RSections_Items>;
  reportingSectionsItemsInsights: Array<RSections_Items_Insights>;
  reportingSectionsItemsTotalCount: Array<RTotal_Count>;
  searchLearningContent: RLearningContentsPage;
  searchLearningContentByCurations: RLearningContentsPage;
  searchSubordinateUsersByEmail?: Maybe<Array<Maybe<RUser>>>;
  selfTrackedLearning: RSelfTrackedLearning;
  selfTrackedLearnings: RSelfTrackedLearningsPage;
  /** Retrieves a space by its ID */
  space: RSpaceV2;
  /** Retrieves members of specified spaces */
  spaceMembers: RSpaceMemberPage;
  /** Retrieves all spaces */
  spaces: RSpaceV2Page;
  surveyAnswerInsightsCSV: Scalars['String']['output'];
  team?: Maybe<RTeam>;
  /** Retrieves team users */
  teamUsers: RTeamUsersPage;
  /** Retrieves team users list */
  teamUsersList: RUserList;
  /** Retrieves teams */
  teams: RTeamsPage;
  user?: Maybe<RUserV2>;
  /** Poll the lifecycle status and progress of a user invite import batch by id. */
  userInviteImportBatchStatus: RUserInviteImportBatchStatusResult;
  userLearningContentLastParticipation?: Maybe<RParticipationV2>;
  userLearningContentLastParticipations: Array<RParticipationV2>;
  userLearningSubmissions: Array<RUserLearningSubmission>;
  userPendingTours: Array<RTour>;
  userTeams: RTeamUsersPage;
  users: RUsersPage;
};

export type RQueryArticleRedirectArgs = {
  articleId: Scalars['Int']['input'];
};

export type RQueryAssignmentV3Args = {
  id: Scalars['Int']['input'];
};

export type RQueryAssignmentV3LearningsArgs = {
  id: Scalars['Int']['input'];
  pagination?: InputMaybe<RPagination>;
};

export type RQueryAssignmentV3UsersArgs = {
  filter: RAssignmentV3UsersFilter;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RAssignmentUsersV3Sort>;
};

export type RQueryAssignmentsV3Args = {
  filter?: InputMaybe<RAssignmentsV3Filter>;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RAssignmentsV3Sort>;
};

export type RQueryAssignmentsV3UserRuleFieldsArgs = {
  filter: RAssignmentsV3UserRuleFieldFilter;
};

export type RQueryAssignmentsV3UserRulePreviewArgs = {
  filter: RAssignmentsV3UserRulePreviewFilter;
};

export type RQueryBlockV2Args = {
  id: Scalars['Int']['input'];
};

export type RQueryCatalogArgs = {
  items?: InputMaybe<Array<InputMaybe<RCatalogItems>>>;
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RQueryCatalogJsonArgs = {
  items?: InputMaybe<Array<InputMaybe<RCatalogItems>>>;
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RQueryCertificatePropertiesArgs = {
  urn: Scalars['URN']['input'];
};

export type RQueryClsapi_LearningArgs = {
  distinct_on?: InputMaybe<Array<RClsapi_Learning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RClsapi_Learning_Order_By>>;
  where?: InputMaybe<RClsapi_Learning_Bool_Exp>;
};

export type RQueryClsapi_Learning_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RClsapi_Learning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RClsapi_Learning_Order_By>>;
  where?: InputMaybe<RClsapi_Learning_Bool_Exp>;
};

export type RQueryClsapi_Learning_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type RQueryClsapi_Learning_JourneysArgs = {
  distinct_on?: InputMaybe<Array<RClsapi_Learning_Journeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RClsapi_Learning_Journeys_Order_By>>;
  where?: InputMaybe<RClsapi_Learning_Journeys_Bool_Exp>;
};

export type RQueryClsapi_Learning_Journeys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RClsapi_Learning_Journeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RClsapi_Learning_Journeys_Order_By>>;
  where?: InputMaybe<RClsapi_Learning_Journeys_Bool_Exp>;
};

export type RQueryClsapi_Learning_Journeys_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type RQueryEnrollmentsArgs = {
  input: REnrollmentsInput;
};

export type RQueryExportLicensesArgs = {
  realm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RQueryFeatureToggleArgs = {
  id: Scalars['Int']['input'];
};

export type RQueryFeatureTogglesArgs = {
  filter?: InputMaybe<RFeatureToggleFilter>;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RFeatureToggleSort>;
};

export type RQueryFindLearningJourneyItemArgs = {
  filter: RFindLearningJourneyItemFilter;
};

export type RQueryGetAggregationByNameArgs = {
  name: Scalars['String']['input'];
};

export type RQueryGetAllOrdersByStateArgs = {
  stateId?: InputMaybe<Scalars['Int']['input']>;
};

export type RQueryGetAllOrdersFilteredArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type RQueryGetApprovalsFilteredArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type RQueryGetCompletionRatePerCourseArgs = {
  userTeamIdIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  usersPool?: InputMaybe<RUsersPool>;
};

export type RQueryGetCompletionsOverTimeArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  usersPool: RUsersPool;
};

export type RQueryGetCurrentUserFeatureTogglesArgs = {
  realm: Scalars['String']['input'];
};

export type RQueryGetEffortForRealmArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  select?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  usersPool: RUsersPool;
};

export type RQueryGetEffortForRealmOverTimeArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  usersPool: RUsersPool;
};

export type RQueryGetElearningCompletionPerLearningIdByUserIdArgs = {
  user_id: Scalars['Int']['input'];
};

export type RQueryGetMetaArgs = {
  type: Scalars['String']['input'];
};

export type RQueryGetOrderHistoryByIdArgs = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
};

export type RQueryGetOrdersArgs = {
  orderBy: Scalars['String']['input'];
  orderByDirection: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  query: ROrderSearchQuery;
};

export type RQueryGetParticipantsArgs = {
  orderDirection?: InputMaybe<ROrderDirection>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  stateIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type RQueryGetParticipationsArgs = {
  input: RParticipationsInput;
};

export type RQueryGetPostArgs = {
  path: Array<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
};

export type RQueryGetProductArgs = {
  fetchAllVariants?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};

export type RQueryGetProductOrdersFlatArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  stateIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type RQueryGetProgressPerCourseByUserArgs = {
  email: Scalars['String']['input'];
};

export type RQueryGetRepliesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  path: Array<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
};

export type RQueryGetSebUsersEmpAndActiveArgs = {
  usersPool: RUsersPool;
};

export type RQueryGetSectionArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  path: Array<Scalars['String']['input']>;
};

export type RQueryGetSectionConversationArgs = {
  depth?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  path: Array<Scalars['String']['input']>;
  postId: Scalars['Int']['input'];
  replies?: InputMaybe<Scalars['Int']['input']>;
};

export type RQueryGetUserActivitySummaryArgs = {
  usersPool: RUsersPool;
};

export type RQueryGetUserByIdArgs = {
  userId: Scalars['Int']['input'];
};

export type RQueryGetUserEffortArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type RQueryGetUserEffortForRealmOverTimeArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  userIdIn?: InputMaybe<Scalars['Int']['input']>;
  usersPool: RUsersPool;
};

export type RQueryGetUserRepliesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  path: Array<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
};

export type RQueryGetUserStatusesArgs = {
  usersPool: RUsersPool;
};

export type RQueryGetUsersByEmailArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RQueryGetUsersPerVerbArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  usersPool: RUsersPool;
};

export type RQueryGetVariantsArgs = {
  productId: Scalars['Int']['input'];
};

export type RQueryGetXapiSessionArgs = {
  learningId: Scalars['Int']['input'];
};

export type RQueryIsLearningCompletedArgs = {
  learningId: Scalars['Int']['input'];
};

export type RQueryIsLearningPathCompletedArgs = {
  learningPathId: Scalars['Int']['input'];
};

export type RQueryIssuedLicenseArgs = {
  provider?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type RQueryIssuedLicensesArgs = {
  provider?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type RQueryLearningArgs = {
  id: Scalars['ID']['input'];
};

export type RQueryLearningCollectionArgs = {
  id: Scalars['Int']['input'];
};

export type RQueryLearningCollectionV2Args = {
  id: Scalars['Int']['input'];
};

export type RQueryLearningCollectionsV2Args = {
  filter: RLearningCollectionFilter;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RLearningCollectionSort>;
};

export type RQueryLearningContentByIdArgs = {
  urn: Scalars['URN']['input'];
};

export type RQueryLearningContentByIdV1Args = {
  urnV1: Scalars['String']['input'];
};

export type RQueryLearningContentByIdsArgs = {
  input: Array<Scalars['URN']['input']>;
  pagination?: InputMaybe<RPagination>;
};

export type RQueryLearningContentByIdsV1Args = {
  input: Array<Scalars['String']['input']>;
  pagination?: InputMaybe<RPagination>;
};

export type RQueryLearningJourneyArgs = {
  id: Scalars['Int']['input'];
};

export type RQueryLearningJourneyCohortImportBatchStatusArgs = {
  batchId: Scalars['ID']['input'];
};

export type RQueryLearningJourneyItemsCatalogArgs = {
  filter: RLearningJourneyItemsCatalogFilter;
  pagination?: InputMaybe<RPagination>;
};

export type RQueryLearningJourneyParticipantsByUserIdsArgs = {
  journeyId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};

export type RQueryLearningJourneySessionArgs = {
  id: Scalars['Int']['input'];
};

export type RQueryLearningJourneySessionsArgs = {
  spaceId: Scalars['Int']['input'];
};

export type RQueryLearningJourneyUpcomingEventLocationArgs = {
  journeyId: Scalars['Int']['input'];
};

export type RQueryLearningJourneyUpcomingItemArgs = {
  afterItemURN?: InputMaybe<Scalars['URN']['input']>;
  journeyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type RQueryLearningJourneysArgs = {
  filter: RLearningJourneyFilter;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RLearningJourneySort>;
};

export type RQueryLearningLoopArgs = {
  id: Scalars['String']['input'];
};

export type RQueryLearningLoopReflectionByLearningLoopIdArgs = {
  learningLoopId: Scalars['String']['input'];
};

export type RQueryLearningLoopsArgs = {
  filter: RLearningLoopFilter;
  pagination?: InputMaybe<RPagination>;
};

export type RQueryLearningSectionItemsCatalogArgs = {
  filter: RLearningSectionItemsCatalogFilter;
  pagination?: InputMaybe<RPagination>;
};

export type RQueryLearningV2Args = {
  id: Scalars['Int']['input'];
};

export type RQueryLearningsPinnedArgs = {
  realm: Scalars['String']['input'];
};

export type RQueryModuleV2Args = {
  id: Scalars['Int']['input'];
};

export type RQueryModulesArgs = {
  learningId: Scalars['ID']['input'];
};

export type RQueryMyLearningActivityAssignmentSubmissionsArgs = {
  input: RUserLearningActivityAssignmentSubmissionFilterInput;
};

export type RQueryMyLearningActivityQuizSubmissionsArgs = {
  input: RUserLearningActivityQuizSubmissionFilterInput;
};

export type RQueryMyLearningJourneyUpcomingEventLocationArgs = {
  journeyId: Scalars['Int']['input'];
};

export type RQueryMySpacesArgs = {
  pagination?: InputMaybe<RPagination>;
};

export type RQueryOverLicenseLimitArgs = {
  realm?: InputMaybe<Scalars['String']['input']>;
};

export type RQueryPageV2Args = {
  id: Scalars['Int']['input'];
};

export type RQueryPagesArgs = {
  moduleId: Scalars['ID']['input'];
};

export type RQueryProviderArgs = {
  id: Scalars['String']['input'];
};

export type RQueryProviderAccessProductIdArgs = {
  provider?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
};

export type RQueryProvidersArgs = {
  filter?: InputMaybe<RProviderFilter>;
  pagination?: InputMaybe<RPagination>;
};

export type RQueryRealmConfigArgs = {
  realm: Scalars['String']['input'];
};

export type RQueryRealmFeatureTogglesArgs = {
  realm: Scalars['String']['input'];
};

export type RQueryRealmProviderLicensesSummaryArgs = {
  provider?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
};

export type RQueryRealmV2Args = {
  id: Scalars['Float']['input'];
};

export type RQueryRealmV2BySlugArgs = {
  slug: Scalars['String']['input'];
};

export type RQueryRealmsV2Args = {
  filter?: InputMaybe<RRealmsFilter>;
  pagination?: InputMaybe<RPagination>;
};

export type RQueryReportingAggregationEffortForRealmArgs = {
  distinct_on?: InputMaybe<Array<RReportingAggregationEffortForRealm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingAggregationEffortForRealm_Order_By>>;
  where?: InputMaybe<RReportingAggregationEffortForRealm_Bool_Exp>;
};

export type RQueryReportingAggregationEffortForRealmAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingAggregationEffortForRealm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingAggregationEffortForRealm_Order_By>>;
  where?: InputMaybe<RReportingAggregationEffortForRealm_Bool_Exp>;
};

export type RQueryReportingLearningActivitiesInsightsArgs = {
  distinct_on?: InputMaybe<Array<RReportingLearningActivitiesInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingLearningActivitiesInsights_Order_By>>;
  where?: InputMaybe<RReportingLearningActivitiesInsights_Bool_Exp>;
};

export type RQueryReportingLearningActivitiesInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingLearningActivitiesInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingLearningActivitiesInsights_Order_By>>;
  where?: InputMaybe<RReportingLearningActivitiesInsights_Bool_Exp>;
};

export type RQueryReportingLearningActivitiesInsightsV2Args = {
  args: RReportingLearningActivitiesInsightsV2_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Activities_Insights_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Activities_Insights_Order_By>>;
  where?: InputMaybe<RLearning_Activities_Insights_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingLearningActivitiesInsightsV2TotalCountArgs = {
  args: RReportingLearningActivitiesInsightsV2TotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingLearningJourneyContentInsightsArgs = {
  distinct_on?: InputMaybe<Array<RReportingLearningJourneyContentInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingLearningJourneyContentInsights_Order_By>>;
  where?: InputMaybe<RReportingLearningJourneyContentInsights_Bool_Exp>;
};

export type RQueryReportingLearningJourneyContentInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingLearningJourneyContentInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingLearningJourneyContentInsights_Order_By>>;
  where?: InputMaybe<RReportingLearningJourneyContentInsights_Bool_Exp>;
};

export type RQueryReportingLearningJourneysItemsArgs = {
  args: RReportingLearningJourneysItems_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Journeys_Items_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journeys_Items_Order_By>>;
  where?: InputMaybe<RLearning_Journeys_Items_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingLearningJourneysItemsInsightsArgs = {
  args: RReportingLearningJourneysItemsInsights_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Journeys_Items_Insights_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journeys_Items_Insights_Order_By>>;
  where?: InputMaybe<RLearning_Journeys_Items_Insights_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingLearningJourneysItemsTotalCountArgs = {
  args: RReportingLearningJourneysItemsTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingLearningSummaryArgs = {
  args: RReportingLearningSummary_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Summary_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Summary_Order_By>>;
  where?: InputMaybe<RLearning_Summary_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingLearningsArgs = {
  args: RReportingLearnings_Arguments;
  distinct_on?: InputMaybe<Array<RLearnings_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearnings_Order_By>>;
  where?: InputMaybe<RLearnings_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingLearningsInsightsArgs = {
  args: RReportingLearningsInsights_Arguments;
  distinct_on?: InputMaybe<Array<RLearningsInsights_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearningsInsights_Order_By>>;
  where?: InputMaybe<RLearningsInsights_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingLearningsTotalCountArgs = {
  args: RReportingLearningsTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingMyLearningJourneyDetailsArgs = {
  args: RReportingMyLearningJourneyDetails_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Journey_Details_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journey_Details_Order_By>>;
  where?: InputMaybe<RLearning_Journey_Details_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingMyLearningJourneysInsightsV2Args = {
  args: RReportingMyLearningJourneysInsightsV2_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Journeys_Insights_V2_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journeys_Insights_V2_Order_By>>;
  where?: InputMaybe<RLearning_Journeys_Insights_V2_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingMyLearningJourneysLearnersArgs = {
  args: RReportingMyLearningJourneysLearners_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Journey_Learners_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journey_Learners_Order_By>>;
  where?: InputMaybe<RLearning_Journey_Learners_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingMyLearningJourneysLearnersTotalCountArgs = {
  args: RReportingMyLearningJourneysLearnersTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingMyLearningJourneysTotalCountArgs = {
  args: RReportingMyLearningJourneysTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingMyLearningJourneysV2Args = {
  args: RReportingMyLearningJourneysV2_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Journeys_V2_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journeys_V2_Order_By>>;
  where?: InputMaybe<RLearning_Journeys_V2_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingMyLearningsLearnersArgs = {
  args: RReportingMyLearningsLearners_Arguments;
  distinct_on?: InputMaybe<Array<RLearners_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearners_Order_By>>;
  where?: InputMaybe<RLearners_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingMyLearningsLearnersTotalCountArgs = {
  args: RReportingMyLearningsLearnersTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingMyLearningsPracticalAssessmentArgs = {
  args: RReportingMyLearningsPracticalAssessment_Arguments;
  distinct_on?: InputMaybe<Array<RPractical_Assessment_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RPractical_Assessment_Order_By>>;
  where?: InputMaybe<RPractical_Assessment_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingMyLearningsQuizArgs = {
  args: RReportingMyLearningsQuiz_Arguments;
  distinct_on?: InputMaybe<Array<RQuiz_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RQuiz_Order_By>>;
  where?: InputMaybe<RQuiz_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingMyLiveLearningsLearnersArgs = {
  args: RReportingMyLiveLearningsLearners_Arguments;
  distinct_on?: InputMaybe<Array<RLive_Learnings_Learners_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLive_Learnings_Learners_Order_By>>;
  where?: InputMaybe<RLive_Learnings_Learners_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingMyLiveLearningsLearnersTotalCountArgs = {
  args: RReportingMyLiveLearningsLearnersTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingParticipantsInsightsArgs = {
  distinct_on?: InputMaybe<Array<RReportingParticipantsInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingParticipantsInsights_Order_By>>;
  where?: InputMaybe<RReportingParticipantsInsights_Bool_Exp>;
};

export type RQueryReportingParticipantsInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingParticipantsInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingParticipantsInsights_Order_By>>;
  where?: InputMaybe<RReportingParticipantsInsights_Bool_Exp>;
};

export type RQueryReportingPracticalAssessmentInsightsArgs = {
  distinct_on?: InputMaybe<Array<RReportingPracticalAssessmentInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingPracticalAssessmentInsights_Order_By>>;
  where?: InputMaybe<RReportingPracticalAssessmentInsights_Bool_Exp>;
};

export type RQueryReportingPracticalAssessmentInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingPracticalAssessmentInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingPracticalAssessmentInsights_Order_By>>;
  where?: InputMaybe<RReportingPracticalAssessmentInsights_Bool_Exp>;
};

export type RQueryReportingQuizQuestionsInsightsArgs = {
  distinct_on?: InputMaybe<Array<RReportingQuizQuestionsInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingQuizQuestionsInsights_Order_By>>;
  where?: InputMaybe<RReportingQuizQuestionsInsights_Bool_Exp>;
};

export type RQueryReportingQuizQuestionsInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingQuizQuestionsInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingQuizQuestionsInsights_Order_By>>;
  where?: InputMaybe<RReportingQuizQuestionsInsights_Bool_Exp>;
};

export type RQueryReportingQuizSummaryInsightsArgs = {
  distinct_on?: InputMaybe<Array<RReportingQuizSummaryInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingQuizSummaryInsights_Order_By>>;
  where?: InputMaybe<RReportingQuizSummaryInsights_Bool_Exp>;
};

export type RQueryReportingQuizSummaryInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingQuizSummaryInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingQuizSummaryInsights_Order_By>>;
  where?: InputMaybe<RReportingQuizSummaryInsights_Bool_Exp>;
};

export type RQueryReportingSectionsItemsArgs = {
  args: RReportingSectionsItems_Arguments;
  distinct_on?: InputMaybe<Array<RSections_Items_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RSections_Items_Order_By>>;
  where?: InputMaybe<RSections_Items_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingSectionsItemsInsightsArgs = {
  args: RReportingSectionsItemsInsights_Arguments;
  distinct_on?: InputMaybe<Array<RSections_Items_Insights_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RSections_Items_Insights_Order_By>>;
  where?: InputMaybe<RSections_Items_Insights_Bool_Exp_Bool_Exp>;
};

export type RQueryReportingSectionsItemsTotalCountArgs = {
  args: RReportingSectionsItemsTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RQuerySearchLearningContentArgs = {
  filter: RSearchLearningContentFilter;
  pagination?: InputMaybe<RPagination>;
};

export type RQuerySearchLearningContentByCurationsArgs = {
  filter: RCurationFilter;
  pagination?: InputMaybe<RPagination>;
};

export type RQuerySearchSubordinateUsersByEmailArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<RSearchSubordinateUsersInput>;
};

export type RQuerySelfTrackedLearningArgs = {
  id: Scalars['Int']['input'];
};

export type RQuerySelfTrackedLearningsArgs = {
  filter: RSelfTrackedLearningsFilter;
  pagination?: InputMaybe<RPagination>;
};

export type RQuerySpaceArgs = {
  id: Scalars['Int']['input'];
};

export type RQuerySpaceMembersArgs = {
  filter: RSpaceMemberFilter;
  pagination?: InputMaybe<RPagination>;
};

export type RQuerySpacesArgs = {
  pagination?: InputMaybe<RPagination>;
};

export type RQuerySurveyAnswerInsightsCsvArgs = {
  id: Scalars['Int']['input'];
};

export type RQueryTeamArgs = {
  id: Scalars['Int']['input'];
};

export type RQueryTeamUsersArgs = {
  filter: RTeamUsersFilter;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RTeamUsersSort>;
};

export type RQueryTeamUsersListArgs = {
  filter: RTeamUsersFilter;
};

export type RQueryTeamsArgs = {
  filter?: InputMaybe<RTeamsFilter>;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RTeamsSort>;
};

export type RQueryUserArgs = {
  id: Scalars['Float']['input'];
};

export type RQueryUserInviteImportBatchStatusArgs = {
  batchId: Scalars['ID']['input'];
};

export type RQueryUserLearningContentLastParticipationArgs = {
  learningContentId: Scalars['URN']['input'];
  userId: Scalars['Int']['input'];
};

export type RQueryUserLearningContentLastParticipationsArgs = {
  learningContentIdIN: Array<Scalars['URN']['input']>;
  userId: Scalars['Int']['input'];
};

export type RQueryUserLearningSubmissionsArgs = {
  input: RUserLearningSubmissionsFilter;
};

export type RQueryUserTeamsArgs = {
  filter: RUserTeamsFilter;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RTeamUsersSort>;
};

export type RQueryUsersArgs = {
  filter?: InputMaybe<RUsersFilter>;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RUsersSort>;
};

export type RQueryResponse = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RRealm = {
  __typename?: 'Realm';
  name: Scalars['String']['output'];
  realm: Scalars['String']['output'];
};

export type RRealmConfig = {
  __typename?: 'RealmConfig';
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  heroVideoUrl?: Maybe<Scalars['String']['output']>;
  languageDefault?: Maybe<Scalars['String']['output']>;
};

export type RRealmFeatureToggle = {
  __typename?: 'RealmFeatureToggle';
  name: Scalars['String']['output'];
};

export type RRealmProviderLicenseSummary = {
  __typename?: 'RealmProviderLicenseSummary';
  catalogUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  pendingLicenses: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  realmId: Scalars['Int']['output'];
};

export enum RRealmRole {
  Admin = 'admin',
  User = 'user',
}

export type RRealmV2 = {
  __typename?: 'RealmV2';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type RRealmsFilter = {
  idNIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  slugIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RRealmsV2Page = {
  __typename?: 'RealmsV2Page';
  data: Array<RRealmV2>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RReplies = {
  __typename?: 'Replies';
  post?: Maybe<RPost>;
  replies?: Maybe<RPostsMeta>;
};

export type RResetLearningJourneySessionDiscussionTeamsInput = {
  /** ID of the learning journey whose session discussion teams are reset. */
  journeyId: Scalars['Int']['input'];
};

export type RReturnData = {
  __typename?: 'ReturnData';
  value?: Maybe<Scalars['String']['output']>;
};

export type RRole = {
  __typename?: 'Role';
  label?: Maybe<Scalars['String']['output']>;
};

export type RSadminPurchaseProduct = {
  id: Scalars['Int']['input'];
  productVariantId?: InputMaybe<Scalars['Int']['input']>;
  spaceId: Scalars['Int']['input'];
};

export type RSadminPurchaseResponse = RMutationResponse & {
  __typename?: 'SadminPurchaseResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  result?: Maybe<Array<Maybe<RSadminPurchaseResult>>>;
  success: Scalars['Boolean']['output'];
};

export type RSadminPurchaseResult = {
  __typename?: 'SadminPurchaseResult';
  email?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

export type RSearchLearningContentFilter = {
  idIN?: InputMaybe<Array<Scalars['String']['input']>>;
  originIdIN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerIn?: InputMaybe<Array<RLearningContentProvider>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RSearchSubordinateUsersInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type RSebUsersEmpAndActive = {
  __typename?: 'SebUsersEmpAndActive';
  count?: Maybe<Scalars['Int']['output']>;
};

export type RSection = {
  __typename?: 'Section';
  access?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isCorporeal?: Maybe<Scalars['Boolean']['output']>;
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  post?: Maybe<RPost>;
  postCount?: Maybe<Scalars['Int']['output']>;
  posts?: Maybe<RPostsMeta>;
  role?: Maybe<RPermissionsRole>;
  stickyPosts?: Maybe<Array<Maybe<RPost>>>;
  subsections?: Maybe<Array<Maybe<RSubSection>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RSectionPermissions = {
  __typename?: 'SectionPermissions';
  canAddReflections?: Maybe<Scalars['Boolean']['output']>;
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  canEditSection?: Maybe<Scalars['Boolean']['output']>;
  canLock?: Maybe<Scalars['Boolean']['output']>;
  canPost?: Maybe<Scalars['Boolean']['output']>;
  canPostSticky?: Maybe<Scalars['Boolean']['output']>;
  canPurge?: Maybe<Scalars['Boolean']['output']>;
  canReply?: Maybe<Scalars['Boolean']['output']>;
  canRestore?: Maybe<Scalars['Boolean']['output']>;
  canView?: Maybe<Scalars['Boolean']['output']>;
  canViewReflections?: Maybe<Scalars['Boolean']['output']>;
};

export type RSelfTrackedLearning = {
  __typename?: 'SelfTrackedLearning';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  effort: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  link?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: RSelfTrackedLearningType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RSelfTrackedLearningResult = {
  __typename?: 'SelfTrackedLearningResult';
  selfTrackedLearning?: Maybe<RSelfTrackedLearning>;
  success: Scalars['Boolean']['output'];
};

export enum RSelfTrackedLearningType {
  Article = 'ARTICLE',
  Book = 'BOOK',
  LiveEvent = 'LIVE_EVENT',
  Other = 'OTHER',
  Podcast = 'PODCAST',
  Program = 'PROGRAM',
  Video = 'VIDEO',
  Workshop = 'WORKSHOP',
}

export type RSelfTrackedLearningsFilter = {
  idIN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RSelfTrackedLearningsPage = {
  __typename?: 'SelfTrackedLearningsPage';
  data: Array<RSelfTrackedLearning>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RService = {
  __typename?: 'Service';
  id?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<RLearnifierCourse>;
  provider?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RServiceInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<RLearnifierCourseInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type RSetEnrollmentAttendanceInput = {
  attended: RAttendedType;
  enrollmentId: Scalars['Int']['input'];
};

export type RSetLanguageInput = {
  language: Scalars['String']['input'];
};

export type RSetUserStatusInput = {
  status?: InputMaybe<RAccountStatus>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type RSetUsernameInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export enum RSortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type RSpace = {
  __typename?: 'Space';
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions: RSpacePermissions;
  realm?: Maybe<Scalars['String']['output']>;
};

export type RSpaceInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RSpaceMember = {
  __typename?: 'SpaceMember';
  email: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  realm: Scalars['String']['output'];
  spaceId: Scalars['Int']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type RSpaceMemberFilter = {
  emailIN?: InputMaybe<Array<Scalars['String']['input']>>;
  idIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeGlobalAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  spaceIdIN: Array<Scalars['Int']['input']>;
};

export type RSpaceMemberPage = {
  __typename?: 'SpaceMemberPage';
  data: Array<RSpaceMember>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RSpacePermissions = {
  __typename?: 'SpacePermissions';
  hasWriteAccessToLearningContent?: Maybe<Scalars['Boolean']['output']>;
};

export type RSpaceV2 = {
  __typename?: 'SpaceV2';
  /** Retrieves content origins for a space */
  contentOrigins: RProviderContentOriginPage;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Retrieves permissions for the current user in a space */
  permissions: RSpacePermissions;
  realm?: Maybe<Scalars['String']['output']>;
  /** Retrieves role assignments for a space */
  roleAssignments: RSpaceV2RoleAssignmentPage;
  updatedAt: Scalars['DateTime']['output'];
};

export type RSpaceV2ContentOriginsArgs = {
  pagination?: InputMaybe<RPagination>;
};

export type RSpaceV2RoleAssignmentsArgs = {
  pagination?: InputMaybe<RPagination>;
};

export type RSpaceV2Page = {
  __typename?: 'SpaceV2Page';
  data: Array<RSpaceV2>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RSpaceV2Result = {
  __typename?: 'SpaceV2Result';
  space?: Maybe<RSpaceV2>;
  success: Scalars['Boolean']['output'];
};

export enum RSpaceV2Role {
  Admin = 'admin',
  DiscussionsModerator = 'discussions_moderator',
  Learner = 'learner',
}

export type RSpaceV2RoleAssignResultDto = {
  __typename?: 'SpaceV2RoleAssignResultDto';
  spaceRoleAssignment?: Maybe<RSpaceV2RoleAssignment>;
  success: Scalars['Boolean']['output'];
};

export type RSpaceV2RoleAssignment = {
  __typename?: 'SpaceV2RoleAssignment';
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  realm?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RSpaceV2Role>;
  roleDisplayName?: Maybe<Scalars['String']['output']>;
  spaceId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<RUserV2>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type RSpaceV2RoleAssignmentPage = {
  __typename?: 'SpaceV2RoleAssignmentPage';
  data: Array<RSpaceV2RoleAssignment>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RState = {
  __typename?: 'State';
  flags?: Maybe<RStateFlag>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RStateFlag = {
  __typename?: 'StateFlag';
  drawStock?: Maybe<Scalars['Boolean']['output']>;
  endState?: Maybe<Scalars['Boolean']['output']>;
  entitlement?: Maybe<Scalars['Boolean']['output']>;
};

export type RStateFlagInput = {
  drawStock?: InputMaybe<Scalars['Boolean']['input']>;
  endState?: InputMaybe<Scalars['Boolean']['input']>;
  entitlement?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RStateInput = {
  flags?: InputMaybe<RStateFlagInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RStats = {
  __typename?: 'Stats';
  likes?: Maybe<Scalars['Int']['output']>;
  replies?: Maybe<Scalars['Int']['output']>;
};

export type RStock = {
  __typename?: 'Stock';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reserved?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RStockInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reserved?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type RString_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type RSubSection = {
  __typename?: 'SubSection';
  access?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCorporeal?: Maybe<Scalars['Boolean']['output']>;
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  posts?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<RPermissionsRole>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RSubject = {
  __typename?: 'Subject';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  urlKey?: Maybe<Scalars['String']['output']>;
};

export type RSubjectCategory = {
  __typename?: 'SubjectCategory';
  category: Scalars['String']['output'];
  categoryId: Scalars['Int']['output'];
  learningId?: Maybe<Scalars['Int']['output']>;
  subject: Scalars['String']['output'];
  subjectId: Scalars['Int']['output'];
};

export type RSubjectCategoryV2 = {
  __typename?: 'SubjectCategoryV2';
  category: Scalars['String']['output'];
  categoryId: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
  subjectId: Scalars['Int']['output'];
};

export type RSubmitFeedbackInput = {
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  consentToCall: Scalars['Boolean']['input'];
  feedbackText: Scalars['String']['input'];
  referrerUrl: Scalars['String']['input'];
};

export type RSubmitFeedbackResult = {
  __typename?: 'SubmitFeedbackResult';
  success: Scalars['Boolean']['output'];
  ticket?: Maybe<RFeedbackTicket>;
};

export type RSubmitLearningActivityAssignmentInput = {
  /** The learner's PDF. Replaces any previous submission for the same activity. */
  file: Scalars['Upload']['input'];
  /** The assignment learning activity the submission belongs to. */
  learningActivityId: Scalars['Int']['input'];
};

export type RSubscription = {
  __typename?: 'Subscription';
  /** fetch data from the table: "clsapi.learning" */
  clsapi_learning: Array<RClsapi_Learning>;
  /** fetch aggregated fields from the table: "clsapi.learning" */
  clsapi_learning_aggregate: RClsapi_Learning_Aggregate;
  /** fetch data from the table: "clsapi.learning" using primary key columns */
  clsapi_learning_by_pk?: Maybe<RClsapi_Learning>;
  /** fetch data from the table: "clsapi.learning_journeys" */
  clsapi_learning_journeys: Array<RClsapi_Learning_Journeys>;
  /** fetch aggregated fields from the table: "clsapi.learning_journeys" */
  clsapi_learning_journeys_aggregate: RClsapi_Learning_Journeys_Aggregate;
  /** fetch data from the table: "clsapi.learning_journeys" using primary key columns */
  clsapi_learning_journeys_by_pk?: Maybe<RClsapi_Learning_Journeys>;
  /** fetch data from the table in a streaming manner: "clsapi.learning_journeys" */
  clsapi_learning_journeys_stream: Array<RClsapi_Learning_Journeys>;
  /** fetch data from the table in a streaming manner: "clsapi.learning" */
  clsapi_learning_stream: Array<RClsapi_Learning>;
  /** fetch data from the table: "reporting.mv_aggregation_effort_for_realm" */
  reportingAggregationEffortForRealm: Array<RReportingAggregationEffortForRealm>;
  /** fetch aggregated fields from the table: "reporting.mv_aggregation_effort_for_realm" */
  reportingAggregationEffortForRealmAggregate: RReportingAggregationEffortForRealm_Aggregate;
  /** fetch data from the table in a streaming manner: "reporting.mv_aggregation_effort_for_realm" */
  reportingAggregationEffortForRealm_stream: Array<RReportingAggregationEffortForRealm>;
  /** fetch data from the table: "reporting.mv_learning_activities_insights" */
  reportingLearningActivitiesInsights: Array<RReportingLearningActivitiesInsights>;
  /** fetch aggregated fields from the table: "reporting.mv_learning_activities_insights" */
  reportingLearningActivitiesInsightsAggregate: RReportingLearningActivitiesInsights_Aggregate;
  reportingLearningActivitiesInsightsV2: Array<RLearning_Activities_Insights>;
  reportingLearningActivitiesInsightsV2TotalCount: Array<RTotal_Count>;
  /** fetch data from the table in a streaming manner: "reporting.mv_learning_activities_insights" */
  reportingLearningActivitiesInsights_stream: Array<RReportingLearningActivitiesInsights>;
  /** fetch data from the table: "reporting.mv_learning_journey_content_insights" */
  reportingLearningJourneyContentInsights: Array<RReportingLearningJourneyContentInsights>;
  /** fetch aggregated fields from the table: "reporting.mv_learning_journey_content_insights" */
  reportingLearningJourneyContentInsightsAggregate: RReportingLearningJourneyContentInsights_Aggregate;
  /** fetch data from the table in a streaming manner: "reporting.mv_learning_journey_content_insights" */
  reportingLearningJourneyContentInsights_stream: Array<RReportingLearningJourneyContentInsights>;
  reportingLearningJourneysItems: Array<RLearning_Journeys_Items>;
  reportingLearningJourneysItemsInsights: Array<RLearning_Journeys_Items_Insights>;
  reportingLearningJourneysItemsTotalCount: Array<RTotal_Count>;
  reportingLearningSummary: Array<RLearning_Summary>;
  reportingLearnings: Array<RLearnings>;
  reportingLearningsInsights: Array<RLearningsInsights>;
  reportingLearningsTotalCount: Array<RTotal_Count>;
  reportingMyLearningJourneyDetails: Array<RLearning_Journey_Details>;
  reportingMyLearningJourneysInsightsV2: Array<RLearning_Journeys_Insights_V2>;
  reportingMyLearningJourneysLearners: Array<RLearning_Journey_Learners>;
  reportingMyLearningJourneysLearnersTotalCount: Array<RTotal_Count>;
  reportingMyLearningJourneysTotalCount: Array<RTotal_Count>;
  reportingMyLearningJourneysV2: Array<RLearning_Journeys_V2>;
  reportingMyLearningsLearners: Array<RLearners>;
  reportingMyLearningsLearnersTotalCount: Array<RTotal_Count>;
  reportingMyLearningsPracticalAssessment: Array<RPractical_Assessment>;
  reportingMyLearningsQuiz: Array<RQuiz>;
  reportingMyLiveLearningsLearners: Array<RLive_Learnings_Learners>;
  reportingMyLiveLearningsLearnersTotalCount: Array<RTotal_Count>;
  /** fetch data from the table: "reporting.mv_participants_insights" */
  reportingParticipantsInsights: Array<RReportingParticipantsInsights>;
  /** fetch aggregated fields from the table: "reporting.mv_participants_insights" */
  reportingParticipantsInsightsAggregate: RReportingParticipantsInsights_Aggregate;
  /** fetch data from the table in a streaming manner: "reporting.mv_participants_insights" */
  reportingParticipantsInsights_stream: Array<RReportingParticipantsInsights>;
  /** fetch data from the table: "reporting.mv_practical_assessment_insights" */
  reportingPracticalAssessmentInsights: Array<RReportingPracticalAssessmentInsights>;
  /** fetch aggregated fields from the table: "reporting.mv_practical_assessment_insights" */
  reportingPracticalAssessmentInsightsAggregate: RReportingPracticalAssessmentInsights_Aggregate;
  /** fetch data from the table in a streaming manner: "reporting.mv_practical_assessment_insights" */
  reportingPracticalAssessmentInsights_stream: Array<RReportingPracticalAssessmentInsights>;
  /** fetch data from the table: "reporting.mv_quiz_questions_insights" */
  reportingQuizQuestionsInsights: Array<RReportingQuizQuestionsInsights>;
  /** fetch aggregated fields from the table: "reporting.mv_quiz_questions_insights" */
  reportingQuizQuestionsInsightsAggregate: RReportingQuizQuestionsInsights_Aggregate;
  /** fetch data from the table in a streaming manner: "reporting.mv_quiz_questions_insights" */
  reportingQuizQuestionsInsights_stream: Array<RReportingQuizQuestionsInsights>;
  /** fetch data from the table: "reporting.mv_quiz_summary_insights" */
  reportingQuizSummaryInsights: Array<RReportingQuizSummaryInsights>;
  /** fetch aggregated fields from the table: "reporting.mv_quiz_summary_insights" */
  reportingQuizSummaryInsightsAggregate: RReportingQuizSummaryInsights_Aggregate;
  /** fetch data from the table in a streaming manner: "reporting.mv_quiz_summary_insights" */
  reportingQuizSummaryInsights_stream: Array<RReportingQuizSummaryInsights>;
  reportingSectionsItems: Array<RSections_Items>;
  reportingSectionsItemsInsights: Array<RSections_Items_Insights>;
  reportingSectionsItemsTotalCount: Array<RTotal_Count>;
};

export type RSubscriptionClsapi_LearningArgs = {
  distinct_on?: InputMaybe<Array<RClsapi_Learning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RClsapi_Learning_Order_By>>;
  where?: InputMaybe<RClsapi_Learning_Bool_Exp>;
};

export type RSubscriptionClsapi_Learning_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RClsapi_Learning_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RClsapi_Learning_Order_By>>;
  where?: InputMaybe<RClsapi_Learning_Bool_Exp>;
};

export type RSubscriptionClsapi_Learning_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type RSubscriptionClsapi_Learning_JourneysArgs = {
  distinct_on?: InputMaybe<Array<RClsapi_Learning_Journeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RClsapi_Learning_Journeys_Order_By>>;
  where?: InputMaybe<RClsapi_Learning_Journeys_Bool_Exp>;
};

export type RSubscriptionClsapi_Learning_Journeys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RClsapi_Learning_Journeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RClsapi_Learning_Journeys_Order_By>>;
  where?: InputMaybe<RClsapi_Learning_Journeys_Bool_Exp>;
};

export type RSubscriptionClsapi_Learning_Journeys_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type RSubscriptionClsapi_Learning_Journeys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RClsapi_Learning_Journeys_Stream_Cursor_Input>>;
  where?: InputMaybe<RClsapi_Learning_Journeys_Bool_Exp>;
};

export type RSubscriptionClsapi_Learning_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RClsapi_Learning_Stream_Cursor_Input>>;
  where?: InputMaybe<RClsapi_Learning_Bool_Exp>;
};

export type RSubscriptionReportingAggregationEffortForRealmArgs = {
  distinct_on?: InputMaybe<Array<RReportingAggregationEffortForRealm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingAggregationEffortForRealm_Order_By>>;
  where?: InputMaybe<RReportingAggregationEffortForRealm_Bool_Exp>;
};

export type RSubscriptionReportingAggregationEffortForRealmAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingAggregationEffortForRealm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingAggregationEffortForRealm_Order_By>>;
  where?: InputMaybe<RReportingAggregationEffortForRealm_Bool_Exp>;
};

export type RSubscriptionReportingAggregationEffortForRealm_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RReportingAggregationEffortForRealm_Stream_Cursor_Input>>;
  where?: InputMaybe<RReportingAggregationEffortForRealm_Bool_Exp>;
};

export type RSubscriptionReportingLearningActivitiesInsightsArgs = {
  distinct_on?: InputMaybe<Array<RReportingLearningActivitiesInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingLearningActivitiesInsights_Order_By>>;
  where?: InputMaybe<RReportingLearningActivitiesInsights_Bool_Exp>;
};

export type RSubscriptionReportingLearningActivitiesInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingLearningActivitiesInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingLearningActivitiesInsights_Order_By>>;
  where?: InputMaybe<RReportingLearningActivitiesInsights_Bool_Exp>;
};

export type RSubscriptionReportingLearningActivitiesInsightsV2Args = {
  args: RReportingLearningActivitiesInsightsV2_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Activities_Insights_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Activities_Insights_Order_By>>;
  where?: InputMaybe<RLearning_Activities_Insights_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingLearningActivitiesInsightsV2TotalCountArgs = {
  args: RReportingLearningActivitiesInsightsV2TotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingLearningActivitiesInsights_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RReportingLearningActivitiesInsights_Stream_Cursor_Input>>;
  where?: InputMaybe<RReportingLearningActivitiesInsights_Bool_Exp>;
};

export type RSubscriptionReportingLearningJourneyContentInsightsArgs = {
  distinct_on?: InputMaybe<Array<RReportingLearningJourneyContentInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingLearningJourneyContentInsights_Order_By>>;
  where?: InputMaybe<RReportingLearningJourneyContentInsights_Bool_Exp>;
};

export type RSubscriptionReportingLearningJourneyContentInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingLearningJourneyContentInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingLearningJourneyContentInsights_Order_By>>;
  where?: InputMaybe<RReportingLearningJourneyContentInsights_Bool_Exp>;
};

export type RSubscriptionReportingLearningJourneyContentInsights_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RReportingLearningJourneyContentInsights_Stream_Cursor_Input>>;
  where?: InputMaybe<RReportingLearningJourneyContentInsights_Bool_Exp>;
};

export type RSubscriptionReportingLearningJourneysItemsArgs = {
  args: RReportingLearningJourneysItems_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Journeys_Items_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journeys_Items_Order_By>>;
  where?: InputMaybe<RLearning_Journeys_Items_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingLearningJourneysItemsInsightsArgs = {
  args: RReportingLearningJourneysItemsInsights_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Journeys_Items_Insights_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journeys_Items_Insights_Order_By>>;
  where?: InputMaybe<RLearning_Journeys_Items_Insights_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingLearningJourneysItemsTotalCountArgs = {
  args: RReportingLearningJourneysItemsTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingLearningSummaryArgs = {
  args: RReportingLearningSummary_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Summary_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Summary_Order_By>>;
  where?: InputMaybe<RLearning_Summary_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingLearningsArgs = {
  args: RReportingLearnings_Arguments;
  distinct_on?: InputMaybe<Array<RLearnings_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearnings_Order_By>>;
  where?: InputMaybe<RLearnings_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingLearningsInsightsArgs = {
  args: RReportingLearningsInsights_Arguments;
  distinct_on?: InputMaybe<Array<RLearningsInsights_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearningsInsights_Order_By>>;
  where?: InputMaybe<RLearningsInsights_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingLearningsTotalCountArgs = {
  args: RReportingLearningsTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingMyLearningJourneyDetailsArgs = {
  args: RReportingMyLearningJourneyDetails_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Journey_Details_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journey_Details_Order_By>>;
  where?: InputMaybe<RLearning_Journey_Details_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingMyLearningJourneysInsightsV2Args = {
  args: RReportingMyLearningJourneysInsightsV2_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Journeys_Insights_V2_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journeys_Insights_V2_Order_By>>;
  where?: InputMaybe<RLearning_Journeys_Insights_V2_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingMyLearningJourneysLearnersArgs = {
  args: RReportingMyLearningJourneysLearners_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Journey_Learners_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journey_Learners_Order_By>>;
  where?: InputMaybe<RLearning_Journey_Learners_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingMyLearningJourneysLearnersTotalCountArgs = {
  args: RReportingMyLearningJourneysLearnersTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingMyLearningJourneysTotalCountArgs = {
  args: RReportingMyLearningJourneysTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingMyLearningJourneysV2Args = {
  args: RReportingMyLearningJourneysV2_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Journeys_V2_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journeys_V2_Order_By>>;
  where?: InputMaybe<RLearning_Journeys_V2_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingMyLearningsLearnersArgs = {
  args: RReportingMyLearningsLearners_Arguments;
  distinct_on?: InputMaybe<Array<RLearners_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearners_Order_By>>;
  where?: InputMaybe<RLearners_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingMyLearningsLearnersTotalCountArgs = {
  args: RReportingMyLearningsLearnersTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingMyLearningsPracticalAssessmentArgs = {
  args: RReportingMyLearningsPracticalAssessment_Arguments;
  distinct_on?: InputMaybe<Array<RPractical_Assessment_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RPractical_Assessment_Order_By>>;
  where?: InputMaybe<RPractical_Assessment_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingMyLearningsQuizArgs = {
  args: RReportingMyLearningsQuiz_Arguments;
  distinct_on?: InputMaybe<Array<RQuiz_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RQuiz_Order_By>>;
  where?: InputMaybe<RQuiz_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingMyLiveLearningsLearnersArgs = {
  args: RReportingMyLiveLearningsLearners_Arguments;
  distinct_on?: InputMaybe<Array<RLive_Learnings_Learners_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLive_Learnings_Learners_Order_By>>;
  where?: InputMaybe<RLive_Learnings_Learners_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingMyLiveLearningsLearnersTotalCountArgs = {
  args: RReportingMyLiveLearningsLearnersTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingParticipantsInsightsArgs = {
  distinct_on?: InputMaybe<Array<RReportingParticipantsInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingParticipantsInsights_Order_By>>;
  where?: InputMaybe<RReportingParticipantsInsights_Bool_Exp>;
};

export type RSubscriptionReportingParticipantsInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingParticipantsInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingParticipantsInsights_Order_By>>;
  where?: InputMaybe<RReportingParticipantsInsights_Bool_Exp>;
};

export type RSubscriptionReportingParticipantsInsights_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RReportingParticipantsInsights_Stream_Cursor_Input>>;
  where?: InputMaybe<RReportingParticipantsInsights_Bool_Exp>;
};

export type RSubscriptionReportingPracticalAssessmentInsightsArgs = {
  distinct_on?: InputMaybe<Array<RReportingPracticalAssessmentInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingPracticalAssessmentInsights_Order_By>>;
  where?: InputMaybe<RReportingPracticalAssessmentInsights_Bool_Exp>;
};

export type RSubscriptionReportingPracticalAssessmentInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingPracticalAssessmentInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingPracticalAssessmentInsights_Order_By>>;
  where?: InputMaybe<RReportingPracticalAssessmentInsights_Bool_Exp>;
};

export type RSubscriptionReportingPracticalAssessmentInsights_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RReportingPracticalAssessmentInsights_Stream_Cursor_Input>>;
  where?: InputMaybe<RReportingPracticalAssessmentInsights_Bool_Exp>;
};

export type RSubscriptionReportingQuizQuestionsInsightsArgs = {
  distinct_on?: InputMaybe<Array<RReportingQuizQuestionsInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingQuizQuestionsInsights_Order_By>>;
  where?: InputMaybe<RReportingQuizQuestionsInsights_Bool_Exp>;
};

export type RSubscriptionReportingQuizQuestionsInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingQuizQuestionsInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingQuizQuestionsInsights_Order_By>>;
  where?: InputMaybe<RReportingQuizQuestionsInsights_Bool_Exp>;
};

export type RSubscriptionReportingQuizQuestionsInsights_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RReportingQuizQuestionsInsights_Stream_Cursor_Input>>;
  where?: InputMaybe<RReportingQuizQuestionsInsights_Bool_Exp>;
};

export type RSubscriptionReportingQuizSummaryInsightsArgs = {
  distinct_on?: InputMaybe<Array<RReportingQuizSummaryInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingQuizSummaryInsights_Order_By>>;
  where?: InputMaybe<RReportingQuizSummaryInsights_Bool_Exp>;
};

export type RSubscriptionReportingQuizSummaryInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RReportingQuizSummaryInsights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RReportingQuizSummaryInsights_Order_By>>;
  where?: InputMaybe<RReportingQuizSummaryInsights_Bool_Exp>;
};

export type RSubscriptionReportingQuizSummaryInsights_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RReportingQuizSummaryInsights_Stream_Cursor_Input>>;
  where?: InputMaybe<RReportingQuizSummaryInsights_Bool_Exp>;
};

export type RSubscriptionReportingSectionsItemsArgs = {
  args: RReportingSectionsItems_Arguments;
  distinct_on?: InputMaybe<Array<RSections_Items_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RSections_Items_Order_By>>;
  where?: InputMaybe<RSections_Items_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingSectionsItemsInsightsArgs = {
  args: RReportingSectionsItemsInsights_Arguments;
  distinct_on?: InputMaybe<Array<RSections_Items_Insights_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RSections_Items_Insights_Order_By>>;
  where?: InputMaybe<RSections_Items_Insights_Bool_Exp_Bool_Exp>;
};

export type RSubscriptionReportingSectionsItemsTotalCountArgs = {
  args: RReportingSectionsItemsTotalCount_Arguments;
  distinct_on?: InputMaybe<Array<RTotal_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RTotal_Count_Order_By>>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
};

export type RTeam = {
  __typename?: 'Team';
  /** Team creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Team deletion date */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Team external ID (set only for managed teams) */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Team ID */
  id: Scalars['Int']['output'];
  /** Determines whether team can be edited */
  isReadOnly: Scalars['Boolean']['output'];
  /** Team name */
  name: Scalars['String']['output'];
  /** Parent team ID */
  parentTeamId?: Maybe<Scalars['Int']['output']>;
  /** Retrieves parent teams */
  parentTeams: RTeamsPage;
  /** Realm */
  realm: Scalars['String']['output'];
  /** Retrieves sub teams */
  subTeams: RTeamsPage;
  /** Retrieves team users */
  teamUsers: RTeamUsersPage;
  /** Team last update date */
  updatedAt: Scalars['DateTime']['output'];
};

export type RTeamParentTeamsArgs = {
  filter?: InputMaybe<RTeamRelsInput>;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RTeamsSort>;
};

export type RTeamSubTeamsArgs = {
  filter?: InputMaybe<RTeamRelsInput>;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RTeamsSort>;
};

export type RTeamTeamUsersArgs = {
  filter?: InputMaybe<RTeamsTeamUsersFilter>;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RTeamUsersSort>;
};

export type RTeamCreateInput = {
  /** Team name */
  name: Scalars['String']['input'];
  /** Parent team ID */
  parentTeamId?: InputMaybe<Scalars['Int']['input']>;
  /** Realm */
  realm: Scalars['String']['input'];
};

export type RTeamRelsInput = {
  /** Whether to include all subteams */
  indirect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to return only read-only teams */
  isReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RTeamRole {
  Manager = 'manager',
  Member = 'member',
}

export type RTeamUpdateInput = {
  /** Team ID */
  id: Scalars['Int']['input'];
  /** Team name */
  name: Scalars['String']['input'];
  /** Parent team ID */
  parentTeamId?: InputMaybe<Scalars['Int']['input']>;
  /** Realm */
  realm: Scalars['String']['input'];
};

export type RTeamUser = {
  __typename?: 'TeamUser';
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Role */
  role: RTeamRole;
  /** Retrieves team */
  team: RTeam;
  /** Team ID */
  teamId: Scalars['Int']['output'];
  /** Last update date */
  updatedAt: Scalars['DateTime']['output'];
  /** Retrieves user */
  user: RUserV2;
  /** User ID */
  userId: Scalars['Int']['output'];
};

export type RTeamUserChangeRoleInput = {
  /** Role */
  role: RTeamRole;
  /** Team ID */
  teamId: Scalars['Int']['input'];
  /** User ID */
  userId: Scalars['Int']['input'];
};

export type RTeamUserRemoveInput = {
  /** Team ID */
  teamId: Scalars['Int']['input'];
  /** User ID */
  userId: Scalars['Int']['input'];
};

export type RTeamUsersAddInput = {
  /** Team ID */
  teamId: Scalars['Int']['input'];
  /** User ID */
  userId: Scalars['Int']['input'];
};

export type RTeamUsersFilter = {
  /** Search phrase */
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  /** Team IDs */
  teamIdIN: Array<Scalars['Int']['input']>;
  /** Whether to include all subteams */
  withSubteams?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RTeamUsersPage = {
  __typename?: 'TeamUsersPage';
  /** Team users */
  data: Array<RTeamUser>;
  /** Limit */
  limit: Scalars['Int']['output'];
  /** Page */
  page: Scalars['Int']['output'];
  /** Total */
  total: Scalars['Int']['output'];
};

export type RTeamUsersSort = {
  /** Sort field */
  field?: InputMaybe<RTeamUsersSortField>;
  /** Sort order */
  order?: InputMaybe<RSortOrder>;
};

export enum RTeamUsersSortField {
  Email = 'EMAIL',
  Id = 'ID',
  Status = 'STATUS',
  Teamname = 'TEAMNAME',
  Username = 'USERNAME',
}

export type RTeamsFilter = {
  /** Whether to return only read-only teams */
  isReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent team filter */
  parentTeamEQ?: InputMaybe<RTeamsParentEqFilter>;
  /** Realm */
  realm?: InputMaybe<Scalars['String']['input']>;
  /** Search phrase */
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  /** Team filter */
  teamNEQ?: InputMaybe<RTeamsTeamNeqFilter>;
};

export type RTeamsPage = {
  __typename?: 'TeamsPage';
  /** Teams */
  data: Array<RTeam>;
  /** Limit */
  limit: Scalars['Int']['output'];
  /** Page */
  page: Scalars['Int']['output'];
  /** Total */
  total: Scalars['Int']['output'];
};

export type RTeamsParentEqFilter = {
  /** Parent team ID */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to include all subteams */
  indirect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RTeamsSort = {
  /** Sort field */
  field?: InputMaybe<RTeamsSortField>;
  /** Sort order */
  order?: InputMaybe<RSortOrder>;
};

export enum RTeamsSortField {
  Id = 'ID',
  Name = 'NAME',
}

export type RTeamsTeamNeqFilter = {
  /** Whether to exclude all subteams */
  excludeAllSubteams?: InputMaybe<Scalars['Boolean']['input']>;
  /** Team ID */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type RTeamsTeamUsersFilter = {
  /** Role */
  role?: InputMaybe<RTeamRole>;
  /** Search phrase */
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include all subteams */
  withSubteams?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RTour = {
  __typename?: 'Tour';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RTourUserCompletions = {
  __typename?: 'TourUserCompletions';
  createdAt: Scalars['DateTime']['output'];
  tourId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['Int']['output'];
};

export type RUpdateCollection = {
  contentOwner?: InputMaybe<Scalars['Int']['input']>;
  creator?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  languageId?: InputMaybe<Scalars['Int']['input']>;
  spaceId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<RLearningStatus>;
  subjectId?: InputMaybe<Scalars['Int']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<RLearningVisibility>;
};

export type RUpdateCollectionItems = {
  id: Scalars['ID']['input'];
  items: Array<InputMaybe<RCollectionItemInput>>;
};

export type RUpdateLearningJourneyCohortTeamsInput = {
  journeyId: Scalars['Int']['input'];
  teamIds: Array<Scalars['Int']['input']>;
};

export type RUpdateLearningJourneyInput = {
  bannerURL?: InputMaybe<Scalars['String']['input']>;
  businessGoalV2?: InputMaybe<Scalars['JSON']['input']>;
  certificateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  completionCriteria?: InputMaybe<RLearningJourneyCompletionStatus>;
  completionInvestTimeSec?: InputMaybe<Scalars['Int']['input']>;
  descriptionV2?: InputMaybe<Scalars['JSON']['input']>;
  discussionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isLinear?: InputMaybe<Scalars['Boolean']['input']>;
  spaceFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<RLearningJourneyStatus>;
  subjectId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RUpdateLearningJourneyOptionsInput = {
  /** Suppresses learner-facing journey and live-event enrollment notifications while preserving enrollment state. */
  disableNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RUpdateLocationRecordingUrlInput = {
  locationId: Scalars['Int']['input'];
  recordingURL: Scalars['String']['input'];
};

export type RUpdateResponse = {
  __typename?: 'UpdateResponse';
  orderId?: Maybe<Scalars['Int']['output']>;
};

export type RUpdateSectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  path: Array<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RUpdateSelfTrackedLearningInput = {
  description: Scalars['String']['input'];
  effort: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  link: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: RSelfTrackedLearningType;
};

export type RUpdateSpaceV2Input = {
  id: Scalars['Int']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  realm: Scalars['String']['input'];
};

export type RUpdateSpaceV2RoleAssignInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  role: RSpaceV2Role;
  roleDisplayName?: InputMaybe<Scalars['String']['input']>;
};

export type RUpsertAssignmentInput = {
  description: Scalars['String']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  learningLoopRecommendedEffort?: InputMaybe<Scalars['Int']['input']>;
  learnings?: InputMaybe<Array<RUpsertAssignmentLearningsInput>>;
  name: Scalars['String']['input'];
  rules?: InputMaybe<RAssignmentsV3RuleInput>;
  spaceId: Scalars['Int']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: RAssignmentV3Status;
  surveyId?: InputMaybe<Scalars['String']['input']>;
  teaser: Scalars['String']['input'];
  totalThresholdEffort?: InputMaybe<Scalars['Int']['input']>;
  type: RAssignmentV3Type;
  users?: InputMaybe<Array<RUpsertAssignmentUsersInput>>;
};

export type RUpsertAssignmentLearningsInput = {
  learningId?: InputMaybe<Scalars['Int']['input']>;
  learningPathId?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
  type?: InputMaybe<RAssignmentStandardV3LearningType>;
};

export type RUpsertAssignmentUsersInput = {
  userId: Scalars['Int']['input'];
};

export type RUpsertCertificatePropertiesInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  logos?: InputMaybe<Array<RCertificateLogoInput>>;
  signatures?: InputMaybe<Array<RCertificateSignatureInput>>;
  templateType: RCertificateTemplateType;
  title?: InputMaybe<Scalars['String']['input']>;
  /** URN of the entity these certificate properties belong to (e.g. a learning journey URN) */
  urn: Scalars['URN']['input'];
};

export type RUpsertFeatureToggleInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  public: Scalars['Boolean']['input'];
};

export type RUpsertLearningInput = {
  activities?: InputMaybe<Array<RLearningActivityInputDto>>;
  learning: RLearningV2Input;
  locations?: InputMaybe<Array<RLocationV2Input>>;
  modules?: InputMaybe<Array<RModuleV2Input>>;
  sectionItems?: InputMaybe<Array<RUpsertLearningSectionItemInput>>;
  subjects?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RUpsertLearningJourneyCohortsInput = {
  journeyId: Scalars['Int']['input'];
  learnerIds: Array<Scalars['Int']['input']>;
};

export type RUpsertLearningJourneyItemBaseInput = {
  availabilityScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityScheduledAtTimezone?: InputMaybe<Scalars['Int']['input']>;
  availabilityType?: InputMaybe<RLearningItemAvailabilityType>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  itemURN: Scalars['URN']['input'];
  realms?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RUpsertLearningJourneyItemsInput = {
  /** List of learning journey items with configuration to upsert */
  items: Array<RUpsertLearningJourneyItemBaseInput>;
  journeyId: Scalars['Int']['input'];
};

export type RUpsertLearningJourneySessionDiscussionTeamMembersInput = {
  teamId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type RUpsertLearningSectionItemInput = {
  availabilityScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityScheduledAtTimezone?: InputMaybe<Scalars['Int']['input']>;
  availabilityType?: InputMaybe<RLearningItemAvailabilityType>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  itemURN: Scalars['URN']['input'];
  realms?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RUser = {
  __typename?: 'User';
  acceptedExtraTerms?: Maybe<Scalars['Boolean']['output']>;
  acceptedGdpr?: Maybe<Scalars['Boolean']['output']>;
  acceptedTos?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<RUserGroup>>>;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  hasViewAccessToAdminPanel?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDebugging?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastActive?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  passwordExpiryDate?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RAccountStatus>;
  timestamp?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type RUserActivitySummary = {
  __typename?: 'UserActivitySummary';
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_activity?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_activity?: Maybe<Scalars['String']['output']>;
  participations_completed?: Maybe<Scalars['Int']['output']>;
  participations_registered?: Maybe<Scalars['Int']['output']>;
  participations_started?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_effort_hours?: Maybe<Scalars['Float']['output']>;
};

export type RUserChangeInput = {
  acceptedExtraTerms?: InputMaybe<Scalars['Boolean']['input']>;
  acceptedGdpr?: InputMaybe<Scalars['Boolean']['input']>;
  acceptedTos?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['Upload']['input']>;
  statusV2?: InputMaybe<RUserStatusV2>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type RUserChangeRealmRoleInput = {
  realm?: InputMaybe<Scalars['String']['input']>;
  role: RRealmRole;
  userId: Scalars['Int']['input'];
};

export type RUserEffort = {
  __typename?: 'UserEffort';
  total: Scalars['Float']['output'];
};

export type RUserEffortOverTime = {
  __typename?: 'UserEffortOverTime';
  average_effort_per_user_in_seconds?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  completed_not_expired?: Maybe<Scalars['Int']['output']>;
  distinct_completed?: Maybe<Scalars['Int']['output']>;
  distinct_completed_not_expired?: Maybe<Scalars['Int']['output']>;
  distinct_users?: Maybe<Scalars['Int']['output']>;
  expired?: Maybe<Scalars['Int']['output']>;
  in_progress?: Maybe<Scalars['Int']['output']>;
  total_effort_in_seconds?: Maybe<Scalars['Int']['output']>;
};

export type RUserFeatureToggle = {
  __typename?: 'UserFeatureToggle';
  name: Scalars['String']['output'];
};

export type RUserGroup = {
  __typename?: 'UserGroup';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Lifecycle status of an asynchronous user invite import batch. */
export enum RUserInviteImportBatchStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
}

export type RUserInviteImportBatchStatusResult = {
  __typename?: 'UserInviteImportBatchStatusResult';
  /** Identifier of the import batch. */
  batchId: Scalars['ID']['output'];
  /** Rows that errored so far. */
  errorCount: Scalars['Int']['output'];
  /** Users created (and invited, when the welcome-email toggle was on) so far. */
  invited: Scalars['Int']['output'];
  /** Rows processed so far. */
  processed: Scalars['Int']['output'];
  /** Rows skipped because the account already existed. */
  skipped: Scalars['Int']['output'];
  /** Current lifecycle status of the batch. */
  status: RUserInviteImportBatchStatus;
  /** Total rows to process in this batch. */
  totalRows: Scalars['Int']['output'];
};

export type RUserInviteImportConfirmInput = {
  file: Scalars['Upload']['input'];
  /** When true, each created user receives the welcome (invite) email. Applies to the whole batch; there is no per-row override. Existing users never receive an email. */
  sendWelcomeEmail: Scalars['Boolean']['input'];
};

export type RUserInviteImportFileError = {
  __typename?: 'UserInviteImportFileError';
  /** Which file-level validation failed (invalid CSV, template mismatch, or too large). */
  code: RUserInviteImportFileErrorCode;
};

/** File-level validation error for a user invite import CSV upload (invalid CSV, wrong template columns, or over the row cap). */
export enum RUserInviteImportFileErrorCode {
  InvalidCsv = 'INVALID_CSV',
  TemplateMismatch = 'TEMPLATE_MISMATCH',
  TooLarge = 'TOO_LARGE',
}

export type RUserInviteImportPreview = {
  __typename?: 'UserInviteImportPreview';
  /** Per-row preview, optionally filtered by outcome. Omitting the filter (or an empty outcomeIN) returns every row. */
  rows: Array<RUserInviteImportRowPreview>;
  /** Aggregate counts per outcome. */
  stats: RUserInviteImportPreviewStats;
};

export type RUserInviteImportPreviewRowsArgs = {
  filter?: InputMaybe<RUserInviteImportRowFilter>;
};

export type RUserInviteImportPreviewInput = {
  file: Scalars['Upload']['input'];
};

export type RUserInviteImportPreviewResult = {
  __typename?: 'UserInviteImportPreviewResult';
  /** The preview buckets when success is true; null on a file-level error. */
  data?: Maybe<RUserInviteImportPreview>;
  /** The file-level error cause when success is false; null on success. */
  errorCause?: Maybe<RUserInviteImportFileError>;
  /** True when the CSV parsed and a preview is available; false when a file-level validation failed. */
  success: Scalars['Boolean']['output'];
};

export type RUserInviteImportPreviewStats = {
  __typename?: 'UserInviteImportPreviewStats';
  /** Rows whose email already has an account — active or invite pending — skipped (ALREADY_INVITED). */
  alreadyInvited: Scalars['Int']['output'];
  /** Rows rejected as a duplicate email within the file (DUPLICATE_IN_FILE). */
  duplicateInFile: Scalars['Int']['output'];
  /** Rows rejected because the email is malformed (INVALID_EMAIL). */
  invalidEmail: Scalars['Int']['output'];
  /** Rows rejected because a required column value is empty (MISSING_REQUIRED_FIELD). */
  missingRequiredField: Scalars['Int']['output'];
  /** Rows targeting a realm the requester cannot invite into (REALM_ACCESS_DENIED). */
  realmAccessDenied: Scalars['Int']['output'];
  /** Total number of data rows parsed from the CSV. */
  total: Scalars['Int']['output'];
  /** Rows whose realm does not match any configured realm (UNKNOWN_REALM). */
  unknownRealm: Scalars['Int']['output'];
  /** Rows that will be invited to the platform (WILL_INVITE). */
  willInvite: Scalars['Int']['output'];
};

export type RUserInviteImportResult = {
  __typename?: 'UserInviteImportResult';
  /** Whether the invite import job was accepted and enqueued. */
  accepted: Scalars['Boolean']['output'];
  /** Identifier of the created import batch, used to poll status. */
  batchId: Scalars['ID']['output'];
  /** Number of users that will be invited by the background job. */
  willInviteCount: Scalars['Int']['output'];
};

export type RUserInviteImportRowFilter = {
  /** Restrict to these outcomes. Omitted, null, or empty returns all rows. */
  outcomeIN?: InputMaybe<Array<RUserInviteImportRowOutcome>>;
};

/** Outcome of a single CSV row in a user invite import preview. */
export enum RUserInviteImportRowOutcome {
  AlreadyInvited = 'ALREADY_INVITED',
  DuplicateInFile = 'DUPLICATE_IN_FILE',
  InvalidEmail = 'INVALID_EMAIL',
  MissingRequiredField = 'MISSING_REQUIRED_FIELD',
  RealmAccessDenied = 'REALM_ACCESS_DENIED',
  /** The realm cell does not exactly match a configured realm slug. The match is case-sensitive. */
  UnknownRealm = 'UNKNOWN_REALM',
  WillInvite = 'WILL_INVITE',
}

export type RUserInviteImportRowPreview = {
  __typename?: 'UserInviteImportRowPreview';
  /** How this row was classified. */
  outcome: RUserInviteImportRowOutcome;
  /** The source CSV row. */
  row: RUserInviteImportSourceRow;
};

export type RUserInviteImportSourceRow = {
  __typename?: 'UserInviteImportSourceRow';
  /** Normalized (lowercased, trimmed) email address from the CSV row. */
  email: Scalars['String']['output'];
  /** First name from the CSV row; null when the cell is empty. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Last name from the CSV row; null when the cell is empty. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Target realm from the CSV row; null when the cell is empty. */
  realm?: Maybe<Scalars['String']['output']>;
  /** Physical 1-based line number of this row in the source CSV (the header is line 1, counting blank lines), for traceback when the same email appears more than once. */
  sourceLine: Scalars['Int']['output'];
};

export type RUserLearningActivityAssignmentSubmission = {
  __typename?: 'UserLearningActivityAssignmentSubmission';
  /** When the learner first submitted for this activity. */
  createdAt: Scalars['DateTime']['output'];
  /** The learner's original file name, for display. The stored object uses a fixed key. */
  fileName: Scalars['String']['output'];
  /** Short-lived download URL for the submitted file. */
  fileURL: RPresignedUrl;
  /** The assignment learning activity this submission belongs to. */
  learningActivityId: Scalars['Int']['output'];
  /** Kind of artefact submitted. DOCUMENT today. */
  type: RAssignmentSubmissionType;
  /** When the learner last replaced the submission. */
  updatedAt: Scalars['DateTime']['output'];
  /** The learner who submitted. */
  userId: Scalars['Int']['output'];
};

export type RUserLearningActivityAssignmentSubmissionFilterInput = {
  /** The assignment learning activities to read submissions for. Between 1 and 100 ids. */
  learningActivityIdsIN: Array<Scalars['Int']['input']>;
};

export type RUserLearningActivityQuizQuestionAnswers = {
  questionId: Scalars['String']['input'];
  selectedOptionIds: Array<Scalars['String']['input']>;
};

export type RUserLearningActivityQuizSubmission = {
  __typename?: 'UserLearningActivityQuizSubmission';
  answers: Scalars['JSON']['output'];
  correctlyAnsweredCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  hasPassed: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  learningActivityId: Scalars['Int']['output'];
  quiz: Scalars['JSON']['output'];
  score: Scalars['Float']['output'];
  totalAnsweredCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type RUserLearningActivityQuizSubmissionFilterInput = {
  includeOlderVersions?: InputMaybe<Scalars['Boolean']['input']>;
  learningActivityQuizIdsIN: Array<Scalars['Int']['input']>;
};

export type RUserLearningActivityQuizSubmissionInput = {
  answers: Array<RUserLearningActivityQuizQuestionAnswers>;
  learningActivityId: Scalars['Int']['input'];
  version: Scalars['String']['input'];
};

export type RUserLearningSubmission = {
  __typename?: 'UserLearningSubmission';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  learningURNV1: Scalars['String']['output'];
  learningURNV2: Scalars['String']['output'];
  pageURNV1: Scalars['String']['output'];
  pageURNV2: Scalars['String']['output'];
  reviewAssignments: Array<RUserLearningSubmissionReviewAssignment>;
  reviews: Array<RUserLearningSubmissionReview>;
  type: RUserLearningSubmissionType;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type RUserLearningSubmissionResult = {
  __typename?: 'UserLearningSubmissionResult';
  submission?: Maybe<RUserLearningSubmission>;
  success: Scalars['Boolean']['output'];
};

export type RUserLearningSubmissionReview = {
  __typename?: 'UserLearningSubmissionReview';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  reviewerId: Scalars['Int']['output'];
  submissionId: Scalars['Int']['output'];
  type: RUserLearningSubmissionReviewType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RUserLearningSubmissionReviewAssignment = {
  __typename?: 'UserLearningSubmissionReviewAssignment';
  createdAt: Scalars['DateTime']['output'];
  expiryAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  reviewerId: Scalars['Int']['output'];
  submission: RUserLearningSubmission;
  submissionId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RUserLearningSubmissionReviewResult = {
  __typename?: 'UserLearningSubmissionReviewResult';
  review?: Maybe<RUserLearningSubmissionReview>;
  success: Scalars['Boolean']['output'];
};

export enum RUserLearningSubmissionReviewType {
  PracticalAssessmentReviewText = 'PRACTICAL_ASSESSMENT_REVIEW_TEXT',
}

export enum RUserLearningSubmissionType {
  PracticalAssessmentDocument = 'PRACTICAL_ASSESSMENT_DOCUMENT',
  PracticalAssessmentText = 'PRACTICAL_ASSESSMENT_TEXT',
  PracticalAssessmentVideo = 'PRACTICAL_ASSESSMENT_VIDEO',
}

export type RUserLearningSubmissionsFilter = {
  learningIdsIN: Array<Scalars['Int']['input']>;
  pageIdsIN: Array<Scalars['Int']['input']>;
  userIdsIN: Array<Scalars['Int']['input']>;
};

export type RUserList = {
  __typename?: 'UserList';
  /** Sorts and paginates the UserList based on analytics data. */
  analyticsSort: RUsersResult;
  /** Returns aggregated data on filtered participations for all users in the list. */
  participationAggregate: RParticipationAggregate;
  total: Scalars['Int']['output'];
  userIds: Array<Scalars['Int']['output']>;
};

export type RUserListAnalyticsSortArgs = {
  filter?: InputMaybe<RParticipationFilterInput>;
  pagination?: InputMaybe<RPaginationInput>;
  sort: RAnalyticsUserSortInput;
};

export type RUserListParticipationAggregateArgs = {
  filter?: InputMaybe<RParticipationFilterInput>;
};

export type RUserMeta = {
  __typename?: 'UserMeta';
  meta?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type RUserRealmRoleAssignment = {
  __typename?: 'UserRealmRoleAssignment';
  realm?: Maybe<Scalars['String']['output']>;
  role: RRealmRole;
};

export type RUserStats = {
  __typename?: 'UserStats';
  liked?: Maybe<Scalars['Int']['output']>;
};

export enum RUserStatus {
  Deactivated = 'deactivated',
  Incomplete = 'incomplete',
  Pending = 'pending',
  Registered = 'registered',
}

export enum RUserStatusV2 {
  Active = 'active',
  Deleted = 'deleted',
  Inactive = 'inactive',
}

export type RUserTeamsFilter = {
  role?: InputMaybe<RTeamRole>;
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
  withSubteams?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RUserV2 = {
  __typename?: 'UserV2';
  acceptedExtraTerms: Scalars['Boolean']['output'];
  acceptedGdpr: Scalars['Boolean']['output'];
  acceptedTos: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastActive: Scalars['DateTime']['output'];
  lastPasswordUpdate: Scalars['DateTime']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  /** Returns aggregated data on filtered participations for the user. */
  participationAggregate: RParticipationAggregate;
  /** Sorts and paginates filtered participations for the user. */
  participations: RParticipationResult;
  profileImage?: Maybe<Scalars['String']['output']>;
  realm: Scalars['String']['output'];
  realmRoleAssignments: Array<RUserRealmRoleAssignment>;
  status: RUserStatus;
  statusV2: RUserStatusV2;
  teams: RTeamUsersPage;
  timestamp: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type RUserV2ParticipationAggregateArgs = {
  filter?: InputMaybe<RParticipationFilterInput>;
};

export type RUserV2ParticipationsArgs = {
  filter?: InputMaybe<RParticipationFilterInput>;
  pagination?: InputMaybe<RPaginationInput>;
  sort?: InputMaybe<RParticipationSortInput>;
};

export type RUserV2TeamsArgs = {
  filter?: InputMaybe<RUsersUserTeams>;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RTeamUsersSort>;
};

export type RUsersFilter = {
  emailIN?: InputMaybe<Array<Scalars['String']['input']>>;
  idIN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  idNIN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  realm?: InputMaybe<Scalars['String']['input']>;
  realmRole?: InputMaybe<RRealmRole>;
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<RUserStatus>>>;
  statusV2IN?: InputMaybe<Array<InputMaybe<RUserStatusV2>>>;
  statusV2NIN?: InputMaybe<Array<InputMaybe<RUserStatusV2>>>;
  teamIdIN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type RUsersPage = {
  __typename?: 'UsersPage';
  data: Array<RUserV2>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum RUsersPool {
  Realm = 'REALM',
  Subordinates = 'SUBORDINATES',
}

export type RUsersResult = {
  __typename?: 'UsersResult';
  data: Array<RUserV2>;
  pageInfo: RPageInfo;
};

export type RUsersSort = {
  field?: InputMaybe<RUsersSortField>;
  order?: InputMaybe<RSortOrder>;
};

export enum RUsersSortField {
  Email = 'EMAIL',
  Id = 'ID',
  Status = 'STATUS',
  Username = 'USERNAME',
}

export type RUsersUserTeams = {
  role?: InputMaybe<RTeamRole>;
  teamIdIN?: InputMaybe<Array<Scalars['Int']['input']>>;
  withSubteams?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RVariant = {
  __typename?: 'Variant';
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  flags?: Maybe<RProductFlags>;
  id?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<RProductMeta>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export type RVariantInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  flags?: InputMaybe<RProductFlagsInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<RProductMetaInput>;
  name: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  validFrom?: InputMaybe<Scalars['String']['input']>;
  validTo?: InputMaybe<Scalars['String']['input']>;
};

export type RVariantResponse = {
  __typename?: 'VariantResponse';
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type RVariantRow = {
  __typename?: 'VariantRow';
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  flags?: Maybe<RProductFlags>;
  id?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<RProductMeta>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export enum RWaitlistType {
  Automatic = 'AUTOMATIC',
  Disabled = 'DISABLED',
}

export type RXapiSession = {
  __typename?: 'XAPISession';
  queryString?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
};

export type RYou = {
  __typename?: 'You';
  have?: Maybe<RUserStats>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type RBigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** Boolean expression to compare columns of type "catalog_item_type". All fields are combined with logical 'AND'. */
export type RCatalog_Item_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['catalog_item_type']['input']>;
  _gt?: InputMaybe<Scalars['catalog_item_type']['input']>;
  _gte?: InputMaybe<Scalars['catalog_item_type']['input']>;
  _in?: InputMaybe<Array<Scalars['catalog_item_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['catalog_item_type']['input']>;
  _lte?: InputMaybe<Scalars['catalog_item_type']['input']>;
  _neq?: InputMaybe<Scalars['catalog_item_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['catalog_item_type']['input']>>;
};

/** columns and relationships of "clsapi.learning" */
export type RClsapi_Learning = {
  __typename?: 'clsapi_learning';
  archived?: Maybe<Scalars['timestamptz']['output']>;
  content_owner?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  creator?: Maybe<Scalars['Int']['output']>;
  effort?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Scalars['json']['output']>;
  preamble: Scalars['String']['output'];
  space_id?: Maybe<Scalars['Int']['output']>;
  status: Scalars['learning_status']['output'];
  teaser: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['learning_type']['output'];
  updated?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['Int']['output']>;
  urn_v1?: Maybe<Scalars['String']['output']>;
  urn_v2?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['learning_visibility']['output']>;
};

/** columns and relationships of "clsapi.learning" */
export type RClsapi_LearningMetaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "clsapi.learning" */
export type RClsapi_Learning_Aggregate = {
  __typename?: 'clsapi_learning_aggregate';
  aggregate?: Maybe<RClsapi_Learning_Aggregate_Fields>;
  nodes: Array<RClsapi_Learning>;
};

/** aggregate fields of "clsapi.learning" */
export type RClsapi_Learning_Aggregate_Fields = {
  __typename?: 'clsapi_learning_aggregate_fields';
  avg?: Maybe<RClsapi_Learning_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RClsapi_Learning_Max_Fields>;
  min?: Maybe<RClsapi_Learning_Min_Fields>;
  stddev?: Maybe<RClsapi_Learning_Stddev_Fields>;
  stddev_pop?: Maybe<RClsapi_Learning_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RClsapi_Learning_Stddev_Samp_Fields>;
  sum?: Maybe<RClsapi_Learning_Sum_Fields>;
  var_pop?: Maybe<RClsapi_Learning_Var_Pop_Fields>;
  var_samp?: Maybe<RClsapi_Learning_Var_Samp_Fields>;
  variance?: Maybe<RClsapi_Learning_Variance_Fields>;
};

/** aggregate fields of "clsapi.learning" */
export type RClsapi_Learning_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RClsapi_Learning_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RClsapi_Learning_Avg_Fields = {
  __typename?: 'clsapi_learning_avg_fields';
  content_owner?: Maybe<Scalars['Float']['output']>;
  creator?: Maybe<Scalars['Float']['output']>;
  effort?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "clsapi.learning". All fields are combined with a logical 'AND'. */
export type RClsapi_Learning_Bool_Exp = {
  _and?: InputMaybe<Array<RClsapi_Learning_Bool_Exp>>;
  _not?: InputMaybe<RClsapi_Learning_Bool_Exp>;
  _or?: InputMaybe<Array<RClsapi_Learning_Bool_Exp>>;
  archived?: InputMaybe<RTimestamptz_Comparison_Exp>;
  content_owner?: InputMaybe<RInt_Comparison_Exp>;
  created?: InputMaybe<RTimestamptz_Comparison_Exp>;
  creator?: InputMaybe<RInt_Comparison_Exp>;
  effort?: InputMaybe<RInt_Comparison_Exp>;
  id?: InputMaybe<RInt_Comparison_Exp>;
  image?: InputMaybe<RString_Comparison_Exp>;
  language_id?: InputMaybe<RInt_Comparison_Exp>;
  meta?: InputMaybe<RJson_Comparison_Exp>;
  preamble?: InputMaybe<RString_Comparison_Exp>;
  space_id?: InputMaybe<RInt_Comparison_Exp>;
  status?: InputMaybe<RLearning_Status_Comparison_Exp>;
  teaser?: InputMaybe<RString_Comparison_Exp>;
  title?: InputMaybe<RString_Comparison_Exp>;
  type?: InputMaybe<RLearning_Type_Comparison_Exp>;
  updated?: InputMaybe<RTimestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<RInt_Comparison_Exp>;
  urn_v1?: InputMaybe<RString_Comparison_Exp>;
  urn_v2?: InputMaybe<RString_Comparison_Exp>;
  visibility?: InputMaybe<RLearning_Visibility_Comparison_Exp>;
};

/** unique or primary key constraints on table "clsapi.learning" */
export enum RClsapi_Learning_Constraint {
  /** unique or primary key constraint on columns "id" */
  LearningPkey = 'learning_pkey',
  /** unique or primary key constraint on columns "urn_v1" */
  LearningUrnV1Idx = 'learning_urn_v1_idx',
  /** unique or primary key constraint on columns "urn_v2" */
  LearningUrnV2Idx = 'learning_urn_v2_idx',
}

/** input type for incrementing numeric columns in table "clsapi.learning" */
export type RClsapi_Learning_Inc_Input = {
  content_owner?: InputMaybe<Scalars['Int']['input']>;
  creator?: InputMaybe<Scalars['Int']['input']>;
  effort?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  updated_by?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "clsapi.learning" */
export type RClsapi_Learning_Insert_Input = {
  archived?: InputMaybe<Scalars['timestamptz']['input']>;
  content_owner?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  creator?: InputMaybe<Scalars['Int']['input']>;
  effort?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['json']['input']>;
  preamble?: InputMaybe<Scalars['String']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['learning_status']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['learning_type']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['learning_visibility']['input']>;
};

/** columns and relationships of "clsapi.learning_journeys" */
export type RClsapi_Learning_Journeys = {
  __typename?: 'clsapi_learning_journeys';
  banner_url: Scalars['String']['output'];
  business_goal_v2: Scalars['jsonb']['output'];
  certificate_enabled: Scalars['Boolean']['output'];
  completion_criteria: Scalars['learning_journey_completion_criteria']['output'];
  completion_invest_time?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description_v2: Scalars['jsonb']['output'];
  discussion_enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_linear: Scalars['Boolean']['output'];
  source_template_id?: Maybe<Scalars['Int']['output']>;
  space_featured: Scalars['Boolean']['output'];
  space_id: Scalars['Int']['output'];
  status: Scalars['learning_journey_status']['output'];
  subject_id?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  urn?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "clsapi.learning_journeys" */
export type RClsapi_Learning_JourneysBusiness_Goal_V2Args = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "clsapi.learning_journeys" */
export type RClsapi_Learning_JourneysDescription_V2Args = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "clsapi.learning_journeys" */
export type RClsapi_Learning_Journeys_Aggregate = {
  __typename?: 'clsapi_learning_journeys_aggregate';
  aggregate?: Maybe<RClsapi_Learning_Journeys_Aggregate_Fields>;
  nodes: Array<RClsapi_Learning_Journeys>;
};

/** aggregate fields of "clsapi.learning_journeys" */
export type RClsapi_Learning_Journeys_Aggregate_Fields = {
  __typename?: 'clsapi_learning_journeys_aggregate_fields';
  avg?: Maybe<RClsapi_Learning_Journeys_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RClsapi_Learning_Journeys_Max_Fields>;
  min?: Maybe<RClsapi_Learning_Journeys_Min_Fields>;
  stddev?: Maybe<RClsapi_Learning_Journeys_Stddev_Fields>;
  stddev_pop?: Maybe<RClsapi_Learning_Journeys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RClsapi_Learning_Journeys_Stddev_Samp_Fields>;
  sum?: Maybe<RClsapi_Learning_Journeys_Sum_Fields>;
  var_pop?: Maybe<RClsapi_Learning_Journeys_Var_Pop_Fields>;
  var_samp?: Maybe<RClsapi_Learning_Journeys_Var_Samp_Fields>;
  variance?: Maybe<RClsapi_Learning_Journeys_Variance_Fields>;
};

/** aggregate fields of "clsapi.learning_journeys" */
export type RClsapi_Learning_Journeys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RClsapi_Learning_Journeys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RClsapi_Learning_Journeys_Append_Input = {
  business_goal_v2?: InputMaybe<Scalars['jsonb']['input']>;
  description_v2?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type RClsapi_Learning_Journeys_Avg_Fields = {
  __typename?: 'clsapi_learning_journeys_avg_fields';
  completion_invest_time?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  source_template_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  subject_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "clsapi.learning_journeys". All fields are combined with a logical 'AND'. */
export type RClsapi_Learning_Journeys_Bool_Exp = {
  _and?: InputMaybe<Array<RClsapi_Learning_Journeys_Bool_Exp>>;
  _not?: InputMaybe<RClsapi_Learning_Journeys_Bool_Exp>;
  _or?: InputMaybe<Array<RClsapi_Learning_Journeys_Bool_Exp>>;
  banner_url?: InputMaybe<RString_Comparison_Exp>;
  business_goal_v2?: InputMaybe<RJsonb_Comparison_Exp>;
  certificate_enabled?: InputMaybe<RBoolean_Comparison_Exp>;
  completion_criteria?: InputMaybe<RLearning_Journey_Completion_Criteria_Comparison_Exp>;
  completion_invest_time?: InputMaybe<RInt_Comparison_Exp>;
  created_at?: InputMaybe<RTimestamptz_Comparison_Exp>;
  description_v2?: InputMaybe<RJsonb_Comparison_Exp>;
  discussion_enabled?: InputMaybe<RBoolean_Comparison_Exp>;
  id?: InputMaybe<RInt_Comparison_Exp>;
  is_linear?: InputMaybe<RBoolean_Comparison_Exp>;
  source_template_id?: InputMaybe<RInt_Comparison_Exp>;
  space_featured?: InputMaybe<RBoolean_Comparison_Exp>;
  space_id?: InputMaybe<RInt_Comparison_Exp>;
  status?: InputMaybe<RLearning_Journey_Status_Comparison_Exp>;
  subject_id?: InputMaybe<RInt_Comparison_Exp>;
  title?: InputMaybe<RString_Comparison_Exp>;
  updated_at?: InputMaybe<RTimestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<RInt_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
};

/** unique or primary key constraints on table "clsapi.learning_journeys" */
export enum RClsapi_Learning_Journeys_Constraint {
  /** unique or primary key constraint on columns "urn" */
  IdxLearningJourneysUrn = 'idx_learning_journeys_urn',
  /** unique or primary key constraint on columns "id" */
  LearningJourneysPk = 'learning_journeys_pk',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RClsapi_Learning_Journeys_Delete_At_Path_Input = {
  business_goal_v2?: InputMaybe<Array<Scalars['String']['input']>>;
  description_v2?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RClsapi_Learning_Journeys_Delete_Elem_Input = {
  business_goal_v2?: InputMaybe<Scalars['Int']['input']>;
  description_v2?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RClsapi_Learning_Journeys_Delete_Key_Input = {
  business_goal_v2?: InputMaybe<Scalars['String']['input']>;
  description_v2?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "clsapi.learning_journeys" */
export type RClsapi_Learning_Journeys_Inc_Input = {
  completion_invest_time?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  source_template_id?: InputMaybe<Scalars['Int']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  subject_id?: InputMaybe<Scalars['Int']['input']>;
  updated_by?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "clsapi.learning_journeys" */
export type RClsapi_Learning_Journeys_Insert_Input = {
  banner_url?: InputMaybe<Scalars['String']['input']>;
  business_goal_v2?: InputMaybe<Scalars['jsonb']['input']>;
  certificate_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  completion_criteria?: InputMaybe<Scalars['learning_journey_completion_criteria']['input']>;
  completion_invest_time?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description_v2?: InputMaybe<Scalars['jsonb']['input']>;
  discussion_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_linear?: InputMaybe<Scalars['Boolean']['input']>;
  source_template_id?: InputMaybe<Scalars['Int']['input']>;
  space_featured?: InputMaybe<Scalars['Boolean']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['learning_journey_status']['input']>;
  subject_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type RClsapi_Learning_Journeys_Max_Fields = {
  __typename?: 'clsapi_learning_journeys_max_fields';
  banner_url?: Maybe<Scalars['String']['output']>;
  completion_criteria?: Maybe<Scalars['learning_journey_completion_criteria']['output']>;
  completion_invest_time?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  source_template_id?: Maybe<Scalars['Int']['output']>;
  space_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['learning_journey_status']['output']>;
  subject_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['Int']['output']>;
  urn?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type RClsapi_Learning_Journeys_Min_Fields = {
  __typename?: 'clsapi_learning_journeys_min_fields';
  banner_url?: Maybe<Scalars['String']['output']>;
  completion_criteria?: Maybe<Scalars['learning_journey_completion_criteria']['output']>;
  completion_invest_time?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  source_template_id?: Maybe<Scalars['Int']['output']>;
  space_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['learning_journey_status']['output']>;
  subject_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['Int']['output']>;
  urn?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "clsapi.learning_journeys" */
export type RClsapi_Learning_Journeys_Mutation_Response = {
  __typename?: 'clsapi_learning_journeys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RClsapi_Learning_Journeys>;
};

/** on_conflict condition type for table "clsapi.learning_journeys" */
export type RClsapi_Learning_Journeys_On_Conflict = {
  constraint: RClsapi_Learning_Journeys_Constraint;
  update_columns?: Array<RClsapi_Learning_Journeys_Update_Column>;
  where?: InputMaybe<RClsapi_Learning_Journeys_Bool_Exp>;
};

/** Ordering options when selecting data from "clsapi.learning_journeys". */
export type RClsapi_Learning_Journeys_Order_By = {
  banner_url?: InputMaybe<ROrder_By>;
  business_goal_v2?: InputMaybe<ROrder_By>;
  certificate_enabled?: InputMaybe<ROrder_By>;
  completion_criteria?: InputMaybe<ROrder_By>;
  completion_invest_time?: InputMaybe<ROrder_By>;
  created_at?: InputMaybe<ROrder_By>;
  description_v2?: InputMaybe<ROrder_By>;
  discussion_enabled?: InputMaybe<ROrder_By>;
  id?: InputMaybe<ROrder_By>;
  is_linear?: InputMaybe<ROrder_By>;
  source_template_id?: InputMaybe<ROrder_By>;
  space_featured?: InputMaybe<ROrder_By>;
  space_id?: InputMaybe<ROrder_By>;
  status?: InputMaybe<ROrder_By>;
  subject_id?: InputMaybe<ROrder_By>;
  title?: InputMaybe<ROrder_By>;
  updated_at?: InputMaybe<ROrder_By>;
  updated_by?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
};

/** primary key columns input for table: clsapi.learning_journeys */
export type RClsapi_Learning_Journeys_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RClsapi_Learning_Journeys_Prepend_Input = {
  business_goal_v2?: InputMaybe<Scalars['jsonb']['input']>;
  description_v2?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "clsapi.learning_journeys" */
export enum RClsapi_Learning_Journeys_Select_Column {
  /** column name */
  BannerUrl = 'banner_url',
  /** column name */
  BusinessGoalV2 = 'business_goal_v2',
  /** column name */
  CertificateEnabled = 'certificate_enabled',
  /** column name */
  CompletionCriteria = 'completion_criteria',
  /** column name */
  CompletionInvestTime = 'completion_invest_time',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionV2 = 'description_v2',
  /** column name */
  DiscussionEnabled = 'discussion_enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsLinear = 'is_linear',
  /** column name */
  SourceTemplateId = 'source_template_id',
  /** column name */
  SpaceFeatured = 'space_featured',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  Status = 'status',
  /** column name */
  SubjectId = 'subject_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  Urn = 'urn',
}

/** input type for updating data in table "clsapi.learning_journeys" */
export type RClsapi_Learning_Journeys_Set_Input = {
  banner_url?: InputMaybe<Scalars['String']['input']>;
  business_goal_v2?: InputMaybe<Scalars['jsonb']['input']>;
  certificate_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  completion_criteria?: InputMaybe<Scalars['learning_journey_completion_criteria']['input']>;
  completion_invest_time?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description_v2?: InputMaybe<Scalars['jsonb']['input']>;
  discussion_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_linear?: InputMaybe<Scalars['Boolean']['input']>;
  source_template_id?: InputMaybe<Scalars['Int']['input']>;
  space_featured?: InputMaybe<Scalars['Boolean']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['learning_journey_status']['input']>;
  subject_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type RClsapi_Learning_Journeys_Stddev_Fields = {
  __typename?: 'clsapi_learning_journeys_stddev_fields';
  completion_invest_time?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  source_template_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  subject_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RClsapi_Learning_Journeys_Stddev_Pop_Fields = {
  __typename?: 'clsapi_learning_journeys_stddev_pop_fields';
  completion_invest_time?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  source_template_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  subject_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RClsapi_Learning_Journeys_Stddev_Samp_Fields = {
  __typename?: 'clsapi_learning_journeys_stddev_samp_fields';
  completion_invest_time?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  source_template_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  subject_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "clsapi_learning_journeys" */
export type RClsapi_Learning_Journeys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RClsapi_Learning_Journeys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<RCursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RClsapi_Learning_Journeys_Stream_Cursor_Value_Input = {
  banner_url?: InputMaybe<Scalars['String']['input']>;
  business_goal_v2?: InputMaybe<Scalars['jsonb']['input']>;
  certificate_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  completion_criteria?: InputMaybe<Scalars['learning_journey_completion_criteria']['input']>;
  completion_invest_time?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description_v2?: InputMaybe<Scalars['jsonb']['input']>;
  discussion_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_linear?: InputMaybe<Scalars['Boolean']['input']>;
  source_template_id?: InputMaybe<Scalars['Int']['input']>;
  space_featured?: InputMaybe<Scalars['Boolean']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['learning_journey_status']['input']>;
  subject_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['Int']['input']>;
  urn?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type RClsapi_Learning_Journeys_Sum_Fields = {
  __typename?: 'clsapi_learning_journeys_sum_fields';
  completion_invest_time?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  source_template_id?: Maybe<Scalars['Int']['output']>;
  space_id?: Maybe<Scalars['Int']['output']>;
  subject_id?: Maybe<Scalars['Int']['output']>;
  updated_by?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "clsapi.learning_journeys" */
export enum RClsapi_Learning_Journeys_Update_Column {
  /** column name */
  BannerUrl = 'banner_url',
  /** column name */
  BusinessGoalV2 = 'business_goal_v2',
  /** column name */
  CertificateEnabled = 'certificate_enabled',
  /** column name */
  CompletionCriteria = 'completion_criteria',
  /** column name */
  CompletionInvestTime = 'completion_invest_time',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionV2 = 'description_v2',
  /** column name */
  DiscussionEnabled = 'discussion_enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsLinear = 'is_linear',
  /** column name */
  SourceTemplateId = 'source_template_id',
  /** column name */
  SpaceFeatured = 'space_featured',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  Status = 'status',
  /** column name */
  SubjectId = 'subject_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
}

export type RClsapi_Learning_Journeys_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RClsapi_Learning_Journeys_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RClsapi_Learning_Journeys_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RClsapi_Learning_Journeys_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RClsapi_Learning_Journeys_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RClsapi_Learning_Journeys_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RClsapi_Learning_Journeys_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RClsapi_Learning_Journeys_Set_Input>;
  /** filter the rows which have to be updated */
  where: RClsapi_Learning_Journeys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RClsapi_Learning_Journeys_Var_Pop_Fields = {
  __typename?: 'clsapi_learning_journeys_var_pop_fields';
  completion_invest_time?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  source_template_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  subject_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RClsapi_Learning_Journeys_Var_Samp_Fields = {
  __typename?: 'clsapi_learning_journeys_var_samp_fields';
  completion_invest_time?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  source_template_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  subject_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RClsapi_Learning_Journeys_Variance_Fields = {
  __typename?: 'clsapi_learning_journeys_variance_fields';
  completion_invest_time?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  source_template_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  subject_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type RClsapi_Learning_Max_Fields = {
  __typename?: 'clsapi_learning_max_fields';
  archived?: Maybe<Scalars['timestamptz']['output']>;
  content_owner?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  creator?: Maybe<Scalars['Int']['output']>;
  effort?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  preamble?: Maybe<Scalars['String']['output']>;
  space_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['learning_status']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['learning_type']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['Int']['output']>;
  urn_v1?: Maybe<Scalars['String']['output']>;
  urn_v2?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['learning_visibility']['output']>;
};

/** aggregate min on columns */
export type RClsapi_Learning_Min_Fields = {
  __typename?: 'clsapi_learning_min_fields';
  archived?: Maybe<Scalars['timestamptz']['output']>;
  content_owner?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  creator?: Maybe<Scalars['Int']['output']>;
  effort?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  preamble?: Maybe<Scalars['String']['output']>;
  space_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['learning_status']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['learning_type']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['Int']['output']>;
  urn_v1?: Maybe<Scalars['String']['output']>;
  urn_v2?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['learning_visibility']['output']>;
};

/** response of any mutation on the table "clsapi.learning" */
export type RClsapi_Learning_Mutation_Response = {
  __typename?: 'clsapi_learning_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RClsapi_Learning>;
};

/** on_conflict condition type for table "clsapi.learning" */
export type RClsapi_Learning_On_Conflict = {
  constraint: RClsapi_Learning_Constraint;
  update_columns?: Array<RClsapi_Learning_Update_Column>;
  where?: InputMaybe<RClsapi_Learning_Bool_Exp>;
};

/** Ordering options when selecting data from "clsapi.learning". */
export type RClsapi_Learning_Order_By = {
  archived?: InputMaybe<ROrder_By>;
  content_owner?: InputMaybe<ROrder_By>;
  created?: InputMaybe<ROrder_By>;
  creator?: InputMaybe<ROrder_By>;
  effort?: InputMaybe<ROrder_By>;
  id?: InputMaybe<ROrder_By>;
  image?: InputMaybe<ROrder_By>;
  language_id?: InputMaybe<ROrder_By>;
  meta?: InputMaybe<ROrder_By>;
  preamble?: InputMaybe<ROrder_By>;
  space_id?: InputMaybe<ROrder_By>;
  status?: InputMaybe<ROrder_By>;
  teaser?: InputMaybe<ROrder_By>;
  title?: InputMaybe<ROrder_By>;
  type?: InputMaybe<ROrder_By>;
  updated?: InputMaybe<ROrder_By>;
  updated_by?: InputMaybe<ROrder_By>;
  urn_v1?: InputMaybe<ROrder_By>;
  urn_v2?: InputMaybe<ROrder_By>;
  visibility?: InputMaybe<ROrder_By>;
};

/** primary key columns input for table: clsapi.learning */
export type RClsapi_Learning_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "clsapi.learning" */
export enum RClsapi_Learning_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  ContentOwner = 'content_owner',
  /** column name */
  Created = 'created',
  /** column name */
  Creator = 'creator',
  /** column name */
  Effort = 'effort',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Preamble = 'preamble',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  Status = 'status',
  /** column name */
  Teaser = 'teaser',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UrnV1 = 'urn_v1',
  /** column name */
  UrnV2 = 'urn_v2',
  /** column name */
  Visibility = 'visibility',
}

/** input type for updating data in table "clsapi.learning" */
export type RClsapi_Learning_Set_Input = {
  archived?: InputMaybe<Scalars['timestamptz']['input']>;
  content_owner?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  creator?: InputMaybe<Scalars['Int']['input']>;
  effort?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['json']['input']>;
  preamble?: InputMaybe<Scalars['String']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['learning_status']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['learning_type']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['learning_visibility']['input']>;
};

/** aggregate stddev on columns */
export type RClsapi_Learning_Stddev_Fields = {
  __typename?: 'clsapi_learning_stddev_fields';
  content_owner?: Maybe<Scalars['Float']['output']>;
  creator?: Maybe<Scalars['Float']['output']>;
  effort?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RClsapi_Learning_Stddev_Pop_Fields = {
  __typename?: 'clsapi_learning_stddev_pop_fields';
  content_owner?: Maybe<Scalars['Float']['output']>;
  creator?: Maybe<Scalars['Float']['output']>;
  effort?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RClsapi_Learning_Stddev_Samp_Fields = {
  __typename?: 'clsapi_learning_stddev_samp_fields';
  content_owner?: Maybe<Scalars['Float']['output']>;
  creator?: Maybe<Scalars['Float']['output']>;
  effort?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "clsapi_learning" */
export type RClsapi_Learning_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RClsapi_Learning_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<RCursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RClsapi_Learning_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['timestamptz']['input']>;
  content_owner?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  creator?: InputMaybe<Scalars['Int']['input']>;
  effort?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['json']['input']>;
  preamble?: InputMaybe<Scalars['String']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['learning_status']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['learning_type']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['Int']['input']>;
  urn_v1?: InputMaybe<Scalars['String']['input']>;
  urn_v2?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['learning_visibility']['input']>;
};

/** aggregate sum on columns */
export type RClsapi_Learning_Sum_Fields = {
  __typename?: 'clsapi_learning_sum_fields';
  content_owner?: Maybe<Scalars['Int']['output']>;
  creator?: Maybe<Scalars['Int']['output']>;
  effort?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
  space_id?: Maybe<Scalars['Int']['output']>;
  updated_by?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "clsapi.learning" */
export enum RClsapi_Learning_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  ContentOwner = 'content_owner',
  /** column name */
  Created = 'created',
  /** column name */
  Creator = 'creator',
  /** column name */
  Effort = 'effort',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Preamble = 'preamble',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  Status = 'status',
  /** column name */
  Teaser = 'teaser',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  Visibility = 'visibility',
}

export type RClsapi_Learning_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RClsapi_Learning_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RClsapi_Learning_Set_Input>;
  /** filter the rows which have to be updated */
  where: RClsapi_Learning_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RClsapi_Learning_Var_Pop_Fields = {
  __typename?: 'clsapi_learning_var_pop_fields';
  content_owner?: Maybe<Scalars['Float']['output']>;
  creator?: Maybe<Scalars['Float']['output']>;
  effort?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RClsapi_Learning_Var_Samp_Fields = {
  __typename?: 'clsapi_learning_var_samp_fields';
  content_owner?: Maybe<Scalars['Float']['output']>;
  creator?: Maybe<Scalars['Float']['output']>;
  effort?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RClsapi_Learning_Variance_Fields = {
  __typename?: 'clsapi_learning_variance_fields';
  content_owner?: Maybe<Scalars['Float']['output']>;
  creator?: Maybe<Scalars['Float']['output']>;
  effort?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  language_id?: Maybe<Scalars['Float']['output']>;
  space_id?: Maybe<Scalars['Float']['output']>;
  updated_by?: Maybe<Scalars['Float']['output']>;
};

/** ordering argument of a cursor */
export enum RCursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC',
}

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type RFloat8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type RJson_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type RJsonb_Cast_Exp = {
  String?: InputMaybe<RString_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type RJsonb_Comparison_Exp = {
  _cast?: InputMaybe<RJsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export type RLearners = {
  __typename?: 'learners';
  completion_time?: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['String']['output'];
  is_completed: Scalars['Boolean']['output'];
  join_time?: Maybe<Scalars['timestamptz']['output']>;
  last_activity_time?: Maybe<Scalars['timestamptz']['output']>;
  profile_image?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['numeric']['output']>;
  space_ids: Scalars['jsonb']['output'];
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  team_names?: Maybe<Scalars['jsonb']['output']>;
  user_id: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type RLearnersSpace_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLearnersTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLearnersTeam_NamesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "learners". All fields are combined with a logical 'AND'. */
export type RLearners_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RLearners_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RLearners_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RLearners_Bool_Exp_Bool_Exp>>;
  completion_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  email?: InputMaybe<RString_Comparison_Exp>;
  is_completed?: InputMaybe<RBoolean_Comparison_Exp>;
  join_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  last_activity_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  profile_image?: InputMaybe<RString_Comparison_Exp>;
  progress?: InputMaybe<RNumeric_Comparison_Exp>;
  space_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  start_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  team_names?: InputMaybe<RJsonb_Comparison_Exp>;
  user_id?: InputMaybe<RInt_Comparison_Exp>;
  username?: InputMaybe<RString_Comparison_Exp>;
};

export enum RLearners_Enum_Name {
  /** column name */
  CompletionTime = 'completion_time',
  /** column name */
  Email = 'email',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  JoinTime = 'join_time',
  /** column name */
  LastActivityTime = 'last_activity_time',
  /** column name */
  ProfileImage = 'profile_image',
  /** column name */
  Progress = 'progress',
  /** column name */
  SpaceIds = 'space_ids',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  TeamNames = 'team_names',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username',
}

/** Ordering options when selecting data from "learners". */
export type RLearners_Order_By = {
  completion_time?: InputMaybe<ROrder_By>;
  email?: InputMaybe<ROrder_By>;
  is_completed?: InputMaybe<ROrder_By>;
  join_time?: InputMaybe<ROrder_By>;
  last_activity_time?: InputMaybe<ROrder_By>;
  profile_image?: InputMaybe<ROrder_By>;
  progress?: InputMaybe<ROrder_By>;
  space_ids?: InputMaybe<ROrder_By>;
  start_time?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  team_names?: InputMaybe<ROrder_By>;
  user_id?: InputMaybe<ROrder_By>;
  username?: InputMaybe<ROrder_By>;
};

export type RLearning_Activities_Insights = {
  __typename?: 'learning_activities_insights';
  activity_order: Scalars['bigint']['output'];
  activity_urn: Scalars['String']['output'];
  completed_count: Scalars['bigint']['output'];
  completion_rate: Scalars['numeric']['output'];
  learning_urn: Scalars['String']['output'];
  not_started_count: Scalars['bigint']['output'];
  space_ids?: Maybe<Scalars['jsonb']['output']>;
  started_count: Scalars['bigint']['output'];
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  title: Scalars['String']['output'];
  total: Scalars['bigint']['output'];
  type: Scalars['String']['output'];
};

export type RLearning_Activities_InsightsSpace_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLearning_Activities_InsightsTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "learning_activities_insights". All fields are combined with a logical 'AND'. */
export type RLearning_Activities_Insights_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RLearning_Activities_Insights_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RLearning_Activities_Insights_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RLearning_Activities_Insights_Bool_Exp_Bool_Exp>>;
  activity_order?: InputMaybe<RBigint_Comparison_Exp>;
  activity_urn?: InputMaybe<RString_Comparison_Exp>;
  completed_count?: InputMaybe<RBigint_Comparison_Exp>;
  completion_rate?: InputMaybe<RNumeric_Comparison_Exp>;
  learning_urn?: InputMaybe<RString_Comparison_Exp>;
  not_started_count?: InputMaybe<RBigint_Comparison_Exp>;
  space_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  started_count?: InputMaybe<RBigint_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  title?: InputMaybe<RString_Comparison_Exp>;
  total?: InputMaybe<RBigint_Comparison_Exp>;
  type?: InputMaybe<RString_Comparison_Exp>;
};

export enum RLearning_Activities_Insights_Enum_Name {
  /** column name */
  ActivityOrder = 'activity_order',
  /** column name */
  ActivityUrn = 'activity_urn',
  /** column name */
  CompletedCount = 'completed_count',
  /** column name */
  CompletionRate = 'completion_rate',
  /** column name */
  LearningUrn = 'learning_urn',
  /** column name */
  NotStartedCount = 'not_started_count',
  /** column name */
  SpaceIds = 'space_ids',
  /** column name */
  StartedCount = 'started_count',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  Title = 'title',
  /** column name */
  Total = 'total',
  /** column name */
  Type = 'type',
}

/** Ordering options when selecting data from "learning_activities_insights". */
export type RLearning_Activities_Insights_Order_By = {
  activity_order?: InputMaybe<ROrder_By>;
  activity_urn?: InputMaybe<ROrder_By>;
  completed_count?: InputMaybe<ROrder_By>;
  completion_rate?: InputMaybe<ROrder_By>;
  learning_urn?: InputMaybe<ROrder_By>;
  not_started_count?: InputMaybe<ROrder_By>;
  space_ids?: InputMaybe<ROrder_By>;
  started_count?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  title?: InputMaybe<ROrder_By>;
  total?: InputMaybe<ROrder_By>;
  type?: InputMaybe<ROrder_By>;
};

/** Boolean expression to compare columns of type "learning_journey_completion_criteria". All fields are combined with logical 'AND'. */
export type RLearning_Journey_Completion_Criteria_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['learning_journey_completion_criteria']['input']>;
  _gt?: InputMaybe<Scalars['learning_journey_completion_criteria']['input']>;
  _gte?: InputMaybe<Scalars['learning_journey_completion_criteria']['input']>;
  _in?: InputMaybe<Array<Scalars['learning_journey_completion_criteria']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['learning_journey_completion_criteria']['input']>;
  _lte?: InputMaybe<Scalars['learning_journey_completion_criteria']['input']>;
  _neq?: InputMaybe<Scalars['learning_journey_completion_criteria']['input']>;
  _nin?: InputMaybe<Array<Scalars['learning_journey_completion_criteria']['input']>>;
};

export type RLearning_Journey_Details = {
  __typename?: 'learning_journey_details';
  completion_status: Scalars['String']['output'];
  completion_time?: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['String']['output'];
  join_time?: Maybe<Scalars['timestamptz']['output']>;
  last_activity_time?: Maybe<Scalars['timestamptz']['output']>;
  space_id: Scalars['Int']['output'];
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  team_names?: Maybe<Scalars['jsonb']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  urn: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type RLearning_Journey_DetailsTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLearning_Journey_DetailsTeam_NamesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "learning_journey_details". All fields are combined with a logical 'AND'. */
export type RLearning_Journey_Details_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RLearning_Journey_Details_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RLearning_Journey_Details_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RLearning_Journey_Details_Bool_Exp_Bool_Exp>>;
  completion_status?: InputMaybe<RString_Comparison_Exp>;
  completion_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  email?: InputMaybe<RString_Comparison_Exp>;
  join_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  last_activity_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  space_id?: InputMaybe<RInt_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  team_names?: InputMaybe<RJsonb_Comparison_Exp>;
  title?: InputMaybe<RString_Comparison_Exp>;
  type?: InputMaybe<RString_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
  username?: InputMaybe<RString_Comparison_Exp>;
};

export enum RLearning_Journey_Details_Enum_Name {
  /** column name */
  CompletionStatus = 'completion_status',
  /** column name */
  CompletionTime = 'completion_time',
  /** column name */
  Email = 'email',
  /** column name */
  JoinTime = 'join_time',
  /** column name */
  LastActivityTime = 'last_activity_time',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  TeamNames = 'team_names',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Urn = 'urn',
  /** column name */
  Username = 'username',
}

/** Ordering options when selecting data from "learning_journey_details". */
export type RLearning_Journey_Details_Order_By = {
  completion_status?: InputMaybe<ROrder_By>;
  completion_time?: InputMaybe<ROrder_By>;
  email?: InputMaybe<ROrder_By>;
  join_time?: InputMaybe<ROrder_By>;
  last_activity_time?: InputMaybe<ROrder_By>;
  space_id?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  team_names?: InputMaybe<ROrder_By>;
  title?: InputMaybe<ROrder_By>;
  type?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
  username?: InputMaybe<ROrder_By>;
};

export type RLearning_Journey_Learners = {
  __typename?: 'learning_journey_learners';
  completion_time?: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['String']['output'];
  is_completed: Scalars['Boolean']['output'];
  join_time?: Maybe<Scalars['timestamptz']['output']>;
  last_activity_time?: Maybe<Scalars['timestamptz']['output']>;
  learning_items_completed: Scalars['Int']['output'];
  learning_items_started: Scalars['Int']['output'];
  profile_image?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['numeric']['output']>;
  space_ids: Scalars['jsonb']['output'];
  start_time?: Maybe<Scalars['timestamptz']['output']>;
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  team_names?: Maybe<Scalars['jsonb']['output']>;
  user_id: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type RLearning_Journey_LearnersSpace_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLearning_Journey_LearnersTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLearning_Journey_LearnersTeam_NamesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "learning_journey_learners". All fields are combined with a logical 'AND'. */
export type RLearning_Journey_Learners_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RLearning_Journey_Learners_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RLearning_Journey_Learners_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RLearning_Journey_Learners_Bool_Exp_Bool_Exp>>;
  completion_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  email?: InputMaybe<RString_Comparison_Exp>;
  is_completed?: InputMaybe<RBoolean_Comparison_Exp>;
  join_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  last_activity_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  learning_items_completed?: InputMaybe<RInt_Comparison_Exp>;
  learning_items_started?: InputMaybe<RInt_Comparison_Exp>;
  profile_image?: InputMaybe<RString_Comparison_Exp>;
  progress?: InputMaybe<RNumeric_Comparison_Exp>;
  space_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  start_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  team_names?: InputMaybe<RJsonb_Comparison_Exp>;
  user_id?: InputMaybe<RInt_Comparison_Exp>;
  username?: InputMaybe<RString_Comparison_Exp>;
};

export enum RLearning_Journey_Learners_Enum_Name {
  /** column name */
  CompletionTime = 'completion_time',
  /** column name */
  Email = 'email',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  JoinTime = 'join_time',
  /** column name */
  LastActivityTime = 'last_activity_time',
  /** column name */
  LearningItemsCompleted = 'learning_items_completed',
  /** column name */
  LearningItemsStarted = 'learning_items_started',
  /** column name */
  ProfileImage = 'profile_image',
  /** column name */
  Progress = 'progress',
  /** column name */
  SpaceIds = 'space_ids',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  TeamNames = 'team_names',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username',
}

/** Ordering options when selecting data from "learning_journey_learners". */
export type RLearning_Journey_Learners_Order_By = {
  completion_time?: InputMaybe<ROrder_By>;
  email?: InputMaybe<ROrder_By>;
  is_completed?: InputMaybe<ROrder_By>;
  join_time?: InputMaybe<ROrder_By>;
  last_activity_time?: InputMaybe<ROrder_By>;
  learning_items_completed?: InputMaybe<ROrder_By>;
  learning_items_started?: InputMaybe<ROrder_By>;
  profile_image?: InputMaybe<ROrder_By>;
  progress?: InputMaybe<ROrder_By>;
  space_ids?: InputMaybe<ROrder_By>;
  start_time?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  team_names?: InputMaybe<ROrder_By>;
  user_id?: InputMaybe<ROrder_By>;
  username?: InputMaybe<ROrder_By>;
};

/** Boolean expression to compare columns of type "learning_journey_status". All fields are combined with logical 'AND'. */
export type RLearning_Journey_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['learning_journey_status']['input']>;
  _gt?: InputMaybe<Scalars['learning_journey_status']['input']>;
  _gte?: InputMaybe<Scalars['learning_journey_status']['input']>;
  _in?: InputMaybe<Array<Scalars['learning_journey_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['learning_journey_status']['input']>;
  _lte?: InputMaybe<Scalars['learning_journey_status']['input']>;
  _neq?: InputMaybe<Scalars['learning_journey_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['learning_journey_status']['input']>>;
};

export type RLearning_Journeys_Insights_V2 = {
  __typename?: 'learning_journeys_insights_v2';
  average_progress: Scalars['numeric']['output'];
  completed_count: Scalars['bigint']['output'];
  completion_rate: Scalars['numeric']['output'];
  learners_count: Scalars['bigint']['output'];
  space_id: Scalars['Int']['output'];
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  urn: Scalars['String']['output'];
};

export type RLearning_Journeys_Insights_V2Team_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "learning_journeys_insights_v2". All fields are combined with a logical 'AND'. */
export type RLearning_Journeys_Insights_V2_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RLearning_Journeys_Insights_V2_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RLearning_Journeys_Insights_V2_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RLearning_Journeys_Insights_V2_Bool_Exp_Bool_Exp>>;
  average_progress?: InputMaybe<RNumeric_Comparison_Exp>;
  completed_count?: InputMaybe<RBigint_Comparison_Exp>;
  completion_rate?: InputMaybe<RNumeric_Comparison_Exp>;
  learners_count?: InputMaybe<RBigint_Comparison_Exp>;
  space_id?: InputMaybe<RInt_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
};

export enum RLearning_Journeys_Insights_V2_Enum_Name {
  /** column name */
  AverageProgress = 'average_progress',
  /** column name */
  CompletedCount = 'completed_count',
  /** column name */
  CompletionRate = 'completion_rate',
  /** column name */
  LearnersCount = 'learners_count',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  Urn = 'urn',
}

/** Ordering options when selecting data from "learning_journeys_insights_v2". */
export type RLearning_Journeys_Insights_V2_Order_By = {
  average_progress?: InputMaybe<ROrder_By>;
  completed_count?: InputMaybe<ROrder_By>;
  completion_rate?: InputMaybe<ROrder_By>;
  learners_count?: InputMaybe<ROrder_By>;
  space_id?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
};

export type RLearning_Journeys_Items = {
  __typename?: 'learning_journeys_items';
  item_order: Scalars['Int']['output'];
  partner: Scalars['String']['output'];
  planned_duration: Scalars['Int']['output'];
  space_id: Scalars['Int']['output'];
  team_ids: Scalars['jsonb']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

export type RLearning_Journeys_ItemsTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "learning_journeys_items". All fields are combined with a logical 'AND'. */
export type RLearning_Journeys_Items_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RLearning_Journeys_Items_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RLearning_Journeys_Items_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RLearning_Journeys_Items_Bool_Exp_Bool_Exp>>;
  item_order?: InputMaybe<RInt_Comparison_Exp>;
  partner?: InputMaybe<RString_Comparison_Exp>;
  planned_duration?: InputMaybe<RInt_Comparison_Exp>;
  space_id?: InputMaybe<RInt_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  title?: InputMaybe<RString_Comparison_Exp>;
  type?: InputMaybe<RString_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
};

export enum RLearning_Journeys_Items_Enum_Name {
  /** column name */
  ItemOrder = 'item_order',
  /** column name */
  Partner = 'partner',
  /** column name */
  PlannedDuration = 'planned_duration',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Urn = 'urn',
}

export type RLearning_Journeys_Items_Insights = {
  __typename?: 'learning_journeys_items_insights';
  completed_count: Scalars['bigint']['output'];
  completion_rate: Scalars['numeric']['output'];
  in_progress_count: Scalars['bigint']['output'];
  not_started_count: Scalars['bigint']['output'];
  space_id: Scalars['Int']['output'];
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  urn: Scalars['String']['output'];
};

export type RLearning_Journeys_Items_InsightsTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "learning_journeys_items_insights". All fields are combined with a logical 'AND'. */
export type RLearning_Journeys_Items_Insights_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RLearning_Journeys_Items_Insights_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RLearning_Journeys_Items_Insights_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RLearning_Journeys_Items_Insights_Bool_Exp_Bool_Exp>>;
  completed_count?: InputMaybe<RBigint_Comparison_Exp>;
  completion_rate?: InputMaybe<RNumeric_Comparison_Exp>;
  in_progress_count?: InputMaybe<RBigint_Comparison_Exp>;
  not_started_count?: InputMaybe<RBigint_Comparison_Exp>;
  space_id?: InputMaybe<RInt_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
};

export enum RLearning_Journeys_Items_Insights_Enum_Name {
  /** column name */
  CompletedCount = 'completed_count',
  /** column name */
  CompletionRate = 'completion_rate',
  /** column name */
  InProgressCount = 'in_progress_count',
  /** column name */
  NotStartedCount = 'not_started_count',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  Urn = 'urn',
}

/** Ordering options when selecting data from "learning_journeys_items_insights". */
export type RLearning_Journeys_Items_Insights_Order_By = {
  completed_count?: InputMaybe<ROrder_By>;
  completion_rate?: InputMaybe<ROrder_By>;
  in_progress_count?: InputMaybe<ROrder_By>;
  not_started_count?: InputMaybe<ROrder_By>;
  space_id?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
};

/** Ordering options when selecting data from "learning_journeys_items". */
export type RLearning_Journeys_Items_Order_By = {
  item_order?: InputMaybe<ROrder_By>;
  partner?: InputMaybe<ROrder_By>;
  planned_duration?: InputMaybe<ROrder_By>;
  space_id?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  title?: InputMaybe<ROrder_By>;
  type?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
};

export type RLearning_Journeys_V2 = {
  __typename?: 'learning_journeys_v2';
  learning_items_count: Scalars['bigint']['output'];
  planned_duration: Scalars['Int']['output'];
  space_id: Scalars['Int']['output'];
  space_name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  title: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

export type RLearning_Journeys_V2Team_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "learning_journeys_v2". All fields are combined with a logical 'AND'. */
export type RLearning_Journeys_V2_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RLearning_Journeys_V2_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RLearning_Journeys_V2_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RLearning_Journeys_V2_Bool_Exp_Bool_Exp>>;
  learning_items_count?: InputMaybe<RBigint_Comparison_Exp>;
  planned_duration?: InputMaybe<RInt_Comparison_Exp>;
  space_id?: InputMaybe<RInt_Comparison_Exp>;
  space_name?: InputMaybe<RString_Comparison_Exp>;
  status?: InputMaybe<RString_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  title?: InputMaybe<RString_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
};

export enum RLearning_Journeys_V2_Enum_Name {
  /** column name */
  LearningItemsCount = 'learning_items_count',
  /** column name */
  PlannedDuration = 'planned_duration',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  SpaceName = 'space_name',
  /** column name */
  Status = 'status',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  Title = 'title',
  /** column name */
  Urn = 'urn',
}

/** Ordering options when selecting data from "learning_journeys_v2". */
export type RLearning_Journeys_V2_Order_By = {
  learning_items_count?: InputMaybe<ROrder_By>;
  planned_duration?: InputMaybe<ROrder_By>;
  space_id?: InputMaybe<ROrder_By>;
  space_name?: InputMaybe<ROrder_By>;
  status?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  title?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
};

/** Boolean expression to compare columns of type "learning_status". All fields are combined with logical 'AND'. */
export type RLearning_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['learning_status']['input']>;
  _gt?: InputMaybe<Scalars['learning_status']['input']>;
  _gte?: InputMaybe<Scalars['learning_status']['input']>;
  _in?: InputMaybe<Array<Scalars['learning_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['learning_status']['input']>;
  _lte?: InputMaybe<Scalars['learning_status']['input']>;
  _neq?: InputMaybe<Scalars['learning_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['learning_status']['input']>>;
};

export type RLearning_Summary = {
  __typename?: 'learning_summary';
  average_progress: Scalars['numeric']['output'];
  completed_count: Scalars['bigint']['output'];
  completion_rate: Scalars['numeric']['output'];
  not_started_count: Scalars['bigint']['output'];
  space_ids?: Maybe<Scalars['jsonb']['output']>;
  started_count: Scalars['bigint']['output'];
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

export type RLearning_SummarySpace_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLearning_SummaryTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "learning_summary". All fields are combined with a logical 'AND'. */
export type RLearning_Summary_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RLearning_Summary_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RLearning_Summary_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RLearning_Summary_Bool_Exp_Bool_Exp>>;
  average_progress?: InputMaybe<RNumeric_Comparison_Exp>;
  completed_count?: InputMaybe<RBigint_Comparison_Exp>;
  completion_rate?: InputMaybe<RNumeric_Comparison_Exp>;
  not_started_count?: InputMaybe<RBigint_Comparison_Exp>;
  space_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  started_count?: InputMaybe<RBigint_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  title?: InputMaybe<RString_Comparison_Exp>;
  type?: InputMaybe<RString_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
};

export enum RLearning_Summary_Enum_Name {
  /** column name */
  AverageProgress = 'average_progress',
  /** column name */
  CompletedCount = 'completed_count',
  /** column name */
  CompletionRate = 'completion_rate',
  /** column name */
  NotStartedCount = 'not_started_count',
  /** column name */
  SpaceIds = 'space_ids',
  /** column name */
  StartedCount = 'started_count',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Urn = 'urn',
}

/** Ordering options when selecting data from "learning_summary". */
export type RLearning_Summary_Order_By = {
  average_progress?: InputMaybe<ROrder_By>;
  completed_count?: InputMaybe<ROrder_By>;
  completion_rate?: InputMaybe<ROrder_By>;
  not_started_count?: InputMaybe<ROrder_By>;
  space_ids?: InputMaybe<ROrder_By>;
  started_count?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  title?: InputMaybe<ROrder_By>;
  type?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
};

/** Boolean expression to compare columns of type "learning_type". All fields are combined with logical 'AND'. */
export type RLearning_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['learning_type']['input']>;
  _gt?: InputMaybe<Scalars['learning_type']['input']>;
  _gte?: InputMaybe<Scalars['learning_type']['input']>;
  _in?: InputMaybe<Array<Scalars['learning_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['learning_type']['input']>;
  _lte?: InputMaybe<Scalars['learning_type']['input']>;
  _neq?: InputMaybe<Scalars['learning_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['learning_type']['input']>>;
};

/** Boolean expression to compare columns of type "learning_visibility". All fields are combined with logical 'AND'. */
export type RLearning_Visibility_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['learning_visibility']['input']>;
  _gt?: InputMaybe<Scalars['learning_visibility']['input']>;
  _gte?: InputMaybe<Scalars['learning_visibility']['input']>;
  _in?: InputMaybe<Array<Scalars['learning_visibility']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['learning_visibility']['input']>;
  _lte?: InputMaybe<Scalars['learning_visibility']['input']>;
  _neq?: InputMaybe<Scalars['learning_visibility']['input']>;
  _nin?: InputMaybe<Array<Scalars['learning_visibility']['input']>>;
};

export type RLearnings = {
  __typename?: 'learnings';
  category?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Scalars['String']['output']>;
  planned_duration: Scalars['Int']['output'];
  space_ids?: Maybe<Scalars['jsonb']['output']>;
  space_names?: Maybe<Scalars['jsonb']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  urn?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type RLearningsSpace_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLearningsSpace_NamesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLearningsTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLearningsInsights = {
  __typename?: 'learningsInsights';
  completion_rate?: Maybe<Scalars['numeric']['output']>;
  learners_count?: Maybe<Scalars['bigint']['output']>;
  space_ids?: Maybe<Scalars['jsonb']['output']>;
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  urn?: Maybe<Scalars['String']['output']>;
};

export type RLearningsInsightsSpace_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLearningsInsightsTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "learningsInsights". All fields are combined with a logical 'AND'. */
export type RLearningsInsights_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RLearningsInsights_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RLearningsInsights_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RLearningsInsights_Bool_Exp_Bool_Exp>>;
  completion_rate?: InputMaybe<RNumeric_Comparison_Exp>;
  learners_count?: InputMaybe<RBigint_Comparison_Exp>;
  space_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
};

export enum RLearningsInsights_Enum_Name {
  /** column name */
  CompletionRate = 'completion_rate',
  /** column name */
  LearnersCount = 'learners_count',
  /** column name */
  SpaceIds = 'space_ids',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  Urn = 'urn',
}

/** Ordering options when selecting data from "learningsInsights". */
export type RLearningsInsights_Order_By = {
  completion_rate?: InputMaybe<ROrder_By>;
  learners_count?: InputMaybe<ROrder_By>;
  space_ids?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
};

/** Boolean expression to filter rows from the logical model for "learnings". All fields are combined with a logical 'AND'. */
export type RLearnings_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RLearnings_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RLearnings_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RLearnings_Bool_Exp_Bool_Exp>>;
  category?: InputMaybe<RString_Comparison_Exp>;
  partner?: InputMaybe<RString_Comparison_Exp>;
  planned_duration?: InputMaybe<RInt_Comparison_Exp>;
  space_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  space_names?: InputMaybe<RJsonb_Comparison_Exp>;
  subject?: InputMaybe<RString_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  title?: InputMaybe<RString_Comparison_Exp>;
  type?: InputMaybe<RString_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
  visibility?: InputMaybe<RString_Comparison_Exp>;
};

export enum RLearnings_Enum_Name {
  /** column name */
  Category = 'category',
  /** column name */
  Partner = 'partner',
  /** column name */
  PlannedDuration = 'planned_duration',
  /** column name */
  SpaceIds = 'space_ids',
  /** column name */
  SpaceNames = 'space_names',
  /** column name */
  Subject = 'subject',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Urn = 'urn',
  /** column name */
  Visibility = 'visibility',
}

/** Ordering options when selecting data from "learnings". */
export type RLearnings_Order_By = {
  category?: InputMaybe<ROrder_By>;
  partner?: InputMaybe<ROrder_By>;
  planned_duration?: InputMaybe<ROrder_By>;
  space_ids?: InputMaybe<ROrder_By>;
  space_names?: InputMaybe<ROrder_By>;
  subject?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  title?: InputMaybe<ROrder_By>;
  type?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
  visibility?: InputMaybe<ROrder_By>;
};

export type RLive_Learnings_Learners = {
  __typename?: 'live_learnings_learners';
  attendance: Scalars['String']['output'];
  completion_time?: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['String']['output'];
  is_completed: Scalars['Boolean']['output'];
  join_time?: Maybe<Scalars['timestamptz']['output']>;
  learning_enrollment_id: Scalars['Int']['output'];
  location_id: Scalars['Int']['output'];
  profile_image?: Maybe<Scalars['String']['output']>;
  registration: Scalars['uuid']['output'];
  session_time: Scalars['timestamptz']['output'];
  space_ids: Scalars['jsonb']['output'];
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  team_names?: Maybe<Scalars['jsonb']['output']>;
  user_id: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type RLive_Learnings_LearnersSpace_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLive_Learnings_LearnersTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RLive_Learnings_LearnersTeam_NamesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "live_learnings_learners". All fields are combined with a logical 'AND'. */
export type RLive_Learnings_Learners_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RLive_Learnings_Learners_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RLive_Learnings_Learners_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RLive_Learnings_Learners_Bool_Exp_Bool_Exp>>;
  attendance?: InputMaybe<RString_Comparison_Exp>;
  completion_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  email?: InputMaybe<RString_Comparison_Exp>;
  is_completed?: InputMaybe<RBoolean_Comparison_Exp>;
  join_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  learning_enrollment_id?: InputMaybe<RInt_Comparison_Exp>;
  location_id?: InputMaybe<RInt_Comparison_Exp>;
  profile_image?: InputMaybe<RString_Comparison_Exp>;
  registration?: InputMaybe<RUuid_Comparison_Exp>;
  session_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  space_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  team_names?: InputMaybe<RJsonb_Comparison_Exp>;
  user_id?: InputMaybe<RInt_Comparison_Exp>;
  username?: InputMaybe<RString_Comparison_Exp>;
};

export enum RLive_Learnings_Learners_Enum_Name {
  /** column name */
  Attendance = 'attendance',
  /** column name */
  CompletionTime = 'completion_time',
  /** column name */
  Email = 'email',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  JoinTime = 'join_time',
  /** column name */
  LearningEnrollmentId = 'learning_enrollment_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  ProfileImage = 'profile_image',
  /** column name */
  Registration = 'registration',
  /** column name */
  SessionTime = 'session_time',
  /** column name */
  SpaceIds = 'space_ids',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  TeamNames = 'team_names',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username',
}

/** Ordering options when selecting data from "live_learnings_learners". */
export type RLive_Learnings_Learners_Order_By = {
  attendance?: InputMaybe<ROrder_By>;
  completion_time?: InputMaybe<ROrder_By>;
  email?: InputMaybe<ROrder_By>;
  is_completed?: InputMaybe<ROrder_By>;
  join_time?: InputMaybe<ROrder_By>;
  learning_enrollment_id?: InputMaybe<ROrder_By>;
  location_id?: InputMaybe<ROrder_By>;
  profile_image?: InputMaybe<ROrder_By>;
  registration?: InputMaybe<ROrder_By>;
  session_time?: InputMaybe<ROrder_By>;
  space_ids?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  team_names?: InputMaybe<ROrder_By>;
  user_id?: InputMaybe<ROrder_By>;
  username?: InputMaybe<ROrder_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type RNumeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum ROrder_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last',
}

export type RPractical_Assessment = {
  __typename?: 'practical_assessment';
  page_urn: Scalars['String']['output'];
  question_title: Scalars['String']['output'];
  responses_count: Scalars['Int']['output'];
  reviews_count: Scalars['Int']['output'];
  space_id: Scalars['Int']['output'];
  team_ids: Scalars['jsonb']['output'];
  title: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

export type RPractical_AssessmentTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "practical_assessment". All fields are combined with a logical 'AND'. */
export type RPractical_Assessment_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RPractical_Assessment_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RPractical_Assessment_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RPractical_Assessment_Bool_Exp_Bool_Exp>>;
  page_urn?: InputMaybe<RString_Comparison_Exp>;
  question_title?: InputMaybe<RString_Comparison_Exp>;
  responses_count?: InputMaybe<RInt_Comparison_Exp>;
  reviews_count?: InputMaybe<RInt_Comparison_Exp>;
  space_id?: InputMaybe<RInt_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  title?: InputMaybe<RString_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
};

export enum RPractical_Assessment_Enum_Name {
  /** column name */
  PageUrn = 'page_urn',
  /** column name */
  QuestionTitle = 'question_title',
  /** column name */
  ResponsesCount = 'responses_count',
  /** column name */
  ReviewsCount = 'reviews_count',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  Title = 'title',
  /** column name */
  Urn = 'urn',
}

/** Ordering options when selecting data from "practical_assessment". */
export type RPractical_Assessment_Order_By = {
  page_urn?: InputMaybe<ROrder_By>;
  question_title?: InputMaybe<ROrder_By>;
  responses_count?: InputMaybe<ROrder_By>;
  reviews_count?: InputMaybe<ROrder_By>;
  space_id?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  title?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
};

export type RQuiz = {
  __typename?: 'quiz';
  activity_urn: Scalars['String']['output'];
  all_attempt_ratio: Scalars['numeric']['output'];
  correct_answers: Scalars['Int']['output'];
  incorrect_answers: Scalars['Int']['output'];
  latest_attempt_ratio: Scalars['numeric']['output'];
  latest_correct_answers: Scalars['Int']['output'];
  latest_incorrect_answers: Scalars['Int']['output'];
  latest_pass_ratio: Scalars['numeric']['output'];
  latest_total: Scalars['Int']['output'];
  latest_total_failed: Scalars['Int']['output'];
  latest_total_passed: Scalars['Int']['output'];
  question_id: Scalars['String']['output'];
  question_title: Scalars['String']['output'];
  space_id: Scalars['Int']['output'];
  team_ids: Scalars['jsonb']['output'];
  total_answers: Scalars['Int']['output'];
  total_unique_user_answers: Scalars['Int']['output'];
  urn: Scalars['String']['output'];
};

export type RQuizTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "quiz". All fields are combined with a logical 'AND'. */
export type RQuiz_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RQuiz_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RQuiz_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RQuiz_Bool_Exp_Bool_Exp>>;
  activity_urn?: InputMaybe<RString_Comparison_Exp>;
  all_attempt_ratio?: InputMaybe<RNumeric_Comparison_Exp>;
  correct_answers?: InputMaybe<RInt_Comparison_Exp>;
  incorrect_answers?: InputMaybe<RInt_Comparison_Exp>;
  latest_attempt_ratio?: InputMaybe<RNumeric_Comparison_Exp>;
  latest_correct_answers?: InputMaybe<RInt_Comparison_Exp>;
  latest_incorrect_answers?: InputMaybe<RInt_Comparison_Exp>;
  latest_pass_ratio?: InputMaybe<RNumeric_Comparison_Exp>;
  latest_total?: InputMaybe<RInt_Comparison_Exp>;
  latest_total_failed?: InputMaybe<RInt_Comparison_Exp>;
  latest_total_passed?: InputMaybe<RInt_Comparison_Exp>;
  question_id?: InputMaybe<RString_Comparison_Exp>;
  question_title?: InputMaybe<RString_Comparison_Exp>;
  space_id?: InputMaybe<RInt_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  total_answers?: InputMaybe<RInt_Comparison_Exp>;
  total_unique_user_answers?: InputMaybe<RInt_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
};

export enum RQuiz_Enum_Name {
  /** column name */
  ActivityUrn = 'activity_urn',
  /** column name */
  AllAttemptRatio = 'all_attempt_ratio',
  /** column name */
  CorrectAnswers = 'correct_answers',
  /** column name */
  IncorrectAnswers = 'incorrect_answers',
  /** column name */
  LatestAttemptRatio = 'latest_attempt_ratio',
  /** column name */
  LatestCorrectAnswers = 'latest_correct_answers',
  /** column name */
  LatestIncorrectAnswers = 'latest_incorrect_answers',
  /** column name */
  LatestPassRatio = 'latest_pass_ratio',
  /** column name */
  LatestTotal = 'latest_total',
  /** column name */
  LatestTotalFailed = 'latest_total_failed',
  /** column name */
  LatestTotalPassed = 'latest_total_passed',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionTitle = 'question_title',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  TotalAnswers = 'total_answers',
  /** column name */
  TotalUniqueUserAnswers = 'total_unique_user_answers',
  /** column name */
  Urn = 'urn',
}

/** Ordering options when selecting data from "quiz". */
export type RQuiz_Order_By = {
  activity_urn?: InputMaybe<ROrder_By>;
  all_attempt_ratio?: InputMaybe<ROrder_By>;
  correct_answers?: InputMaybe<ROrder_By>;
  incorrect_answers?: InputMaybe<ROrder_By>;
  latest_attempt_ratio?: InputMaybe<ROrder_By>;
  latest_correct_answers?: InputMaybe<ROrder_By>;
  latest_incorrect_answers?: InputMaybe<ROrder_By>;
  latest_pass_ratio?: InputMaybe<ROrder_By>;
  latest_total?: InputMaybe<ROrder_By>;
  latest_total_failed?: InputMaybe<ROrder_By>;
  latest_total_passed?: InputMaybe<ROrder_By>;
  question_id?: InputMaybe<ROrder_By>;
  question_title?: InputMaybe<ROrder_By>;
  space_id?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  total_answers?: InputMaybe<ROrder_By>;
  total_unique_user_answers?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
};

/** columns and relationships of "reporting.mv_aggregation_effort_for_realm" */
export type RReportingAggregationEffortForRealm = {
  __typename?: 'reportingAggregationEffortForRealm';
  averageEffort?: Maybe<Scalars['bigint']['output']>;
  fromTime?: Maybe<Scalars['timestamptz']['output']>;
  meta_update_time?: Maybe<Scalars['timestamptz']['output']>;
  p50Effort?: Maybe<Scalars['float8']['output']>;
  p60Effort?: Maybe<Scalars['float8']['output']>;
  p70Effort?: Maybe<Scalars['float8']['output']>;
  p80Effort?: Maybe<Scalars['float8']['output']>;
  p90Effort?: Maybe<Scalars['float8']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  toTime?: Maybe<Scalars['timestamptz']['output']>;
  totalEffort?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "reporting.mv_aggregation_effort_for_realm" */
export type RReportingAggregationEffortForRealm_Aggregate = {
  __typename?: 'reportingAggregationEffortForRealm_aggregate';
  aggregate?: Maybe<RReportingAggregationEffortForRealm_Aggregate_Fields>;
  nodes: Array<RReportingAggregationEffortForRealm>;
};

/** aggregate fields of "reporting.mv_aggregation_effort_for_realm" */
export type RReportingAggregationEffortForRealm_Aggregate_Fields = {
  __typename?: 'reportingAggregationEffortForRealm_aggregate_fields';
  avg?: Maybe<RReportingAggregationEffortForRealm_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RReportingAggregationEffortForRealm_Max_Fields>;
  min?: Maybe<RReportingAggregationEffortForRealm_Min_Fields>;
  stddev?: Maybe<RReportingAggregationEffortForRealm_Stddev_Fields>;
  stddev_pop?: Maybe<RReportingAggregationEffortForRealm_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RReportingAggregationEffortForRealm_Stddev_Samp_Fields>;
  sum?: Maybe<RReportingAggregationEffortForRealm_Sum_Fields>;
  var_pop?: Maybe<RReportingAggregationEffortForRealm_Var_Pop_Fields>;
  var_samp?: Maybe<RReportingAggregationEffortForRealm_Var_Samp_Fields>;
  variance?: Maybe<RReportingAggregationEffortForRealm_Variance_Fields>;
};

/** aggregate fields of "reporting.mv_aggregation_effort_for_realm" */
export type RReportingAggregationEffortForRealm_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RReportingAggregationEffortForRealm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RReportingAggregationEffortForRealm_Avg_Fields = {
  __typename?: 'reportingAggregationEffortForRealm_avg_fields';
  averageEffort?: Maybe<Scalars['Float']['output']>;
  p50Effort?: Maybe<Scalars['Float']['output']>;
  p60Effort?: Maybe<Scalars['Float']['output']>;
  p70Effort?: Maybe<Scalars['Float']['output']>;
  p80Effort?: Maybe<Scalars['Float']['output']>;
  p90Effort?: Maybe<Scalars['Float']['output']>;
  totalEffort?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "reporting.mv_aggregation_effort_for_realm". All fields are combined with a logical 'AND'. */
export type RReportingAggregationEffortForRealm_Bool_Exp = {
  _and?: InputMaybe<Array<RReportingAggregationEffortForRealm_Bool_Exp>>;
  _not?: InputMaybe<RReportingAggregationEffortForRealm_Bool_Exp>;
  _or?: InputMaybe<Array<RReportingAggregationEffortForRealm_Bool_Exp>>;
  averageEffort?: InputMaybe<RBigint_Comparison_Exp>;
  fromTime?: InputMaybe<RTimestamptz_Comparison_Exp>;
  meta_update_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  p50Effort?: InputMaybe<RFloat8_Comparison_Exp>;
  p60Effort?: InputMaybe<RFloat8_Comparison_Exp>;
  p70Effort?: InputMaybe<RFloat8_Comparison_Exp>;
  p80Effort?: InputMaybe<RFloat8_Comparison_Exp>;
  p90Effort?: InputMaybe<RFloat8_Comparison_Exp>;
  realm?: InputMaybe<RString_Comparison_Exp>;
  toTime?: InputMaybe<RTimestamptz_Comparison_Exp>;
  totalEffort?: InputMaybe<RBigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type RReportingAggregationEffortForRealm_Max_Fields = {
  __typename?: 'reportingAggregationEffortForRealm_max_fields';
  averageEffort?: Maybe<Scalars['bigint']['output']>;
  fromTime?: Maybe<Scalars['timestamptz']['output']>;
  meta_update_time?: Maybe<Scalars['timestamptz']['output']>;
  p50Effort?: Maybe<Scalars['float8']['output']>;
  p60Effort?: Maybe<Scalars['float8']['output']>;
  p70Effort?: Maybe<Scalars['float8']['output']>;
  p80Effort?: Maybe<Scalars['float8']['output']>;
  p90Effort?: Maybe<Scalars['float8']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  toTime?: Maybe<Scalars['timestamptz']['output']>;
  totalEffort?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type RReportingAggregationEffortForRealm_Min_Fields = {
  __typename?: 'reportingAggregationEffortForRealm_min_fields';
  averageEffort?: Maybe<Scalars['bigint']['output']>;
  fromTime?: Maybe<Scalars['timestamptz']['output']>;
  meta_update_time?: Maybe<Scalars['timestamptz']['output']>;
  p50Effort?: Maybe<Scalars['float8']['output']>;
  p60Effort?: Maybe<Scalars['float8']['output']>;
  p70Effort?: Maybe<Scalars['float8']['output']>;
  p80Effort?: Maybe<Scalars['float8']['output']>;
  p90Effort?: Maybe<Scalars['float8']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  toTime?: Maybe<Scalars['timestamptz']['output']>;
  totalEffort?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "reporting.mv_aggregation_effort_for_realm". */
export type RReportingAggregationEffortForRealm_Order_By = {
  averageEffort?: InputMaybe<ROrder_By>;
  fromTime?: InputMaybe<ROrder_By>;
  meta_update_time?: InputMaybe<ROrder_By>;
  p50Effort?: InputMaybe<ROrder_By>;
  p60Effort?: InputMaybe<ROrder_By>;
  p70Effort?: InputMaybe<ROrder_By>;
  p80Effort?: InputMaybe<ROrder_By>;
  p90Effort?: InputMaybe<ROrder_By>;
  realm?: InputMaybe<ROrder_By>;
  toTime?: InputMaybe<ROrder_By>;
  totalEffort?: InputMaybe<ROrder_By>;
};

/** select columns of table "reporting.mv_aggregation_effort_for_realm" */
export enum RReportingAggregationEffortForRealm_Select_Column {
  /** column name */
  AverageEffort = 'averageEffort',
  /** column name */
  FromTime = 'fromTime',
  /** column name */
  MetaUpdateTime = 'meta_update_time',
  /** column name */
  P50Effort = 'p50Effort',
  /** column name */
  P60Effort = 'p60Effort',
  /** column name */
  P70Effort = 'p70Effort',
  /** column name */
  P80Effort = 'p80Effort',
  /** column name */
  P90Effort = 'p90Effort',
  /** column name */
  Realm = 'realm',
  /** column name */
  ToTime = 'toTime',
  /** column name */
  TotalEffort = 'totalEffort',
}

/** aggregate stddev on columns */
export type RReportingAggregationEffortForRealm_Stddev_Fields = {
  __typename?: 'reportingAggregationEffortForRealm_stddev_fields';
  averageEffort?: Maybe<Scalars['Float']['output']>;
  p50Effort?: Maybe<Scalars['Float']['output']>;
  p60Effort?: Maybe<Scalars['Float']['output']>;
  p70Effort?: Maybe<Scalars['Float']['output']>;
  p80Effort?: Maybe<Scalars['Float']['output']>;
  p90Effort?: Maybe<Scalars['Float']['output']>;
  totalEffort?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RReportingAggregationEffortForRealm_Stddev_Pop_Fields = {
  __typename?: 'reportingAggregationEffortForRealm_stddev_pop_fields';
  averageEffort?: Maybe<Scalars['Float']['output']>;
  p50Effort?: Maybe<Scalars['Float']['output']>;
  p60Effort?: Maybe<Scalars['Float']['output']>;
  p70Effort?: Maybe<Scalars['Float']['output']>;
  p80Effort?: Maybe<Scalars['Float']['output']>;
  p90Effort?: Maybe<Scalars['Float']['output']>;
  totalEffort?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RReportingAggregationEffortForRealm_Stddev_Samp_Fields = {
  __typename?: 'reportingAggregationEffortForRealm_stddev_samp_fields';
  averageEffort?: Maybe<Scalars['Float']['output']>;
  p50Effort?: Maybe<Scalars['Float']['output']>;
  p60Effort?: Maybe<Scalars['Float']['output']>;
  p70Effort?: Maybe<Scalars['Float']['output']>;
  p80Effort?: Maybe<Scalars['Float']['output']>;
  p90Effort?: Maybe<Scalars['Float']['output']>;
  totalEffort?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportingAggregationEffortForRealm" */
export type RReportingAggregationEffortForRealm_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RReportingAggregationEffortForRealm_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<RCursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RReportingAggregationEffortForRealm_Stream_Cursor_Value_Input = {
  averageEffort?: InputMaybe<Scalars['bigint']['input']>;
  fromTime?: InputMaybe<Scalars['timestamptz']['input']>;
  meta_update_time?: InputMaybe<Scalars['timestamptz']['input']>;
  p50Effort?: InputMaybe<Scalars['float8']['input']>;
  p60Effort?: InputMaybe<Scalars['float8']['input']>;
  p70Effort?: InputMaybe<Scalars['float8']['input']>;
  p80Effort?: InputMaybe<Scalars['float8']['input']>;
  p90Effort?: InputMaybe<Scalars['float8']['input']>;
  realm?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['timestamptz']['input']>;
  totalEffort?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type RReportingAggregationEffortForRealm_Sum_Fields = {
  __typename?: 'reportingAggregationEffortForRealm_sum_fields';
  averageEffort?: Maybe<Scalars['bigint']['output']>;
  p50Effort?: Maybe<Scalars['float8']['output']>;
  p60Effort?: Maybe<Scalars['float8']['output']>;
  p70Effort?: Maybe<Scalars['float8']['output']>;
  p80Effort?: Maybe<Scalars['float8']['output']>;
  p90Effort?: Maybe<Scalars['float8']['output']>;
  totalEffort?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type RReportingAggregationEffortForRealm_Var_Pop_Fields = {
  __typename?: 'reportingAggregationEffortForRealm_var_pop_fields';
  averageEffort?: Maybe<Scalars['Float']['output']>;
  p50Effort?: Maybe<Scalars['Float']['output']>;
  p60Effort?: Maybe<Scalars['Float']['output']>;
  p70Effort?: Maybe<Scalars['Float']['output']>;
  p80Effort?: Maybe<Scalars['Float']['output']>;
  p90Effort?: Maybe<Scalars['Float']['output']>;
  totalEffort?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RReportingAggregationEffortForRealm_Var_Samp_Fields = {
  __typename?: 'reportingAggregationEffortForRealm_var_samp_fields';
  averageEffort?: Maybe<Scalars['Float']['output']>;
  p50Effort?: Maybe<Scalars['Float']['output']>;
  p60Effort?: Maybe<Scalars['Float']['output']>;
  p70Effort?: Maybe<Scalars['Float']['output']>;
  p80Effort?: Maybe<Scalars['Float']['output']>;
  p90Effort?: Maybe<Scalars['Float']['output']>;
  totalEffort?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RReportingAggregationEffortForRealm_Variance_Fields = {
  __typename?: 'reportingAggregationEffortForRealm_variance_fields';
  averageEffort?: Maybe<Scalars['Float']['output']>;
  p50Effort?: Maybe<Scalars['Float']['output']>;
  p60Effort?: Maybe<Scalars['Float']['output']>;
  p70Effort?: Maybe<Scalars['Float']['output']>;
  p80Effort?: Maybe<Scalars['Float']['output']>;
  p90Effort?: Maybe<Scalars['Float']['output']>;
  totalEffort?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "reporting.mv_learning_activities_insights" */
export type RReportingLearningActivitiesInsights = {
  __typename?: 'reportingLearningActivitiesInsights';
  activityType?: Maybe<Scalars['String']['output']>;
  activityURN?: Maybe<Scalars['String']['output']>;
  completedCount?: Maybe<Scalars['bigint']['output']>;
  completionRate?: Maybe<Scalars['numeric']['output']>;
  inProgressCount?: Maybe<Scalars['bigint']['output']>;
  learningURN?: Maybe<Scalars['String']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  notStartedCount?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  plannedDuration?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['float8']['output']>;
  startedCount?: Maybe<Scalars['bigint']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['bigint']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** reportingLearningActivitiesInsightsV2TotalCountNative Query Arguments */
export type RReportingLearningActivitiesInsightsV2TotalCount_Arguments = {
  activity_urn?: InputMaybe<Scalars['String']['input']>;
  expected_user_ids?: InputMaybe<Scalars['jsonb']['input']>;
  learning_urn: Scalars['String']['input'];
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** reportingLearningActivitiesInsightsV2Native Query Arguments */
export type RReportingLearningActivitiesInsightsV2_Arguments = {
  activity_urn?: InputMaybe<Scalars['String']['input']>;
  expected_user_ids?: InputMaybe<Scalars['jsonb']['input']>;
  learning_urn: Scalars['String']['input'];
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregated selection of "reporting.mv_learning_activities_insights" */
export type RReportingLearningActivitiesInsights_Aggregate = {
  __typename?: 'reportingLearningActivitiesInsights_aggregate';
  aggregate?: Maybe<RReportingLearningActivitiesInsights_Aggregate_Fields>;
  nodes: Array<RReportingLearningActivitiesInsights>;
};

/** aggregate fields of "reporting.mv_learning_activities_insights" */
export type RReportingLearningActivitiesInsights_Aggregate_Fields = {
  __typename?: 'reportingLearningActivitiesInsights_aggregate_fields';
  avg?: Maybe<RReportingLearningActivitiesInsights_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RReportingLearningActivitiesInsights_Max_Fields>;
  min?: Maybe<RReportingLearningActivitiesInsights_Min_Fields>;
  stddev?: Maybe<RReportingLearningActivitiesInsights_Stddev_Fields>;
  stddev_pop?: Maybe<RReportingLearningActivitiesInsights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RReportingLearningActivitiesInsights_Stddev_Samp_Fields>;
  sum?: Maybe<RReportingLearningActivitiesInsights_Sum_Fields>;
  var_pop?: Maybe<RReportingLearningActivitiesInsights_Var_Pop_Fields>;
  var_samp?: Maybe<RReportingLearningActivitiesInsights_Var_Samp_Fields>;
  variance?: Maybe<RReportingLearningActivitiesInsights_Variance_Fields>;
};

/** aggregate fields of "reporting.mv_learning_activities_insights" */
export type RReportingLearningActivitiesInsights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RReportingLearningActivitiesInsights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RReportingLearningActivitiesInsights_Avg_Fields = {
  __typename?: 'reportingLearningActivitiesInsights_avg_fields';
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  inProgressCount?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "reporting.mv_learning_activities_insights". All fields are combined with a logical 'AND'. */
export type RReportingLearningActivitiesInsights_Bool_Exp = {
  _and?: InputMaybe<Array<RReportingLearningActivitiesInsights_Bool_Exp>>;
  _not?: InputMaybe<RReportingLearningActivitiesInsights_Bool_Exp>;
  _or?: InputMaybe<Array<RReportingLearningActivitiesInsights_Bool_Exp>>;
  activityType?: InputMaybe<RString_Comparison_Exp>;
  activityURN?: InputMaybe<RString_Comparison_Exp>;
  completedCount?: InputMaybe<RBigint_Comparison_Exp>;
  completionRate?: InputMaybe<RNumeric_Comparison_Exp>;
  inProgressCount?: InputMaybe<RBigint_Comparison_Exp>;
  learningURN?: InputMaybe<RString_Comparison_Exp>;
  metaUpdateTime?: InputMaybe<RTimestamptz_Comparison_Exp>;
  notStartedCount?: InputMaybe<RBigint_Comparison_Exp>;
  order?: InputMaybe<RInt_Comparison_Exp>;
  plannedDuration?: InputMaybe<RInt_Comparison_Exp>;
  progress?: InputMaybe<RFloat8_Comparison_Exp>;
  startedCount?: InputMaybe<RBigint_Comparison_Exp>;
  title?: InputMaybe<RString_Comparison_Exp>;
  totalCount?: InputMaybe<RBigint_Comparison_Exp>;
  totalEffortInSeconds?: InputMaybe<RNumeric_Comparison_Exp>;
  type?: InputMaybe<RString_Comparison_Exp>;
};

/** aggregate max on columns */
export type RReportingLearningActivitiesInsights_Max_Fields = {
  __typename?: 'reportingLearningActivitiesInsights_max_fields';
  activityType?: Maybe<Scalars['String']['output']>;
  activityURN?: Maybe<Scalars['String']['output']>;
  completedCount?: Maybe<Scalars['bigint']['output']>;
  completionRate?: Maybe<Scalars['numeric']['output']>;
  inProgressCount?: Maybe<Scalars['bigint']['output']>;
  learningURN?: Maybe<Scalars['String']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  notStartedCount?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  plannedDuration?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['float8']['output']>;
  startedCount?: Maybe<Scalars['bigint']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['bigint']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type RReportingLearningActivitiesInsights_Min_Fields = {
  __typename?: 'reportingLearningActivitiesInsights_min_fields';
  activityType?: Maybe<Scalars['String']['output']>;
  activityURN?: Maybe<Scalars['String']['output']>;
  completedCount?: Maybe<Scalars['bigint']['output']>;
  completionRate?: Maybe<Scalars['numeric']['output']>;
  inProgressCount?: Maybe<Scalars['bigint']['output']>;
  learningURN?: Maybe<Scalars['String']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  notStartedCount?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  plannedDuration?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['float8']['output']>;
  startedCount?: Maybe<Scalars['bigint']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['bigint']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "reporting.mv_learning_activities_insights". */
export type RReportingLearningActivitiesInsights_Order_By = {
  activityType?: InputMaybe<ROrder_By>;
  activityURN?: InputMaybe<ROrder_By>;
  completedCount?: InputMaybe<ROrder_By>;
  completionRate?: InputMaybe<ROrder_By>;
  inProgressCount?: InputMaybe<ROrder_By>;
  learningURN?: InputMaybe<ROrder_By>;
  metaUpdateTime?: InputMaybe<ROrder_By>;
  notStartedCount?: InputMaybe<ROrder_By>;
  order?: InputMaybe<ROrder_By>;
  plannedDuration?: InputMaybe<ROrder_By>;
  progress?: InputMaybe<ROrder_By>;
  startedCount?: InputMaybe<ROrder_By>;
  title?: InputMaybe<ROrder_By>;
  totalCount?: InputMaybe<ROrder_By>;
  totalEffortInSeconds?: InputMaybe<ROrder_By>;
  type?: InputMaybe<ROrder_By>;
};

/** select columns of table "reporting.mv_learning_activities_insights" */
export enum RReportingLearningActivitiesInsights_Select_Column {
  /** column name */
  ActivityType = 'activityType',
  /** column name */
  ActivityUrn = 'activityURN',
  /** column name */
  CompletedCount = 'completedCount',
  /** column name */
  CompletionRate = 'completionRate',
  /** column name */
  InProgressCount = 'inProgressCount',
  /** column name */
  LearningUrn = 'learningURN',
  /** column name */
  MetaUpdateTime = 'metaUpdateTime',
  /** column name */
  NotStartedCount = 'notStartedCount',
  /** column name */
  Order = 'order',
  /** column name */
  PlannedDuration = 'plannedDuration',
  /** column name */
  Progress = 'progress',
  /** column name */
  StartedCount = 'startedCount',
  /** column name */
  Title = 'title',
  /** column name */
  TotalCount = 'totalCount',
  /** column name */
  TotalEffortInSeconds = 'totalEffortInSeconds',
  /** column name */
  Type = 'type',
}

/** aggregate stddev on columns */
export type RReportingLearningActivitiesInsights_Stddev_Fields = {
  __typename?: 'reportingLearningActivitiesInsights_stddev_fields';
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  inProgressCount?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RReportingLearningActivitiesInsights_Stddev_Pop_Fields = {
  __typename?: 'reportingLearningActivitiesInsights_stddev_pop_fields';
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  inProgressCount?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RReportingLearningActivitiesInsights_Stddev_Samp_Fields = {
  __typename?: 'reportingLearningActivitiesInsights_stddev_samp_fields';
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  inProgressCount?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportingLearningActivitiesInsights" */
export type RReportingLearningActivitiesInsights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RReportingLearningActivitiesInsights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<RCursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RReportingLearningActivitiesInsights_Stream_Cursor_Value_Input = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  activityURN?: InputMaybe<Scalars['String']['input']>;
  completedCount?: InputMaybe<Scalars['bigint']['input']>;
  completionRate?: InputMaybe<Scalars['numeric']['input']>;
  inProgressCount?: InputMaybe<Scalars['bigint']['input']>;
  learningURN?: InputMaybe<Scalars['String']['input']>;
  metaUpdateTime?: InputMaybe<Scalars['timestamptz']['input']>;
  notStartedCount?: InputMaybe<Scalars['bigint']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  plannedDuration?: InputMaybe<Scalars['Int']['input']>;
  progress?: InputMaybe<Scalars['float8']['input']>;
  startedCount?: InputMaybe<Scalars['bigint']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalCount?: InputMaybe<Scalars['bigint']['input']>;
  totalEffortInSeconds?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type RReportingLearningActivitiesInsights_Sum_Fields = {
  __typename?: 'reportingLearningActivitiesInsights_sum_fields';
  completedCount?: Maybe<Scalars['bigint']['output']>;
  completionRate?: Maybe<Scalars['numeric']['output']>;
  inProgressCount?: Maybe<Scalars['bigint']['output']>;
  notStartedCount?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  plannedDuration?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['float8']['output']>;
  startedCount?: Maybe<Scalars['bigint']['output']>;
  totalCount?: Maybe<Scalars['bigint']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type RReportingLearningActivitiesInsights_Var_Pop_Fields = {
  __typename?: 'reportingLearningActivitiesInsights_var_pop_fields';
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  inProgressCount?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RReportingLearningActivitiesInsights_Var_Samp_Fields = {
  __typename?: 'reportingLearningActivitiesInsights_var_samp_fields';
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  inProgressCount?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RReportingLearningActivitiesInsights_Variance_Fields = {
  __typename?: 'reportingLearningActivitiesInsights_variance_fields';
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  inProgressCount?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "reporting.mv_learning_journey_content_insights" */
export type RReportingLearningJourneyContentInsights = {
  __typename?: 'reportingLearningJourneyContentInsights';
  averageProgress?: Maybe<Scalars['numeric']['output']>;
  completedCount?: Maybe<Scalars['bigint']['output']>;
  completionRate?: Maybe<Scalars['numeric']['output']>;
  learningContentTitle?: Maybe<Scalars['String']['output']>;
  learningContentURN?: Maybe<Scalars['String']['output']>;
  learningJourneyTitle?: Maybe<Scalars['String']['output']>;
  learningJourneyURN?: Maybe<Scalars['String']['output']>;
  learningType?: Maybe<Scalars['catalog_item_type']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  notStartedCount?: Maybe<Scalars['bigint']['output']>;
  plannedDuration?: Maybe<Scalars['Int']['output']>;
  startedCount?: Maybe<Scalars['bigint']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "reporting.mv_learning_journey_content_insights" */
export type RReportingLearningJourneyContentInsights_Aggregate = {
  __typename?: 'reportingLearningJourneyContentInsights_aggregate';
  aggregate?: Maybe<RReportingLearningJourneyContentInsights_Aggregate_Fields>;
  nodes: Array<RReportingLearningJourneyContentInsights>;
};

/** aggregate fields of "reporting.mv_learning_journey_content_insights" */
export type RReportingLearningJourneyContentInsights_Aggregate_Fields = {
  __typename?: 'reportingLearningJourneyContentInsights_aggregate_fields';
  avg?: Maybe<RReportingLearningJourneyContentInsights_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RReportingLearningJourneyContentInsights_Max_Fields>;
  min?: Maybe<RReportingLearningJourneyContentInsights_Min_Fields>;
  stddev?: Maybe<RReportingLearningJourneyContentInsights_Stddev_Fields>;
  stddev_pop?: Maybe<RReportingLearningJourneyContentInsights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RReportingLearningJourneyContentInsights_Stddev_Samp_Fields>;
  sum?: Maybe<RReportingLearningJourneyContentInsights_Sum_Fields>;
  var_pop?: Maybe<RReportingLearningJourneyContentInsights_Var_Pop_Fields>;
  var_samp?: Maybe<RReportingLearningJourneyContentInsights_Var_Samp_Fields>;
  variance?: Maybe<RReportingLearningJourneyContentInsights_Variance_Fields>;
};

/** aggregate fields of "reporting.mv_learning_journey_content_insights" */
export type RReportingLearningJourneyContentInsights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RReportingLearningJourneyContentInsights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RReportingLearningJourneyContentInsights_Avg_Fields = {
  __typename?: 'reportingLearningJourneyContentInsights_avg_fields';
  averageProgress?: Maybe<Scalars['Float']['output']>;
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "reporting.mv_learning_journey_content_insights". All fields are combined with a logical 'AND'. */
export type RReportingLearningJourneyContentInsights_Bool_Exp = {
  _and?: InputMaybe<Array<RReportingLearningJourneyContentInsights_Bool_Exp>>;
  _not?: InputMaybe<RReportingLearningJourneyContentInsights_Bool_Exp>;
  _or?: InputMaybe<Array<RReportingLearningJourneyContentInsights_Bool_Exp>>;
  averageProgress?: InputMaybe<RNumeric_Comparison_Exp>;
  completedCount?: InputMaybe<RBigint_Comparison_Exp>;
  completionRate?: InputMaybe<RNumeric_Comparison_Exp>;
  learningContentTitle?: InputMaybe<RString_Comparison_Exp>;
  learningContentURN?: InputMaybe<RString_Comparison_Exp>;
  learningJourneyTitle?: InputMaybe<RString_Comparison_Exp>;
  learningJourneyURN?: InputMaybe<RString_Comparison_Exp>;
  learningType?: InputMaybe<RCatalog_Item_Type_Comparison_Exp>;
  metaUpdateTime?: InputMaybe<RTimestamptz_Comparison_Exp>;
  notStartedCount?: InputMaybe<RBigint_Comparison_Exp>;
  plannedDuration?: InputMaybe<RInt_Comparison_Exp>;
  startedCount?: InputMaybe<RBigint_Comparison_Exp>;
  totalEffortInSeconds?: InputMaybe<RNumeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type RReportingLearningJourneyContentInsights_Max_Fields = {
  __typename?: 'reportingLearningJourneyContentInsights_max_fields';
  averageProgress?: Maybe<Scalars['numeric']['output']>;
  completedCount?: Maybe<Scalars['bigint']['output']>;
  completionRate?: Maybe<Scalars['numeric']['output']>;
  learningContentTitle?: Maybe<Scalars['String']['output']>;
  learningContentURN?: Maybe<Scalars['String']['output']>;
  learningJourneyTitle?: Maybe<Scalars['String']['output']>;
  learningJourneyURN?: Maybe<Scalars['String']['output']>;
  learningType?: Maybe<Scalars['catalog_item_type']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  notStartedCount?: Maybe<Scalars['bigint']['output']>;
  plannedDuration?: Maybe<Scalars['Int']['output']>;
  startedCount?: Maybe<Scalars['bigint']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type RReportingLearningJourneyContentInsights_Min_Fields = {
  __typename?: 'reportingLearningJourneyContentInsights_min_fields';
  averageProgress?: Maybe<Scalars['numeric']['output']>;
  completedCount?: Maybe<Scalars['bigint']['output']>;
  completionRate?: Maybe<Scalars['numeric']['output']>;
  learningContentTitle?: Maybe<Scalars['String']['output']>;
  learningContentURN?: Maybe<Scalars['String']['output']>;
  learningJourneyTitle?: Maybe<Scalars['String']['output']>;
  learningJourneyURN?: Maybe<Scalars['String']['output']>;
  learningType?: Maybe<Scalars['catalog_item_type']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  notStartedCount?: Maybe<Scalars['bigint']['output']>;
  plannedDuration?: Maybe<Scalars['Int']['output']>;
  startedCount?: Maybe<Scalars['bigint']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['numeric']['output']>;
};

/** Ordering options when selecting data from "reporting.mv_learning_journey_content_insights". */
export type RReportingLearningJourneyContentInsights_Order_By = {
  averageProgress?: InputMaybe<ROrder_By>;
  completedCount?: InputMaybe<ROrder_By>;
  completionRate?: InputMaybe<ROrder_By>;
  learningContentTitle?: InputMaybe<ROrder_By>;
  learningContentURN?: InputMaybe<ROrder_By>;
  learningJourneyTitle?: InputMaybe<ROrder_By>;
  learningJourneyURN?: InputMaybe<ROrder_By>;
  learningType?: InputMaybe<ROrder_By>;
  metaUpdateTime?: InputMaybe<ROrder_By>;
  notStartedCount?: InputMaybe<ROrder_By>;
  plannedDuration?: InputMaybe<ROrder_By>;
  startedCount?: InputMaybe<ROrder_By>;
  totalEffortInSeconds?: InputMaybe<ROrder_By>;
};

/** select columns of table "reporting.mv_learning_journey_content_insights" */
export enum RReportingLearningJourneyContentInsights_Select_Column {
  /** column name */
  AverageProgress = 'averageProgress',
  /** column name */
  CompletedCount = 'completedCount',
  /** column name */
  CompletionRate = 'completionRate',
  /** column name */
  LearningContentTitle = 'learningContentTitle',
  /** column name */
  LearningContentUrn = 'learningContentURN',
  /** column name */
  LearningJourneyTitle = 'learningJourneyTitle',
  /** column name */
  LearningJourneyUrn = 'learningJourneyURN',
  /** column name */
  LearningType = 'learningType',
  /** column name */
  MetaUpdateTime = 'metaUpdateTime',
  /** column name */
  NotStartedCount = 'notStartedCount',
  /** column name */
  PlannedDuration = 'plannedDuration',
  /** column name */
  StartedCount = 'startedCount',
  /** column name */
  TotalEffortInSeconds = 'totalEffortInSeconds',
}

/** aggregate stddev on columns */
export type RReportingLearningJourneyContentInsights_Stddev_Fields = {
  __typename?: 'reportingLearningJourneyContentInsights_stddev_fields';
  averageProgress?: Maybe<Scalars['Float']['output']>;
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RReportingLearningJourneyContentInsights_Stddev_Pop_Fields = {
  __typename?: 'reportingLearningJourneyContentInsights_stddev_pop_fields';
  averageProgress?: Maybe<Scalars['Float']['output']>;
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RReportingLearningJourneyContentInsights_Stddev_Samp_Fields = {
  __typename?: 'reportingLearningJourneyContentInsights_stddev_samp_fields';
  averageProgress?: Maybe<Scalars['Float']['output']>;
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportingLearningJourneyContentInsights" */
export type RReportingLearningJourneyContentInsights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RReportingLearningJourneyContentInsights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<RCursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RReportingLearningJourneyContentInsights_Stream_Cursor_Value_Input = {
  averageProgress?: InputMaybe<Scalars['numeric']['input']>;
  completedCount?: InputMaybe<Scalars['bigint']['input']>;
  completionRate?: InputMaybe<Scalars['numeric']['input']>;
  learningContentTitle?: InputMaybe<Scalars['String']['input']>;
  learningContentURN?: InputMaybe<Scalars['String']['input']>;
  learningJourneyTitle?: InputMaybe<Scalars['String']['input']>;
  learningJourneyURN?: InputMaybe<Scalars['String']['input']>;
  learningType?: InputMaybe<Scalars['catalog_item_type']['input']>;
  metaUpdateTime?: InputMaybe<Scalars['timestamptz']['input']>;
  notStartedCount?: InputMaybe<Scalars['bigint']['input']>;
  plannedDuration?: InputMaybe<Scalars['Int']['input']>;
  startedCount?: InputMaybe<Scalars['bigint']['input']>;
  totalEffortInSeconds?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type RReportingLearningJourneyContentInsights_Sum_Fields = {
  __typename?: 'reportingLearningJourneyContentInsights_sum_fields';
  averageProgress?: Maybe<Scalars['numeric']['output']>;
  completedCount?: Maybe<Scalars['bigint']['output']>;
  completionRate?: Maybe<Scalars['numeric']['output']>;
  notStartedCount?: Maybe<Scalars['bigint']['output']>;
  plannedDuration?: Maybe<Scalars['Int']['output']>;
  startedCount?: Maybe<Scalars['bigint']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type RReportingLearningJourneyContentInsights_Var_Pop_Fields = {
  __typename?: 'reportingLearningJourneyContentInsights_var_pop_fields';
  averageProgress?: Maybe<Scalars['Float']['output']>;
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RReportingLearningJourneyContentInsights_Var_Samp_Fields = {
  __typename?: 'reportingLearningJourneyContentInsights_var_samp_fields';
  averageProgress?: Maybe<Scalars['Float']['output']>;
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RReportingLearningJourneyContentInsights_Variance_Fields = {
  __typename?: 'reportingLearningJourneyContentInsights_variance_fields';
  averageProgress?: Maybe<Scalars['Float']['output']>;
  completedCount?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  notStartedCount?: Maybe<Scalars['Float']['output']>;
  plannedDuration?: Maybe<Scalars['Float']['output']>;
  startedCount?: Maybe<Scalars['Float']['output']>;
  totalEffortInSeconds?: Maybe<Scalars['Float']['output']>;
};

/** reportingLearningJourneysItemsInsightsNative Query Arguments */
export type RReportingLearningJourneysItemsInsights_Arguments = {
  learning_journey_urn: Scalars['String']['input'];
  learning_urns?: InputMaybe<Scalars['jsonb']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** reportingLearningJourneysItemsTotalCountNative Query Arguments */
export type RReportingLearningJourneysItemsTotalCount_Arguments = {
  learning_journey_urn: Scalars['String']['input'];
  learning_urns?: InputMaybe<Scalars['jsonb']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** reportingLearningJourneysItemsNative Query Arguments */
export type RReportingLearningJourneysItems_Arguments = {
  learning_journey_urn: Scalars['String']['input'];
  learning_urns?: InputMaybe<Scalars['jsonb']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** reportingLearningSummaryNative Query Arguments */
export type RReportingLearningSummary_Arguments = {
  expected_user_ids?: InputMaybe<Scalars['jsonb']['input']>;
  is_complete?: InputMaybe<Scalars['Boolean']['input']>;
  learning_urn: Scalars['String']['input'];
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  user_ids?: InputMaybe<Scalars['jsonb']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** reportingLearningsInsightsNative Query Arguments */
export type RReportingLearningsInsights_Arguments = {
  category?: InputMaybe<Scalars['String']['input']>;
  learning_urns?: InputMaybe<Scalars['jsonb']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  status: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** reportingLearningsTotalCountNative Query Arguments */
export type RReportingLearningsTotalCount_Arguments = {
  category?: InputMaybe<Scalars['String']['input']>;
  learning_urns?: InputMaybe<Scalars['jsonb']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  status: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** reportingLearningsNative Query Arguments */
export type RReportingLearnings_Arguments = {
  category?: InputMaybe<Scalars['String']['input']>;
  learning_urns?: InputMaybe<Scalars['jsonb']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  status: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** reportingMyLearningJourneyDetailsNative Query Arguments */
export type RReportingMyLearningJourneyDetails_Arguments = {
  learning_journey_urn: Scalars['String']['input'];
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** reportingMyLearningJourneysInsightsV2Native Query Arguments */
export type RReportingMyLearningJourneysInsightsV2_Arguments = {
  learning_journey_urns?: InputMaybe<Scalars['jsonb']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** reportingMyLearningJourneysLearnersTotalCountNative Query Arguments */
export type RReportingMyLearningJourneysLearnersTotalCount_Arguments = {
  is_complete?: InputMaybe<Scalars['Boolean']['input']>;
  learning_journey_urn: Scalars['String']['input'];
  search_phrase?: InputMaybe<Scalars['String']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** reportingMyLearningJourneysLearnersNative Query Arguments */
export type RReportingMyLearningJourneysLearners_Arguments = {
  is_complete?: InputMaybe<Scalars['Boolean']['input']>;
  learning_journey_urn: Scalars['String']['input'];
  search_phrase?: InputMaybe<Scalars['String']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** reportingMyLearningJourneysTotalCountNative Query Arguments */
export type RReportingMyLearningJourneysTotalCount_Arguments = {
  learning_journey_urns?: InputMaybe<Scalars['jsonb']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** reportingMyLearningJourneysV2Native Query Arguments */
export type RReportingMyLearningJourneysV2_Arguments = {
  learning_journey_urns?: InputMaybe<Scalars['jsonb']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** reportingMyLearningsLearnersTotalCountNative Query Arguments */
export type RReportingMyLearningsLearnersTotalCount_Arguments = {
  expected_user_ids?: InputMaybe<Scalars['jsonb']['input']>;
  is_complete?: InputMaybe<Scalars['Boolean']['input']>;
  learning_urn: Scalars['String']['input'];
  search_phrase?: InputMaybe<Scalars['String']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  user_ids?: InputMaybe<Scalars['jsonb']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** reportingMyLearningsLearnersNative Query Arguments */
export type RReportingMyLearningsLearners_Arguments = {
  expected_user_ids?: InputMaybe<Scalars['jsonb']['input']>;
  is_complete?: InputMaybe<Scalars['Boolean']['input']>;
  learning_urn: Scalars['String']['input'];
  search_phrase?: InputMaybe<Scalars['String']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  user_ids?: InputMaybe<Scalars['jsonb']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** reportingMyLearningsPracticalAssessmentNative Query Arguments */
export type RReportingMyLearningsPracticalAssessment_Arguments = {
  learning_urn: Scalars['String']['input'];
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** reportingMyLearningsQuizNative Query Arguments */
export type RReportingMyLearningsQuiz_Arguments = {
  learning_urn: Scalars['String']['input'];
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** reportingMyLiveLearningsLearnersTotalCountNative Query Arguments */
export type RReportingMyLiveLearningsLearnersTotalCount_Arguments = {
  learning_urn: Scalars['String']['input'];
  location_id?: InputMaybe<Scalars['Int']['input']>;
  search_phrase?: InputMaybe<Scalars['String']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  user_ids?: InputMaybe<Scalars['jsonb']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** reportingMyLiveLearningsLearnersNative Query Arguments */
export type RReportingMyLiveLearningsLearners_Arguments = {
  learning_urn: Scalars['String']['input'];
  location_id?: InputMaybe<Scalars['Int']['input']>;
  search_phrase?: InputMaybe<Scalars['String']['input']>;
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  user_ids?: InputMaybe<Scalars['jsonb']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "reporting.mv_participants_insights" */
export type RReportingParticipantsInsights = {
  __typename?: 'reportingParticipantsInsights';
  email?: Maybe<Scalars['String']['output']>;
  firstStatement?: Maybe<Scalars['timestamptz']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['float8']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  urn?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "reporting.mv_participants_insights" */
export type RReportingParticipantsInsights_Aggregate = {
  __typename?: 'reportingParticipantsInsights_aggregate';
  aggregate?: Maybe<RReportingParticipantsInsights_Aggregate_Fields>;
  nodes: Array<RReportingParticipantsInsights>;
};

/** aggregate fields of "reporting.mv_participants_insights" */
export type RReportingParticipantsInsights_Aggregate_Fields = {
  __typename?: 'reportingParticipantsInsights_aggregate_fields';
  avg?: Maybe<RReportingParticipantsInsights_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RReportingParticipantsInsights_Max_Fields>;
  min?: Maybe<RReportingParticipantsInsights_Min_Fields>;
  stddev?: Maybe<RReportingParticipantsInsights_Stddev_Fields>;
  stddev_pop?: Maybe<RReportingParticipantsInsights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RReportingParticipantsInsights_Stddev_Samp_Fields>;
  sum?: Maybe<RReportingParticipantsInsights_Sum_Fields>;
  var_pop?: Maybe<RReportingParticipantsInsights_Var_Pop_Fields>;
  var_samp?: Maybe<RReportingParticipantsInsights_Var_Samp_Fields>;
  variance?: Maybe<RReportingParticipantsInsights_Variance_Fields>;
};

/** aggregate fields of "reporting.mv_participants_insights" */
export type RReportingParticipantsInsights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RReportingParticipantsInsights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RReportingParticipantsInsights_Avg_Fields = {
  __typename?: 'reportingParticipantsInsights_avg_fields';
  progress?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "reporting.mv_participants_insights". All fields are combined with a logical 'AND'. */
export type RReportingParticipantsInsights_Bool_Exp = {
  _and?: InputMaybe<Array<RReportingParticipantsInsights_Bool_Exp>>;
  _not?: InputMaybe<RReportingParticipantsInsights_Bool_Exp>;
  _or?: InputMaybe<Array<RReportingParticipantsInsights_Bool_Exp>>;
  email?: InputMaybe<RString_Comparison_Exp>;
  firstStatement?: InputMaybe<RTimestamptz_Comparison_Exp>;
  metaUpdateTime?: InputMaybe<RTimestamptz_Comparison_Exp>;
  profileImage?: InputMaybe<RString_Comparison_Exp>;
  progress?: InputMaybe<RFloat8_Comparison_Exp>;
  status?: InputMaybe<RString_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
  userId?: InputMaybe<RInt_Comparison_Exp>;
  username?: InputMaybe<RString_Comparison_Exp>;
};

/** aggregate max on columns */
export type RReportingParticipantsInsights_Max_Fields = {
  __typename?: 'reportingParticipantsInsights_max_fields';
  email?: Maybe<Scalars['String']['output']>;
  firstStatement?: Maybe<Scalars['timestamptz']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['float8']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  urn?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type RReportingParticipantsInsights_Min_Fields = {
  __typename?: 'reportingParticipantsInsights_min_fields';
  email?: Maybe<Scalars['String']['output']>;
  firstStatement?: Maybe<Scalars['timestamptz']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['float8']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  urn?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "reporting.mv_participants_insights". */
export type RReportingParticipantsInsights_Order_By = {
  email?: InputMaybe<ROrder_By>;
  firstStatement?: InputMaybe<ROrder_By>;
  metaUpdateTime?: InputMaybe<ROrder_By>;
  profileImage?: InputMaybe<ROrder_By>;
  progress?: InputMaybe<ROrder_By>;
  status?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
  userId?: InputMaybe<ROrder_By>;
  username?: InputMaybe<ROrder_By>;
};

/** select columns of table "reporting.mv_participants_insights" */
export enum RReportingParticipantsInsights_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  FirstStatement = 'firstStatement',
  /** column name */
  MetaUpdateTime = 'metaUpdateTime',
  /** column name */
  ProfileImage = 'profileImage',
  /** column name */
  Progress = 'progress',
  /** column name */
  Status = 'status',
  /** column name */
  Urn = 'urn',
  /** column name */
  UserId = 'userId',
  /** column name */
  Username = 'username',
}

/** aggregate stddev on columns */
export type RReportingParticipantsInsights_Stddev_Fields = {
  __typename?: 'reportingParticipantsInsights_stddev_fields';
  progress?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RReportingParticipantsInsights_Stddev_Pop_Fields = {
  __typename?: 'reportingParticipantsInsights_stddev_pop_fields';
  progress?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RReportingParticipantsInsights_Stddev_Samp_Fields = {
  __typename?: 'reportingParticipantsInsights_stddev_samp_fields';
  progress?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportingParticipantsInsights" */
export type RReportingParticipantsInsights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RReportingParticipantsInsights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<RCursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RReportingParticipantsInsights_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstStatement?: InputMaybe<Scalars['timestamptz']['input']>;
  metaUpdateTime?: InputMaybe<Scalars['timestamptz']['input']>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['float8']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  urn?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type RReportingParticipantsInsights_Sum_Fields = {
  __typename?: 'reportingParticipantsInsights_sum_fields';
  progress?: Maybe<Scalars['float8']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type RReportingParticipantsInsights_Var_Pop_Fields = {
  __typename?: 'reportingParticipantsInsights_var_pop_fields';
  progress?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RReportingParticipantsInsights_Var_Samp_Fields = {
  __typename?: 'reportingParticipantsInsights_var_samp_fields';
  progress?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RReportingParticipantsInsights_Variance_Fields = {
  __typename?: 'reportingParticipantsInsights_variance_fields';
  progress?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "reporting.mv_practical_assessment_insights" */
export type RReportingPracticalAssessmentInsights = {
  __typename?: 'reportingPracticalAssessmentInsights';
  learningContentURN?: Maybe<Scalars['String']['output']>;
  learningJourneyURN?: Maybe<Scalars['String']['output']>;
  learning_content_title?: Maybe<Scalars['String']['output']>;
  learning_journey_title?: Maybe<Scalars['String']['output']>;
  meta_update_time?: Maybe<Scalars['timestamptz']['output']>;
  pageId?: Maybe<Scalars['Int']['output']>;
  pageURN?: Maybe<Scalars['String']['output']>;
  responsesCount?: Maybe<Scalars['bigint']['output']>;
  reviewsCount?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "reporting.mv_practical_assessment_insights" */
export type RReportingPracticalAssessmentInsights_Aggregate = {
  __typename?: 'reportingPracticalAssessmentInsights_aggregate';
  aggregate?: Maybe<RReportingPracticalAssessmentInsights_Aggregate_Fields>;
  nodes: Array<RReportingPracticalAssessmentInsights>;
};

/** aggregate fields of "reporting.mv_practical_assessment_insights" */
export type RReportingPracticalAssessmentInsights_Aggregate_Fields = {
  __typename?: 'reportingPracticalAssessmentInsights_aggregate_fields';
  avg?: Maybe<RReportingPracticalAssessmentInsights_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RReportingPracticalAssessmentInsights_Max_Fields>;
  min?: Maybe<RReportingPracticalAssessmentInsights_Min_Fields>;
  stddev?: Maybe<RReportingPracticalAssessmentInsights_Stddev_Fields>;
  stddev_pop?: Maybe<RReportingPracticalAssessmentInsights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RReportingPracticalAssessmentInsights_Stddev_Samp_Fields>;
  sum?: Maybe<RReportingPracticalAssessmentInsights_Sum_Fields>;
  var_pop?: Maybe<RReportingPracticalAssessmentInsights_Var_Pop_Fields>;
  var_samp?: Maybe<RReportingPracticalAssessmentInsights_Var_Samp_Fields>;
  variance?: Maybe<RReportingPracticalAssessmentInsights_Variance_Fields>;
};

/** aggregate fields of "reporting.mv_practical_assessment_insights" */
export type RReportingPracticalAssessmentInsights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RReportingPracticalAssessmentInsights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RReportingPracticalAssessmentInsights_Avg_Fields = {
  __typename?: 'reportingPracticalAssessmentInsights_avg_fields';
  pageId?: Maybe<Scalars['Float']['output']>;
  responsesCount?: Maybe<Scalars['Float']['output']>;
  reviewsCount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "reporting.mv_practical_assessment_insights". All fields are combined with a logical 'AND'. */
export type RReportingPracticalAssessmentInsights_Bool_Exp = {
  _and?: InputMaybe<Array<RReportingPracticalAssessmentInsights_Bool_Exp>>;
  _not?: InputMaybe<RReportingPracticalAssessmentInsights_Bool_Exp>;
  _or?: InputMaybe<Array<RReportingPracticalAssessmentInsights_Bool_Exp>>;
  learningContentURN?: InputMaybe<RString_Comparison_Exp>;
  learningJourneyURN?: InputMaybe<RString_Comparison_Exp>;
  learning_content_title?: InputMaybe<RString_Comparison_Exp>;
  learning_journey_title?: InputMaybe<RString_Comparison_Exp>;
  meta_update_time?: InputMaybe<RTimestamptz_Comparison_Exp>;
  pageId?: InputMaybe<RInt_Comparison_Exp>;
  pageURN?: InputMaybe<RString_Comparison_Exp>;
  responsesCount?: InputMaybe<RBigint_Comparison_Exp>;
  reviewsCount?: InputMaybe<RBigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type RReportingPracticalAssessmentInsights_Max_Fields = {
  __typename?: 'reportingPracticalAssessmentInsights_max_fields';
  learningContentURN?: Maybe<Scalars['String']['output']>;
  learningJourneyURN?: Maybe<Scalars['String']['output']>;
  learning_content_title?: Maybe<Scalars['String']['output']>;
  learning_journey_title?: Maybe<Scalars['String']['output']>;
  meta_update_time?: Maybe<Scalars['timestamptz']['output']>;
  pageId?: Maybe<Scalars['Int']['output']>;
  pageURN?: Maybe<Scalars['String']['output']>;
  responsesCount?: Maybe<Scalars['bigint']['output']>;
  reviewsCount?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type RReportingPracticalAssessmentInsights_Min_Fields = {
  __typename?: 'reportingPracticalAssessmentInsights_min_fields';
  learningContentURN?: Maybe<Scalars['String']['output']>;
  learningJourneyURN?: Maybe<Scalars['String']['output']>;
  learning_content_title?: Maybe<Scalars['String']['output']>;
  learning_journey_title?: Maybe<Scalars['String']['output']>;
  meta_update_time?: Maybe<Scalars['timestamptz']['output']>;
  pageId?: Maybe<Scalars['Int']['output']>;
  pageURN?: Maybe<Scalars['String']['output']>;
  responsesCount?: Maybe<Scalars['bigint']['output']>;
  reviewsCount?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "reporting.mv_practical_assessment_insights". */
export type RReportingPracticalAssessmentInsights_Order_By = {
  learningContentURN?: InputMaybe<ROrder_By>;
  learningJourneyURN?: InputMaybe<ROrder_By>;
  learning_content_title?: InputMaybe<ROrder_By>;
  learning_journey_title?: InputMaybe<ROrder_By>;
  meta_update_time?: InputMaybe<ROrder_By>;
  pageId?: InputMaybe<ROrder_By>;
  pageURN?: InputMaybe<ROrder_By>;
  responsesCount?: InputMaybe<ROrder_By>;
  reviewsCount?: InputMaybe<ROrder_By>;
};

/** select columns of table "reporting.mv_practical_assessment_insights" */
export enum RReportingPracticalAssessmentInsights_Select_Column {
  /** column name */
  LearningContentUrn = 'learningContentURN',
  /** column name */
  LearningJourneyUrn = 'learningJourneyURN',
  /** column name */
  LearningContentTitle = 'learning_content_title',
  /** column name */
  LearningJourneyTitle = 'learning_journey_title',
  /** column name */
  MetaUpdateTime = 'meta_update_time',
  /** column name */
  PageId = 'pageId',
  /** column name */
  PageUrn = 'pageURN',
  /** column name */
  ResponsesCount = 'responsesCount',
  /** column name */
  ReviewsCount = 'reviewsCount',
}

/** aggregate stddev on columns */
export type RReportingPracticalAssessmentInsights_Stddev_Fields = {
  __typename?: 'reportingPracticalAssessmentInsights_stddev_fields';
  pageId?: Maybe<Scalars['Float']['output']>;
  responsesCount?: Maybe<Scalars['Float']['output']>;
  reviewsCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RReportingPracticalAssessmentInsights_Stddev_Pop_Fields = {
  __typename?: 'reportingPracticalAssessmentInsights_stddev_pop_fields';
  pageId?: Maybe<Scalars['Float']['output']>;
  responsesCount?: Maybe<Scalars['Float']['output']>;
  reviewsCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RReportingPracticalAssessmentInsights_Stddev_Samp_Fields = {
  __typename?: 'reportingPracticalAssessmentInsights_stddev_samp_fields';
  pageId?: Maybe<Scalars['Float']['output']>;
  responsesCount?: Maybe<Scalars['Float']['output']>;
  reviewsCount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportingPracticalAssessmentInsights" */
export type RReportingPracticalAssessmentInsights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RReportingPracticalAssessmentInsights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<RCursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RReportingPracticalAssessmentInsights_Stream_Cursor_Value_Input = {
  learningContentURN?: InputMaybe<Scalars['String']['input']>;
  learningJourneyURN?: InputMaybe<Scalars['String']['input']>;
  learning_content_title?: InputMaybe<Scalars['String']['input']>;
  learning_journey_title?: InputMaybe<Scalars['String']['input']>;
  meta_update_time?: InputMaybe<Scalars['timestamptz']['input']>;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  pageURN?: InputMaybe<Scalars['String']['input']>;
  responsesCount?: InputMaybe<Scalars['bigint']['input']>;
  reviewsCount?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type RReportingPracticalAssessmentInsights_Sum_Fields = {
  __typename?: 'reportingPracticalAssessmentInsights_sum_fields';
  pageId?: Maybe<Scalars['Int']['output']>;
  responsesCount?: Maybe<Scalars['bigint']['output']>;
  reviewsCount?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type RReportingPracticalAssessmentInsights_Var_Pop_Fields = {
  __typename?: 'reportingPracticalAssessmentInsights_var_pop_fields';
  pageId?: Maybe<Scalars['Float']['output']>;
  responsesCount?: Maybe<Scalars['Float']['output']>;
  reviewsCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RReportingPracticalAssessmentInsights_Var_Samp_Fields = {
  __typename?: 'reportingPracticalAssessmentInsights_var_samp_fields';
  pageId?: Maybe<Scalars['Float']['output']>;
  responsesCount?: Maybe<Scalars['Float']['output']>;
  reviewsCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RReportingPracticalAssessmentInsights_Variance_Fields = {
  __typename?: 'reportingPracticalAssessmentInsights_variance_fields';
  pageId?: Maybe<Scalars['Float']['output']>;
  responsesCount?: Maybe<Scalars['Float']['output']>;
  reviewsCount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "reporting.mv_quiz_questions_insights" */
export type RReportingQuizQuestionsInsights = {
  __typename?: 'reportingQuizQuestionsInsights';
  activityUrn?: Maybe<Scalars['String']['output']>;
  correctAnswers?: Maybe<Scalars['bigint']['output']>;
  incorrectAnswers?: Maybe<Scalars['bigint']['output']>;
  learningUrn?: Maybe<Scalars['String']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  questionId?: Maybe<Scalars['String']['output']>;
  questionIdx?: Maybe<Scalars['String']['output']>;
  questionTitle?: Maybe<Scalars['String']['output']>;
  quizId?: Maybe<Scalars['Int']['output']>;
  ratio?: Maybe<Scalars['numeric']['output']>;
  totalAnswers?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "reporting.mv_quiz_questions_insights" */
export type RReportingQuizQuestionsInsights_Aggregate = {
  __typename?: 'reportingQuizQuestionsInsights_aggregate';
  aggregate?: Maybe<RReportingQuizQuestionsInsights_Aggregate_Fields>;
  nodes: Array<RReportingQuizQuestionsInsights>;
};

/** aggregate fields of "reporting.mv_quiz_questions_insights" */
export type RReportingQuizQuestionsInsights_Aggregate_Fields = {
  __typename?: 'reportingQuizQuestionsInsights_aggregate_fields';
  avg?: Maybe<RReportingQuizQuestionsInsights_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RReportingQuizQuestionsInsights_Max_Fields>;
  min?: Maybe<RReportingQuizQuestionsInsights_Min_Fields>;
  stddev?: Maybe<RReportingQuizQuestionsInsights_Stddev_Fields>;
  stddev_pop?: Maybe<RReportingQuizQuestionsInsights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RReportingQuizQuestionsInsights_Stddev_Samp_Fields>;
  sum?: Maybe<RReportingQuizQuestionsInsights_Sum_Fields>;
  var_pop?: Maybe<RReportingQuizQuestionsInsights_Var_Pop_Fields>;
  var_samp?: Maybe<RReportingQuizQuestionsInsights_Var_Samp_Fields>;
  variance?: Maybe<RReportingQuizQuestionsInsights_Variance_Fields>;
};

/** aggregate fields of "reporting.mv_quiz_questions_insights" */
export type RReportingQuizQuestionsInsights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RReportingQuizQuestionsInsights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RReportingQuizQuestionsInsights_Avg_Fields = {
  __typename?: 'reportingQuizQuestionsInsights_avg_fields';
  correctAnswers?: Maybe<Scalars['Float']['output']>;
  incorrectAnswers?: Maybe<Scalars['Float']['output']>;
  quizId?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  totalAnswers?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "reporting.mv_quiz_questions_insights". All fields are combined with a logical 'AND'. */
export type RReportingQuizQuestionsInsights_Bool_Exp = {
  _and?: InputMaybe<Array<RReportingQuizQuestionsInsights_Bool_Exp>>;
  _not?: InputMaybe<RReportingQuizQuestionsInsights_Bool_Exp>;
  _or?: InputMaybe<Array<RReportingQuizQuestionsInsights_Bool_Exp>>;
  activityUrn?: InputMaybe<RString_Comparison_Exp>;
  correctAnswers?: InputMaybe<RBigint_Comparison_Exp>;
  incorrectAnswers?: InputMaybe<RBigint_Comparison_Exp>;
  learningUrn?: InputMaybe<RString_Comparison_Exp>;
  metaUpdateTime?: InputMaybe<RTimestamptz_Comparison_Exp>;
  questionId?: InputMaybe<RString_Comparison_Exp>;
  questionIdx?: InputMaybe<RString_Comparison_Exp>;
  questionTitle?: InputMaybe<RString_Comparison_Exp>;
  quizId?: InputMaybe<RInt_Comparison_Exp>;
  ratio?: InputMaybe<RNumeric_Comparison_Exp>;
  totalAnswers?: InputMaybe<RBigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type RReportingQuizQuestionsInsights_Max_Fields = {
  __typename?: 'reportingQuizQuestionsInsights_max_fields';
  activityUrn?: Maybe<Scalars['String']['output']>;
  correctAnswers?: Maybe<Scalars['bigint']['output']>;
  incorrectAnswers?: Maybe<Scalars['bigint']['output']>;
  learningUrn?: Maybe<Scalars['String']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  questionId?: Maybe<Scalars['String']['output']>;
  questionIdx?: Maybe<Scalars['String']['output']>;
  questionTitle?: Maybe<Scalars['String']['output']>;
  quizId?: Maybe<Scalars['Int']['output']>;
  ratio?: Maybe<Scalars['numeric']['output']>;
  totalAnswers?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type RReportingQuizQuestionsInsights_Min_Fields = {
  __typename?: 'reportingQuizQuestionsInsights_min_fields';
  activityUrn?: Maybe<Scalars['String']['output']>;
  correctAnswers?: Maybe<Scalars['bigint']['output']>;
  incorrectAnswers?: Maybe<Scalars['bigint']['output']>;
  learningUrn?: Maybe<Scalars['String']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  questionId?: Maybe<Scalars['String']['output']>;
  questionIdx?: Maybe<Scalars['String']['output']>;
  questionTitle?: Maybe<Scalars['String']['output']>;
  quizId?: Maybe<Scalars['Int']['output']>;
  ratio?: Maybe<Scalars['numeric']['output']>;
  totalAnswers?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "reporting.mv_quiz_questions_insights". */
export type RReportingQuizQuestionsInsights_Order_By = {
  activityUrn?: InputMaybe<ROrder_By>;
  correctAnswers?: InputMaybe<ROrder_By>;
  incorrectAnswers?: InputMaybe<ROrder_By>;
  learningUrn?: InputMaybe<ROrder_By>;
  metaUpdateTime?: InputMaybe<ROrder_By>;
  questionId?: InputMaybe<ROrder_By>;
  questionIdx?: InputMaybe<ROrder_By>;
  questionTitle?: InputMaybe<ROrder_By>;
  quizId?: InputMaybe<ROrder_By>;
  ratio?: InputMaybe<ROrder_By>;
  totalAnswers?: InputMaybe<ROrder_By>;
};

/** select columns of table "reporting.mv_quiz_questions_insights" */
export enum RReportingQuizQuestionsInsights_Select_Column {
  /** column name */
  ActivityUrn = 'activityUrn',
  /** column name */
  CorrectAnswers = 'correctAnswers',
  /** column name */
  IncorrectAnswers = 'incorrectAnswers',
  /** column name */
  LearningUrn = 'learningUrn',
  /** column name */
  MetaUpdateTime = 'metaUpdateTime',
  /** column name */
  QuestionId = 'questionId',
  /** column name */
  QuestionIdx = 'questionIdx',
  /** column name */
  QuestionTitle = 'questionTitle',
  /** column name */
  QuizId = 'quizId',
  /** column name */
  Ratio = 'ratio',
  /** column name */
  TotalAnswers = 'totalAnswers',
}

/** aggregate stddev on columns */
export type RReportingQuizQuestionsInsights_Stddev_Fields = {
  __typename?: 'reportingQuizQuestionsInsights_stddev_fields';
  correctAnswers?: Maybe<Scalars['Float']['output']>;
  incorrectAnswers?: Maybe<Scalars['Float']['output']>;
  quizId?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  totalAnswers?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RReportingQuizQuestionsInsights_Stddev_Pop_Fields = {
  __typename?: 'reportingQuizQuestionsInsights_stddev_pop_fields';
  correctAnswers?: Maybe<Scalars['Float']['output']>;
  incorrectAnswers?: Maybe<Scalars['Float']['output']>;
  quizId?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  totalAnswers?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RReportingQuizQuestionsInsights_Stddev_Samp_Fields = {
  __typename?: 'reportingQuizQuestionsInsights_stddev_samp_fields';
  correctAnswers?: Maybe<Scalars['Float']['output']>;
  incorrectAnswers?: Maybe<Scalars['Float']['output']>;
  quizId?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  totalAnswers?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportingQuizQuestionsInsights" */
export type RReportingQuizQuestionsInsights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RReportingQuizQuestionsInsights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<RCursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RReportingQuizQuestionsInsights_Stream_Cursor_Value_Input = {
  activityUrn?: InputMaybe<Scalars['String']['input']>;
  correctAnswers?: InputMaybe<Scalars['bigint']['input']>;
  incorrectAnswers?: InputMaybe<Scalars['bigint']['input']>;
  learningUrn?: InputMaybe<Scalars['String']['input']>;
  metaUpdateTime?: InputMaybe<Scalars['timestamptz']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  questionIdx?: InputMaybe<Scalars['String']['input']>;
  questionTitle?: InputMaybe<Scalars['String']['input']>;
  quizId?: InputMaybe<Scalars['Int']['input']>;
  ratio?: InputMaybe<Scalars['numeric']['input']>;
  totalAnswers?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type RReportingQuizQuestionsInsights_Sum_Fields = {
  __typename?: 'reportingQuizQuestionsInsights_sum_fields';
  correctAnswers?: Maybe<Scalars['bigint']['output']>;
  incorrectAnswers?: Maybe<Scalars['bigint']['output']>;
  quizId?: Maybe<Scalars['Int']['output']>;
  ratio?: Maybe<Scalars['numeric']['output']>;
  totalAnswers?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type RReportingQuizQuestionsInsights_Var_Pop_Fields = {
  __typename?: 'reportingQuizQuestionsInsights_var_pop_fields';
  correctAnswers?: Maybe<Scalars['Float']['output']>;
  incorrectAnswers?: Maybe<Scalars['Float']['output']>;
  quizId?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  totalAnswers?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RReportingQuizQuestionsInsights_Var_Samp_Fields = {
  __typename?: 'reportingQuizQuestionsInsights_var_samp_fields';
  correctAnswers?: Maybe<Scalars['Float']['output']>;
  incorrectAnswers?: Maybe<Scalars['Float']['output']>;
  quizId?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  totalAnswers?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RReportingQuizQuestionsInsights_Variance_Fields = {
  __typename?: 'reportingQuizQuestionsInsights_variance_fields';
  correctAnswers?: Maybe<Scalars['Float']['output']>;
  incorrectAnswers?: Maybe<Scalars['Float']['output']>;
  quizId?: Maybe<Scalars['Float']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  totalAnswers?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "reporting.mv_quiz_summary_insights" */
export type RReportingQuizSummaryInsights = {
  __typename?: 'reportingQuizSummaryInsights';
  activityUrn?: Maybe<Scalars['String']['output']>;
  avgRatio?: Maybe<Scalars['numeric']['output']>;
  learningUrn?: Maybe<Scalars['String']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  totalParticipants?: Maybe<Scalars['bigint']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  totalResponses?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "reporting.mv_quiz_summary_insights" */
export type RReportingQuizSummaryInsights_Aggregate = {
  __typename?: 'reportingQuizSummaryInsights_aggregate';
  aggregate?: Maybe<RReportingQuizSummaryInsights_Aggregate_Fields>;
  nodes: Array<RReportingQuizSummaryInsights>;
};

/** aggregate fields of "reporting.mv_quiz_summary_insights" */
export type RReportingQuizSummaryInsights_Aggregate_Fields = {
  __typename?: 'reportingQuizSummaryInsights_aggregate_fields';
  avg?: Maybe<RReportingQuizSummaryInsights_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RReportingQuizSummaryInsights_Max_Fields>;
  min?: Maybe<RReportingQuizSummaryInsights_Min_Fields>;
  stddev?: Maybe<RReportingQuizSummaryInsights_Stddev_Fields>;
  stddev_pop?: Maybe<RReportingQuizSummaryInsights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RReportingQuizSummaryInsights_Stddev_Samp_Fields>;
  sum?: Maybe<RReportingQuizSummaryInsights_Sum_Fields>;
  var_pop?: Maybe<RReportingQuizSummaryInsights_Var_Pop_Fields>;
  var_samp?: Maybe<RReportingQuizSummaryInsights_Var_Samp_Fields>;
  variance?: Maybe<RReportingQuizSummaryInsights_Variance_Fields>;
};

/** aggregate fields of "reporting.mv_quiz_summary_insights" */
export type RReportingQuizSummaryInsights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RReportingQuizSummaryInsights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RReportingQuizSummaryInsights_Avg_Fields = {
  __typename?: 'reportingQuizSummaryInsights_avg_fields';
  avgRatio?: Maybe<Scalars['Float']['output']>;
  totalParticipants?: Maybe<Scalars['Float']['output']>;
  totalQuestions?: Maybe<Scalars['Float']['output']>;
  totalResponses?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "reporting.mv_quiz_summary_insights". All fields are combined with a logical 'AND'. */
export type RReportingQuizSummaryInsights_Bool_Exp = {
  _and?: InputMaybe<Array<RReportingQuizSummaryInsights_Bool_Exp>>;
  _not?: InputMaybe<RReportingQuizSummaryInsights_Bool_Exp>;
  _or?: InputMaybe<Array<RReportingQuizSummaryInsights_Bool_Exp>>;
  activityUrn?: InputMaybe<RString_Comparison_Exp>;
  avgRatio?: InputMaybe<RNumeric_Comparison_Exp>;
  learningUrn?: InputMaybe<RString_Comparison_Exp>;
  metaUpdateTime?: InputMaybe<RTimestamptz_Comparison_Exp>;
  totalParticipants?: InputMaybe<RBigint_Comparison_Exp>;
  totalQuestions?: InputMaybe<RInt_Comparison_Exp>;
  totalResponses?: InputMaybe<RBigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type RReportingQuizSummaryInsights_Max_Fields = {
  __typename?: 'reportingQuizSummaryInsights_max_fields';
  activityUrn?: Maybe<Scalars['String']['output']>;
  avgRatio?: Maybe<Scalars['numeric']['output']>;
  learningUrn?: Maybe<Scalars['String']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  totalParticipants?: Maybe<Scalars['bigint']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  totalResponses?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type RReportingQuizSummaryInsights_Min_Fields = {
  __typename?: 'reportingQuizSummaryInsights_min_fields';
  activityUrn?: Maybe<Scalars['String']['output']>;
  avgRatio?: Maybe<Scalars['numeric']['output']>;
  learningUrn?: Maybe<Scalars['String']['output']>;
  metaUpdateTime?: Maybe<Scalars['timestamptz']['output']>;
  totalParticipants?: Maybe<Scalars['bigint']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  totalResponses?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "reporting.mv_quiz_summary_insights". */
export type RReportingQuizSummaryInsights_Order_By = {
  activityUrn?: InputMaybe<ROrder_By>;
  avgRatio?: InputMaybe<ROrder_By>;
  learningUrn?: InputMaybe<ROrder_By>;
  metaUpdateTime?: InputMaybe<ROrder_By>;
  totalParticipants?: InputMaybe<ROrder_By>;
  totalQuestions?: InputMaybe<ROrder_By>;
  totalResponses?: InputMaybe<ROrder_By>;
};

/** select columns of table "reporting.mv_quiz_summary_insights" */
export enum RReportingQuizSummaryInsights_Select_Column {
  /** column name */
  ActivityUrn = 'activityUrn',
  /** column name */
  AvgRatio = 'avgRatio',
  /** column name */
  LearningUrn = 'learningUrn',
  /** column name */
  MetaUpdateTime = 'metaUpdateTime',
  /** column name */
  TotalParticipants = 'totalParticipants',
  /** column name */
  TotalQuestions = 'totalQuestions',
  /** column name */
  TotalResponses = 'totalResponses',
}

/** aggregate stddev on columns */
export type RReportingQuizSummaryInsights_Stddev_Fields = {
  __typename?: 'reportingQuizSummaryInsights_stddev_fields';
  avgRatio?: Maybe<Scalars['Float']['output']>;
  totalParticipants?: Maybe<Scalars['Float']['output']>;
  totalQuestions?: Maybe<Scalars['Float']['output']>;
  totalResponses?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RReportingQuizSummaryInsights_Stddev_Pop_Fields = {
  __typename?: 'reportingQuizSummaryInsights_stddev_pop_fields';
  avgRatio?: Maybe<Scalars['Float']['output']>;
  totalParticipants?: Maybe<Scalars['Float']['output']>;
  totalQuestions?: Maybe<Scalars['Float']['output']>;
  totalResponses?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RReportingQuizSummaryInsights_Stddev_Samp_Fields = {
  __typename?: 'reportingQuizSummaryInsights_stddev_samp_fields';
  avgRatio?: Maybe<Scalars['Float']['output']>;
  totalParticipants?: Maybe<Scalars['Float']['output']>;
  totalQuestions?: Maybe<Scalars['Float']['output']>;
  totalResponses?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "reportingQuizSummaryInsights" */
export type RReportingQuizSummaryInsights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RReportingQuizSummaryInsights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<RCursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RReportingQuizSummaryInsights_Stream_Cursor_Value_Input = {
  activityUrn?: InputMaybe<Scalars['String']['input']>;
  avgRatio?: InputMaybe<Scalars['numeric']['input']>;
  learningUrn?: InputMaybe<Scalars['String']['input']>;
  metaUpdateTime?: InputMaybe<Scalars['timestamptz']['input']>;
  totalParticipants?: InputMaybe<Scalars['bigint']['input']>;
  totalQuestions?: InputMaybe<Scalars['Int']['input']>;
  totalResponses?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type RReportingQuizSummaryInsights_Sum_Fields = {
  __typename?: 'reportingQuizSummaryInsights_sum_fields';
  avgRatio?: Maybe<Scalars['numeric']['output']>;
  totalParticipants?: Maybe<Scalars['bigint']['output']>;
  totalQuestions?: Maybe<Scalars['Int']['output']>;
  totalResponses?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type RReportingQuizSummaryInsights_Var_Pop_Fields = {
  __typename?: 'reportingQuizSummaryInsights_var_pop_fields';
  avgRatio?: Maybe<Scalars['Float']['output']>;
  totalParticipants?: Maybe<Scalars['Float']['output']>;
  totalQuestions?: Maybe<Scalars['Float']['output']>;
  totalResponses?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RReportingQuizSummaryInsights_Var_Samp_Fields = {
  __typename?: 'reportingQuizSummaryInsights_var_samp_fields';
  avgRatio?: Maybe<Scalars['Float']['output']>;
  totalParticipants?: Maybe<Scalars['Float']['output']>;
  totalQuestions?: Maybe<Scalars['Float']['output']>;
  totalResponses?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RReportingQuizSummaryInsights_Variance_Fields = {
  __typename?: 'reportingQuizSummaryInsights_variance_fields';
  avgRatio?: Maybe<Scalars['Float']['output']>;
  totalParticipants?: Maybe<Scalars['Float']['output']>;
  totalQuestions?: Maybe<Scalars['Float']['output']>;
  totalResponses?: Maybe<Scalars['Float']['output']>;
};

/** reportingSectionsItemsInsightsNative Query Arguments */
export type RReportingSectionsItemsInsights_Arguments = {
  learning_urns?: InputMaybe<Scalars['jsonb']['input']>;
  section_urn: Scalars['String']['input'];
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** reportingSectionsItemsTotalCountNative Query Arguments */
export type RReportingSectionsItemsTotalCount_Arguments = {
  learning_urns?: InputMaybe<Scalars['jsonb']['input']>;
  section_urn: Scalars['String']['input'];
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** reportingSectionsItemsNative Query Arguments */
export type RReportingSectionsItems_Arguments = {
  learning_urns?: InputMaybe<Scalars['jsonb']['input']>;
  section_urn: Scalars['String']['input'];
  space_id?: InputMaybe<Scalars['Int']['input']>;
  space_ids?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  team_ids?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type RSections_Items = {
  __typename?: 'sections_items';
  item_order: Scalars['Int']['output'];
  partner: Scalars['String']['output'];
  planned_duration: Scalars['Int']['output'];
  space_id: Scalars['Int']['output'];
  team_ids: Scalars['jsonb']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

export type RSections_ItemsTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "sections_items". All fields are combined with a logical 'AND'. */
export type RSections_Items_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RSections_Items_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RSections_Items_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RSections_Items_Bool_Exp_Bool_Exp>>;
  item_order?: InputMaybe<RInt_Comparison_Exp>;
  partner?: InputMaybe<RString_Comparison_Exp>;
  planned_duration?: InputMaybe<RInt_Comparison_Exp>;
  space_id?: InputMaybe<RInt_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  title?: InputMaybe<RString_Comparison_Exp>;
  type?: InputMaybe<RString_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
};

export enum RSections_Items_Enum_Name {
  /** column name */
  ItemOrder = 'item_order',
  /** column name */
  Partner = 'partner',
  /** column name */
  PlannedDuration = 'planned_duration',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Urn = 'urn',
}

export type RSections_Items_Insights = {
  __typename?: 'sections_items_insights';
  completed_count: Scalars['bigint']['output'];
  completion_rate: Scalars['numeric']['output'];
  in_progress_count: Scalars['bigint']['output'];
  not_started_count: Scalars['bigint']['output'];
  space_id: Scalars['Int']['output'];
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  urn: Scalars['String']['output'];
};

export type RSections_Items_InsightsTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "sections_items_insights". All fields are combined with a logical 'AND'. */
export type RSections_Items_Insights_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RSections_Items_Insights_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RSections_Items_Insights_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RSections_Items_Insights_Bool_Exp_Bool_Exp>>;
  completed_count?: InputMaybe<RBigint_Comparison_Exp>;
  completion_rate?: InputMaybe<RNumeric_Comparison_Exp>;
  in_progress_count?: InputMaybe<RBigint_Comparison_Exp>;
  not_started_count?: InputMaybe<RBigint_Comparison_Exp>;
  space_id?: InputMaybe<RInt_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  urn?: InputMaybe<RString_Comparison_Exp>;
};

export enum RSections_Items_Insights_Enum_Name {
  /** column name */
  CompletedCount = 'completed_count',
  /** column name */
  CompletionRate = 'completion_rate',
  /** column name */
  InProgressCount = 'in_progress_count',
  /** column name */
  NotStartedCount = 'not_started_count',
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  Urn = 'urn',
}

/** Ordering options when selecting data from "sections_items_insights". */
export type RSections_Items_Insights_Order_By = {
  completed_count?: InputMaybe<ROrder_By>;
  completion_rate?: InputMaybe<ROrder_By>;
  in_progress_count?: InputMaybe<ROrder_By>;
  not_started_count?: InputMaybe<ROrder_By>;
  space_id?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
};

/** Ordering options when selecting data from "sections_items". */
export type RSections_Items_Order_By = {
  item_order?: InputMaybe<ROrder_By>;
  partner?: InputMaybe<ROrder_By>;
  planned_duration?: InputMaybe<ROrder_By>;
  space_id?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  title?: InputMaybe<ROrder_By>;
  type?: InputMaybe<ROrder_By>;
  urn?: InputMaybe<ROrder_By>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type RTimestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

export type RTotal_Count = {
  __typename?: 'total_count';
  space_id: Scalars['Int']['output'];
  space_ids: Scalars['jsonb']['output'];
  team_ids?: Maybe<Scalars['jsonb']['output']>;
  total_count: Scalars['bigint']['output'];
};

export type RTotal_CountSpace_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type RTotal_CountTeam_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "total_count". All fields are combined with a logical 'AND'. */
export type RTotal_Count_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<RTotal_Count_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<RTotal_Count_Bool_Exp_Bool_Exp>>;
  space_id?: InputMaybe<RInt_Comparison_Exp>;
  space_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  team_ids?: InputMaybe<RJsonb_Comparison_Exp>;
  total_count?: InputMaybe<RBigint_Comparison_Exp>;
};

export enum RTotal_Count_Enum_Name {
  /** column name */
  SpaceId = 'space_id',
  /** column name */
  SpaceIds = 'space_ids',
  /** column name */
  TeamIds = 'team_ids',
  /** column name */
  TotalCount = 'total_count',
}

/** Ordering options when selecting data from "total_count". */
export type RTotal_Count_Order_By = {
  space_id?: InputMaybe<ROrder_By>;
  space_ids?: InputMaybe<ROrder_By>;
  team_ids?: InputMaybe<ROrder_By>;
  total_count?: InputMaybe<ROrder_By>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type RUuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type RGetCompletionRatePerCourseQueryVariables = Exact<{
  usersPool: RUsersPool;
}>;

export type RGetCompletionRatePerCourseQuery = {
  __typename?: 'Query';
  completionRatePerCourse?:
    | Array<{
        __typename?: 'CompletionRatePerCourse';
        completed?: number | undefined;
        progressed?: number | undefined;
        completion_rate?: number | undefined;
        object_id?: string | undefined;
        object_type?: string | undefined;
        object_name?: string | undefined;
      }>
    | undefined;
};

export type RGetDashboardDataQueryVariables = Exact<{
  usersPool: RUsersPool;
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type RGetDashboardDataQuery = {
  __typename?: 'Query';
  completionsOverTime?: Array<{ __typename?: 'DataItem'; name: string; value: number } | undefined> | undefined;
  userEffort?:
    | {
        __typename?: 'UserEffortOverTime';
        in_progress?: number | undefined;
        completed?: number | undefined;
        expired?: number | undefined;
        completed_not_expired?: number | undefined;
        total_effort_in_seconds?: number | undefined;
        distinct_users?: number | undefined;
        distinct_completed?: number | undefined;
        distinct_completed_not_expired?: number | undefined;
        average_effort_per_user_in_seconds?: number | undefined;
      }
    | undefined;
  effortForRealmOverTime?:
    | Array<{ __typename?: 'EffortForRealmOverTime'; name: string; value?: number | undefined } | undefined>
    | undefined;
};

export type RIsLearningPathCompletedQueryVariables = Exact<{
  learningPathId: Scalars['Int']['input'];
}>;

export type RIsLearningPathCompletedQuery = { __typename?: 'Query'; isLearningPathCompleted?: boolean | undefined };

export type RCompleteLearningPathMutationVariables = Exact<{
  learningPathId: Scalars['Int']['input'];
}>;

export type RCompleteLearningPathMutation = { __typename?: 'Mutation'; completeLearningPath?: boolean | undefined };

export type RCompleteLearningMutationVariables = Exact<{
  learningId: Scalars['Int']['input'];
}>;

export type RCompleteLearningMutation = { __typename?: 'Mutation'; completeLearning: boolean };

export type RGetUserEffortQueryVariables = Exact<{
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
}>;

export type RGetUserEffortQuery = { __typename?: 'Query'; getUserEffort: { __typename?: 'UserEffort'; total: number } };

export type RLearningProgressFragment = {
  __typename?: 'Learning';
  progress?: { __typename: 'LearningProgress'; expiredAt?: string | undefined } | undefined;
};

export type RLearningProgressCacheWriteFragment = {
  __typename?: 'Learning';
  progress?:
    | {
        __typename?: 'LearningProgress';
        completed?: boolean | undefined;
        completedPercentage?: number | undefined;
        historical?: boolean | undefined;
        expiredAt?: string | undefined;
      }
    | undefined;
};

export type RGetParticipationsQueryVariables = Exact<{
  input: RParticipationsInput;
}>;

export type RGetParticipationsQuery = {
  __typename?: 'Query';
  participations: Array<{
    __typename?: 'ParticipationGroup';
    id: number;
    userId: number;
    objectId: string;
    catalogObjectId: string;
    registration: string;
    progress: number;
    isCompleted: boolean;
    userEffort?: number | undefined;
    completedAt?: string | undefined;
    expiredAt?: string | undefined;
    platform: string;
    objectName?: string | undefined;
    objectType?: string | undefined;
    plannedDuration?: number | undefined;
    firstStatement: string;
    lastStatement: string;
    firstActivity?: string | undefined;
    lastActivity?: string | undefined;
    previousParticipations?:
      | Array<{
          __typename?: 'Participation';
          id: number;
          userId: number;
          objectId: string;
          catalogObjectId: string;
          registration: string;
          progress: number;
          isCompleted: boolean;
          userEffort?: number | undefined;
          completedAt?: Date | undefined;
          expiredAt?: Date | undefined;
          platform: string;
          objectName?: string | undefined;
          objectType?: string | undefined;
          plannedDuration?: number | undefined;
          firstStatement: Date;
          lastStatement: Date;
          firstActivity?: Date | undefined;
          lastActivity?: Date | undefined;
        }>
      | undefined;
  }>;
};

export type RGetPopulationDataQueryVariables = Exact<{
  usersPool: RUsersPool;
}>;

export type RGetPopulationDataQuery = {
  __typename?: 'Query';
  userStatuses?: Array<{ __typename?: 'DataItem'; name: string; value: number } | undefined> | undefined;
  effortForRealm?:
    | Array<
        | {
            __typename?: 'EffortForRealm';
            total_effort_for_realm?: number | undefined;
            average_effort_per_user?: number | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RGetSebDataQueryVariables = Exact<{
  usersPool: RUsersPool;
}>;

export type RGetSebDataQuery = {
  __typename?: 'Query';
  getSebUsersEmpAndActive?: { __typename?: 'SebUsersEmpAndActive'; count?: number | undefined } | undefined;
};

export type RGetUserActivitySummaryQueryVariables = Exact<{
  usersPool: RUsersPool;
}>;

export type RGetUserActivitySummaryQuery = {
  __typename?: 'Query';
  userActivitySummary?:
    | Array<
        | {
            __typename?: 'UserActivitySummary';
            id: number;
            company?: string | undefined;
            email?: string | undefined;
            first_activity?: string | undefined;
            last_activity?: string | undefined;
            participations_completed?: number | undefined;
            participations_started?: number | undefined;
            participations_registered?: number | undefined;
            status?: string | undefined;
            total_effort_hours?: number | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RAssignmentV3QueryVariables = Exact<{
  id: Scalars['Int']['input'];
  userIdIN?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  userTeamIdIN?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  pagination?: InputMaybe<RPagination>;
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  includeUserTeams?: Scalars['Boolean']['input'];
  includeUsers?: Scalars['Boolean']['input'];
  includeLearnings?: Scalars['Boolean']['input'];
  periodIN?: InputMaybe<Array<RPeriodFilter> | RPeriodFilter>;
  statusIN?: InputMaybe<Array<RAssignmentUserCompletionStatus> | RAssignmentUserCompletionStatus>;
  selectGeneric?: Scalars['Boolean']['input'];
  selectAdmin?: Scalars['Boolean']['input'];
  selectLearner?: Scalars['Boolean']['input'];
  selectManager?: Scalars['Boolean']['input'];
  selectStrategic?: Scalars['Boolean']['input'];
}>;

export type RAssignmentV3Query = {
  __typename?: 'Query';
  generic?:
    | {
        __typename: 'AssignmentStandardV3';
        id: number;
        spaceId: number;
        name: string;
        teaser: string;
        description?: string | undefined;
        image?: string | undefined;
        type: RAssignmentV3Type;
        status?: RAssignmentV3Status | undefined;
        createdAt: Date;
        updatedAt: Date;
        learnings?:
          | {
              __typename?: 'AssignmentStandardV3LearningPage';
              limit: number;
              page: number;
              total: number;
              data: Array<{
                __typename?: 'AssignmentStandardV3Learning';
                type: RAssignmentStandardV3LearningType;
                id: number;
                assignmentGroupId?: number | undefined;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3LearningPage';
              limit: number;
              page: number;
              total: number;
              data: Array<{
                __typename?: 'AssignmentStrategicV3Learning';
                id: number;
                assignmentGroupId?: number | undefined;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            };
        users?:
          | {
              __typename?: 'AssignmentStandardV3UsersPage';
              limit: number;
              page: number;
              total: number;
              data: Array<{
                __typename?: 'AssignmentStandardV3User';
                assignmentId: number;
                userId: number;
                agent: RAssignmentV3UserAgent;
                order?: number | undefined;
                progress: {
                  __typename?: 'AssignmentStandardV3UserProgress';
                  estimatedEffort: number;
                  requiredItemsCompletedCount: number;
                  requiredItemsCount: number;
                  completed: boolean;
                  participations: Array<{
                    __typename?: 'AssignmentStandardV3UserParticipation';
                    assignmentLearningId: number;
                    participationId: number;
                    progress: number;
                    completedAt?: Date | undefined;
                    expiredAt?: Date | undefined;
                  }>;
                };
                user: {
                  __typename?: 'UserV2';
                  id: number;
                  username?: string | undefined;
                  email: string;
                  timestamp: Date;
                  status: RUserStatus;
                  teams?: {
                    __typename?: 'TeamUsersPage';
                    data: Array<{
                      __typename?: 'TeamUser';
                      teamId: number;
                      team: { __typename?: 'Team'; id: number; name: string };
                    }>;
                  };
                };
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3UsersPage';
              limit: number;
              page: number;
              total: number;
              data: Array<{
                __typename?: 'AssignmentStrategicV3User';
                assignmentId: number;
                userId: number;
                agent: RAssignmentV3UserAgent;
                order?: number | undefined;
                progress: { __typename?: 'AssignmentStrategicV3UserProgress'; completed: boolean; estimatedEffort: number };
                user: {
                  __typename?: 'UserV2';
                  id: number;
                  username?: string | undefined;
                  email: string;
                  timestamp: Date;
                  status: RUserStatus;
                  teams?: {
                    __typename?: 'TeamUsersPage';
                    data: Array<{
                      __typename?: 'TeamUser';
                      teamId: number;
                      team: { __typename?: 'Team'; id: number; name: string };
                    }>;
                  };
                };
              }>;
            };
        progress?: { __typename?: 'AssignmentV3Progress'; completedCount: number; completionRate: number };
      }
    | {
        __typename: 'AssignmentStrategicV3';
        startAt: Date;
        endAt: Date;
        learningLoopRecommendedEffort: number;
        totalThresholdEffort: number;
        id: number;
        spaceId: number;
        name: string;
        teaser: string;
        description?: string | undefined;
        image?: string | undefined;
        type: RAssignmentV3Type;
        status?: RAssignmentV3Status | undefined;
        createdAt: Date;
        updatedAt: Date;
        learnings?:
          | {
              __typename?: 'AssignmentStandardV3LearningPage';
              limit: number;
              page: number;
              total: number;
              data: Array<{
                __typename?: 'AssignmentStandardV3Learning';
                type: RAssignmentStandardV3LearningType;
                id: number;
                assignmentGroupId?: number | undefined;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3LearningPage';
              limit: number;
              page: number;
              total: number;
              data: Array<{
                __typename?: 'AssignmentStrategicV3Learning';
                id: number;
                assignmentGroupId?: number | undefined;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            };
        users?:
          | {
              __typename?: 'AssignmentStandardV3UsersPage';
              limit: number;
              page: number;
              total: number;
              data: Array<{
                __typename?: 'AssignmentStandardV3User';
                assignmentId: number;
                userId: number;
                agent: RAssignmentV3UserAgent;
                order?: number | undefined;
                progress: {
                  __typename?: 'AssignmentStandardV3UserProgress';
                  estimatedEffort: number;
                  requiredItemsCompletedCount: number;
                  requiredItemsCount: number;
                  completed: boolean;
                  participations: Array<{
                    __typename?: 'AssignmentStandardV3UserParticipation';
                    assignmentLearningId: number;
                    participationId: number;
                    progress: number;
                    completedAt?: Date | undefined;
                    expiredAt?: Date | undefined;
                  }>;
                };
                user: {
                  __typename?: 'UserV2';
                  id: number;
                  username?: string | undefined;
                  email: string;
                  timestamp: Date;
                  status: RUserStatus;
                  teams?: {
                    __typename?: 'TeamUsersPage';
                    data: Array<{
                      __typename?: 'TeamUser';
                      teamId: number;
                      team: { __typename?: 'Team'; id: number; name: string };
                    }>;
                  };
                };
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3UsersPage';
              limit: number;
              page: number;
              total: number;
              data: Array<{
                __typename?: 'AssignmentStrategicV3User';
                assignmentId: number;
                userId: number;
                agent: RAssignmentV3UserAgent;
                order?: number | undefined;
                progress: { __typename?: 'AssignmentStrategicV3UserProgress'; completed: boolean; estimatedEffort: number };
                user: {
                  __typename?: 'UserV2';
                  id: number;
                  username?: string | undefined;
                  email: string;
                  timestamp: Date;
                  status: RUserStatus;
                  teams?: {
                    __typename?: 'TeamUsersPage';
                    data: Array<{
                      __typename?: 'TeamUser';
                      teamId: number;
                      team: { __typename?: 'Team'; id: number; name: string };
                    }>;
                  };
                };
              }>;
            };
      }
    | undefined;
  admin?:
    | {
        __typename?: 'AssignmentStandardV3';
        id: number;
        spaceId: number;
        name: string;
        teaser: string;
        description?: string | undefined;
        image?: string | undefined;
        type: RAssignmentV3Type;
        status?: RAssignmentV3Status | undefined;
        surveyId?: string | undefined;
        rules?:
          | {
              __typename?: 'AssignmentsV3Rule';
              operator: RAssignmentsV3RuleOperator;
              expressions: Array<{
                __typename?: 'AssignmentsV3RuleExpression';
                operator: RAssignmentsV3RuleOperator;
                conditions: Array<{
                  __typename?: 'AssignmentsV3RuleCondition';
                  column: RAssignmentsV3RuleField;
                  compare: RAssignmentsV3RuleCompareOperator;
                  value?: string | undefined;
                  selections?: Array<string> | undefined;
                }>;
              }>;
            }
          | undefined;
        learnings:
          | {
              __typename?: 'AssignmentStandardV3LearningPage';
              data: Array<{
                __typename?: 'AssignmentStandardV3Learning';
                type: RAssignmentStandardV3LearningType;
                id: number;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3LearningPage';
              data: Array<{
                __typename?: 'AssignmentStrategicV3Learning';
                id: number;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            };
        users:
          | {
              __typename?: 'AssignmentStandardV3UsersPage';
              data: Array<{
                __typename?: 'AssignmentStandardV3User';
                assignmentId: number;
                userId: number;
                agent: RAssignmentV3UserAgent;
                user: { __typename?: 'UserV2'; id: number; email: string; username?: string | undefined; status: RUserStatus };
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3UsersPage';
              data: Array<{
                __typename?: 'AssignmentStrategicV3User';
                assignmentId: number;
                userId: number;
                agent: RAssignmentV3UserAgent;
                user: { __typename?: 'UserV2'; id: number; email: string; username?: string | undefined; status: RUserStatus };
              }>;
            };
      }
    | {
        __typename?: 'AssignmentStrategicV3';
        startAt: Date;
        endAt: Date;
        learningLoopRecommendedEffort: number;
        totalThresholdEffort: number;
        id: number;
        spaceId: number;
        name: string;
        teaser: string;
        description?: string | undefined;
        image?: string | undefined;
        type: RAssignmentV3Type;
        status?: RAssignmentV3Status | undefined;
        surveyId?: string | undefined;
        rules?:
          | {
              __typename?: 'AssignmentsV3Rule';
              operator: RAssignmentsV3RuleOperator;
              expressions: Array<{
                __typename?: 'AssignmentsV3RuleExpression';
                operator: RAssignmentsV3RuleOperator;
                conditions: Array<{
                  __typename?: 'AssignmentsV3RuleCondition';
                  column: RAssignmentsV3RuleField;
                  compare: RAssignmentsV3RuleCompareOperator;
                  value?: string | undefined;
                  selections?: Array<string> | undefined;
                }>;
              }>;
            }
          | undefined;
        learnings:
          | {
              __typename?: 'AssignmentStandardV3LearningPage';
              data: Array<{
                __typename?: 'AssignmentStandardV3Learning';
                type: RAssignmentStandardV3LearningType;
                id: number;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3LearningPage';
              data: Array<{
                __typename?: 'AssignmentStrategicV3Learning';
                id: number;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            };
        users:
          | {
              __typename?: 'AssignmentStandardV3UsersPage';
              data: Array<{
                __typename?: 'AssignmentStandardV3User';
                assignmentId: number;
                userId: number;
                agent: RAssignmentV3UserAgent;
                user: { __typename?: 'UserV2'; id: number; email: string; username?: string | undefined; status: RUserStatus };
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3UsersPage';
              data: Array<{
                __typename?: 'AssignmentStrategicV3User';
                assignmentId: number;
                userId: number;
                agent: RAssignmentV3UserAgent;
                user: { __typename?: 'UserV2'; id: number; email: string; username?: string | undefined; status: RUserStatus };
              }>;
            };
      }
    | undefined;
  learner?:
    | {
        __typename?: 'AssignmentStandardV3';
        id: number;
        name: string;
        description?: string | undefined;
        type: RAssignmentV3Type;
        teaser: string;
        image?: string | undefined;
        surveyId?: string | undefined;
        users:
          | {
              __typename?: 'AssignmentStandardV3UsersPage';
              data: Array<{
                __typename?: 'AssignmentStandardV3User';
                assignmentId: number;
                userId: number;
                progress: {
                  __typename?: 'AssignmentStandardV3UserProgress';
                  estimatedEffort: number;
                  requiredItemsCompletedCount: number;
                  requiredItemsCount: number;
                  completed: boolean;
                  participations: Array<{ __typename?: 'AssignmentStandardV3UserParticipation'; progress: number }>;
                };
                user: { __typename?: 'UserV2'; id: number };
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3UsersPage';
              data: Array<{
                __typename?: 'AssignmentStrategicV3User';
                assignmentId: number;
                userId: number;
                progress: {
                  __typename?: 'AssignmentStrategicV3UserProgress';
                  completed: boolean;
                  estimatedEffort: number;
                  competencyAssessment: { __typename?: 'AssignmentStrategicV3UserSurveyProgress'; canTake: boolean };
                };
                user: { __typename?: 'UserV2'; id: number };
              }>;
            };
        learnings:
          | {
              __typename?: 'AssignmentStandardV3LearningPage';
              data: Array<{
                __typename?: 'AssignmentStandardV3Learning';
                type: RAssignmentStandardV3LearningType;
                id: number;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3LearningPage';
              data: Array<{
                __typename?: 'AssignmentStrategicV3Learning';
                id: number;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            };
      }
    | {
        __typename?: 'AssignmentStrategicV3';
        startAt: Date;
        endAt: Date;
        learningLoopRecommendedEffort: number;
        totalThresholdEffort: number;
        id: number;
        name: string;
        description?: string | undefined;
        type: RAssignmentV3Type;
        teaser: string;
        image?: string | undefined;
        surveyId?: string | undefined;
        users:
          | {
              __typename?: 'AssignmentStandardV3UsersPage';
              data: Array<{
                __typename?: 'AssignmentStandardV3User';
                assignmentId: number;
                userId: number;
                progress: {
                  __typename?: 'AssignmentStandardV3UserProgress';
                  estimatedEffort: number;
                  requiredItemsCompletedCount: number;
                  requiredItemsCount: number;
                  completed: boolean;
                  participations: Array<{ __typename?: 'AssignmentStandardV3UserParticipation'; progress: number }>;
                };
                user: { __typename?: 'UserV2'; id: number };
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3UsersPage';
              data: Array<{
                __typename?: 'AssignmentStrategicV3User';
                assignmentId: number;
                userId: number;
                progress: {
                  __typename?: 'AssignmentStrategicV3UserProgress';
                  completed: boolean;
                  estimatedEffort: number;
                  competencyAssessment: { __typename?: 'AssignmentStrategicV3UserSurveyProgress'; canTake: boolean };
                };
                user: { __typename?: 'UserV2'; id: number };
              }>;
            };
        learnings:
          | {
              __typename?: 'AssignmentStandardV3LearningPage';
              data: Array<{
                __typename?: 'AssignmentStandardV3Learning';
                type: RAssignmentStandardV3LearningType;
                id: number;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3LearningPage';
              data: Array<{
                __typename?: 'AssignmentStrategicV3Learning';
                id: number;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            };
      }
    | undefined;
  manager?:
    | {
        __typename?: 'AssignmentStandardV3';
        id: number;
        name: string;
        type: RAssignmentV3Type;
        learnings:
          | {
              __typename?: 'AssignmentStandardV3LearningPage';
              total: number;
              data: Array<{
                __typename?: 'AssignmentStandardV3Learning';
                type: RAssignmentStandardV3LearningType;
                id: number;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3LearningPage';
              total: number;
              data: Array<{
                __typename?: 'AssignmentStrategicV3Learning';
                id: number;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            };
        users:
          | {
              __typename?: 'AssignmentStandardV3UsersPage';
              data: Array<{
                __typename?: 'AssignmentStandardV3User';
                userId: number;
                progress: {
                  __typename?: 'AssignmentStandardV3UserProgress';
                  completed: boolean;
                  participations: Array<{
                    __typename?: 'AssignmentStandardV3UserParticipation';
                    assignmentLearningId: number;
                    participationId: number;
                    progress: number;
                    completedAt?: Date | undefined;
                    expiredAt?: Date | undefined;
                  }>;
                };
                user: { __typename?: 'UserV2'; id: number; username?: string | undefined; email: string };
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3UsersPage';
              data: Array<{
                __typename?: 'AssignmentStrategicV3User';
                userId: number;
                user: { __typename?: 'UserV2'; id: number; username?: string | undefined; email: string };
              }>;
            };
      }
    | {
        __typename?: 'AssignmentStrategicV3';
        id: number;
        name: string;
        type: RAssignmentV3Type;
        learnings:
          | {
              __typename?: 'AssignmentStandardV3LearningPage';
              total: number;
              data: Array<{
                __typename?: 'AssignmentStandardV3Learning';
                type: RAssignmentStandardV3LearningType;
                id: number;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3LearningPage';
              total: number;
              data: Array<{
                __typename?: 'AssignmentStrategicV3Learning';
                id: number;
                learningPathId?: number | undefined;
                learningId?: number | undefined;
                order?: number | undefined;
              }>;
            };
        users:
          | {
              __typename?: 'AssignmentStandardV3UsersPage';
              data: Array<{
                __typename?: 'AssignmentStandardV3User';
                userId: number;
                progress: {
                  __typename?: 'AssignmentStandardV3UserProgress';
                  completed: boolean;
                  participations: Array<{
                    __typename?: 'AssignmentStandardV3UserParticipation';
                    assignmentLearningId: number;
                    participationId: number;
                    progress: number;
                    completedAt?: Date | undefined;
                    expiredAt?: Date | undefined;
                  }>;
                };
                user: { __typename?: 'UserV2'; id: number; username?: string | undefined; email: string };
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3UsersPage';
              data: Array<{
                __typename?: 'AssignmentStrategicV3User';
                userId: number;
                user: { __typename?: 'UserV2'; id: number; username?: string | undefined; email: string };
              }>;
            };
      }
    | undefined;
  strategic?:
    | {
        __typename?: 'AssignmentStandardV3';
        id: number;
        name: string;
        users:
          | {
              __typename?: 'AssignmentStandardV3UsersPage';
              total: number;
              data: Array<{
                __typename?: 'AssignmentStandardV3User';
                assignmentId: number;
                userId: number;
                user: {
                  __typename?: 'UserV2';
                  id: number;
                  username?: string | undefined;
                  email: string;
                  teams: {
                    __typename?: 'TeamUsersPage';
                    data: Array<{
                      __typename?: 'TeamUser';
                      teamId: number;
                      team: { __typename?: 'Team'; id: number; name: string };
                    }>;
                  };
                };
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3UsersPage';
              total: number;
              data: Array<{
                __typename?: 'AssignmentStrategicV3User';
                assignmentId: number;
                userId: number;
                progress: {
                  __typename?: 'AssignmentStrategicV3UserProgress';
                  reflectionsCompleted: number;
                  active: boolean;
                  reflectionsLimit: number;
                  completed: boolean;
                  userCompletionStatus: RAssignmentUserCompletionStatus;
                  estimatedEffortProgress: number;
                  estimatedEffort: number;
                };
                user: {
                  __typename?: 'UserV2';
                  id: number;
                  username?: string | undefined;
                  email: string;
                  teams: {
                    __typename?: 'TeamUsersPage';
                    data: Array<{
                      __typename?: 'TeamUser';
                      teamId: number;
                      team: { __typename?: 'Team'; id: number; name: string };
                    }>;
                  };
                };
              }>;
            };
      }
    | {
        __typename?: 'AssignmentStrategicV3';
        startAt: Date;
        endAt: Date;
        learningLoopRecommendedEffort: number;
        totalThresholdEffort: number;
        id: number;
        name: string;
        progress: {
          __typename?: 'AssignmentStrategicV3Progress';
          estimatedEffort: number;
          reflections: {
            __typename?: 'AssignmentStrategicV3ReflectionsProgress';
            completedCount: number;
            completedThreshold: number;
          };
          learners: { __typename?: 'AssignmentStrategicV3LearnersProgress'; completedCount: number; activeCount: number };
        };
        users:
          | {
              __typename?: 'AssignmentStandardV3UsersPage';
              total: number;
              data: Array<{
                __typename?: 'AssignmentStandardV3User';
                assignmentId: number;
                userId: number;
                user: {
                  __typename?: 'UserV2';
                  id: number;
                  username?: string | undefined;
                  email: string;
                  teams: {
                    __typename?: 'TeamUsersPage';
                    data: Array<{
                      __typename?: 'TeamUser';
                      teamId: number;
                      team: { __typename?: 'Team'; id: number; name: string };
                    }>;
                  };
                };
              }>;
            }
          | {
              __typename?: 'AssignmentStrategicV3UsersPage';
              total: number;
              data: Array<{
                __typename?: 'AssignmentStrategicV3User';
                assignmentId: number;
                userId: number;
                progress: {
                  __typename?: 'AssignmentStrategicV3UserProgress';
                  reflectionsCompleted: number;
                  active: boolean;
                  reflectionsLimit: number;
                  completed: boolean;
                  userCompletionStatus: RAssignmentUserCompletionStatus;
                  estimatedEffortProgress: number;
                  estimatedEffort: number;
                };
                user: {
                  __typename?: 'UserV2';
                  id: number;
                  username?: string | undefined;
                  email: string;
                  teams: {
                    __typename?: 'TeamUsersPage';
                    data: Array<{
                      __typename?: 'TeamUser';
                      teamId: number;
                      team: { __typename?: 'Team'; id: number; name: string };
                    }>;
                  };
                };
              }>;
            };
      }
    | undefined;
};

export type RAssignmentsV3QueryVariables = Exact<{
  spacedIdsIN?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RAssignmentV3Type>;
  userIdIN?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  userTeamIdIN?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  status?: InputMaybe<RAssignmentV3Status>;
  sort?: InputMaybe<RAssignmentsV3Sort>;
  pagination?: InputMaybe<RPagination>;
  includeUserTeams?: Scalars['Boolean']['input'];
  includeUsers?: Scalars['Boolean']['input'];
  includeLearnings?: Scalars['Boolean']['input'];
  selectGeneric?: Scalars['Boolean']['input'];
  selectAdmin?: Scalars['Boolean']['input'];
  selectManager?: Scalars['Boolean']['input'];
  selectLearner?: Scalars['Boolean']['input'];
  selectCards?: Scalars['Boolean']['input'];
  selectHomepage?: Scalars['Boolean']['input'];
}>;

export type RAssignmentsV3Query = {
  __typename?: 'Query';
  assignmentsV3?: {
    __typename?: 'AssignmentsV3Page';
    limit: number;
    page: number;
    total: number;
    data?: Array<
      | {
          __typename: 'AssignmentStandardV3';
          id: number;
          name: string;
          description?: string | undefined;
          type: RAssignmentV3Type;
          teaser: string;
          image?: string | undefined;
          spaceId: number;
          status?: RAssignmentV3Status | undefined;
          createdAt: Date;
          updatedAt: Date;
          progress: { __typename?: 'AssignmentV3Progress'; completedCount: number; completionRate: number };
          learnings:
            | {
                __typename?: 'AssignmentStandardV3LearningPage';
                total: number;
                limit: number;
                page: number;
                data: Array<{
                  __typename?: 'AssignmentStandardV3Learning';
                  type: RAssignmentStandardV3LearningType;
                  id: number;
                  assignmentGroupId?: number | undefined;
                  learningPathId?: number | undefined;
                  learningId?: number | undefined;
                  order?: number | undefined;
                }>;
              }
            | {
                __typename?: 'AssignmentStrategicV3LearningPage';
                total: number;
                limit: number;
                page: number;
                data: Array<{
                  __typename?: 'AssignmentStrategicV3Learning';
                  id: number;
                  learningPathId?: number | undefined;
                  learningId?: number | undefined;
                  order?: number | undefined;
                  assignmentGroupId?: number | undefined;
                }>;
              };
          users:
            | {
                __typename?: 'AssignmentStandardV3UsersPage';
                total: number;
                limit: number;
                page: number;
                data: Array<{
                  __typename?: 'AssignmentStandardV3User';
                  assignmentId: number;
                  userId: number;
                  agent: RAssignmentV3UserAgent;
                  order?: number | undefined;
                  progress: {
                    __typename?: 'AssignmentStandardV3UserProgress';
                    estimatedEffort: number;
                    requiredItemsCompletedCount: number;
                    requiredItemsCount: number;
                    completed: boolean;
                    participations: Array<{
                      __typename?: 'AssignmentStandardV3UserParticipation';
                      assignmentLearningId: number;
                      participationId: number;
                      progress: number;
                      completedAt?: Date | undefined;
                      expiredAt?: Date | undefined;
                    }>;
                  };
                  user: {
                    __typename?: 'UserV2';
                    id: number;
                    username?: string | undefined;
                    email: string;
                    timestamp: Date;
                    status: RUserStatus;
                    teams?: {
                      __typename?: 'TeamUsersPage';
                      data: Array<{
                        __typename?: 'TeamUser';
                        teamId: number;
                        team: { __typename?: 'Team'; id: number; name: string };
                      }>;
                    };
                  };
                }>;
              }
            | {
                __typename?: 'AssignmentStrategicV3UsersPage';
                total: number;
                limit: number;
                page: number;
                data: Array<{
                  __typename?: 'AssignmentStrategicV3User';
                  assignmentId: number;
                  userId: number;
                  agent: RAssignmentV3UserAgent;
                  order?: number | undefined;
                  progress: { __typename?: 'AssignmentStrategicV3UserProgress'; completed: boolean; estimatedEffort: number };
                  user: {
                    __typename?: 'UserV2';
                    id: number;
                    username?: string | undefined;
                    email: string;
                    timestamp: Date;
                    status: RUserStatus;
                    teams?: {
                      __typename?: 'TeamUsersPage';
                      data: Array<{
                        __typename?: 'TeamUser';
                        teamId: number;
                        team: { __typename?: 'Team'; id: number; name: string };
                      }>;
                    };
                  };
                }>;
              };
        }
      | {
          __typename: 'AssignmentStrategicV3';
          startAt: Date;
          endAt: Date;
          totalThresholdEffort: number;
          id: number;
          name: string;
          description?: string | undefined;
          type: RAssignmentV3Type;
          teaser: string;
          image?: string | undefined;
          learningLoopRecommendedEffort: number;
          spaceId: number;
          status?: RAssignmentV3Status | undefined;
          createdAt: Date;
          updatedAt: Date;
          progress: {
            __typename?: 'AssignmentStrategicV3Progress';
            learners: { __typename?: 'AssignmentStrategicV3LearnersProgress'; completedCount: number; activeCount: number };
          };
          learnings:
            | {
                __typename?: 'AssignmentStandardV3LearningPage';
                total: number;
                limit: number;
                page: number;
                data: Array<{
                  __typename?: 'AssignmentStandardV3Learning';
                  type: RAssignmentStandardV3LearningType;
                  id: number;
                  assignmentGroupId?: number | undefined;
                  learningPathId?: number | undefined;
                  learningId?: number | undefined;
                  order?: number | undefined;
                }>;
              }
            | {
                __typename?: 'AssignmentStrategicV3LearningPage';
                total: number;
                limit: number;
                page: number;
                data: Array<{
                  __typename?: 'AssignmentStrategicV3Learning';
                  id: number;
                  learningPathId?: number | undefined;
                  learningId?: number | undefined;
                  order?: number | undefined;
                  assignmentGroupId?: number | undefined;
                }>;
              };
          users:
            | {
                __typename?: 'AssignmentStandardV3UsersPage';
                total: number;
                limit: number;
                page: number;
                data: Array<{
                  __typename?: 'AssignmentStandardV3User';
                  assignmentId: number;
                  userId: number;
                  agent: RAssignmentV3UserAgent;
                  order?: number | undefined;
                  progress: {
                    __typename?: 'AssignmentStandardV3UserProgress';
                    estimatedEffort: number;
                    requiredItemsCompletedCount: number;
                    requiredItemsCount: number;
                    completed: boolean;
                    participations: Array<{
                      __typename?: 'AssignmentStandardV3UserParticipation';
                      assignmentLearningId: number;
                      participationId: number;
                      progress: number;
                      completedAt?: Date | undefined;
                      expiredAt?: Date | undefined;
                    }>;
                  };
                  user: {
                    __typename?: 'UserV2';
                    id: number;
                    username?: string | undefined;
                    email: string;
                    timestamp: Date;
                    status: RUserStatus;
                    teams?: {
                      __typename?: 'TeamUsersPage';
                      data: Array<{
                        __typename?: 'TeamUser';
                        teamId: number;
                        team: { __typename?: 'Team'; id: number; name: string };
                      }>;
                    };
                  };
                }>;
              }
            | {
                __typename?: 'AssignmentStrategicV3UsersPage';
                total: number;
                limit: number;
                page: number;
                data: Array<{
                  __typename?: 'AssignmentStrategicV3User';
                  assignmentId: number;
                  userId: number;
                  agent: RAssignmentV3UserAgent;
                  order?: number | undefined;
                  progress: { __typename?: 'AssignmentStrategicV3UserProgress'; completed: boolean; estimatedEffort: number };
                  user: {
                    __typename?: 'UserV2';
                    id: number;
                    username?: string | undefined;
                    email: string;
                    timestamp: Date;
                    status: RUserStatus;
                    teams?: {
                      __typename?: 'TeamUsersPage';
                      data: Array<{
                        __typename?: 'TeamUser';
                        teamId: number;
                        team: { __typename?: 'Team'; id: number; name: string };
                      }>;
                    };
                  };
                }>;
              };
        }
    >;
  };
  admin?: {
    __typename?: 'AssignmentsV3Page';
    data: Array<
      | {
          __typename: 'AssignmentStandardV3';
          id: number;
          name: string;
          type: RAssignmentV3Type;
          status?: RAssignmentV3Status | undefined;
          spaceId: number;
          learnings:
            | { __typename?: 'AssignmentStandardV3LearningPage'; total: number }
            | { __typename?: 'AssignmentStrategicV3LearningPage'; total: number };
          users:
            | { __typename?: 'AssignmentStandardV3UsersPage'; total: number }
            | { __typename?: 'AssignmentStrategicV3UsersPage'; total: number };
        }
      | {
          __typename: 'AssignmentStrategicV3';
          id: number;
          name: string;
          type: RAssignmentV3Type;
          status?: RAssignmentV3Status | undefined;
          spaceId: number;
          learnings:
            | { __typename?: 'AssignmentStandardV3LearningPage'; total: number }
            | { __typename?: 'AssignmentStrategicV3LearningPage'; total: number };
          users:
            | { __typename?: 'AssignmentStandardV3UsersPage'; total: number }
            | { __typename?: 'AssignmentStrategicV3UsersPage'; total: number };
        }
    >;
  };
};

export type RAssignmentStandardV3LearningPageGenericFieldsFragment = {
  __typename?: 'AssignmentStandardV3LearningPage';
  limit: number;
  page: number;
  total: number;
  data: Array<{
    __typename?: 'AssignmentStandardV3Learning';
    type: RAssignmentStandardV3LearningType;
    id: number;
    assignmentGroupId?: number | undefined;
    learningPathId?: number | undefined;
    learningId?: number | undefined;
    order?: number | undefined;
  }>;
};

export type RAssignmentStrategicV3LearningPageGenericFieldsFragment = {
  __typename?: 'AssignmentStrategicV3LearningPage';
  limit: number;
  page: number;
  total: number;
  data: Array<{
    __typename?: 'AssignmentStrategicV3Learning';
    id: number;
    assignmentGroupId?: number | undefined;
    learningPathId?: number | undefined;
    learningId?: number | undefined;
    order?: number | undefined;
  }>;
};

export type RAssignmentStandardV3UsersPageGenericFieldsFragment = {
  __typename?: 'AssignmentStandardV3UsersPage';
  limit: number;
  page: number;
  total: number;
  data: Array<{
    __typename?: 'AssignmentStandardV3User';
    assignmentId: number;
    userId: number;
    agent: RAssignmentV3UserAgent;
    order?: number | undefined;
    progress: {
      __typename?: 'AssignmentStandardV3UserProgress';
      estimatedEffort: number;
      requiredItemsCompletedCount: number;
      requiredItemsCount: number;
      completed: boolean;
      participations: Array<{
        __typename?: 'AssignmentStandardV3UserParticipation';
        assignmentLearningId: number;
        participationId: number;
        progress: number;
        completedAt?: Date | undefined;
        expiredAt?: Date | undefined;
      }>;
    };
    user: {
      __typename?: 'UserV2';
      id: number;
      username?: string | undefined;
      email: string;
      timestamp: Date;
      status: RUserStatus;
      teams?: {
        __typename?: 'TeamUsersPage';
        data: Array<{ __typename?: 'TeamUser'; teamId: number; team: { __typename?: 'Team'; id: number; name: string } }>;
      };
    };
  }>;
};

export type RAssignmentStrategicV3UsersPageGenericFieldsFragment = {
  __typename?: 'AssignmentStrategicV3UsersPage';
  limit: number;
  page: number;
  total: number;
  data: Array<{
    __typename?: 'AssignmentStrategicV3User';
    assignmentId: number;
    userId: number;
    agent: RAssignmentV3UserAgent;
    order?: number | undefined;
    progress: { __typename?: 'AssignmentStrategicV3UserProgress'; completed: boolean; estimatedEffort: number };
    user: {
      __typename?: 'UserV2';
      id: number;
      username?: string | undefined;
      email: string;
      timestamp: Date;
      status: RUserStatus;
      teams?: {
        __typename?: 'TeamUsersPage';
        data: Array<{ __typename?: 'TeamUser'; teamId: number; team: { __typename?: 'Team'; id: number; name: string } }>;
      };
    };
  }>;
};

export type RAssignmentStandardV3BaseFieldsFragment = {
  __typename: 'AssignmentStandardV3';
  id: number;
  spaceId: number;
  name: string;
  teaser: string;
  description?: string | undefined;
  image?: string | undefined;
  type: RAssignmentV3Type;
  status?: RAssignmentV3Status | undefined;
  createdAt: Date;
  updatedAt: Date;
};

export type RAssignmentStandardV3GenericFieldsFragment = {
  __typename: 'AssignmentStandardV3';
  id: number;
  spaceId: number;
  name: string;
  teaser: string;
  description?: string | undefined;
  image?: string | undefined;
  type: RAssignmentV3Type;
  status?: RAssignmentV3Status | undefined;
  createdAt: Date;
  updatedAt: Date;
  learnings?:
    | {
        __typename?: 'AssignmentStandardV3LearningPage';
        limit: number;
        page: number;
        total: number;
        data: Array<{
          __typename?: 'AssignmentStandardV3Learning';
          type: RAssignmentStandardV3LearningType;
          id: number;
          assignmentGroupId?: number | undefined;
          learningPathId?: number | undefined;
          learningId?: number | undefined;
          order?: number | undefined;
        }>;
      }
    | {
        __typename?: 'AssignmentStrategicV3LearningPage';
        limit: number;
        page: number;
        total: number;
        data: Array<{
          __typename?: 'AssignmentStrategicV3Learning';
          id: number;
          assignmentGroupId?: number | undefined;
          learningPathId?: number | undefined;
          learningId?: number | undefined;
          order?: number | undefined;
        }>;
      };
  users?:
    | {
        __typename?: 'AssignmentStandardV3UsersPage';
        limit: number;
        page: number;
        total: number;
        data: Array<{
          __typename?: 'AssignmentStandardV3User';
          assignmentId: number;
          userId: number;
          agent: RAssignmentV3UserAgent;
          order?: number | undefined;
          progress: {
            __typename?: 'AssignmentStandardV3UserProgress';
            estimatedEffort: number;
            requiredItemsCompletedCount: number;
            requiredItemsCount: number;
            completed: boolean;
            participations: Array<{
              __typename?: 'AssignmentStandardV3UserParticipation';
              assignmentLearningId: number;
              participationId: number;
              progress: number;
              completedAt?: Date | undefined;
              expiredAt?: Date | undefined;
            }>;
          };
          user: {
            __typename?: 'UserV2';
            id: number;
            username?: string | undefined;
            email: string;
            timestamp: Date;
            status: RUserStatus;
            teams?: {
              __typename?: 'TeamUsersPage';
              data: Array<{ __typename?: 'TeamUser'; teamId: number; team: { __typename?: 'Team'; id: number; name: string } }>;
            };
          };
        }>;
      }
    | {
        __typename?: 'AssignmentStrategicV3UsersPage';
        limit: number;
        page: number;
        total: number;
        data: Array<{
          __typename?: 'AssignmentStrategicV3User';
          assignmentId: number;
          userId: number;
          agent: RAssignmentV3UserAgent;
          order?: number | undefined;
          progress: { __typename?: 'AssignmentStrategicV3UserProgress'; completed: boolean; estimatedEffort: number };
          user: {
            __typename?: 'UserV2';
            id: number;
            username?: string | undefined;
            email: string;
            timestamp: Date;
            status: RUserStatus;
            teams?: {
              __typename?: 'TeamUsersPage';
              data: Array<{ __typename?: 'TeamUser'; teamId: number; team: { __typename?: 'Team'; id: number; name: string } }>;
            };
          };
        }>;
      };
  progress?: { __typename?: 'AssignmentV3Progress'; completedCount: number; completionRate: number };
};

export type RAssignmentStrategicV3BaseFieldsFragment = {
  __typename: 'AssignmentStrategicV3';
  id: number;
  spaceId: number;
  name: string;
  teaser: string;
  description?: string | undefined;
  image?: string | undefined;
  type: RAssignmentV3Type;
  status?: RAssignmentV3Status | undefined;
  createdAt: Date;
  updatedAt: Date;
};

export type RAssignmentStrategicV3GenericFieldsFragment = {
  __typename: 'AssignmentStrategicV3';
  startAt: Date;
  endAt: Date;
  learningLoopRecommendedEffort: number;
  totalThresholdEffort: number;
  id: number;
  spaceId: number;
  name: string;
  teaser: string;
  description?: string | undefined;
  image?: string | undefined;
  type: RAssignmentV3Type;
  status?: RAssignmentV3Status | undefined;
  createdAt: Date;
  updatedAt: Date;
  learnings?:
    | {
        __typename?: 'AssignmentStandardV3LearningPage';
        limit: number;
        page: number;
        total: number;
        data: Array<{
          __typename?: 'AssignmentStandardV3Learning';
          type: RAssignmentStandardV3LearningType;
          id: number;
          assignmentGroupId?: number | undefined;
          learningPathId?: number | undefined;
          learningId?: number | undefined;
          order?: number | undefined;
        }>;
      }
    | {
        __typename?: 'AssignmentStrategicV3LearningPage';
        limit: number;
        page: number;
        total: number;
        data: Array<{
          __typename?: 'AssignmentStrategicV3Learning';
          id: number;
          assignmentGroupId?: number | undefined;
          learningPathId?: number | undefined;
          learningId?: number | undefined;
          order?: number | undefined;
        }>;
      };
  users?:
    | {
        __typename?: 'AssignmentStandardV3UsersPage';
        limit: number;
        page: number;
        total: number;
        data: Array<{
          __typename?: 'AssignmentStandardV3User';
          assignmentId: number;
          userId: number;
          agent: RAssignmentV3UserAgent;
          order?: number | undefined;
          progress: {
            __typename?: 'AssignmentStandardV3UserProgress';
            estimatedEffort: number;
            requiredItemsCompletedCount: number;
            requiredItemsCount: number;
            completed: boolean;
            participations: Array<{
              __typename?: 'AssignmentStandardV3UserParticipation';
              assignmentLearningId: number;
              participationId: number;
              progress: number;
              completedAt?: Date | undefined;
              expiredAt?: Date | undefined;
            }>;
          };
          user: {
            __typename?: 'UserV2';
            id: number;
            username?: string | undefined;
            email: string;
            timestamp: Date;
            status: RUserStatus;
            teams?: {
              __typename?: 'TeamUsersPage';
              data: Array<{ __typename?: 'TeamUser'; teamId: number; team: { __typename?: 'Team'; id: number; name: string } }>;
            };
          };
        }>;
      }
    | {
        __typename?: 'AssignmentStrategicV3UsersPage';
        limit: number;
        page: number;
        total: number;
        data: Array<{
          __typename?: 'AssignmentStrategicV3User';
          assignmentId: number;
          userId: number;
          agent: RAssignmentV3UserAgent;
          order?: number | undefined;
          progress: { __typename?: 'AssignmentStrategicV3UserProgress'; completed: boolean; estimatedEffort: number };
          user: {
            __typename?: 'UserV2';
            id: number;
            username?: string | undefined;
            email: string;
            timestamp: Date;
            status: RUserStatus;
            teams?: {
              __typename?: 'TeamUsersPage';
              data: Array<{ __typename?: 'TeamUser'; teamId: number; team: { __typename?: 'Team'; id: number; name: string } }>;
            };
          };
        }>;
      };
};

export type RAssignmentsV3PageMetadataFieldsFragment = {
  __typename?: 'AssignmentsV3Page';
  limit: number;
  page: number;
  total: number;
};

export type RDeleteAssignmentV3MutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type RDeleteAssignmentV3Mutation = {
  __typename?: 'Mutation';
  deleteAssignmentV3: { __typename?: 'AssignmentsV3Result'; success: boolean };
};

export type RUpsertAssignmentV3MutationVariables = Exact<{
  input: RUpsertAssignmentInput;
}>;

export type RUpsertAssignmentV3Mutation = {
  __typename?: 'Mutation';
  upsertAssignmentV3: {
    __typename?: 'AssignmentsV3Result';
    success: boolean;
    assignment?:
      | {
          __typename?: 'AssignmentStandardV3';
          id: number;
          spaceId: number;
          name: string;
          teaser: string;
          description?: string | undefined;
          image?: string | undefined;
          surveyId?: string | undefined;
          type: RAssignmentV3Type;
          status?: RAssignmentV3Status | undefined;
          rules?:
            | {
                __typename?: 'AssignmentsV3Rule';
                operator: RAssignmentsV3RuleOperator;
                expressions: Array<{
                  __typename?: 'AssignmentsV3RuleExpression';
                  operator: RAssignmentsV3RuleOperator;
                  conditions: Array<{
                    __typename?: 'AssignmentsV3RuleCondition';
                    column: RAssignmentsV3RuleField;
                    compare: RAssignmentsV3RuleCompareOperator;
                    value?: string | undefined;
                    selections?: Array<string> | undefined;
                  }>;
                }>;
              }
            | undefined;
          learnings:
            | {
                __typename?: 'AssignmentStandardV3LearningPage';
                data: Array<{
                  __typename?: 'AssignmentStandardV3Learning';
                  type: RAssignmentStandardV3LearningType;
                  id: number;
                  assignmentGroupId?: number | undefined;
                  learningPathId?: number | undefined;
                  learningId?: number | undefined;
                  order?: number | undefined;
                }>;
              }
            | {
                __typename?: 'AssignmentStrategicV3LearningPage';
                data: Array<{
                  __typename?: 'AssignmentStrategicV3Learning';
                  id: number;
                  assignmentGroupId?: number | undefined;
                  learningPathId?: number | undefined;
                  learningId?: number | undefined;
                  order?: number | undefined;
                }>;
              };
          users:
            | {
                __typename?: 'AssignmentStandardV3UsersPage';
                data: Array<{
                  __typename?: 'AssignmentStandardV3User';
                  userId: number;
                  assignmentId: number;
                  agent: RAssignmentV3UserAgent;
                  progress: {
                    __typename?: 'AssignmentStandardV3UserProgress';
                    completed: boolean;
                    participations: Array<{
                      __typename?: 'AssignmentStandardV3UserParticipation';
                      assignmentLearningId: number;
                      participationId: number;
                      progress: number;
                      completedAt?: Date | undefined;
                      expiredAt?: Date | undefined;
                    }>;
                  };
                  user: { __typename?: 'UserV2'; id: number; email: string; username?: string | undefined };
                }>;
              }
            | {
                __typename?: 'AssignmentStrategicV3UsersPage';
                data: Array<{
                  __typename?: 'AssignmentStrategicV3User';
                  userId: number;
                  assignmentId: number;
                  agent: RAssignmentV3UserAgent;
                  user: { __typename?: 'UserV2'; id: number; email: string; username?: string | undefined };
                }>;
              };
        }
      | {
          __typename?: 'AssignmentStrategicV3';
          startAt: Date;
          endAt: Date;
          learningLoopRecommendedEffort: number;
          totalThresholdEffort: number;
          id: number;
          spaceId: number;
          name: string;
          teaser: string;
          description?: string | undefined;
          image?: string | undefined;
          surveyId?: string | undefined;
          type: RAssignmentV3Type;
          status?: RAssignmentV3Status | undefined;
          rules?:
            | {
                __typename?: 'AssignmentsV3Rule';
                operator: RAssignmentsV3RuleOperator;
                expressions: Array<{
                  __typename?: 'AssignmentsV3RuleExpression';
                  operator: RAssignmentsV3RuleOperator;
                  conditions: Array<{
                    __typename?: 'AssignmentsV3RuleCondition';
                    column: RAssignmentsV3RuleField;
                    compare: RAssignmentsV3RuleCompareOperator;
                    value?: string | undefined;
                    selections?: Array<string> | undefined;
                  }>;
                }>;
              }
            | undefined;
          learnings:
            | {
                __typename?: 'AssignmentStandardV3LearningPage';
                data: Array<{
                  __typename?: 'AssignmentStandardV3Learning';
                  type: RAssignmentStandardV3LearningType;
                  id: number;
                  assignmentGroupId?: number | undefined;
                  learningPathId?: number | undefined;
                  learningId?: number | undefined;
                  order?: number | undefined;
                }>;
              }
            | {
                __typename?: 'AssignmentStrategicV3LearningPage';
                data: Array<{
                  __typename?: 'AssignmentStrategicV3Learning';
                  id: number;
                  assignmentGroupId?: number | undefined;
                  learningPathId?: number | undefined;
                  learningId?: number | undefined;
                  order?: number | undefined;
                }>;
              };
          users:
            | {
                __typename?: 'AssignmentStandardV3UsersPage';
                data: Array<{
                  __typename?: 'AssignmentStandardV3User';
                  userId: number;
                  assignmentId: number;
                  agent: RAssignmentV3UserAgent;
                  progress: {
                    __typename?: 'AssignmentStandardV3UserProgress';
                    completed: boolean;
                    participations: Array<{
                      __typename?: 'AssignmentStandardV3UserParticipation';
                      assignmentLearningId: number;
                      participationId: number;
                      progress: number;
                      completedAt?: Date | undefined;
                      expiredAt?: Date | undefined;
                    }>;
                  };
                  user: { __typename?: 'UserV2'; id: number; email: string; username?: string | undefined };
                }>;
              }
            | {
                __typename?: 'AssignmentStrategicV3UsersPage';
                data: Array<{
                  __typename?: 'AssignmentStrategicV3User';
                  userId: number;
                  assignmentId: number;
                  agent: RAssignmentV3UserAgent;
                  user: { __typename?: 'UserV2'; id: number; email: string; username?: string | undefined };
                }>;
              };
        }
      | undefined;
  };
};

export type RAssignmentTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type RAssignmentTemplatesQuery = {
  __typename?: 'Query';
  assignmentTemplates: Array<{ __typename?: 'AssignmentTemplate'; id: number; image: string; name: string; teaser: string }>;
};

export type RCreateAssignmentFromTemplateMutationVariables = Exact<{
  input: RCreateAssignmentFromTemplateInput;
}>;

export type RCreateAssignmentFromTemplateMutation = {
  __typename?: 'Mutation';
  createAssignmentFromTemplate: {
    __typename?: 'AssignmentsV3Result';
    success: boolean;
    assignment?:
      | { __typename?: 'AssignmentStandardV3'; id: number; name: string }
      | { __typename?: 'AssignmentStrategicV3'; id: number; name: string }
      | undefined;
  };
};

export type RAddAssignmentUserSurveyMutationVariables = Exact<{
  input: RAssignmentUserSurveyInput;
}>;

export type RAddAssignmentUserSurveyMutation = {
  __typename?: 'Mutation';
  addAssignmentUserSurvey: { __typename?: 'AddAssignmentUserSurveyResult'; success: boolean };
};

export type RAssignmentsV3UserRuleFieldsQueryVariables = Exact<{
  filter: RAssignmentsV3UserRuleFieldFilter;
}>;

export type RAssignmentsV3UserRuleFieldsQuery = {
  __typename?: 'Query';
  assignmentsV3UserRuleFields: Array<{
    __typename?: 'AssignmentsV3UserRuleField';
    field: string;
    values: Array<string | undefined>;
  }>;
};

export type RAssignmentsV3UserRulePreviewQueryVariables = Exact<{
  payload: RAssignmentsV3UserRulePreviewFilter;
}>;

export type RAssignmentsV3UserRulePreviewQuery = {
  __typename?: 'Query';
  assignmentsV3UserRulePreview: {
    __typename?: 'AssignmentsV3UserRulePreview';
    users: Array<{
      __typename?: 'AssignmentsV3UserRulePreviewUser';
      id: number;
      email: string;
      username?: string | undefined;
      profileImage?: string | undefined;
    }>;
  };
};

export type RAssignmentV3UsersQueryVariables = Exact<{
  filter: RAssignmentV3UsersFilter;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RAssignmentUsersV3Sort>;
  includeProgress: Scalars['Boolean']['input'];
}>;

export type RAssignmentV3UsersQuery = {
  __typename?: 'Query';
  assignmentV3Users:
    | {
        __typename?: 'AssignmentStandardV3UsersPage';
        total: number;
        data: Array<{
          __typename?: 'AssignmentStandardV3User';
          userId: number;
          assignmentId: number;
          progress?: {
            __typename: 'AssignmentStandardV3UserProgress';
            participations: Array<{
              __typename?: 'AssignmentStandardV3UserParticipation';
              assignmentLearningId: number;
              participationId: number;
              progress: number;
              completedAt?: Date | undefined;
            }>;
          };
          user: {
            __typename?: 'UserV2';
            id: number;
            email: string;
            profileImage?: string | undefined;
            username?: string | undefined;
            status: RUserStatus;
          };
        }>;
      }
    | {
        __typename?: 'AssignmentStrategicV3UsersPage';
        total: number;
        data: Array<{
          __typename?: 'AssignmentStrategicV3User';
          userId: number;
          assignmentId: number;
          progress?: { __typename?: 'AssignmentStrategicV3UserProgress'; completed: boolean; estimatedEffort: number };
          user: {
            __typename?: 'UserV2';
            id: number;
            email: string;
            profileImage?: string | undefined;
            username?: string | undefined;
            status: RUserStatus;
          };
        }>;
      };
};

export type RUserLearningContentLastParticipationQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  learningContentId: Scalars['URN']['input'];
}>;

export type RUserLearningContentLastParticipationQuery = {
  __typename?: 'Query';
  userLearningContentLastParticipation?:
    | {
        __typename?: 'ParticipationV2';
        id?: number | undefined;
        objectId: string;
        userId: number;
        progress: number;
        isCompleted: boolean;
        completedAt?: Date | undefined;
        plannedDuration?: number | undefined;
        plannedLearningsCount?: number | undefined;
        userEffort?: number | undefined;
        expiryAt?: Date | undefined;
      }
    | undefined;
};

export type RUserLearningContentLastParticipationsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  learningContentIdIn: Array<Scalars['URN']['input']> | Scalars['URN']['input'];
}>;

export type RUserLearningContentLastParticipationsQuery = {
  __typename?: 'Query';
  userLearningContentLastParticipations: Array<{
    __typename?: 'ParticipationV2';
    id?: number | undefined;
    objectId: string;
    userId: number;
    progress: number;
    isCompleted: boolean;
    completedAt?: Date | undefined;
    plannedDuration?: number | undefined;
    plannedLearningsCount?: number | undefined;
    userEffort?: number | undefined;
    expiryAt?: Date | undefined;
  }>;
};

export type RGetCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type RGetCategoriesQuery = {
  __typename?: 'Query';
  getCategories?:
    | Array<
        | {
            __typename?: 'Category';
            id?: number | undefined;
            name?: string | undefined;
            urlKey?: string | undefined;
            subjects?:
              | Array<
                  | { __typename?: 'Subject'; id?: number | undefined; name?: string | undefined; urlKey?: string | undefined }
                  | undefined
                >
              | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RLearningCollectionsV2QueryVariables = Exact<{
  filter: RLearningCollectionFilter;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RLearningCollectionSort>;
}>;

export type RLearningCollectionsV2Query = {
  __typename?: 'Query';
  learningCollectionsV2: {
    __typename?: 'LearningCollectionPage';
    limit: number;
    page: number;
    total: number;
    data: Array<{
      __typename?: 'LearningCollectionV2';
      id: number;
      title: string;
      visibility: RLearningV2Visibility;
      status: RLearningV2Status;
      space?: { __typename?: 'SpaceV2'; id: number; name: string } | undefined;
      subject?:
        | { __typename?: 'SubjectCategoryV2'; subjectId: number; subject: string; categoryId: number; category: string }
        | undefined;
      items: { __typename?: 'LearningCollectionItemPage'; total: number };
    }>;
  };
};

export type RLearningCollectionV2QueryVariables = Exact<{
  id: Scalars['Int']['input'];
  spaceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type RLearningCollectionV2Query = {
  __typename?: 'Query';
  learningCollectionV2: {
    __typename?: 'LearningCollectionV2';
    id: number;
    urn: string;
    title: string;
    imageURL?: string | undefined;
    visibility: RLearningV2Visibility;
    status: RLearningV2Status;
    updatedAt?: Date | undefined;
    updatedByUser?:
      | { __typename?: 'UserV2'; id: number; firstname?: string | undefined; lastname?: string | undefined }
      | undefined;
    space?: { __typename?: 'SpaceV2'; id: number; name: string } | undefined;
    subject?:
      | { __typename?: 'SubjectCategoryV2'; subjectId: number; subject: string; categoryId: number; category: string }
      | undefined;
    items: {
      __typename?: 'LearningCollectionItemPage';
      total: number;
      data: Array<{
        __typename?: 'LearningCollectionItem';
        collectionId: number;
        contentURNV1: string;
        curationURNV1: string;
        id: number;
        order: number;
        content?:
          | {
              __typename?: 'LearningContent';
              id: string;
              title: string;
              description: string;
              imageURL?: string | undefined;
              provider: RLearningContentProvider;
              plannedDuration?: number | undefined;
              metadata?:
                | {
                    __typename?: 'LearningContentMetadata';
                    language?: string | undefined;
                    level?: string | undefined;
                    type?: RLearningContentContentType | undefined;
                    timezone?: number | undefined;
                  }
                | undefined;
              curations: Array<{
                __typename?: 'LearningCuration';
                id: string;
                spaceId: number;
                launchURLPath?: string | undefined;
                title?: string | undefined;
                description?: string | undefined;
                imageURL?: string | undefined;
                editURLPath?: string | undefined;
                systemGenerated?: boolean | undefined;
              }>;
            }
          | undefined;
      }>;
    };
  };
};

export type RLearningContentFragment = {
  __typename?: 'LearningContent';
  id: string;
  idV1: string;
  title: string;
  description: string;
  imageURL?: string | undefined;
  provider: RLearningContentProvider;
  plannedDuration?: number | undefined;
  plannedLearningsCount?: number | undefined;
  metadata?:
    | {
        __typename?: 'LearningContentMetadata';
        language?: string | undefined;
        level?: string | undefined;
        type?: RLearningContentContentType | undefined;
        timezone?: number | undefined;
      }
    | undefined;
  locations?:
    | Array<{
        __typename?: 'LearningContentLocationData';
        id?: number | undefined;
        endDate?: Date | undefined;
        startDate?: Date | undefined;
        type?: RLocationType | undefined;
        address?: string | undefined;
        recordingURL?: string | undefined;
      }>
    | undefined;
  curations: Array<{
    __typename?: 'LearningCuration';
    id: string;
    spaceId: number;
    launchURLPath?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    imageURL?: string | undefined;
    editURLPath?: string | undefined;
    systemGenerated?: boolean | undefined;
  }>;
};

export type RParticipationFragment = {
  __typename?: 'ParticipationV2';
  id?: number | undefined;
  objectId: string;
  userId: number;
  progress: number;
  isCompleted: boolean;
  completedAt?: Date | undefined;
  plannedDuration?: number | undefined;
  plannedLearningsCount?: number | undefined;
  userEffort?: number | undefined;
  expiryAt?: Date | undefined;
};

export type RLearningContentProgressFragment = {
  __typename?: 'LearningContent';
  progress?:
    | {
        __typename?: 'ParticipationV2';
        id?: number | undefined;
        objectId: string;
        userId: number;
        progress: number;
        isCompleted: boolean;
        completedAt?: Date | undefined;
        plannedDuration?: number | undefined;
        plannedLearningsCount?: number | undefined;
        userEffort?: number | undefined;
        expiryAt?: Date | undefined;
      }
    | undefined;
};

export type RLearningSectionItemFragmentFragment = {
  __typename?: 'LearningSectionItem';
  availabilityScheduledAt?: Date | undefined;
  availabilityScheduledAtTimezone?: number | undefined;
  availabilityType: RLearningItemAvailabilityType;
  createdAt: Date;
  isOptional: boolean;
  learningId: number;
  learningItemURNV2: string;
  order: number;
  realms: Array<string>;
  updatedAt: Date;
  isLocked?: boolean;
  id: number;
  learningItem?:
    | {
        __typename?: 'LearningContent';
        id: string;
        idV1: string;
        title: string;
        description: string;
        imageURL?: string | undefined;
        provider: RLearningContentProvider;
        plannedDuration?: number | undefined;
        plannedLearningsCount?: number | undefined;
        locationsWithEnrollment?:
          | Array<{
              __typename?: 'LearningContentLocationData';
              id?: number | undefined;
              userLocationEnrollment?: Array<{ __typename?: 'Enrollment'; id: number }> | undefined;
            }>
          | undefined;
        metadata?:
          | {
              __typename?: 'LearningContentMetadata';
              language?: string | undefined;
              level?: string | undefined;
              type?: RLearningContentContentType | undefined;
              timezone?: number | undefined;
            }
          | undefined;
        locations?:
          | Array<{
              __typename?: 'LearningContentLocationData';
              id?: number | undefined;
              endDate?: Date | undefined;
              startDate?: Date | undefined;
              type?: RLocationType | undefined;
              address?: string | undefined;
              recordingURL?: string | undefined;
            }>
          | undefined;
        curations: Array<{
          __typename?: 'LearningCuration';
          id: string;
          spaceId: number;
          launchURLPath?: string | undefined;
          title?: string | undefined;
          description?: string | undefined;
          imageURL?: string | undefined;
          editURLPath?: string | undefined;
          systemGenerated?: boolean | undefined;
        }>;
        progress?:
          | {
              __typename?: 'ParticipationV2';
              id?: number | undefined;
              objectId: string;
              userId: number;
              progress: number;
              isCompleted: boolean;
              completedAt?: Date | undefined;
              plannedDuration?: number | undefined;
              plannedLearningsCount?: number | undefined;
              userEffort?: number | undefined;
              expiryAt?: Date | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type RReportingLearningSummaryQueryVariables = Exact<{
  args: RReportingLearningSummary_Arguments;
  distinct_on?: InputMaybe<Array<RLearning_Summary_Enum_Name> | RLearning_Summary_Enum_Name>;
}>;

export type RReportingLearningSummaryQuery = {
  __typename?: 'Query';
  reportingLearningSummary: Array<{
    __typename?: 'learning_summary';
    urn: string;
    title: string;
    type: string;
    not_started_count: any;
    started_count: any;
    completed_count: any;
    average_progress: any;
    completion_rate: any;
  }>;
};

export type RReportingLearningActivitiesInsightsQueryVariables = Exact<{
  where?: InputMaybe<RReportingLearningActivitiesInsights_Bool_Exp>;
  order_by?: InputMaybe<Array<RReportingLearningActivitiesInsights_Order_By> | RReportingLearningActivitiesInsights_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<
    Array<RReportingLearningActivitiesInsights_Select_Column> | RReportingLearningActivitiesInsights_Select_Column
  >;
  whereAggregate?: InputMaybe<RReportingLearningActivitiesInsights_Bool_Exp>;
}>;

export type RReportingLearningActivitiesInsightsQuery = {
  __typename?: 'Query';
  reportingLearningActivitiesInsights: Array<{
    __typename?: 'reportingLearningActivitiesInsights';
    activityURN?: string | undefined;
    activityType?: string | undefined;
    completedCount?: any | undefined;
    completionRate?: any | undefined;
    type?: string | undefined;
    totalEffortInSeconds?: any | undefined;
    title?: string | undefined;
    startedCount?: any | undefined;
    totalCount?: any | undefined;
    inProgressCount?: any | undefined;
    progress?: any | undefined;
    order?: number | undefined;
    plannedDuration?: number | undefined;
    notStartedCount?: any | undefined;
    metaUpdateTime?: any | undefined;
    learningURN?: string | undefined;
  }>;
  filteredTotal: {
    __typename?: 'reportingLearningActivitiesInsights_aggregate';
    aggregate?: { __typename?: 'reportingLearningActivitiesInsights_aggregate_fields'; count: number } | undefined;
  };
  total: {
    __typename?: 'reportingLearningActivitiesInsights_aggregate';
    aggregate?: { __typename?: 'reportingLearningActivitiesInsights_aggregate_fields'; count: number } | undefined;
  };
};

export type RReportingParticipantsInsightsQueryVariables = Exact<{
  where?: InputMaybe<RReportingParticipantsInsights_Bool_Exp>;
  order_by?: InputMaybe<Array<RReportingParticipantsInsights_Order_By> | RReportingParticipantsInsights_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<RReportingParticipantsInsights_Select_Column> | RReportingParticipantsInsights_Select_Column>;
  whereAggregate?: InputMaybe<RReportingParticipantsInsights_Bool_Exp>;
}>;

export type RReportingParticipantsInsightsQuery = {
  __typename?: 'Query';
  reportingParticipantsInsights: Array<{
    __typename?: 'reportingParticipantsInsights';
    status?: string | undefined;
    email?: string | undefined;
    progress?: any | undefined;
    firstStatement?: any | undefined;
    profileImage?: string | undefined;
    urn?: string | undefined;
    userId?: number | undefined;
    username?: string | undefined;
  }>;
  total: {
    __typename?: 'reportingParticipantsInsights_aggregate';
    aggregate?: { __typename?: 'reportingParticipantsInsights_aggregate_fields'; count: number } | undefined;
  };
};

export type RGenerateLearningActivitiesCsvMutationVariables = Exact<{
  input: RGenerateLearningReportCsvInput;
}>;

export type RGenerateLearningActivitiesCsvMutation = {
  __typename?: 'Mutation';
  generateLearningActivitiesCSV: {
    __typename?: 'GenerateLearningReportCSVResult';
    presignedURL?: string | undefined;
    success: boolean;
  };
};

export type RReportingMyLearningsQuizQueryVariables = Exact<{
  args: RReportingMyLearningsQuiz_Arguments;
}>;

export type RReportingMyLearningsQuizQuery = {
  __typename?: 'Query';
  reportingMyLearningsQuiz: Array<{
    __typename?: 'quiz';
    urn: string;
    activity_urn: string;
    question_id: string;
    question_title: string;
    total_answers: number;
    correct_answers: number;
    incorrect_answers: number;
    all_attempt_ratio: any;
    total_unique_user_answers: number;
    latest_correct_answers: number;
    latest_incorrect_answers: number;
    latest_attempt_ratio: any;
    latest_pass_ratio: any;
    latest_total_passed: number;
    latest_total_failed: number;
  }>;
};

export type RLearningWithActivitiesQueryVariables = Exact<{
  learningV2Id: Scalars['Int']['input'];
}>;

export type RLearningWithActivitiesQuery = {
  __typename?: 'Query';
  learningV2: {
    __typename?: 'LearningV2';
    id: number;
    title: string;
    activities?:
      | Array<{ __typename?: 'LearningActivityDto'; id: number; urn: string; data: any; learningId?: number | undefined }>
      | undefined;
  };
};

export type RGenerateLearningActivityQuizCsvMutationVariables = Exact<{
  input: RGenerateLearningActivityQuizCsvInput;
}>;

export type RGenerateLearningActivityQuizCsvMutation = {
  __typename?: 'Mutation';
  generateLearningActivityQuizCSV: {
    __typename?: 'GenerateLearningReportCSVResult';
    presignedURL?: string | undefined;
    success: boolean;
  };
};

export type RReportingSectionsItemsQueryVariables = Exact<{
  args: RReportingSectionsItems_Arguments;
  orderBy?: InputMaybe<Array<RSections_Items_Order_By> | RSections_Items_Order_By>;
}>;

export type RReportingSectionsItemsQuery = {
  __typename?: 'Query';
  reportingSectionsItems: Array<{
    __typename?: 'sections_items';
    urn: string;
    type: string;
    item_order: number;
    planned_duration: number;
    partner: string;
    team_ids: any;
    space_id: number;
    title: string;
  }>;
};

export type RReportingSectionsItemsInsightsQueryVariables = Exact<{
  args: RReportingSectionsItemsInsights_Arguments;
  orderBy?: InputMaybe<Array<RSections_Items_Insights_Order_By> | RSections_Items_Insights_Order_By>;
}>;

export type RReportingSectionsItemsInsightsQuery = {
  __typename?: 'Query';
  reportingSectionsItemsInsights: Array<{
    __typename?: 'sections_items_insights';
    urn: string;
    not_started_count: any;
    in_progress_count: any;
    completed_count: any;
    completion_rate: any;
    space_id: number;
    team_ids?: any | undefined;
  }>;
};

export type RReportingSectionsItemsTotalCountQueryVariables = Exact<{
  args: RReportingSectionsItemsTotalCount_Arguments;
  orderBy?: InputMaybe<Array<RTotal_Count_Order_By> | RTotal_Count_Order_By>;
}>;

export type RReportingSectionsItemsTotalCountQuery = {
  __typename?: 'Query';
  reportingSectionsItemsTotalCount: Array<{
    __typename?: 'total_count';
    total_count: any;
    space_id: number;
    space_ids: any;
    team_ids?: any | undefined;
  }>;
};

export type RMeQueryVariables = Exact<{ [key: string]: never }>;

export type RMeQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'Me';
    acceptedExtraTerms: boolean;
    acceptedGdpr: boolean;
    acceptedTos: boolean;
    email: string;
    firstname?: string | undefined;
    id: number;
    isDebugging: boolean;
    language?: string | undefined;
    lastname?: string | undefined;
    profileImage?: string | undefined;
    realm: string;
    status: RUserStatus;
    username?: string | undefined;
    permissions: {
      __typename?: 'MePermissions';
      hasViewAccessToAdminPanel: boolean;
      hasViewAccessToManagerDashboard: boolean;
      hasWriteAccessToInternals: boolean;
    };
  };
};

export type RPostFragmentFragment = {
  __typename: 'Post';
  id?: number | undefined;
  title?: string | undefined;
  content?: string | undefined;
  created?: string | undefined;
  deleted?: boolean | undefined;
  publishDate?: string | undefined;
  sticky?: boolean | undefined;
  media?: { __typename?: 'PostMedia'; url?: string | undefined; type?: RPostMediaType | undefined } | undefined;
  user?:
    | {
        __typename?: 'PostUser';
        id?: number | undefined;
        username?: string | undefined;
        realm?: string | undefined;
        email?: string | undefined;
        profileImage?: string | undefined;
        role?: { __typename?: 'PostUserRole'; labels?: Array<string | undefined> | undefined } | undefined;
      }
    | undefined;
  section?: { __typename?: 'Section'; path?: string | undefined } | undefined;
  permissions?:
    | {
        __typename?: 'PostPermissions';
        canReply?: boolean | undefined;
        canEdit?: boolean | undefined;
        canDelete?: boolean | undefined;
        canSticky?: boolean | undefined;
        canUnsticky?: boolean | undefined;
        canViewReflectionReplies?: boolean | undefined;
      }
    | undefined;
  stats?: { __typename?: 'Stats'; likes?: number | undefined; replies?: number | undefined } | undefined;
  you?: { __typename?: 'You'; have?: { __typename?: 'UserStats'; liked?: number | undefined } | undefined } | undefined;
};

export type RSectionFragmentFragment = {
  __typename: 'Section';
  id?: string | undefined;
  path?: string | undefined;
  title?: string | undefined;
  description?: string | undefined;
  role?:
    | {
        __typename?: 'PermissionsRole';
        permissions?:
          | {
              __typename?: 'SectionPermissions';
              canPost?: boolean | undefined;
              canPostSticky?: boolean | undefined;
              canAddReflections?: boolean | undefined;
              canViewReflections?: boolean | undefined;
              canEditSection?: boolean | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type RGetSectionQueryVariables = Exact<{
  path: Array<Scalars['String']['input']> | Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RGetSectionQuery = {
  __typename?: 'Query';
  getSection?:
    | {
        __typename: 'Section';
        id?: string | undefined;
        path?: string | undefined;
        title?: string | undefined;
        description?: string | undefined;
        posts?:
          | {
              __typename?: 'PostsMeta';
              page?: number | undefined;
              pageSize?: number | undefined;
              total?: number | undefined;
              pages?: number | undefined;
              items?:
                | Array<
                    | {
                        __typename: 'Post';
                        id?: number | undefined;
                        title?: string | undefined;
                        content?: string | undefined;
                        created?: string | undefined;
                        deleted?: boolean | undefined;
                        publishDate?: string | undefined;
                        sticky?: boolean | undefined;
                        media?:
                          | { __typename?: 'PostMedia'; url?: string | undefined; type?: RPostMediaType | undefined }
                          | undefined;
                        user?:
                          | {
                              __typename?: 'PostUser';
                              id?: number | undefined;
                              username?: string | undefined;
                              realm?: string | undefined;
                              email?: string | undefined;
                              profileImage?: string | undefined;
                              role?: { __typename?: 'PostUserRole'; labels?: Array<string | undefined> | undefined } | undefined;
                            }
                          | undefined;
                        section?: { __typename?: 'Section'; path?: string | undefined } | undefined;
                        permissions?:
                          | {
                              __typename?: 'PostPermissions';
                              canReply?: boolean | undefined;
                              canEdit?: boolean | undefined;
                              canDelete?: boolean | undefined;
                              canSticky?: boolean | undefined;
                              canUnsticky?: boolean | undefined;
                              canViewReflectionReplies?: boolean | undefined;
                            }
                          | undefined;
                        stats?: { __typename?: 'Stats'; likes?: number | undefined; replies?: number | undefined } | undefined;
                        you?:
                          | { __typename?: 'You'; have?: { __typename?: 'UserStats'; liked?: number | undefined } | undefined }
                          | undefined;
                      }
                    | undefined
                  >
                | undefined;
            }
          | undefined;
        stickyPosts?:
          | Array<
              | {
                  __typename: 'Post';
                  id?: number | undefined;
                  title?: string | undefined;
                  content?: string | undefined;
                  created?: string | undefined;
                  deleted?: boolean | undefined;
                  publishDate?: string | undefined;
                  sticky?: boolean | undefined;
                  media?: { __typename?: 'PostMedia'; url?: string | undefined; type?: RPostMediaType | undefined } | undefined;
                  user?:
                    | {
                        __typename?: 'PostUser';
                        id?: number | undefined;
                        username?: string | undefined;
                        realm?: string | undefined;
                        email?: string | undefined;
                        profileImage?: string | undefined;
                        role?: { __typename?: 'PostUserRole'; labels?: Array<string | undefined> | undefined } | undefined;
                      }
                    | undefined;
                  section?: { __typename?: 'Section'; path?: string | undefined } | undefined;
                  permissions?:
                    | {
                        __typename?: 'PostPermissions';
                        canReply?: boolean | undefined;
                        canEdit?: boolean | undefined;
                        canDelete?: boolean | undefined;
                        canSticky?: boolean | undefined;
                        canUnsticky?: boolean | undefined;
                        canViewReflectionReplies?: boolean | undefined;
                      }
                    | undefined;
                  stats?: { __typename?: 'Stats'; likes?: number | undefined; replies?: number | undefined } | undefined;
                  you?:
                    | { __typename?: 'You'; have?: { __typename?: 'UserStats'; liked?: number | undefined } | undefined }
                    | undefined;
                }
              | undefined
            >
          | undefined;
        subsections?:
          | Array<
              | { __typename?: 'SubSection'; id?: number | undefined; title?: string | undefined; path?: string | undefined }
              | undefined
            >
          | undefined;
        role?:
          | {
              __typename?: 'PermissionsRole';
              permissions?:
                | {
                    __typename?: 'SectionPermissions';
                    canPost?: boolean | undefined;
                    canPostSticky?: boolean | undefined;
                    canAddReflections?: boolean | undefined;
                    canViewReflections?: boolean | undefined;
                    canEditSection?: boolean | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type RGetRepliesQueryVariables = Exact<{
  path: Array<Scalars['String']['input']> | Scalars['String']['input'];
  postId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RGetRepliesQuery = {
  __typename?: 'Query';
  getReplies?:
    | {
        __typename?: 'Replies';
        post?:
          | {
              __typename: 'Post';
              id?: number | undefined;
              title?: string | undefined;
              content?: string | undefined;
              created?: string | undefined;
              deleted?: boolean | undefined;
              publishDate?: string | undefined;
              sticky?: boolean | undefined;
              media?: { __typename?: 'PostMedia'; url?: string | undefined; type?: RPostMediaType | undefined } | undefined;
              user?:
                | {
                    __typename?: 'PostUser';
                    id?: number | undefined;
                    username?: string | undefined;
                    realm?: string | undefined;
                    email?: string | undefined;
                    profileImage?: string | undefined;
                    role?: { __typename?: 'PostUserRole'; labels?: Array<string | undefined> | undefined } | undefined;
                  }
                | undefined;
              section?: { __typename?: 'Section'; path?: string | undefined } | undefined;
              permissions?:
                | {
                    __typename?: 'PostPermissions';
                    canReply?: boolean | undefined;
                    canEdit?: boolean | undefined;
                    canDelete?: boolean | undefined;
                    canSticky?: boolean | undefined;
                    canUnsticky?: boolean | undefined;
                    canViewReflectionReplies?: boolean | undefined;
                  }
                | undefined;
              stats?: { __typename?: 'Stats'; likes?: number | undefined; replies?: number | undefined } | undefined;
              you?:
                | { __typename?: 'You'; have?: { __typename?: 'UserStats'; liked?: number | undefined } | undefined }
                | undefined;
            }
          | undefined;
        replies?:
          | {
              __typename?: 'PostsMeta';
              page?: number | undefined;
              pageSize?: number | undefined;
              total?: number | undefined;
              pages?: number | undefined;
              items?:
                | Array<
                    | {
                        __typename: 'Post';
                        id?: number | undefined;
                        title?: string | undefined;
                        content?: string | undefined;
                        created?: string | undefined;
                        deleted?: boolean | undefined;
                        publishDate?: string | undefined;
                        sticky?: boolean | undefined;
                        media?:
                          | { __typename?: 'PostMedia'; url?: string | undefined; type?: RPostMediaType | undefined }
                          | undefined;
                        user?:
                          | {
                              __typename?: 'PostUser';
                              id?: number | undefined;
                              username?: string | undefined;
                              realm?: string | undefined;
                              email?: string | undefined;
                              profileImage?: string | undefined;
                              role?: { __typename?: 'PostUserRole'; labels?: Array<string | undefined> | undefined } | undefined;
                            }
                          | undefined;
                        section?: { __typename?: 'Section'; path?: string | undefined } | undefined;
                        permissions?:
                          | {
                              __typename?: 'PostPermissions';
                              canReply?: boolean | undefined;
                              canEdit?: boolean | undefined;
                              canDelete?: boolean | undefined;
                              canSticky?: boolean | undefined;
                              canUnsticky?: boolean | undefined;
                              canViewReflectionReplies?: boolean | undefined;
                            }
                          | undefined;
                        stats?: { __typename?: 'Stats'; likes?: number | undefined; replies?: number | undefined } | undefined;
                        you?:
                          | { __typename?: 'You'; have?: { __typename?: 'UserStats'; liked?: number | undefined } | undefined }
                          | undefined;
                      }
                    | undefined
                  >
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type RGetUserRepliesQueryVariables = Exact<{
  path: Array<Scalars['String']['input']> | Scalars['String']['input'];
  postId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RGetUserRepliesQuery = {
  __typename?: 'Query';
  getUserReplies?:
    | {
        __typename?: 'Replies';
        replies?:
          | {
              __typename?: 'PostsMeta';
              page?: number | undefined;
              pageSize?: number | undefined;
              total?: number | undefined;
              pages?: number | undefined;
              items?:
                | Array<
                    | {
                        __typename: 'Post';
                        id?: number | undefined;
                        title?: string | undefined;
                        content?: string | undefined;
                        created?: string | undefined;
                        deleted?: boolean | undefined;
                        publishDate?: string | undefined;
                        sticky?: boolean | undefined;
                        media?:
                          | { __typename?: 'PostMedia'; url?: string | undefined; type?: RPostMediaType | undefined }
                          | undefined;
                        user?:
                          | {
                              __typename?: 'PostUser';
                              id?: number | undefined;
                              username?: string | undefined;
                              realm?: string | undefined;
                              email?: string | undefined;
                              profileImage?: string | undefined;
                              role?: { __typename?: 'PostUserRole'; labels?: Array<string | undefined> | undefined } | undefined;
                            }
                          | undefined;
                        section?: { __typename?: 'Section'; path?: string | undefined } | undefined;
                        permissions?:
                          | {
                              __typename?: 'PostPermissions';
                              canReply?: boolean | undefined;
                              canEdit?: boolean | undefined;
                              canDelete?: boolean | undefined;
                              canSticky?: boolean | undefined;
                              canUnsticky?: boolean | undefined;
                              canViewReflectionReplies?: boolean | undefined;
                            }
                          | undefined;
                        stats?: { __typename?: 'Stats'; likes?: number | undefined; replies?: number | undefined } | undefined;
                        you?:
                          | { __typename?: 'You'; have?: { __typename?: 'UserStats'; liked?: number | undefined } | undefined }
                          | undefined;
                      }
                    | undefined
                  >
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type RGetPostQueryVariables = Exact<{
  path: Array<Scalars['String']['input']> | Scalars['String']['input'];
  postId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RGetPostQuery = {
  __typename?: 'Query';
  getPost?:
    | {
        __typename: 'Post';
        id?: number | undefined;
        title?: string | undefined;
        content?: string | undefined;
        created?: string | undefined;
        deleted?: boolean | undefined;
        publishDate?: string | undefined;
        sticky?: boolean | undefined;
        media?: { __typename?: 'PostMedia'; url?: string | undefined; type?: RPostMediaType | undefined } | undefined;
        user?:
          | {
              __typename?: 'PostUser';
              id?: number | undefined;
              username?: string | undefined;
              realm?: string | undefined;
              email?: string | undefined;
              profileImage?: string | undefined;
              role?: { __typename?: 'PostUserRole'; labels?: Array<string | undefined> | undefined } | undefined;
            }
          | undefined;
        section?: { __typename?: 'Section'; path?: string | undefined } | undefined;
        permissions?:
          | {
              __typename?: 'PostPermissions';
              canReply?: boolean | undefined;
              canEdit?: boolean | undefined;
              canDelete?: boolean | undefined;
              canSticky?: boolean | undefined;
              canUnsticky?: boolean | undefined;
              canViewReflectionReplies?: boolean | undefined;
            }
          | undefined;
        stats?: { __typename?: 'Stats'; likes?: number | undefined; replies?: number | undefined } | undefined;
        you?: { __typename?: 'You'; have?: { __typename?: 'UserStats'; liked?: number | undefined } | undefined } | undefined;
      }
    | undefined;
};

export type RCreateSectionMutationVariables = Exact<{
  payload?: InputMaybe<RCreateSectionInput>;
}>;

export type RCreateSectionMutation = {
  __typename?: 'Mutation';
  createSection?:
    | {
        __typename: 'Section';
        id?: string | undefined;
        path?: string | undefined;
        title?: string | undefined;
        description?: string | undefined;
        role?:
          | {
              __typename?: 'PermissionsRole';
              permissions?:
                | {
                    __typename?: 'SectionPermissions';
                    canPost?: boolean | undefined;
                    canPostSticky?: boolean | undefined;
                    canAddReflections?: boolean | undefined;
                    canViewReflections?: boolean | undefined;
                    canEditSection?: boolean | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type RUpdateSectionMutationVariables = Exact<{
  payload?: InputMaybe<RUpdateSectionInput>;
}>;

export type RUpdateSectionMutation = {
  __typename?: 'Mutation';
  updateSection?:
    | {
        __typename: 'Section';
        id?: string | undefined;
        path?: string | undefined;
        title?: string | undefined;
        description?: string | undefined;
        role?:
          | {
              __typename?: 'PermissionsRole';
              permissions?:
                | {
                    __typename?: 'SectionPermissions';
                    canPost?: boolean | undefined;
                    canPostSticky?: boolean | undefined;
                    canAddReflections?: boolean | undefined;
                    canViewReflections?: boolean | undefined;
                    canEditSection?: boolean | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type RCreatePostMutationVariables = Exact<{
  path: Array<Scalars['String']['input']> | Scalars['String']['input'];
  payload?: InputMaybe<RPostInput>;
}>;

export type RCreatePostMutation = {
  __typename?: 'Mutation';
  createPost?:
    | {
        __typename: 'Post';
        id?: number | undefined;
        title?: string | undefined;
        content?: string | undefined;
        created?: string | undefined;
        deleted?: boolean | undefined;
        publishDate?: string | undefined;
        sticky?: boolean | undefined;
        media?: { __typename?: 'PostMedia'; url?: string | undefined; type?: RPostMediaType | undefined } | undefined;
        user?:
          | {
              __typename?: 'PostUser';
              id?: number | undefined;
              username?: string | undefined;
              realm?: string | undefined;
              email?: string | undefined;
              profileImage?: string | undefined;
              role?: { __typename?: 'PostUserRole'; labels?: Array<string | undefined> | undefined } | undefined;
            }
          | undefined;
        section?: { __typename?: 'Section'; path?: string | undefined } | undefined;
        permissions?:
          | {
              __typename?: 'PostPermissions';
              canReply?: boolean | undefined;
              canEdit?: boolean | undefined;
              canDelete?: boolean | undefined;
              canSticky?: boolean | undefined;
              canUnsticky?: boolean | undefined;
              canViewReflectionReplies?: boolean | undefined;
            }
          | undefined;
        stats?: { __typename?: 'Stats'; likes?: number | undefined; replies?: number | undefined } | undefined;
        you?: { __typename?: 'You'; have?: { __typename?: 'UserStats'; liked?: number | undefined } | undefined } | undefined;
      }
    | undefined;
};

export type RUpdatePostMutationVariables = Exact<{
  path: Array<Scalars['String']['input']> | Scalars['String']['input'];
  postId?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<RPostInput>;
}>;

export type RUpdatePostMutation = {
  __typename?: 'Mutation';
  updatePost?:
    | {
        __typename: 'Post';
        id?: number | undefined;
        title?: string | undefined;
        content?: string | undefined;
        created?: string | undefined;
        deleted?: boolean | undefined;
        publishDate?: string | undefined;
        sticky?: boolean | undefined;
        media?: { __typename?: 'PostMedia'; url?: string | undefined; type?: RPostMediaType | undefined } | undefined;
        user?:
          | {
              __typename?: 'PostUser';
              id?: number | undefined;
              username?: string | undefined;
              realm?: string | undefined;
              email?: string | undefined;
              profileImage?: string | undefined;
              role?: { __typename?: 'PostUserRole'; labels?: Array<string | undefined> | undefined } | undefined;
            }
          | undefined;
        section?: { __typename?: 'Section'; path?: string | undefined } | undefined;
        permissions?:
          | {
              __typename?: 'PostPermissions';
              canReply?: boolean | undefined;
              canEdit?: boolean | undefined;
              canDelete?: boolean | undefined;
              canSticky?: boolean | undefined;
              canUnsticky?: boolean | undefined;
              canViewReflectionReplies?: boolean | undefined;
            }
          | undefined;
        stats?: { __typename?: 'Stats'; likes?: number | undefined; replies?: number | undefined } | undefined;
        you?: { __typename?: 'You'; have?: { __typename?: 'UserStats'; liked?: number | undefined } | undefined } | undefined;
      }
    | undefined;
};

export type RDeletePostMutationVariables = Exact<{
  path: Array<Scalars['String']['input']> | Scalars['String']['input'];
  postId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RDeletePostMutation = {
  __typename?: 'Mutation';
  deletePost?:
    | {
        __typename: 'Post';
        id?: number | undefined;
        title?: string | undefined;
        content?: string | undefined;
        created?: string | undefined;
        deleted?: boolean | undefined;
        publishDate?: string | undefined;
        sticky?: boolean | undefined;
        media?: { __typename?: 'PostMedia'; url?: string | undefined; type?: RPostMediaType | undefined } | undefined;
        user?:
          | {
              __typename?: 'PostUser';
              id?: number | undefined;
              username?: string | undefined;
              realm?: string | undefined;
              email?: string | undefined;
              profileImage?: string | undefined;
              role?: { __typename?: 'PostUserRole'; labels?: Array<string | undefined> | undefined } | undefined;
            }
          | undefined;
        section?: { __typename?: 'Section'; path?: string | undefined } | undefined;
        permissions?:
          | {
              __typename?: 'PostPermissions';
              canReply?: boolean | undefined;
              canEdit?: boolean | undefined;
              canDelete?: boolean | undefined;
              canSticky?: boolean | undefined;
              canUnsticky?: boolean | undefined;
              canViewReflectionReplies?: boolean | undefined;
            }
          | undefined;
        stats?: { __typename?: 'Stats'; likes?: number | undefined; replies?: number | undefined } | undefined;
        you?: { __typename?: 'You'; have?: { __typename?: 'UserStats'; liked?: number | undefined } | undefined } | undefined;
      }
    | undefined;
};

export type RToggleActionMutationVariables = Exact<{
  path: Array<Scalars['String']['input']> | Scalars['String']['input'];
  postId?: InputMaybe<Scalars['Int']['input']>;
  action?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<RPostActionInput>;
}>;

export type RToggleActionMutation = {
  __typename?: 'Mutation';
  toggleAction?:
    | {
        __typename: 'Post';
        id?: number | undefined;
        title?: string | undefined;
        content?: string | undefined;
        created?: string | undefined;
        deleted?: boolean | undefined;
        publishDate?: string | undefined;
        sticky?: boolean | undefined;
        media?: { __typename?: 'PostMedia'; url?: string | undefined; type?: RPostMediaType | undefined } | undefined;
        user?:
          | {
              __typename?: 'PostUser';
              id?: number | undefined;
              username?: string | undefined;
              realm?: string | undefined;
              email?: string | undefined;
              profileImage?: string | undefined;
              role?: { __typename?: 'PostUserRole'; labels?: Array<string | undefined> | undefined } | undefined;
            }
          | undefined;
        section?: { __typename?: 'Section'; path?: string | undefined } | undefined;
        permissions?:
          | {
              __typename?: 'PostPermissions';
              canReply?: boolean | undefined;
              canEdit?: boolean | undefined;
              canDelete?: boolean | undefined;
              canSticky?: boolean | undefined;
              canUnsticky?: boolean | undefined;
              canViewReflectionReplies?: boolean | undefined;
            }
          | undefined;
        stats?: { __typename?: 'Stats'; likes?: number | undefined; replies?: number | undefined } | undefined;
        you?: { __typename?: 'You'; have?: { __typename?: 'UserStats'; liked?: number | undefined } | undefined } | undefined;
      }
    | undefined;
};

export type REnrollmentCreateByEmailsMutationVariables = Exact<{
  input: REnrollByEmailInput;
}>;

export type REnrollmentCreateByEmailsMutation = {
  __typename?: 'Mutation';
  enrollmentCreateByEmails: Array<{
    __typename?: 'Enrollment';
    id: number;
    locationId: number;
    userId: number;
    enrolledAt: Date;
    attended: RAttendedType;
  }>;
};

export type REnrollSelfMutationVariables = Exact<{
  input: REnrollSelfInput;
}>;

export type REnrollSelfMutation = {
  __typename?: 'Mutation';
  enrollSelf: {
    __typename?: 'Enrollment';
    id: number;
    locationId: number;
    userId: number;
    enrolledAt: Date;
    attended: RAttendedType;
  };
};

export type RDeleteEnrollmentMutationVariables = Exact<{
  input: RDeleteEnrollmentInput;
}>;

export type RDeleteEnrollmentMutation = { __typename?: 'Mutation'; deleteEnrollment: boolean };

export type REnrollmentsQueryVariables = Exact<{
  input: REnrollmentsInput;
}>;

export type REnrollmentsQuery = {
  __typename?: 'Query';
  enrollments: Array<{
    __typename?: 'Enrollment';
    id: number;
    locationId: number;
    userId: number;
    enrolledAt: Date;
    attended: RAttendedType;
    user?: { __typename?: 'UserV2'; username?: string | undefined; email: string; profileImage?: string | undefined } | undefined;
  }>;
};

export type RSetEnrollmentAttendanceMutationVariables = Exact<{
  input: RSetEnrollmentAttendanceInput;
}>;

export type RSetEnrollmentAttendanceMutation = {
  __typename?: 'Mutation';
  setEnrollmentAttendance: {
    __typename?: 'Enrollment';
    id: number;
    locationId: number;
    userId: number;
    enrolledAt: Date;
    attended: RAttendedType;
  };
};

export type RSetBulkEnrollmentAttendanceMutationVariables = Exact<{
  input: Array<RSetEnrollmentAttendanceInput> | RSetEnrollmentAttendanceInput;
}>;

export type RSetBulkEnrollmentAttendanceMutation = {
  __typename?: 'Mutation';
  setBulkEnrollmentAttendance: Array<{
    __typename?: 'Enrollment';
    id: number;
    locationId: number;
    userId: number;
    enrolledAt: Date;
    attended: RAttendedType;
  }>;
};

export type RRealmFeatureTogglesQueryVariables = Exact<{
  realm: Scalars['String']['input'];
}>;

export type RRealmFeatureTogglesQuery = {
  __typename?: 'Query';
  realmFeatureToggles?: Array<{ __typename?: 'RealmFeatureToggle'; name: string }> | undefined;
};

export type RUserFeatureTogglesQueryVariables = Exact<{
  realm: Scalars['String']['input'];
}>;

export type RUserFeatureTogglesQuery = {
  __typename?: 'Query';
  getCurrentUserFeatureToggles?: Array<{ __typename?: 'UserFeatureToggle'; name: string }> | undefined;
};

export type RSubmitFeedbackMutationVariables = Exact<{
  input: RSubmitFeedbackInput;
}>;

export type RSubmitFeedbackMutation = {
  __typename?: 'Mutation';
  submitFeedback: {
    __typename?: 'SubmitFeedbackResult';
    success: boolean;
    ticket?:
      | {
          __typename?: 'FeedbackTicket';
          id: number;
          subject: string;
          description: string;
          status: RFeedbackTicketStatus;
          priority: RFeedbackTicketPriority;
          type: string;
          tags?: Array<string> | undefined;
        }
      | undefined;
  };
};

export type RInventoryFragmentFragment = {
  __typename?: 'InventoryItem';
  name?: string | undefined;
  id?: number | undefined;
  productId?: number | undefined;
  userSelfTrackedLearningId?: number | undefined;
  journeyId?: number | undefined;
  label?: string | undefined;
  spaceId?: number | undefined;
  state?: string | undefined;
  image?: string | undefined;
  provider?: string | undefined;
  providerAccess?: string | undefined;
  customLink?: string | undefined;
  accessLink?: string | undefined;
  teaser?: string | undefined;
  totalEffort?: number | undefined;
  totalLearningsCount?: number | undefined;
  orderId?: number | undefined;
  isCancellable?: boolean | undefined;
  isApprovalRequired?: boolean | undefined;
  mandatory?: boolean | undefined;
  isExternal?: boolean | undefined;
  objectId?: string | undefined;
  archived?: boolean | undefined;
  participation?:
    | { __typename?: 'Participation'; completedAt?: Date | undefined; progress: number; userEffort?: number | undefined }
    | undefined;
  variant?:
    | {
        __typename?: 'Variant';
        id?: number | undefined;
        name: string;
        validFrom?: string | undefined;
        validTo?: string | undefined;
        meta?: { __typename?: 'ProductMeta'; METHOD?: string | undefined; LOCATION?: string | undefined } | undefined;
      }
    | undefined;
};

export type RMyEnrollmentsFragmentFragment = {
  __typename?: 'EventEnrollment';
  id: number;
  learningId: number;
  locationId: number;
  title: string;
  teaser: string;
  type: string;
  image?: string | undefined;
  address?: string | undefined;
  startDate?: Date | undefined;
  endDate?: Date | undefined;
  room?: string | undefined;
};

export type RGetInventoryQueryVariables = Exact<{ [key: string]: never }>;

export type RGetInventoryQuery = {
  __typename?: 'Query';
  getInventory?:
    | {
        __typename?: 'Inventory';
        ongoing?:
          | Array<
              | {
                  __typename?: 'InventoryItem';
                  name?: string | undefined;
                  id?: number | undefined;
                  productId?: number | undefined;
                  userSelfTrackedLearningId?: number | undefined;
                  journeyId?: number | undefined;
                  label?: string | undefined;
                  spaceId?: number | undefined;
                  state?: string | undefined;
                  image?: string | undefined;
                  provider?: string | undefined;
                  providerAccess?: string | undefined;
                  customLink?: string | undefined;
                  accessLink?: string | undefined;
                  teaser?: string | undefined;
                  totalEffort?: number | undefined;
                  totalLearningsCount?: number | undefined;
                  orderId?: number | undefined;
                  isCancellable?: boolean | undefined;
                  isApprovalRequired?: boolean | undefined;
                  mandatory?: boolean | undefined;
                  isExternal?: boolean | undefined;
                  objectId?: string | undefined;
                  archived?: boolean | undefined;
                  participation?:
                    | {
                        __typename?: 'Participation';
                        completedAt?: Date | undefined;
                        progress: number;
                        userEffort?: number | undefined;
                      }
                    | undefined;
                  variant?:
                    | {
                        __typename?: 'Variant';
                        id?: number | undefined;
                        name: string;
                        validFrom?: string | undefined;
                        validTo?: string | undefined;
                        meta?:
                          | { __typename?: 'ProductMeta'; METHOD?: string | undefined; LOCATION?: string | undefined }
                          | undefined;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
        completed?:
          | Array<
              | {
                  __typename?: 'InventoryItem';
                  name?: string | undefined;
                  id?: number | undefined;
                  productId?: number | undefined;
                  userSelfTrackedLearningId?: number | undefined;
                  journeyId?: number | undefined;
                  label?: string | undefined;
                  spaceId?: number | undefined;
                  state?: string | undefined;
                  image?: string | undefined;
                  provider?: string | undefined;
                  providerAccess?: string | undefined;
                  customLink?: string | undefined;
                  accessLink?: string | undefined;
                  teaser?: string | undefined;
                  totalEffort?: number | undefined;
                  totalLearningsCount?: number | undefined;
                  orderId?: number | undefined;
                  isCancellable?: boolean | undefined;
                  isApprovalRequired?: boolean | undefined;
                  mandatory?: boolean | undefined;
                  isExternal?: boolean | undefined;
                  objectId?: string | undefined;
                  archived?: boolean | undefined;
                  participation?:
                    | {
                        __typename?: 'Participation';
                        completedAt?: Date | undefined;
                        progress: number;
                        userEffort?: number | undefined;
                      }
                    | undefined;
                  variant?:
                    | {
                        __typename?: 'Variant';
                        id?: number | undefined;
                        name: string;
                        validFrom?: string | undefined;
                        validTo?: string | undefined;
                        meta?:
                          | { __typename?: 'ProductMeta'; METHOD?: string | undefined; LOCATION?: string | undefined }
                          | undefined;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
  myEnrollments: Array<{
    __typename?: 'EventEnrollment';
    id: number;
    learningId: number;
    locationId: number;
    title: string;
    teaser: string;
    type: string;
    image?: string | undefined;
    address?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    room?: string | undefined;
  }>;
};

export type RGetHistoricCompletedCoursesQueryVariables = Exact<{ [key: string]: never }>;

export type RGetHistoricCompletedCoursesQuery = {
  __typename?: 'Query';
  getHistoricCompletedCourses?:
    | Array<
        | {
            __typename?: 'HistoricCompletedCourse';
            id?: number | undefined;
            name?: string | undefined;
            completed?: string | undefined;
            type?: string | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RCancelMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;

export type RCancelMutation = {
  __typename?: 'Mutation';
  cancel?: { __typename?: 'ReturnData'; value?: string | undefined } | undefined;
};

export type RCertificatePropertiesQueryVariables = Exact<{
  urn: Scalars['URN']['input'];
}>;

export type RCertificatePropertiesQuery = {
  __typename?: 'Query';
  certificateProperties?:
    | {
        __typename?: 'CertificateProperties';
        date?: string | undefined;
        description?: string | undefined;
        header?: string | undefined;
        title?: string | undefined;
        templateType: RCertificateTemplateType;
        urn: string;
        updatedAt: Date;
        updatedBy: number;
        logos: Array<{
          __typename?: 'CertificateLogo';
          logoUrl?: string | undefined;
          order: number;
          organisationText?: string | undefined;
        }>;
        signatures: Array<{
          __typename?: 'CertificateSignature';
          title?: string | undefined;
          signatureUrl?: string | undefined;
          order: number;
          name?: string | undefined;
          institution?: string | undefined;
        }>;
      }
    | undefined;
};

export type RUpsertCertificatePropertiesMutationVariables = Exact<{
  input: RUpsertCertificatePropertiesInput;
}>;

export type RUpsertCertificatePropertiesMutation = {
  __typename?: 'Mutation';
  upsertCertificateProperties: {
    __typename?: 'CertificateProperties';
    templateType: RCertificateTemplateType;
    title?: string | undefined;
    updatedAt: Date;
    updatedBy: number;
    urn: string;
    date?: string | undefined;
    description?: string | undefined;
    header?: string | undefined;
    signatures: Array<{
      __typename?: 'CertificateSignature';
      title?: string | undefined;
      signatureUrl?: string | undefined;
      order: number;
      name?: string | undefined;
      institution?: string | undefined;
    }>;
    logos: Array<{
      __typename?: 'CertificateLogo';
      logoUrl?: string | undefined;
      order: number;
      organisationText?: string | undefined;
    }>;
  };
};

export type RLearningJourneyPreviewCohortImportMutationVariables = Exact<{
  input: RLearningJourneyCohortImportInput;
}>;

export type RLearningJourneyPreviewCohortImportMutation = {
  __typename?: 'Mutation';
  learningJourneyPreviewCohortImport: {
    __typename?: 'LearningJourneyCohortImportPreviewResult';
    success: boolean;
    errorCause?:
      | { __typename?: 'LearningJourneyCohortImportFileError'; code: RLearningJourneyCohortImportFileErrorCode }
      | undefined;
    data?:
      | {
          __typename?: 'LearningJourneyCohortImportPreview';
          stats: {
            __typename?: 'LearningJourneyCohortImportPreviewStats';
            total: number;
            willAdd: number;
            alreadyInCohort: number;
            userNotFound: number;
            invalidEmail: number;
            duplicateInFile: number;
          };
          rows: Array<{
            __typename?: 'LearningJourneyCohortImportRowPreview';
            outcome: RLearningJourneyCohortImportRowOutcome;
            row: { __typename?: 'LearningJourneyCohortImportSourceRow'; email: string; sourceLine: number };
          }>;
        }
      | undefined;
  };
};

export type RLearningJourneyConfirmCohortImportMutationVariables = Exact<{
  input: RLearningJourneyCohortImportInput;
}>;

export type RLearningJourneyConfirmCohortImportMutation = {
  __typename?: 'Mutation';
  learningJourneyConfirmCohortImport: {
    __typename?: 'LearningJourneyCohortImportResult';
    accepted: boolean;
    batchId: string;
    willAddCount: number;
  };
};

export type RLearningJourneyTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type RLearningJourneyTemplatesQuery = {
  __typename?: 'Query';
  learningJourneyTemplates: Array<{
    __typename?: 'LearningJourneyTemplateDto';
    id: number;
    bannerURL: string;
    teaser: string;
    title: string;
  }>;
};

export type RCreateLearningJourneyFromTemplateMutationVariables = Exact<{
  input: RCreateLearningJourneyFromTemplateInput;
}>;

export type RCreateLearningJourneyFromTemplateMutation = {
  __typename?: 'Mutation';
  createLearningJourneyFromTemplate: {
    __typename?: 'LearningJourneyResult';
    success: boolean;
    journey?: { __typename?: 'LearningJourney'; id: number } | undefined;
  };
};

export type RLearningJourneyQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  includeItems: Scalars['Boolean']['input'];
  spaceIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
  includeCohortTeams: Scalars['Boolean']['input'];
  includeUpdateByUser: Scalars['Boolean']['input'];
  itemsFilter?: InputMaybe<RLearningJourneyItemsFilter>;
  includeContentProgress: Scalars['Boolean']['input'];
}>;

export type RLearningJourneyQuery = {
  __typename?: 'Query';
  learningJourney: {
    __typename?: 'LearningJourney';
    id: number;
    urn: string;
    spaceId: number;
    title: string;
    bannerURL?: string | undefined;
    businessGoalV2: any;
    descriptionV2: any;
    status: RLearningJourneyStatus;
    spaceFeatured: boolean;
    allUpcomingItemsLocked: boolean;
    completionCriteria?: RLearningJourneyCompletionStatus | undefined;
    completionInvestTimeSec?: number | undefined;
    discussionEnabled: boolean;
    discussionForumSectionPath: string;
    certificateEnabled: boolean;
    subjectId?: number | undefined;
    createdAt: Date;
    updatedAt: Date;
    myCertificateURL?: { __typename?: 'PresignedURL'; expiresAfter: Date; url: string } | undefined;
    subject?:
      | { __typename?: 'SubjectCategoryV2'; subjectId: number; subject: string; categoryId: number; category: string }
      | undefined;
    cohortTeams?: Array<{ __typename?: 'Team'; id: number; name: string }> | undefined;
    updateByUser?:
      | { __typename?: 'UserV2'; id: number; firstname?: string | undefined; lastname?: string | undefined }
      | undefined;
    items?: {
      __typename?: 'LearningJourneyItemPage';
      data: Array<{
        __typename?: 'LearningJourneyItem';
        id: number;
        order: number;
        isLocked: boolean;
        isOptional: boolean;
        availabilityType: RLearningItemAvailabilityType;
        realms: Array<string>;
        availabilityScheduledAt?: Date | undefined;
        availabilityScheduledAtTimezone?: number | undefined;
        contentId: string;
        content?:
          | {
              __typename?: 'LearningContent';
              id: string;
              idV1: string;
              title: string;
              description: string;
              imageURL?: string | undefined;
              provider: RLearningContentProvider;
              plannedDuration?: number | undefined;
              plannedLearningsCount?: number | undefined;
              locationsWithEnrollment?:
                | Array<{
                    __typename?: 'LearningContentLocationData';
                    id?: number | undefined;
                    userLocationEnrollment?: Array<{ __typename?: 'Enrollment'; id: number }> | undefined;
                  }>
                | undefined;
              metadata?:
                | {
                    __typename?: 'LearningContentMetadata';
                    language?: string | undefined;
                    level?: string | undefined;
                    type?: RLearningContentContentType | undefined;
                    timezone?: number | undefined;
                  }
                | undefined;
              locations?:
                | Array<{
                    __typename?: 'LearningContentLocationData';
                    id?: number | undefined;
                    endDate?: Date | undefined;
                    startDate?: Date | undefined;
                    type?: RLocationType | undefined;
                    address?: string | undefined;
                    recordingURL?: string | undefined;
                  }>
                | undefined;
              curations: Array<{
                __typename?: 'LearningCuration';
                id: string;
                spaceId: number;
                launchURLPath?: string | undefined;
                title?: string | undefined;
                description?: string | undefined;
                imageURL?: string | undefined;
                editURLPath?: string | undefined;
                systemGenerated?: boolean | undefined;
              }>;
              progress?:
                | {
                    __typename?: 'ParticipationV2';
                    id?: number | undefined;
                    objectId: string;
                    userId: number;
                    progress: number;
                    isCompleted: boolean;
                    completedAt?: Date | undefined;
                    plannedDuration?: number | undefined;
                    plannedLearningsCount?: number | undefined;
                    userEffort?: number | undefined;
                    expiryAt?: Date | undefined;
                  }
                | undefined;
            }
          | undefined;
      }>;
    };
  };
};

export type RLearningJourneysQueryVariables = Exact<{
  filter: RLearningJourneyFilter;
  pagination?: InputMaybe<RPagination>;
}>;

export type RLearningJourneysQuery = {
  __typename?: 'Query';
  learningJourneys: {
    __typename?: 'LearningJourneyPage';
    total: number;
    data: Array<{
      __typename?: 'LearningJourney';
      id: number;
      spaceId: number;
      subjectId?: number | undefined;
      title: string;
      status: RLearningJourneyStatus;
      subject?:
        | { __typename?: 'SubjectCategoryV2'; subjectId: number; subject: string; categoryId: number; category: string }
        | undefined;
      items: { __typename?: 'LearningJourneyItemPage'; total: number };
    }>;
  };
};

export type RLearningJourneySessionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  includeProgress: Scalars['Boolean']['input'];
}>;

export type RLearningJourneySessionQuery = {
  __typename?: 'Query';
  learningJourneySession: {
    __typename?: 'LearningJourneySession';
    id: number;
    startedAt: Date;
    cohort: {
      __typename?: 'LearningJourneyCohort';
      learners: Array<{
        __typename?: 'LearningJourneyLearner';
        userId: number;
        sessionId: number;
        user: {
          __typename?: 'UserV2';
          id: number;
          email: string;
          username?: string | undefined;
          profileImage?: string | undefined;
        };
        progress?: { __typename?: 'ParticipationV2'; isCompleted: boolean; progress: number } | undefined;
      }>;
      teams: Array<{ __typename?: 'Team'; id: number; name: string; parentTeamId?: number | undefined }>;
    };
  };
};

export type RLearningJourneyItemsCatalogQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  spaceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  pagination: RPagination;
}>;

export type RLearningJourneyItemsCatalogQuery = {
  __typename?: 'Query';
  learningJourneyItemsCatalog: {
    __typename?: 'LearningContentsPage';
    limit: number;
    page: number;
    data: Array<{
      __typename?: 'LearningContent';
      id: string;
      idV1: string;
      title: string;
      description: string;
      imageURL?: string | undefined;
      provider: RLearningContentProvider;
      plannedDuration?: number | undefined;
      plannedLearningsCount?: number | undefined;
      metadata?:
        | {
            __typename?: 'LearningContentMetadata';
            language?: string | undefined;
            level?: string | undefined;
            type?: RLearningContentContentType | undefined;
            timezone?: number | undefined;
          }
        | undefined;
      locations?:
        | Array<{
            __typename?: 'LearningContentLocationData';
            id?: number | undefined;
            endDate?: Date | undefined;
            startDate?: Date | undefined;
            type?: RLocationType | undefined;
            address?: string | undefined;
            recordingURL?: string | undefined;
          }>
        | undefined;
      curations: Array<{
        __typename?: 'LearningCuration';
        id: string;
        spaceId: number;
        launchURLPath?: string | undefined;
        title?: string | undefined;
        description?: string | undefined;
        imageURL?: string | undefined;
        editURLPath?: string | undefined;
        systemGenerated?: boolean | undefined;
      }>;
    }>;
  };
};

export type RLearningJourneyDiscussionTeamsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type RLearningJourneyDiscussionTeamsQuery = {
  __typename?: 'Query';
  learningJourney: {
    __typename?: 'LearningJourney';
    id: number;
    spaceId: number;
    sessions: Array<{
      __typename?: 'LearningJourneySession';
      id: number;
      urn: string;
      journeyId: number;
      discussionTeams?:
        | Array<{
            __typename?: 'LearningJourneySessionDiscussionTeam';
            id: number;
            sessionId: number;
            name: string;
            teamSize: number;
            createdAt: Date;
            updatedAt: Date;
            members: Array<{
              __typename?: 'LearningJourneySessionDiscussionTeamMember';
              teamId: number;
              userId: number;
              createdAt: Date;
              user: {
                __typename?: 'UserV2';
                id: number;
                realm: string;
                email: string;
                username?: string | undefined;
                firstname?: string | undefined;
              };
            }>;
          }>
        | undefined;
    }>;
  };
};

export type RReportingLearningJourneyContentInsightsQueryVariables = Exact<{
  where?: InputMaybe<RReportingLearningJourneyContentInsights_Bool_Exp>;
  orderBy?: InputMaybe<
    Array<RReportingLearningJourneyContentInsights_Order_By> | RReportingLearningJourneyContentInsights_Order_By
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  whereAggregate?: InputMaybe<RReportingLearningJourneyContentInsights_Bool_Exp>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RReportingLearningJourneyContentInsightsQuery = {
  __typename?: 'Query';
  reportingLearningJourneyContentInsights: Array<{
    __typename?: 'reportingLearningJourneyContentInsights';
    learningContentURN?: string | undefined;
    learningContentTitle?: string | undefined;
    learningType?: any | undefined;
    startedCount?: any | undefined;
    completedCount?: any | undefined;
    completionRate?: any | undefined;
    notStartedCount?: any | undefined;
  }>;
  filteredTotal: {
    __typename?: 'reportingLearningJourneyContentInsights_aggregate';
    aggregate?: { __typename?: 'reportingLearningJourneyContentInsights_aggregate_fields'; count: number } | undefined;
  };
  total: {
    __typename?: 'reportingLearningJourneyContentInsights_aggregate';
    aggregate?: { __typename?: 'reportingLearningJourneyContentInsights_aggregate_fields'; count: number } | undefined;
  };
};

export type RReportingLearningJourneysItemsQueryVariables = Exact<{
  args: RReportingLearningJourneysItems_Arguments;
  where?: InputMaybe<RLearning_Journeys_Items_Bool_Exp_Bool_Exp>;
  orderBy?: InputMaybe<Array<RLearning_Journeys_Items_Order_By> | RLearning_Journeys_Items_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RReportingLearningJourneysItemsQuery = {
  __typename?: 'Query';
  reportingLearningJourneysItems: Array<{
    __typename?: 'learning_journeys_items';
    urn: string;
    title: string;
    type: string;
    partner: string;
  }>;
};

export type RReportingLearningJourneysItemsInsightsQueryVariables = Exact<{
  args: RReportingLearningJourneysItemsInsights_Arguments;
  where?: InputMaybe<RLearning_Journeys_Items_Insights_Bool_Exp_Bool_Exp>;
  orderBy?: InputMaybe<Array<RLearning_Journeys_Items_Insights_Order_By> | RLearning_Journeys_Items_Insights_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RReportingLearningJourneysItemsInsightsQuery = {
  __typename?: 'Query';
  reportingLearningJourneysItemsInsights: Array<{
    __typename?: 'learning_journeys_items_insights';
    urn: string;
    not_started_count: any;
    in_progress_count: any;
    completed_count: any;
    completion_rate: any;
  }>;
};

export type RReportingLearningJourneysItemsTotalCountQueryVariables = Exact<{
  args: RReportingLearningJourneysItemsTotalCount_Arguments;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
  orderBy?: InputMaybe<Array<RTotal_Count_Order_By> | RTotal_Count_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RReportingLearningJourneysItemsTotalCountQuery = {
  __typename?: 'Query';
  reportingLearningJourneysItemsTotalCount: Array<{ __typename?: 'total_count'; total_count: any }>;
};

export type RLearningJourneySectionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filter: RLearningSectionItemsFilter;
  pagination: RPagination;
  userId: Scalars['Int']['input'];
  spaceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  includeSectionProgress: Scalars['Boolean']['input'];
  includeContentProgress: Scalars['Boolean']['input'];
  includeUpdateByUser: Scalars['Boolean']['input'];
  includeIsLocked: Scalars['Boolean']['input'];
}>;

export type RLearningJourneySectionQuery = {
  __typename?: 'Query';
  learningV2: {
    __typename?: 'LearningV2';
    id: number;
    contentOwnerId?: number | undefined;
    title: string;
    spaceId: number;
    languageId?: number | undefined;
    teaser: string;
    effort?: number | undefined;
    image?: string | undefined;
    visibility?: RLearningV2Visibility | undefined;
    meta?: any | undefined;
    status: RLearningV2Status;
    type: RLearningV2Type;
    urn: string;
    updatedAt?: Date | undefined;
    sectionItems: {
      __typename?: 'LearningSectionItemPage';
      data: Array<{
        __typename?: 'LearningSectionItem';
        availabilityScheduledAt?: Date | undefined;
        availabilityScheduledAtTimezone?: number | undefined;
        availabilityType: RLearningItemAvailabilityType;
        createdAt: Date;
        isOptional: boolean;
        learningId: number;
        learningItemURNV2: string;
        order: number;
        realms: Array<string>;
        updatedAt: Date;
        isLocked?: boolean;
        id: number;
        learningItem?:
          | {
              __typename?: 'LearningContent';
              id: string;
              idV1: string;
              title: string;
              description: string;
              imageURL?: string | undefined;
              provider: RLearningContentProvider;
              plannedDuration?: number | undefined;
              plannedLearningsCount?: number | undefined;
              locationsWithEnrollment?:
                | Array<{
                    __typename?: 'LearningContentLocationData';
                    id?: number | undefined;
                    userLocationEnrollment?: Array<{ __typename?: 'Enrollment'; id: number }> | undefined;
                  }>
                | undefined;
              metadata?:
                | {
                    __typename?: 'LearningContentMetadata';
                    language?: string | undefined;
                    level?: string | undefined;
                    type?: RLearningContentContentType | undefined;
                    timezone?: number | undefined;
                  }
                | undefined;
              locations?:
                | Array<{
                    __typename?: 'LearningContentLocationData';
                    id?: number | undefined;
                    endDate?: Date | undefined;
                    startDate?: Date | undefined;
                    type?: RLocationType | undefined;
                    address?: string | undefined;
                    recordingURL?: string | undefined;
                  }>
                | undefined;
              curations: Array<{
                __typename?: 'LearningCuration';
                id: string;
                spaceId: number;
                launchURLPath?: string | undefined;
                title?: string | undefined;
                description?: string | undefined;
                imageURL?: string | undefined;
                editURLPath?: string | undefined;
                systemGenerated?: boolean | undefined;
              }>;
              progress?:
                | {
                    __typename?: 'ParticipationV2';
                    id?: number | undefined;
                    objectId: string;
                    userId: number;
                    progress: number;
                    isCompleted: boolean;
                    completedAt?: Date | undefined;
                    plannedDuration?: number | undefined;
                    plannedLearningsCount?: number | undefined;
                    userEffort?: number | undefined;
                    expiryAt?: Date | undefined;
                  }
                | undefined;
            }
          | undefined;
      }>;
    };
    userLastParticipation?:
      | {
          __typename?: 'ParticipationV2';
          id?: number | undefined;
          objectId: string;
          userId: number;
          progress: number;
          isCompleted: boolean;
          completedAt?: Date | undefined;
          plannedDuration?: number | undefined;
          plannedLearningsCount?: number | undefined;
          userEffort?: number | undefined;
          expiryAt?: Date | undefined;
        }
      | undefined;
    updateByUser?:
      | { __typename?: 'UserV2'; id: number; firstname?: string | undefined; lastname?: string | undefined }
      | undefined;
    subjects?: Array<{ __typename?: 'SubjectCategory'; subjectId: number }> | undefined;
  };
};

export type RCloneLearningJourneyMutationVariables = Exact<{
  input: RCloneLearningJourneyInput;
}>;

export type RCloneLearningJourneyMutation = {
  __typename?: 'Mutation';
  cloneLearningJourney: {
    __typename?: 'LearningJourneyResult';
    success: boolean;
    journey?: { __typename?: 'LearningJourney'; id: number } | undefined;
  };
};

export type RRemoveUsersFromLearningJourneyCohortMutationVariables = Exact<{
  journeyId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type RRemoveUsersFromLearningJourneyCohortMutation = {
  __typename?: 'Mutation';
  removeUsersFromLearningJourneyCohort: {
    __typename?: 'LearningJourneySessionResult';
    learnersAdded?: Array<number> | undefined;
    success: boolean;
  };
};

export type RAddTeamsToLearningJourneyCohortMutationVariables = Exact<{
  input: RUpdateLearningJourneyCohortTeamsInput;
}>;

export type RAddTeamsToLearningJourneyCohortMutation = {
  __typename?: 'Mutation';
  addTeamsToLearningJourneyCohort: {
    __typename?: 'LearningJourneySessionResult';
    learnersAdded?: Array<number> | undefined;
    success: boolean;
  };
};

export type RCreateLearningJourneyMutationVariables = Exact<{
  input: RCreateLearningJourneyInput;
}>;

export type RCreateLearningJourneyMutation = {
  __typename?: 'Mutation';
  createLearningJourney: {
    __typename?: 'LearningJourneyResult';
    success: boolean;
    journey?: { __typename?: 'LearningJourney'; id: number } | undefined;
  };
};

export type RUpsertLearningJourneyItemsMutationVariables = Exact<{
  input: RUpsertLearningJourneyItemsInput;
}>;

export type RUpsertLearningJourneyItemsMutation = {
  __typename?: 'Mutation';
  upsertLearningJourneyItems: {
    __typename?: 'LearningJourneyResult';
    success: boolean;
    journey?: { __typename?: 'LearningJourney'; id: number } | undefined;
  };
};

export type RUpdateLearningJourneyMutationVariables = Exact<{
  input: RUpdateLearningJourneyInput;
  options?: InputMaybe<RUpdateLearningJourneyOptionsInput>;
}>;

export type RUpdateLearningJourneyMutation = {
  __typename?: 'Mutation';
  updateLearningJourney: {
    __typename?: 'LearningJourneyResult';
    success: boolean;
    journey?:
      | {
          __typename?: 'LearningJourney';
          id: number;
          subjectId?: number | undefined;
          businessGoalV2: any;
          title: string;
          descriptionV2: any;
          bannerURL?: string | undefined;
          status: RLearningJourneyStatus;
          completionCriteria?: RLearningJourneyCompletionStatus | undefined;
          completionInvestTimeSec?: number | undefined;
          certificateEnabled: boolean;
          subject?:
            | { __typename?: 'SubjectCategoryV2'; subjectId: number; subject: string; categoryId: number; category: string }
            | undefined;
        }
      | undefined;
  };
};

export type RUpsertLearningJourneyCohortsMutationVariables = Exact<{
  input: RUpsertLearningJourneyCohortsInput;
}>;

export type RUpsertLearningJourneyCohortsMutation = {
  __typename?: 'Mutation';
  upsertLearningJourneyCohorts: { __typename?: 'LearningJourneySessionResult'; success: boolean };
};

export type RBootstrapLearningJourneySessionDiscussionTeamsMutationVariables = Exact<{
  sessionId: Scalars['Int']['input'];
  teamSize: Scalars['Int']['input'];
}>;

export type RBootstrapLearningJourneySessionDiscussionTeamsMutation = {
  __typename?: 'Mutation';
  bootstrapLearningJourneySesssionDiscussionTeams: { __typename?: 'LearningJourneySessionResult'; success: boolean };
};

export type RResetLearningJourneySessionDiscussionTeamsMutationVariables = Exact<{
  input: RResetLearningJourneySessionDiscussionTeamsInput;
}>;

export type RResetLearningJourneySessionDiscussionTeamsMutation = {
  __typename?: 'Mutation';
  resetLearningJourneySessionDiscussionTeams: { __typename?: 'LearningJourneySessionResult'; success: boolean };
};

export type RUpsertLearningJourneySessionDiscussionTeamMembersMutationVariables = Exact<{
  sessionId: Scalars['Int']['input'];
  teamMembers:
    | Array<RUpsertLearningJourneySessionDiscussionTeamMembersInput>
    | RUpsertLearningJourneySessionDiscussionTeamMembersInput;
}>;

export type RUpsertLearningJourneySessionDiscussionTeamMembersMutation = {
  __typename?: 'Mutation';
  upsertLearningJourneySessionDiscussionTeamMembers: { __typename?: 'LearningJourneySessionResult'; success: boolean };
};

export type RJoinLearningJourneyCohortsMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
}>;

export type RJoinLearningJourneyCohortsMutation = {
  __typename?: 'Mutation';
  joinLearningJourneyCohort: { __typename?: 'LearningJourneySessionResult'; success: boolean };
};

export type RCreateLearningJourneyPracticalAssessmentsMutationVariables = Exact<{
  input: RCreateLearningJourneyPracticalAssessmentsInput;
}>;

export type RCreateLearningJourneyPracticalAssessmentsMutation = {
  __typename?: 'Mutation';
  createLearningJourneyPracticalAssessments: Array<{
    __typename?: 'LearningV2';
    id: number;
    title: string;
    urn: string;
    type: RLearningV2Type;
    image?: string | undefined;
    effort?: number | undefined;
  }>;
};

export type RCreateUserLearningSubmissionMutationVariables = Exact<{
  input: RCreateUserLearningSubmissionInput;
}>;

export type RCreateUserLearningSubmissionMutation = {
  __typename?: 'Mutation';
  createUserLearningSubmission: {
    __typename?: 'UserLearningSubmissionResult';
    success: boolean;
    submission?:
      | {
          __typename?: 'UserLearningSubmission';
          data: any;
          id: number;
          createdAt: Date;
          userId: number;
          type: RUserLearningSubmissionType;
          pageURNV2: string;
          learningURNV2: string;
        }
      | undefined;
  };
};

export type RUserLearningSubmissionsQueryVariables = Exact<{
  input: RUserLearningSubmissionsFilter;
}>;

export type RUserLearningSubmissionsQuery = {
  __typename?: 'Query';
  userLearningSubmissions: Array<{
    __typename?: 'UserLearningSubmission';
    createdAt: Date;
    data: any;
    id: number;
    pageURNV2: string;
    learningURNV2: string;
    type: RUserLearningSubmissionType;
    updatedAt: Date;
    userId: number;
    reviews: Array<{
      __typename?: 'UserLearningSubmissionReview';
      createdAt: Date;
      data: any;
      id: number;
      reviewerId: number;
      submissionId: number;
      type: RUserLearningSubmissionReviewType;
      updatedAt: Date;
    }>;
    reviewAssignments: Array<{
      __typename?: 'UserLearningSubmissionReviewAssignment';
      createdAt: Date;
      expiryAt: Date;
      id: number;
      reviewerId: number;
      submissionId: number;
      updatedAt: Date;
      submission: {
        __typename?: 'UserLearningSubmission';
        data: any;
        id: number;
        createdAt: Date;
        pageURNV2: string;
        type: RUserLearningSubmissionType;
        userId: number;
        updatedAt: Date;
        reviews: Array<{
          __typename?: 'UserLearningSubmissionReview';
          reviewerId: number;
          createdAt: Date;
          data: any;
          id: number;
        }>;
      };
    }>;
  }>;
};

export type RCreateUserLearningSubmissionReviewMutationVariables = Exact<{
  input: RCreateUserLearningSubmissionReviewInput;
}>;

export type RCreateUserLearningSubmissionReviewMutation = {
  __typename?: 'Mutation';
  createUserLearningSubmissionReview: { __typename?: 'UserLearningSubmissionReviewResult'; success: boolean };
};

export type RReportingMyLearningsPracticalAssessmentQueryVariables = Exact<{
  args: RReportingMyLearningsPracticalAssessment_Arguments;
}>;

export type RReportingMyLearningsPracticalAssessmentQuery = {
  __typename?: 'Query';
  reportingMyLearningsPracticalAssessment: Array<{
    __typename?: 'practical_assessment';
    urn: string;
    title: string;
    page_urn: string;
    question_title: string;
    responses_count: number;
    reviews_count: number;
  }>;
};

export type RCreateLearningJourneyLiveEventMutationVariables = Exact<{
  input: RCreateLearningJourneyLiveEventInput;
}>;

export type RCreateLearningJourneyLiveEventMutation = {
  __typename?: 'Mutation';
  createLearningJourneyLiveEvent: {
    __typename?: 'LearningV2';
    id: number;
    title: string;
    type: RLearningV2Type;
    urn: string;
    effort?: number | undefined;
    image?: string | undefined;
  };
};

export type RUpdateLocationRecordingUrlMutationVariables = Exact<{
  input: RUpdateLocationRecordingUrlInput;
}>;

export type RUpdateLocationRecordingUrlMutation = {
  __typename?: 'Mutation';
  updateLocationRecordingURL: { __typename?: 'Location'; id: number; recordingURL?: string | undefined };
};

export type RSearchLearningJourneyContentQueryVariables = Exact<{
  filter: RSearchLearningContentFilter;
  pagination: RPagination;
  spaceIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;

export type RSearchLearningJourneyContentQuery = {
  __typename?: 'Query';
  searchLearningContent: {
    __typename?: 'LearningContentsPage';
    limit: number;
    page: number;
    data: Array<{
      __typename?: 'LearningContent';
      id: string;
      idV1: string;
      title: string;
      description: string;
      imageURL?: string | undefined;
      provider: RLearningContentProvider;
      plannedDuration?: number | undefined;
      plannedLearningsCount?: number | undefined;
      metadata?:
        | {
            __typename?: 'LearningContentMetadata';
            language?: string | undefined;
            level?: string | undefined;
            type?: RLearningContentContentType | undefined;
            timezone?: number | undefined;
          }
        | undefined;
      locations?:
        | Array<{
            __typename?: 'LearningContentLocationData';
            id?: number | undefined;
            endDate?: Date | undefined;
            startDate?: Date | undefined;
            type?: RLocationType | undefined;
            address?: string | undefined;
            recordingURL?: string | undefined;
          }>
        | undefined;
      curations: Array<{
        __typename?: 'LearningCuration';
        id: string;
        spaceId: number;
        launchURLPath?: string | undefined;
        title?: string | undefined;
        description?: string | undefined;
        imageURL?: string | undefined;
        editURLPath?: string | undefined;
        systemGenerated?: boolean | undefined;
      }>;
    }>;
  };
};

export type RDeleteLearningJourneysMutationVariables = Exact<{
  journeyIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type RDeleteLearningJourneysMutation = {
  __typename?: 'Mutation';
  deleteLearningJourneys: Array<{ __typename?: 'LearningJourney'; id: number; status: RLearningJourneyStatus }>;
};

export type RGenerateLearningJourneyItemsCsvMutationVariables = Exact<{
  input: RGenerateLearningJourneyReportCsvInput;
}>;

export type RGenerateLearningJourneyItemsCsvMutation = {
  __typename?: 'Mutation';
  generateLearningJourneyItemsCSV: {
    __typename?: 'GenerateLearningJourneyReportCSVResult';
    presignedURL?: string | undefined;
    success: boolean;
  };
};

export type RGenerateLearningJourneyLearnersCsvMutationVariables = Exact<{
  input: RGenerateLearningJourneyReportCsvInput;
}>;

export type RGenerateLearningJourneyLearnersCsvMutation = {
  __typename?: 'Mutation';
  generateLearningJourneyLearnersCSV: {
    __typename?: 'GenerateLearningJourneyReportCSVResult';
    presignedURL?: string | undefined;
    success: boolean;
  };
};

export type RReportingMyLearningJourneysLearnersTotalCountQueryVariables = Exact<{
  args: RReportingMyLearningJourneysLearnersTotalCount_Arguments;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RReportingMyLearningJourneysLearnersTotalCountQuery = {
  __typename?: 'Query';
  reportingMyLearningJourneysLearnersTotalCount: Array<{ __typename?: 'total_count'; total_count: any }>;
};

export type RReportingMyLearningJourneysLearnersQueryVariables = Exact<{
  args: RReportingMyLearningJourneysLearners_Arguments;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RLearning_Journey_Learners_Order_By> | RLearning_Journey_Learners_Order_By>;
}>;

export type RReportingMyLearningJourneysLearnersQuery = {
  __typename?: 'Query';
  reportingMyLearningJourneysLearners: Array<{
    __typename?: 'learning_journey_learners';
    user_id: number;
    username: string;
    email: string;
    profile_image?: string | undefined;
    join_time?: any | undefined;
    progress?: any | undefined;
    is_completed: boolean;
    completion_time?: any | undefined;
    last_activity_time?: any | undefined;
  }>;
};

export type RReportingMyLearningJourneysV2QueryVariables = Exact<{
  args: RReportingMyLearningJourneysV2_Arguments;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RLearning_Journeys_V2_Order_By> | RLearning_Journeys_V2_Order_By>;
}>;

export type RReportingMyLearningJourneysV2Query = {
  __typename?: 'Query';
  reportingMyLearningJourneysV2: Array<{
    __typename?: 'learning_journeys_v2';
    urn: string;
    title: string;
    status: string;
    space_name: string;
    space_id: number;
    learning_items_count: any;
  }>;
};

export type RReportingMyLearningsLearnersQueryVariables = Exact<{
  args: RReportingMyLearningsLearners_Arguments;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RLearners_Order_By> | RLearners_Order_By>;
  where?: InputMaybe<RLearners_Bool_Exp_Bool_Exp>;
}>;

export type RReportingMyLearningsLearnersQuery = {
  __typename?: 'Query';
  reportingMyLearningsLearners: Array<{
    __typename?: 'learners';
    user_id: number;
    username: string;
    email: string;
    profile_image?: string | undefined;
    join_time?: any | undefined;
    progress?: any | undefined;
    completion_time?: any | undefined;
    is_completed: boolean;
    last_activity_time?: any | undefined;
  }>;
};

export type RReportingMyLiveLearningsLearnersQueryVariables = Exact<{
  args: RReportingMyLiveLearningsLearners_Arguments;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RLive_Learnings_Learners_Order_By> | RLive_Learnings_Learners_Order_By>;
  where?: InputMaybe<RLive_Learnings_Learners_Bool_Exp_Bool_Exp>;
}>;

export type RReportingMyLiveLearningsLearnersQuery = {
  __typename?: 'Query';
  reportingMyLiveLearningsLearners: Array<{
    __typename?: 'live_learnings_learners';
    user_id: number;
    username: string;
    email: string;
    profile_image?: string | undefined;
    session_time: any;
    attendance: string;
    completion_time?: any | undefined;
    is_completed: boolean;
    registration: any;
    location_id: number;
  }>;
};

export type RReportingMyLearningsLearnersTotalCountQueryVariables = Exact<{
  args: RReportingMyLearningsLearnersTotalCount_Arguments;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RTotal_Count_Order_By> | RTotal_Count_Order_By>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
}>;

export type RReportingMyLearningsLearnersTotalCountQuery = {
  __typename?: 'Query';
  reportingMyLearningsLearnersTotalCount: Array<{ __typename?: 'total_count'; space_id: number; total_count: any }>;
};

export type RReportingMyLiveLearningsLearnersTotalCountQueryVariables = Exact<{
  args: RReportingMyLiveLearningsLearnersTotalCount_Arguments;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RTotal_Count_Order_By> | RTotal_Count_Order_By>;
  where?: InputMaybe<RTotal_Count_Bool_Exp_Bool_Exp>;
}>;

export type RReportingMyLiveLearningsLearnersTotalCountQuery = {
  __typename?: 'Query';
  reportingMyLiveLearningsLearnersTotalCount: Array<{ __typename?: 'total_count'; space_id: number; total_count: any }>;
};

export type RReportingMyLearningJourneysInsightsV2QueryVariables = Exact<{
  args: RReportingMyLearningJourneysInsightsV2_Arguments;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RLearning_Journeys_Insights_V2_Order_By> | RLearning_Journeys_Insights_V2_Order_By>;
}>;

export type RReportingMyLearningJourneysInsightsV2Query = {
  __typename?: 'Query';
  reportingMyLearningJourneysInsightsV2: Array<{
    __typename?: 'learning_journeys_insights_v2';
    urn: string;
    average_progress: any;
    learners_count: any;
    completed_count: any;
    completion_rate: any;
  }>;
};

export type RReportingMyLearningJourneysTotalCountQueryVariables = Exact<{
  args: RReportingMyLearningJourneysTotalCount_Arguments;
}>;

export type RReportingMyLearningJourneysTotalCountQuery = {
  __typename?: 'Query';
  reportingMyLearningJourneysTotalCount: Array<{ __typename?: 'total_count'; total_count: any; space_id: number }>;
};

export type RLearningJourneyUpcomingEventLocationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  spaceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type RLearningJourneyUpcomingEventLocationQuery = {
  __typename?: 'Query';
  learningJourneyUpcomingEventLocation?:
    | {
        __typename?: 'Location';
        id: number;
        endDate?: Date | undefined;
        startDate?: Date | undefined;
        type?: RLocationType | undefined;
        address?: string | undefined;
        recordingURL?: string | undefined;
        learningContent?:
          | {
              __typename?: 'LearningContent';
              id: string;
              idV1: string;
              title: string;
              description: string;
              imageURL?: string | undefined;
              provider: RLearningContentProvider;
              plannedDuration?: number | undefined;
              plannedLearningsCount?: number | undefined;
              metadata?:
                | {
                    __typename?: 'LearningContentMetadata';
                    language?: string | undefined;
                    level?: string | undefined;
                    type?: RLearningContentContentType | undefined;
                    timezone?: number | undefined;
                  }
                | undefined;
              locations?:
                | Array<{
                    __typename?: 'LearningContentLocationData';
                    id?: number | undefined;
                    endDate?: Date | undefined;
                    startDate?: Date | undefined;
                    type?: RLocationType | undefined;
                    address?: string | undefined;
                    recordingURL?: string | undefined;
                  }>
                | undefined;
              curations: Array<{
                __typename?: 'LearningCuration';
                id: string;
                spaceId: number;
                launchURLPath?: string | undefined;
                title?: string | undefined;
                description?: string | undefined;
                imageURL?: string | undefined;
                editURLPath?: string | undefined;
                systemGenerated?: boolean | undefined;
              }>;
            }
          | undefined;
      }
    | undefined;
};

export type RLearningJourneyUpcomingItemQueryVariables = Exact<{
  journeyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  afterItemURN?: InputMaybe<Scalars['URN']['input']>;
  spaceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  includeContentProgress: Scalars['Boolean']['input'];
}>;

export type RLearningJourneyUpcomingItemQuery = {
  __typename?: 'Query';
  learningJourneyUpcomingItem?:
    | {
        __typename?: 'LearningJourneyUpcomingItem';
        isLocked: boolean;
        isOptional: boolean;
        availabilityType: RLearningItemAvailabilityType;
        availabilityScheduledAt?: Date | undefined;
        availabilityScheduledAtTimezone?: number | undefined;
        contentId: string;
        content?:
          | {
              __typename?: 'LearningContent';
              id: string;
              idV1: string;
              title: string;
              description: string;
              imageURL?: string | undefined;
              provider: RLearningContentProvider;
              plannedDuration?: number | undefined;
              plannedLearningsCount?: number | undefined;
              locationsWithEnrollment?:
                | Array<{
                    __typename?: 'LearningContentLocationData';
                    id?: number | undefined;
                    userLocationEnrollment?: Array<{ __typename?: 'Enrollment'; id: number }> | undefined;
                  }>
                | undefined;
              metadata?:
                | {
                    __typename?: 'LearningContentMetadata';
                    language?: string | undefined;
                    level?: string | undefined;
                    type?: RLearningContentContentType | undefined;
                    timezone?: number | undefined;
                  }
                | undefined;
              locations?:
                | Array<{
                    __typename?: 'LearningContentLocationData';
                    id?: number | undefined;
                    endDate?: Date | undefined;
                    startDate?: Date | undefined;
                    type?: RLocationType | undefined;
                    address?: string | undefined;
                    recordingURL?: string | undefined;
                  }>
                | undefined;
              curations: Array<{
                __typename?: 'LearningCuration';
                id: string;
                spaceId: number;
                launchURLPath?: string | undefined;
                title?: string | undefined;
                description?: string | undefined;
                imageURL?: string | undefined;
                editURLPath?: string | undefined;
                systemGenerated?: boolean | undefined;
              }>;
              progress?:
                | {
                    __typename?: 'ParticipationV2';
                    id?: number | undefined;
                    objectId: string;
                    userId: number;
                    progress: number;
                    isCompleted: boolean;
                    completedAt?: Date | undefined;
                    plannedDuration?: number | undefined;
                    plannedLearningsCount?: number | undefined;
                    userEffort?: number | undefined;
                    expiryAt?: Date | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type RLearningJourneyPreviewTeamImportMutationVariables = Exact<{
  input: RLearningJourneyTeamImportInput;
}>;

export type RLearningJourneyPreviewTeamImportMutation = {
  __typename?: 'Mutation';
  learningJourneyPreviewTeamImport: {
    __typename?: 'LearningJourneyTeamImportPreviewResult';
    success: boolean;
    errorCause?: { __typename?: 'LearningJourneyTeamImportFileError'; code: RLearningJourneyTeamImportFileErrorCode } | undefined;
    data?:
      | {
          __typename?: 'LearningJourneyTeamImportPreview';
          allJourneyLearnersAssigned: boolean;
          stats: {
            __typename?: 'LearningJourneyTeamImportPreviewStats';
            total: number;
            ready: number;
            notInJourney: number;
            missingTeam: number;
            invalidEmail: number;
            duplicateInFile: number;
            missingRequiredField: number;
          };
          rows: Array<{
            __typename?: 'LearningJourneyTeamImportRowPreview';
            outcome: RLearningJourneyTeamImportRowOutcome;
            row: { __typename?: 'LearningJourneyTeamImportSourceRow'; email: string; teamName: string; sourceLine: number };
          }>;
          missingLearners: Array<{
            __typename?: 'LearningJourneyTeamImportMissingLearner';
            email: string;
            fullName?: string | undefined;
          }>;
        }
      | undefined;
  };
};

export type RLearningJourneyConfirmTeamImportMutationVariables = Exact<{
  input: RLearningJourneyTeamImportInput;
}>;

export type RLearningJourneyConfirmTeamImportMutation = {
  __typename?: 'Mutation';
  learningJourneyConfirmTeamImport: {
    __typename?: 'LearningJourneyTeamImportResult';
    success: boolean;
    teamsCreated: number;
    learnersAssigned: number;
  };
};

export type RGetLanguagesQueryVariables = Exact<{ [key: string]: never }>;

export type RGetLanguagesQuery = {
  __typename?: 'Query';
  getLanguages?: Array<{ __typename?: 'Language'; id?: number | undefined; name?: string | undefined } | undefined> | undefined;
};

export type RProductFragmentFragment = {
  __typename?: 'Product';
  id?: number | undefined;
  name?: string | undefined;
  label?: string | undefined;
  creator?: number | undefined;
  contentOwner?: number | undefined;
  timestamp?: string | undefined;
  costCenter?: string | undefined;
  legalEntity?: string | undefined;
  price?: number | undefined;
  currency?: string | undefined;
  status?: RLearningStatus | undefined;
  learnifierCourseName?: string | undefined;
  subjects?:
    | Array<
        | {
            __typename?: 'LearningSubject';
            subjectId?: number | undefined;
            categoryId?: number | undefined;
            subject?: string | undefined;
            category?: string | undefined;
          }
        | undefined
      >
    | undefined;
  space?: { __typename?: 'Space'; id: number; name?: string | undefined } | undefined;
  meta?:
    | {
        __typename?: 'ProductMeta';
        IMAGE?: string | undefined;
        TEASER?: string | undefined;
        DESCRIPTION?: string | undefined;
        FORMAT?: string | undefined;
        LEVEL?: string | undefined;
        LENGTH?: string | undefined;
        EFFORT?: string | undefined;
        TOTAL_EFFORT?: string | undefined;
        LANGUAGE?: string | undefined;
        INSTITUTION?: string | undefined;
        INSTRUCTORS?: string | undefined;
        LOCATION?: string | undefined;
        ENROLL_BUTTON_TEXT?: string | undefined;
        CONFIRM_MESSAGE?: string | undefined;
        PROVIDER?: string | undefined;
        CUSTOM_LINK?: string | undefined;
        OBJECT_ID?: string | undefined;
        PROVIDER_ACCESS?: string | undefined;
        TEAMS?: string | undefined;
        TEAMSIZE?: string | undefined;
        DISCUSSION_SECTION?: string | undefined;
        REFLECTION_SECTION?: string | undefined;
        ATTRIBUTES?: string | undefined;
        CONNECTIONS?: string | undefined;
      }
    | undefined;
  flags?:
    | {
        __typename?: 'ProductFlags';
        available?: boolean | undefined;
        approvalRequired?: boolean | undefined;
        globalMandatoryTraining?: boolean | undefined;
        enrollmentDisabled?: boolean | undefined;
        socialFeaturesEnabled?: boolean | undefined;
        reflectionsEnabled?: boolean | undefined;
        requiresApplication?: boolean | undefined;
        canEdit?: boolean | undefined;
        featured?: boolean | undefined;
        hasTeams?: boolean | undefined;
      }
    | undefined;
  services?:
    | Array<
        | {
            __typename?: 'Service';
            id?: number | undefined;
            type?: string | undefined;
            provider?: string | undefined;
            resource?: string | undefined;
            url?: string | undefined;
            meta?:
              | {
                  __typename?: 'LearnifierCourse';
                  name?: string | undefined;
                  host?: string | undefined;
                  organizationId?: string | undefined;
                  projectId?: string | undefined;
                  description?: string | undefined;
                  title?: string | undefined;
                  picture?: string | undefined;
                  status?: string | undefined;
                  adminLink?: string | undefined;
                  locale?: string | undefined;
                  timezone?: string | undefined;
                  country?: string | undefined;
                  resource?: string | undefined;
                }
              | undefined;
          }
        | undefined
      >
    | undefined;
  stocks?:
    | Array<
        | {
            __typename?: 'Stock';
            id?: number | undefined;
            total?: number | undefined;
            reserved?: number | undefined;
            enabled?: boolean | undefined;
          }
        | undefined
      >
    | undefined;
  state?:
    | {
        __typename?: 'State';
        id?: number | undefined;
        name?: string | undefined;
        flags?:
          | {
              __typename?: 'StateFlag';
              drawStock?: boolean | undefined;
              endState?: boolean | undefined;
              entitlement?: boolean | undefined;
            }
          | undefined;
      }
    | undefined;
  variants?:
    | Array<
        | {
            __typename?: 'Variant';
            id?: number | undefined;
            name: string;
            validTo?: string | undefined;
            validFrom?: string | undefined;
            enabled?: boolean | undefined;
            meta?: { __typename?: 'ProductMeta'; LOCATION?: string | undefined; METHOD?: string | undefined } | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RGetProductsQueryVariables = Exact<{ [key: string]: never }>;

export type RGetProductsQuery = {
  __typename?: 'Query';
  getProducts?:
    | Array<
        | {
            __typename?: 'Product';
            id?: number | undefined;
            name?: string | undefined;
            label?: string | undefined;
            creator?: number | undefined;
            contentOwner?: number | undefined;
            timestamp?: string | undefined;
            costCenter?: string | undefined;
            legalEntity?: string | undefined;
            price?: number | undefined;
            currency?: string | undefined;
            status?: RLearningStatus | undefined;
            learnifierCourseName?: string | undefined;
            subjects?:
              | Array<
                  | {
                      __typename?: 'LearningSubject';
                      subjectId?: number | undefined;
                      categoryId?: number | undefined;
                      subject?: string | undefined;
                      category?: string | undefined;
                    }
                  | undefined
                >
              | undefined;
            space?: { __typename?: 'Space'; id: number; name?: string | undefined } | undefined;
            meta?:
              | {
                  __typename?: 'ProductMeta';
                  IMAGE?: string | undefined;
                  TEASER?: string | undefined;
                  DESCRIPTION?: string | undefined;
                  FORMAT?: string | undefined;
                  LEVEL?: string | undefined;
                  LENGTH?: string | undefined;
                  EFFORT?: string | undefined;
                  TOTAL_EFFORT?: string | undefined;
                  LANGUAGE?: string | undefined;
                  INSTITUTION?: string | undefined;
                  INSTRUCTORS?: string | undefined;
                  LOCATION?: string | undefined;
                  ENROLL_BUTTON_TEXT?: string | undefined;
                  CONFIRM_MESSAGE?: string | undefined;
                  PROVIDER?: string | undefined;
                  CUSTOM_LINK?: string | undefined;
                  OBJECT_ID?: string | undefined;
                  PROVIDER_ACCESS?: string | undefined;
                  TEAMS?: string | undefined;
                  TEAMSIZE?: string | undefined;
                  DISCUSSION_SECTION?: string | undefined;
                  REFLECTION_SECTION?: string | undefined;
                  ATTRIBUTES?: string | undefined;
                  CONNECTIONS?: string | undefined;
                }
              | undefined;
            flags?:
              | {
                  __typename?: 'ProductFlags';
                  available?: boolean | undefined;
                  approvalRequired?: boolean | undefined;
                  globalMandatoryTraining?: boolean | undefined;
                  enrollmentDisabled?: boolean | undefined;
                  socialFeaturesEnabled?: boolean | undefined;
                  reflectionsEnabled?: boolean | undefined;
                  requiresApplication?: boolean | undefined;
                  canEdit?: boolean | undefined;
                  featured?: boolean | undefined;
                  hasTeams?: boolean | undefined;
                }
              | undefined;
            services?:
              | Array<
                  | {
                      __typename?: 'Service';
                      id?: number | undefined;
                      type?: string | undefined;
                      provider?: string | undefined;
                      resource?: string | undefined;
                      url?: string | undefined;
                      meta?:
                        | {
                            __typename?: 'LearnifierCourse';
                            name?: string | undefined;
                            host?: string | undefined;
                            organizationId?: string | undefined;
                            projectId?: string | undefined;
                            description?: string | undefined;
                            title?: string | undefined;
                            picture?: string | undefined;
                            status?: string | undefined;
                            adminLink?: string | undefined;
                            locale?: string | undefined;
                            timezone?: string | undefined;
                            country?: string | undefined;
                            resource?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined
                >
              | undefined;
            stocks?:
              | Array<
                  | {
                      __typename?: 'Stock';
                      id?: number | undefined;
                      total?: number | undefined;
                      reserved?: number | undefined;
                      enabled?: boolean | undefined;
                    }
                  | undefined
                >
              | undefined;
            state?:
              | {
                  __typename?: 'State';
                  id?: number | undefined;
                  name?: string | undefined;
                  flags?:
                    | {
                        __typename?: 'StateFlag';
                        drawStock?: boolean | undefined;
                        endState?: boolean | undefined;
                        entitlement?: boolean | undefined;
                      }
                    | undefined;
                }
              | undefined;
            variants?:
              | Array<
                  | {
                      __typename?: 'Variant';
                      id?: number | undefined;
                      name: string;
                      validTo?: string | undefined;
                      validFrom?: string | undefined;
                      enabled?: boolean | undefined;
                      meta?:
                        | { __typename?: 'ProductMeta'; LOCATION?: string | undefined; METHOD?: string | undefined }
                        | undefined;
                    }
                  | undefined
                >
              | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RGetProductQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type RGetProductQuery = {
  __typename?: 'Query';
  getProduct?:
    | {
        __typename?: 'Product';
        isPending?: boolean | undefined;
        productVariantId?: number | undefined;
        orderId?: number | undefined;
        id?: number | undefined;
        name?: string | undefined;
        label?: string | undefined;
        creator?: number | undefined;
        contentOwner?: number | undefined;
        timestamp?: string | undefined;
        costCenter?: string | undefined;
        legalEntity?: string | undefined;
        price?: number | undefined;
        currency?: string | undefined;
        status?: RLearningStatus | undefined;
        learnifierCourseName?: string | undefined;
        subjects?:
          | Array<
              | {
                  __typename?: 'LearningSubject';
                  subjectId?: number | undefined;
                  categoryId?: number | undefined;
                  subject?: string | undefined;
                  category?: string | undefined;
                }
              | undefined
            >
          | undefined;
        space?: { __typename?: 'Space'; id: number; name?: string | undefined } | undefined;
        meta?:
          | {
              __typename?: 'ProductMeta';
              IMAGE?: string | undefined;
              TEASER?: string | undefined;
              DESCRIPTION?: string | undefined;
              FORMAT?: string | undefined;
              LEVEL?: string | undefined;
              LENGTH?: string | undefined;
              EFFORT?: string | undefined;
              TOTAL_EFFORT?: string | undefined;
              LANGUAGE?: string | undefined;
              INSTITUTION?: string | undefined;
              INSTRUCTORS?: string | undefined;
              LOCATION?: string | undefined;
              ENROLL_BUTTON_TEXT?: string | undefined;
              CONFIRM_MESSAGE?: string | undefined;
              PROVIDER?: string | undefined;
              CUSTOM_LINK?: string | undefined;
              OBJECT_ID?: string | undefined;
              PROVIDER_ACCESS?: string | undefined;
              TEAMS?: string | undefined;
              TEAMSIZE?: string | undefined;
              DISCUSSION_SECTION?: string | undefined;
              REFLECTION_SECTION?: string | undefined;
              ATTRIBUTES?: string | undefined;
              CONNECTIONS?: string | undefined;
            }
          | undefined;
        flags?:
          | {
              __typename?: 'ProductFlags';
              available?: boolean | undefined;
              approvalRequired?: boolean | undefined;
              globalMandatoryTraining?: boolean | undefined;
              enrollmentDisabled?: boolean | undefined;
              socialFeaturesEnabled?: boolean | undefined;
              reflectionsEnabled?: boolean | undefined;
              requiresApplication?: boolean | undefined;
              canEdit?: boolean | undefined;
              featured?: boolean | undefined;
              hasTeams?: boolean | undefined;
            }
          | undefined;
        services?:
          | Array<
              | {
                  __typename?: 'Service';
                  id?: number | undefined;
                  type?: string | undefined;
                  provider?: string | undefined;
                  resource?: string | undefined;
                  url?: string | undefined;
                  meta?:
                    | {
                        __typename?: 'LearnifierCourse';
                        name?: string | undefined;
                        host?: string | undefined;
                        organizationId?: string | undefined;
                        projectId?: string | undefined;
                        description?: string | undefined;
                        title?: string | undefined;
                        picture?: string | undefined;
                        status?: string | undefined;
                        adminLink?: string | undefined;
                        locale?: string | undefined;
                        timezone?: string | undefined;
                        country?: string | undefined;
                        resource?: string | undefined;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
        stocks?:
          | Array<
              | {
                  __typename?: 'Stock';
                  id?: number | undefined;
                  total?: number | undefined;
                  reserved?: number | undefined;
                  enabled?: boolean | undefined;
                }
              | undefined
            >
          | undefined;
        state?:
          | {
              __typename?: 'State';
              id?: number | undefined;
              name?: string | undefined;
              flags?:
                | {
                    __typename?: 'StateFlag';
                    drawStock?: boolean | undefined;
                    endState?: boolean | undefined;
                    entitlement?: boolean | undefined;
                  }
                | undefined;
            }
          | undefined;
        variants?:
          | Array<
              | {
                  __typename?: 'Variant';
                  id?: number | undefined;
                  name: string;
                  validTo?: string | undefined;
                  validFrom?: string | undefined;
                  enabled?: boolean | undefined;
                  meta?: { __typename?: 'ProductMeta'; LOCATION?: string | undefined; METHOD?: string | undefined } | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type RGetVariantsQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;

export type RGetVariantsQuery = {
  __typename?: 'Query';
  getVariants?:
    | Array<
        | {
            __typename?: 'Variant';
            id?: number | undefined;
            name: string;
            validTo?: string | undefined;
            validFrom?: string | undefined;
            enabled?: boolean | undefined;
            meta?: { __typename?: 'ProductMeta'; LOCATION?: string | undefined; METHOD?: string | undefined } | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RGetParticipantsQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  orderDirection?: InputMaybe<ROrderDirection>;
  stateIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;

export type RGetParticipantsQuery = {
  __typename?: 'Query';
  getParticipants?:
    | {
        __typename?: 'ParticipantsResult';
        total?: number | undefined;
        totalPages?: number | undefined;
        participants?:
          | Array<
              | {
                  __typename?: 'Participant';
                  id?: number | undefined;
                  username?: string | undefined;
                  email?: string | undefined;
                  realm?: string | undefined;
                  profileImage?: string | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type RPurchaseMutationVariables = Exact<{
  products: Array<InputMaybe<RPurchaseProduct>> | InputMaybe<RPurchaseProduct>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;

export type RPurchaseMutation = {
  __typename?: 'Mutation';
  purchase?: { __typename?: 'PurchaseResponse'; orderId: number } | undefined;
};

export type RSadminPurchaseMutationVariables = Exact<{
  product: RSadminPurchaseProduct;
  emails: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;

export type RSadminPurchaseMutation = {
  __typename?: 'Mutation';
  sadminPurchase?:
    | {
        __typename?: 'SadminPurchaseResponse';
        success: boolean;
        message: string;
        code: string;
        result?:
          | Array<
              | {
                  __typename?: 'SadminPurchaseResult';
                  orderId?: number | undefined;
                  email?: string | undefined;
                  message?: string | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type RCreateOrUpdateMutationVariables = Exact<{
  product: RProductInput;
}>;

export type RCreateOrUpdateMutation = {
  __typename?: 'Mutation';
  createOrUpdate?: { __typename?: 'Product'; id?: number | undefined } | undefined;
};

export type RCreateVariantMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  variant: RVariantInput;
}>;

export type RCreateVariantMutation = {
  __typename?: 'Mutation';
  createVariant?: { __typename?: 'Variant'; id?: number | undefined } | undefined;
};

export type RUpdateVariantMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  variant: RVariantInput;
}>;

export type RUpdateVariantMutation = {
  __typename?: 'Mutation';
  updateVariant?: { __typename?: 'Variant'; id?: number | undefined } | undefined;
};

export type RRemoveVariantMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  variantId: Scalars['Int']['input'];
}>;

export type RRemoveVariantMutation = {
  __typename?: 'Mutation';
  removeVariant?: { __typename?: 'VariantResponse'; value?: boolean | undefined } | undefined;
};

export type RArticleRedirectQueryVariables = Exact<{
  articleId: Scalars['Int']['input'];
}>;

export type RArticleRedirectQuery = {
  __typename?: 'Query';
  articleRedirect?: { __typename?: 'ArticleRedirect'; learningId?: number | undefined; title?: string | undefined } | undefined;
};

export type RLearningContentByIdFragment = {
  __typename?: 'LearningContent';
  id: string;
  idV1: string;
  title: string;
  description: string;
  imageURL?: string | undefined;
  provider: RLearningContentProvider;
  plannedDuration?: number | undefined;
  plannedLearningsCount?: number | undefined;
  expiredAt?: Date | undefined;
  metadata?:
    | {
        __typename?: 'LearningContentMetadata';
        language?: string | undefined;
        level?: string | undefined;
        systemGenerated?: boolean | undefined;
        type?: RLearningContentContentType | undefined;
        timezone?: number | undefined;
      }
    | undefined;
  locations?:
    | Array<{
        __typename?: 'LearningContentLocationData';
        id?: number | undefined;
        type?: RLocationType | undefined;
        address?: string | undefined;
        endDate?: Date | undefined;
        startDate?: Date | undefined;
        recordingURL?: string | undefined;
      }>
    | undefined;
  curations: Array<{
    __typename?: 'LearningCuration';
    id: string;
    spaceId: number;
    launchURLPath?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    imageURL?: string | undefined;
    editURLPath?: string | undefined;
    updatedAt?: Date | undefined;
    systemGenerated?: boolean | undefined;
    space?: { __typename?: 'SpaceV2'; id: number; name: string; label: string } | undefined;
    updateByUser?:
      | {
          __typename?: 'UserV2';
          id: number;
          firstname?: string | undefined;
          lastname?: string | undefined;
          username?: string | undefined;
        }
      | undefined;
  }>;
};

export type RLearningContentByIdsQueryVariables = Exact<{
  contentURNs: Array<Scalars['URN']['input']> | Scalars['URN']['input'];
  spaceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type RLearningContentByIdsQuery = {
  __typename?: 'Query';
  learningContentByIds: Array<{
    __typename?: 'LearningContent';
    id: string;
    idV1: string;
    title: string;
    description: string;
    imageURL?: string | undefined;
    provider: RLearningContentProvider;
    plannedDuration?: number | undefined;
    plannedLearningsCount?: number | undefined;
    expiredAt?: Date | undefined;
    metadata?:
      | {
          __typename?: 'LearningContentMetadata';
          language?: string | undefined;
          level?: string | undefined;
          systemGenerated?: boolean | undefined;
          type?: RLearningContentContentType | undefined;
          timezone?: number | undefined;
        }
      | undefined;
    locations?:
      | Array<{
          __typename?: 'LearningContentLocationData';
          id?: number | undefined;
          type?: RLocationType | undefined;
          address?: string | undefined;
          endDate?: Date | undefined;
          startDate?: Date | undefined;
          recordingURL?: string | undefined;
        }>
      | undefined;
    curations: Array<{
      __typename?: 'LearningCuration';
      id: string;
      spaceId: number;
      launchURLPath?: string | undefined;
      title?: string | undefined;
      description?: string | undefined;
      imageURL?: string | undefined;
      editURLPath?: string | undefined;
      updatedAt?: Date | undefined;
      systemGenerated?: boolean | undefined;
      space?: { __typename?: 'SpaceV2'; id: number; name: string; label: string } | undefined;
      updateByUser?:
        | {
            __typename?: 'UserV2';
            id: number;
            firstname?: string | undefined;
            lastname?: string | undefined;
            username?: string | undefined;
          }
        | undefined;
    }>;
  }>;
};

export type RLearningContentByIdV1QueryVariables = Exact<{
  urn: Scalars['String']['input'];
  spaceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type RLearningContentByIdV1Query = {
  __typename?: 'Query';
  learningContentByIdV1: {
    __typename?: 'LearningContent';
    id: string;
    idV1: string;
    title: string;
    description: string;
    imageURL?: string | undefined;
    provider: RLearningContentProvider;
    plannedDuration?: number | undefined;
    plannedLearningsCount?: number | undefined;
    expiredAt?: Date | undefined;
    metadata?:
      | {
          __typename?: 'LearningContentMetadata';
          language?: string | undefined;
          level?: string | undefined;
          systemGenerated?: boolean | undefined;
          type?: RLearningContentContentType | undefined;
          timezone?: number | undefined;
        }
      | undefined;
    locations?:
      | Array<{
          __typename?: 'LearningContentLocationData';
          id?: number | undefined;
          type?: RLocationType | undefined;
          address?: string | undefined;
          endDate?: Date | undefined;
          startDate?: Date | undefined;
          recordingURL?: string | undefined;
        }>
      | undefined;
    curations: Array<{
      __typename?: 'LearningCuration';
      id: string;
      spaceId: number;
      launchURLPath?: string | undefined;
      title?: string | undefined;
      description?: string | undefined;
      imageURL?: string | undefined;
      editURLPath?: string | undefined;
      updatedAt?: Date | undefined;
      systemGenerated?: boolean | undefined;
      space?: { __typename?: 'SpaceV2'; id: number; name: string; label: string } | undefined;
      updateByUser?:
        | {
            __typename?: 'UserV2';
            id: number;
            firstname?: string | undefined;
            lastname?: string | undefined;
            username?: string | undefined;
          }
        | undefined;
    }>;
  };
};

export type RGenerateLiveLearningItemLearnersCsvMutationVariables = Exact<{
  input: RGenerateLearningReportCsvInput;
}>;

export type RGenerateLiveLearningItemLearnersCsvMutation = {
  __typename?: 'Mutation';
  generateLiveLearningItemLearnersCSV: {
    __typename?: 'GenerateLearningReportCSVResult';
    presignedURL?: string | undefined;
    success: boolean;
  };
};

export type RGenerateLearningItemLearnersCsvMutationVariables = Exact<{
  input: RGenerateLearningReportCsvInput;
}>;

export type RGenerateLearningItemLearnersCsvMutation = {
  __typename?: 'Mutation';
  generateLearningItemLearnersCSV: {
    __typename?: 'GenerateLearningReportCSVResult';
    presignedURL?: string | undefined;
    success: boolean;
  };
};

export type RGenerateSectionItemsCsvMutationVariables = Exact<{
  input: RGenerateLearningReportCsvInput;
}>;

export type RGenerateSectionItemsCsvMutation = {
  __typename?: 'Mutation';
  generateSectionItemsCSV: {
    __typename?: 'GenerateLearningReportCSVResult';
    presignedURL?: string | undefined;
    success: boolean;
  };
};

export type RLearningContentByIdsV1QueryVariables = Exact<{
  contentURNs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  spaceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type RLearningContentByIdsV1Query = {
  __typename?: 'Query';
  learningContentByIdsV1: Array<{
    __typename?: 'LearningContent';
    id: string;
    idV1: string;
    title: string;
    description: string;
    imageURL?: string | undefined;
    provider: RLearningContentProvider;
    plannedDuration?: number | undefined;
    plannedLearningsCount?: number | undefined;
    expiredAt?: Date | undefined;
    metadata?:
      | {
          __typename?: 'LearningContentMetadata';
          language?: string | undefined;
          level?: string | undefined;
          systemGenerated?: boolean | undefined;
          type?: RLearningContentContentType | undefined;
          timezone?: number | undefined;
        }
      | undefined;
    locations?:
      | Array<{
          __typename?: 'LearningContentLocationData';
          id?: number | undefined;
          type?: RLocationType | undefined;
          address?: string | undefined;
          endDate?: Date | undefined;
          startDate?: Date | undefined;
          recordingURL?: string | undefined;
        }>
      | undefined;
    curations: Array<{
      __typename?: 'LearningCuration';
      id: string;
      spaceId: number;
      launchURLPath?: string | undefined;
      title?: string | undefined;
      description?: string | undefined;
      imageURL?: string | undefined;
      editURLPath?: string | undefined;
      updatedAt?: Date | undefined;
      systemGenerated?: boolean | undefined;
      space?: { __typename?: 'SpaceV2'; id: number; name: string; label: string } | undefined;
      updateByUser?:
        | {
            __typename?: 'UserV2';
            id: number;
            firstname?: string | undefined;
            lastname?: string | undefined;
            username?: string | undefined;
          }
        | undefined;
    }>;
  }>;
};

export type RLearningLoopsQueryVariables = Exact<{
  assignmentId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  pagination?: InputMaybe<RPagination>;
}>;

export type RLearningLoopsQuery = {
  __typename?: 'Query';
  learningLoops: {
    __typename?: 'LearningLoopPage';
    limit: number;
    page: number;
    total: number;
    data: Array<{
      __typename?: 'LearningLoop';
      id: string;
      assignmentId: number;
      userId: number;
      estimatedEffort: number;
      startAt: Date;
      endAt: Date;
      isActive: boolean;
      createdAt: Date;
      updatedAt: Date;
      canReflect: boolean;
      recommendedEffort: number;
      activitiesAggregated: Array<{
        __typename?: 'LearningLoopActivityAggregated';
        participation: {
          __typename?: 'ParticipationV2';
          id?: number | undefined;
          objectId: string;
          catalogObjectId?: string | undefined;
          completedAt?: Date | undefined;
          endAt?: Date | undefined;
          expiryAt?: Date | undefined;
          isCompleted: boolean;
          plannedDuration?: number | undefined;
          userId: number;
          userEffort?: number | undefined;
        };
      }>;
      reflection?:
        | {
            __typename?: 'LearningLoopReflection';
            id: number;
            learningLoopId: string;
            description: string;
            applied: RLearningLoopReflectionApplied;
            createdAt: Date;
            updatedAt: Date;
          }
        | undefined;
    }>;
  };
};

export type RLearningLoopSelfTrackedLearningAddMutationVariables = Exact<{
  input: RAddSelfTrackedLearningToLearningLoopInput;
}>;

export type RLearningLoopSelfTrackedLearningAddMutation = {
  __typename?: 'Mutation';
  addSelfTrackedLearningToLearningLoop: { __typename?: 'AddSelfTrackedLearningToLearningLoopResult'; success: boolean };
};

export type RCreateLearningLoopReflectionMutationVariables = Exact<{
  input: RCreateLearningLoopReflectionInput;
}>;

export type RCreateLearningLoopReflectionMutation = {
  __typename?: 'Mutation';
  createLearningLoopReflection: {
    __typename?: 'CreateLearningLoopReflectionResult';
    success: boolean;
    learningLoop?:
      | {
          __typename?: 'LearningLoopReflection';
          id: number;
          learningLoopId: string;
          description: string;
          applied: RLearningLoopReflectionApplied;
          createdAt: Date;
          updatedAt: Date;
        }
      | undefined;
  };
};

export type RSaveLearningEditorMutationVariables = Exact<{
  input: RLearningInput;
}>;

export type RSaveLearningEditorMutation = {
  __typename?: 'Mutation';
  saveLearning?: { __typename?: 'Learning'; id: number } | undefined;
};

export type RLearningBaseFragmentFragment = {
  __typename?: 'Learning';
  id: number;
  created?: string | undefined;
  updated?: string | undefined;
  title?: string | undefined;
  type?: RLearningType | undefined;
  teaser?: string | undefined;
  image?: string | undefined;
  preamble?: string | undefined;
  spaceId?: number | undefined;
  meta?: any | undefined;
  effort?: number | undefined;
  archived?: string | undefined;
  visibility?: RLearningVisibility | undefined;
  languageId?: number | undefined;
  updatedByEmail?: string | undefined;
  creatorEmail?: string | undefined;
};

export type RLearningQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RLearningQuery = {
  __typename?: 'Query';
  learning?:
    | {
        __typename?: 'Learning';
        contentOwner?: number | undefined;
        canEdit?: boolean | undefined;
        id: number;
        created?: string | undefined;
        updated?: string | undefined;
        title?: string | undefined;
        type?: RLearningType | undefined;
        teaser?: string | undefined;
        image?: string | undefined;
        preamble?: string | undefined;
        spaceId?: number | undefined;
        meta?: any | undefined;
        effort?: number | undefined;
        archived?: string | undefined;
        visibility?: RLearningVisibility | undefined;
        languageId?: number | undefined;
        updatedByEmail?: string | undefined;
        creatorEmail?: string | undefined;
        progress?:
          | {
              __typename?: 'LearningProgress';
              completed?: boolean | undefined;
              completedPercentage?: number | undefined;
              historical?: boolean | undefined;
              expiredAt?: string | undefined;
            }
          | undefined;
        subjects?:
          | Array<
              | {
                  __typename?: 'LearningSubject';
                  subjectId?: number | undefined;
                  subject?: string | undefined;
                  categoryId?: number | undefined;
                  category?: string | undefined;
                }
              | undefined
            >
          | undefined;
        locations?:
          | Array<
              | {
                  __typename?: 'Location';
                  id: number;
                  startDate?: Date | undefined;
                  endDate?: Date | undefined;
                  address?: string | undefined;
                  room?: string | undefined;
                  capacity?: number | undefined;
                  waitlistType: RWaitlistType;
                  myEnrollment?: { __typename?: 'Enrollment'; id: number; attended: RAttendedType } | undefined;
                  stats?:
                    | {
                        __typename?: 'LocationStats';
                        isFinished: boolean;
                        enrolledCount: number;
                        waitlistedCount: number;
                        attendedCount: number;
                        notAttendedCount: number;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
        modules?:
          | Array<
              | {
                  __typename?: 'Module';
                  id?: number | undefined;
                  created?: string | undefined;
                  updated?: string | undefined;
                  learningId?: number | undefined;
                  type?: string | undefined;
                  name?: string | undefined;
                  order?: number | undefined;
                  pages?:
                    | Array<
                        | {
                            __typename?: 'Page';
                            id?: number | undefined;
                            created?: string | undefined;
                            updated?: string | undefined;
                            moduleId?: number | undefined;
                            type?: string | undefined;
                            name?: string | undefined;
                            order?: number | undefined;
                            blocks?:
                              | Array<
                                  | {
                                      __typename?: 'Block';
                                      id?: number | undefined;
                                      created?: string | undefined;
                                      updated?: string | undefined;
                                      pageId?: number | undefined;
                                      order?: number | undefined;
                                      type?: string | undefined;
                                      data?: any | undefined;
                                    }
                                  | undefined
                                >
                              | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type RArchiveLearningMutationVariables = Exact<{
  learningId: Scalars['Int']['input'];
}>;

export type RArchiveLearningMutation = {
  __typename?: 'Mutation';
  archiveLearning?: { __typename?: 'Learning'; id: number } | undefined;
};

export type RRestoreLearningMutationVariables = Exact<{
  learningId: Scalars['Int']['input'];
}>;

export type RRestoreLearningMutation = {
  __typename?: 'Mutation';
  restoreLearning?: { __typename?: 'Learning'; id: number } | undefined;
};

export type RLearningPinnedFragmentFragment = {
  __typename?: 'LearningPinned';
  realm: string;
  learningId?: number | undefined;
  learningPathId?: number | undefined;
  learningCollectionId?: number | undefined;
  learningJourneyId?: number | undefined;
  position: number;
};

export type RLearningsPinnedQueryVariables = Exact<{
  realm: Scalars['String']['input'];
}>;

export type RLearningsPinnedQuery = {
  __typename?: 'Query';
  learningsPinned: Array<{
    __typename?: 'LearningPinned';
    realm: string;
    learningId?: number | undefined;
    learningPathId?: number | undefined;
    learningCollectionId?: number | undefined;
    learningJourneyId?: number | undefined;
    position: number;
  }>;
};

export type RLearningPinnedUpdateMutationVariables = Exact<{
  realm: Scalars['String']['input'];
  input: Array<RLearningPinnedUpdateInput> | RLearningPinnedUpdateInput;
}>;

export type RLearningPinnedUpdateMutation = {
  __typename?: 'Mutation';
  learningPinnedUpdate: Array<{
    __typename?: 'LearningPinned';
    realm: string;
    learningId?: number | undefined;
    learningPathId?: number | undefined;
    learningCollectionId?: number | undefined;
    learningJourneyId?: number | undefined;
    position: number;
  }>;
};

export type RLearningFragmentFragment = {
  __typename?: 'Learning';
  id: number;
  title?: string | undefined;
  spaceId?: number | undefined;
  languageId?: number | undefined;
  teaser?: string | undefined;
  effort?: number | undefined;
  image?: string | undefined;
  visibility?: RLearningVisibility | undefined;
  meta?: any | undefined;
  status?: RLearningStatus | undefined;
  type?: RLearningType | undefined;
  urnV2?: string | undefined;
};

export type RLearningV2FragmentFragment = {
  __typename?: 'LearningV2';
  id: number;
  contentOwnerId?: number | undefined;
  title: string;
  spaceId: number;
  languageId?: number | undefined;
  teaser: string;
  effort?: number | undefined;
  image?: string | undefined;
  visibility?: RLearningV2Visibility | undefined;
  meta?: any | undefined;
  status: RLearningV2Status;
  type: RLearningV2Type;
  urn: string;
  updatedAt?: Date | undefined;
  subjects?: Array<{ __typename?: 'SubjectCategory'; subjectId: number }> | undefined;
};

export type RActivityFragmentFragment = {
  __typename?: 'LearningActivityDto';
  createdAt: Date;
  data: any;
  id: number;
  learningId?: number | undefined;
  order: number;
  parentActivityId?: number | undefined;
  type: RLearningActivityType;
  updatedAt: Date;
};

export type RLearningModulesDeepFragmentFragment = {
  __typename?: 'Module';
  id?: number | undefined;
  learningId?: number | undefined;
  pages?:
    | Array<
        | {
            __typename?: 'Page';
            id?: number | undefined;
            name?: string | undefined;
            order?: number | undefined;
            moduleId?: number | undefined;
            blocks?:
              | Array<
                  | {
                      __typename?: 'Block';
                      id?: number | undefined;
                      pageId?: number | undefined;
                      type?: string | undefined;
                      data?: any | undefined;
                    }
                  | undefined
                >
              | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RLearningProgressFragmentFragment = {
  __typename?: 'LearningProgress';
  completed?: boolean | undefined;
  completedPercentage?: number | undefined;
  expiredAt?: string | undefined;
  historical?: boolean | undefined;
};

export type RLocationsFragmentFragment = {
  __typename?: 'Location';
  id: number;
  type?: RLocationType | undefined;
  room?: string | undefined;
  address?: string | undefined;
  endDate?: Date | undefined;
  startDate?: Date | undefined;
  recordingURL?: string | undefined;
  registration?: string | undefined;
  myEnrollment?: { __typename?: 'Enrollment'; id: number; attended: RAttendedType } | undefined;
};

export type RLearningByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeProgress: Scalars['Boolean']['input'];
  includeLocations: Scalars['Boolean']['input'];
}>;

export type RLearningByIdQuery = {
  __typename?: 'Query';
  learning?:
    | {
        __typename?: 'Learning';
        id: number;
        title?: string | undefined;
        spaceId?: number | undefined;
        languageId?: number | undefined;
        teaser?: string | undefined;
        effort?: number | undefined;
        image?: string | undefined;
        visibility?: RLearningVisibility | undefined;
        meta?: any | undefined;
        status?: RLearningStatus | undefined;
        type?: RLearningType | undefined;
        urnV2?: string | undefined;
        modules?:
          | Array<
              | {
                  __typename?: 'Module';
                  id?: number | undefined;
                  learningId?: number | undefined;
                  pages?:
                    | Array<
                        | {
                            __typename?: 'Page';
                            id?: number | undefined;
                            name?: string | undefined;
                            order?: number | undefined;
                            moduleId?: number | undefined;
                            blocks?:
                              | Array<
                                  | {
                                      __typename?: 'Block';
                                      id?: number | undefined;
                                      pageId?: number | undefined;
                                      type?: string | undefined;
                                      data?: any | undefined;
                                    }
                                  | undefined
                                >
                              | undefined;
                          }
                        | undefined
                      >
                    | undefined;
                }
              | undefined
            >
          | undefined;
        progress?:
          | {
              __typename?: 'LearningProgress';
              completed?: boolean | undefined;
              completedPercentage?: number | undefined;
              expiredAt?: string | undefined;
              historical?: boolean | undefined;
            }
          | undefined;
        locations?:
          | Array<
              | {
                  __typename?: 'Location';
                  id: number;
                  type?: RLocationType | undefined;
                  room?: string | undefined;
                  address?: string | undefined;
                  endDate?: Date | undefined;
                  startDate?: Date | undefined;
                  recordingURL?: string | undefined;
                  registration?: string | undefined;
                  myEnrollment?: { __typename?: 'Enrollment'; id: number; attended: RAttendedType } | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type RLearningV2ByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
}>;

export type RLearningV2ByIdQuery = {
  __typename?: 'Query';
  learningV2: {
    __typename?: 'LearningV2';
    id: number;
    contentOwnerId?: number | undefined;
    title: string;
    spaceId: number;
    languageId?: number | undefined;
    teaser: string;
    effort?: number | undefined;
    image?: string | undefined;
    visibility?: RLearningV2Visibility | undefined;
    meta?: any | undefined;
    status: RLearningV2Status;
    type: RLearningV2Type;
    urn: string;
    updatedAt?: Date | undefined;
    activities?:
      | Array<{
          __typename?: 'LearningActivityDto';
          createdAt: Date;
          data: any;
          id: number;
          learningId?: number | undefined;
          order: number;
          parentActivityId?: number | undefined;
          type: RLearningActivityType;
          updatedAt: Date;
        }>
      | undefined;
    userLastParticipation?:
      | {
          __typename?: 'ParticipationV2';
          id?: number | undefined;
          expiryAt?: Date | undefined;
          isCompleted: boolean;
          progress: number;
          plannedDuration?: number | undefined;
          userEffort?: number | undefined;
        }
      | undefined;
    updateByUser?:
      | { __typename?: 'UserV2'; id: number; firstname?: string | undefined; lastname?: string | undefined }
      | undefined;
    subjects?: Array<{ __typename?: 'SubjectCategory'; subjectId: number }> | undefined;
  };
};

export type RSaveLearningMutationVariables = Exact<{
  input: RLearningInput;
}>;

export type RSaveLearningMutation = {
  __typename?: 'Mutation';
  saveLearning?: { __typename?: 'Learning'; id: number; title?: string | undefined; image?: string | undefined } | undefined;
};

export type RUpsertLearningMutationVariables = Exact<{
  input: RUpsertLearningInput;
}>;

export type RUpsertLearningMutation = {
  __typename?: 'Mutation';
  upsertLearning: {
    __typename?: 'LearningV2';
    id: number;
    title: string;
    image?: string | undefined;
    urn: string;
    activities?:
      | Array<{
          __typename?: 'LearningActivityDto';
          createdAt: Date;
          data: any;
          id: number;
          learningId?: number | undefined;
          order: number;
          parentActivityId?: number | undefined;
          type: RLearningActivityType;
          updatedAt: Date;
        }>
      | undefined;
  };
};

export type RDeleteLearningMutationVariables = Exact<{
  learningId: Scalars['Int']['input'];
}>;

export type RDeleteLearningMutation = {
  __typename?: 'Mutation';
  deleteLearning?: { __typename?: 'Learning'; id: number } | undefined;
};

export type RLearningTypeByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RLearningTypeByIdQuery = {
  __typename?: 'Query';
  learning?: { __typename?: 'Learning'; id: number; type?: RLearningType | undefined } | undefined;
};

export type RLearningParentsByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  filter: RLearningParentsFilter;
  userId: Scalars['Int']['input'];
}>;

export type RLearningParentsByIdQuery = {
  __typename?: 'Query';
  learning?:
    | {
        __typename?: 'Learning';
        id: number;
        urnV2?: string | undefined;
        parents: Array<{
          __typename?: 'LearningContent';
          id: string;
          title: string;
          userLastParticipation?: { __typename?: 'ParticipationV2'; id?: number | undefined } | undefined;
        }>;
      }
    | undefined;
};

export type RFindLearningJourneyItemQueryVariables = Exact<{
  filter: RFindLearningJourneyItemFilter;
}>;

export type RFindLearningJourneyItemQuery = {
  __typename?: 'Query';
  findLearningJourneyItem: Array<
    | {
        __typename?: 'LearningJourneyItem';
        id: number;
        learningItemURNV2: string;
        journeyId: number;
        breadcrumbs: Array<{
          __typename?: 'JourneyItemBreadcrumb';
          urn: string;
          content?: { __typename?: 'LearningContent'; id: string; title: string } | undefined;
        }>;
      }
    | {
        __typename?: 'LearningSectionItem';
        id: number;
        learningItemURNV2: string;
        learningId: number;
        breadcrumbs: Array<{
          __typename?: 'JourneyItemBreadcrumb';
          urn: string;
          content?: { __typename?: 'LearningContent'; id: string; title: string } | undefined;
        }>;
      }
  >;
};

export type RSearchLearningContentQueryVariables = Exact<{
  filter: RSearchLearningContentFilter;
  pagination: RPagination;
  spaceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type RSearchLearningContentQuery = {
  __typename?: 'Query';
  searchLearningContent: {
    __typename?: 'LearningContentsPage';
    limit: number;
    page: number;
    total: number;
    data: Array<{
      __typename?: 'LearningContent';
      id: string;
      idV1: string;
      title: string;
      description: string;
      imageURL?: string | undefined;
      provider: RLearningContentProvider;
      plannedDuration?: number | undefined;
      plannedLearningsCount?: number | undefined;
      metadata?:
        | {
            __typename?: 'LearningContentMetadata';
            language?: string | undefined;
            level?: string | undefined;
            type?: RLearningContentContentType | undefined;
            timezone?: number | undefined;
          }
        | undefined;
      locations?:
        | Array<{
            __typename?: 'LearningContentLocationData';
            id?: number | undefined;
            endDate?: Date | undefined;
            startDate?: Date | undefined;
            type?: RLocationType | undefined;
            address?: string | undefined;
            recordingURL?: string | undefined;
          }>
        | undefined;
      curations: Array<{
        __typename?: 'LearningCuration';
        id: string;
        spaceId: number;
        launchURLPath?: string | undefined;
        title?: string | undefined;
        description?: string | undefined;
        imageURL?: string | undefined;
        editURLPath?: string | undefined;
        systemGenerated?: boolean | undefined;
      }>;
    }>;
  };
};

export type RImportLearningContentToSpaceMutationVariables = Exact<{
  input: RImportLearningContentToSpaceInput;
}>;

export type RImportLearningContentToSpaceMutation = {
  __typename?: 'Mutation';
  importLearningContentToSpace: {
    __typename?: 'ImportLearningContentToSpaceResult';
    success: boolean;
    failedIds?: Array<string> | undefined;
    content?: Array<{ __typename?: 'LearningContent'; id: string; title: string }> | undefined;
  };
};

export type RSubmitLearningActivityQuizAnswersMutationVariables = Exact<{
  input: RUserLearningActivityQuizSubmissionInput;
}>;

export type RSubmitLearningActivityQuizAnswersMutation = {
  __typename?: 'Mutation';
  submitLearningActivityQuizAnswers: { __typename?: 'UserLearningActivityQuizSubmission'; id: number };
};

export type RMyLearningActivityQuizSubmissionsQueryVariables = Exact<{
  input: RUserLearningActivityQuizSubmissionFilterInput;
}>;

export type RMyLearningActivityQuizSubmissionsQuery = {
  __typename?: 'Query';
  myLearningActivityQuizSubmissions: Array<{
    __typename?: 'UserLearningActivityQuizSubmission';
    answers: any;
    quiz: any;
    id: number;
    score: number;
    correctlyAnsweredCount: number;
    totalAnsweredCount: number;
    hasPassed: boolean;
  }>;
};

export type RLearningActivityAssignmentSubmissionFragment = {
  __typename?: 'UserLearningActivityAssignmentSubmission';
  learningActivityId: number;
  userId: number;
  type: RAssignmentSubmissionType;
  fileName: string;
  createdAt: Date;
  updatedAt: Date;
  fileURL: { __typename?: 'PresignedURL'; url: string; expiresAfter: Date };
};

export type RMyLearningActivityAssignmentSubmissionsQueryVariables = Exact<{
  input: RUserLearningActivityAssignmentSubmissionFilterInput;
}>;

export type RMyLearningActivityAssignmentSubmissionsQuery = {
  __typename?: 'Query';
  myLearningActivityAssignmentSubmissions: Array<{
    __typename?: 'UserLearningActivityAssignmentSubmission';
    learningActivityId: number;
    userId: number;
    type: RAssignmentSubmissionType;
    fileName: string;
    createdAt: Date;
    updatedAt: Date;
    fileURL: { __typename?: 'PresignedURL'; url: string; expiresAfter: Date };
  }>;
};

export type RSubmitLearningActivityAssignmentMutationVariables = Exact<{
  input: RSubmitLearningActivityAssignmentInput;
}>;

export type RSubmitLearningActivityAssignmentMutation = {
  __typename?: 'Mutation';
  submitLearningActivityAssignment: {
    __typename?: 'UserLearningActivityAssignmentSubmission';
    learningActivityId: number;
    userId: number;
    type: RAssignmentSubmissionType;
    fileName: string;
    createdAt: Date;
    updatedAt: Date;
    fileURL: { __typename?: 'PresignedURL'; url: string; expiresAfter: Date };
  };
};

export type RMigrateOnDemandLearningToCoursesMutationVariables = Exact<{
  learningId: Scalars['Int']['input'];
}>;

export type RMigrateOnDemandLearningToCoursesMutation = {
  __typename?: 'Mutation';
  migrateOnDemandLearningToCourses: { __typename?: 'LearningV2'; id: number; title: string };
};

export type RCloneLearningMutationVariables = Exact<{
  input: RCloneLearningInput;
}>;

export type RCloneLearningMutation = {
  __typename?: 'Mutation';
  cloneLearning: { __typename?: 'LearningV2'; id: number; type: RLearningV2Type; title: string; urn: string };
};

export type RCloneLearningActivitiesMutationVariables = Exact<{
  activityId: Scalars['Float']['input'];
}>;

export type RCloneLearningActivitiesMutation = {
  __typename?: 'Mutation';
  cloneLearningActivities: {
    __typename?: 'LearningActivityDto';
    createdAt: Date;
    data: any;
    id: number;
    learningId?: number | undefined;
    order: number;
    parentActivityId?: number | undefined;
    type: RLearningActivityType;
    updatedAt: Date;
  };
};

export type RChangeEnrollmentLocationMutationVariables = Exact<{
  input: RChangeEnrollmentLocationInput;
}>;

export type RChangeEnrollmentLocationMutation = {
  __typename?: 'Mutation';
  changeEnrollmentLocation: { __typename?: 'Enrollment'; id: number; locationId: number; attended: RAttendedType };
};

export type RReportingLearningsQueryVariables = Exact<{
  args: RReportingLearnings_Arguments;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RLearnings_Order_By> | RLearnings_Order_By>;
}>;

export type RReportingLearningsQuery = {
  __typename?: 'Query';
  reportingLearnings: Array<{
    __typename?: 'learnings';
    partner?: string | undefined;
    space_ids?: any | undefined;
    space_names?: any | undefined;
    team_ids?: any | undefined;
    title?: string | undefined;
    type?: string | undefined;
    urn?: string | undefined;
    visibility?: string | undefined;
    category?: string | undefined;
    subject?: string | undefined;
    planned_duration: number;
  }>;
};

export type RReportingLearningsTotalCountQueryVariables = Exact<{
  args: RReportingLearningsTotalCount_Arguments;
}>;

export type RReportingLearningsTotalCountQuery = {
  __typename?: 'Query';
  reportingLearningsTotalCount: Array<{ __typename?: 'total_count'; total_count: any }>;
};

export type RReportingLearningsInsightsQueryVariables = Exact<{
  args: RReportingLearningsInsights_Arguments;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RLearningsInsights_Order_By> | RLearningsInsights_Order_By>;
}>;

export type RReportingLearningsInsightsQuery = {
  __typename?: 'Query';
  reportingLearningsInsights: Array<{
    __typename?: 'learningsInsights';
    completion_rate?: any | undefined;
    learners_count?: any | undefined;
    space_ids?: any | undefined;
    team_ids?: any | undefined;
    urn?: string | undefined;
  }>;
};

export type RGetXapiSessionQueryVariables = Exact<{
  learningId: Scalars['Int']['input'];
}>;

export type RGetXapiSessionQuery = {
  __typename?: 'Query';
  getXAPISession: { __typename?: 'XAPISession'; queryString?: string | undefined; registration?: string | undefined };
};

export type RIsLearningCompletedQueryVariables = Exact<{
  learningId: Scalars['Int']['input'];
}>;

export type RIsLearningCompletedQuery = { __typename?: 'Query'; isLearningCompleted: boolean };

export type RGetLearningXapiSessionQueryVariables = Exact<{
  learningId: Scalars['Int']['input'];
}>;

export type RGetLearningXapiSessionQuery = {
  __typename?: 'Query';
  getXAPISession: { __typename?: 'XAPISession'; queryString?: string | undefined; registration?: string | undefined };
};

export type RRegisterToLearningMutationVariables = Exact<{
  learningId: Scalars['Int']['input'];
}>;

export type RRegisterToLearningMutation = {
  __typename?: 'Mutation';
  registerToLearning: { __typename?: 'XAPISession'; queryString?: string | undefined; registration?: string | undefined };
};

export type RApproveLicenseMutationVariables = Exact<{
  currentRealm?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  licenseId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RApproveLicenseMutation = { __typename?: 'Mutation'; approveLicense?: boolean | undefined };

export type RGetIssuedLicenseByIdQueryVariables = Exact<{
  realm?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type RGetIssuedLicenseByIdQuery = {
  __typename?: 'Query';
  issuedLicenses?:
    | Array<
        | {
            __typename?: 'IssuedLicense';
            id?: number | undefined;
            userId?: number | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
            lastRequestedAt?: string | undefined;
            status?: RLicenseStatus | undefined;
            division?: string | undefined;
            sId?: string | undefined;
            employeeId?: string | undefined;
            businessArea?: string | undefined;
            businessUnit?: string | undefined;
            user?: { __typename?: 'User'; email?: string | undefined; username?: string | undefined } | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RRevokeLicenseMutationVariables = Exact<{
  licenseId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RRevokeLicenseMutation = { __typename?: 'Mutation'; revokeLicense?: boolean | undefined };

export type RSyncCourseraLicensesQueryVariables = Exact<{
  realm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type RSyncCourseraLicensesQuery = {
  __typename?: 'Query';
  exportLicenses?:
    | Array<
        | {
            __typename?: 'IssuedLicense';
            id?: number | undefined;
            userId?: number | undefined;
            status?: RLicenseStatus | undefined;
            createdAt?: string | undefined;
            updatedAt?: string | undefined;
            lastRequestedAt?: string | undefined;
            division?: string | undefined;
            sId?: string | undefined;
            employeeId?: string | undefined;
            businessArea?: string | undefined;
            businessUnit?: string | undefined;
            user?: { __typename?: 'User'; email?: string | undefined; username?: string | undefined } | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RProviderLicensesQueryVariables = Exact<{
  realm?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
}>;

export type RProviderLicensesQuery = {
  __typename?: 'Query';
  realmProviderLicensesSummary?: { __typename?: 'RealmProviderLicenseSummary'; id: number; pendingLicenses: number } | undefined;
};

export type RCourseraQueryVariables = Exact<{
  provider?: InputMaybe<Scalars['String']['input']>;
  currentRealm?: InputMaybe<Scalars['String']['input']>;
}>;

export type RCourseraQuery = {
  __typename?: 'Query';
  issuedLicense?:
    | { __typename?: 'IssuedLicense'; status?: RLicenseStatus | undefined; id?: number | undefined; userId?: number | undefined }
    | undefined;
  realmProviderLicensesSummary?:
    | { __typename?: 'RealmProviderLicenseSummary'; id: number; catalogUrl?: string | undefined }
    | undefined;
};

export type RProviderAccessProductQueryVariables = Exact<{
  realm?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
}>;

export type RProviderAccessProductQuery = {
  __typename?: 'Query';
  providerAccessProductId?: { __typename?: 'IdResponse'; id: number } | undefined;
};

export type RRequestCourseraLicenseMutationVariables = Exact<{
  currentRealm?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
}>;

export type RRequestCourseraLicenseMutation = { __typename?: 'Mutation'; requestLicense?: boolean | undefined };

export type RManagementParticipationsQueryVariables = Exact<{
  objectIdIn: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  userTeamIdIn: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;

export type RManagementParticipationsQuery = {
  __typename?: 'Query';
  participations: Array<{
    __typename?: 'ParticipationGroup';
    id: number;
    userId: number;
    objectId: string;
    progress: number;
    completedAt?: string | undefined;
    objectName?: string | undefined;
    objectType?: string | undefined;
  }>;
};

export type RManagementCompletionRatePerCourseQueryVariables = Exact<{
  usersPool?: InputMaybe<RUsersPool>;
  userTeamIdIn?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;

export type RManagementCompletionRatePerCourseQuery = {
  __typename?: 'Query';
  getCompletionRatePerCourse?:
    | Array<{
        __typename?: 'CompletionRatePerCourse';
        object_id?: string | undefined;
        object_type?: string | undefined;
        object_name?: string | undefined;
        completion_rate?: number | undefined;
        completed?: number | undefined;
        progressed?: number | undefined;
      }>
    | undefined;
};

export type RUserTeamsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type RUserTeamsQuery = {
  __typename?: 'Query';
  userTeams: {
    __typename?: 'TeamUsersPage';
    data: Array<{
      __typename?: 'TeamUser';
      team: {
        __typename?: 'Team';
        id: number;
        name: string;
        parentTeamId?: number | undefined;
        subTeams: {
          __typename?: 'TeamsPage';
          data: Array<{ __typename?: 'Team'; id: number; name: string; parentTeamId?: number | undefined }>;
        };
      };
    }>;
  };
};

export type RManagementTeamUsersEmptyQueryVariables = Exact<{ [key: string]: never }>;

export type RManagementTeamUsersEmptyQuery = { __typename?: 'Query'; alias1: { __typename?: 'TeamUsersPage'; total: number } };

export type RManagementTeamUsersQueryVariables = Exact<{
  teamIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  withSubTeams?: InputMaybe<Scalars['Boolean']['input']>;
  activityFrom?: InputMaybe<Scalars['Time']['input']>;
  activityTo?: InputMaybe<Scalars['Time']['input']>;
}>;

export type RManagementTeamUsersQuery = {
  __typename?: 'Query';
  teamUsers: {
    __typename?: 'TeamUsersPage';
    data: Array<{
      __typename?: 'TeamUser';
      team: { __typename?: 'Team'; id: number; name: string };
      user: {
        __typename?: 'UserV2';
        id: number;
        username?: string | undefined;
        email: string;
        timestamp: Date;
        lastActive: Date;
        participationAggregate: {
          __typename?: 'ParticipationAggregate';
          total: number;
          started: number;
          completed: number;
          effort: any;
        };
      };
    }>;
  };
};

export type RNotificationFragmentFragment = {
  __typename?: 'BabelonNotification';
  id: string;
  notificationType?: RBabelonNotificationType | undefined;
  respondentName?: string | undefined;
  replyId?: number | undefined;
  postId?: number | undefined;
  topLevelPostId?: number | undefined;
  topLevelPostTitle?: string | undefined;
  sectionTitle?: string | undefined;
  sectionPath?: string | undefined;
  productId?: number | undefined;
  productTitle?: string | undefined;
};

export type RGetNotificationsQueryVariables = Exact<{ [key: string]: never }>;

export type RGetNotificationsQuery = {
  __typename?: 'Query';
  notifications?:
    | Array<
        | {
            __typename?: 'BabelonNotification';
            id: string;
            notificationType?: RBabelonNotificationType | undefined;
            respondentName?: string | undefined;
            replyId?: number | undefined;
            postId?: number | undefined;
            topLevelPostId?: number | undefined;
            topLevelPostTitle?: string | undefined;
            sectionTitle?: string | undefined;
            sectionPath?: string | undefined;
            productId?: number | undefined;
            productTitle?: string | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RMarkAllNotificationsAsSeenMutationVariables = Exact<{ [key: string]: never }>;

export type RMarkAllNotificationsAsSeenMutation = {
  __typename?: 'Mutation';
  markAllNotificationsAsSeen?:
    | Array<
        | {
            __typename?: 'BabelonNotification';
            id: string;
            notificationType?: RBabelonNotificationType | undefined;
            respondentName?: string | undefined;
            replyId?: number | undefined;
            postId?: number | undefined;
            topLevelPostId?: number | undefined;
            topLevelPostTitle?: string | undefined;
            sectionTitle?: string | undefined;
            sectionPath?: string | undefined;
            productId?: number | undefined;
            productTitle?: string | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RMarkNotificationAsSeenMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
}>;

export type RMarkNotificationAsSeenMutation = {
  __typename?: 'Mutation';
  markNotificationAsSeen?:
    | Array<
        | {
            __typename?: 'BabelonNotification';
            id: string;
            notificationType?: RBabelonNotificationType | undefined;
            respondentName?: string | undefined;
            replyId?: number | undefined;
            postId?: number | undefined;
            topLevelPostId?: number | undefined;
            topLevelPostTitle?: string | undefined;
            sectionTitle?: string | undefined;
            sectionPath?: string | undefined;
            productId?: number | undefined;
            productTitle?: string | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RGetProductOrdersFlatQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
  stateIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RGetProductOrdersFlatQuery = {
  __typename?: 'Query';
  getProductOrdersFlat?:
    | {
        __typename?: 'ProductOrdersFlatResult';
        total?: number | undefined;
        totalPages?: number | undefined;
        productOrders?:
          | Array<
              | {
                  __typename?: 'ProductOrdersFlat';
                  orderId?: number | undefined;
                  productId?: number | undefined;
                  productVariantId?: number | undefined;
                  spaceId?: number | undefined;
                  stateId?: number | undefined;
                  userId?: number | undefined;
                  username?: string | undefined;
                  email?: string | undefined;
                  realm?: string | undefined;
                  profileImage?: string | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type RGetAllOrdersFilteredQueryVariables = Exact<{
  stateId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RGetAllOrdersFilteredQuery = {
  __typename?: 'Query';
  getAllOrdersFiltered?:
    | {
        __typename?: 'FilteredOrdersFlatResult';
        total?: number | undefined;
        totalPages?: number | undefined;
        productOrders?:
          | Array<
              | {
                  __typename?: 'OrderRowFlat';
                  created?: string | undefined;
                  orderId?: number | undefined;
                  productId?: number | undefined;
                  productVariantId?: number | undefined;
                  spaceId?: number | undefined;
                  stateId?: number | undefined;
                  stateName?: string | undefined;
                  userId?: number | undefined;
                  user?:
                    | { __typename?: 'User'; username?: string | undefined; id?: number | undefined; email?: string | undefined }
                    | undefined;
                  products?:
                    | {
                        __typename?: 'ProductRow';
                        id?: number | undefined;
                        label?: string | undefined;
                        name?: string | undefined;
                        productId?: number | undefined;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type RGetApprovalsFilteredQueryVariables = Exact<{
  stateId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RGetApprovalsFilteredQuery = {
  __typename?: 'Query';
  getApprovalsFiltered?:
    | {
        __typename?: 'FilteredOrdersFlatResult';
        total?: number | undefined;
        totalPages?: number | undefined;
        productOrders?:
          | Array<
              | {
                  __typename?: 'OrderRowFlat';
                  created?: string | undefined;
                  orderId?: number | undefined;
                  productId?: number | undefined;
                  productVariantId?: number | undefined;
                  spaceId?: number | undefined;
                  stateId?: number | undefined;
                  stateName?: string | undefined;
                  note?: string | undefined;
                  userId?: number | undefined;
                  user?:
                    | { __typename?: 'User'; username?: string | undefined; id?: number | undefined; email?: string | undefined }
                    | undefined;
                  products?:
                    | {
                        __typename?: 'ProductRow';
                        id?: number | undefined;
                        label?: string | undefined;
                        name?: string | undefined;
                        productId?: number | undefined;
                      }
                    | undefined;
                }
              | undefined
            >
          | undefined;
      }
    | undefined;
};

export type RGetAllOrdersByStateQueryVariables = Exact<{
  stateId: Scalars['Int']['input'];
}>;

export type RGetAllOrdersByStateQuery = {
  __typename?: 'Query';
  getAllOrdersByState?: Array<{ __typename?: 'OrderRowFlat'; id?: number | undefined } | undefined> | undefined;
};

export type RUpdateOrderMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
  stateId: Scalars['Int']['input'];
}>;

export type RUpdateOrderMutation = {
  __typename?: 'Mutation';
  updateOrder?: { __typename?: 'UpdateResponse'; orderId?: number | undefined } | undefined;
};

export type RApplyOrderRulesMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;

export type RApplyOrderRulesMutation = {
  __typename?: 'Mutation';
  applyOrderRules?: { __typename?: 'UpdateResponse'; orderId?: number | undefined } | undefined;
};

export type RGetAllProductsShortQueryVariables = Exact<{ [key: string]: never }>;

export type RGetAllProductsShortQuery = {
  __typename?: 'Query';
  getAllProductsShort?:
    | Array<{ __typename?: 'ProductLabel'; id?: string | undefined; name?: string | undefined } | undefined>
    | undefined;
};

export type RGetOrderHistoryByIdQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RGetOrderHistoryByIdQuery = {
  __typename?: 'Query';
  getOrderHistoryById?:
    | Array<
        | {
            __typename?: 'OrderHistory';
            orderRowId?: string | undefined;
            stateId?: string | undefined;
            stateName?: string | undefined;
            updatedAt?: string | undefined;
            error?: string | undefined;
            updatedBy?: { __typename?: 'User'; id?: number | undefined; username?: string | undefined } | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RProductParentsByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filter: RProductParentsFilter;
  userId: Scalars['Int']['input'];
}>;

export type RProductParentsByIdQuery = {
  __typename?: 'Query';
  getProduct?:
    | {
        __typename?: 'Product';
        id?: number | undefined;
        learningContentUrnV2?: any | undefined;
        parents: Array<{
          __typename?: 'LearningContent';
          id: string;
          title: string;
          userLastParticipation?: { __typename?: 'ParticipationV2'; id?: number | undefined } | undefined;
        }>;
      }
    | undefined;
};

export type RGetLearnifierCoursesQueryVariables = Exact<{ [key: string]: never }>;

export type RGetLearnifierCoursesQuery = {
  __typename?: 'Query';
  getLearnifierCourses?:
    | Array<
        | {
            __typename?: 'LearnifierCourse';
            name?: string | undefined;
            host?: string | undefined;
            organizationId?: string | undefined;
            projectId?: string | undefined;
            description?: string | undefined;
            title?: string | undefined;
            picture?: string | undefined;
            status?: string | undefined;
            adminLink?: string | undefined;
            locale?: string | undefined;
            timezone?: string | undefined;
            country?: string | undefined;
            resource?: string | undefined;
          }
        | undefined
      >
    | undefined;
};

export type REffortForRealmQueryVariables = Exact<{
  realm: Scalars['String']['input'];
  fromTime: Scalars['timestamptz']['input'];
  toTime: Scalars['timestamptz']['input'];
}>;

export type REffortForRealmQuery = {
  __typename?: 'Query';
  reportingAggregationEffortForRealm: Array<{
    __typename?: 'reportingAggregationEffortForRealm';
    totalEffort?: any | undefined;
    averageEffort?: any | undefined;
    p90Effort?: any | undefined;
    p80Effort?: any | undefined;
    p70Effort?: any | undefined;
    p60Effort?: any | undefined;
    p50Effort?: any | undefined;
    fromTime?: any | undefined;
    toTime?: any | undefined;
  }>;
};

export type RGetRealmsQueryVariables = Exact<{ [key: string]: never }>;

export type RGetRealmsQuery = { __typename?: 'Query'; realms: Array<{ __typename?: 'Realm'; realm: string; name: string }> };

export type RRealmConfigQueryVariables = Exact<{
  realm: Scalars['String']['input'];
}>;

export type RRealmConfigQuery = {
  __typename?: 'Query';
  realmConfig?: { __typename?: 'RealmConfig'; heroImageUrl?: string | undefined; heroVideoUrl?: string | undefined } | undefined;
};

export type RCreateSelfTrackedLearningMutationVariables = Exact<{
  userSelfTrackedLearning: RCreateSelfTrackedLearningInput;
}>;

export type RCreateSelfTrackedLearningMutation = {
  __typename?: 'Mutation';
  createSelfTrackedLearning: { __typename?: 'SelfTrackedLearningResult'; success: boolean };
};

export type RGetUserSelfTrackedLearningQueryVariables = Exact<{
  userSelfTrackedLearningId: Scalars['Int']['input'];
}>;

export type RGetUserSelfTrackedLearningQuery = {
  __typename?: 'Query';
  selfTrackedLearning: {
    __typename?: 'SelfTrackedLearning';
    id: number;
    type: RSelfTrackedLearningType;
    title: string;
    description: string;
    effort: number;
    link?: string | undefined;
  };
};

export type RUpdateUserSelfTrackedLearningMutationVariables = Exact<{
  userSelfTrackedLearning: RUpdateSelfTrackedLearningInput;
}>;

export type RUpdateUserSelfTrackedLearningMutation = {
  __typename?: 'Mutation';
  updateSelfTrackedLearning: { __typename?: 'SelfTrackedLearningResult'; success: boolean };
};

export type RRemoveUserSelfTrackedLearningMutationVariables = Exact<{
  userSelfTrackedLearningId: Scalars['Int']['input'];
}>;

export type RRemoveUserSelfTrackedLearningMutation = {
  __typename?: 'Mutation';
  removeSelfTrackedLearning: { __typename?: 'SelfTrackedLearningResult'; success: boolean };
};

export type RSelfTrackedLearningsQueryVariables = Exact<{
  idIN?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  pagination?: InputMaybe<RPagination>;
}>;

export type RSelfTrackedLearningsQuery = {
  __typename?: 'Query';
  selfTrackedLearnings: {
    __typename?: 'SelfTrackedLearningsPage';
    limit: number;
    page: number;
    total: number;
    data: Array<{
      __typename?: 'SelfTrackedLearning';
      id: number;
      type: RSelfTrackedLearningType;
      title: string;
      description: string;
      effort: number;
      link?: string | undefined;
    }>;
  };
};

export type RSpaceMembersQueryVariables = Exact<{
  filter: RSpaceMemberFilter;
  pagination: RPagination;
}>;

export type RSpaceMembersQuery = {
  __typename?: 'Query';
  spaceMembers: {
    __typename?: 'SpaceMemberPage';
    data: Array<{
      __typename?: 'SpaceMember';
      id: number;
      email: string;
      realm: string;
      spaceId: number;
      firstname?: string | undefined;
      lastname?: string | undefined;
      username?: string | undefined;
      profileImage?: string | undefined;
    }>;
  };
};

export type RSpacesQueryVariables = Exact<{
  withPermissions: Scalars['Boolean']['input'];
  withContentOrigins: Scalars['Boolean']['input'];
}>;

export type RSpacesQuery = {
  __typename?: 'Query';
  spaces: {
    __typename?: 'SpaceV2Page';
    data: Array<{
      __typename?: 'SpaceV2';
      id: number;
      realm?: string | undefined;
      label: string;
      name: string;
      permissions?: { __typename?: 'SpacePermissions'; hasWriteAccessToLearningContent?: boolean | undefined };
      contentOrigins?: {
        __typename?: 'ProviderContentOriginPage';
        data: Array<{
          __typename?: 'ProviderContentOrigin';
          id: string;
          provider: { __typename?: 'Provider'; id: string; title: string; type: RLearningContentProvider };
        }>;
      };
    }>;
  };
};

export type RTeamsQueryVariables = Exact<{
  filter: RTeamsFilter;
  pagination: RPagination;
  sort: RTeamsSort;
  withSubTeams: Scalars['Boolean']['input'];
}>;

export type RTeamsQuery = {
  __typename?: 'Query';
  teams: {
    __typename?: 'TeamsPage';
    limit: number;
    page: number;
    total: number;
    data: Array<{
      __typename?: 'Team';
      id: number;
      realm: string;
      name: string;
      parentTeamId?: number | undefined;
      isReadOnly: boolean;
      subTeams?: {
        __typename?: 'TeamsPage';
        data: Array<{
          __typename?: 'Team';
          id: number;
          realm: string;
          name: string;
          parentTeamId?: number | undefined;
          isReadOnly: boolean;
          members: { __typename?: 'TeamUsersPage'; total: number };
          managers: { __typename?: 'TeamUsersPage'; total: number };
        }>;
      };
      members: { __typename?: 'TeamUsersPage'; total: number };
      managers: { __typename?: 'TeamUsersPage'; total: number };
    }>;
  };
};

export type RTeamQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  withParentTeam: Scalars['Boolean']['input'];
  withParentTeams: Scalars['Boolean']['input'];
}>;

export type RTeamQuery = {
  __typename?: 'Query';
  team?:
    | {
        __typename?: 'Team';
        id: number;
        realm: string;
        name: string;
        parentTeamId?: number | undefined;
        isReadOnly: boolean;
        parentTeam?: {
          __typename?: 'TeamsPage';
          data: Array<{
            __typename?: 'Team';
            id: number;
            realm: string;
            name: string;
            parentTeamId?: number | undefined;
            isReadOnly: boolean;
          }>;
        };
        allParentTeams?: {
          __typename?: 'TeamsPage';
          data: Array<{
            __typename?: 'Team';
            id: number;
            realm: string;
            name: string;
            parentTeamId?: number | undefined;
            isReadOnly: boolean;
          }>;
        };
      }
    | undefined;
};

export type RTeamCreateMutationVariables = Exact<{
  input: RTeamCreateInput;
}>;

export type RTeamCreateMutation = {
  __typename?: 'Mutation';
  teamCreate: { __typename?: 'Team'; id: number; name: string; parentTeamId?: number | undefined };
};

export type RTeamUpdateMutationVariables = Exact<{
  input: RTeamUpdateInput;
}>;

export type RTeamUpdateMutation = {
  __typename?: 'Mutation';
  teamUpdate: { __typename?: 'Team'; id: number; name: string; parentTeamId?: number | undefined };
};

export type RTeamDeleteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type RTeamDeleteMutation = { __typename?: 'Mutation'; teamDelete: boolean };

export type RTeamUsersQueryVariables = Exact<{
  filter: RTeamUsersFilter;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RTeamUsersSort>;
}>;

export type RTeamUsersQuery = {
  __typename?: 'Query';
  teamUsers: {
    __typename?: 'TeamUsersPage';
    limit: number;
    page: number;
    total: number;
    data: Array<{
      __typename?: 'TeamUser';
      teamId: number;
      userId: number;
      role: RTeamRole;
      user: {
        __typename?: 'UserV2';
        id: number;
        email: string;
        realm: string;
        profileImage?: string | undefined;
        username?: string | undefined;
        status: RUserStatus;
        lastActive: Date;
        timestamp: Date;
      };
    }>;
  };
};

export type RTeamUsersAddMutationVariables = Exact<{
  input: Array<RTeamUsersAddInput> | RTeamUsersAddInput;
}>;

export type RTeamUsersAddMutation = {
  __typename?: 'Mutation';
  teamUsersAdd: Array<{ __typename?: 'TeamUser'; teamId: number; userId: number; role: RTeamRole }>;
};

export type RTeamUserChangeRoleMutationVariables = Exact<{
  input: RTeamUserChangeRoleInput;
}>;

export type RTeamUserChangeRoleMutation = {
  __typename?: 'Mutation';
  teamUserChangeRole: { __typename?: 'TeamUser'; teamId: number; userId: number; role: RTeamRole };
};

export type RTeamUserRemoveMutationVariables = Exact<{
  input: RTeamUserRemoveInput;
}>;

export type RTeamUserRemoveMutation = { __typename?: 'Mutation'; teamUserRemove: boolean };

export type RTeamItemFragmentFragment = {
  __typename?: 'Team';
  id: number;
  realm: string;
  name: string;
  parentTeamId?: number | undefined;
  isReadOnly: boolean;
};

export type RTeamUserFragmentFragment = { __typename?: 'TeamUser'; teamId: number; userId: number; role: RTeamRole };

export type RTeamsWithUsersQueryVariables = Exact<{
  filter?: InputMaybe<RTeamsFilter>;
}>;

export type RTeamsWithUsersQuery = {
  __typename?: 'Query';
  teams: {
    __typename?: 'TeamsPage';
    data: Array<{
      __typename?: 'Team';
      id: number;
      name: string;
      teamUsers: {
        __typename?: 'TeamUsersPage';
        total: number;
        data: Array<{
          __typename?: 'TeamUser';
          userId: number;
          user: {
            __typename?: 'UserV2';
            firstname?: string | undefined;
            lastname?: string | undefined;
            profileImage?: string | undefined;
          };
        }>;
      };
    }>;
  };
};

export type RUsersQueryVariables = Exact<{
  filter?: InputMaybe<RUsersFilter>;
  pagination?: InputMaybe<RPagination>;
  sort?: InputMaybe<RUsersSort>;
  withRealmRoleAssignments: Scalars['Boolean']['input'];
}>;

export type RUsersQuery = {
  __typename?: 'Query';
  users: {
    __typename?: 'UsersPage';
    limit: number;
    page: number;
    total: number;
    data: Array<{
      __typename?: 'UserV2';
      id: number;
      email: string;
      realm: string;
      profileImage?: string | undefined;
      username?: string | undefined;
      status: RUserStatus;
      lastActive: Date;
      timestamp: Date;
      realmRoleAssignments?: Array<{ __typename?: 'UserRealmRoleAssignment'; realm?: string | undefined; role: RRealmRole }>;
    }>;
  };
};

export type RUserChangeRealmRoleMutationVariables = Exact<{
  input: RUserChangeRealmRoleInput;
}>;

export type RUserChangeRealmRoleMutation = {
  __typename?: 'Mutation';
  userChangeRealmRole: { __typename?: 'UserV2'; id: number };
};

export type RUserFragmentFragment = {
  __typename?: 'UserV2';
  id: number;
  email: string;
  realm: string;
  profileImage?: string | undefined;
  username?: string | undefined;
  status: RUserStatus;
  lastActive: Date;
  timestamp: Date;
};

export type RChangePasswordMutationVariables = Exact<{ [key: string]: never }>;

export type RChangePasswordMutation = { __typename?: 'Mutation'; changePassword?: string | undefined };

export type RUserPreviewInviteImportMutationVariables = Exact<{
  input: RUserInviteImportPreviewInput;
}>;

export type RUserPreviewInviteImportMutation = {
  __typename?: 'Mutation';
  userPreviewInviteImport: {
    __typename?: 'UserInviteImportPreviewResult';
    success: boolean;
    errorCause?: { __typename?: 'UserInviteImportFileError'; code: RUserInviteImportFileErrorCode } | undefined;
    data?:
      | {
          __typename?: 'UserInviteImportPreview';
          stats: {
            __typename?: 'UserInviteImportPreviewStats';
            total: number;
            willInvite: number;
            alreadyInvited: number;
            invalidEmail: number;
            duplicateInFile: number;
            missingRequiredField: number;
            unknownRealm: number;
            realmAccessDenied: number;
          };
          rows: Array<{
            __typename?: 'UserInviteImportRowPreview';
            outcome: RUserInviteImportRowOutcome;
            row: {
              __typename?: 'UserInviteImportSourceRow';
              email: string;
              firstName?: string | undefined;
              lastName?: string | undefined;
              sourceLine: number;
            };
          }>;
        }
      | undefined;
  };
};

export type RUserConfirmInviteImportMutationVariables = Exact<{
  input: RUserInviteImportConfirmInput;
}>;

export type RUserConfirmInviteImportMutation = {
  __typename?: 'Mutation';
  userConfirmInviteImport: { __typename?: 'UserInviteImportResult'; accepted: boolean; batchId: string; willInviteCount: number };
};

export type RUserInviteImportBatchStatusQueryVariables = Exact<{
  batchId: Scalars['ID']['input'];
}>;

export type RUserInviteImportBatchStatusQuery = {
  __typename?: 'Query';
  userInviteImportBatchStatus: {
    __typename?: 'UserInviteImportBatchStatusResult';
    batchId: string;
    status: RUserInviteImportBatchStatus;
    totalRows: number;
    processed: number;
    invited: number;
    skipped: number;
    errorCount: number;
  };
};

export type RGetUsersByEmailQueryVariables = Exact<{
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type RGetUsersByEmailQuery = {
  __typename?: 'Query';
  getUsersByEmail?:
    | Array<
        | {
            __typename?: 'User';
            id?: number | undefined;
            username?: string | undefined;
            email?: string | undefined;
            realm?: string | undefined;
            profileImage?: string | undefined;
            status?: RAccountStatus | undefined;
          }
        | undefined
      >
    | undefined;
};

export type RCreateUsersMutationVariables = Exact<{
  payload?: InputMaybe<RCreateUserInput>;
}>;

export type RCreateUsersMutation = {
  __typename?: 'Mutation';
  createUsers?: Array<{ __typename?: 'CreateUsersResponse'; userId: number; realm: string } | undefined> | undefined;
};

export type RVoidObjectMutationVariables = Exact<{
  targetUserId: Scalars['Int']['input'];
  objectId: Scalars['String']['input'];
  registration: Scalars['String']['input'];
}>;

export type RVoidObjectMutation = { __typename?: 'Mutation'; voidObject?: string | undefined };

export type RCompleteObjectMutationVariables = Exact<{
  targetUserId: Scalars['Int']['input'];
  objectId: Scalars['String']['input'];
  registration: Scalars['String']['input'];
}>;

export type RCompleteObjectMutation = { __typename?: 'Mutation'; completeObject?: string | undefined };

export type RDeleteXapiStateMutationVariables = Exact<{
  targetUserId: Scalars['Int']['input'];
  objectId: Scalars['String']['input'];
  registration: Scalars['String']['input'];
}>;

export type RDeleteXapiStateMutation = { __typename?: 'Mutation'; deleteXAPIState?: string | undefined };

export type RSearchSubordinateUsersByEmailQueryVariables = Exact<{
  input?: InputMaybe<RSearchSubordinateUsersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RSearchSubordinateUsersByEmailQuery = {
  __typename?: 'Query';
  searchSubordinateUsersByEmail?:
    | Array<
        { __typename?: 'User'; id?: number | undefined; email?: string | undefined; username?: string | undefined } | undefined
      >
    | undefined;
};

export type RSetUserStatusMutationVariables = Exact<{
  input?: InputMaybe<RSetUserStatusInput>;
}>;

export type RSetUserStatusMutation = { __typename?: 'Mutation'; setUserStatus?: string | undefined };

export type RUpdateUsersMutationVariables = Exact<{
  input: RUserChangeInput;
}>;

export type RUpdateUsersMutation = { __typename?: 'Mutation'; updateUser: { __typename?: 'UserV2'; id: number } };

export type RUserByIdQueryVariables = Exact<{
  userId: Scalars['Float']['input'];
}>;

export type RUserByIdQuery = {
  __typename?: 'Query';
  user?:
    | {
        __typename?: 'UserV2';
        id: number;
        email: string;
        realm: string;
        firstname?: string | undefined;
        lastname?: string | undefined;
        username?: string | undefined;
        status: RUserStatus;
        statusV2: RUserStatusV2;
        profileImage?: string | undefined;
        lastPasswordUpdate: Date;
        language?: string | undefined;
        lastActive: Date;
        timestamp: Date;
        externalId?: string | undefined;
      }
    | undefined;
};

export const LearningProgressFragmentDoc = gql`
  fragment LearningProgress on Learning {
    progress {
      __typename
      expiredAt
    }
  }
`;
export const LearningProgressCacheWriteFragmentDoc = gql`
  fragment LearningProgressCacheWrite on Learning {
    progress {
      completed
      completedPercentage
      historical
      expiredAt
    }
  }
`;
export const AssignmentStandardV3BaseFieldsFragmentDoc = gql`
  fragment AssignmentStandardV3BaseFields on AssignmentStandardV3 {
    id
    spaceId
    name
    teaser
    description
    image
    type
    status
    createdAt
    updatedAt
    __typename
  }
`;
export const AssignmentStandardV3LearningPageGenericFieldsFragmentDoc = gql`
  fragment AssignmentStandardV3LearningPageGenericFields on AssignmentStandardV3LearningPage {
    data {
      id
      assignmentGroupId
      learningPathId
      learningId
      order
    }
    ... on AssignmentStandardV3LearningPage {
      data {
        ... on AssignmentStandardV3Learning {
          type
        }
      }
    }
    limit
    page
    total
  }
`;
export const AssignmentStrategicV3LearningPageGenericFieldsFragmentDoc = gql`
  fragment AssignmentStrategicV3LearningPageGenericFields on AssignmentStrategicV3LearningPage {
    data {
      id
      assignmentGroupId
      learningPathId
      learningId
      order
    }
    limit
    page
    total
  }
`;
export const AssignmentStandardV3UsersPageGenericFieldsFragmentDoc = gql`
  fragment AssignmentStandardV3UsersPageGenericFields on AssignmentStandardV3UsersPage {
    data {
      assignmentId
      userId
      agent
      order
      user {
        id
        username
        email
        timestamp
        status
        teams @include(if: $includeUserTeams) {
          data {
            teamId
            team {
              id
              name
            }
          }
        }
      }
    }
    ... on AssignmentStandardV3UsersPage {
      data {
        ... on AssignmentStandardV3User {
          progress {
            estimatedEffort
            requiredItemsCompletedCount
            requiredItemsCount
            completed
            participations {
              assignmentLearningId
              participationId
              progress
              completedAt
              expiredAt
            }
          }
        }
      }
    }
    limit
    page
    total
  }
`;
export const AssignmentStrategicV3UsersPageGenericFieldsFragmentDoc = gql`
  fragment AssignmentStrategicV3UsersPageGenericFields on AssignmentStrategicV3UsersPage {
    data {
      assignmentId
      userId
      agent
      order
      user {
        id
        username
        email
        timestamp
        status
        teams @include(if: $includeUserTeams) {
          data {
            teamId
            team {
              id
              name
            }
          }
        }
      }
    }
    ... on AssignmentStrategicV3UsersPage {
      data {
        ... on AssignmentStrategicV3User {
          progress {
            completed
            estimatedEffort
          }
        }
      }
    }
    limit
    page
    total
  }
`;
export const AssignmentStandardV3GenericFieldsFragmentDoc = gql`
  fragment AssignmentStandardV3GenericFields on AssignmentStandardV3 {
    ...AssignmentStandardV3BaseFields
    learnings(pagination: $pagination) @include(if: $includeLearnings) {
      ...AssignmentStandardV3LearningPageGenericFields
      ...AssignmentStrategicV3LearningPageGenericFields
    }
    users(pagination: $pagination, filter: { userTeamIdIN: $userTeamIdIN, userIdIN: $userIdIN, searchPhrase: $searchPhrase })
      @include(if: $includeUsers) {
      ...AssignmentStandardV3UsersPageGenericFields
      ...AssignmentStrategicV3UsersPageGenericFields
    }
    progress(filter: { userTeamIdIN: $userTeamIdIN }) @include(if: $includeUserTeams) {
      completedCount
      completionRate
    }
  }
  ${AssignmentStandardV3BaseFieldsFragmentDoc}
  ${AssignmentStandardV3LearningPageGenericFieldsFragmentDoc}
  ${AssignmentStrategicV3LearningPageGenericFieldsFragmentDoc}
  ${AssignmentStandardV3UsersPageGenericFieldsFragmentDoc}
  ${AssignmentStrategicV3UsersPageGenericFieldsFragmentDoc}
`;
export const AssignmentStrategicV3BaseFieldsFragmentDoc = gql`
  fragment AssignmentStrategicV3BaseFields on AssignmentStrategicV3 {
    id
    spaceId
    name
    teaser
    description
    image
    type
    status
    createdAt
    updatedAt
    __typename
  }
`;
export const AssignmentStrategicV3GenericFieldsFragmentDoc = gql`
  fragment AssignmentStrategicV3GenericFields on AssignmentStrategicV3 {
    ...AssignmentStrategicV3BaseFields
    learnings(pagination: $pagination) @include(if: $includeLearnings) {
      ...AssignmentStandardV3LearningPageGenericFields
      ...AssignmentStrategicV3LearningPageGenericFields
    }
    users(pagination: $pagination, filter: { userTeamIdIN: $userTeamIdIN, userIdIN: $userIdIN, searchPhrase: $searchPhrase })
      @include(if: $includeUsers) {
      ...AssignmentStandardV3UsersPageGenericFields
      ...AssignmentStrategicV3UsersPageGenericFields
    }
    startAt
    endAt
    learningLoopRecommendedEffort
    totalThresholdEffort
  }
  ${AssignmentStrategicV3BaseFieldsFragmentDoc}
  ${AssignmentStandardV3LearningPageGenericFieldsFragmentDoc}
  ${AssignmentStrategicV3LearningPageGenericFieldsFragmentDoc}
  ${AssignmentStandardV3UsersPageGenericFieldsFragmentDoc}
  ${AssignmentStrategicV3UsersPageGenericFieldsFragmentDoc}
`;
export const AssignmentsV3PageMetadataFieldsFragmentDoc = gql`
  fragment AssignmentsV3PageMetadataFields on AssignmentsV3Page {
    limit
    page
    total
  }
`;
export const LearningContentFragmentDoc = gql`
  fragment LearningContent on LearningContent {
    id
    idV1
    title
    description
    imageURL
    provider
    plannedDuration
    plannedLearningsCount
    metadata {
      language
      level
      type
      timezone
    }
    locations {
      id
      endDate
      startDate
      type
      address
      recordingURL
    }
    curations(filter: { spacedIdsIN: $spaceIds }) {
      id
      spaceId
      launchURLPath
      title
      description
      imageURL
      editURLPath
      systemGenerated
    }
  }
`;
export const ParticipationFragmentDoc = gql`
  fragment Participation on ParticipationV2 {
    id
    objectId
    userId
    progress
    isCompleted
    completedAt
    plannedDuration
    plannedLearningsCount
    userEffort
    expiryAt
  }
`;
export const LearningContentProgressFragmentDoc = gql`
  fragment LearningContentProgress on LearningContent {
    progress: userLastParticipation(userId: $userId) @include(if: $includeContentProgress) {
      ...Participation
    }
  }
  ${ParticipationFragmentDoc}
`;
export const LearningSectionItemFragmentFragmentDoc = gql`
  fragment LearningSectionItemFragment on LearningSectionItem {
    availabilityScheduledAt
    availabilityScheduledAtTimezone
    availabilityType
    createdAt
    isOptional
    learningId
    learningItemURNV2
    order
    realms
    updatedAt
    isLocked(userId: $userId) @include(if: $includeIsLocked)
    id
    learningItem {
      ...LearningContent
      ...LearningContentProgress
      locationsWithEnrollment: locations {
        id
        userLocationEnrollment(userIds: [$userId]) {
          id
        }
      }
    }
  }
  ${LearningContentFragmentDoc}
  ${LearningContentProgressFragmentDoc}
`;
export const PostFragmentFragmentDoc = gql`
  fragment PostFragment on Post {
    __typename
    id
    title
    content
    media {
      url
      type
    }
    created
    deleted
    publishDate
    sticky
    user {
      id
      username
      realm
      email
      role {
        labels
      }
      profileImage
    }
    section {
      path
    }
    permissions {
      canReply
      canEdit
      canDelete
      canSticky
      canUnsticky
      canViewReflectionReplies
    }
    stats {
      likes
      replies
    }
    you {
      have {
        liked
      }
    }
  }
`;
export const SectionFragmentFragmentDoc = gql`
  fragment SectionFragment on Section {
    __typename
    id
    path
    title
    description
    role {
      permissions {
        canPost
        canPostSticky
        canAddReflections
        canViewReflections
        canEditSection
      }
    }
  }
`;
export const InventoryFragmentFragmentDoc = gql`
  fragment InventoryFragment on InventoryItem {
    name
    id
    productId
    userSelfTrackedLearningId
    journeyId
    label
    spaceId
    state
    image
    provider
    providerAccess
    customLink
    accessLink
    teaser
    totalEffort
    totalLearningsCount
    orderId
    isCancellable
    isApprovalRequired
    mandatory
    isExternal
    objectId
    participation {
      completedAt
      progress
      userEffort
    }
    variant {
      id
      name
      validFrom
      validTo
      meta {
        METHOD
        LOCATION
      }
    }
    archived
  }
`;
export const MyEnrollmentsFragmentFragmentDoc = gql`
  fragment MyEnrollmentsFragment on EventEnrollment {
    id
    learningId
    locationId
    title
    teaser
    type
    image
    address
    startDate
    endDate
    room
  }
`;
export const ProductFragmentFragmentDoc = gql`
  fragment ProductFragment on Product {
    id
    name
    label
    creator
    contentOwner
    timestamp
    costCenter
    legalEntity
    price
    currency
    status
    subjects {
      subjectId
      categoryId
      subject
      category
    }
    space {
      id
      name
    }
    meta {
      IMAGE
      TEASER
      DESCRIPTION
      FORMAT
      LEVEL
      LENGTH
      EFFORT
      TOTAL_EFFORT
      LANGUAGE
      INSTITUTION
      INSTRUCTORS
      LOCATION
      ENROLL_BUTTON_TEXT
      CONFIRM_MESSAGE
      PROVIDER
      CUSTOM_LINK
      OBJECT_ID
      PROVIDER_ACCESS
      TEAMS
      TEAMSIZE
      DISCUSSION_SECTION
      REFLECTION_SECTION
      ATTRIBUTES
      CONNECTIONS
    }
    flags {
      available
      approvalRequired
      globalMandatoryTraining
      enrollmentDisabled
      socialFeaturesEnabled
      reflectionsEnabled
      requiresApplication
      canEdit
      featured
      hasTeams
    }
    services {
      id
      type
      provider
      resource
      url
      meta {
        name
        host
        organizationId
        projectId
        description
        title
        picture
        status
        adminLink
        locale
        timezone
        country
        resource
      }
    }
    stocks {
      id
      total
      reserved
      enabled
    }
    state {
      id
      name
      flags {
        drawStock
        endState
        entitlement
      }
    }
    variants {
      id
      name
      validTo
      validFrom
      enabled
      meta {
        LOCATION
        METHOD
      }
    }
    learnifierCourseName
  }
`;
export const LearningContentByIdFragmentDoc = gql`
  fragment LearningContentById on LearningContent {
    id
    idV1
    title
    description
    imageURL
    provider
    plannedDuration
    plannedLearningsCount
    expiredAt
    metadata {
      language
      level
      systemGenerated
      type
      timezone
    }
    locations {
      id
      type
      address
      endDate
      startDate
      recordingURL
    }
    curations(filter: { spacedIdsIN: $spaceIds }) {
      id
      spaceId
      space {
        id
        name
        label
      }
      launchURLPath
      title
      description
      imageURL
      editURLPath
      updatedAt
      systemGenerated
      updateByUser {
        id
        firstname
        lastname
        username
      }
    }
  }
`;
export const LearningBaseFragmentFragmentDoc = gql`
  fragment LearningBaseFragment on Learning {
    id
    created
    updated
    title
    type
    teaser
    image
    preamble
    spaceId
    meta
    effort
    archived
    visibility
    languageId
    updatedByEmail
    creatorEmail
  }
`;
export const LearningPinnedFragmentFragmentDoc = gql`
  fragment LearningPinnedFragment on LearningPinned {
    realm
    learningId
    learningPathId
    learningCollectionId
    learningJourneyId
    position
  }
`;
export const LearningFragmentFragmentDoc = gql`
  fragment LearningFragment on Learning {
    id
    title
    spaceId
    languageId
    teaser
    effort
    image
    visibility
    meta
    status
    type
    urnV2
  }
`;
export const LearningV2FragmentFragmentDoc = gql`
  fragment LearningV2Fragment on LearningV2 {
    id
    contentOwnerId
    title
    spaceId
    languageId
    teaser
    effort
    image
    visibility
    meta
    subjects {
      subjectId
    }
    status
    type
    urn
    updatedAt
  }
`;
export const ActivityFragmentFragmentDoc = gql`
  fragment ActivityFragment on LearningActivityDto {
    createdAt
    data
    id
    learningId
    order
    parentActivityId
    type
    updatedAt
  }
`;
export const LearningModulesDeepFragmentFragmentDoc = gql`
  fragment LearningModulesDeepFragment on Module {
    id
    learningId
    pages {
      id
      name
      order
      moduleId
      blocks {
        id
        pageId
        type
        data
      }
    }
  }
`;
export const LearningProgressFragmentFragmentDoc = gql`
  fragment LearningProgressFragment on LearningProgress {
    completed
    completedPercentage
    expiredAt
    historical
  }
`;
export const LocationsFragmentFragmentDoc = gql`
  fragment LocationsFragment on Location {
    id
    type
    room
    address
    endDate
    startDate
    recordingURL
    registration
    myEnrollment {
      id
      attended
    }
  }
`;
export const LearningActivityAssignmentSubmissionFragmentDoc = gql`
  fragment learningActivityAssignmentSubmission on UserLearningActivityAssignmentSubmission {
    learningActivityId
    userId
    type
    fileName
    fileURL {
      url
      expiresAfter
    }
    createdAt
    updatedAt
  }
`;
export const NotificationFragmentFragmentDoc = gql`
  fragment NotificationFragment on BabelonNotification {
    id
    notificationType
    respondentName
    replyId
    postId
    topLevelPostId
    topLevelPostTitle
    sectionTitle
    sectionPath
    productId
    productTitle
  }
`;
export const TeamItemFragmentFragmentDoc = gql`
  fragment TeamItemFragment on Team {
    id
    realm
    name
    parentTeamId
    isReadOnly
  }
`;
export const TeamUserFragmentFragmentDoc = gql`
  fragment TeamUserFragment on TeamUser {
    teamId
    userId
    role
  }
`;
export const UserFragmentFragmentDoc = gql`
  fragment UserFragment on UserV2 {
    id
    email
    realm
    profileImage
    username
    status
    lastActive
    timestamp
  }
`;
export const GetCompletionRatePerCourseDocument = gql`
  query getCompletionRatePerCourse($usersPool: UsersPool!) {
    completionRatePerCourse: getCompletionRatePerCourse(usersPool: $usersPool) {
      completed
      progressed
      completion_rate
      object_id
      object_type
      object_name
    }
  }
`;

/**
 * __useGetCompletionRatePerCourseQueryRemote__
 *
 * To run a query within a React component, call `useGetCompletionRatePerCourseQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletionRatePerCourseQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletionRatePerCourseQueryRemote({
 *   variables: {
 *      usersPool: // value for 'usersPool'
 *   },
 * });
 */
export function useGetCompletionRatePerCourseQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RGetCompletionRatePerCourseQuery, RGetCompletionRatePerCourseQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetCompletionRatePerCourseQuery, RGetCompletionRatePerCourseQueryVariables>(
    GetCompletionRatePerCourseDocument,
    options,
  );
}
export function useGetCompletionRatePerCourseLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetCompletionRatePerCourseQuery, RGetCompletionRatePerCourseQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetCompletionRatePerCourseQuery, RGetCompletionRatePerCourseQueryVariables>(
    GetCompletionRatePerCourseDocument,
    options,
  );
}
export type GetCompletionRatePerCourseQueryRemoteHookResult = ReturnType<typeof useGetCompletionRatePerCourseQueryRemote>;
export type GetCompletionRatePerCourseLazyQueryRemoteHookResult = ReturnType<typeof useGetCompletionRatePerCourseLazyQueryRemote>;
export type GetCompletionRatePerCourseQueryResult = Apollo.QueryResult<
  RGetCompletionRatePerCourseQuery,
  RGetCompletionRatePerCourseQueryVariables
>;
export const GetDashboardDataDocument = gql`
  query getDashboardData($usersPool: UsersPool!, $from: String, $to: String, $groupBy: String) {
    completionsOverTime: getCompletionsOverTime(usersPool: $usersPool, from: $from, to: $to) {
      name
      value
    }
    userEffort: getUserEffortForRealmOverTime(usersPool: $usersPool, from: $from, to: $to, groupBy: $groupBy) {
      in_progress
      completed
      expired
      completed_not_expired
      total_effort_in_seconds
      distinct_users
      distinct_completed
      distinct_completed_not_expired
      average_effort_per_user_in_seconds
    }
    effortForRealmOverTime: getEffortForRealmOverTime(usersPool: $usersPool, from: $from, to: $to) {
      name
      value
    }
  }
`;

/**
 * __useGetDashboardDataQueryRemote__
 *
 * To run a query within a React component, call `useGetDashboardDataQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardDataQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardDataQueryRemote({
 *   variables: {
 *      usersPool: // value for 'usersPool'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useGetDashboardDataQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RGetDashboardDataQuery, RGetDashboardDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetDashboardDataQuery, RGetDashboardDataQueryVariables>(GetDashboardDataDocument, options);
}
export function useGetDashboardDataLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetDashboardDataQuery, RGetDashboardDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetDashboardDataQuery, RGetDashboardDataQueryVariables>(GetDashboardDataDocument, options);
}
export type GetDashboardDataQueryRemoteHookResult = ReturnType<typeof useGetDashboardDataQueryRemote>;
export type GetDashboardDataLazyQueryRemoteHookResult = ReturnType<typeof useGetDashboardDataLazyQueryRemote>;
export type GetDashboardDataQueryResult = Apollo.QueryResult<RGetDashboardDataQuery, RGetDashboardDataQueryVariables>;
export const IsLearningPathCompletedDocument = gql`
  query isLearningPathCompleted($learningPathId: Int!) {
    isLearningPathCompleted(learningPathId: $learningPathId)
  }
`;

/**
 * __useIsLearningPathCompletedQueryRemote__
 *
 * To run a query within a React component, call `useIsLearningPathCompletedQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useIsLearningPathCompletedQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsLearningPathCompletedQueryRemote({
 *   variables: {
 *      learningPathId: // value for 'learningPathId'
 *   },
 * });
 */
export function useIsLearningPathCompletedQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RIsLearningPathCompletedQuery, RIsLearningPathCompletedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RIsLearningPathCompletedQuery, RIsLearningPathCompletedQueryVariables>(
    IsLearningPathCompletedDocument,
    options,
  );
}
export function useIsLearningPathCompletedLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RIsLearningPathCompletedQuery, RIsLearningPathCompletedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RIsLearningPathCompletedQuery, RIsLearningPathCompletedQueryVariables>(
    IsLearningPathCompletedDocument,
    options,
  );
}
export type IsLearningPathCompletedQueryRemoteHookResult = ReturnType<typeof useIsLearningPathCompletedQueryRemote>;
export type IsLearningPathCompletedLazyQueryRemoteHookResult = ReturnType<typeof useIsLearningPathCompletedLazyQueryRemote>;
export type IsLearningPathCompletedQueryResult = Apollo.QueryResult<
  RIsLearningPathCompletedQuery,
  RIsLearningPathCompletedQueryVariables
>;
export const CompleteLearningPathDocument = gql`
  mutation completeLearningPath($learningPathId: Int!) {
    completeLearningPath(learningPathId: $learningPathId)
  }
`;
export type RCompleteLearningPathMutationFn = Apollo.MutationFunction<
  RCompleteLearningPathMutation,
  RCompleteLearningPathMutationVariables
>;

/**
 * __useCompleteLearningPathMutationRemote__
 *
 * To run a mutation, you first call `useCompleteLearningPathMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteLearningPathMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeLearningPathMutationRemote, { data, loading, error }] = useCompleteLearningPathMutationRemote({
 *   variables: {
 *      learningPathId: // value for 'learningPathId'
 *   },
 * });
 */
export function useCompleteLearningPathMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCompleteLearningPathMutation, RCompleteLearningPathMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCompleteLearningPathMutation, RCompleteLearningPathMutationVariables>(
    CompleteLearningPathDocument,
    options,
  );
}
export type CompleteLearningPathMutationRemoteHookResult = ReturnType<typeof useCompleteLearningPathMutationRemote>;
export type CompleteLearningPathMutationResult = Apollo.MutationResult<RCompleteLearningPathMutation>;
export type CompleteLearningPathMutationOptions = Apollo.BaseMutationOptions<
  RCompleteLearningPathMutation,
  RCompleteLearningPathMutationVariables
>;
export const CompleteLearningDocument = gql`
  mutation completeLearning($learningId: Int!) {
    completeLearning(learningId: $learningId)
  }
`;
export type RCompleteLearningMutationFn = Apollo.MutationFunction<RCompleteLearningMutation, RCompleteLearningMutationVariables>;

/**
 * __useCompleteLearningMutationRemote__
 *
 * To run a mutation, you first call `useCompleteLearningMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteLearningMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeLearningMutationRemote, { data, loading, error }] = useCompleteLearningMutationRemote({
 *   variables: {
 *      learningId: // value for 'learningId'
 *   },
 * });
 */
export function useCompleteLearningMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCompleteLearningMutation, RCompleteLearningMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCompleteLearningMutation, RCompleteLearningMutationVariables>(CompleteLearningDocument, options);
}
export type CompleteLearningMutationRemoteHookResult = ReturnType<typeof useCompleteLearningMutationRemote>;
export type CompleteLearningMutationResult = Apollo.MutationResult<RCompleteLearningMutation>;
export type CompleteLearningMutationOptions = Apollo.BaseMutationOptions<
  RCompleteLearningMutation,
  RCompleteLearningMutationVariables
>;
export const GetUserEffortDocument = gql`
  query getUserEffort($from: String, $to: String) {
    getUserEffort(from: $from, to: $to) {
      total
    }
  }
`;

/**
 * __useGetUserEffortQueryRemote__
 *
 * To run a query within a React component, call `useGetUserEffortQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEffortQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEffortQueryRemote({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetUserEffortQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetUserEffortQuery, RGetUserEffortQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetUserEffortQuery, RGetUserEffortQueryVariables>(GetUserEffortDocument, options);
}
export function useGetUserEffortLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetUserEffortQuery, RGetUserEffortQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetUserEffortQuery, RGetUserEffortQueryVariables>(GetUserEffortDocument, options);
}
export type GetUserEffortQueryRemoteHookResult = ReturnType<typeof useGetUserEffortQueryRemote>;
export type GetUserEffortLazyQueryRemoteHookResult = ReturnType<typeof useGetUserEffortLazyQueryRemote>;
export type GetUserEffortQueryResult = Apollo.QueryResult<RGetUserEffortQuery, RGetUserEffortQueryVariables>;
export const GetParticipationsDocument = gql`
  query getParticipations($input: ParticipationsInput!) {
    participations: getParticipations(input: $input) {
      id
      userId
      objectId
      catalogObjectId
      registration
      progress
      isCompleted
      userEffort
      completedAt
      expiredAt
      platform
      objectName
      objectType
      plannedDuration
      firstStatement
      lastStatement
      firstActivity
      lastActivity
      previousParticipations {
        id
        userId
        objectId
        catalogObjectId
        registration
        progress
        isCompleted
        userEffort
        completedAt
        expiredAt
        platform
        objectName
        objectType
        plannedDuration
        firstStatement
        lastStatement
        firstActivity
        lastActivity
      }
    }
  }
`;

/**
 * __useGetParticipationsQueryRemote__
 *
 * To run a query within a React component, call `useGetParticipationsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipationsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipationsQueryRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetParticipationsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RGetParticipationsQuery, RGetParticipationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetParticipationsQuery, RGetParticipationsQueryVariables>(GetParticipationsDocument, options);
}
export function useGetParticipationsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetParticipationsQuery, RGetParticipationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetParticipationsQuery, RGetParticipationsQueryVariables>(GetParticipationsDocument, options);
}
export type GetParticipationsQueryRemoteHookResult = ReturnType<typeof useGetParticipationsQueryRemote>;
export type GetParticipationsLazyQueryRemoteHookResult = ReturnType<typeof useGetParticipationsLazyQueryRemote>;
export type GetParticipationsQueryResult = Apollo.QueryResult<RGetParticipationsQuery, RGetParticipationsQueryVariables>;
export const GetPopulationDataDocument = gql`
  query getPopulationData($usersPool: UsersPool!) {
    userStatuses: getUserStatuses(usersPool: $usersPool) {
      name
      value
    }
    effortForRealm: getEffortForRealm(usersPool: $usersPool) {
      total_effort_for_realm
      average_effort_per_user
    }
  }
`;

/**
 * __useGetPopulationDataQueryRemote__
 *
 * To run a query within a React component, call `useGetPopulationDataQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetPopulationDataQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopulationDataQueryRemote({
 *   variables: {
 *      usersPool: // value for 'usersPool'
 *   },
 * });
 */
export function useGetPopulationDataQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RGetPopulationDataQuery, RGetPopulationDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetPopulationDataQuery, RGetPopulationDataQueryVariables>(GetPopulationDataDocument, options);
}
export function useGetPopulationDataLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetPopulationDataQuery, RGetPopulationDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetPopulationDataQuery, RGetPopulationDataQueryVariables>(GetPopulationDataDocument, options);
}
export type GetPopulationDataQueryRemoteHookResult = ReturnType<typeof useGetPopulationDataQueryRemote>;
export type GetPopulationDataLazyQueryRemoteHookResult = ReturnType<typeof useGetPopulationDataLazyQueryRemote>;
export type GetPopulationDataQueryResult = Apollo.QueryResult<RGetPopulationDataQuery, RGetPopulationDataQueryVariables>;
export const GetSebDataDocument = gql`
  query getSebData($usersPool: UsersPool!) {
    getSebUsersEmpAndActive(usersPool: $usersPool) {
      count
    }
  }
`;

/**
 * __useGetSebDataQueryRemote__
 *
 * To run a query within a React component, call `useGetSebDataQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetSebDataQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSebDataQueryRemote({
 *   variables: {
 *      usersPool: // value for 'usersPool'
 *   },
 * });
 */
export function useGetSebDataQueryRemote(baseOptions: Apollo.QueryHookOptions<RGetSebDataQuery, RGetSebDataQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetSebDataQuery, RGetSebDataQueryVariables>(GetSebDataDocument, options);
}
export function useGetSebDataLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetSebDataQuery, RGetSebDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetSebDataQuery, RGetSebDataQueryVariables>(GetSebDataDocument, options);
}
export type GetSebDataQueryRemoteHookResult = ReturnType<typeof useGetSebDataQueryRemote>;
export type GetSebDataLazyQueryRemoteHookResult = ReturnType<typeof useGetSebDataLazyQueryRemote>;
export type GetSebDataQueryResult = Apollo.QueryResult<RGetSebDataQuery, RGetSebDataQueryVariables>;
export const GetUserActivitySummaryDocument = gql`
  query getUserActivitySummary($usersPool: UsersPool!) {
    userActivitySummary: getUserActivitySummary(usersPool: $usersPool) {
      id
      company
      email
      first_activity
      last_activity
      participations_completed
      participations_started
      participations_registered
      status
      total_effort_hours
    }
  }
`;

/**
 * __useGetUserActivitySummaryQueryRemote__
 *
 * To run a query within a React component, call `useGetUserActivitySummaryQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetUserActivitySummaryQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserActivitySummaryQueryRemote({
 *   variables: {
 *      usersPool: // value for 'usersPool'
 *   },
 * });
 */
export function useGetUserActivitySummaryQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RGetUserActivitySummaryQuery, RGetUserActivitySummaryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetUserActivitySummaryQuery, RGetUserActivitySummaryQueryVariables>(
    GetUserActivitySummaryDocument,
    options,
  );
}
export function useGetUserActivitySummaryLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetUserActivitySummaryQuery, RGetUserActivitySummaryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetUserActivitySummaryQuery, RGetUserActivitySummaryQueryVariables>(
    GetUserActivitySummaryDocument,
    options,
  );
}
export type GetUserActivitySummaryQueryRemoteHookResult = ReturnType<typeof useGetUserActivitySummaryQueryRemote>;
export type GetUserActivitySummaryLazyQueryRemoteHookResult = ReturnType<typeof useGetUserActivitySummaryLazyQueryRemote>;
export type GetUserActivitySummaryQueryResult = Apollo.QueryResult<
  RGetUserActivitySummaryQuery,
  RGetUserActivitySummaryQueryVariables
>;
export const AssignmentV3Document = gql`
  query assignmentV3(
    $id: Int!
    $userIdIN: [Int!]
    $userTeamIdIN: [Int!]
    $pagination: Pagination
    $searchPhrase: String
    $includeUserTeams: Boolean! = false
    $includeUsers: Boolean! = false
    $includeLearnings: Boolean! = false
    $periodIN: [PeriodFilter!]
    $statusIN: [AssignmentUserCompletionStatus!]
    $selectGeneric: Boolean! = false
    $selectAdmin: Boolean! = false
    $selectLearner: Boolean! = false
    $selectManager: Boolean! = false
    $selectStrategic: Boolean! = false
  ) {
    generic: assignmentV3(id: $id) @include(if: $selectGeneric) {
      ...AssignmentStandardV3GenericFields
      ...AssignmentStrategicV3GenericFields
    }
    admin: assignmentV3(id: $id) @include(if: $selectAdmin) {
      id
      spaceId
      name
      teaser
      description
      image
      rules {
        operator
        expressions {
          operator
          conditions {
            column
            compare
            value
            selections
          }
        }
      }
      type
      status
      surveyId
      learnings(pagination: $pagination) {
        data {
          id
          learningPathId
          learningId
          order
        }
        ... on AssignmentStandardV3LearningPage {
          data {
            ... on AssignmentStandardV3Learning {
              type
            }
          }
        }
      }
      users(pagination: $pagination) {
        data {
          assignmentId
          userId
          user {
            id
            email
            username
            status
          }
          agent
        }
      }
      ... on AssignmentStrategicV3 {
        startAt
        endAt
        learningLoopRecommendedEffort
        totalThresholdEffort
      }
    }
    learner: assignmentV3(id: $id) @include(if: $selectLearner) {
      id
      name
      description
      type
      teaser
      image
      surveyId
      users(pagination: { page: 1, limit: 1 }, filter: { userIdIN: $userIdIN }) {
        data {
          assignmentId
          userId
          user {
            id
          }
        }
        ... on AssignmentStandardV3UsersPage {
          data {
            ... on AssignmentStandardV3User {
              progress {
                estimatedEffort
                requiredItemsCompletedCount
                requiredItemsCount
                completed
                participations {
                  progress
                }
              }
            }
          }
        }
        ... on AssignmentStrategicV3UsersPage {
          data {
            ... on AssignmentStrategicV3User {
              progress {
                completed
                estimatedEffort
                competencyAssessment {
                  canTake
                }
              }
            }
          }
        }
      }
      learnings(pagination: { limit: -1, page: 1 }) {
        data {
          id
          learningPathId
          learningId
          order
        }
        ... on AssignmentStandardV3LearningPage {
          data {
            ... on AssignmentStandardV3Learning {
              type
            }
          }
        }
      }
      ... on AssignmentStrategicV3 {
        startAt
        endAt
        learningLoopRecommendedEffort
        totalThresholdEffort
      }
    }
    manager: assignmentV3(id: $id) @include(if: $selectManager) {
      id
      name
      type
      learnings(pagination: { limit: -1, page: 1 }) {
        total
        data {
          id
          learningPathId
          learningId
          order
        }
        ... on AssignmentStandardV3LearningPage {
          data {
            ... on AssignmentStandardV3Learning {
              type
            }
          }
        }
      }
      users(filter: { userTeamIdIN: $userTeamIdIN }, pagination: { limit: -1 }) {
        data {
          userId
          user {
            id
            username
            email
          }
        }
        ... on AssignmentStandardV3UsersPage {
          data {
            ... on AssignmentStandardV3User {
              progress {
                completed
                participations {
                  assignmentLearningId
                  participationId
                  progress
                  completedAt
                  expiredAt
                }
              }
            }
          }
        }
      }
    }
    strategic: assignmentV3(id: $id) @include(if: $selectStrategic) {
      id
      name
      ... on AssignmentStrategicV3 {
        startAt
        endAt
        learningLoopRecommendedEffort
        totalThresholdEffort
        progress(filter: { userTeamIdIN: $userTeamIdIN, periodIN: $periodIN, statusIN: $statusIN }) {
          estimatedEffort
          reflections {
            completedCount
            completedThreshold
          }
          learners {
            completedCount
            activeCount
          }
        }
      }
      users(pagination: $pagination, filter: { userTeamIdIN: $userTeamIdIN, userIdIN: $userIdIN, statusIN: $statusIN }) {
        total
        data {
          assignmentId
          userId
          user {
            id
            username
            email
            teams {
              data {
                teamId
                team {
                  id
                  name
                }
              }
            }
          }
        }
        ... on AssignmentStrategicV3UsersPage {
          data {
            progress(filter: { periodIN: $periodIN }) {
              reflectionsCompleted
              active
              reflectionsLimit
              completed
              userCompletionStatus
              estimatedEffortProgress
              estimatedEffort
            }
          }
        }
      }
    }
  }
  ${AssignmentStandardV3GenericFieldsFragmentDoc}
  ${AssignmentStrategicV3GenericFieldsFragmentDoc}
`;

/**
 * __useAssignmentV3QueryRemote__
 *
 * To run a query within a React component, call `useAssignmentV3QueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentV3QueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentV3QueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *      userIdIN: // value for 'userIdIN'
 *      userTeamIdIN: // value for 'userTeamIdIN'
 *      pagination: // value for 'pagination'
 *      searchPhrase: // value for 'searchPhrase'
 *      includeUserTeams: // value for 'includeUserTeams'
 *      includeUsers: // value for 'includeUsers'
 *      includeLearnings: // value for 'includeLearnings'
 *      periodIN: // value for 'periodIN'
 *      statusIN: // value for 'statusIN'
 *      selectGeneric: // value for 'selectGeneric'
 *      selectAdmin: // value for 'selectAdmin'
 *      selectLearner: // value for 'selectLearner'
 *      selectManager: // value for 'selectManager'
 *      selectStrategic: // value for 'selectStrategic'
 *   },
 * });
 */
export function useAssignmentV3QueryRemote(
  baseOptions: Apollo.QueryHookOptions<RAssignmentV3Query, RAssignmentV3QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RAssignmentV3Query, RAssignmentV3QueryVariables>(AssignmentV3Document, options);
}
export function useAssignmentV3LazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RAssignmentV3Query, RAssignmentV3QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RAssignmentV3Query, RAssignmentV3QueryVariables>(AssignmentV3Document, options);
}
export type AssignmentV3QueryRemoteHookResult = ReturnType<typeof useAssignmentV3QueryRemote>;
export type AssignmentV3LazyQueryRemoteHookResult = ReturnType<typeof useAssignmentV3LazyQueryRemote>;
export type AssignmentV3QueryResult = Apollo.QueryResult<RAssignmentV3Query, RAssignmentV3QueryVariables>;
export const AssignmentsV3Document = gql`
  query assignmentsV3(
    $spacedIdsIN: [Int!]
    $searchPhrase: String
    $type: AssignmentV3Type
    $userIdIN: [Int!]
    $userTeamIdIN: [Int!]
    $status: AssignmentV3Status
    $sort: AssignmentsV3Sort
    $pagination: Pagination
    $includeUserTeams: Boolean! = false
    $includeUsers: Boolean! = false
    $includeLearnings: Boolean! = false
    $selectGeneric: Boolean! = false
    $selectAdmin: Boolean! = false
    $selectManager: Boolean! = false
    $selectLearner: Boolean! = false
    $selectCards: Boolean! = false
    $selectHomepage: Boolean! = false
  ) {
    assignmentsV3(
      filter: {
        spacedIdsIN: $spacedIdsIN
        searchPhrase: $searchPhrase
        type: $type
        userIdIN: $userIdIN
        userTeamIdIN: $userTeamIdIN
        status: $status
      }
      sort: $sort
      pagination: $pagination
    ) @skip(if: $selectAdmin) {
      ... @include(if: $selectGeneric) {
        data {
          ...AssignmentStandardV3GenericFields
          ...AssignmentStrategicV3GenericFields
        }
        ...AssignmentsV3PageMetadataFields
      }
      ... @include(if: $selectManager) {
        data {
          __typename
          id
          name
          description
          type
          learnings(pagination: $pagination) {
            total
          }
          users(
            pagination: $pagination
            filter: { userTeamIdIN: $userTeamIdIN, userIdIN: $userIdIN, searchPhrase: $searchPhrase }
          ) {
            total
          }
          ... on AssignmentStrategicV3 {
            progress(filter: { userTeamIdIN: $userTeamIdIN }) {
              learners {
                completedCount
                activeCount
              }
            }
          }
          ... on AssignmentStandardV3 {
            progress(filter: { userTeamIdIN: $userTeamIdIN }) {
              completedCount
              completionRate
            }
          }
        }
      }
      ... @include(if: $selectLearner) {
        data {
          __typename
          id
          name
          type
          learnings(pagination: $pagination) {
            data {
              id
              learningPathId
              learningId
              order
            }
            ... on AssignmentStandardV3LearningPage {
              data {
                ... on AssignmentStandardV3Learning {
                  type
                }
              }
            }
          }
        }
      }
      ... @include(if: $selectCards) {
        data {
          id
          name
          type
          ... on AssignmentStrategicV3 {
            startAt
            endAt
            totalThresholdEffort
          }
          users(
            pagination: $pagination
            filter: { userTeamIdIN: $userTeamIdIN, userIdIN: $userIdIN, searchPhrase: $searchPhrase }
          ) {
            data {
              assignmentId
              userId
              user {
                id
              }
            }
            ... on AssignmentStandardV3UsersPage {
              data {
                ... on AssignmentStandardV3User {
                  progress {
                    estimatedEffort
                    requiredItemsCompletedCount
                    requiredItemsCount
                    completed
                    participations {
                      progress
                    }
                  }
                }
              }
            }
            ... on AssignmentStrategicV3UsersPage {
              data {
                ... on AssignmentStrategicV3User {
                  progress {
                    completed
                    estimatedEffort
                  }
                }
              }
            }
          }
        }
      }
      ... @include(if: $selectHomepage) {
        data {
          id
          name
          teaser
          image
        }
      }
    }
    admin: assignmentsV3(filter: { spacedIdsIN: $spacedIdsIN }, pagination: $pagination) @include(if: $selectAdmin) {
      data {
        __typename
        id
        name
        type
        status
        spaceId
        learnings(pagination: $pagination) {
          total
        }
        users(pagination: $pagination) {
          total
        }
      }
    }
  }
  ${AssignmentStandardV3GenericFieldsFragmentDoc}
  ${AssignmentStrategicV3GenericFieldsFragmentDoc}
  ${AssignmentsV3PageMetadataFieldsFragmentDoc}
`;

/**
 * __useAssignmentsV3QueryRemote__
 *
 * To run a query within a React component, call `useAssignmentsV3QueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentsV3QueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentsV3QueryRemote({
 *   variables: {
 *      spacedIdsIN: // value for 'spacedIdsIN'
 *      searchPhrase: // value for 'searchPhrase'
 *      type: // value for 'type'
 *      userIdIN: // value for 'userIdIN'
 *      userTeamIdIN: // value for 'userTeamIdIN'
 *      status: // value for 'status'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      includeUserTeams: // value for 'includeUserTeams'
 *      includeUsers: // value for 'includeUsers'
 *      includeLearnings: // value for 'includeLearnings'
 *      selectGeneric: // value for 'selectGeneric'
 *      selectAdmin: // value for 'selectAdmin'
 *      selectManager: // value for 'selectManager'
 *      selectLearner: // value for 'selectLearner'
 *      selectCards: // value for 'selectCards'
 *      selectHomepage: // value for 'selectHomepage'
 *   },
 * });
 */
export function useAssignmentsV3QueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RAssignmentsV3Query, RAssignmentsV3QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RAssignmentsV3Query, RAssignmentsV3QueryVariables>(AssignmentsV3Document, options);
}
export function useAssignmentsV3LazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RAssignmentsV3Query, RAssignmentsV3QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RAssignmentsV3Query, RAssignmentsV3QueryVariables>(AssignmentsV3Document, options);
}
export type AssignmentsV3QueryRemoteHookResult = ReturnType<typeof useAssignmentsV3QueryRemote>;
export type AssignmentsV3LazyQueryRemoteHookResult = ReturnType<typeof useAssignmentsV3LazyQueryRemote>;
export type AssignmentsV3QueryResult = Apollo.QueryResult<RAssignmentsV3Query, RAssignmentsV3QueryVariables>;
export const DeleteAssignmentV3Document = gql`
  mutation deleteAssignmentV3($id: Int!) {
    deleteAssignmentV3(id: $id) {
      success
    }
  }
`;
export type RDeleteAssignmentV3MutationFn = Apollo.MutationFunction<
  RDeleteAssignmentV3Mutation,
  RDeleteAssignmentV3MutationVariables
>;

/**
 * __useDeleteAssignmentV3MutationRemote__
 *
 * To run a mutation, you first call `useDeleteAssignmentV3MutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentV3MutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentV3MutationRemote, { data, loading, error }] = useDeleteAssignmentV3MutationRemote({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssignmentV3MutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RDeleteAssignmentV3Mutation, RDeleteAssignmentV3MutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RDeleteAssignmentV3Mutation, RDeleteAssignmentV3MutationVariables>(
    DeleteAssignmentV3Document,
    options,
  );
}
export type DeleteAssignmentV3MutationRemoteHookResult = ReturnType<typeof useDeleteAssignmentV3MutationRemote>;
export type DeleteAssignmentV3MutationResult = Apollo.MutationResult<RDeleteAssignmentV3Mutation>;
export type DeleteAssignmentV3MutationOptions = Apollo.BaseMutationOptions<
  RDeleteAssignmentV3Mutation,
  RDeleteAssignmentV3MutationVariables
>;
export const UpsertAssignmentV3Document = gql`
  mutation upsertAssignmentV3($input: UpsertAssignmentInput!) {
    upsertAssignmentV3(input: $input) {
      assignment {
        id
        spaceId
        name
        teaser
        description
        image
        surveyId
        rules {
          operator
          expressions {
            operator
            conditions {
              column
              compare
              value
              selections
            }
          }
        }
        type
        status
        learnings(pagination: { limit: -1, page: 1 }) {
          data {
            id
            assignmentGroupId
            learningPathId
            learningId
            order
          }
          ... on AssignmentStandardV3LearningPage {
            data {
              ... on AssignmentStandardV3Learning {
                type
              }
            }
          }
        }
        users(pagination: { limit: -1, page: 1 }) {
          data {
            userId
            assignmentId
            user {
              id
              email
              username
            }
            agent
          }
          ... on AssignmentStandardV3UsersPage {
            data {
              ... on AssignmentStandardV3User {
                progress {
                  completed
                  participations {
                    assignmentLearningId
                    participationId
                    progress
                    completedAt
                    expiredAt
                  }
                }
              }
            }
          }
        }
        ... on AssignmentStrategicV3 {
          startAt
          endAt
          learningLoopRecommendedEffort
          totalThresholdEffort
        }
      }
      success
    }
  }
`;
export type RUpsertAssignmentV3MutationFn = Apollo.MutationFunction<
  RUpsertAssignmentV3Mutation,
  RUpsertAssignmentV3MutationVariables
>;

/**
 * __useUpsertAssignmentV3MutationRemote__
 *
 * To run a mutation, you first call `useUpsertAssignmentV3MutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAssignmentV3MutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAssignmentV3MutationRemote, { data, loading, error }] = useUpsertAssignmentV3MutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAssignmentV3MutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpsertAssignmentV3Mutation, RUpsertAssignmentV3MutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpsertAssignmentV3Mutation, RUpsertAssignmentV3MutationVariables>(
    UpsertAssignmentV3Document,
    options,
  );
}
export type UpsertAssignmentV3MutationRemoteHookResult = ReturnType<typeof useUpsertAssignmentV3MutationRemote>;
export type UpsertAssignmentV3MutationResult = Apollo.MutationResult<RUpsertAssignmentV3Mutation>;
export type UpsertAssignmentV3MutationOptions = Apollo.BaseMutationOptions<
  RUpsertAssignmentV3Mutation,
  RUpsertAssignmentV3MutationVariables
>;
export const AssignmentTemplatesDocument = gql`
  query assignmentTemplates {
    assignmentTemplates {
      id
      image
      name
      teaser
    }
  }
`;

/**
 * __useAssignmentTemplatesQueryRemote__
 *
 * To run a query within a React component, call `useAssignmentTemplatesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentTemplatesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentTemplatesQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useAssignmentTemplatesQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RAssignmentTemplatesQuery, RAssignmentTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RAssignmentTemplatesQuery, RAssignmentTemplatesQueryVariables>(AssignmentTemplatesDocument, options);
}
export function useAssignmentTemplatesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RAssignmentTemplatesQuery, RAssignmentTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RAssignmentTemplatesQuery, RAssignmentTemplatesQueryVariables>(AssignmentTemplatesDocument, options);
}
export type AssignmentTemplatesQueryRemoteHookResult = ReturnType<typeof useAssignmentTemplatesQueryRemote>;
export type AssignmentTemplatesLazyQueryRemoteHookResult = ReturnType<typeof useAssignmentTemplatesLazyQueryRemote>;
export type AssignmentTemplatesQueryResult = Apollo.QueryResult<RAssignmentTemplatesQuery, RAssignmentTemplatesQueryVariables>;
export const CreateAssignmentFromTemplateDocument = gql`
  mutation createAssignmentFromTemplate($input: CreateAssignmentFromTemplateInput!) {
    createAssignmentFromTemplate(input: $input) {
      assignment {
        id
        name
      }
      success
    }
  }
`;
export type RCreateAssignmentFromTemplateMutationFn = Apollo.MutationFunction<
  RCreateAssignmentFromTemplateMutation,
  RCreateAssignmentFromTemplateMutationVariables
>;

/**
 * __useCreateAssignmentFromTemplateMutationRemote__
 *
 * To run a mutation, you first call `useCreateAssignmentFromTemplateMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentFromTemplateMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentFromTemplateMutationRemote, { data, loading, error }] = useCreateAssignmentFromTemplateMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssignmentFromTemplateMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCreateAssignmentFromTemplateMutation, RCreateAssignmentFromTemplateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateAssignmentFromTemplateMutation, RCreateAssignmentFromTemplateMutationVariables>(
    CreateAssignmentFromTemplateDocument,
    options,
  );
}
export type CreateAssignmentFromTemplateMutationRemoteHookResult = ReturnType<
  typeof useCreateAssignmentFromTemplateMutationRemote
>;
export type CreateAssignmentFromTemplateMutationResult = Apollo.MutationResult<RCreateAssignmentFromTemplateMutation>;
export type CreateAssignmentFromTemplateMutationOptions = Apollo.BaseMutationOptions<
  RCreateAssignmentFromTemplateMutation,
  RCreateAssignmentFromTemplateMutationVariables
>;
export const AddAssignmentUserSurveyDocument = gql`
  mutation addAssignmentUserSurvey($input: AssignmentUserSurveyInput!) {
    addAssignmentUserSurvey(input: $input) {
      success
    }
  }
`;
export type RAddAssignmentUserSurveyMutationFn = Apollo.MutationFunction<
  RAddAssignmentUserSurveyMutation,
  RAddAssignmentUserSurveyMutationVariables
>;

/**
 * __useAddAssignmentUserSurveyMutationRemote__
 *
 * To run a mutation, you first call `useAddAssignmentUserSurveyMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssignmentUserSurveyMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssignmentUserSurveyMutationRemote, { data, loading, error }] = useAddAssignmentUserSurveyMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAssignmentUserSurveyMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RAddAssignmentUserSurveyMutation, RAddAssignmentUserSurveyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RAddAssignmentUserSurveyMutation, RAddAssignmentUserSurveyMutationVariables>(
    AddAssignmentUserSurveyDocument,
    options,
  );
}
export type AddAssignmentUserSurveyMutationRemoteHookResult = ReturnType<typeof useAddAssignmentUserSurveyMutationRemote>;
export type AddAssignmentUserSurveyMutationResult = Apollo.MutationResult<RAddAssignmentUserSurveyMutation>;
export type AddAssignmentUserSurveyMutationOptions = Apollo.BaseMutationOptions<
  RAddAssignmentUserSurveyMutation,
  RAddAssignmentUserSurveyMutationVariables
>;
export const AssignmentsV3UserRuleFieldsDocument = gql`
  query assignmentsV3UserRuleFields($filter: AssignmentsV3UserRuleFieldFilter!) {
    assignmentsV3UserRuleFields(filter: $filter) {
      field
      values
    }
  }
`;

/**
 * __useAssignmentsV3UserRuleFieldsQueryRemote__
 *
 * To run a query within a React component, call `useAssignmentsV3UserRuleFieldsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentsV3UserRuleFieldsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentsV3UserRuleFieldsQueryRemote({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAssignmentsV3UserRuleFieldsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RAssignmentsV3UserRuleFieldsQuery, RAssignmentsV3UserRuleFieldsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RAssignmentsV3UserRuleFieldsQuery, RAssignmentsV3UserRuleFieldsQueryVariables>(
    AssignmentsV3UserRuleFieldsDocument,
    options,
  );
}
export function useAssignmentsV3UserRuleFieldsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RAssignmentsV3UserRuleFieldsQuery, RAssignmentsV3UserRuleFieldsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RAssignmentsV3UserRuleFieldsQuery, RAssignmentsV3UserRuleFieldsQueryVariables>(
    AssignmentsV3UserRuleFieldsDocument,
    options,
  );
}
export type AssignmentsV3UserRuleFieldsQueryRemoteHookResult = ReturnType<typeof useAssignmentsV3UserRuleFieldsQueryRemote>;
export type AssignmentsV3UserRuleFieldsLazyQueryRemoteHookResult = ReturnType<
  typeof useAssignmentsV3UserRuleFieldsLazyQueryRemote
>;
export type AssignmentsV3UserRuleFieldsQueryResult = Apollo.QueryResult<
  RAssignmentsV3UserRuleFieldsQuery,
  RAssignmentsV3UserRuleFieldsQueryVariables
>;
export const AssignmentsV3UserRulePreviewDocument = gql`
  query assignmentsV3UserRulePreview($payload: AssignmentsV3UserRulePreviewFilter!) {
    assignmentsV3UserRulePreview(filter: $payload) {
      users {
        id
        email
        username
        profileImage
      }
    }
  }
`;

/**
 * __useAssignmentsV3UserRulePreviewQueryRemote__
 *
 * To run a query within a React component, call `useAssignmentsV3UserRulePreviewQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentsV3UserRulePreviewQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentsV3UserRulePreviewQueryRemote({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAssignmentsV3UserRulePreviewQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RAssignmentsV3UserRulePreviewQuery, RAssignmentsV3UserRulePreviewQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RAssignmentsV3UserRulePreviewQuery, RAssignmentsV3UserRulePreviewQueryVariables>(
    AssignmentsV3UserRulePreviewDocument,
    options,
  );
}
export function useAssignmentsV3UserRulePreviewLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RAssignmentsV3UserRulePreviewQuery, RAssignmentsV3UserRulePreviewQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RAssignmentsV3UserRulePreviewQuery, RAssignmentsV3UserRulePreviewQueryVariables>(
    AssignmentsV3UserRulePreviewDocument,
    options,
  );
}
export type AssignmentsV3UserRulePreviewQueryRemoteHookResult = ReturnType<typeof useAssignmentsV3UserRulePreviewQueryRemote>;
export type AssignmentsV3UserRulePreviewLazyQueryRemoteHookResult = ReturnType<
  typeof useAssignmentsV3UserRulePreviewLazyQueryRemote
>;
export type AssignmentsV3UserRulePreviewQueryResult = Apollo.QueryResult<
  RAssignmentsV3UserRulePreviewQuery,
  RAssignmentsV3UserRulePreviewQueryVariables
>;
export const AssignmentV3UsersDocument = gql`
  query assignmentV3Users(
    $filter: AssignmentV3UsersFilter!
    $pagination: Pagination
    $sort: AssignmentUsersV3Sort
    $includeProgress: Boolean!
  ) {
    assignmentV3Users(filter: $filter, pagination: $pagination, sort: $sort) {
      data {
        userId
        assignmentId
        user {
          id
          email
          profileImage
          username
          status
        }
        ... on AssignmentStrategicV3User {
          progress @include(if: $includeProgress) {
            completed
            estimatedEffort
          }
        }
        ... on AssignmentStandardV3User {
          progress @include(if: $includeProgress) {
            __typename
            participations {
              assignmentLearningId
              participationId
              progress
              completedAt
            }
          }
        }
      }
      total
    }
  }
`;

/**
 * __useAssignmentV3UsersQueryRemote__
 *
 * To run a query within a React component, call `useAssignmentV3UsersQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentV3UsersQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentV3UsersQueryRemote({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      includeProgress: // value for 'includeProgress'
 *   },
 * });
 */
export function useAssignmentV3UsersQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RAssignmentV3UsersQuery, RAssignmentV3UsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RAssignmentV3UsersQuery, RAssignmentV3UsersQueryVariables>(AssignmentV3UsersDocument, options);
}
export function useAssignmentV3UsersLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RAssignmentV3UsersQuery, RAssignmentV3UsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RAssignmentV3UsersQuery, RAssignmentV3UsersQueryVariables>(AssignmentV3UsersDocument, options);
}
export type AssignmentV3UsersQueryRemoteHookResult = ReturnType<typeof useAssignmentV3UsersQueryRemote>;
export type AssignmentV3UsersLazyQueryRemoteHookResult = ReturnType<typeof useAssignmentV3UsersLazyQueryRemote>;
export type AssignmentV3UsersQueryResult = Apollo.QueryResult<RAssignmentV3UsersQuery, RAssignmentV3UsersQueryVariables>;
export const UserLearningContentLastParticipationDocument = gql`
  query userLearningContentLastParticipation($userId: Int!, $learningContentId: URN!) {
    userLearningContentLastParticipation(userId: $userId, learningContentId: $learningContentId) {
      ...Participation
    }
  }
  ${ParticipationFragmentDoc}
`;

/**
 * __useUserLearningContentLastParticipationQueryRemote__
 *
 * To run a query within a React component, call `useUserLearningContentLastParticipationQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useUserLearningContentLastParticipationQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLearningContentLastParticipationQueryRemote({
 *   variables: {
 *      userId: // value for 'userId'
 *      learningContentId: // value for 'learningContentId'
 *   },
 * });
 */
export function useUserLearningContentLastParticipationQueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RUserLearningContentLastParticipationQuery,
    RUserLearningContentLastParticipationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RUserLearningContentLastParticipationQuery, RUserLearningContentLastParticipationQueryVariables>(
    UserLearningContentLastParticipationDocument,
    options,
  );
}
export function useUserLearningContentLastParticipationLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RUserLearningContentLastParticipationQuery,
    RUserLearningContentLastParticipationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RUserLearningContentLastParticipationQuery, RUserLearningContentLastParticipationQueryVariables>(
    UserLearningContentLastParticipationDocument,
    options,
  );
}
export type UserLearningContentLastParticipationQueryRemoteHookResult = ReturnType<
  typeof useUserLearningContentLastParticipationQueryRemote
>;
export type UserLearningContentLastParticipationLazyQueryRemoteHookResult = ReturnType<
  typeof useUserLearningContentLastParticipationLazyQueryRemote
>;
export type UserLearningContentLastParticipationQueryResult = Apollo.QueryResult<
  RUserLearningContentLastParticipationQuery,
  RUserLearningContentLastParticipationQueryVariables
>;
export const UserLearningContentLastParticipationsDocument = gql`
  query userLearningContentLastParticipations($userId: Int!, $learningContentIdIn: [URN!]!) {
    userLearningContentLastParticipations(userId: $userId, learningContentIdIN: $learningContentIdIn) {
      ...Participation
    }
  }
  ${ParticipationFragmentDoc}
`;

/**
 * __useUserLearningContentLastParticipationsQueryRemote__
 *
 * To run a query within a React component, call `useUserLearningContentLastParticipationsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useUserLearningContentLastParticipationsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLearningContentLastParticipationsQueryRemote({
 *   variables: {
 *      userId: // value for 'userId'
 *      learningContentIdIn: // value for 'learningContentIdIn'
 *   },
 * });
 */
export function useUserLearningContentLastParticipationsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RUserLearningContentLastParticipationsQuery,
    RUserLearningContentLastParticipationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RUserLearningContentLastParticipationsQuery, RUserLearningContentLastParticipationsQueryVariables>(
    UserLearningContentLastParticipationsDocument,
    options,
  );
}
export function useUserLearningContentLastParticipationsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RUserLearningContentLastParticipationsQuery,
    RUserLearningContentLastParticipationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RUserLearningContentLastParticipationsQuery, RUserLearningContentLastParticipationsQueryVariables>(
    UserLearningContentLastParticipationsDocument,
    options,
  );
}
export type UserLearningContentLastParticipationsQueryRemoteHookResult = ReturnType<
  typeof useUserLearningContentLastParticipationsQueryRemote
>;
export type UserLearningContentLastParticipationsLazyQueryRemoteHookResult = ReturnType<
  typeof useUserLearningContentLastParticipationsLazyQueryRemote
>;
export type UserLearningContentLastParticipationsQueryResult = Apollo.QueryResult<
  RUserLearningContentLastParticipationsQuery,
  RUserLearningContentLastParticipationsQueryVariables
>;
export const GetCategoriesDocument = gql`
  query getCategories {
    getCategories {
      id
      name
      urlKey
      subjects {
        id
        name
        urlKey
      }
    }
  }
`;

/**
 * __useGetCategoriesQueryRemote__
 *
 * To run a query within a React component, call `useGetCategoriesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoriesQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetCategoriesQuery, RGetCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetCategoriesQuery, RGetCategoriesQueryVariables>(GetCategoriesDocument, options);
}
export function useGetCategoriesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetCategoriesQuery, RGetCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetCategoriesQuery, RGetCategoriesQueryVariables>(GetCategoriesDocument, options);
}
export type GetCategoriesQueryRemoteHookResult = ReturnType<typeof useGetCategoriesQueryRemote>;
export type GetCategoriesLazyQueryRemoteHookResult = ReturnType<typeof useGetCategoriesLazyQueryRemote>;
export type GetCategoriesQueryResult = Apollo.QueryResult<RGetCategoriesQuery, RGetCategoriesQueryVariables>;
export const LearningCollectionsV2Document = gql`
  query learningCollectionsV2($filter: LearningCollectionFilter!, $pagination: Pagination, $sort: LearningCollectionSort) {
    learningCollectionsV2(filter: $filter, pagination: $pagination, sort: $sort) {
      data {
        id
        title
        visibility
        status
        space {
          id
          name
        }
        subject {
          subjectId
          subject
          categoryId
          category
        }
        items {
          total
        }
      }
      limit
      page
      total
    }
  }
`;

/**
 * __useLearningCollectionsV2QueryRemote__
 *
 * To run a query within a React component, call `useLearningCollectionsV2QueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningCollectionsV2QueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCollectionsV2QueryRemote({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLearningCollectionsV2QueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningCollectionsV2Query, RLearningCollectionsV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningCollectionsV2Query, RLearningCollectionsV2QueryVariables>(
    LearningCollectionsV2Document,
    options,
  );
}
export function useLearningCollectionsV2LazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningCollectionsV2Query, RLearningCollectionsV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningCollectionsV2Query, RLearningCollectionsV2QueryVariables>(
    LearningCollectionsV2Document,
    options,
  );
}
export type LearningCollectionsV2QueryRemoteHookResult = ReturnType<typeof useLearningCollectionsV2QueryRemote>;
export type LearningCollectionsV2LazyQueryRemoteHookResult = ReturnType<typeof useLearningCollectionsV2LazyQueryRemote>;
export type LearningCollectionsV2QueryResult = Apollo.QueryResult<
  RLearningCollectionsV2Query,
  RLearningCollectionsV2QueryVariables
>;
export const LearningCollectionV2Document = gql`
  query learningCollectionV2($id: Int!, $spaceIds: [Int!]!) {
    learningCollectionV2(id: $id) {
      id
      urn
      title
      imageURL
      visibility
      status
      updatedAt
      updatedByUser {
        id
        firstname
        lastname
      }
      space {
        id
        name
      }
      subject {
        subjectId
        subject
        categoryId
        category
      }
      items {
        data {
          collectionId
          content {
            id
            title
            description
            imageURL
            provider
            plannedDuration
            metadata {
              language
              level
              type
              timezone
            }
            curations(filter: { spacedIdsIN: $spaceIds }) {
              id
              spaceId
              launchURLPath
              title
              description
              imageURL
              editURLPath
              systemGenerated
            }
          }
          contentURNV1
          curationURNV1
          id
          order
        }
        total
      }
    }
  }
`;

/**
 * __useLearningCollectionV2QueryRemote__
 *
 * To run a query within a React component, call `useLearningCollectionV2QueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningCollectionV2QueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCollectionV2QueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *      spaceIds: // value for 'spaceIds'
 *   },
 * });
 */
export function useLearningCollectionV2QueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningCollectionV2Query, RLearningCollectionV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningCollectionV2Query, RLearningCollectionV2QueryVariables>(LearningCollectionV2Document, options);
}
export function useLearningCollectionV2LazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningCollectionV2Query, RLearningCollectionV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningCollectionV2Query, RLearningCollectionV2QueryVariables>(
    LearningCollectionV2Document,
    options,
  );
}
export type LearningCollectionV2QueryRemoteHookResult = ReturnType<typeof useLearningCollectionV2QueryRemote>;
export type LearningCollectionV2LazyQueryRemoteHookResult = ReturnType<typeof useLearningCollectionV2LazyQueryRemote>;
export type LearningCollectionV2QueryResult = Apollo.QueryResult<RLearningCollectionV2Query, RLearningCollectionV2QueryVariables>;
export const ReportingLearningSummaryDocument = gql`
  query reportingLearningSummary($args: reportingLearningSummary_arguments!, $distinct_on: [learning_summary_enum_name!]) {
    reportingLearningSummary(args: $args, distinct_on: $distinct_on) {
      urn
      title
      type
      not_started_count
      started_count
      completed_count
      average_progress
      completion_rate
    }
  }
`;

/**
 * __useReportingLearningSummaryQueryRemote__
 *
 * To run a query within a React component, call `useReportingLearningSummaryQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingLearningSummaryQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingLearningSummaryQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      distinct_on: // value for 'distinct_on'
 *   },
 * });
 */
export function useReportingLearningSummaryQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RReportingLearningSummaryQuery, RReportingLearningSummaryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingLearningSummaryQuery, RReportingLearningSummaryQueryVariables>(
    ReportingLearningSummaryDocument,
    options,
  );
}
export function useReportingLearningSummaryLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RReportingLearningSummaryQuery, RReportingLearningSummaryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingLearningSummaryQuery, RReportingLearningSummaryQueryVariables>(
    ReportingLearningSummaryDocument,
    options,
  );
}
export type ReportingLearningSummaryQueryRemoteHookResult = ReturnType<typeof useReportingLearningSummaryQueryRemote>;
export type ReportingLearningSummaryLazyQueryRemoteHookResult = ReturnType<typeof useReportingLearningSummaryLazyQueryRemote>;
export type ReportingLearningSummaryQueryResult = Apollo.QueryResult<
  RReportingLearningSummaryQuery,
  RReportingLearningSummaryQueryVariables
>;
export const ReportingLearningActivitiesInsightsDocument = gql`
  query reportingLearningActivitiesInsights(
    $where: reportingLearningActivitiesInsights_bool_exp
    $order_by: [reportingLearningActivitiesInsights_order_by!]
    $limit: Int
    $offset: Int
    $distinct_on: [reportingLearningActivitiesInsights_select_column!]
    $whereAggregate: reportingLearningActivitiesInsights_bool_exp
  ) {
    reportingLearningActivitiesInsights(
      where: $where
      order_by: $order_by
      limit: $limit
      offset: $offset
      distinct_on: $distinct_on
    ) {
      activityURN
      activityType
      completedCount
      completionRate
      type
      totalEffortInSeconds
      title
      startedCount
      totalCount
      inProgressCount
      progress
      order
      plannedDuration
      notStartedCount
      metaUpdateTime
      learningURN
    }
    filteredTotal: reportingLearningActivitiesInsightsAggregate(where: $where) {
      aggregate {
        count
      }
    }
    total: reportingLearningActivitiesInsightsAggregate(where: $whereAggregate) {
      aggregate {
        count
      }
    }
  }
`;

/**
 * __useReportingLearningActivitiesInsightsQueryRemote__
 *
 * To run a query within a React component, call `useReportingLearningActivitiesInsightsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingLearningActivitiesInsightsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingLearningActivitiesInsightsQueryRemote({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      distinct_on: // value for 'distinct_on'
 *      whereAggregate: // value for 'whereAggregate'
 *   },
 * });
 */
export function useReportingLearningActivitiesInsightsQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<
    RReportingLearningActivitiesInsightsQuery,
    RReportingLearningActivitiesInsightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingLearningActivitiesInsightsQuery, RReportingLearningActivitiesInsightsQueryVariables>(
    ReportingLearningActivitiesInsightsDocument,
    options,
  );
}
export function useReportingLearningActivitiesInsightsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingLearningActivitiesInsightsQuery,
    RReportingLearningActivitiesInsightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingLearningActivitiesInsightsQuery, RReportingLearningActivitiesInsightsQueryVariables>(
    ReportingLearningActivitiesInsightsDocument,
    options,
  );
}
export type ReportingLearningActivitiesInsightsQueryRemoteHookResult = ReturnType<
  typeof useReportingLearningActivitiesInsightsQueryRemote
>;
export type ReportingLearningActivitiesInsightsLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingLearningActivitiesInsightsLazyQueryRemote
>;
export type ReportingLearningActivitiesInsightsQueryResult = Apollo.QueryResult<
  RReportingLearningActivitiesInsightsQuery,
  RReportingLearningActivitiesInsightsQueryVariables
>;
export const ReportingParticipantsInsightsDocument = gql`
  query reportingParticipantsInsights(
    $where: reportingParticipantsInsights_bool_exp
    $order_by: [reportingParticipantsInsights_order_by!]
    $limit: Int
    $offset: Int
    $distinct_on: [reportingParticipantsInsights_select_column!]
    $whereAggregate: reportingParticipantsInsights_bool_exp
  ) {
    reportingParticipantsInsights(where: $where, order_by: $order_by, limit: $limit, offset: $offset, distinct_on: $distinct_on) {
      status
      email
      progress
      firstStatement
      profileImage
      urn
      userId
      username
    }
    total: reportingParticipantsInsightsAggregate(where: $whereAggregate) {
      aggregate {
        count
      }
    }
  }
`;

/**
 * __useReportingParticipantsInsightsQueryRemote__
 *
 * To run a query within a React component, call `useReportingParticipantsInsightsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingParticipantsInsightsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingParticipantsInsightsQueryRemote({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      distinct_on: // value for 'distinct_on'
 *      whereAggregate: // value for 'whereAggregate'
 *   },
 * });
 */
export function useReportingParticipantsInsightsQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RReportingParticipantsInsightsQuery, RReportingParticipantsInsightsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingParticipantsInsightsQuery, RReportingParticipantsInsightsQueryVariables>(
    ReportingParticipantsInsightsDocument,
    options,
  );
}
export function useReportingParticipantsInsightsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RReportingParticipantsInsightsQuery, RReportingParticipantsInsightsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingParticipantsInsightsQuery, RReportingParticipantsInsightsQueryVariables>(
    ReportingParticipantsInsightsDocument,
    options,
  );
}
export type ReportingParticipantsInsightsQueryRemoteHookResult = ReturnType<typeof useReportingParticipantsInsightsQueryRemote>;
export type ReportingParticipantsInsightsLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingParticipantsInsightsLazyQueryRemote
>;
export type ReportingParticipantsInsightsQueryResult = Apollo.QueryResult<
  RReportingParticipantsInsightsQuery,
  RReportingParticipantsInsightsQueryVariables
>;
export const GenerateLearningActivitiesCsvDocument = gql`
  mutation generateLearningActivitiesCSV($input: GenerateLearningReportCSVInput!) {
    generateLearningActivitiesCSV(input: $input) {
      presignedURL
      success
    }
  }
`;
export type RGenerateLearningActivitiesCsvMutationFn = Apollo.MutationFunction<
  RGenerateLearningActivitiesCsvMutation,
  RGenerateLearningActivitiesCsvMutationVariables
>;

/**
 * __useGenerateLearningActivitiesCsvMutationRemote__
 *
 * To run a mutation, you first call `useGenerateLearningActivitiesCsvMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLearningActivitiesCsvMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLearningActivitiesCsvMutationRemote, { data, loading, error }] = useGenerateLearningActivitiesCsvMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLearningActivitiesCsvMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RGenerateLearningActivitiesCsvMutation,
    RGenerateLearningActivitiesCsvMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RGenerateLearningActivitiesCsvMutation, RGenerateLearningActivitiesCsvMutationVariables>(
    GenerateLearningActivitiesCsvDocument,
    options,
  );
}
export type GenerateLearningActivitiesCsvMutationRemoteHookResult = ReturnType<
  typeof useGenerateLearningActivitiesCsvMutationRemote
>;
export type GenerateLearningActivitiesCsvMutationResult = Apollo.MutationResult<RGenerateLearningActivitiesCsvMutation>;
export type GenerateLearningActivitiesCsvMutationOptions = Apollo.BaseMutationOptions<
  RGenerateLearningActivitiesCsvMutation,
  RGenerateLearningActivitiesCsvMutationVariables
>;
export const ReportingMyLearningsQuizDocument = gql`
  query reportingMyLearningsQuiz($args: reportingMyLearningsQuiz_arguments!) {
    reportingMyLearningsQuiz(args: $args) {
      urn
      activity_urn
      question_id
      question_title
      total_answers
      correct_answers
      incorrect_answers
      all_attempt_ratio
      total_unique_user_answers
      latest_correct_answers
      latest_incorrect_answers
      latest_attempt_ratio
      latest_pass_ratio
      latest_total_passed
      latest_total_failed
    }
  }
`;

/**
 * __useReportingMyLearningsQuizQueryRemote__
 *
 * To run a query within a React component, call `useReportingMyLearningsQuizQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingMyLearningsQuizQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingMyLearningsQuizQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useReportingMyLearningsQuizQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RReportingMyLearningsQuizQuery, RReportingMyLearningsQuizQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingMyLearningsQuizQuery, RReportingMyLearningsQuizQueryVariables>(
    ReportingMyLearningsQuizDocument,
    options,
  );
}
export function useReportingMyLearningsQuizLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RReportingMyLearningsQuizQuery, RReportingMyLearningsQuizQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingMyLearningsQuizQuery, RReportingMyLearningsQuizQueryVariables>(
    ReportingMyLearningsQuizDocument,
    options,
  );
}
export type ReportingMyLearningsQuizQueryRemoteHookResult = ReturnType<typeof useReportingMyLearningsQuizQueryRemote>;
export type ReportingMyLearningsQuizLazyQueryRemoteHookResult = ReturnType<typeof useReportingMyLearningsQuizLazyQueryRemote>;
export type ReportingMyLearningsQuizQueryResult = Apollo.QueryResult<
  RReportingMyLearningsQuizQuery,
  RReportingMyLearningsQuizQueryVariables
>;
export const LearningWithActivitiesDocument = gql`
  query learningWithActivities($learningV2Id: Int!) {
    learningV2(id: $learningV2Id) {
      id
      title
      activities {
        id
        urn
        data
        learningId
      }
    }
  }
`;

/**
 * __useLearningWithActivitiesQueryRemote__
 *
 * To run a query within a React component, call `useLearningWithActivitiesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningWithActivitiesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningWithActivitiesQueryRemote({
 *   variables: {
 *      learningV2Id: // value for 'learningV2Id'
 *   },
 * });
 */
export function useLearningWithActivitiesQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningWithActivitiesQuery, RLearningWithActivitiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningWithActivitiesQuery, RLearningWithActivitiesQueryVariables>(
    LearningWithActivitiesDocument,
    options,
  );
}
export function useLearningWithActivitiesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningWithActivitiesQuery, RLearningWithActivitiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningWithActivitiesQuery, RLearningWithActivitiesQueryVariables>(
    LearningWithActivitiesDocument,
    options,
  );
}
export type LearningWithActivitiesQueryRemoteHookResult = ReturnType<typeof useLearningWithActivitiesQueryRemote>;
export type LearningWithActivitiesLazyQueryRemoteHookResult = ReturnType<typeof useLearningWithActivitiesLazyQueryRemote>;
export type LearningWithActivitiesQueryResult = Apollo.QueryResult<
  RLearningWithActivitiesQuery,
  RLearningWithActivitiesQueryVariables
>;
export const GenerateLearningActivityQuizCsvDocument = gql`
  mutation generateLearningActivityQuizCSV($input: GenerateLearningActivityQuizCSVInput!) {
    generateLearningActivityQuizCSV(input: $input) {
      presignedURL
      success
    }
  }
`;
export type RGenerateLearningActivityQuizCsvMutationFn = Apollo.MutationFunction<
  RGenerateLearningActivityQuizCsvMutation,
  RGenerateLearningActivityQuizCsvMutationVariables
>;

/**
 * __useGenerateLearningActivityQuizCsvMutationRemote__
 *
 * To run a mutation, you first call `useGenerateLearningActivityQuizCsvMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLearningActivityQuizCsvMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLearningActivityQuizCsvMutationRemote, { data, loading, error }] = useGenerateLearningActivityQuizCsvMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLearningActivityQuizCsvMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RGenerateLearningActivityQuizCsvMutation,
    RGenerateLearningActivityQuizCsvMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RGenerateLearningActivityQuizCsvMutation, RGenerateLearningActivityQuizCsvMutationVariables>(
    GenerateLearningActivityQuizCsvDocument,
    options,
  );
}
export type GenerateLearningActivityQuizCsvMutationRemoteHookResult = ReturnType<
  typeof useGenerateLearningActivityQuizCsvMutationRemote
>;
export type GenerateLearningActivityQuizCsvMutationResult = Apollo.MutationResult<RGenerateLearningActivityQuizCsvMutation>;
export type GenerateLearningActivityQuizCsvMutationOptions = Apollo.BaseMutationOptions<
  RGenerateLearningActivityQuizCsvMutation,
  RGenerateLearningActivityQuizCsvMutationVariables
>;
export const ReportingSectionsItemsDocument = gql`
  query reportingSectionsItems($args: reportingSectionsItems_arguments!, $orderBy: [sections_items_order_by!]) {
    reportingSectionsItems(args: $args, order_by: $orderBy) {
      urn
      type
      item_order
      planned_duration
      partner
      team_ids
      space_id
      title
    }
  }
`;

/**
 * __useReportingSectionsItemsQueryRemote__
 *
 * To run a query within a React component, call `useReportingSectionsItemsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingSectionsItemsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingSectionsItemsQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useReportingSectionsItemsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RReportingSectionsItemsQuery, RReportingSectionsItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingSectionsItemsQuery, RReportingSectionsItemsQueryVariables>(
    ReportingSectionsItemsDocument,
    options,
  );
}
export function useReportingSectionsItemsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RReportingSectionsItemsQuery, RReportingSectionsItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingSectionsItemsQuery, RReportingSectionsItemsQueryVariables>(
    ReportingSectionsItemsDocument,
    options,
  );
}
export type ReportingSectionsItemsQueryRemoteHookResult = ReturnType<typeof useReportingSectionsItemsQueryRemote>;
export type ReportingSectionsItemsLazyQueryRemoteHookResult = ReturnType<typeof useReportingSectionsItemsLazyQueryRemote>;
export type ReportingSectionsItemsQueryResult = Apollo.QueryResult<
  RReportingSectionsItemsQuery,
  RReportingSectionsItemsQueryVariables
>;
export const ReportingSectionsItemsInsightsDocument = gql`
  query reportingSectionsItemsInsights(
    $args: reportingSectionsItemsInsights_arguments!
    $orderBy: [sections_items_insights_order_by!]
  ) {
    reportingSectionsItemsInsights(args: $args, order_by: $orderBy) {
      urn
      not_started_count
      in_progress_count
      completed_count
      completion_rate
      space_id
      team_ids
    }
  }
`;

/**
 * __useReportingSectionsItemsInsightsQueryRemote__
 *
 * To run a query within a React component, call `useReportingSectionsItemsInsightsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingSectionsItemsInsightsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingSectionsItemsInsightsQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useReportingSectionsItemsInsightsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RReportingSectionsItemsInsightsQuery, RReportingSectionsItemsInsightsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingSectionsItemsInsightsQuery, RReportingSectionsItemsInsightsQueryVariables>(
    ReportingSectionsItemsInsightsDocument,
    options,
  );
}
export function useReportingSectionsItemsInsightsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RReportingSectionsItemsInsightsQuery, RReportingSectionsItemsInsightsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingSectionsItemsInsightsQuery, RReportingSectionsItemsInsightsQueryVariables>(
    ReportingSectionsItemsInsightsDocument,
    options,
  );
}
export type ReportingSectionsItemsInsightsQueryRemoteHookResult = ReturnType<typeof useReportingSectionsItemsInsightsQueryRemote>;
export type ReportingSectionsItemsInsightsLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingSectionsItemsInsightsLazyQueryRemote
>;
export type ReportingSectionsItemsInsightsQueryResult = Apollo.QueryResult<
  RReportingSectionsItemsInsightsQuery,
  RReportingSectionsItemsInsightsQueryVariables
>;
export const ReportingSectionsItemsTotalCountDocument = gql`
  query reportingSectionsItemsTotalCount($args: reportingSectionsItemsTotalCount_arguments!, $orderBy: [total_count_order_by!]) {
    reportingSectionsItemsTotalCount(args: $args, order_by: $orderBy) {
      total_count
      space_id
      space_ids
      team_ids
    }
  }
`;

/**
 * __useReportingSectionsItemsTotalCountQueryRemote__
 *
 * To run a query within a React component, call `useReportingSectionsItemsTotalCountQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingSectionsItemsTotalCountQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingSectionsItemsTotalCountQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useReportingSectionsItemsTotalCountQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RReportingSectionsItemsTotalCountQuery, RReportingSectionsItemsTotalCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingSectionsItemsTotalCountQuery, RReportingSectionsItemsTotalCountQueryVariables>(
    ReportingSectionsItemsTotalCountDocument,
    options,
  );
}
export function useReportingSectionsItemsTotalCountLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingSectionsItemsTotalCountQuery,
    RReportingSectionsItemsTotalCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingSectionsItemsTotalCountQuery, RReportingSectionsItemsTotalCountQueryVariables>(
    ReportingSectionsItemsTotalCountDocument,
    options,
  );
}
export type ReportingSectionsItemsTotalCountQueryRemoteHookResult = ReturnType<
  typeof useReportingSectionsItemsTotalCountQueryRemote
>;
export type ReportingSectionsItemsTotalCountLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingSectionsItemsTotalCountLazyQueryRemote
>;
export type ReportingSectionsItemsTotalCountQueryResult = Apollo.QueryResult<
  RReportingSectionsItemsTotalCountQuery,
  RReportingSectionsItemsTotalCountQueryVariables
>;
export const MeDocument = gql`
  query me {
    me {
      acceptedExtraTerms
      acceptedGdpr
      acceptedTos
      email
      firstname
      id
      isDebugging
      language
      lastname
      permissions {
        hasViewAccessToAdminPanel
        hasViewAccessToManagerDashboard
        hasWriteAccessToInternals
      }
      profileImage
      realm
      status
      username
    }
  }
`;

/**
 * __useMeQueryRemote__
 *
 * To run a query within a React component, call `useMeQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useMeQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useMeQueryRemote(baseOptions?: Apollo.QueryHookOptions<RMeQuery, RMeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RMeQuery, RMeQueryVariables>(MeDocument, options);
}
export function useMeLazyQueryRemote(baseOptions?: Apollo.LazyQueryHookOptions<RMeQuery, RMeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RMeQuery, RMeQueryVariables>(MeDocument, options);
}
export type MeQueryRemoteHookResult = ReturnType<typeof useMeQueryRemote>;
export type MeLazyQueryRemoteHookResult = ReturnType<typeof useMeLazyQueryRemote>;
export type MeQueryResult = Apollo.QueryResult<RMeQuery, RMeQueryVariables>;
export const GetSectionDocument = gql`
  query getSection($path: [String!]!, $page: Int, $pageSize: Int) {
    getSection(path: $path, page: $page, pageSize: $pageSize) {
      ...SectionFragment
      posts {
        page
        pageSize
        total
        pages
        items {
          ...PostFragment
        }
      }
      stickyPosts {
        ...PostFragment
      }
      subsections {
        id
        title
        path
      }
    }
  }
  ${SectionFragmentFragmentDoc}
  ${PostFragmentFragmentDoc}
`;

/**
 * __useGetSectionQueryRemote__
 *
 * To run a query within a React component, call `useGetSectionQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionQueryRemote({
 *   variables: {
 *      path: // value for 'path'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetSectionQueryRemote(baseOptions: Apollo.QueryHookOptions<RGetSectionQuery, RGetSectionQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetSectionQuery, RGetSectionQueryVariables>(GetSectionDocument, options);
}
export function useGetSectionLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetSectionQuery, RGetSectionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetSectionQuery, RGetSectionQueryVariables>(GetSectionDocument, options);
}
export type GetSectionQueryRemoteHookResult = ReturnType<typeof useGetSectionQueryRemote>;
export type GetSectionLazyQueryRemoteHookResult = ReturnType<typeof useGetSectionLazyQueryRemote>;
export type GetSectionQueryResult = Apollo.QueryResult<RGetSectionQuery, RGetSectionQueryVariables>;
export const GetRepliesDocument = gql`
  query getReplies($path: [String!]!, $postId: Int, $page: Int, $pageSize: Int) {
    getReplies(path: $path, postId: $postId, page: $page, pageSize: $pageSize) {
      post {
        ...PostFragment
      }
      replies {
        page
        pageSize
        total
        pages
        items {
          ...PostFragment
        }
      }
    }
  }
  ${PostFragmentFragmentDoc}
`;

/**
 * __useGetRepliesQueryRemote__
 *
 * To run a query within a React component, call `useGetRepliesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetRepliesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRepliesQueryRemote({
 *   variables: {
 *      path: // value for 'path'
 *      postId: // value for 'postId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetRepliesQueryRemote(baseOptions: Apollo.QueryHookOptions<RGetRepliesQuery, RGetRepliesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetRepliesQuery, RGetRepliesQueryVariables>(GetRepliesDocument, options);
}
export function useGetRepliesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetRepliesQuery, RGetRepliesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetRepliesQuery, RGetRepliesQueryVariables>(GetRepliesDocument, options);
}
export type GetRepliesQueryRemoteHookResult = ReturnType<typeof useGetRepliesQueryRemote>;
export type GetRepliesLazyQueryRemoteHookResult = ReturnType<typeof useGetRepliesLazyQueryRemote>;
export type GetRepliesQueryResult = Apollo.QueryResult<RGetRepliesQuery, RGetRepliesQueryVariables>;
export const GetUserRepliesDocument = gql`
  query getUserReplies($path: [String!]!, $postId: Int, $page: Int, $pageSize: Int) {
    getUserReplies(path: $path, postId: $postId, page: $page, pageSize: $pageSize) {
      replies {
        page
        pageSize
        total
        pages
        items {
          ...PostFragment
        }
      }
    }
  }
  ${PostFragmentFragmentDoc}
`;

/**
 * __useGetUserRepliesQueryRemote__
 *
 * To run a query within a React component, call `useGetUserRepliesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRepliesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRepliesQueryRemote({
 *   variables: {
 *      path: // value for 'path'
 *      postId: // value for 'postId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetUserRepliesQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RGetUserRepliesQuery, RGetUserRepliesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetUserRepliesQuery, RGetUserRepliesQueryVariables>(GetUserRepliesDocument, options);
}
export function useGetUserRepliesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetUserRepliesQuery, RGetUserRepliesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetUserRepliesQuery, RGetUserRepliesQueryVariables>(GetUserRepliesDocument, options);
}
export type GetUserRepliesQueryRemoteHookResult = ReturnType<typeof useGetUserRepliesQueryRemote>;
export type GetUserRepliesLazyQueryRemoteHookResult = ReturnType<typeof useGetUserRepliesLazyQueryRemote>;
export type GetUserRepliesQueryResult = Apollo.QueryResult<RGetUserRepliesQuery, RGetUserRepliesQueryVariables>;
export const GetPostDocument = gql`
  query getPost($path: [String!]!, $postId: Int) {
    getPost(path: $path, postId: $postId) {
      ...PostFragment
    }
  }
  ${PostFragmentFragmentDoc}
`;

/**
 * __useGetPostQueryRemote__
 *
 * To run a query within a React component, call `useGetPostQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetPostQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostQueryRemote({
 *   variables: {
 *      path: // value for 'path'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostQueryRemote(baseOptions: Apollo.QueryHookOptions<RGetPostQuery, RGetPostQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetPostQuery, RGetPostQueryVariables>(GetPostDocument, options);
}
export function useGetPostLazyQueryRemote(baseOptions?: Apollo.LazyQueryHookOptions<RGetPostQuery, RGetPostQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetPostQuery, RGetPostQueryVariables>(GetPostDocument, options);
}
export type GetPostQueryRemoteHookResult = ReturnType<typeof useGetPostQueryRemote>;
export type GetPostLazyQueryRemoteHookResult = ReturnType<typeof useGetPostLazyQueryRemote>;
export type GetPostQueryResult = Apollo.QueryResult<RGetPostQuery, RGetPostQueryVariables>;
export const CreateSectionDocument = gql`
  mutation createSection($payload: CreateSectionInput) {
    createSection(payload: $payload) {
      ...SectionFragment
    }
  }
  ${SectionFragmentFragmentDoc}
`;
export type RCreateSectionMutationFn = Apollo.MutationFunction<RCreateSectionMutation, RCreateSectionMutationVariables>;

/**
 * __useCreateSectionMutationRemote__
 *
 * To run a mutation, you first call `useCreateSectionMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSectionMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSectionMutationRemote, { data, loading, error }] = useCreateSectionMutationRemote({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateSectionMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCreateSectionMutation, RCreateSectionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateSectionMutation, RCreateSectionMutationVariables>(CreateSectionDocument, options);
}
export type CreateSectionMutationRemoteHookResult = ReturnType<typeof useCreateSectionMutationRemote>;
export type CreateSectionMutationResult = Apollo.MutationResult<RCreateSectionMutation>;
export type CreateSectionMutationOptions = Apollo.BaseMutationOptions<RCreateSectionMutation, RCreateSectionMutationVariables>;
export const UpdateSectionDocument = gql`
  mutation updateSection($payload: UpdateSectionInput) {
    updateSection(payload: $payload) {
      ...SectionFragment
    }
  }
  ${SectionFragmentFragmentDoc}
`;
export type RUpdateSectionMutationFn = Apollo.MutationFunction<RUpdateSectionMutation, RUpdateSectionMutationVariables>;

/**
 * __useUpdateSectionMutationRemote__
 *
 * To run a mutation, you first call `useUpdateSectionMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSectionMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSectionMutationRemote, { data, loading, error }] = useUpdateSectionMutationRemote({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateSectionMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpdateSectionMutation, RUpdateSectionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpdateSectionMutation, RUpdateSectionMutationVariables>(UpdateSectionDocument, options);
}
export type UpdateSectionMutationRemoteHookResult = ReturnType<typeof useUpdateSectionMutationRemote>;
export type UpdateSectionMutationResult = Apollo.MutationResult<RUpdateSectionMutation>;
export type UpdateSectionMutationOptions = Apollo.BaseMutationOptions<RUpdateSectionMutation, RUpdateSectionMutationVariables>;
export const CreatePostDocument = gql`
  mutation createPost($path: [String!]!, $payload: PostInput) {
    createPost(path: $path, payload: $payload) {
      ...PostFragment
    }
  }
  ${PostFragmentFragmentDoc}
`;
export type RCreatePostMutationFn = Apollo.MutationFunction<RCreatePostMutation, RCreatePostMutationVariables>;

/**
 * __useCreatePostMutationRemote__
 *
 * To run a mutation, you first call `useCreatePostMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutationRemote, { data, loading, error }] = useCreatePostMutationRemote({
 *   variables: {
 *      path: // value for 'path'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreatePostMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCreatePostMutation, RCreatePostMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreatePostMutation, RCreatePostMutationVariables>(CreatePostDocument, options);
}
export type CreatePostMutationRemoteHookResult = ReturnType<typeof useCreatePostMutationRemote>;
export type CreatePostMutationResult = Apollo.MutationResult<RCreatePostMutation>;
export type CreatePostMutationOptions = Apollo.BaseMutationOptions<RCreatePostMutation, RCreatePostMutationVariables>;
export const UpdatePostDocument = gql`
  mutation updatePost($path: [String!]!, $postId: Int, $payload: PostInput) {
    updatePost(path: $path, postId: $postId, payload: $payload) {
      ...PostFragment
    }
  }
  ${PostFragmentFragmentDoc}
`;
export type RUpdatePostMutationFn = Apollo.MutationFunction<RUpdatePostMutation, RUpdatePostMutationVariables>;

/**
 * __useUpdatePostMutationRemote__
 *
 * To run a mutation, you first call `useUpdatePostMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutationRemote, { data, loading, error }] = useUpdatePostMutationRemote({
 *   variables: {
 *      path: // value for 'path'
 *      postId: // value for 'postId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdatePostMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpdatePostMutation, RUpdatePostMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpdatePostMutation, RUpdatePostMutationVariables>(UpdatePostDocument, options);
}
export type UpdatePostMutationRemoteHookResult = ReturnType<typeof useUpdatePostMutationRemote>;
export type UpdatePostMutationResult = Apollo.MutationResult<RUpdatePostMutation>;
export type UpdatePostMutationOptions = Apollo.BaseMutationOptions<RUpdatePostMutation, RUpdatePostMutationVariables>;
export const DeletePostDocument = gql`
  mutation deletePost($path: [String!]!, $postId: Int) {
    deletePost(path: $path, postId: $postId) {
      ...PostFragment
    }
  }
  ${PostFragmentFragmentDoc}
`;
export type RDeletePostMutationFn = Apollo.MutationFunction<RDeletePostMutation, RDeletePostMutationVariables>;

/**
 * __useDeletePostMutationRemote__
 *
 * To run a mutation, you first call `useDeletePostMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutationRemote, { data, loading, error }] = useDeletePostMutationRemote({
 *   variables: {
 *      path: // value for 'path'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeletePostMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RDeletePostMutation, RDeletePostMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RDeletePostMutation, RDeletePostMutationVariables>(DeletePostDocument, options);
}
export type DeletePostMutationRemoteHookResult = ReturnType<typeof useDeletePostMutationRemote>;
export type DeletePostMutationResult = Apollo.MutationResult<RDeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<RDeletePostMutation, RDeletePostMutationVariables>;
export const ToggleActionDocument = gql`
  mutation toggleAction($path: [String!]!, $postId: Int, $action: String, $payload: PostActionInput) {
    toggleAction(path: $path, postId: $postId, action: $action, payload: $payload) {
      ...PostFragment
    }
  }
  ${PostFragmentFragmentDoc}
`;
export type RToggleActionMutationFn = Apollo.MutationFunction<RToggleActionMutation, RToggleActionMutationVariables>;

/**
 * __useToggleActionMutationRemote__
 *
 * To run a mutation, you first call `useToggleActionMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleActionMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleActionMutationRemote, { data, loading, error }] = useToggleActionMutationRemote({
 *   variables: {
 *      path: // value for 'path'
 *      postId: // value for 'postId'
 *      action: // value for 'action'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useToggleActionMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RToggleActionMutation, RToggleActionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RToggleActionMutation, RToggleActionMutationVariables>(ToggleActionDocument, options);
}
export type ToggleActionMutationRemoteHookResult = ReturnType<typeof useToggleActionMutationRemote>;
export type ToggleActionMutationResult = Apollo.MutationResult<RToggleActionMutation>;
export type ToggleActionMutationOptions = Apollo.BaseMutationOptions<RToggleActionMutation, RToggleActionMutationVariables>;
export const EnrollmentCreateByEmailsDocument = gql`
  mutation enrollmentCreateByEmails($input: EnrollByEmailInput!) {
    enrollmentCreateByEmails(input: $input) {
      id
      locationId
      userId
      enrolledAt
      attended
    }
  }
`;
export type REnrollmentCreateByEmailsMutationFn = Apollo.MutationFunction<
  REnrollmentCreateByEmailsMutation,
  REnrollmentCreateByEmailsMutationVariables
>;

/**
 * __useEnrollmentCreateByEmailsMutationRemote__
 *
 * To run a mutation, you first call `useEnrollmentCreateByEmailsMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentCreateByEmailsMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentCreateByEmailsMutationRemote, { data, loading, error }] = useEnrollmentCreateByEmailsMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollmentCreateByEmailsMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<REnrollmentCreateByEmailsMutation, REnrollmentCreateByEmailsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<REnrollmentCreateByEmailsMutation, REnrollmentCreateByEmailsMutationVariables>(
    EnrollmentCreateByEmailsDocument,
    options,
  );
}
export type EnrollmentCreateByEmailsMutationRemoteHookResult = ReturnType<typeof useEnrollmentCreateByEmailsMutationRemote>;
export type EnrollmentCreateByEmailsMutationResult = Apollo.MutationResult<REnrollmentCreateByEmailsMutation>;
export type EnrollmentCreateByEmailsMutationOptions = Apollo.BaseMutationOptions<
  REnrollmentCreateByEmailsMutation,
  REnrollmentCreateByEmailsMutationVariables
>;
export const EnrollSelfDocument = gql`
  mutation enrollSelf($input: EnrollSelfInput!) {
    enrollSelf(input: $input) {
      id
      locationId
      userId
      enrolledAt
      attended
    }
  }
`;
export type REnrollSelfMutationFn = Apollo.MutationFunction<REnrollSelfMutation, REnrollSelfMutationVariables>;

/**
 * __useEnrollSelfMutationRemote__
 *
 * To run a mutation, you first call `useEnrollSelfMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollSelfMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollSelfMutationRemote, { data, loading, error }] = useEnrollSelfMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollSelfMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<REnrollSelfMutation, REnrollSelfMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<REnrollSelfMutation, REnrollSelfMutationVariables>(EnrollSelfDocument, options);
}
export type EnrollSelfMutationRemoteHookResult = ReturnType<typeof useEnrollSelfMutationRemote>;
export type EnrollSelfMutationResult = Apollo.MutationResult<REnrollSelfMutation>;
export type EnrollSelfMutationOptions = Apollo.BaseMutationOptions<REnrollSelfMutation, REnrollSelfMutationVariables>;
export const DeleteEnrollmentDocument = gql`
  mutation deleteEnrollment($input: DeleteEnrollmentInput!) {
    deleteEnrollment(input: $input)
  }
`;
export type RDeleteEnrollmentMutationFn = Apollo.MutationFunction<RDeleteEnrollmentMutation, RDeleteEnrollmentMutationVariables>;

/**
 * __useDeleteEnrollmentMutationRemote__
 *
 * To run a mutation, you first call `useDeleteEnrollmentMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnrollmentMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnrollmentMutationRemote, { data, loading, error }] = useDeleteEnrollmentMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEnrollmentMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RDeleteEnrollmentMutation, RDeleteEnrollmentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RDeleteEnrollmentMutation, RDeleteEnrollmentMutationVariables>(DeleteEnrollmentDocument, options);
}
export type DeleteEnrollmentMutationRemoteHookResult = ReturnType<typeof useDeleteEnrollmentMutationRemote>;
export type DeleteEnrollmentMutationResult = Apollo.MutationResult<RDeleteEnrollmentMutation>;
export type DeleteEnrollmentMutationOptions = Apollo.BaseMutationOptions<
  RDeleteEnrollmentMutation,
  RDeleteEnrollmentMutationVariables
>;
export const EnrollmentsDocument = gql`
  query enrollments($input: EnrollmentsInput!) {
    enrollments(input: $input) {
      id
      locationId
      userId
      enrolledAt
      attended
      user {
        username
        email
        profileImage
      }
    }
  }
`;

/**
 * __useEnrollmentsQueryRemote__
 *
 * To run a query within a React component, call `useEnrollmentsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentsQueryRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollmentsQueryRemote(baseOptions: Apollo.QueryHookOptions<REnrollmentsQuery, REnrollmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<REnrollmentsQuery, REnrollmentsQueryVariables>(EnrollmentsDocument, options);
}
export function useEnrollmentsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<REnrollmentsQuery, REnrollmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<REnrollmentsQuery, REnrollmentsQueryVariables>(EnrollmentsDocument, options);
}
export type EnrollmentsQueryRemoteHookResult = ReturnType<typeof useEnrollmentsQueryRemote>;
export type EnrollmentsLazyQueryRemoteHookResult = ReturnType<typeof useEnrollmentsLazyQueryRemote>;
export type EnrollmentsQueryResult = Apollo.QueryResult<REnrollmentsQuery, REnrollmentsQueryVariables>;
export const SetEnrollmentAttendanceDocument = gql`
  mutation setEnrollmentAttendance($input: SetEnrollmentAttendanceInput!) {
    setEnrollmentAttendance(input: $input) {
      id
      locationId
      userId
      enrolledAt
      attended
    }
  }
`;
export type RSetEnrollmentAttendanceMutationFn = Apollo.MutationFunction<
  RSetEnrollmentAttendanceMutation,
  RSetEnrollmentAttendanceMutationVariables
>;

/**
 * __useSetEnrollmentAttendanceMutationRemote__
 *
 * To run a mutation, you first call `useSetEnrollmentAttendanceMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEnrollmentAttendanceMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEnrollmentAttendanceMutationRemote, { data, loading, error }] = useSetEnrollmentAttendanceMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEnrollmentAttendanceMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RSetEnrollmentAttendanceMutation, RSetEnrollmentAttendanceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RSetEnrollmentAttendanceMutation, RSetEnrollmentAttendanceMutationVariables>(
    SetEnrollmentAttendanceDocument,
    options,
  );
}
export type SetEnrollmentAttendanceMutationRemoteHookResult = ReturnType<typeof useSetEnrollmentAttendanceMutationRemote>;
export type SetEnrollmentAttendanceMutationResult = Apollo.MutationResult<RSetEnrollmentAttendanceMutation>;
export type SetEnrollmentAttendanceMutationOptions = Apollo.BaseMutationOptions<
  RSetEnrollmentAttendanceMutation,
  RSetEnrollmentAttendanceMutationVariables
>;
export const SetBulkEnrollmentAttendanceDocument = gql`
  mutation setBulkEnrollmentAttendance($input: [SetEnrollmentAttendanceInput!]!) {
    setBulkEnrollmentAttendance(input: $input) {
      id
      locationId
      userId
      enrolledAt
      attended
    }
  }
`;
export type RSetBulkEnrollmentAttendanceMutationFn = Apollo.MutationFunction<
  RSetBulkEnrollmentAttendanceMutation,
  RSetBulkEnrollmentAttendanceMutationVariables
>;

/**
 * __useSetBulkEnrollmentAttendanceMutationRemote__
 *
 * To run a mutation, you first call `useSetBulkEnrollmentAttendanceMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBulkEnrollmentAttendanceMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBulkEnrollmentAttendanceMutationRemote, { data, loading, error }] = useSetBulkEnrollmentAttendanceMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetBulkEnrollmentAttendanceMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RSetBulkEnrollmentAttendanceMutation, RSetBulkEnrollmentAttendanceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RSetBulkEnrollmentAttendanceMutation, RSetBulkEnrollmentAttendanceMutationVariables>(
    SetBulkEnrollmentAttendanceDocument,
    options,
  );
}
export type SetBulkEnrollmentAttendanceMutationRemoteHookResult = ReturnType<typeof useSetBulkEnrollmentAttendanceMutationRemote>;
export type SetBulkEnrollmentAttendanceMutationResult = Apollo.MutationResult<RSetBulkEnrollmentAttendanceMutation>;
export type SetBulkEnrollmentAttendanceMutationOptions = Apollo.BaseMutationOptions<
  RSetBulkEnrollmentAttendanceMutation,
  RSetBulkEnrollmentAttendanceMutationVariables
>;
export const RealmFeatureTogglesDocument = gql`
  query realmFeatureToggles($realm: String!) {
    realmFeatureToggles(realm: $realm) {
      name
    }
  }
`;

/**
 * __useRealmFeatureTogglesQueryRemote__
 *
 * To run a query within a React component, call `useRealmFeatureTogglesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useRealmFeatureTogglesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealmFeatureTogglesQueryRemote({
 *   variables: {
 *      realm: // value for 'realm'
 *   },
 * });
 */
export function useRealmFeatureTogglesQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RRealmFeatureTogglesQuery, RRealmFeatureTogglesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RRealmFeatureTogglesQuery, RRealmFeatureTogglesQueryVariables>(RealmFeatureTogglesDocument, options);
}
export function useRealmFeatureTogglesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RRealmFeatureTogglesQuery, RRealmFeatureTogglesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RRealmFeatureTogglesQuery, RRealmFeatureTogglesQueryVariables>(RealmFeatureTogglesDocument, options);
}
export type RealmFeatureTogglesQueryRemoteHookResult = ReturnType<typeof useRealmFeatureTogglesQueryRemote>;
export type RealmFeatureTogglesLazyQueryRemoteHookResult = ReturnType<typeof useRealmFeatureTogglesLazyQueryRemote>;
export type RealmFeatureTogglesQueryResult = Apollo.QueryResult<RRealmFeatureTogglesQuery, RRealmFeatureTogglesQueryVariables>;
export const UserFeatureTogglesDocument = gql`
  query userFeatureToggles($realm: String!) {
    getCurrentUserFeatureToggles(realm: $realm) {
      name
    }
  }
`;

/**
 * __useUserFeatureTogglesQueryRemote__
 *
 * To run a query within a React component, call `useUserFeatureTogglesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useUserFeatureTogglesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFeatureTogglesQueryRemote({
 *   variables: {
 *      realm: // value for 'realm'
 *   },
 * });
 */
export function useUserFeatureTogglesQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RUserFeatureTogglesQuery, RUserFeatureTogglesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RUserFeatureTogglesQuery, RUserFeatureTogglesQueryVariables>(UserFeatureTogglesDocument, options);
}
export function useUserFeatureTogglesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RUserFeatureTogglesQuery, RUserFeatureTogglesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RUserFeatureTogglesQuery, RUserFeatureTogglesQueryVariables>(UserFeatureTogglesDocument, options);
}
export type UserFeatureTogglesQueryRemoteHookResult = ReturnType<typeof useUserFeatureTogglesQueryRemote>;
export type UserFeatureTogglesLazyQueryRemoteHookResult = ReturnType<typeof useUserFeatureTogglesLazyQueryRemote>;
export type UserFeatureTogglesQueryResult = Apollo.QueryResult<RUserFeatureTogglesQuery, RUserFeatureTogglesQueryVariables>;
export const SubmitFeedbackDocument = gql`
  mutation SubmitFeedback($input: SubmitFeedbackInput!) {
    submitFeedback(input: $input) {
      success
      ticket {
        id
        subject
        description
        status
        priority
        type
        tags
      }
    }
  }
`;
export type RSubmitFeedbackMutationFn = Apollo.MutationFunction<RSubmitFeedbackMutation, RSubmitFeedbackMutationVariables>;

/**
 * __useSubmitFeedbackMutationRemote__
 *
 * To run a mutation, you first call `useSubmitFeedbackMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFeedbackMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFeedbackMutationRemote, { data, loading, error }] = useSubmitFeedbackMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitFeedbackMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RSubmitFeedbackMutation, RSubmitFeedbackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RSubmitFeedbackMutation, RSubmitFeedbackMutationVariables>(SubmitFeedbackDocument, options);
}
export type SubmitFeedbackMutationRemoteHookResult = ReturnType<typeof useSubmitFeedbackMutationRemote>;
export type SubmitFeedbackMutationResult = Apollo.MutationResult<RSubmitFeedbackMutation>;
export type SubmitFeedbackMutationOptions = Apollo.BaseMutationOptions<RSubmitFeedbackMutation, RSubmitFeedbackMutationVariables>;
export const GetInventoryDocument = gql`
  query getInventory {
    getInventory {
      ongoing {
        ...InventoryFragment
      }
      completed {
        ...InventoryFragment
      }
    }
    myEnrollments {
      ...MyEnrollmentsFragment
    }
  }
  ${InventoryFragmentFragmentDoc}
  ${MyEnrollmentsFragmentFragmentDoc}
`;

/**
 * __useGetInventoryQueryRemote__
 *
 * To run a query within a React component, call `useGetInventoryQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetInventoryQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInventoryQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useGetInventoryQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetInventoryQuery, RGetInventoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetInventoryQuery, RGetInventoryQueryVariables>(GetInventoryDocument, options);
}
export function useGetInventoryLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetInventoryQuery, RGetInventoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetInventoryQuery, RGetInventoryQueryVariables>(GetInventoryDocument, options);
}
export type GetInventoryQueryRemoteHookResult = ReturnType<typeof useGetInventoryQueryRemote>;
export type GetInventoryLazyQueryRemoteHookResult = ReturnType<typeof useGetInventoryLazyQueryRemote>;
export type GetInventoryQueryResult = Apollo.QueryResult<RGetInventoryQuery, RGetInventoryQueryVariables>;
export const GetHistoricCompletedCoursesDocument = gql`
  query getHistoricCompletedCourses {
    getHistoricCompletedCourses {
      id
      name
      completed
      type
    }
  }
`;

/**
 * __useGetHistoricCompletedCoursesQueryRemote__
 *
 * To run a query within a React component, call `useGetHistoricCompletedCoursesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricCompletedCoursesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricCompletedCoursesQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useGetHistoricCompletedCoursesQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetHistoricCompletedCoursesQuery, RGetHistoricCompletedCoursesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetHistoricCompletedCoursesQuery, RGetHistoricCompletedCoursesQueryVariables>(
    GetHistoricCompletedCoursesDocument,
    options,
  );
}
export function useGetHistoricCompletedCoursesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetHistoricCompletedCoursesQuery, RGetHistoricCompletedCoursesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetHistoricCompletedCoursesQuery, RGetHistoricCompletedCoursesQueryVariables>(
    GetHistoricCompletedCoursesDocument,
    options,
  );
}
export type GetHistoricCompletedCoursesQueryRemoteHookResult = ReturnType<typeof useGetHistoricCompletedCoursesQueryRemote>;
export type GetHistoricCompletedCoursesLazyQueryRemoteHookResult = ReturnType<
  typeof useGetHistoricCompletedCoursesLazyQueryRemote
>;
export type GetHistoricCompletedCoursesQueryResult = Apollo.QueryResult<
  RGetHistoricCompletedCoursesQuery,
  RGetHistoricCompletedCoursesQueryVariables
>;
export const CancelDocument = gql`
  mutation cancel($orderId: Int!) {
    cancel(orderId: $orderId) {
      value
    }
  }
`;
export type RCancelMutationFn = Apollo.MutationFunction<RCancelMutation, RCancelMutationVariables>;

/**
 * __useCancelMutationRemote__
 *
 * To run a mutation, you first call `useCancelMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMutationRemote, { data, loading, error }] = useCancelMutationRemote({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCancelMutationRemote(baseOptions?: Apollo.MutationHookOptions<RCancelMutation, RCancelMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCancelMutation, RCancelMutationVariables>(CancelDocument, options);
}
export type CancelMutationRemoteHookResult = ReturnType<typeof useCancelMutationRemote>;
export type CancelMutationResult = Apollo.MutationResult<RCancelMutation>;
export type CancelMutationOptions = Apollo.BaseMutationOptions<RCancelMutation, RCancelMutationVariables>;
export const CertificatePropertiesDocument = gql`
  query certificateProperties($urn: URN!) {
    certificateProperties(urn: $urn) {
      date
      description
      header
      title
      templateType
      urn
      updatedAt
      updatedBy
      logos {
        logoUrl
        order
        organisationText
      }
      signatures {
        title
        signatureUrl
        order
        name
        institution
      }
    }
  }
`;

/**
 * __useCertificatePropertiesQueryRemote__
 *
 * To run a query within a React component, call `useCertificatePropertiesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useCertificatePropertiesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificatePropertiesQueryRemote({
 *   variables: {
 *      urn: // value for 'urn'
 *   },
 * });
 */
export function useCertificatePropertiesQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RCertificatePropertiesQuery, RCertificatePropertiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RCertificatePropertiesQuery, RCertificatePropertiesQueryVariables>(
    CertificatePropertiesDocument,
    options,
  );
}
export function useCertificatePropertiesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RCertificatePropertiesQuery, RCertificatePropertiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RCertificatePropertiesQuery, RCertificatePropertiesQueryVariables>(
    CertificatePropertiesDocument,
    options,
  );
}
export type CertificatePropertiesQueryRemoteHookResult = ReturnType<typeof useCertificatePropertiesQueryRemote>;
export type CertificatePropertiesLazyQueryRemoteHookResult = ReturnType<typeof useCertificatePropertiesLazyQueryRemote>;
export type CertificatePropertiesQueryResult = Apollo.QueryResult<
  RCertificatePropertiesQuery,
  RCertificatePropertiesQueryVariables
>;
export const UpsertCertificatePropertiesDocument = gql`
  mutation upsertCertificateProperties($input: UpsertCertificatePropertiesInput!) {
    upsertCertificateProperties(input: $input) {
      signatures {
        title
        signatureUrl
        order
        name
        institution
      }
      templateType
      title
      updatedAt
      updatedBy
      urn
      date
      description
      header
      logos {
        logoUrl
        order
        organisationText
      }
    }
  }
`;
export type RUpsertCertificatePropertiesMutationFn = Apollo.MutationFunction<
  RUpsertCertificatePropertiesMutation,
  RUpsertCertificatePropertiesMutationVariables
>;

/**
 * __useUpsertCertificatePropertiesMutationRemote__
 *
 * To run a mutation, you first call `useUpsertCertificatePropertiesMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCertificatePropertiesMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCertificatePropertiesMutationRemote, { data, loading, error }] = useUpsertCertificatePropertiesMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCertificatePropertiesMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpsertCertificatePropertiesMutation, RUpsertCertificatePropertiesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpsertCertificatePropertiesMutation, RUpsertCertificatePropertiesMutationVariables>(
    UpsertCertificatePropertiesDocument,
    options,
  );
}
export type UpsertCertificatePropertiesMutationRemoteHookResult = ReturnType<typeof useUpsertCertificatePropertiesMutationRemote>;
export type UpsertCertificatePropertiesMutationResult = Apollo.MutationResult<RUpsertCertificatePropertiesMutation>;
export type UpsertCertificatePropertiesMutationOptions = Apollo.BaseMutationOptions<
  RUpsertCertificatePropertiesMutation,
  RUpsertCertificatePropertiesMutationVariables
>;
export const LearningJourneyPreviewCohortImportDocument = gql`
  mutation learningJourneyPreviewCohortImport($input: LearningJourneyCohortImportInput!) {
    learningJourneyPreviewCohortImport(input: $input) {
      success
      errorCause {
        code
      }
      data {
        stats {
          total
          willAdd
          alreadyInCohort
          userNotFound
          invalidEmail
          duplicateInFile
        }
        rows {
          outcome
          row {
            email
            sourceLine
          }
        }
      }
    }
  }
`;
export type RLearningJourneyPreviewCohortImportMutationFn = Apollo.MutationFunction<
  RLearningJourneyPreviewCohortImportMutation,
  RLearningJourneyPreviewCohortImportMutationVariables
>;

/**
 * __useLearningJourneyPreviewCohortImportMutationRemote__
 *
 * To run a mutation, you first call `useLearningJourneyPreviewCohortImportMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneyPreviewCohortImportMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningJourneyPreviewCohortImportMutationRemote, { data, loading, error }] = useLearningJourneyPreviewCohortImportMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLearningJourneyPreviewCohortImportMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RLearningJourneyPreviewCohortImportMutation,
    RLearningJourneyPreviewCohortImportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RLearningJourneyPreviewCohortImportMutation, RLearningJourneyPreviewCohortImportMutationVariables>(
    LearningJourneyPreviewCohortImportDocument,
    options,
  );
}
export type LearningJourneyPreviewCohortImportMutationRemoteHookResult = ReturnType<
  typeof useLearningJourneyPreviewCohortImportMutationRemote
>;
export type LearningJourneyPreviewCohortImportMutationResult = Apollo.MutationResult<RLearningJourneyPreviewCohortImportMutation>;
export type LearningJourneyPreviewCohortImportMutationOptions = Apollo.BaseMutationOptions<
  RLearningJourneyPreviewCohortImportMutation,
  RLearningJourneyPreviewCohortImportMutationVariables
>;
export const LearningJourneyConfirmCohortImportDocument = gql`
  mutation learningJourneyConfirmCohortImport($input: LearningJourneyCohortImportInput!) {
    learningJourneyConfirmCohortImport(input: $input) {
      accepted
      batchId
      willAddCount
    }
  }
`;
export type RLearningJourneyConfirmCohortImportMutationFn = Apollo.MutationFunction<
  RLearningJourneyConfirmCohortImportMutation,
  RLearningJourneyConfirmCohortImportMutationVariables
>;

/**
 * __useLearningJourneyConfirmCohortImportMutationRemote__
 *
 * To run a mutation, you first call `useLearningJourneyConfirmCohortImportMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneyConfirmCohortImportMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningJourneyConfirmCohortImportMutationRemote, { data, loading, error }] = useLearningJourneyConfirmCohortImportMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLearningJourneyConfirmCohortImportMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RLearningJourneyConfirmCohortImportMutation,
    RLearningJourneyConfirmCohortImportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RLearningJourneyConfirmCohortImportMutation, RLearningJourneyConfirmCohortImportMutationVariables>(
    LearningJourneyConfirmCohortImportDocument,
    options,
  );
}
export type LearningJourneyConfirmCohortImportMutationRemoteHookResult = ReturnType<
  typeof useLearningJourneyConfirmCohortImportMutationRemote
>;
export type LearningJourneyConfirmCohortImportMutationResult = Apollo.MutationResult<RLearningJourneyConfirmCohortImportMutation>;
export type LearningJourneyConfirmCohortImportMutationOptions = Apollo.BaseMutationOptions<
  RLearningJourneyConfirmCohortImportMutation,
  RLearningJourneyConfirmCohortImportMutationVariables
>;
export const LearningJourneyTemplatesDocument = gql`
  query learningJourneyTemplates {
    learningJourneyTemplates {
      id
      bannerURL
      teaser
      title
    }
  }
`;

/**
 * __useLearningJourneyTemplatesQueryRemote__
 *
 * To run a query within a React component, call `useLearningJourneyTemplatesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneyTemplatesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningJourneyTemplatesQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useLearningJourneyTemplatesQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RLearningJourneyTemplatesQuery, RLearningJourneyTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningJourneyTemplatesQuery, RLearningJourneyTemplatesQueryVariables>(
    LearningJourneyTemplatesDocument,
    options,
  );
}
export function useLearningJourneyTemplatesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningJourneyTemplatesQuery, RLearningJourneyTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningJourneyTemplatesQuery, RLearningJourneyTemplatesQueryVariables>(
    LearningJourneyTemplatesDocument,
    options,
  );
}
export type LearningJourneyTemplatesQueryRemoteHookResult = ReturnType<typeof useLearningJourneyTemplatesQueryRemote>;
export type LearningJourneyTemplatesLazyQueryRemoteHookResult = ReturnType<typeof useLearningJourneyTemplatesLazyQueryRemote>;
export type LearningJourneyTemplatesQueryResult = Apollo.QueryResult<
  RLearningJourneyTemplatesQuery,
  RLearningJourneyTemplatesQueryVariables
>;
export const CreateLearningJourneyFromTemplateDocument = gql`
  mutation createLearningJourneyFromTemplate($input: CreateLearningJourneyFromTemplateInput!) {
    createLearningJourneyFromTemplate(input: $input) {
      success
      journey {
        id
      }
    }
  }
`;
export type RCreateLearningJourneyFromTemplateMutationFn = Apollo.MutationFunction<
  RCreateLearningJourneyFromTemplateMutation,
  RCreateLearningJourneyFromTemplateMutationVariables
>;

/**
 * __useCreateLearningJourneyFromTemplateMutationRemote__
 *
 * To run a mutation, you first call `useCreateLearningJourneyFromTemplateMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningJourneyFromTemplateMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningJourneyFromTemplateMutationRemote, { data, loading, error }] = useCreateLearningJourneyFromTemplateMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearningJourneyFromTemplateMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RCreateLearningJourneyFromTemplateMutation,
    RCreateLearningJourneyFromTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateLearningJourneyFromTemplateMutation, RCreateLearningJourneyFromTemplateMutationVariables>(
    CreateLearningJourneyFromTemplateDocument,
    options,
  );
}
export type CreateLearningJourneyFromTemplateMutationRemoteHookResult = ReturnType<
  typeof useCreateLearningJourneyFromTemplateMutationRemote
>;
export type CreateLearningJourneyFromTemplateMutationResult = Apollo.MutationResult<RCreateLearningJourneyFromTemplateMutation>;
export type CreateLearningJourneyFromTemplateMutationOptions = Apollo.BaseMutationOptions<
  RCreateLearningJourneyFromTemplateMutation,
  RCreateLearningJourneyFromTemplateMutationVariables
>;
export const LearningJourneyDocument = gql`
  query learningJourney(
    $id: Int!
    $includeItems: Boolean!
    $spaceIds: [Int!]
    $userId: Int!
    $includeCohortTeams: Boolean!
    $includeUpdateByUser: Boolean!
    $itemsFilter: LearningJourneyItemsFilter
    $includeContentProgress: Boolean!
  ) {
    learningJourney(id: $id) {
      id
      urn
      spaceId
      title
      bannerURL
      businessGoalV2
      descriptionV2
      status
      spaceFeatured
      allUpcomingItemsLocked
      completionCriteria
      completionInvestTimeSec
      discussionEnabled
      discussionForumSectionPath
      certificateEnabled
      myCertificateURL {
        expiresAfter
        url
      }
      subjectId
      subject {
        subjectId
        subject
        categoryId
        category
      }
      createdAt
      updatedAt
      cohortTeams @include(if: $includeCohortTeams) {
        id
        name
      }
      updateByUser @include(if: $includeUpdateByUser) {
        id
        firstname
        lastname
      }
      items(filter: $itemsFilter, pagination: { limit: -1 }) @include(if: $includeItems) {
        data {
          id
          contentId: learningItemURNV2
          content: learningItem {
            ...LearningContent
            ...LearningContentProgress
            locationsWithEnrollment: locations {
              id
              userLocationEnrollment(userIds: [$userId]) {
                id
              }
            }
          }
          order
          isLocked(userId: $userId)
          isOptional
          availabilityType
          realms
          availabilityScheduledAt
          availabilityScheduledAtTimezone
        }
      }
    }
  }
  ${LearningContentFragmentDoc}
  ${LearningContentProgressFragmentDoc}
`;

/**
 * __useLearningJourneyQueryRemote__
 *
 * To run a query within a React component, call `useLearningJourneyQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneyQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningJourneyQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *      includeItems: // value for 'includeItems'
 *      spaceIds: // value for 'spaceIds'
 *      userId: // value for 'userId'
 *      includeCohortTeams: // value for 'includeCohortTeams'
 *      includeUpdateByUser: // value for 'includeUpdateByUser'
 *      itemsFilter: // value for 'itemsFilter'
 *      includeContentProgress: // value for 'includeContentProgress'
 *   },
 * });
 */
export function useLearningJourneyQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningJourneyQuery, RLearningJourneyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningJourneyQuery, RLearningJourneyQueryVariables>(LearningJourneyDocument, options);
}
export function useLearningJourneyLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningJourneyQuery, RLearningJourneyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningJourneyQuery, RLearningJourneyQueryVariables>(LearningJourneyDocument, options);
}
export type LearningJourneyQueryRemoteHookResult = ReturnType<typeof useLearningJourneyQueryRemote>;
export type LearningJourneyLazyQueryRemoteHookResult = ReturnType<typeof useLearningJourneyLazyQueryRemote>;
export type LearningJourneyQueryResult = Apollo.QueryResult<RLearningJourneyQuery, RLearningJourneyQueryVariables>;
export const LearningJourneysDocument = gql`
  query learningJourneys($filter: LearningJourneyFilter!, $pagination: Pagination) {
    learningJourneys(filter: $filter, pagination: $pagination) {
      total
      data {
        id
        spaceId
        subjectId
        subject {
          subjectId
          subject
          categoryId
          category
        }
        title
        status
        items(pagination: { limit: -1 }) {
          total
        }
      }
    }
  }
`;

/**
 * __useLearningJourneysQueryRemote__
 *
 * To run a query within a React component, call `useLearningJourneysQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneysQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningJourneysQueryRemote({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useLearningJourneysQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningJourneysQuery, RLearningJourneysQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningJourneysQuery, RLearningJourneysQueryVariables>(LearningJourneysDocument, options);
}
export function useLearningJourneysLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningJourneysQuery, RLearningJourneysQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningJourneysQuery, RLearningJourneysQueryVariables>(LearningJourneysDocument, options);
}
export type LearningJourneysQueryRemoteHookResult = ReturnType<typeof useLearningJourneysQueryRemote>;
export type LearningJourneysLazyQueryRemoteHookResult = ReturnType<typeof useLearningJourneysLazyQueryRemote>;
export type LearningJourneysQueryResult = Apollo.QueryResult<RLearningJourneysQuery, RLearningJourneysQueryVariables>;
export const LearningJourneySessionDocument = gql`
  query learningJourneySession($id: Int!, $includeProgress: Boolean!) {
    learningJourneySession(id: $id) {
      id
      startedAt
      cohort {
        learners {
          userId
          sessionId
          user {
            id
            email
            username
            profileImage
          }
          progress @include(if: $includeProgress) {
            isCompleted
            progress
          }
        }
        teams {
          id
          name
          parentTeamId
        }
      }
    }
  }
`;

/**
 * __useLearningJourneySessionQueryRemote__
 *
 * To run a query within a React component, call `useLearningJourneySessionQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneySessionQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningJourneySessionQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *      includeProgress: // value for 'includeProgress'
 *   },
 * });
 */
export function useLearningJourneySessionQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningJourneySessionQuery, RLearningJourneySessionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningJourneySessionQuery, RLearningJourneySessionQueryVariables>(
    LearningJourneySessionDocument,
    options,
  );
}
export function useLearningJourneySessionLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningJourneySessionQuery, RLearningJourneySessionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningJourneySessionQuery, RLearningJourneySessionQueryVariables>(
    LearningJourneySessionDocument,
    options,
  );
}
export type LearningJourneySessionQueryRemoteHookResult = ReturnType<typeof useLearningJourneySessionQueryRemote>;
export type LearningJourneySessionLazyQueryRemoteHookResult = ReturnType<typeof useLearningJourneySessionLazyQueryRemote>;
export type LearningJourneySessionQueryResult = Apollo.QueryResult<
  RLearningJourneySessionQuery,
  RLearningJourneySessionQueryVariables
>;
export const LearningJourneyItemsCatalogDocument = gql`
  query learningJourneyItemsCatalog($id: Int!, $spaceIds: [Int!]!, $searchPhrase: String, $pagination: Pagination!) {
    learningJourneyItemsCatalog(filter: { id: $id, searchPhrase: $searchPhrase }, pagination: $pagination) {
      data {
        ...LearningContent
      }
      limit
      page
    }
  }
  ${LearningContentFragmentDoc}
`;

/**
 * __useLearningJourneyItemsCatalogQueryRemote__
 *
 * To run a query within a React component, call `useLearningJourneyItemsCatalogQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneyItemsCatalogQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningJourneyItemsCatalogQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *      spaceIds: // value for 'spaceIds'
 *      searchPhrase: // value for 'searchPhrase'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useLearningJourneyItemsCatalogQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningJourneyItemsCatalogQuery, RLearningJourneyItemsCatalogQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningJourneyItemsCatalogQuery, RLearningJourneyItemsCatalogQueryVariables>(
    LearningJourneyItemsCatalogDocument,
    options,
  );
}
export function useLearningJourneyItemsCatalogLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningJourneyItemsCatalogQuery, RLearningJourneyItemsCatalogQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningJourneyItemsCatalogQuery, RLearningJourneyItemsCatalogQueryVariables>(
    LearningJourneyItemsCatalogDocument,
    options,
  );
}
export type LearningJourneyItemsCatalogQueryRemoteHookResult = ReturnType<typeof useLearningJourneyItemsCatalogQueryRemote>;
export type LearningJourneyItemsCatalogLazyQueryRemoteHookResult = ReturnType<
  typeof useLearningJourneyItemsCatalogLazyQueryRemote
>;
export type LearningJourneyItemsCatalogQueryResult = Apollo.QueryResult<
  RLearningJourneyItemsCatalogQuery,
  RLearningJourneyItemsCatalogQueryVariables
>;
export const LearningJourneyDiscussionTeamsDocument = gql`
  query learningJourneyDiscussionTeams($id: Int!) {
    learningJourney(id: $id) {
      id
      spaceId
      sessions {
        id
        urn
        journeyId
        discussionTeams {
          id
          sessionId
          name
          teamSize
          createdAt
          updatedAt
          members {
            teamId
            userId
            createdAt
            user {
              id
              realm
              email
              username
              firstname
            }
          }
        }
      }
    }
  }
`;

/**
 * __useLearningJourneyDiscussionTeamsQueryRemote__
 *
 * To run a query within a React component, call `useLearningJourneyDiscussionTeamsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneyDiscussionTeamsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningJourneyDiscussionTeamsQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningJourneyDiscussionTeamsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningJourneyDiscussionTeamsQuery, RLearningJourneyDiscussionTeamsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningJourneyDiscussionTeamsQuery, RLearningJourneyDiscussionTeamsQueryVariables>(
    LearningJourneyDiscussionTeamsDocument,
    options,
  );
}
export function useLearningJourneyDiscussionTeamsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningJourneyDiscussionTeamsQuery, RLearningJourneyDiscussionTeamsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningJourneyDiscussionTeamsQuery, RLearningJourneyDiscussionTeamsQueryVariables>(
    LearningJourneyDiscussionTeamsDocument,
    options,
  );
}
export type LearningJourneyDiscussionTeamsQueryRemoteHookResult = ReturnType<typeof useLearningJourneyDiscussionTeamsQueryRemote>;
export type LearningJourneyDiscussionTeamsLazyQueryRemoteHookResult = ReturnType<
  typeof useLearningJourneyDiscussionTeamsLazyQueryRemote
>;
export type LearningJourneyDiscussionTeamsQueryResult = Apollo.QueryResult<
  RLearningJourneyDiscussionTeamsQuery,
  RLearningJourneyDiscussionTeamsQueryVariables
>;
export const ReportingLearningJourneyContentInsightsDocument = gql`
  query reportingLearningJourneyContentInsights(
    $where: reportingLearningJourneyContentInsights_bool_exp
    $orderBy: [reportingLearningJourneyContentInsights_order_by!]
    $limit: Int
    $whereAggregate: reportingLearningJourneyContentInsights_bool_exp
    $offset: Int
  ) {
    reportingLearningJourneyContentInsights(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
      learningContentURN
      learningContentTitle
      learningType
      startedCount
      completedCount
      completionRate
      notStartedCount
    }
    filteredTotal: reportingLearningJourneyContentInsightsAggregate(where: $where) {
      aggregate {
        count
      }
    }
    total: reportingLearningJourneyContentInsightsAggregate(where: $whereAggregate) {
      aggregate {
        count
      }
    }
  }
`;

/**
 * __useReportingLearningJourneyContentInsightsQueryRemote__
 *
 * To run a query within a React component, call `useReportingLearningJourneyContentInsightsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingLearningJourneyContentInsightsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingLearningJourneyContentInsightsQueryRemote({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      whereAggregate: // value for 'whereAggregate'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useReportingLearningJourneyContentInsightsQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<
    RReportingLearningJourneyContentInsightsQuery,
    RReportingLearningJourneyContentInsightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingLearningJourneyContentInsightsQuery, RReportingLearningJourneyContentInsightsQueryVariables>(
    ReportingLearningJourneyContentInsightsDocument,
    options,
  );
}
export function useReportingLearningJourneyContentInsightsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingLearningJourneyContentInsightsQuery,
    RReportingLearningJourneyContentInsightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RReportingLearningJourneyContentInsightsQuery,
    RReportingLearningJourneyContentInsightsQueryVariables
  >(ReportingLearningJourneyContentInsightsDocument, options);
}
export type ReportingLearningJourneyContentInsightsQueryRemoteHookResult = ReturnType<
  typeof useReportingLearningJourneyContentInsightsQueryRemote
>;
export type ReportingLearningJourneyContentInsightsLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingLearningJourneyContentInsightsLazyQueryRemote
>;
export type ReportingLearningJourneyContentInsightsQueryResult = Apollo.QueryResult<
  RReportingLearningJourneyContentInsightsQuery,
  RReportingLearningJourneyContentInsightsQueryVariables
>;
export const ReportingLearningJourneysItemsDocument = gql`
  query reportingLearningJourneysItems(
    $args: reportingLearningJourneysItems_arguments!
    $where: learning_journeys_items_bool_exp_bool_exp
    $orderBy: [learning_journeys_items_order_by!]
    $limit: Int
    $offset: Int
  ) {
    reportingLearningJourneysItems(args: $args, order_by: $orderBy, where: $where, limit: $limit, offset: $offset) {
      urn
      title
      type
      partner
    }
  }
`;

/**
 * __useReportingLearningJourneysItemsQueryRemote__
 *
 * To run a query within a React component, call `useReportingLearningJourneysItemsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingLearningJourneysItemsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingLearningJourneysItemsQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useReportingLearningJourneysItemsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RReportingLearningJourneysItemsQuery, RReportingLearningJourneysItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingLearningJourneysItemsQuery, RReportingLearningJourneysItemsQueryVariables>(
    ReportingLearningJourneysItemsDocument,
    options,
  );
}
export function useReportingLearningJourneysItemsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RReportingLearningJourneysItemsQuery, RReportingLearningJourneysItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingLearningJourneysItemsQuery, RReportingLearningJourneysItemsQueryVariables>(
    ReportingLearningJourneysItemsDocument,
    options,
  );
}
export type ReportingLearningJourneysItemsQueryRemoteHookResult = ReturnType<typeof useReportingLearningJourneysItemsQueryRemote>;
export type ReportingLearningJourneysItemsLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingLearningJourneysItemsLazyQueryRemote
>;
export type ReportingLearningJourneysItemsQueryResult = Apollo.QueryResult<
  RReportingLearningJourneysItemsQuery,
  RReportingLearningJourneysItemsQueryVariables
>;
export const ReportingLearningJourneysItemsInsightsDocument = gql`
  query reportingLearningJourneysItemsInsights(
    $args: reportingLearningJourneysItemsInsights_arguments!
    $where: learning_journeys_items_insights_bool_exp_bool_exp
    $orderBy: [learning_journeys_items_insights_order_by!]
    $limit: Int
    $offset: Int
  ) {
    reportingLearningJourneysItemsInsights(args: $args, order_by: $orderBy, where: $where, limit: $limit, offset: $offset) {
      urn
      not_started_count
      in_progress_count
      completed_count
      completion_rate
    }
  }
`;

/**
 * __useReportingLearningJourneysItemsInsightsQueryRemote__
 *
 * To run a query within a React component, call `useReportingLearningJourneysItemsInsightsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingLearningJourneysItemsInsightsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingLearningJourneysItemsInsightsQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useReportingLearningJourneysItemsInsightsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RReportingLearningJourneysItemsInsightsQuery,
    RReportingLearningJourneysItemsInsightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingLearningJourneysItemsInsightsQuery, RReportingLearningJourneysItemsInsightsQueryVariables>(
    ReportingLearningJourneysItemsInsightsDocument,
    options,
  );
}
export function useReportingLearningJourneysItemsInsightsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingLearningJourneysItemsInsightsQuery,
    RReportingLearningJourneysItemsInsightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingLearningJourneysItemsInsightsQuery, RReportingLearningJourneysItemsInsightsQueryVariables>(
    ReportingLearningJourneysItemsInsightsDocument,
    options,
  );
}
export type ReportingLearningJourneysItemsInsightsQueryRemoteHookResult = ReturnType<
  typeof useReportingLearningJourneysItemsInsightsQueryRemote
>;
export type ReportingLearningJourneysItemsInsightsLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingLearningJourneysItemsInsightsLazyQueryRemote
>;
export type ReportingLearningJourneysItemsInsightsQueryResult = Apollo.QueryResult<
  RReportingLearningJourneysItemsInsightsQuery,
  RReportingLearningJourneysItemsInsightsQueryVariables
>;
export const ReportingLearningJourneysItemsTotalCountDocument = gql`
  query reportingLearningJourneysItemsTotalCount(
    $args: reportingLearningJourneysItemsTotalCount_arguments!
    $where: total_count_bool_exp_bool_exp
    $orderBy: [total_count_order_by!]
    $limit: Int
    $offset: Int
  ) {
    reportingLearningJourneysItemsTotalCount(args: $args, order_by: $orderBy, where: $where, limit: $limit, offset: $offset) {
      total_count
    }
  }
`;

/**
 * __useReportingLearningJourneysItemsTotalCountQueryRemote__
 *
 * To run a query within a React component, call `useReportingLearningJourneysItemsTotalCountQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingLearningJourneysItemsTotalCountQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingLearningJourneysItemsTotalCountQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useReportingLearningJourneysItemsTotalCountQueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RReportingLearningJourneysItemsTotalCountQuery,
    RReportingLearningJourneysItemsTotalCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingLearningJourneysItemsTotalCountQuery, RReportingLearningJourneysItemsTotalCountQueryVariables>(
    ReportingLearningJourneysItemsTotalCountDocument,
    options,
  );
}
export function useReportingLearningJourneysItemsTotalCountLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingLearningJourneysItemsTotalCountQuery,
    RReportingLearningJourneysItemsTotalCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RReportingLearningJourneysItemsTotalCountQuery,
    RReportingLearningJourneysItemsTotalCountQueryVariables
  >(ReportingLearningJourneysItemsTotalCountDocument, options);
}
export type ReportingLearningJourneysItemsTotalCountQueryRemoteHookResult = ReturnType<
  typeof useReportingLearningJourneysItemsTotalCountQueryRemote
>;
export type ReportingLearningJourneysItemsTotalCountLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingLearningJourneysItemsTotalCountLazyQueryRemote
>;
export type ReportingLearningJourneysItemsTotalCountQueryResult = Apollo.QueryResult<
  RReportingLearningJourneysItemsTotalCountQuery,
  RReportingLearningJourneysItemsTotalCountQueryVariables
>;
export const LearningJourneySectionDocument = gql`
  query learningJourneySection(
    $id: Int!
    $filter: LearningSectionItemsFilter!
    $pagination: Pagination!
    $userId: Int!
    $spaceIds: [Int!]!
    $includeSectionProgress: Boolean!
    $includeContentProgress: Boolean!
    $includeUpdateByUser: Boolean!
    $includeIsLocked: Boolean!
  ) {
    learningV2(id: $id) {
      ...LearningV2Fragment
      sectionItems(filter: $filter, pagination: $pagination) {
        data {
          ...LearningSectionItemFragment
        }
      }
      userLastParticipation(userId: $userId) @include(if: $includeSectionProgress) {
        ...Participation
      }
      updateByUser @include(if: $includeUpdateByUser) {
        id
        firstname
        lastname
      }
    }
  }
  ${LearningV2FragmentFragmentDoc}
  ${LearningSectionItemFragmentFragmentDoc}
  ${ParticipationFragmentDoc}
`;

/**
 * __useLearningJourneySectionQueryRemote__
 *
 * To run a query within a React component, call `useLearningJourneySectionQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneySectionQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningJourneySectionQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      userId: // value for 'userId'
 *      spaceIds: // value for 'spaceIds'
 *      includeSectionProgress: // value for 'includeSectionProgress'
 *      includeContentProgress: // value for 'includeContentProgress'
 *      includeUpdateByUser: // value for 'includeUpdateByUser'
 *      includeIsLocked: // value for 'includeIsLocked'
 *   },
 * });
 */
export function useLearningJourneySectionQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningJourneySectionQuery, RLearningJourneySectionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningJourneySectionQuery, RLearningJourneySectionQueryVariables>(
    LearningJourneySectionDocument,
    options,
  );
}
export function useLearningJourneySectionLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningJourneySectionQuery, RLearningJourneySectionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningJourneySectionQuery, RLearningJourneySectionQueryVariables>(
    LearningJourneySectionDocument,
    options,
  );
}
export type LearningJourneySectionQueryRemoteHookResult = ReturnType<typeof useLearningJourneySectionQueryRemote>;
export type LearningJourneySectionLazyQueryRemoteHookResult = ReturnType<typeof useLearningJourneySectionLazyQueryRemote>;
export type LearningJourneySectionQueryResult = Apollo.QueryResult<
  RLearningJourneySectionQuery,
  RLearningJourneySectionQueryVariables
>;
export const CloneLearningJourneyDocument = gql`
  mutation cloneLearningJourney($input: CloneLearningJourneyInput!) {
    cloneLearningJourney(input: $input) {
      journey {
        id
      }
      success
    }
  }
`;
export type RCloneLearningJourneyMutationFn = Apollo.MutationFunction<
  RCloneLearningJourneyMutation,
  RCloneLearningJourneyMutationVariables
>;

/**
 * __useCloneLearningJourneyMutationRemote__
 *
 * To run a mutation, you first call `useCloneLearningJourneyMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneLearningJourneyMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneLearningJourneyMutationRemote, { data, loading, error }] = useCloneLearningJourneyMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneLearningJourneyMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCloneLearningJourneyMutation, RCloneLearningJourneyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCloneLearningJourneyMutation, RCloneLearningJourneyMutationVariables>(
    CloneLearningJourneyDocument,
    options,
  );
}
export type CloneLearningJourneyMutationRemoteHookResult = ReturnType<typeof useCloneLearningJourneyMutationRemote>;
export type CloneLearningJourneyMutationResult = Apollo.MutationResult<RCloneLearningJourneyMutation>;
export type CloneLearningJourneyMutationOptions = Apollo.BaseMutationOptions<
  RCloneLearningJourneyMutation,
  RCloneLearningJourneyMutationVariables
>;
export const RemoveUsersFromLearningJourneyCohortDocument = gql`
  mutation removeUsersFromLearningJourneyCohort($journeyId: Int!, $userIds: [Int!]!) {
    removeUsersFromLearningJourneyCohort(journeyId: $journeyId, userIds: $userIds) {
      learnersAdded
      success
    }
  }
`;
export type RRemoveUsersFromLearningJourneyCohortMutationFn = Apollo.MutationFunction<
  RRemoveUsersFromLearningJourneyCohortMutation,
  RRemoveUsersFromLearningJourneyCohortMutationVariables
>;

/**
 * __useRemoveUsersFromLearningJourneyCohortMutationRemote__
 *
 * To run a mutation, you first call `useRemoveUsersFromLearningJourneyCohortMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersFromLearningJourneyCohortMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersFromLearningJourneyCohortMutationRemote, { data, loading, error }] = useRemoveUsersFromLearningJourneyCohortMutationRemote({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useRemoveUsersFromLearningJourneyCohortMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RRemoveUsersFromLearningJourneyCohortMutation,
    RRemoveUsersFromLearningJourneyCohortMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RRemoveUsersFromLearningJourneyCohortMutation,
    RRemoveUsersFromLearningJourneyCohortMutationVariables
  >(RemoveUsersFromLearningJourneyCohortDocument, options);
}
export type RemoveUsersFromLearningJourneyCohortMutationRemoteHookResult = ReturnType<
  typeof useRemoveUsersFromLearningJourneyCohortMutationRemote
>;
export type RemoveUsersFromLearningJourneyCohortMutationResult =
  Apollo.MutationResult<RRemoveUsersFromLearningJourneyCohortMutation>;
export type RemoveUsersFromLearningJourneyCohortMutationOptions = Apollo.BaseMutationOptions<
  RRemoveUsersFromLearningJourneyCohortMutation,
  RRemoveUsersFromLearningJourneyCohortMutationVariables
>;
export const AddTeamsToLearningJourneyCohortDocument = gql`
  mutation addTeamsToLearningJourneyCohort($input: UpdateLearningJourneyCohortTeamsInput!) {
    addTeamsToLearningJourneyCohort(input: $input) {
      learnersAdded
      success
    }
  }
`;
export type RAddTeamsToLearningJourneyCohortMutationFn = Apollo.MutationFunction<
  RAddTeamsToLearningJourneyCohortMutation,
  RAddTeamsToLearningJourneyCohortMutationVariables
>;

/**
 * __useAddTeamsToLearningJourneyCohortMutationRemote__
 *
 * To run a mutation, you first call `useAddTeamsToLearningJourneyCohortMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamsToLearningJourneyCohortMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamsToLearningJourneyCohortMutationRemote, { data, loading, error }] = useAddTeamsToLearningJourneyCohortMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTeamsToLearningJourneyCohortMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RAddTeamsToLearningJourneyCohortMutation,
    RAddTeamsToLearningJourneyCohortMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RAddTeamsToLearningJourneyCohortMutation, RAddTeamsToLearningJourneyCohortMutationVariables>(
    AddTeamsToLearningJourneyCohortDocument,
    options,
  );
}
export type AddTeamsToLearningJourneyCohortMutationRemoteHookResult = ReturnType<
  typeof useAddTeamsToLearningJourneyCohortMutationRemote
>;
export type AddTeamsToLearningJourneyCohortMutationResult = Apollo.MutationResult<RAddTeamsToLearningJourneyCohortMutation>;
export type AddTeamsToLearningJourneyCohortMutationOptions = Apollo.BaseMutationOptions<
  RAddTeamsToLearningJourneyCohortMutation,
  RAddTeamsToLearningJourneyCohortMutationVariables
>;
export const CreateLearningJourneyDocument = gql`
  mutation createLearningJourney($input: CreateLearningJourneyInput!) {
    createLearningJourney(input: $input) {
      success
      journey {
        id
      }
    }
  }
`;
export type RCreateLearningJourneyMutationFn = Apollo.MutationFunction<
  RCreateLearningJourneyMutation,
  RCreateLearningJourneyMutationVariables
>;

/**
 * __useCreateLearningJourneyMutationRemote__
 *
 * To run a mutation, you first call `useCreateLearningJourneyMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningJourneyMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningJourneyMutationRemote, { data, loading, error }] = useCreateLearningJourneyMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearningJourneyMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCreateLearningJourneyMutation, RCreateLearningJourneyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateLearningJourneyMutation, RCreateLearningJourneyMutationVariables>(
    CreateLearningJourneyDocument,
    options,
  );
}
export type CreateLearningJourneyMutationRemoteHookResult = ReturnType<typeof useCreateLearningJourneyMutationRemote>;
export type CreateLearningJourneyMutationResult = Apollo.MutationResult<RCreateLearningJourneyMutation>;
export type CreateLearningJourneyMutationOptions = Apollo.BaseMutationOptions<
  RCreateLearningJourneyMutation,
  RCreateLearningJourneyMutationVariables
>;
export const UpsertLearningJourneyItemsDocument = gql`
  mutation upsertLearningJourneyItems($input: UpsertLearningJourneyItemsInput!) {
    upsertLearningJourneyItems(input: $input) {
      success
      journey {
        id
      }
    }
  }
`;
export type RUpsertLearningJourneyItemsMutationFn = Apollo.MutationFunction<
  RUpsertLearningJourneyItemsMutation,
  RUpsertLearningJourneyItemsMutationVariables
>;

/**
 * __useUpsertLearningJourneyItemsMutationRemote__
 *
 * To run a mutation, you first call `useUpsertLearningJourneyItemsMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLearningJourneyItemsMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLearningJourneyItemsMutationRemote, { data, loading, error }] = useUpsertLearningJourneyItemsMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertLearningJourneyItemsMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpsertLearningJourneyItemsMutation, RUpsertLearningJourneyItemsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpsertLearningJourneyItemsMutation, RUpsertLearningJourneyItemsMutationVariables>(
    UpsertLearningJourneyItemsDocument,
    options,
  );
}
export type UpsertLearningJourneyItemsMutationRemoteHookResult = ReturnType<typeof useUpsertLearningJourneyItemsMutationRemote>;
export type UpsertLearningJourneyItemsMutationResult = Apollo.MutationResult<RUpsertLearningJourneyItemsMutation>;
export type UpsertLearningJourneyItemsMutationOptions = Apollo.BaseMutationOptions<
  RUpsertLearningJourneyItemsMutation,
  RUpsertLearningJourneyItemsMutationVariables
>;
export const UpdateLearningJourneyDocument = gql`
  mutation updateLearningJourney($input: UpdateLearningJourneyInput!, $options: UpdateLearningJourneyOptionsInput) {
    updateLearningJourney(input: $input, options: $options) {
      success
      journey {
        id
        subjectId
        subject {
          subjectId
          subject
          categoryId
          category
        }
        businessGoalV2
        title
        descriptionV2
        bannerURL
        status
        completionCriteria
        completionInvestTimeSec
        certificateEnabled
      }
    }
  }
`;
export type RUpdateLearningJourneyMutationFn = Apollo.MutationFunction<
  RUpdateLearningJourneyMutation,
  RUpdateLearningJourneyMutationVariables
>;

/**
 * __useUpdateLearningJourneyMutationRemote__
 *
 * To run a mutation, you first call `useUpdateLearningJourneyMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningJourneyMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningJourneyMutationRemote, { data, loading, error }] = useUpdateLearningJourneyMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUpdateLearningJourneyMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpdateLearningJourneyMutation, RUpdateLearningJourneyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpdateLearningJourneyMutation, RUpdateLearningJourneyMutationVariables>(
    UpdateLearningJourneyDocument,
    options,
  );
}
export type UpdateLearningJourneyMutationRemoteHookResult = ReturnType<typeof useUpdateLearningJourneyMutationRemote>;
export type UpdateLearningJourneyMutationResult = Apollo.MutationResult<RUpdateLearningJourneyMutation>;
export type UpdateLearningJourneyMutationOptions = Apollo.BaseMutationOptions<
  RUpdateLearningJourneyMutation,
  RUpdateLearningJourneyMutationVariables
>;
export const UpsertLearningJourneyCohortsDocument = gql`
  mutation upsertLearningJourneyCohorts($input: UpsertLearningJourneyCohortsInput!) {
    upsertLearningJourneyCohorts(input: $input) {
      success
    }
  }
`;
export type RUpsertLearningJourneyCohortsMutationFn = Apollo.MutationFunction<
  RUpsertLearningJourneyCohortsMutation,
  RUpsertLearningJourneyCohortsMutationVariables
>;

/**
 * __useUpsertLearningJourneyCohortsMutationRemote__
 *
 * To run a mutation, you first call `useUpsertLearningJourneyCohortsMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLearningJourneyCohortsMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLearningJourneyCohortsMutationRemote, { data, loading, error }] = useUpsertLearningJourneyCohortsMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertLearningJourneyCohortsMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpsertLearningJourneyCohortsMutation, RUpsertLearningJourneyCohortsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpsertLearningJourneyCohortsMutation, RUpsertLearningJourneyCohortsMutationVariables>(
    UpsertLearningJourneyCohortsDocument,
    options,
  );
}
export type UpsertLearningJourneyCohortsMutationRemoteHookResult = ReturnType<
  typeof useUpsertLearningJourneyCohortsMutationRemote
>;
export type UpsertLearningJourneyCohortsMutationResult = Apollo.MutationResult<RUpsertLearningJourneyCohortsMutation>;
export type UpsertLearningJourneyCohortsMutationOptions = Apollo.BaseMutationOptions<
  RUpsertLearningJourneyCohortsMutation,
  RUpsertLearningJourneyCohortsMutationVariables
>;
export const BootstrapLearningJourneySessionDiscussionTeamsDocument = gql`
  mutation bootstrapLearningJourneySessionDiscussionTeams($sessionId: Int!, $teamSize: Int!) {
    bootstrapLearningJourneySesssionDiscussionTeams(sessionId: $sessionId, teamSize: $teamSize) {
      success
    }
  }
`;
export type RBootstrapLearningJourneySessionDiscussionTeamsMutationFn = Apollo.MutationFunction<
  RBootstrapLearningJourneySessionDiscussionTeamsMutation,
  RBootstrapLearningJourneySessionDiscussionTeamsMutationVariables
>;

/**
 * __useBootstrapLearningJourneySessionDiscussionTeamsMutationRemote__
 *
 * To run a mutation, you first call `useBootstrapLearningJourneySessionDiscussionTeamsMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBootstrapLearningJourneySessionDiscussionTeamsMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bootstrapLearningJourneySessionDiscussionTeamsMutationRemote, { data, loading, error }] = useBootstrapLearningJourneySessionDiscussionTeamsMutationRemote({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      teamSize: // value for 'teamSize'
 *   },
 * });
 */
export function useBootstrapLearningJourneySessionDiscussionTeamsMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RBootstrapLearningJourneySessionDiscussionTeamsMutation,
    RBootstrapLearningJourneySessionDiscussionTeamsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RBootstrapLearningJourneySessionDiscussionTeamsMutation,
    RBootstrapLearningJourneySessionDiscussionTeamsMutationVariables
  >(BootstrapLearningJourneySessionDiscussionTeamsDocument, options);
}
export type BootstrapLearningJourneySessionDiscussionTeamsMutationRemoteHookResult = ReturnType<
  typeof useBootstrapLearningJourneySessionDiscussionTeamsMutationRemote
>;
export type BootstrapLearningJourneySessionDiscussionTeamsMutationResult =
  Apollo.MutationResult<RBootstrapLearningJourneySessionDiscussionTeamsMutation>;
export type BootstrapLearningJourneySessionDiscussionTeamsMutationOptions = Apollo.BaseMutationOptions<
  RBootstrapLearningJourneySessionDiscussionTeamsMutation,
  RBootstrapLearningJourneySessionDiscussionTeamsMutationVariables
>;
export const ResetLearningJourneySessionDiscussionTeamsDocument = gql`
  mutation resetLearningJourneySessionDiscussionTeams($input: ResetLearningJourneySessionDiscussionTeamsInput!) {
    resetLearningJourneySessionDiscussionTeams(input: $input) {
      success
    }
  }
`;
export type RResetLearningJourneySessionDiscussionTeamsMutationFn = Apollo.MutationFunction<
  RResetLearningJourneySessionDiscussionTeamsMutation,
  RResetLearningJourneySessionDiscussionTeamsMutationVariables
>;

/**
 * __useResetLearningJourneySessionDiscussionTeamsMutationRemote__
 *
 * To run a mutation, you first call `useResetLearningJourneySessionDiscussionTeamsMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetLearningJourneySessionDiscussionTeamsMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetLearningJourneySessionDiscussionTeamsMutationRemote, { data, loading, error }] = useResetLearningJourneySessionDiscussionTeamsMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetLearningJourneySessionDiscussionTeamsMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RResetLearningJourneySessionDiscussionTeamsMutation,
    RResetLearningJourneySessionDiscussionTeamsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RResetLearningJourneySessionDiscussionTeamsMutation,
    RResetLearningJourneySessionDiscussionTeamsMutationVariables
  >(ResetLearningJourneySessionDiscussionTeamsDocument, options);
}
export type ResetLearningJourneySessionDiscussionTeamsMutationRemoteHookResult = ReturnType<
  typeof useResetLearningJourneySessionDiscussionTeamsMutationRemote
>;
export type ResetLearningJourneySessionDiscussionTeamsMutationResult =
  Apollo.MutationResult<RResetLearningJourneySessionDiscussionTeamsMutation>;
export type ResetLearningJourneySessionDiscussionTeamsMutationOptions = Apollo.BaseMutationOptions<
  RResetLearningJourneySessionDiscussionTeamsMutation,
  RResetLearningJourneySessionDiscussionTeamsMutationVariables
>;
export const UpsertLearningJourneySessionDiscussionTeamMembersDocument = gql`
  mutation upsertLearningJourneySessionDiscussionTeamMembers(
    $sessionId: Int!
    $teamMembers: [UpsertLearningJourneySessionDiscussionTeamMembersInput!]!
  ) {
    upsertLearningJourneySessionDiscussionTeamMembers(sessionId: $sessionId, teamMembers: $teamMembers) {
      success
    }
  }
`;
export type RUpsertLearningJourneySessionDiscussionTeamMembersMutationFn = Apollo.MutationFunction<
  RUpsertLearningJourneySessionDiscussionTeamMembersMutation,
  RUpsertLearningJourneySessionDiscussionTeamMembersMutationVariables
>;

/**
 * __useUpsertLearningJourneySessionDiscussionTeamMembersMutationRemote__
 *
 * To run a mutation, you first call `useUpsertLearningJourneySessionDiscussionTeamMembersMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLearningJourneySessionDiscussionTeamMembersMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLearningJourneySessionDiscussionTeamMembersMutationRemote, { data, loading, error }] = useUpsertLearningJourneySessionDiscussionTeamMembersMutationRemote({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      teamMembers: // value for 'teamMembers'
 *   },
 * });
 */
export function useUpsertLearningJourneySessionDiscussionTeamMembersMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RUpsertLearningJourneySessionDiscussionTeamMembersMutation,
    RUpsertLearningJourneySessionDiscussionTeamMembersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RUpsertLearningJourneySessionDiscussionTeamMembersMutation,
    RUpsertLearningJourneySessionDiscussionTeamMembersMutationVariables
  >(UpsertLearningJourneySessionDiscussionTeamMembersDocument, options);
}
export type UpsertLearningJourneySessionDiscussionTeamMembersMutationRemoteHookResult = ReturnType<
  typeof useUpsertLearningJourneySessionDiscussionTeamMembersMutationRemote
>;
export type UpsertLearningJourneySessionDiscussionTeamMembersMutationResult =
  Apollo.MutationResult<RUpsertLearningJourneySessionDiscussionTeamMembersMutation>;
export type UpsertLearningJourneySessionDiscussionTeamMembersMutationOptions = Apollo.BaseMutationOptions<
  RUpsertLearningJourneySessionDiscussionTeamMembersMutation,
  RUpsertLearningJourneySessionDiscussionTeamMembersMutationVariables
>;
export const JoinLearningJourneyCohortsDocument = gql`
  mutation joinLearningJourneyCohorts($userId: Int!, $sessionId: Int!) {
    joinLearningJourneyCohort(userId: $userId, sessionId: $sessionId) {
      success
    }
  }
`;
export type RJoinLearningJourneyCohortsMutationFn = Apollo.MutationFunction<
  RJoinLearningJourneyCohortsMutation,
  RJoinLearningJourneyCohortsMutationVariables
>;

/**
 * __useJoinLearningJourneyCohortsMutationRemote__
 *
 * To run a mutation, you first call `useJoinLearningJourneyCohortsMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinLearningJourneyCohortsMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinLearningJourneyCohortsMutationRemote, { data, loading, error }] = useJoinLearningJourneyCohortsMutationRemote({
 *   variables: {
 *      userId: // value for 'userId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useJoinLearningJourneyCohortsMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RJoinLearningJourneyCohortsMutation, RJoinLearningJourneyCohortsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RJoinLearningJourneyCohortsMutation, RJoinLearningJourneyCohortsMutationVariables>(
    JoinLearningJourneyCohortsDocument,
    options,
  );
}
export type JoinLearningJourneyCohortsMutationRemoteHookResult = ReturnType<typeof useJoinLearningJourneyCohortsMutationRemote>;
export type JoinLearningJourneyCohortsMutationResult = Apollo.MutationResult<RJoinLearningJourneyCohortsMutation>;
export type JoinLearningJourneyCohortsMutationOptions = Apollo.BaseMutationOptions<
  RJoinLearningJourneyCohortsMutation,
  RJoinLearningJourneyCohortsMutationVariables
>;
export const CreateLearningJourneyPracticalAssessmentsDocument = gql`
  mutation createLearningJourneyPracticalAssessments($input: CreateLearningJourneyPracticalAssessmentsInput!) {
    createLearningJourneyPracticalAssessments(input: $input) {
      id
      title
      urn
      type
      image
      effort
    }
  }
`;
export type RCreateLearningJourneyPracticalAssessmentsMutationFn = Apollo.MutationFunction<
  RCreateLearningJourneyPracticalAssessmentsMutation,
  RCreateLearningJourneyPracticalAssessmentsMutationVariables
>;

/**
 * __useCreateLearningJourneyPracticalAssessmentsMutationRemote__
 *
 * To run a mutation, you first call `useCreateLearningJourneyPracticalAssessmentsMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningJourneyPracticalAssessmentsMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningJourneyPracticalAssessmentsMutationRemote, { data, loading, error }] = useCreateLearningJourneyPracticalAssessmentsMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearningJourneyPracticalAssessmentsMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RCreateLearningJourneyPracticalAssessmentsMutation,
    RCreateLearningJourneyPracticalAssessmentsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RCreateLearningJourneyPracticalAssessmentsMutation,
    RCreateLearningJourneyPracticalAssessmentsMutationVariables
  >(CreateLearningJourneyPracticalAssessmentsDocument, options);
}
export type CreateLearningJourneyPracticalAssessmentsMutationRemoteHookResult = ReturnType<
  typeof useCreateLearningJourneyPracticalAssessmentsMutationRemote
>;
export type CreateLearningJourneyPracticalAssessmentsMutationResult =
  Apollo.MutationResult<RCreateLearningJourneyPracticalAssessmentsMutation>;
export type CreateLearningJourneyPracticalAssessmentsMutationOptions = Apollo.BaseMutationOptions<
  RCreateLearningJourneyPracticalAssessmentsMutation,
  RCreateLearningJourneyPracticalAssessmentsMutationVariables
>;
export const CreateUserLearningSubmissionDocument = gql`
  mutation createUserLearningSubmission($input: CreateUserLearningSubmissionInput!) {
    createUserLearningSubmission(input: $input) {
      success
      submission {
        data
        id
        createdAt
        userId
        type
        pageURNV2
        learningURNV2
      }
    }
  }
`;
export type RCreateUserLearningSubmissionMutationFn = Apollo.MutationFunction<
  RCreateUserLearningSubmissionMutation,
  RCreateUserLearningSubmissionMutationVariables
>;

/**
 * __useCreateUserLearningSubmissionMutationRemote__
 *
 * To run a mutation, you first call `useCreateUserLearningSubmissionMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserLearningSubmissionMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserLearningSubmissionMutationRemote, { data, loading, error }] = useCreateUserLearningSubmissionMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserLearningSubmissionMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCreateUserLearningSubmissionMutation, RCreateUserLearningSubmissionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateUserLearningSubmissionMutation, RCreateUserLearningSubmissionMutationVariables>(
    CreateUserLearningSubmissionDocument,
    options,
  );
}
export type CreateUserLearningSubmissionMutationRemoteHookResult = ReturnType<
  typeof useCreateUserLearningSubmissionMutationRemote
>;
export type CreateUserLearningSubmissionMutationResult = Apollo.MutationResult<RCreateUserLearningSubmissionMutation>;
export type CreateUserLearningSubmissionMutationOptions = Apollo.BaseMutationOptions<
  RCreateUserLearningSubmissionMutation,
  RCreateUserLearningSubmissionMutationVariables
>;
export const UserLearningSubmissionsDocument = gql`
  query userLearningSubmissions($input: UserLearningSubmissionsFilter!) {
    userLearningSubmissions(input: $input) {
      createdAt
      data
      id
      pageURNV2
      learningURNV2
      reviews {
        createdAt
        data
        id
        reviewerId
        submissionId
        type
        updatedAt
      }
      reviewAssignments {
        createdAt
        expiryAt
        id
        reviewerId
        submissionId
        updatedAt
        submission {
          data
          id
          createdAt
          pageURNV2
          type
          userId
          updatedAt
          reviews {
            reviewerId
            createdAt
            data
            id
          }
        }
      }
      type
      updatedAt
      userId
    }
  }
`;

/**
 * __useUserLearningSubmissionsQueryRemote__
 *
 * To run a query within a React component, call `useUserLearningSubmissionsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useUserLearningSubmissionsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLearningSubmissionsQueryRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserLearningSubmissionsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RUserLearningSubmissionsQuery, RUserLearningSubmissionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RUserLearningSubmissionsQuery, RUserLearningSubmissionsQueryVariables>(
    UserLearningSubmissionsDocument,
    options,
  );
}
export function useUserLearningSubmissionsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RUserLearningSubmissionsQuery, RUserLearningSubmissionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RUserLearningSubmissionsQuery, RUserLearningSubmissionsQueryVariables>(
    UserLearningSubmissionsDocument,
    options,
  );
}
export type UserLearningSubmissionsQueryRemoteHookResult = ReturnType<typeof useUserLearningSubmissionsQueryRemote>;
export type UserLearningSubmissionsLazyQueryRemoteHookResult = ReturnType<typeof useUserLearningSubmissionsLazyQueryRemote>;
export type UserLearningSubmissionsQueryResult = Apollo.QueryResult<
  RUserLearningSubmissionsQuery,
  RUserLearningSubmissionsQueryVariables
>;
export const CreateUserLearningSubmissionReviewDocument = gql`
  mutation createUserLearningSubmissionReview($input: CreateUserLearningSubmissionReviewInput!) {
    createUserLearningSubmissionReview(input: $input) {
      success
    }
  }
`;
export type RCreateUserLearningSubmissionReviewMutationFn = Apollo.MutationFunction<
  RCreateUserLearningSubmissionReviewMutation,
  RCreateUserLearningSubmissionReviewMutationVariables
>;

/**
 * __useCreateUserLearningSubmissionReviewMutationRemote__
 *
 * To run a mutation, you first call `useCreateUserLearningSubmissionReviewMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserLearningSubmissionReviewMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserLearningSubmissionReviewMutationRemote, { data, loading, error }] = useCreateUserLearningSubmissionReviewMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserLearningSubmissionReviewMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RCreateUserLearningSubmissionReviewMutation,
    RCreateUserLearningSubmissionReviewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateUserLearningSubmissionReviewMutation, RCreateUserLearningSubmissionReviewMutationVariables>(
    CreateUserLearningSubmissionReviewDocument,
    options,
  );
}
export type CreateUserLearningSubmissionReviewMutationRemoteHookResult = ReturnType<
  typeof useCreateUserLearningSubmissionReviewMutationRemote
>;
export type CreateUserLearningSubmissionReviewMutationResult = Apollo.MutationResult<RCreateUserLearningSubmissionReviewMutation>;
export type CreateUserLearningSubmissionReviewMutationOptions = Apollo.BaseMutationOptions<
  RCreateUserLearningSubmissionReviewMutation,
  RCreateUserLearningSubmissionReviewMutationVariables
>;
export const ReportingMyLearningsPracticalAssessmentDocument = gql`
  query reportingMyLearningsPracticalAssessment($args: reportingMyLearningsPracticalAssessment_arguments!) {
    reportingMyLearningsPracticalAssessment(args: $args) {
      urn
      title
      page_urn
      question_title
      responses_count
      reviews_count
    }
  }
`;

/**
 * __useReportingMyLearningsPracticalAssessmentQueryRemote__
 *
 * To run a query within a React component, call `useReportingMyLearningsPracticalAssessmentQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingMyLearningsPracticalAssessmentQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingMyLearningsPracticalAssessmentQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useReportingMyLearningsPracticalAssessmentQueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RReportingMyLearningsPracticalAssessmentQuery,
    RReportingMyLearningsPracticalAssessmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingMyLearningsPracticalAssessmentQuery, RReportingMyLearningsPracticalAssessmentQueryVariables>(
    ReportingMyLearningsPracticalAssessmentDocument,
    options,
  );
}
export function useReportingMyLearningsPracticalAssessmentLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingMyLearningsPracticalAssessmentQuery,
    RReportingMyLearningsPracticalAssessmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RReportingMyLearningsPracticalAssessmentQuery,
    RReportingMyLearningsPracticalAssessmentQueryVariables
  >(ReportingMyLearningsPracticalAssessmentDocument, options);
}
export type ReportingMyLearningsPracticalAssessmentQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningsPracticalAssessmentQueryRemote
>;
export type ReportingMyLearningsPracticalAssessmentLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningsPracticalAssessmentLazyQueryRemote
>;
export type ReportingMyLearningsPracticalAssessmentQueryResult = Apollo.QueryResult<
  RReportingMyLearningsPracticalAssessmentQuery,
  RReportingMyLearningsPracticalAssessmentQueryVariables
>;
export const CreateLearningJourneyLiveEventDocument = gql`
  mutation createLearningJourneyLiveEvent($input: CreateLearningJourneyLiveEventInput!) {
    createLearningJourneyLiveEvent(input: $input) {
      id
      title
      type
      urn
      effort
      image
    }
  }
`;
export type RCreateLearningJourneyLiveEventMutationFn = Apollo.MutationFunction<
  RCreateLearningJourneyLiveEventMutation,
  RCreateLearningJourneyLiveEventMutationVariables
>;

/**
 * __useCreateLearningJourneyLiveEventMutationRemote__
 *
 * To run a mutation, you first call `useCreateLearningJourneyLiveEventMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningJourneyLiveEventMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningJourneyLiveEventMutationRemote, { data, loading, error }] = useCreateLearningJourneyLiveEventMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearningJourneyLiveEventMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RCreateLearningJourneyLiveEventMutation,
    RCreateLearningJourneyLiveEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateLearningJourneyLiveEventMutation, RCreateLearningJourneyLiveEventMutationVariables>(
    CreateLearningJourneyLiveEventDocument,
    options,
  );
}
export type CreateLearningJourneyLiveEventMutationRemoteHookResult = ReturnType<
  typeof useCreateLearningJourneyLiveEventMutationRemote
>;
export type CreateLearningJourneyLiveEventMutationResult = Apollo.MutationResult<RCreateLearningJourneyLiveEventMutation>;
export type CreateLearningJourneyLiveEventMutationOptions = Apollo.BaseMutationOptions<
  RCreateLearningJourneyLiveEventMutation,
  RCreateLearningJourneyLiveEventMutationVariables
>;
export const UpdateLocationRecordingUrlDocument = gql`
  mutation updateLocationRecordingURL($input: UpdateLocationRecordingURLInput!) {
    updateLocationRecordingURL(input: $input) {
      id
      recordingURL
    }
  }
`;
export type RUpdateLocationRecordingUrlMutationFn = Apollo.MutationFunction<
  RUpdateLocationRecordingUrlMutation,
  RUpdateLocationRecordingUrlMutationVariables
>;

/**
 * __useUpdateLocationRecordingUrlMutationRemote__
 *
 * To run a mutation, you first call `useUpdateLocationRecordingUrlMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationRecordingUrlMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationRecordingUrlMutationRemote, { data, loading, error }] = useUpdateLocationRecordingUrlMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationRecordingUrlMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpdateLocationRecordingUrlMutation, RUpdateLocationRecordingUrlMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpdateLocationRecordingUrlMutation, RUpdateLocationRecordingUrlMutationVariables>(
    UpdateLocationRecordingUrlDocument,
    options,
  );
}
export type UpdateLocationRecordingUrlMutationRemoteHookResult = ReturnType<typeof useUpdateLocationRecordingUrlMutationRemote>;
export type UpdateLocationRecordingUrlMutationResult = Apollo.MutationResult<RUpdateLocationRecordingUrlMutation>;
export type UpdateLocationRecordingUrlMutationOptions = Apollo.BaseMutationOptions<
  RUpdateLocationRecordingUrlMutation,
  RUpdateLocationRecordingUrlMutationVariables
>;
export const SearchLearningJourneyContentDocument = gql`
  query searchLearningJourneyContent($filter: SearchLearningContentFilter!, $pagination: Pagination!, $spaceIds: [Int!]) {
    searchLearningContent(filter: $filter, pagination: $pagination) {
      data {
        ...LearningContent
      }
      limit
      page
    }
  }
  ${LearningContentFragmentDoc}
`;

/**
 * __useSearchLearningJourneyContentQueryRemote__
 *
 * To run a query within a React component, call `useSearchLearningJourneyContentQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useSearchLearningJourneyContentQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLearningJourneyContentQueryRemote({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      spaceIds: // value for 'spaceIds'
 *   },
 * });
 */
export function useSearchLearningJourneyContentQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RSearchLearningJourneyContentQuery, RSearchLearningJourneyContentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RSearchLearningJourneyContentQuery, RSearchLearningJourneyContentQueryVariables>(
    SearchLearningJourneyContentDocument,
    options,
  );
}
export function useSearchLearningJourneyContentLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RSearchLearningJourneyContentQuery, RSearchLearningJourneyContentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RSearchLearningJourneyContentQuery, RSearchLearningJourneyContentQueryVariables>(
    SearchLearningJourneyContentDocument,
    options,
  );
}
export type SearchLearningJourneyContentQueryRemoteHookResult = ReturnType<typeof useSearchLearningJourneyContentQueryRemote>;
export type SearchLearningJourneyContentLazyQueryRemoteHookResult = ReturnType<
  typeof useSearchLearningJourneyContentLazyQueryRemote
>;
export type SearchLearningJourneyContentQueryResult = Apollo.QueryResult<
  RSearchLearningJourneyContentQuery,
  RSearchLearningJourneyContentQueryVariables
>;
export const DeleteLearningJourneysDocument = gql`
  mutation deleteLearningJourneys($journeyIds: [Int!]!) {
    deleteLearningJourneys(journeyIds: $journeyIds) {
      id
      status
    }
  }
`;
export type RDeleteLearningJourneysMutationFn = Apollo.MutationFunction<
  RDeleteLearningJourneysMutation,
  RDeleteLearningJourneysMutationVariables
>;

/**
 * __useDeleteLearningJourneysMutationRemote__
 *
 * To run a mutation, you first call `useDeleteLearningJourneysMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLearningJourneysMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLearningJourneysMutationRemote, { data, loading, error }] = useDeleteLearningJourneysMutationRemote({
 *   variables: {
 *      journeyIds: // value for 'journeyIds'
 *   },
 * });
 */
export function useDeleteLearningJourneysMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RDeleteLearningJourneysMutation, RDeleteLearningJourneysMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RDeleteLearningJourneysMutation, RDeleteLearningJourneysMutationVariables>(
    DeleteLearningJourneysDocument,
    options,
  );
}
export type DeleteLearningJourneysMutationRemoteHookResult = ReturnType<typeof useDeleteLearningJourneysMutationRemote>;
export type DeleteLearningJourneysMutationResult = Apollo.MutationResult<RDeleteLearningJourneysMutation>;
export type DeleteLearningJourneysMutationOptions = Apollo.BaseMutationOptions<
  RDeleteLearningJourneysMutation,
  RDeleteLearningJourneysMutationVariables
>;
export const GenerateLearningJourneyItemsCsvDocument = gql`
  mutation generateLearningJourneyItemsCSV($input: GenerateLearningJourneyReportCSVInput!) {
    generateLearningJourneyItemsCSV(input: $input) {
      presignedURL
      success
    }
  }
`;
export type RGenerateLearningJourneyItemsCsvMutationFn = Apollo.MutationFunction<
  RGenerateLearningJourneyItemsCsvMutation,
  RGenerateLearningJourneyItemsCsvMutationVariables
>;

/**
 * __useGenerateLearningJourneyItemsCsvMutationRemote__
 *
 * To run a mutation, you first call `useGenerateLearningJourneyItemsCsvMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLearningJourneyItemsCsvMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLearningJourneyItemsCsvMutationRemote, { data, loading, error }] = useGenerateLearningJourneyItemsCsvMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLearningJourneyItemsCsvMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RGenerateLearningJourneyItemsCsvMutation,
    RGenerateLearningJourneyItemsCsvMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RGenerateLearningJourneyItemsCsvMutation, RGenerateLearningJourneyItemsCsvMutationVariables>(
    GenerateLearningJourneyItemsCsvDocument,
    options,
  );
}
export type GenerateLearningJourneyItemsCsvMutationRemoteHookResult = ReturnType<
  typeof useGenerateLearningJourneyItemsCsvMutationRemote
>;
export type GenerateLearningJourneyItemsCsvMutationResult = Apollo.MutationResult<RGenerateLearningJourneyItemsCsvMutation>;
export type GenerateLearningJourneyItemsCsvMutationOptions = Apollo.BaseMutationOptions<
  RGenerateLearningJourneyItemsCsvMutation,
  RGenerateLearningJourneyItemsCsvMutationVariables
>;
export const GenerateLearningJourneyLearnersCsvDocument = gql`
  mutation generateLearningJourneyLearnersCSV($input: GenerateLearningJourneyReportCSVInput!) {
    generateLearningJourneyLearnersCSV(input: $input) {
      presignedURL
      success
    }
  }
`;
export type RGenerateLearningJourneyLearnersCsvMutationFn = Apollo.MutationFunction<
  RGenerateLearningJourneyLearnersCsvMutation,
  RGenerateLearningJourneyLearnersCsvMutationVariables
>;

/**
 * __useGenerateLearningJourneyLearnersCsvMutationRemote__
 *
 * To run a mutation, you first call `useGenerateLearningJourneyLearnersCsvMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLearningJourneyLearnersCsvMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLearningJourneyLearnersCsvMutationRemote, { data, loading, error }] = useGenerateLearningJourneyLearnersCsvMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLearningJourneyLearnersCsvMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RGenerateLearningJourneyLearnersCsvMutation,
    RGenerateLearningJourneyLearnersCsvMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RGenerateLearningJourneyLearnersCsvMutation, RGenerateLearningJourneyLearnersCsvMutationVariables>(
    GenerateLearningJourneyLearnersCsvDocument,
    options,
  );
}
export type GenerateLearningJourneyLearnersCsvMutationRemoteHookResult = ReturnType<
  typeof useGenerateLearningJourneyLearnersCsvMutationRemote
>;
export type GenerateLearningJourneyLearnersCsvMutationResult = Apollo.MutationResult<RGenerateLearningJourneyLearnersCsvMutation>;
export type GenerateLearningJourneyLearnersCsvMutationOptions = Apollo.BaseMutationOptions<
  RGenerateLearningJourneyLearnersCsvMutation,
  RGenerateLearningJourneyLearnersCsvMutationVariables
>;
export const ReportingMyLearningJourneysLearnersTotalCountDocument = gql`
  query reportingMyLearningJourneysLearnersTotalCount(
    $args: reportingMyLearningJourneysLearnersTotalCount_arguments!
    $limit: Int
    $offset: Int
  ) {
    reportingMyLearningJourneysLearnersTotalCount(args: $args, limit: $limit, offset: $offset) {
      total_count
    }
  }
`;

/**
 * __useReportingMyLearningJourneysLearnersTotalCountQueryRemote__
 *
 * To run a query within a React component, call `useReportingMyLearningJourneysLearnersTotalCountQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingMyLearningJourneysLearnersTotalCountQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingMyLearningJourneysLearnersTotalCountQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useReportingMyLearningJourneysLearnersTotalCountQueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RReportingMyLearningJourneysLearnersTotalCountQuery,
    RReportingMyLearningJourneysLearnersTotalCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RReportingMyLearningJourneysLearnersTotalCountQuery,
    RReportingMyLearningJourneysLearnersTotalCountQueryVariables
  >(ReportingMyLearningJourneysLearnersTotalCountDocument, options);
}
export function useReportingMyLearningJourneysLearnersTotalCountLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingMyLearningJourneysLearnersTotalCountQuery,
    RReportingMyLearningJourneysLearnersTotalCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RReportingMyLearningJourneysLearnersTotalCountQuery,
    RReportingMyLearningJourneysLearnersTotalCountQueryVariables
  >(ReportingMyLearningJourneysLearnersTotalCountDocument, options);
}
export type ReportingMyLearningJourneysLearnersTotalCountQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningJourneysLearnersTotalCountQueryRemote
>;
export type ReportingMyLearningJourneysLearnersTotalCountLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningJourneysLearnersTotalCountLazyQueryRemote
>;
export type ReportingMyLearningJourneysLearnersTotalCountQueryResult = Apollo.QueryResult<
  RReportingMyLearningJourneysLearnersTotalCountQuery,
  RReportingMyLearningJourneysLearnersTotalCountQueryVariables
>;
export const ReportingMyLearningJourneysLearnersDocument = gql`
  query reportingMyLearningJourneysLearners(
    $args: reportingMyLearningJourneysLearners_arguments!
    $limit: Int
    $offset: Int
    $order_by: [learning_journey_learners_order_by!]
  ) {
    reportingMyLearningJourneysLearners(args: $args, limit: $limit, offset: $offset, order_by: $order_by) {
      user_id
      username
      email
      profile_image
      join_time
      progress
      is_completed
      completion_time
      last_activity_time
    }
  }
`;

/**
 * __useReportingMyLearningJourneysLearnersQueryRemote__
 *
 * To run a query within a React component, call `useReportingMyLearningJourneysLearnersQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingMyLearningJourneysLearnersQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingMyLearningJourneysLearnersQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useReportingMyLearningJourneysLearnersQueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RReportingMyLearningJourneysLearnersQuery,
    RReportingMyLearningJourneysLearnersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingMyLearningJourneysLearnersQuery, RReportingMyLearningJourneysLearnersQueryVariables>(
    ReportingMyLearningJourneysLearnersDocument,
    options,
  );
}
export function useReportingMyLearningJourneysLearnersLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingMyLearningJourneysLearnersQuery,
    RReportingMyLearningJourneysLearnersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingMyLearningJourneysLearnersQuery, RReportingMyLearningJourneysLearnersQueryVariables>(
    ReportingMyLearningJourneysLearnersDocument,
    options,
  );
}
export type ReportingMyLearningJourneysLearnersQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningJourneysLearnersQueryRemote
>;
export type ReportingMyLearningJourneysLearnersLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningJourneysLearnersLazyQueryRemote
>;
export type ReportingMyLearningJourneysLearnersQueryResult = Apollo.QueryResult<
  RReportingMyLearningJourneysLearnersQuery,
  RReportingMyLearningJourneysLearnersQueryVariables
>;
export const ReportingMyLearningJourneysV2Document = gql`
  query reportingMyLearningJourneysV2(
    $args: reportingMyLearningJourneysV2_arguments!
    $limit: Int
    $offset: Int
    $orderBy: [learning_journeys_v2_order_by!]
  ) {
    reportingMyLearningJourneysV2(args: $args, limit: $limit, offset: $offset, order_by: $orderBy) {
      urn
      title
      status
      space_name
      space_id
      learning_items_count
    }
  }
`;

/**
 * __useReportingMyLearningJourneysV2QueryRemote__
 *
 * To run a query within a React component, call `useReportingMyLearningJourneysV2QueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingMyLearningJourneysV2QueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingMyLearningJourneysV2QueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useReportingMyLearningJourneysV2QueryRemote(
  baseOptions: Apollo.QueryHookOptions<RReportingMyLearningJourneysV2Query, RReportingMyLearningJourneysV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingMyLearningJourneysV2Query, RReportingMyLearningJourneysV2QueryVariables>(
    ReportingMyLearningJourneysV2Document,
    options,
  );
}
export function useReportingMyLearningJourneysV2LazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RReportingMyLearningJourneysV2Query, RReportingMyLearningJourneysV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingMyLearningJourneysV2Query, RReportingMyLearningJourneysV2QueryVariables>(
    ReportingMyLearningJourneysV2Document,
    options,
  );
}
export type ReportingMyLearningJourneysV2QueryRemoteHookResult = ReturnType<typeof useReportingMyLearningJourneysV2QueryRemote>;
export type ReportingMyLearningJourneysV2LazyQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningJourneysV2LazyQueryRemote
>;
export type ReportingMyLearningJourneysV2QueryResult = Apollo.QueryResult<
  RReportingMyLearningJourneysV2Query,
  RReportingMyLearningJourneysV2QueryVariables
>;
export const ReportingMyLearningsLearnersDocument = gql`
  query reportingMyLearningsLearners(
    $args: reportingMyLearningsLearners_arguments!
    $limit: Int
    $offset: Int
    $orderBy: [learners_order_by!]
    $where: learners_bool_exp_bool_exp
  ) {
    reportingMyLearningsLearners(args: $args, limit: $limit, offset: $offset, order_by: $orderBy, where: $where) {
      user_id
      username
      email
      profile_image
      join_time
      progress
      completion_time
      is_completed
      last_activity_time
    }
  }
`;

/**
 * __useReportingMyLearningsLearnersQueryRemote__
 *
 * To run a query within a React component, call `useReportingMyLearningsLearnersQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingMyLearningsLearnersQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingMyLearningsLearnersQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useReportingMyLearningsLearnersQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RReportingMyLearningsLearnersQuery, RReportingMyLearningsLearnersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingMyLearningsLearnersQuery, RReportingMyLearningsLearnersQueryVariables>(
    ReportingMyLearningsLearnersDocument,
    options,
  );
}
export function useReportingMyLearningsLearnersLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RReportingMyLearningsLearnersQuery, RReportingMyLearningsLearnersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingMyLearningsLearnersQuery, RReportingMyLearningsLearnersQueryVariables>(
    ReportingMyLearningsLearnersDocument,
    options,
  );
}
export type ReportingMyLearningsLearnersQueryRemoteHookResult = ReturnType<typeof useReportingMyLearningsLearnersQueryRemote>;
export type ReportingMyLearningsLearnersLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningsLearnersLazyQueryRemote
>;
export type ReportingMyLearningsLearnersQueryResult = Apollo.QueryResult<
  RReportingMyLearningsLearnersQuery,
  RReportingMyLearningsLearnersQueryVariables
>;
export const ReportingMyLiveLearningsLearnersDocument = gql`
  query reportingMyLiveLearningsLearners(
    $args: reportingMyLiveLearningsLearners_arguments!
    $limit: Int
    $offset: Int
    $orderBy: [live_learnings_learners_order_by!]
    $where: live_learnings_learners_bool_exp_bool_exp
  ) {
    reportingMyLiveLearningsLearners(args: $args, limit: $limit, offset: $offset, order_by: $orderBy, where: $where) {
      user_id
      username
      email
      profile_image
      session_time
      attendance
      completion_time
      is_completed
      registration
      location_id
    }
  }
`;

/**
 * __useReportingMyLiveLearningsLearnersQueryRemote__
 *
 * To run a query within a React component, call `useReportingMyLiveLearningsLearnersQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingMyLiveLearningsLearnersQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingMyLiveLearningsLearnersQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useReportingMyLiveLearningsLearnersQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RReportingMyLiveLearningsLearnersQuery, RReportingMyLiveLearningsLearnersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingMyLiveLearningsLearnersQuery, RReportingMyLiveLearningsLearnersQueryVariables>(
    ReportingMyLiveLearningsLearnersDocument,
    options,
  );
}
export function useReportingMyLiveLearningsLearnersLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingMyLiveLearningsLearnersQuery,
    RReportingMyLiveLearningsLearnersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingMyLiveLearningsLearnersQuery, RReportingMyLiveLearningsLearnersQueryVariables>(
    ReportingMyLiveLearningsLearnersDocument,
    options,
  );
}
export type ReportingMyLiveLearningsLearnersQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLiveLearningsLearnersQueryRemote
>;
export type ReportingMyLiveLearningsLearnersLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLiveLearningsLearnersLazyQueryRemote
>;
export type ReportingMyLiveLearningsLearnersQueryResult = Apollo.QueryResult<
  RReportingMyLiveLearningsLearnersQuery,
  RReportingMyLiveLearningsLearnersQueryVariables
>;
export const ReportingMyLearningsLearnersTotalCountDocument = gql`
  query reportingMyLearningsLearnersTotalCount(
    $args: reportingMyLearningsLearnersTotalCount_arguments!
    $limit: Int
    $offset: Int
    $orderBy: [total_count_order_by!]
    $where: total_count_bool_exp_bool_exp
  ) {
    reportingMyLearningsLearnersTotalCount(args: $args, limit: $limit, offset: $offset, order_by: $orderBy, where: $where) {
      space_id
      total_count
    }
  }
`;

/**
 * __useReportingMyLearningsLearnersTotalCountQueryRemote__
 *
 * To run a query within a React component, call `useReportingMyLearningsLearnersTotalCountQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingMyLearningsLearnersTotalCountQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingMyLearningsLearnersTotalCountQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useReportingMyLearningsLearnersTotalCountQueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RReportingMyLearningsLearnersTotalCountQuery,
    RReportingMyLearningsLearnersTotalCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingMyLearningsLearnersTotalCountQuery, RReportingMyLearningsLearnersTotalCountQueryVariables>(
    ReportingMyLearningsLearnersTotalCountDocument,
    options,
  );
}
export function useReportingMyLearningsLearnersTotalCountLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingMyLearningsLearnersTotalCountQuery,
    RReportingMyLearningsLearnersTotalCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingMyLearningsLearnersTotalCountQuery, RReportingMyLearningsLearnersTotalCountQueryVariables>(
    ReportingMyLearningsLearnersTotalCountDocument,
    options,
  );
}
export type ReportingMyLearningsLearnersTotalCountQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningsLearnersTotalCountQueryRemote
>;
export type ReportingMyLearningsLearnersTotalCountLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningsLearnersTotalCountLazyQueryRemote
>;
export type ReportingMyLearningsLearnersTotalCountQueryResult = Apollo.QueryResult<
  RReportingMyLearningsLearnersTotalCountQuery,
  RReportingMyLearningsLearnersTotalCountQueryVariables
>;
export const ReportingMyLiveLearningsLearnersTotalCountDocument = gql`
  query reportingMyLiveLearningsLearnersTotalCount(
    $args: reportingMyLiveLearningsLearnersTotalCount_arguments!
    $limit: Int
    $offset: Int
    $orderBy: [total_count_order_by!]
    $where: total_count_bool_exp_bool_exp
  ) {
    reportingMyLiveLearningsLearnersTotalCount(args: $args, limit: $limit, offset: $offset, order_by: $orderBy, where: $where) {
      space_id
      total_count
    }
  }
`;

/**
 * __useReportingMyLiveLearningsLearnersTotalCountQueryRemote__
 *
 * To run a query within a React component, call `useReportingMyLiveLearningsLearnersTotalCountQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingMyLiveLearningsLearnersTotalCountQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingMyLiveLearningsLearnersTotalCountQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useReportingMyLiveLearningsLearnersTotalCountQueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RReportingMyLiveLearningsLearnersTotalCountQuery,
    RReportingMyLiveLearningsLearnersTotalCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RReportingMyLiveLearningsLearnersTotalCountQuery,
    RReportingMyLiveLearningsLearnersTotalCountQueryVariables
  >(ReportingMyLiveLearningsLearnersTotalCountDocument, options);
}
export function useReportingMyLiveLearningsLearnersTotalCountLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingMyLiveLearningsLearnersTotalCountQuery,
    RReportingMyLiveLearningsLearnersTotalCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RReportingMyLiveLearningsLearnersTotalCountQuery,
    RReportingMyLiveLearningsLearnersTotalCountQueryVariables
  >(ReportingMyLiveLearningsLearnersTotalCountDocument, options);
}
export type ReportingMyLiveLearningsLearnersTotalCountQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLiveLearningsLearnersTotalCountQueryRemote
>;
export type ReportingMyLiveLearningsLearnersTotalCountLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLiveLearningsLearnersTotalCountLazyQueryRemote
>;
export type ReportingMyLiveLearningsLearnersTotalCountQueryResult = Apollo.QueryResult<
  RReportingMyLiveLearningsLearnersTotalCountQuery,
  RReportingMyLiveLearningsLearnersTotalCountQueryVariables
>;
export const ReportingMyLearningJourneysInsightsV2Document = gql`
  query reportingMyLearningJourneysInsightsV2(
    $args: reportingMyLearningJourneysInsightsV2_arguments!
    $limit: Int
    $offset: Int
    $orderBy: [learning_journeys_insights_v2_order_by!]
  ) {
    reportingMyLearningJourneysInsightsV2(args: $args, limit: $limit, offset: $offset, order_by: $orderBy) {
      urn
      average_progress
      learners_count
      completed_count
      completion_rate
    }
  }
`;

/**
 * __useReportingMyLearningJourneysInsightsV2QueryRemote__
 *
 * To run a query within a React component, call `useReportingMyLearningJourneysInsightsV2QueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingMyLearningJourneysInsightsV2QueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingMyLearningJourneysInsightsV2QueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useReportingMyLearningJourneysInsightsV2QueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RReportingMyLearningJourneysInsightsV2Query,
    RReportingMyLearningJourneysInsightsV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingMyLearningJourneysInsightsV2Query, RReportingMyLearningJourneysInsightsV2QueryVariables>(
    ReportingMyLearningJourneysInsightsV2Document,
    options,
  );
}
export function useReportingMyLearningJourneysInsightsV2LazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingMyLearningJourneysInsightsV2Query,
    RReportingMyLearningJourneysInsightsV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingMyLearningJourneysInsightsV2Query, RReportingMyLearningJourneysInsightsV2QueryVariables>(
    ReportingMyLearningJourneysInsightsV2Document,
    options,
  );
}
export type ReportingMyLearningJourneysInsightsV2QueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningJourneysInsightsV2QueryRemote
>;
export type ReportingMyLearningJourneysInsightsV2LazyQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningJourneysInsightsV2LazyQueryRemote
>;
export type ReportingMyLearningJourneysInsightsV2QueryResult = Apollo.QueryResult<
  RReportingMyLearningJourneysInsightsV2Query,
  RReportingMyLearningJourneysInsightsV2QueryVariables
>;
export const ReportingMyLearningJourneysTotalCountDocument = gql`
  query reportingMyLearningJourneysTotalCount($args: reportingMyLearningJourneysTotalCount_arguments!) {
    reportingMyLearningJourneysTotalCount(args: $args) {
      total_count
      space_id
    }
  }
`;

/**
 * __useReportingMyLearningJourneysTotalCountQueryRemote__
 *
 * To run a query within a React component, call `useReportingMyLearningJourneysTotalCountQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingMyLearningJourneysTotalCountQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingMyLearningJourneysTotalCountQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useReportingMyLearningJourneysTotalCountQueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RReportingMyLearningJourneysTotalCountQuery,
    RReportingMyLearningJourneysTotalCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingMyLearningJourneysTotalCountQuery, RReportingMyLearningJourneysTotalCountQueryVariables>(
    ReportingMyLearningJourneysTotalCountDocument,
    options,
  );
}
export function useReportingMyLearningJourneysTotalCountLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RReportingMyLearningJourneysTotalCountQuery,
    RReportingMyLearningJourneysTotalCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingMyLearningJourneysTotalCountQuery, RReportingMyLearningJourneysTotalCountQueryVariables>(
    ReportingMyLearningJourneysTotalCountDocument,
    options,
  );
}
export type ReportingMyLearningJourneysTotalCountQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningJourneysTotalCountQueryRemote
>;
export type ReportingMyLearningJourneysTotalCountLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingMyLearningJourneysTotalCountLazyQueryRemote
>;
export type ReportingMyLearningJourneysTotalCountQueryResult = Apollo.QueryResult<
  RReportingMyLearningJourneysTotalCountQuery,
  RReportingMyLearningJourneysTotalCountQueryVariables
>;
export const LearningJourneyUpcomingEventLocationDocument = gql`
  query learningJourneyUpcomingEventLocation($id: Int!, $spaceIds: [Int!]!) {
    learningJourneyUpcomingEventLocation(journeyId: $id) {
      id
      endDate
      startDate
      type
      address
      recordingURL
      learningContent {
        ...LearningContent
      }
    }
  }
  ${LearningContentFragmentDoc}
`;

/**
 * __useLearningJourneyUpcomingEventLocationQueryRemote__
 *
 * To run a query within a React component, call `useLearningJourneyUpcomingEventLocationQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneyUpcomingEventLocationQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningJourneyUpcomingEventLocationQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *      spaceIds: // value for 'spaceIds'
 *   },
 * });
 */
export function useLearningJourneyUpcomingEventLocationQueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RLearningJourneyUpcomingEventLocationQuery,
    RLearningJourneyUpcomingEventLocationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningJourneyUpcomingEventLocationQuery, RLearningJourneyUpcomingEventLocationQueryVariables>(
    LearningJourneyUpcomingEventLocationDocument,
    options,
  );
}
export function useLearningJourneyUpcomingEventLocationLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RLearningJourneyUpcomingEventLocationQuery,
    RLearningJourneyUpcomingEventLocationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningJourneyUpcomingEventLocationQuery, RLearningJourneyUpcomingEventLocationQueryVariables>(
    LearningJourneyUpcomingEventLocationDocument,
    options,
  );
}
export type LearningJourneyUpcomingEventLocationQueryRemoteHookResult = ReturnType<
  typeof useLearningJourneyUpcomingEventLocationQueryRemote
>;
export type LearningJourneyUpcomingEventLocationLazyQueryRemoteHookResult = ReturnType<
  typeof useLearningJourneyUpcomingEventLocationLazyQueryRemote
>;
export type LearningJourneyUpcomingEventLocationQueryResult = Apollo.QueryResult<
  RLearningJourneyUpcomingEventLocationQuery,
  RLearningJourneyUpcomingEventLocationQueryVariables
>;
export const LearningJourneyUpcomingItemDocument = gql`
  query learningJourneyUpcomingItem(
    $journeyId: Int!
    $userId: Int!
    $afterItemURN: URN
    $spaceIds: [Int!]!
    $includeContentProgress: Boolean!
  ) {
    learningJourneyUpcomingItem(journeyId: $journeyId, userId: $userId, afterItemURN: $afterItemURN) {
      contentId: learningItemURNV2
      content: learningItem {
        ...LearningContent
        ...LearningContentProgress
        locationsWithEnrollment: locations {
          id
          userLocationEnrollment(userIds: [$userId]) {
            id
          }
        }
      }
      isLocked(userId: $userId)
      isOptional
      availabilityType
      availabilityScheduledAt
      availabilityScheduledAtTimezone
    }
  }
  ${LearningContentFragmentDoc}
  ${LearningContentProgressFragmentDoc}
`;

/**
 * __useLearningJourneyUpcomingItemQueryRemote__
 *
 * To run a query within a React component, call `useLearningJourneyUpcomingItemQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneyUpcomingItemQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningJourneyUpcomingItemQueryRemote({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *      userId: // value for 'userId'
 *      afterItemURN: // value for 'afterItemURN'
 *      spaceIds: // value for 'spaceIds'
 *      includeContentProgress: // value for 'includeContentProgress'
 *   },
 * });
 */
export function useLearningJourneyUpcomingItemQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningJourneyUpcomingItemQuery, RLearningJourneyUpcomingItemQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningJourneyUpcomingItemQuery, RLearningJourneyUpcomingItemQueryVariables>(
    LearningJourneyUpcomingItemDocument,
    options,
  );
}
export function useLearningJourneyUpcomingItemLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningJourneyUpcomingItemQuery, RLearningJourneyUpcomingItemQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningJourneyUpcomingItemQuery, RLearningJourneyUpcomingItemQueryVariables>(
    LearningJourneyUpcomingItemDocument,
    options,
  );
}
export type LearningJourneyUpcomingItemQueryRemoteHookResult = ReturnType<typeof useLearningJourneyUpcomingItemQueryRemote>;
export type LearningJourneyUpcomingItemLazyQueryRemoteHookResult = ReturnType<
  typeof useLearningJourneyUpcomingItemLazyQueryRemote
>;
export type LearningJourneyUpcomingItemQueryResult = Apollo.QueryResult<
  RLearningJourneyUpcomingItemQuery,
  RLearningJourneyUpcomingItemQueryVariables
>;
export const LearningJourneyPreviewTeamImportDocument = gql`
  mutation learningJourneyPreviewTeamImport($input: LearningJourneyTeamImportInput!) {
    learningJourneyPreviewTeamImport(input: $input) {
      success
      errorCause {
        code
      }
      data {
        allJourneyLearnersAssigned
        stats {
          total
          ready
          notInJourney
          missingTeam
          invalidEmail
          duplicateInFile
          missingRequiredField
        }
        rows {
          outcome
          row {
            email
            teamName
            sourceLine
          }
        }
        missingLearners {
          email
          fullName
        }
      }
    }
  }
`;
export type RLearningJourneyPreviewTeamImportMutationFn = Apollo.MutationFunction<
  RLearningJourneyPreviewTeamImportMutation,
  RLearningJourneyPreviewTeamImportMutationVariables
>;

/**
 * __useLearningJourneyPreviewTeamImportMutationRemote__
 *
 * To run a mutation, you first call `useLearningJourneyPreviewTeamImportMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneyPreviewTeamImportMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningJourneyPreviewTeamImportMutationRemote, { data, loading, error }] = useLearningJourneyPreviewTeamImportMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLearningJourneyPreviewTeamImportMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RLearningJourneyPreviewTeamImportMutation,
    RLearningJourneyPreviewTeamImportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RLearningJourneyPreviewTeamImportMutation, RLearningJourneyPreviewTeamImportMutationVariables>(
    LearningJourneyPreviewTeamImportDocument,
    options,
  );
}
export type LearningJourneyPreviewTeamImportMutationRemoteHookResult = ReturnType<
  typeof useLearningJourneyPreviewTeamImportMutationRemote
>;
export type LearningJourneyPreviewTeamImportMutationResult = Apollo.MutationResult<RLearningJourneyPreviewTeamImportMutation>;
export type LearningJourneyPreviewTeamImportMutationOptions = Apollo.BaseMutationOptions<
  RLearningJourneyPreviewTeamImportMutation,
  RLearningJourneyPreviewTeamImportMutationVariables
>;
export const LearningJourneyConfirmTeamImportDocument = gql`
  mutation learningJourneyConfirmTeamImport($input: LearningJourneyTeamImportInput!) {
    learningJourneyConfirmTeamImport(input: $input) {
      success
      teamsCreated
      learnersAssigned
    }
  }
`;
export type RLearningJourneyConfirmTeamImportMutationFn = Apollo.MutationFunction<
  RLearningJourneyConfirmTeamImportMutation,
  RLearningJourneyConfirmTeamImportMutationVariables
>;

/**
 * __useLearningJourneyConfirmTeamImportMutationRemote__
 *
 * To run a mutation, you first call `useLearningJourneyConfirmTeamImportMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningJourneyConfirmTeamImportMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningJourneyConfirmTeamImportMutationRemote, { data, loading, error }] = useLearningJourneyConfirmTeamImportMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLearningJourneyConfirmTeamImportMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RLearningJourneyConfirmTeamImportMutation,
    RLearningJourneyConfirmTeamImportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RLearningJourneyConfirmTeamImportMutation, RLearningJourneyConfirmTeamImportMutationVariables>(
    LearningJourneyConfirmTeamImportDocument,
    options,
  );
}
export type LearningJourneyConfirmTeamImportMutationRemoteHookResult = ReturnType<
  typeof useLearningJourneyConfirmTeamImportMutationRemote
>;
export type LearningJourneyConfirmTeamImportMutationResult = Apollo.MutationResult<RLearningJourneyConfirmTeamImportMutation>;
export type LearningJourneyConfirmTeamImportMutationOptions = Apollo.BaseMutationOptions<
  RLearningJourneyConfirmTeamImportMutation,
  RLearningJourneyConfirmTeamImportMutationVariables
>;
export const GetLanguagesDocument = gql`
  query getLanguages {
    getLanguages {
      id
      name
    }
  }
`;

/**
 * __useGetLanguagesQueryRemote__
 *
 * To run a query within a React component, call `useGetLanguagesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useGetLanguagesQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetLanguagesQuery, RGetLanguagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetLanguagesQuery, RGetLanguagesQueryVariables>(GetLanguagesDocument, options);
}
export function useGetLanguagesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetLanguagesQuery, RGetLanguagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetLanguagesQuery, RGetLanguagesQueryVariables>(GetLanguagesDocument, options);
}
export type GetLanguagesQueryRemoteHookResult = ReturnType<typeof useGetLanguagesQueryRemote>;
export type GetLanguagesLazyQueryRemoteHookResult = ReturnType<typeof useGetLanguagesLazyQueryRemote>;
export type GetLanguagesQueryResult = Apollo.QueryResult<RGetLanguagesQuery, RGetLanguagesQueryVariables>;
export const GetProductsDocument = gql`
  query getProducts {
    getProducts {
      ...ProductFragment
    }
  }
  ${ProductFragmentFragmentDoc}
`;

/**
 * __useGetProductsQueryRemote__
 *
 * To run a query within a React component, call `useGetProductsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useGetProductsQueryRemote(baseOptions?: Apollo.QueryHookOptions<RGetProductsQuery, RGetProductsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetProductsQuery, RGetProductsQueryVariables>(GetProductsDocument, options);
}
export function useGetProductsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetProductsQuery, RGetProductsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetProductsQuery, RGetProductsQueryVariables>(GetProductsDocument, options);
}
export type GetProductsQueryRemoteHookResult = ReturnType<typeof useGetProductsQueryRemote>;
export type GetProductsLazyQueryRemoteHookResult = ReturnType<typeof useGetProductsLazyQueryRemote>;
export type GetProductsQueryResult = Apollo.QueryResult<RGetProductsQuery, RGetProductsQueryVariables>;
export const GetProductDocument = gql`
  query getProduct($id: Int!) {
    getProduct(id: $id) {
      ...ProductFragment
      isPending
      productVariantId
      orderId
    }
  }
  ${ProductFragmentFragmentDoc}
`;

/**
 * __useGetProductQueryRemote__
 *
 * To run a query within a React component, call `useGetProductQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQueryRemote(baseOptions: Apollo.QueryHookOptions<RGetProductQuery, RGetProductQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetProductQuery, RGetProductQueryVariables>(GetProductDocument, options);
}
export function useGetProductLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetProductQuery, RGetProductQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetProductQuery, RGetProductQueryVariables>(GetProductDocument, options);
}
export type GetProductQueryRemoteHookResult = ReturnType<typeof useGetProductQueryRemote>;
export type GetProductLazyQueryRemoteHookResult = ReturnType<typeof useGetProductLazyQueryRemote>;
export type GetProductQueryResult = Apollo.QueryResult<RGetProductQuery, RGetProductQueryVariables>;
export const GetVariantsDocument = gql`
  query getVariants($productId: Int!) {
    getVariants(productId: $productId) {
      id
      name
      validTo
      validFrom
      enabled
      meta {
        LOCATION
        METHOD
      }
    }
  }
`;

/**
 * __useGetVariantsQueryRemote__
 *
 * To run a query within a React component, call `useGetVariantsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetVariantsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVariantsQueryRemote({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetVariantsQueryRemote(baseOptions: Apollo.QueryHookOptions<RGetVariantsQuery, RGetVariantsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetVariantsQuery, RGetVariantsQueryVariables>(GetVariantsDocument, options);
}
export function useGetVariantsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetVariantsQuery, RGetVariantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetVariantsQuery, RGetVariantsQueryVariables>(GetVariantsDocument, options);
}
export type GetVariantsQueryRemoteHookResult = ReturnType<typeof useGetVariantsQueryRemote>;
export type GetVariantsLazyQueryRemoteHookResult = ReturnType<typeof useGetVariantsLazyQueryRemote>;
export type GetVariantsQueryResult = Apollo.QueryResult<RGetVariantsQuery, RGetVariantsQueryVariables>;
export const GetParticipantsDocument = gql`
  query getParticipants($productId: Int!, $page: Int, $pageSize: Int, $orderDirection: OrderDirection, $stateIds: [Int]!) {
    getParticipants(
      productId: $productId
      page: $page
      pageSize: $pageSize
      orderDirection: $orderDirection
      stateIds: $stateIds
    ) {
      total
      totalPages
      participants {
        id
        username
        email
        realm
        profileImage
      }
    }
  }
`;

/**
 * __useGetParticipantsQueryRemote__
 *
 * To run a query within a React component, call `useGetParticipantsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantsQueryRemote({
 *   variables: {
 *      productId: // value for 'productId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderDirection: // value for 'orderDirection'
 *      stateIds: // value for 'stateIds'
 *   },
 * });
 */
export function useGetParticipantsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RGetParticipantsQuery, RGetParticipantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetParticipantsQuery, RGetParticipantsQueryVariables>(GetParticipantsDocument, options);
}
export function useGetParticipantsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetParticipantsQuery, RGetParticipantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetParticipantsQuery, RGetParticipantsQueryVariables>(GetParticipantsDocument, options);
}
export type GetParticipantsQueryRemoteHookResult = ReturnType<typeof useGetParticipantsQueryRemote>;
export type GetParticipantsLazyQueryRemoteHookResult = ReturnType<typeof useGetParticipantsLazyQueryRemote>;
export type GetParticipantsQueryResult = Apollo.QueryResult<RGetParticipantsQuery, RGetParticipantsQueryVariables>;
export const PurchaseDocument = gql`
  mutation purchase($products: [PurchaseProduct]!, $note: String) {
    purchase(products: $products, note: $note) {
      orderId
    }
  }
`;
export type RPurchaseMutationFn = Apollo.MutationFunction<RPurchaseMutation, RPurchaseMutationVariables>;

/**
 * __usePurchaseMutationRemote__
 *
 * To run a mutation, you first call `usePurchaseMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseMutationRemote, { data, loading, error }] = usePurchaseMutationRemote({
 *   variables: {
 *      products: // value for 'products'
 *      note: // value for 'note'
 *   },
 * });
 */
export function usePurchaseMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RPurchaseMutation, RPurchaseMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RPurchaseMutation, RPurchaseMutationVariables>(PurchaseDocument, options);
}
export type PurchaseMutationRemoteHookResult = ReturnType<typeof usePurchaseMutationRemote>;
export type PurchaseMutationResult = Apollo.MutationResult<RPurchaseMutation>;
export type PurchaseMutationOptions = Apollo.BaseMutationOptions<RPurchaseMutation, RPurchaseMutationVariables>;
export const SadminPurchaseDocument = gql`
  mutation sadminPurchase($product: SadminPurchaseProduct!, $emails: [String]!) {
    sadminPurchase(product: $product, emails: $emails) {
      result {
        orderId
        email
        message
      }
      success
      message
      code
    }
  }
`;
export type RSadminPurchaseMutationFn = Apollo.MutationFunction<RSadminPurchaseMutation, RSadminPurchaseMutationVariables>;

/**
 * __useSadminPurchaseMutationRemote__
 *
 * To run a mutation, you first call `useSadminPurchaseMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSadminPurchaseMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sadminPurchaseMutationRemote, { data, loading, error }] = useSadminPurchaseMutationRemote({
 *   variables: {
 *      product: // value for 'product'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useSadminPurchaseMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RSadminPurchaseMutation, RSadminPurchaseMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RSadminPurchaseMutation, RSadminPurchaseMutationVariables>(SadminPurchaseDocument, options);
}
export type SadminPurchaseMutationRemoteHookResult = ReturnType<typeof useSadminPurchaseMutationRemote>;
export type SadminPurchaseMutationResult = Apollo.MutationResult<RSadminPurchaseMutation>;
export type SadminPurchaseMutationOptions = Apollo.BaseMutationOptions<RSadminPurchaseMutation, RSadminPurchaseMutationVariables>;
export const CreateOrUpdateDocument = gql`
  mutation createOrUpdate($product: ProductInput!) {
    createOrUpdate(product: $product) {
      id
    }
  }
`;
export type RCreateOrUpdateMutationFn = Apollo.MutationFunction<RCreateOrUpdateMutation, RCreateOrUpdateMutationVariables>;

/**
 * __useCreateOrUpdateMutationRemote__
 *
 * To run a mutation, you first call `useCreateOrUpdateMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateMutationRemote, { data, loading, error }] = useCreateOrUpdateMutationRemote({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useCreateOrUpdateMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCreateOrUpdateMutation, RCreateOrUpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateOrUpdateMutation, RCreateOrUpdateMutationVariables>(CreateOrUpdateDocument, options);
}
export type CreateOrUpdateMutationRemoteHookResult = ReturnType<typeof useCreateOrUpdateMutationRemote>;
export type CreateOrUpdateMutationResult = Apollo.MutationResult<RCreateOrUpdateMutation>;
export type CreateOrUpdateMutationOptions = Apollo.BaseMutationOptions<RCreateOrUpdateMutation, RCreateOrUpdateMutationVariables>;
export const CreateVariantDocument = gql`
  mutation createVariant($productId: Int!, $variant: VariantInput!) {
    createVariant(productId: $productId, variant: $variant) {
      id
    }
  }
`;
export type RCreateVariantMutationFn = Apollo.MutationFunction<RCreateVariantMutation, RCreateVariantMutationVariables>;

/**
 * __useCreateVariantMutationRemote__
 *
 * To run a mutation, you first call `useCreateVariantMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVariantMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVariantMutationRemote, { data, loading, error }] = useCreateVariantMutationRemote({
 *   variables: {
 *      productId: // value for 'productId'
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useCreateVariantMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCreateVariantMutation, RCreateVariantMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateVariantMutation, RCreateVariantMutationVariables>(CreateVariantDocument, options);
}
export type CreateVariantMutationRemoteHookResult = ReturnType<typeof useCreateVariantMutationRemote>;
export type CreateVariantMutationResult = Apollo.MutationResult<RCreateVariantMutation>;
export type CreateVariantMutationOptions = Apollo.BaseMutationOptions<RCreateVariantMutation, RCreateVariantMutationVariables>;
export const UpdateVariantDocument = gql`
  mutation updateVariant($productId: Int!, $variant: VariantInput!) {
    updateVariant(productId: $productId, variant: $variant) {
      id
    }
  }
`;
export type RUpdateVariantMutationFn = Apollo.MutationFunction<RUpdateVariantMutation, RUpdateVariantMutationVariables>;

/**
 * __useUpdateVariantMutationRemote__
 *
 * To run a mutation, you first call `useUpdateVariantMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVariantMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVariantMutationRemote, { data, loading, error }] = useUpdateVariantMutationRemote({
 *   variables: {
 *      productId: // value for 'productId'
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useUpdateVariantMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpdateVariantMutation, RUpdateVariantMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpdateVariantMutation, RUpdateVariantMutationVariables>(UpdateVariantDocument, options);
}
export type UpdateVariantMutationRemoteHookResult = ReturnType<typeof useUpdateVariantMutationRemote>;
export type UpdateVariantMutationResult = Apollo.MutationResult<RUpdateVariantMutation>;
export type UpdateVariantMutationOptions = Apollo.BaseMutationOptions<RUpdateVariantMutation, RUpdateVariantMutationVariables>;
export const RemoveVariantDocument = gql`
  mutation removeVariant($productId: Int!, $variantId: Int!) {
    removeVariant(productId: $productId, variantId: $variantId) {
      value
    }
  }
`;
export type RRemoveVariantMutationFn = Apollo.MutationFunction<RRemoveVariantMutation, RRemoveVariantMutationVariables>;

/**
 * __useRemoveVariantMutationRemote__
 *
 * To run a mutation, you first call `useRemoveVariantMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVariantMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVariantMutationRemote, { data, loading, error }] = useRemoveVariantMutationRemote({
 *   variables: {
 *      productId: // value for 'productId'
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useRemoveVariantMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RRemoveVariantMutation, RRemoveVariantMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RRemoveVariantMutation, RRemoveVariantMutationVariables>(RemoveVariantDocument, options);
}
export type RemoveVariantMutationRemoteHookResult = ReturnType<typeof useRemoveVariantMutationRemote>;
export type RemoveVariantMutationResult = Apollo.MutationResult<RRemoveVariantMutation>;
export type RemoveVariantMutationOptions = Apollo.BaseMutationOptions<RRemoveVariantMutation, RRemoveVariantMutationVariables>;
export const ArticleRedirectDocument = gql`
  query articleRedirect($articleId: Int!) {
    articleRedirect(articleId: $articleId) {
      learningId
      title
    }
  }
`;

/**
 * __useArticleRedirectQueryRemote__
 *
 * To run a query within a React component, call `useArticleRedirectQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useArticleRedirectQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleRedirectQueryRemote({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useArticleRedirectQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RArticleRedirectQuery, RArticleRedirectQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RArticleRedirectQuery, RArticleRedirectQueryVariables>(ArticleRedirectDocument, options);
}
export function useArticleRedirectLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RArticleRedirectQuery, RArticleRedirectQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RArticleRedirectQuery, RArticleRedirectQueryVariables>(ArticleRedirectDocument, options);
}
export type ArticleRedirectQueryRemoteHookResult = ReturnType<typeof useArticleRedirectQueryRemote>;
export type ArticleRedirectLazyQueryRemoteHookResult = ReturnType<typeof useArticleRedirectLazyQueryRemote>;
export type ArticleRedirectQueryResult = Apollo.QueryResult<RArticleRedirectQuery, RArticleRedirectQueryVariables>;
export const LearningContentByIdsDocument = gql`
  query learningContentByIds($contentURNs: [URN!]!, $spaceIds: [Int!]!) {
    learningContentByIds(input: $contentURNs, pagination: { limit: -1, page: 1 }) {
      ...LearningContentById
    }
  }
  ${LearningContentByIdFragmentDoc}
`;

/**
 * __useLearningContentByIdsQueryRemote__
 *
 * To run a query within a React component, call `useLearningContentByIdsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningContentByIdsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningContentByIdsQueryRemote({
 *   variables: {
 *      contentURNs: // value for 'contentURNs'
 *      spaceIds: // value for 'spaceIds'
 *   },
 * });
 */
export function useLearningContentByIdsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningContentByIdsQuery, RLearningContentByIdsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningContentByIdsQuery, RLearningContentByIdsQueryVariables>(LearningContentByIdsDocument, options);
}
export function useLearningContentByIdsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningContentByIdsQuery, RLearningContentByIdsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningContentByIdsQuery, RLearningContentByIdsQueryVariables>(
    LearningContentByIdsDocument,
    options,
  );
}
export type LearningContentByIdsQueryRemoteHookResult = ReturnType<typeof useLearningContentByIdsQueryRemote>;
export type LearningContentByIdsLazyQueryRemoteHookResult = ReturnType<typeof useLearningContentByIdsLazyQueryRemote>;
export type LearningContentByIdsQueryResult = Apollo.QueryResult<RLearningContentByIdsQuery, RLearningContentByIdsQueryVariables>;
export const LearningContentByIdV1Document = gql`
  query learningContentByIdV1($urn: String!, $spaceIds: [Int!]!) {
    learningContentByIdV1(urnV1: $urn) {
      ...LearningContentById
    }
  }
  ${LearningContentByIdFragmentDoc}
`;

/**
 * __useLearningContentByIdV1QueryRemote__
 *
 * To run a query within a React component, call `useLearningContentByIdV1QueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningContentByIdV1QueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningContentByIdV1QueryRemote({
 *   variables: {
 *      urn: // value for 'urn'
 *      spaceIds: // value for 'spaceIds'
 *   },
 * });
 */
export function useLearningContentByIdV1QueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningContentByIdV1Query, RLearningContentByIdV1QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningContentByIdV1Query, RLearningContentByIdV1QueryVariables>(
    LearningContentByIdV1Document,
    options,
  );
}
export function useLearningContentByIdV1LazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningContentByIdV1Query, RLearningContentByIdV1QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningContentByIdV1Query, RLearningContentByIdV1QueryVariables>(
    LearningContentByIdV1Document,
    options,
  );
}
export type LearningContentByIdV1QueryRemoteHookResult = ReturnType<typeof useLearningContentByIdV1QueryRemote>;
export type LearningContentByIdV1LazyQueryRemoteHookResult = ReturnType<typeof useLearningContentByIdV1LazyQueryRemote>;
export type LearningContentByIdV1QueryResult = Apollo.QueryResult<
  RLearningContentByIdV1Query,
  RLearningContentByIdV1QueryVariables
>;
export const GenerateLiveLearningItemLearnersCsvDocument = gql`
  mutation generateLiveLearningItemLearnersCSV($input: GenerateLearningReportCSVInput!) {
    generateLiveLearningItemLearnersCSV(input: $input) {
      presignedURL
      success
    }
  }
`;
export type RGenerateLiveLearningItemLearnersCsvMutationFn = Apollo.MutationFunction<
  RGenerateLiveLearningItemLearnersCsvMutation,
  RGenerateLiveLearningItemLearnersCsvMutationVariables
>;

/**
 * __useGenerateLiveLearningItemLearnersCsvMutationRemote__
 *
 * To run a mutation, you first call `useGenerateLiveLearningItemLearnersCsvMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLiveLearningItemLearnersCsvMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLiveLearningItemLearnersCsvMutationRemote, { data, loading, error }] = useGenerateLiveLearningItemLearnersCsvMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLiveLearningItemLearnersCsvMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RGenerateLiveLearningItemLearnersCsvMutation,
    RGenerateLiveLearningItemLearnersCsvMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RGenerateLiveLearningItemLearnersCsvMutation, RGenerateLiveLearningItemLearnersCsvMutationVariables>(
    GenerateLiveLearningItemLearnersCsvDocument,
    options,
  );
}
export type GenerateLiveLearningItemLearnersCsvMutationRemoteHookResult = ReturnType<
  typeof useGenerateLiveLearningItemLearnersCsvMutationRemote
>;
export type GenerateLiveLearningItemLearnersCsvMutationResult =
  Apollo.MutationResult<RGenerateLiveLearningItemLearnersCsvMutation>;
export type GenerateLiveLearningItemLearnersCsvMutationOptions = Apollo.BaseMutationOptions<
  RGenerateLiveLearningItemLearnersCsvMutation,
  RGenerateLiveLearningItemLearnersCsvMutationVariables
>;
export const GenerateLearningItemLearnersCsvDocument = gql`
  mutation generateLearningItemLearnersCSV($input: GenerateLearningReportCSVInput!) {
    generateLearningItemLearnersCSV(input: $input) {
      presignedURL
      success
    }
  }
`;
export type RGenerateLearningItemLearnersCsvMutationFn = Apollo.MutationFunction<
  RGenerateLearningItemLearnersCsvMutation,
  RGenerateLearningItemLearnersCsvMutationVariables
>;

/**
 * __useGenerateLearningItemLearnersCsvMutationRemote__
 *
 * To run a mutation, you first call `useGenerateLearningItemLearnersCsvMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLearningItemLearnersCsvMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLearningItemLearnersCsvMutationRemote, { data, loading, error }] = useGenerateLearningItemLearnersCsvMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLearningItemLearnersCsvMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RGenerateLearningItemLearnersCsvMutation,
    RGenerateLearningItemLearnersCsvMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RGenerateLearningItemLearnersCsvMutation, RGenerateLearningItemLearnersCsvMutationVariables>(
    GenerateLearningItemLearnersCsvDocument,
    options,
  );
}
export type GenerateLearningItemLearnersCsvMutationRemoteHookResult = ReturnType<
  typeof useGenerateLearningItemLearnersCsvMutationRemote
>;
export type GenerateLearningItemLearnersCsvMutationResult = Apollo.MutationResult<RGenerateLearningItemLearnersCsvMutation>;
export type GenerateLearningItemLearnersCsvMutationOptions = Apollo.BaseMutationOptions<
  RGenerateLearningItemLearnersCsvMutation,
  RGenerateLearningItemLearnersCsvMutationVariables
>;
export const GenerateSectionItemsCsvDocument = gql`
  mutation generateSectionItemsCSV($input: GenerateLearningReportCSVInput!) {
    generateSectionItemsCSV(input: $input) {
      presignedURL
      success
    }
  }
`;
export type RGenerateSectionItemsCsvMutationFn = Apollo.MutationFunction<
  RGenerateSectionItemsCsvMutation,
  RGenerateSectionItemsCsvMutationVariables
>;

/**
 * __useGenerateSectionItemsCsvMutationRemote__
 *
 * To run a mutation, you first call `useGenerateSectionItemsCsvMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSectionItemsCsvMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSectionItemsCsvMutationRemote, { data, loading, error }] = useGenerateSectionItemsCsvMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSectionItemsCsvMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RGenerateSectionItemsCsvMutation, RGenerateSectionItemsCsvMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RGenerateSectionItemsCsvMutation, RGenerateSectionItemsCsvMutationVariables>(
    GenerateSectionItemsCsvDocument,
    options,
  );
}
export type GenerateSectionItemsCsvMutationRemoteHookResult = ReturnType<typeof useGenerateSectionItemsCsvMutationRemote>;
export type GenerateSectionItemsCsvMutationResult = Apollo.MutationResult<RGenerateSectionItemsCsvMutation>;
export type GenerateSectionItemsCsvMutationOptions = Apollo.BaseMutationOptions<
  RGenerateSectionItemsCsvMutation,
  RGenerateSectionItemsCsvMutationVariables
>;
export const LearningContentByIdsV1Document = gql`
  query learningContentByIdsV1($contentURNs: [String!]!, $spaceIds: [Int!]!) {
    learningContentByIdsV1(input: $contentURNs) {
      ...LearningContentById
    }
  }
  ${LearningContentByIdFragmentDoc}
`;

/**
 * __useLearningContentByIdsV1QueryRemote__
 *
 * To run a query within a React component, call `useLearningContentByIdsV1QueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningContentByIdsV1QueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningContentByIdsV1QueryRemote({
 *   variables: {
 *      contentURNs: // value for 'contentURNs'
 *      spaceIds: // value for 'spaceIds'
 *   },
 * });
 */
export function useLearningContentByIdsV1QueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningContentByIdsV1Query, RLearningContentByIdsV1QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningContentByIdsV1Query, RLearningContentByIdsV1QueryVariables>(
    LearningContentByIdsV1Document,
    options,
  );
}
export function useLearningContentByIdsV1LazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningContentByIdsV1Query, RLearningContentByIdsV1QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningContentByIdsV1Query, RLearningContentByIdsV1QueryVariables>(
    LearningContentByIdsV1Document,
    options,
  );
}
export type LearningContentByIdsV1QueryRemoteHookResult = ReturnType<typeof useLearningContentByIdsV1QueryRemote>;
export type LearningContentByIdsV1LazyQueryRemoteHookResult = ReturnType<typeof useLearningContentByIdsV1LazyQueryRemote>;
export type LearningContentByIdsV1QueryResult = Apollo.QueryResult<
  RLearningContentByIdsV1Query,
  RLearningContentByIdsV1QueryVariables
>;
export const LearningLoopsDocument = gql`
  query learningLoops($assignmentId: Int!, $userId: Int!, $pagination: Pagination) {
    learningLoops(filter: { assignmentId: $assignmentId, userId: $userId }, pagination: $pagination) {
      data {
        id
        assignmentId
        userId
        estimatedEffort
        startAt
        endAt
        isActive
        createdAt
        updatedAt
        canReflect
        recommendedEffort
        activitiesAggregated {
          participation {
            id
            objectId
            catalogObjectId
            completedAt
            endAt
            expiryAt
            isCompleted
            plannedDuration
            userId
            userEffort
          }
        }
        reflection {
          id
          learningLoopId
          description
          applied
          createdAt
          updatedAt
        }
      }
      limit
      page
      total
    }
  }
`;

/**
 * __useLearningLoopsQueryRemote__
 *
 * To run a query within a React component, call `useLearningLoopsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningLoopsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningLoopsQueryRemote({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      userId: // value for 'userId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useLearningLoopsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningLoopsQuery, RLearningLoopsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningLoopsQuery, RLearningLoopsQueryVariables>(LearningLoopsDocument, options);
}
export function useLearningLoopsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningLoopsQuery, RLearningLoopsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningLoopsQuery, RLearningLoopsQueryVariables>(LearningLoopsDocument, options);
}
export type LearningLoopsQueryRemoteHookResult = ReturnType<typeof useLearningLoopsQueryRemote>;
export type LearningLoopsLazyQueryRemoteHookResult = ReturnType<typeof useLearningLoopsLazyQueryRemote>;
export type LearningLoopsQueryResult = Apollo.QueryResult<RLearningLoopsQuery, RLearningLoopsQueryVariables>;
export const LearningLoopSelfTrackedLearningAddDocument = gql`
  mutation learningLoopSelfTrackedLearningAdd($input: AddSelfTrackedLearningToLearningLoopInput!) {
    addSelfTrackedLearningToLearningLoop(input: $input) {
      success
    }
  }
`;
export type RLearningLoopSelfTrackedLearningAddMutationFn = Apollo.MutationFunction<
  RLearningLoopSelfTrackedLearningAddMutation,
  RLearningLoopSelfTrackedLearningAddMutationVariables
>;

/**
 * __useLearningLoopSelfTrackedLearningAddMutationRemote__
 *
 * To run a mutation, you first call `useLearningLoopSelfTrackedLearningAddMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningLoopSelfTrackedLearningAddMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningLoopSelfTrackedLearningAddMutationRemote, { data, loading, error }] = useLearningLoopSelfTrackedLearningAddMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLearningLoopSelfTrackedLearningAddMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RLearningLoopSelfTrackedLearningAddMutation,
    RLearningLoopSelfTrackedLearningAddMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RLearningLoopSelfTrackedLearningAddMutation, RLearningLoopSelfTrackedLearningAddMutationVariables>(
    LearningLoopSelfTrackedLearningAddDocument,
    options,
  );
}
export type LearningLoopSelfTrackedLearningAddMutationRemoteHookResult = ReturnType<
  typeof useLearningLoopSelfTrackedLearningAddMutationRemote
>;
export type LearningLoopSelfTrackedLearningAddMutationResult = Apollo.MutationResult<RLearningLoopSelfTrackedLearningAddMutation>;
export type LearningLoopSelfTrackedLearningAddMutationOptions = Apollo.BaseMutationOptions<
  RLearningLoopSelfTrackedLearningAddMutation,
  RLearningLoopSelfTrackedLearningAddMutationVariables
>;
export const CreateLearningLoopReflectionDocument = gql`
  mutation createLearningLoopReflection($input: CreateLearningLoopReflectionInput!) {
    createLearningLoopReflection(input: $input) {
      learningLoop {
        id
        learningLoopId
        description
        applied
        createdAt
        updatedAt
      }
      success
    }
  }
`;
export type RCreateLearningLoopReflectionMutationFn = Apollo.MutationFunction<
  RCreateLearningLoopReflectionMutation,
  RCreateLearningLoopReflectionMutationVariables
>;

/**
 * __useCreateLearningLoopReflectionMutationRemote__
 *
 * To run a mutation, you first call `useCreateLearningLoopReflectionMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningLoopReflectionMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningLoopReflectionMutationRemote, { data, loading, error }] = useCreateLearningLoopReflectionMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearningLoopReflectionMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCreateLearningLoopReflectionMutation, RCreateLearningLoopReflectionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateLearningLoopReflectionMutation, RCreateLearningLoopReflectionMutationVariables>(
    CreateLearningLoopReflectionDocument,
    options,
  );
}
export type CreateLearningLoopReflectionMutationRemoteHookResult = ReturnType<
  typeof useCreateLearningLoopReflectionMutationRemote
>;
export type CreateLearningLoopReflectionMutationResult = Apollo.MutationResult<RCreateLearningLoopReflectionMutation>;
export type CreateLearningLoopReflectionMutationOptions = Apollo.BaseMutationOptions<
  RCreateLearningLoopReflectionMutation,
  RCreateLearningLoopReflectionMutationVariables
>;
export const SaveLearningEditorDocument = gql`
  mutation saveLearningEditor($input: LearningInput!) {
    saveLearning(payload: $input) {
      id
    }
  }
`;
export type RSaveLearningEditorMutationFn = Apollo.MutationFunction<
  RSaveLearningEditorMutation,
  RSaveLearningEditorMutationVariables
>;

/**
 * __useSaveLearningEditorMutationRemote__
 *
 * To run a mutation, you first call `useSaveLearningEditorMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLearningEditorMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLearningEditorMutationRemote, { data, loading, error }] = useSaveLearningEditorMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLearningEditorMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RSaveLearningEditorMutation, RSaveLearningEditorMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RSaveLearningEditorMutation, RSaveLearningEditorMutationVariables>(
    SaveLearningEditorDocument,
    options,
  );
}
export type SaveLearningEditorMutationRemoteHookResult = ReturnType<typeof useSaveLearningEditorMutationRemote>;
export type SaveLearningEditorMutationResult = Apollo.MutationResult<RSaveLearningEditorMutation>;
export type SaveLearningEditorMutationOptions = Apollo.BaseMutationOptions<
  RSaveLearningEditorMutation,
  RSaveLearningEditorMutationVariables
>;
export const LearningDocument = gql`
  query Learning($id: ID!) {
    learning(id: $id) {
      ...LearningBaseFragment
      progress {
        completed
        completedPercentage
        historical
        expiredAt
      }
      contentOwner
      canEdit
      subjects {
        subjectId
        subject
        categoryId
        category
      }
      locations {
        id
        startDate
        endDate
        address
        room
        capacity
        waitlistType
        myEnrollment {
          id
          attended
        }
        stats {
          isFinished
          enrolledCount
          waitlistedCount
          attendedCount
          notAttendedCount
        }
      }
      modules {
        id
        created
        updated
        learningId
        type
        name
        order
        pages {
          id
          created
          updated
          moduleId
          type
          name
          order
          blocks {
            id
            created
            updated
            pageId
            order
            type
            data
          }
        }
      }
    }
  }
  ${LearningBaseFragmentFragmentDoc}
`;

/**
 * __useLearningQueryRemote__
 *
 * To run a query within a React component, call `useLearningQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningQueryRemote(baseOptions: Apollo.QueryHookOptions<RLearningQuery, RLearningQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningQuery, RLearningQueryVariables>(LearningDocument, options);
}
export function useLearningLazyQueryRemote(baseOptions?: Apollo.LazyQueryHookOptions<RLearningQuery, RLearningQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningQuery, RLearningQueryVariables>(LearningDocument, options);
}
export type LearningQueryRemoteHookResult = ReturnType<typeof useLearningQueryRemote>;
export type LearningLazyQueryRemoteHookResult = ReturnType<typeof useLearningLazyQueryRemote>;
export type LearningQueryResult = Apollo.QueryResult<RLearningQuery, RLearningQueryVariables>;
export const ArchiveLearningDocument = gql`
  mutation archiveLearning($learningId: Int!) {
    archiveLearning(learningId: $learningId) {
      id
    }
  }
`;
export type RArchiveLearningMutationFn = Apollo.MutationFunction<RArchiveLearningMutation, RArchiveLearningMutationVariables>;

/**
 * __useArchiveLearningMutationRemote__
 *
 * To run a mutation, you first call `useArchiveLearningMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveLearningMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveLearningMutationRemote, { data, loading, error }] = useArchiveLearningMutationRemote({
 *   variables: {
 *      learningId: // value for 'learningId'
 *   },
 * });
 */
export function useArchiveLearningMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RArchiveLearningMutation, RArchiveLearningMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RArchiveLearningMutation, RArchiveLearningMutationVariables>(ArchiveLearningDocument, options);
}
export type ArchiveLearningMutationRemoteHookResult = ReturnType<typeof useArchiveLearningMutationRemote>;
export type ArchiveLearningMutationResult = Apollo.MutationResult<RArchiveLearningMutation>;
export type ArchiveLearningMutationOptions = Apollo.BaseMutationOptions<
  RArchiveLearningMutation,
  RArchiveLearningMutationVariables
>;
export const RestoreLearningDocument = gql`
  mutation restoreLearning($learningId: Int!) {
    restoreLearning(learningId: $learningId) {
      id
    }
  }
`;
export type RRestoreLearningMutationFn = Apollo.MutationFunction<RRestoreLearningMutation, RRestoreLearningMutationVariables>;

/**
 * __useRestoreLearningMutationRemote__
 *
 * To run a mutation, you first call `useRestoreLearningMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreLearningMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreLearningMutationRemote, { data, loading, error }] = useRestoreLearningMutationRemote({
 *   variables: {
 *      learningId: // value for 'learningId'
 *   },
 * });
 */
export function useRestoreLearningMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RRestoreLearningMutation, RRestoreLearningMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RRestoreLearningMutation, RRestoreLearningMutationVariables>(RestoreLearningDocument, options);
}
export type RestoreLearningMutationRemoteHookResult = ReturnType<typeof useRestoreLearningMutationRemote>;
export type RestoreLearningMutationResult = Apollo.MutationResult<RRestoreLearningMutation>;
export type RestoreLearningMutationOptions = Apollo.BaseMutationOptions<
  RRestoreLearningMutation,
  RRestoreLearningMutationVariables
>;
export const LearningsPinnedDocument = gql`
  query learningsPinned($realm: String!) {
    learningsPinned(realm: $realm) {
      ...LearningPinnedFragment
    }
  }
  ${LearningPinnedFragmentFragmentDoc}
`;

/**
 * __useLearningsPinnedQueryRemote__
 *
 * To run a query within a React component, call `useLearningsPinnedQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningsPinnedQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningsPinnedQueryRemote({
 *   variables: {
 *      realm: // value for 'realm'
 *   },
 * });
 */
export function useLearningsPinnedQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningsPinnedQuery, RLearningsPinnedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningsPinnedQuery, RLearningsPinnedQueryVariables>(LearningsPinnedDocument, options);
}
export function useLearningsPinnedLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningsPinnedQuery, RLearningsPinnedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningsPinnedQuery, RLearningsPinnedQueryVariables>(LearningsPinnedDocument, options);
}
export type LearningsPinnedQueryRemoteHookResult = ReturnType<typeof useLearningsPinnedQueryRemote>;
export type LearningsPinnedLazyQueryRemoteHookResult = ReturnType<typeof useLearningsPinnedLazyQueryRemote>;
export type LearningsPinnedQueryResult = Apollo.QueryResult<RLearningsPinnedQuery, RLearningsPinnedQueryVariables>;
export const LearningPinnedUpdateDocument = gql`
  mutation learningPinnedUpdate($realm: String!, $input: [LearningPinnedUpdateInput!]!) {
    learningPinnedUpdate(realm: $realm, input: $input) {
      ...LearningPinnedFragment
    }
  }
  ${LearningPinnedFragmentFragmentDoc}
`;
export type RLearningPinnedUpdateMutationFn = Apollo.MutationFunction<
  RLearningPinnedUpdateMutation,
  RLearningPinnedUpdateMutationVariables
>;

/**
 * __useLearningPinnedUpdateMutationRemote__
 *
 * To run a mutation, you first call `useLearningPinnedUpdateMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPinnedUpdateMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPinnedUpdateMutationRemote, { data, loading, error }] = useLearningPinnedUpdateMutationRemote({
 *   variables: {
 *      realm: // value for 'realm'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLearningPinnedUpdateMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RLearningPinnedUpdateMutation, RLearningPinnedUpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RLearningPinnedUpdateMutation, RLearningPinnedUpdateMutationVariables>(
    LearningPinnedUpdateDocument,
    options,
  );
}
export type LearningPinnedUpdateMutationRemoteHookResult = ReturnType<typeof useLearningPinnedUpdateMutationRemote>;
export type LearningPinnedUpdateMutationResult = Apollo.MutationResult<RLearningPinnedUpdateMutation>;
export type LearningPinnedUpdateMutationOptions = Apollo.BaseMutationOptions<
  RLearningPinnedUpdateMutation,
  RLearningPinnedUpdateMutationVariables
>;
export const LearningByIdDocument = gql`
  query learningById($id: ID!, $includeProgress: Boolean!, $includeLocations: Boolean!) {
    learning(id: $id) {
      ...LearningFragment
      modules {
        ...LearningModulesDeepFragment
      }
      progress @include(if: $includeProgress) {
        ...LearningProgressFragment
      }
      locations @include(if: $includeLocations) {
        ...LocationsFragment
      }
    }
  }
  ${LearningFragmentFragmentDoc}
  ${LearningModulesDeepFragmentFragmentDoc}
  ${LearningProgressFragmentFragmentDoc}
  ${LocationsFragmentFragmentDoc}
`;

/**
 * __useLearningByIdQueryRemote__
 *
 * To run a query within a React component, call `useLearningByIdQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningByIdQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningByIdQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *      includeProgress: // value for 'includeProgress'
 *      includeLocations: // value for 'includeLocations'
 *   },
 * });
 */
export function useLearningByIdQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningByIdQuery, RLearningByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningByIdQuery, RLearningByIdQueryVariables>(LearningByIdDocument, options);
}
export function useLearningByIdLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningByIdQuery, RLearningByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningByIdQuery, RLearningByIdQueryVariables>(LearningByIdDocument, options);
}
export type LearningByIdQueryRemoteHookResult = ReturnType<typeof useLearningByIdQueryRemote>;
export type LearningByIdLazyQueryRemoteHookResult = ReturnType<typeof useLearningByIdLazyQueryRemote>;
export type LearningByIdQueryResult = Apollo.QueryResult<RLearningByIdQuery, RLearningByIdQueryVariables>;
export const LearningV2ByIdDocument = gql`
  query learningV2ById($id: Int!, $userId: Int!) {
    learningV2(id: $id) {
      ...LearningV2Fragment
      activities {
        ...ActivityFragment
      }
      userLastParticipation(userId: $userId) {
        id
        expiryAt
        isCompleted
        progress
        plannedDuration
        userEffort
      }
      updateByUser {
        id
        firstname
        lastname
      }
    }
  }
  ${LearningV2FragmentFragmentDoc}
  ${ActivityFragmentFragmentDoc}
`;

/**
 * __useLearningV2ByIdQueryRemote__
 *
 * To run a query within a React component, call `useLearningV2ByIdQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningV2ByIdQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningV2ByIdQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLearningV2ByIdQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningV2ByIdQuery, RLearningV2ByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningV2ByIdQuery, RLearningV2ByIdQueryVariables>(LearningV2ByIdDocument, options);
}
export function useLearningV2ByIdLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningV2ByIdQuery, RLearningV2ByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningV2ByIdQuery, RLearningV2ByIdQueryVariables>(LearningV2ByIdDocument, options);
}
export type LearningV2ByIdQueryRemoteHookResult = ReturnType<typeof useLearningV2ByIdQueryRemote>;
export type LearningV2ByIdLazyQueryRemoteHookResult = ReturnType<typeof useLearningV2ByIdLazyQueryRemote>;
export type LearningV2ByIdQueryResult = Apollo.QueryResult<RLearningV2ByIdQuery, RLearningV2ByIdQueryVariables>;
export const SaveLearningDocument = gql`
  mutation saveLearning($input: LearningInput!) {
    saveLearning(payload: $input) {
      id
      title
      image
    }
  }
`;
export type RSaveLearningMutationFn = Apollo.MutationFunction<RSaveLearningMutation, RSaveLearningMutationVariables>;

/**
 * __useSaveLearningMutationRemote__
 *
 * To run a mutation, you first call `useSaveLearningMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLearningMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLearningMutationRemote, { data, loading, error }] = useSaveLearningMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLearningMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RSaveLearningMutation, RSaveLearningMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RSaveLearningMutation, RSaveLearningMutationVariables>(SaveLearningDocument, options);
}
export type SaveLearningMutationRemoteHookResult = ReturnType<typeof useSaveLearningMutationRemote>;
export type SaveLearningMutationResult = Apollo.MutationResult<RSaveLearningMutation>;
export type SaveLearningMutationOptions = Apollo.BaseMutationOptions<RSaveLearningMutation, RSaveLearningMutationVariables>;
export const UpsertLearningDocument = gql`
  mutation upsertLearning($input: UpsertLearningInput!) {
    upsertLearning(input: $input) {
      id
      title
      image
      urn
      activities {
        ...ActivityFragment
      }
    }
  }
  ${ActivityFragmentFragmentDoc}
`;
export type RUpsertLearningMutationFn = Apollo.MutationFunction<RUpsertLearningMutation, RUpsertLearningMutationVariables>;

/**
 * __useUpsertLearningMutationRemote__
 *
 * To run a mutation, you first call `useUpsertLearningMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLearningMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLearningMutationRemote, { data, loading, error }] = useUpsertLearningMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertLearningMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpsertLearningMutation, RUpsertLearningMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpsertLearningMutation, RUpsertLearningMutationVariables>(UpsertLearningDocument, options);
}
export type UpsertLearningMutationRemoteHookResult = ReturnType<typeof useUpsertLearningMutationRemote>;
export type UpsertLearningMutationResult = Apollo.MutationResult<RUpsertLearningMutation>;
export type UpsertLearningMutationOptions = Apollo.BaseMutationOptions<RUpsertLearningMutation, RUpsertLearningMutationVariables>;
export const DeleteLearningDocument = gql`
  mutation deleteLearning($learningId: Int!) {
    deleteLearning(learningId: $learningId) {
      id
    }
  }
`;
export type RDeleteLearningMutationFn = Apollo.MutationFunction<RDeleteLearningMutation, RDeleteLearningMutationVariables>;

/**
 * __useDeleteLearningMutationRemote__
 *
 * To run a mutation, you first call `useDeleteLearningMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLearningMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLearningMutationRemote, { data, loading, error }] = useDeleteLearningMutationRemote({
 *   variables: {
 *      learningId: // value for 'learningId'
 *   },
 * });
 */
export function useDeleteLearningMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RDeleteLearningMutation, RDeleteLearningMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RDeleteLearningMutation, RDeleteLearningMutationVariables>(DeleteLearningDocument, options);
}
export type DeleteLearningMutationRemoteHookResult = ReturnType<typeof useDeleteLearningMutationRemote>;
export type DeleteLearningMutationResult = Apollo.MutationResult<RDeleteLearningMutation>;
export type DeleteLearningMutationOptions = Apollo.BaseMutationOptions<RDeleteLearningMutation, RDeleteLearningMutationVariables>;
export const LearningTypeByIdDocument = gql`
  query learningTypeById($id: ID!) {
    learning(id: $id) {
      id
      type
    }
  }
`;

/**
 * __useLearningTypeByIdQueryRemote__
 *
 * To run a query within a React component, call `useLearningTypeByIdQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningTypeByIdQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningTypeByIdQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningTypeByIdQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningTypeByIdQuery, RLearningTypeByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningTypeByIdQuery, RLearningTypeByIdQueryVariables>(LearningTypeByIdDocument, options);
}
export function useLearningTypeByIdLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningTypeByIdQuery, RLearningTypeByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningTypeByIdQuery, RLearningTypeByIdQueryVariables>(LearningTypeByIdDocument, options);
}
export type LearningTypeByIdQueryRemoteHookResult = ReturnType<typeof useLearningTypeByIdQueryRemote>;
export type LearningTypeByIdLazyQueryRemoteHookResult = ReturnType<typeof useLearningTypeByIdLazyQueryRemote>;
export type LearningTypeByIdQueryResult = Apollo.QueryResult<RLearningTypeByIdQuery, RLearningTypeByIdQueryVariables>;
export const LearningParentsByIdDocument = gql`
  query learningParentsById($id: ID!, $filter: LearningParentsFilter!, $userId: Int!) {
    learning(id: $id) {
      id
      urnV2
      parents(filter: $filter) {
        id
        title
        userLastParticipation(userId: $userId) {
          id
        }
      }
    }
  }
`;

/**
 * __useLearningParentsByIdQueryRemote__
 *
 * To run a query within a React component, call `useLearningParentsByIdQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useLearningParentsByIdQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningParentsByIdQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLearningParentsByIdQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RLearningParentsByIdQuery, RLearningParentsByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RLearningParentsByIdQuery, RLearningParentsByIdQueryVariables>(LearningParentsByIdDocument, options);
}
export function useLearningParentsByIdLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RLearningParentsByIdQuery, RLearningParentsByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RLearningParentsByIdQuery, RLearningParentsByIdQueryVariables>(LearningParentsByIdDocument, options);
}
export type LearningParentsByIdQueryRemoteHookResult = ReturnType<typeof useLearningParentsByIdQueryRemote>;
export type LearningParentsByIdLazyQueryRemoteHookResult = ReturnType<typeof useLearningParentsByIdLazyQueryRemote>;
export type LearningParentsByIdQueryResult = Apollo.QueryResult<RLearningParentsByIdQuery, RLearningParentsByIdQueryVariables>;
export const FindLearningJourneyItemDocument = gql`
  query findLearningJourneyItem($filter: FindLearningJourneyItemFilter!) {
    findLearningJourneyItem(filter: $filter) {
      ... on LearningJourneyItem {
        id
        learningItemURNV2
        journeyId
        breadcrumbs {
          urn
          content {
            id
            title
          }
        }
      }
      ... on LearningSectionItem {
        id
        learningItemURNV2
        learningId
        breadcrumbs {
          urn
          content {
            id
            title
          }
        }
      }
    }
  }
`;

/**
 * __useFindLearningJourneyItemQueryRemote__
 *
 * To run a query within a React component, call `useFindLearningJourneyItemQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useFindLearningJourneyItemQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLearningJourneyItemQueryRemote({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindLearningJourneyItemQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RFindLearningJourneyItemQuery, RFindLearningJourneyItemQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RFindLearningJourneyItemQuery, RFindLearningJourneyItemQueryVariables>(
    FindLearningJourneyItemDocument,
    options,
  );
}
export function useFindLearningJourneyItemLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RFindLearningJourneyItemQuery, RFindLearningJourneyItemQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RFindLearningJourneyItemQuery, RFindLearningJourneyItemQueryVariables>(
    FindLearningJourneyItemDocument,
    options,
  );
}
export type FindLearningJourneyItemQueryRemoteHookResult = ReturnType<typeof useFindLearningJourneyItemQueryRemote>;
export type FindLearningJourneyItemLazyQueryRemoteHookResult = ReturnType<typeof useFindLearningJourneyItemLazyQueryRemote>;
export type FindLearningJourneyItemQueryResult = Apollo.QueryResult<
  RFindLearningJourneyItemQuery,
  RFindLearningJourneyItemQueryVariables
>;
export const SearchLearningContentDocument = gql`
  query searchLearningContent($filter: SearchLearningContentFilter!, $pagination: Pagination!, $spaceIds: [Int!]!) {
    searchLearningContent(filter: $filter, pagination: $pagination) {
      data {
        ...LearningContent
      }
      limit
      page
      total
    }
  }
  ${LearningContentFragmentDoc}
`;

/**
 * __useSearchLearningContentQueryRemote__
 *
 * To run a query within a React component, call `useSearchLearningContentQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useSearchLearningContentQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLearningContentQueryRemote({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      spaceIds: // value for 'spaceIds'
 *   },
 * });
 */
export function useSearchLearningContentQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RSearchLearningContentQuery, RSearchLearningContentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RSearchLearningContentQuery, RSearchLearningContentQueryVariables>(
    SearchLearningContentDocument,
    options,
  );
}
export function useSearchLearningContentLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RSearchLearningContentQuery, RSearchLearningContentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RSearchLearningContentQuery, RSearchLearningContentQueryVariables>(
    SearchLearningContentDocument,
    options,
  );
}
export type SearchLearningContentQueryRemoteHookResult = ReturnType<typeof useSearchLearningContentQueryRemote>;
export type SearchLearningContentLazyQueryRemoteHookResult = ReturnType<typeof useSearchLearningContentLazyQueryRemote>;
export type SearchLearningContentQueryResult = Apollo.QueryResult<
  RSearchLearningContentQuery,
  RSearchLearningContentQueryVariables
>;
export const ImportLearningContentToSpaceDocument = gql`
  mutation importLearningContentToSpace($input: ImportLearningContentToSpaceInput!) {
    importLearningContentToSpace(input: $input) {
      success
      content {
        id
        title
      }
      failedIds
    }
  }
`;
export type RImportLearningContentToSpaceMutationFn = Apollo.MutationFunction<
  RImportLearningContentToSpaceMutation,
  RImportLearningContentToSpaceMutationVariables
>;

/**
 * __useImportLearningContentToSpaceMutationRemote__
 *
 * To run a mutation, you first call `useImportLearningContentToSpaceMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportLearningContentToSpaceMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importLearningContentToSpaceMutationRemote, { data, loading, error }] = useImportLearningContentToSpaceMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportLearningContentToSpaceMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RImportLearningContentToSpaceMutation, RImportLearningContentToSpaceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RImportLearningContentToSpaceMutation, RImportLearningContentToSpaceMutationVariables>(
    ImportLearningContentToSpaceDocument,
    options,
  );
}
export type ImportLearningContentToSpaceMutationRemoteHookResult = ReturnType<
  typeof useImportLearningContentToSpaceMutationRemote
>;
export type ImportLearningContentToSpaceMutationResult = Apollo.MutationResult<RImportLearningContentToSpaceMutation>;
export type ImportLearningContentToSpaceMutationOptions = Apollo.BaseMutationOptions<
  RImportLearningContentToSpaceMutation,
  RImportLearningContentToSpaceMutationVariables
>;
export const SubmitLearningActivityQuizAnswersDocument = gql`
  mutation submitLearningActivityQuizAnswers($input: UserLearningActivityQuizSubmissionInput!) {
    submitLearningActivityQuizAnswers(input: $input) {
      id
    }
  }
`;
export type RSubmitLearningActivityQuizAnswersMutationFn = Apollo.MutationFunction<
  RSubmitLearningActivityQuizAnswersMutation,
  RSubmitLearningActivityQuizAnswersMutationVariables
>;

/**
 * __useSubmitLearningActivityQuizAnswersMutationRemote__
 *
 * To run a mutation, you first call `useSubmitLearningActivityQuizAnswersMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLearningActivityQuizAnswersMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLearningActivityQuizAnswersMutationRemote, { data, loading, error }] = useSubmitLearningActivityQuizAnswersMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitLearningActivityQuizAnswersMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RSubmitLearningActivityQuizAnswersMutation,
    RSubmitLearningActivityQuizAnswersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RSubmitLearningActivityQuizAnswersMutation, RSubmitLearningActivityQuizAnswersMutationVariables>(
    SubmitLearningActivityQuizAnswersDocument,
    options,
  );
}
export type SubmitLearningActivityQuizAnswersMutationRemoteHookResult = ReturnType<
  typeof useSubmitLearningActivityQuizAnswersMutationRemote
>;
export type SubmitLearningActivityQuizAnswersMutationResult = Apollo.MutationResult<RSubmitLearningActivityQuizAnswersMutation>;
export type SubmitLearningActivityQuizAnswersMutationOptions = Apollo.BaseMutationOptions<
  RSubmitLearningActivityQuizAnswersMutation,
  RSubmitLearningActivityQuizAnswersMutationVariables
>;
export const MyLearningActivityQuizSubmissionsDocument = gql`
  query myLearningActivityQuizSubmissions($input: UserLearningActivityQuizSubmissionFilterInput!) {
    myLearningActivityQuizSubmissions(input: $input) {
      answers
      quiz
      id
      score
      correctlyAnsweredCount
      totalAnsweredCount
      hasPassed
    }
  }
`;

/**
 * __useMyLearningActivityQuizSubmissionsQueryRemote__
 *
 * To run a query within a React component, call `useMyLearningActivityQuizSubmissionsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useMyLearningActivityQuizSubmissionsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLearningActivityQuizSubmissionsQueryRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMyLearningActivityQuizSubmissionsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RMyLearningActivityQuizSubmissionsQuery, RMyLearningActivityQuizSubmissionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RMyLearningActivityQuizSubmissionsQuery, RMyLearningActivityQuizSubmissionsQueryVariables>(
    MyLearningActivityQuizSubmissionsDocument,
    options,
  );
}
export function useMyLearningActivityQuizSubmissionsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RMyLearningActivityQuizSubmissionsQuery,
    RMyLearningActivityQuizSubmissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RMyLearningActivityQuizSubmissionsQuery, RMyLearningActivityQuizSubmissionsQueryVariables>(
    MyLearningActivityQuizSubmissionsDocument,
    options,
  );
}
export type MyLearningActivityQuizSubmissionsQueryRemoteHookResult = ReturnType<
  typeof useMyLearningActivityQuizSubmissionsQueryRemote
>;
export type MyLearningActivityQuizSubmissionsLazyQueryRemoteHookResult = ReturnType<
  typeof useMyLearningActivityQuizSubmissionsLazyQueryRemote
>;
export type MyLearningActivityQuizSubmissionsQueryResult = Apollo.QueryResult<
  RMyLearningActivityQuizSubmissionsQuery,
  RMyLearningActivityQuizSubmissionsQueryVariables
>;
export const MyLearningActivityAssignmentSubmissionsDocument = gql`
  query myLearningActivityAssignmentSubmissions($input: UserLearningActivityAssignmentSubmissionFilterInput!) {
    myLearningActivityAssignmentSubmissions(input: $input) {
      ...learningActivityAssignmentSubmission
    }
  }
  ${LearningActivityAssignmentSubmissionFragmentDoc}
`;

/**
 * __useMyLearningActivityAssignmentSubmissionsQueryRemote__
 *
 * To run a query within a React component, call `useMyLearningActivityAssignmentSubmissionsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useMyLearningActivityAssignmentSubmissionsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLearningActivityAssignmentSubmissionsQueryRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMyLearningActivityAssignmentSubmissionsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<
    RMyLearningActivityAssignmentSubmissionsQuery,
    RMyLearningActivityAssignmentSubmissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RMyLearningActivityAssignmentSubmissionsQuery, RMyLearningActivityAssignmentSubmissionsQueryVariables>(
    MyLearningActivityAssignmentSubmissionsDocument,
    options,
  );
}
export function useMyLearningActivityAssignmentSubmissionsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RMyLearningActivityAssignmentSubmissionsQuery,
    RMyLearningActivityAssignmentSubmissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RMyLearningActivityAssignmentSubmissionsQuery,
    RMyLearningActivityAssignmentSubmissionsQueryVariables
  >(MyLearningActivityAssignmentSubmissionsDocument, options);
}
export type MyLearningActivityAssignmentSubmissionsQueryRemoteHookResult = ReturnType<
  typeof useMyLearningActivityAssignmentSubmissionsQueryRemote
>;
export type MyLearningActivityAssignmentSubmissionsLazyQueryRemoteHookResult = ReturnType<
  typeof useMyLearningActivityAssignmentSubmissionsLazyQueryRemote
>;
export type MyLearningActivityAssignmentSubmissionsQueryResult = Apollo.QueryResult<
  RMyLearningActivityAssignmentSubmissionsQuery,
  RMyLearningActivityAssignmentSubmissionsQueryVariables
>;
export const SubmitLearningActivityAssignmentDocument = gql`
  mutation submitLearningActivityAssignment($input: SubmitLearningActivityAssignmentInput!) {
    submitLearningActivityAssignment(input: $input) {
      ...learningActivityAssignmentSubmission
    }
  }
  ${LearningActivityAssignmentSubmissionFragmentDoc}
`;
export type RSubmitLearningActivityAssignmentMutationFn = Apollo.MutationFunction<
  RSubmitLearningActivityAssignmentMutation,
  RSubmitLearningActivityAssignmentMutationVariables
>;

/**
 * __useSubmitLearningActivityAssignmentMutationRemote__
 *
 * To run a mutation, you first call `useSubmitLearningActivityAssignmentMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLearningActivityAssignmentMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLearningActivityAssignmentMutationRemote, { data, loading, error }] = useSubmitLearningActivityAssignmentMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitLearningActivityAssignmentMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RSubmitLearningActivityAssignmentMutation,
    RSubmitLearningActivityAssignmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RSubmitLearningActivityAssignmentMutation, RSubmitLearningActivityAssignmentMutationVariables>(
    SubmitLearningActivityAssignmentDocument,
    options,
  );
}
export type SubmitLearningActivityAssignmentMutationRemoteHookResult = ReturnType<
  typeof useSubmitLearningActivityAssignmentMutationRemote
>;
export type SubmitLearningActivityAssignmentMutationResult = Apollo.MutationResult<RSubmitLearningActivityAssignmentMutation>;
export type SubmitLearningActivityAssignmentMutationOptions = Apollo.BaseMutationOptions<
  RSubmitLearningActivityAssignmentMutation,
  RSubmitLearningActivityAssignmentMutationVariables
>;
export const MigrateOnDemandLearningToCoursesDocument = gql`
  mutation migrateOnDemandLearningToCourses($learningId: Int!) {
    migrateOnDemandLearningToCourses(learningId: $learningId) {
      id
      title
    }
  }
`;
export type RMigrateOnDemandLearningToCoursesMutationFn = Apollo.MutationFunction<
  RMigrateOnDemandLearningToCoursesMutation,
  RMigrateOnDemandLearningToCoursesMutationVariables
>;

/**
 * __useMigrateOnDemandLearningToCoursesMutationRemote__
 *
 * To run a mutation, you first call `useMigrateOnDemandLearningToCoursesMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateOnDemandLearningToCoursesMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateOnDemandLearningToCoursesMutationRemote, { data, loading, error }] = useMigrateOnDemandLearningToCoursesMutationRemote({
 *   variables: {
 *      learningId: // value for 'learningId'
 *   },
 * });
 */
export function useMigrateOnDemandLearningToCoursesMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RMigrateOnDemandLearningToCoursesMutation,
    RMigrateOnDemandLearningToCoursesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RMigrateOnDemandLearningToCoursesMutation, RMigrateOnDemandLearningToCoursesMutationVariables>(
    MigrateOnDemandLearningToCoursesDocument,
    options,
  );
}
export type MigrateOnDemandLearningToCoursesMutationRemoteHookResult = ReturnType<
  typeof useMigrateOnDemandLearningToCoursesMutationRemote
>;
export type MigrateOnDemandLearningToCoursesMutationResult = Apollo.MutationResult<RMigrateOnDemandLearningToCoursesMutation>;
export type MigrateOnDemandLearningToCoursesMutationOptions = Apollo.BaseMutationOptions<
  RMigrateOnDemandLearningToCoursesMutation,
  RMigrateOnDemandLearningToCoursesMutationVariables
>;
export const CloneLearningDocument = gql`
  mutation cloneLearning($input: CloneLearningInput!) {
    cloneLearning(input: $input) {
      id
      type
      title
      urn
    }
  }
`;
export type RCloneLearningMutationFn = Apollo.MutationFunction<RCloneLearningMutation, RCloneLearningMutationVariables>;

/**
 * __useCloneLearningMutationRemote__
 *
 * To run a mutation, you first call `useCloneLearningMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneLearningMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneLearningMutationRemote, { data, loading, error }] = useCloneLearningMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneLearningMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCloneLearningMutation, RCloneLearningMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCloneLearningMutation, RCloneLearningMutationVariables>(CloneLearningDocument, options);
}
export type CloneLearningMutationRemoteHookResult = ReturnType<typeof useCloneLearningMutationRemote>;
export type CloneLearningMutationResult = Apollo.MutationResult<RCloneLearningMutation>;
export type CloneLearningMutationOptions = Apollo.BaseMutationOptions<RCloneLearningMutation, RCloneLearningMutationVariables>;
export const CloneLearningActivitiesDocument = gql`
  mutation cloneLearningActivities($activityId: Float!) {
    cloneLearningActivities(activityId: $activityId) {
      ...ActivityFragment
    }
  }
  ${ActivityFragmentFragmentDoc}
`;
export type RCloneLearningActivitiesMutationFn = Apollo.MutationFunction<
  RCloneLearningActivitiesMutation,
  RCloneLearningActivitiesMutationVariables
>;

/**
 * __useCloneLearningActivitiesMutationRemote__
 *
 * To run a mutation, you first call `useCloneLearningActivitiesMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneLearningActivitiesMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneLearningActivitiesMutationRemote, { data, loading, error }] = useCloneLearningActivitiesMutationRemote({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useCloneLearningActivitiesMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCloneLearningActivitiesMutation, RCloneLearningActivitiesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCloneLearningActivitiesMutation, RCloneLearningActivitiesMutationVariables>(
    CloneLearningActivitiesDocument,
    options,
  );
}
export type CloneLearningActivitiesMutationRemoteHookResult = ReturnType<typeof useCloneLearningActivitiesMutationRemote>;
export type CloneLearningActivitiesMutationResult = Apollo.MutationResult<RCloneLearningActivitiesMutation>;
export type CloneLearningActivitiesMutationOptions = Apollo.BaseMutationOptions<
  RCloneLearningActivitiesMutation,
  RCloneLearningActivitiesMutationVariables
>;
export const ChangeEnrollmentLocationDocument = gql`
  mutation changeEnrollmentLocation($input: ChangeEnrollmentLocationInput!) {
    changeEnrollmentLocation(input: $input) {
      id
      locationId
      attended
    }
  }
`;
export type RChangeEnrollmentLocationMutationFn = Apollo.MutationFunction<
  RChangeEnrollmentLocationMutation,
  RChangeEnrollmentLocationMutationVariables
>;

/**
 * __useChangeEnrollmentLocationMutationRemote__
 *
 * To run a mutation, you first call `useChangeEnrollmentLocationMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEnrollmentLocationMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEnrollmentLocationMutationRemote, { data, loading, error }] = useChangeEnrollmentLocationMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeEnrollmentLocationMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RChangeEnrollmentLocationMutation, RChangeEnrollmentLocationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RChangeEnrollmentLocationMutation, RChangeEnrollmentLocationMutationVariables>(
    ChangeEnrollmentLocationDocument,
    options,
  );
}
export type ChangeEnrollmentLocationMutationRemoteHookResult = ReturnType<typeof useChangeEnrollmentLocationMutationRemote>;
export type ChangeEnrollmentLocationMutationResult = Apollo.MutationResult<RChangeEnrollmentLocationMutation>;
export type ChangeEnrollmentLocationMutationOptions = Apollo.BaseMutationOptions<
  RChangeEnrollmentLocationMutation,
  RChangeEnrollmentLocationMutationVariables
>;
export const ReportingLearningsDocument = gql`
  query reportingLearnings($args: reportingLearnings_arguments!, $limit: Int, $offset: Int, $orderBy: [learnings_order_by!]) {
    reportingLearnings(args: $args, limit: $limit, offset: $offset, order_by: $orderBy) {
      partner
      space_ids
      space_names
      team_ids
      title
      type
      urn
      visibility
      category
      subject
      planned_duration
    }
  }
`;

/**
 * __useReportingLearningsQueryRemote__
 *
 * To run a query within a React component, call `useReportingLearningsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingLearningsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingLearningsQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useReportingLearningsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RReportingLearningsQuery, RReportingLearningsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingLearningsQuery, RReportingLearningsQueryVariables>(ReportingLearningsDocument, options);
}
export function useReportingLearningsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RReportingLearningsQuery, RReportingLearningsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingLearningsQuery, RReportingLearningsQueryVariables>(ReportingLearningsDocument, options);
}
export type ReportingLearningsQueryRemoteHookResult = ReturnType<typeof useReportingLearningsQueryRemote>;
export type ReportingLearningsLazyQueryRemoteHookResult = ReturnType<typeof useReportingLearningsLazyQueryRemote>;
export type ReportingLearningsQueryResult = Apollo.QueryResult<RReportingLearningsQuery, RReportingLearningsQueryVariables>;
export const ReportingLearningsTotalCountDocument = gql`
  query reportingLearningsTotalCount($args: reportingLearningsTotalCount_arguments!) {
    reportingLearningsTotalCount(args: $args) {
      total_count
    }
  }
`;

/**
 * __useReportingLearningsTotalCountQueryRemote__
 *
 * To run a query within a React component, call `useReportingLearningsTotalCountQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingLearningsTotalCountQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingLearningsTotalCountQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useReportingLearningsTotalCountQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RReportingLearningsTotalCountQuery, RReportingLearningsTotalCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingLearningsTotalCountQuery, RReportingLearningsTotalCountQueryVariables>(
    ReportingLearningsTotalCountDocument,
    options,
  );
}
export function useReportingLearningsTotalCountLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RReportingLearningsTotalCountQuery, RReportingLearningsTotalCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingLearningsTotalCountQuery, RReportingLearningsTotalCountQueryVariables>(
    ReportingLearningsTotalCountDocument,
    options,
  );
}
export type ReportingLearningsTotalCountQueryRemoteHookResult = ReturnType<typeof useReportingLearningsTotalCountQueryRemote>;
export type ReportingLearningsTotalCountLazyQueryRemoteHookResult = ReturnType<
  typeof useReportingLearningsTotalCountLazyQueryRemote
>;
export type ReportingLearningsTotalCountQueryResult = Apollo.QueryResult<
  RReportingLearningsTotalCountQuery,
  RReportingLearningsTotalCountQueryVariables
>;
export const ReportingLearningsInsightsDocument = gql`
  query reportingLearningsInsights(
    $args: reportingLearningsInsights_arguments!
    $limit: Int
    $offset: Int
    $orderBy: [learningsInsights_order_by!]
  ) {
    reportingLearningsInsights(args: $args, limit: $limit, offset: $offset, order_by: $orderBy) {
      completion_rate
      learners_count
      space_ids
      team_ids
      urn
    }
  }
`;

/**
 * __useReportingLearningsInsightsQueryRemote__
 *
 * To run a query within a React component, call `useReportingLearningsInsightsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useReportingLearningsInsightsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingLearningsInsightsQueryRemote({
 *   variables: {
 *      args: // value for 'args'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useReportingLearningsInsightsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RReportingLearningsInsightsQuery, RReportingLearningsInsightsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RReportingLearningsInsightsQuery, RReportingLearningsInsightsQueryVariables>(
    ReportingLearningsInsightsDocument,
    options,
  );
}
export function useReportingLearningsInsightsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RReportingLearningsInsightsQuery, RReportingLearningsInsightsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RReportingLearningsInsightsQuery, RReportingLearningsInsightsQueryVariables>(
    ReportingLearningsInsightsDocument,
    options,
  );
}
export type ReportingLearningsInsightsQueryRemoteHookResult = ReturnType<typeof useReportingLearningsInsightsQueryRemote>;
export type ReportingLearningsInsightsLazyQueryRemoteHookResult = ReturnType<typeof useReportingLearningsInsightsLazyQueryRemote>;
export type ReportingLearningsInsightsQueryResult = Apollo.QueryResult<
  RReportingLearningsInsightsQuery,
  RReportingLearningsInsightsQueryVariables
>;
export const GetXapiSessionDocument = gql`
  query getXAPISession($learningId: Int!) {
    getXAPISession(learningId: $learningId) {
      queryString
      registration
    }
  }
`;

/**
 * __useGetXapiSessionQueryRemote__
 *
 * To run a query within a React component, call `useGetXapiSessionQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetXapiSessionQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetXapiSessionQueryRemote({
 *   variables: {
 *      learningId: // value for 'learningId'
 *   },
 * });
 */
export function useGetXapiSessionQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RGetXapiSessionQuery, RGetXapiSessionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetXapiSessionQuery, RGetXapiSessionQueryVariables>(GetXapiSessionDocument, options);
}
export function useGetXapiSessionLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetXapiSessionQuery, RGetXapiSessionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetXapiSessionQuery, RGetXapiSessionQueryVariables>(GetXapiSessionDocument, options);
}
export type GetXapiSessionQueryRemoteHookResult = ReturnType<typeof useGetXapiSessionQueryRemote>;
export type GetXapiSessionLazyQueryRemoteHookResult = ReturnType<typeof useGetXapiSessionLazyQueryRemote>;
export type GetXapiSessionQueryResult = Apollo.QueryResult<RGetXapiSessionQuery, RGetXapiSessionQueryVariables>;
export const IsLearningCompletedDocument = gql`
  query isLearningCompleted($learningId: Int!) {
    isLearningCompleted(learningId: $learningId)
  }
`;

/**
 * __useIsLearningCompletedQueryRemote__
 *
 * To run a query within a React component, call `useIsLearningCompletedQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useIsLearningCompletedQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsLearningCompletedQueryRemote({
 *   variables: {
 *      learningId: // value for 'learningId'
 *   },
 * });
 */
export function useIsLearningCompletedQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RIsLearningCompletedQuery, RIsLearningCompletedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RIsLearningCompletedQuery, RIsLearningCompletedQueryVariables>(IsLearningCompletedDocument, options);
}
export function useIsLearningCompletedLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RIsLearningCompletedQuery, RIsLearningCompletedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RIsLearningCompletedQuery, RIsLearningCompletedQueryVariables>(IsLearningCompletedDocument, options);
}
export type IsLearningCompletedQueryRemoteHookResult = ReturnType<typeof useIsLearningCompletedQueryRemote>;
export type IsLearningCompletedLazyQueryRemoteHookResult = ReturnType<typeof useIsLearningCompletedLazyQueryRemote>;
export type IsLearningCompletedQueryResult = Apollo.QueryResult<RIsLearningCompletedQuery, RIsLearningCompletedQueryVariables>;
export const GetLearningXapiSessionDocument = gql`
  query getLearningXAPISession($learningId: Int!) {
    getXAPISession(learningId: $learningId) {
      queryString
      registration
    }
  }
`;

/**
 * __useGetLearningXapiSessionQueryRemote__
 *
 * To run a query within a React component, call `useGetLearningXapiSessionQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningXapiSessionQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningXapiSessionQueryRemote({
 *   variables: {
 *      learningId: // value for 'learningId'
 *   },
 * });
 */
export function useGetLearningXapiSessionQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RGetLearningXapiSessionQuery, RGetLearningXapiSessionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetLearningXapiSessionQuery, RGetLearningXapiSessionQueryVariables>(
    GetLearningXapiSessionDocument,
    options,
  );
}
export function useGetLearningXapiSessionLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetLearningXapiSessionQuery, RGetLearningXapiSessionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetLearningXapiSessionQuery, RGetLearningXapiSessionQueryVariables>(
    GetLearningXapiSessionDocument,
    options,
  );
}
export type GetLearningXapiSessionQueryRemoteHookResult = ReturnType<typeof useGetLearningXapiSessionQueryRemote>;
export type GetLearningXapiSessionLazyQueryRemoteHookResult = ReturnType<typeof useGetLearningXapiSessionLazyQueryRemote>;
export type GetLearningXapiSessionQueryResult = Apollo.QueryResult<
  RGetLearningXapiSessionQuery,
  RGetLearningXapiSessionQueryVariables
>;
export const RegisterToLearningDocument = gql`
  mutation registerToLearning($learningId: Int!) {
    registerToLearning(learningId: $learningId) {
      queryString
      registration
    }
  }
`;
export type RRegisterToLearningMutationFn = Apollo.MutationFunction<
  RRegisterToLearningMutation,
  RRegisterToLearningMutationVariables
>;

/**
 * __useRegisterToLearningMutationRemote__
 *
 * To run a mutation, you first call `useRegisterToLearningMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterToLearningMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerToLearningMutationRemote, { data, loading, error }] = useRegisterToLearningMutationRemote({
 *   variables: {
 *      learningId: // value for 'learningId'
 *   },
 * });
 */
export function useRegisterToLearningMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RRegisterToLearningMutation, RRegisterToLearningMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RRegisterToLearningMutation, RRegisterToLearningMutationVariables>(
    RegisterToLearningDocument,
    options,
  );
}
export type RegisterToLearningMutationRemoteHookResult = ReturnType<typeof useRegisterToLearningMutationRemote>;
export type RegisterToLearningMutationResult = Apollo.MutationResult<RRegisterToLearningMutation>;
export type RegisterToLearningMutationOptions = Apollo.BaseMutationOptions<
  RRegisterToLearningMutation,
  RRegisterToLearningMutationVariables
>;
export const ApproveLicenseDocument = gql`
  mutation approveLicense($currentRealm: String, $provider: String, $licenseId: Int) {
    approveLicense(realm: $currentRealm, provider: $provider, licenseId: $licenseId)
  }
`;
export type RApproveLicenseMutationFn = Apollo.MutationFunction<RApproveLicenseMutation, RApproveLicenseMutationVariables>;

/**
 * __useApproveLicenseMutationRemote__
 *
 * To run a mutation, you first call `useApproveLicenseMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveLicenseMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveLicenseMutationRemote, { data, loading, error }] = useApproveLicenseMutationRemote({
 *   variables: {
 *      currentRealm: // value for 'currentRealm'
 *      provider: // value for 'provider'
 *      licenseId: // value for 'licenseId'
 *   },
 * });
 */
export function useApproveLicenseMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RApproveLicenseMutation, RApproveLicenseMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RApproveLicenseMutation, RApproveLicenseMutationVariables>(ApproveLicenseDocument, options);
}
export type ApproveLicenseMutationRemoteHookResult = ReturnType<typeof useApproveLicenseMutationRemote>;
export type ApproveLicenseMutationResult = Apollo.MutationResult<RApproveLicenseMutation>;
export type ApproveLicenseMutationOptions = Apollo.BaseMutationOptions<RApproveLicenseMutation, RApproveLicenseMutationVariables>;
export const GetIssuedLicenseByIdDocument = gql`
  query getIssuedLicenseById($realm: String, $provider: String, $userId: Int, $status: String) {
    issuedLicenses(realm: $realm, provider: $provider, userId: $userId, status: $status) {
      id
      userId
      createdAt
      updatedAt
      lastRequestedAt
      status
      division
      sId
      employeeId
      businessArea
      businessUnit
      user {
        email
        username
      }
    }
  }
`;

/**
 * __useGetIssuedLicenseByIdQueryRemote__
 *
 * To run a query within a React component, call `useGetIssuedLicenseByIdQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetIssuedLicenseByIdQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssuedLicenseByIdQueryRemote({
 *   variables: {
 *      realm: // value for 'realm'
 *      provider: // value for 'provider'
 *      userId: // value for 'userId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetIssuedLicenseByIdQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetIssuedLicenseByIdQuery, RGetIssuedLicenseByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetIssuedLicenseByIdQuery, RGetIssuedLicenseByIdQueryVariables>(GetIssuedLicenseByIdDocument, options);
}
export function useGetIssuedLicenseByIdLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetIssuedLicenseByIdQuery, RGetIssuedLicenseByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetIssuedLicenseByIdQuery, RGetIssuedLicenseByIdQueryVariables>(
    GetIssuedLicenseByIdDocument,
    options,
  );
}
export type GetIssuedLicenseByIdQueryRemoteHookResult = ReturnType<typeof useGetIssuedLicenseByIdQueryRemote>;
export type GetIssuedLicenseByIdLazyQueryRemoteHookResult = ReturnType<typeof useGetIssuedLicenseByIdLazyQueryRemote>;
export type GetIssuedLicenseByIdQueryResult = Apollo.QueryResult<RGetIssuedLicenseByIdQuery, RGetIssuedLicenseByIdQueryVariables>;
export const RevokeLicenseDocument = gql`
  mutation revokeLicense($licenseId: Int) {
    revokeLicense(licenseId: $licenseId)
  }
`;
export type RRevokeLicenseMutationFn = Apollo.MutationFunction<RRevokeLicenseMutation, RRevokeLicenseMutationVariables>;

/**
 * __useRevokeLicenseMutationRemote__
 *
 * To run a mutation, you first call `useRevokeLicenseMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeLicenseMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeLicenseMutationRemote, { data, loading, error }] = useRevokeLicenseMutationRemote({
 *   variables: {
 *      licenseId: // value for 'licenseId'
 *   },
 * });
 */
export function useRevokeLicenseMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RRevokeLicenseMutation, RRevokeLicenseMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RRevokeLicenseMutation, RRevokeLicenseMutationVariables>(RevokeLicenseDocument, options);
}
export type RevokeLicenseMutationRemoteHookResult = ReturnType<typeof useRevokeLicenseMutationRemote>;
export type RevokeLicenseMutationResult = Apollo.MutationResult<RRevokeLicenseMutation>;
export type RevokeLicenseMutationOptions = Apollo.BaseMutationOptions<RRevokeLicenseMutation, RRevokeLicenseMutationVariables>;
export const SyncCourseraLicensesDocument = gql`
  query syncCourseraLicenses($realm: String, $status: String) {
    exportLicenses(realm: $realm, status: $status) {
      id
      userId
      status
      createdAt
      updatedAt
      lastRequestedAt
      division
      sId
      employeeId
      businessArea
      businessUnit
      user {
        email
        username
      }
    }
  }
`;

/**
 * __useSyncCourseraLicensesQueryRemote__
 *
 * To run a query within a React component, call `useSyncCourseraLicensesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useSyncCourseraLicensesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncCourseraLicensesQueryRemote({
 *   variables: {
 *      realm: // value for 'realm'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSyncCourseraLicensesQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RSyncCourseraLicensesQuery, RSyncCourseraLicensesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RSyncCourseraLicensesQuery, RSyncCourseraLicensesQueryVariables>(SyncCourseraLicensesDocument, options);
}
export function useSyncCourseraLicensesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RSyncCourseraLicensesQuery, RSyncCourseraLicensesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RSyncCourseraLicensesQuery, RSyncCourseraLicensesQueryVariables>(
    SyncCourseraLicensesDocument,
    options,
  );
}
export type SyncCourseraLicensesQueryRemoteHookResult = ReturnType<typeof useSyncCourseraLicensesQueryRemote>;
export type SyncCourseraLicensesLazyQueryRemoteHookResult = ReturnType<typeof useSyncCourseraLicensesLazyQueryRemote>;
export type SyncCourseraLicensesQueryResult = Apollo.QueryResult<RSyncCourseraLicensesQuery, RSyncCourseraLicensesQueryVariables>;
export const ProviderLicensesDocument = gql`
  query providerLicenses($realm: String, $provider: String) {
    realmProviderLicensesSummary(realm: $realm, provider: $provider) {
      id
      pendingLicenses
    }
  }
`;

/**
 * __useProviderLicensesQueryRemote__
 *
 * To run a query within a React component, call `useProviderLicensesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useProviderLicensesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderLicensesQueryRemote({
 *   variables: {
 *      realm: // value for 'realm'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useProviderLicensesQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RProviderLicensesQuery, RProviderLicensesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RProviderLicensesQuery, RProviderLicensesQueryVariables>(ProviderLicensesDocument, options);
}
export function useProviderLicensesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RProviderLicensesQuery, RProviderLicensesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RProviderLicensesQuery, RProviderLicensesQueryVariables>(ProviderLicensesDocument, options);
}
export type ProviderLicensesQueryRemoteHookResult = ReturnType<typeof useProviderLicensesQueryRemote>;
export type ProviderLicensesLazyQueryRemoteHookResult = ReturnType<typeof useProviderLicensesLazyQueryRemote>;
export type ProviderLicensesQueryResult = Apollo.QueryResult<RProviderLicensesQuery, RProviderLicensesQueryVariables>;
export const CourseraDocument = gql`
  query coursera($provider: String, $currentRealm: String) {
    issuedLicense(provider: $provider, realm: $currentRealm) {
      status
      id
      userId
    }
    realmProviderLicensesSummary(provider: $provider, realm: $currentRealm) {
      id
      catalogUrl
    }
  }
`;

/**
 * __useCourseraQueryRemote__
 *
 * To run a query within a React component, call `useCourseraQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useCourseraQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseraQueryRemote({
 *   variables: {
 *      provider: // value for 'provider'
 *      currentRealm: // value for 'currentRealm'
 *   },
 * });
 */
export function useCourseraQueryRemote(baseOptions?: Apollo.QueryHookOptions<RCourseraQuery, RCourseraQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RCourseraQuery, RCourseraQueryVariables>(CourseraDocument, options);
}
export function useCourseraLazyQueryRemote(baseOptions?: Apollo.LazyQueryHookOptions<RCourseraQuery, RCourseraQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RCourseraQuery, RCourseraQueryVariables>(CourseraDocument, options);
}
export type CourseraQueryRemoteHookResult = ReturnType<typeof useCourseraQueryRemote>;
export type CourseraLazyQueryRemoteHookResult = ReturnType<typeof useCourseraLazyQueryRemote>;
export type CourseraQueryResult = Apollo.QueryResult<RCourseraQuery, RCourseraQueryVariables>;
export const ProviderAccessProductDocument = gql`
  query providerAccessProduct($realm: String, $provider: String) {
    providerAccessProductId(realm: $realm, provider: $provider) {
      id
    }
  }
`;

/**
 * __useProviderAccessProductQueryRemote__
 *
 * To run a query within a React component, call `useProviderAccessProductQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useProviderAccessProductQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderAccessProductQueryRemote({
 *   variables: {
 *      realm: // value for 'realm'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useProviderAccessProductQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RProviderAccessProductQuery, RProviderAccessProductQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RProviderAccessProductQuery, RProviderAccessProductQueryVariables>(
    ProviderAccessProductDocument,
    options,
  );
}
export function useProviderAccessProductLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RProviderAccessProductQuery, RProviderAccessProductQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RProviderAccessProductQuery, RProviderAccessProductQueryVariables>(
    ProviderAccessProductDocument,
    options,
  );
}
export type ProviderAccessProductQueryRemoteHookResult = ReturnType<typeof useProviderAccessProductQueryRemote>;
export type ProviderAccessProductLazyQueryRemoteHookResult = ReturnType<typeof useProviderAccessProductLazyQueryRemote>;
export type ProviderAccessProductQueryResult = Apollo.QueryResult<
  RProviderAccessProductQuery,
  RProviderAccessProductQueryVariables
>;
export const RequestCourseraLicenseDocument = gql`
  mutation requestCourseraLicense($currentRealm: String, $provider: String) {
    requestLicense(provider: $provider, realm: $currentRealm)
  }
`;
export type RRequestCourseraLicenseMutationFn = Apollo.MutationFunction<
  RRequestCourseraLicenseMutation,
  RRequestCourseraLicenseMutationVariables
>;

/**
 * __useRequestCourseraLicenseMutationRemote__
 *
 * To run a mutation, you first call `useRequestCourseraLicenseMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCourseraLicenseMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCourseraLicenseMutationRemote, { data, loading, error }] = useRequestCourseraLicenseMutationRemote({
 *   variables: {
 *      currentRealm: // value for 'currentRealm'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useRequestCourseraLicenseMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RRequestCourseraLicenseMutation, RRequestCourseraLicenseMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RRequestCourseraLicenseMutation, RRequestCourseraLicenseMutationVariables>(
    RequestCourseraLicenseDocument,
    options,
  );
}
export type RequestCourseraLicenseMutationRemoteHookResult = ReturnType<typeof useRequestCourseraLicenseMutationRemote>;
export type RequestCourseraLicenseMutationResult = Apollo.MutationResult<RRequestCourseraLicenseMutation>;
export type RequestCourseraLicenseMutationOptions = Apollo.BaseMutationOptions<
  RRequestCourseraLicenseMutation,
  RRequestCourseraLicenseMutationVariables
>;
export const ManagementParticipationsDocument = gql`
  query managementParticipations($objectIdIn: [String]!, $userTeamIdIn: [Int]!) {
    participations: getParticipations(input: { objectIdIn: $objectIdIn, userTeamIdIn: $userTeamIdIn, includeCatalogData: true }) {
      id
      userId
      objectId
      progress
      completedAt
      objectName
      objectType
    }
  }
`;

/**
 * __useManagementParticipationsQueryRemote__
 *
 * To run a query within a React component, call `useManagementParticipationsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useManagementParticipationsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagementParticipationsQueryRemote({
 *   variables: {
 *      objectIdIn: // value for 'objectIdIn'
 *      userTeamIdIn: // value for 'userTeamIdIn'
 *   },
 * });
 */
export function useManagementParticipationsQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RManagementParticipationsQuery, RManagementParticipationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RManagementParticipationsQuery, RManagementParticipationsQueryVariables>(
    ManagementParticipationsDocument,
    options,
  );
}
export function useManagementParticipationsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RManagementParticipationsQuery, RManagementParticipationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RManagementParticipationsQuery, RManagementParticipationsQueryVariables>(
    ManagementParticipationsDocument,
    options,
  );
}
export type ManagementParticipationsQueryRemoteHookResult = ReturnType<typeof useManagementParticipationsQueryRemote>;
export type ManagementParticipationsLazyQueryRemoteHookResult = ReturnType<typeof useManagementParticipationsLazyQueryRemote>;
export type ManagementParticipationsQueryResult = Apollo.QueryResult<
  RManagementParticipationsQuery,
  RManagementParticipationsQueryVariables
>;
export const ManagementCompletionRatePerCourseDocument = gql`
  query managementCompletionRatePerCourse($usersPool: UsersPool, $userTeamIdIn: [Int!]) {
    getCompletionRatePerCourse(usersPool: $usersPool, userTeamIdIn: $userTeamIdIn) {
      object_id
      object_type
      object_name
      completion_rate
      completed
      progressed
    }
  }
`;

/**
 * __useManagementCompletionRatePerCourseQueryRemote__
 *
 * To run a query within a React component, call `useManagementCompletionRatePerCourseQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useManagementCompletionRatePerCourseQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagementCompletionRatePerCourseQueryRemote({
 *   variables: {
 *      usersPool: // value for 'usersPool'
 *      userTeamIdIn: // value for 'userTeamIdIn'
 *   },
 * });
 */
export function useManagementCompletionRatePerCourseQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<
    RManagementCompletionRatePerCourseQuery,
    RManagementCompletionRatePerCourseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RManagementCompletionRatePerCourseQuery, RManagementCompletionRatePerCourseQueryVariables>(
    ManagementCompletionRatePerCourseDocument,
    options,
  );
}
export function useManagementCompletionRatePerCourseLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RManagementCompletionRatePerCourseQuery,
    RManagementCompletionRatePerCourseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RManagementCompletionRatePerCourseQuery, RManagementCompletionRatePerCourseQueryVariables>(
    ManagementCompletionRatePerCourseDocument,
    options,
  );
}
export type ManagementCompletionRatePerCourseQueryRemoteHookResult = ReturnType<
  typeof useManagementCompletionRatePerCourseQueryRemote
>;
export type ManagementCompletionRatePerCourseLazyQueryRemoteHookResult = ReturnType<
  typeof useManagementCompletionRatePerCourseLazyQueryRemote
>;
export type ManagementCompletionRatePerCourseQueryResult = Apollo.QueryResult<
  RManagementCompletionRatePerCourseQuery,
  RManagementCompletionRatePerCourseQueryVariables
>;
export const UserTeamsDocument = gql`
  query userTeams($userId: Int!) {
    userTeams(filter: { userId: $userId, role: manager, withSubteams: true }, pagination: { limit: -1 }) {
      data {
        team {
          id
          name
          parentTeamId
          subTeams(filter: { indirect: true }, pagination: { limit: -1 }) {
            data {
              id
              name
              parentTeamId
            }
          }
        }
      }
    }
  }
`;

/**
 * __useUserTeamsQueryRemote__
 *
 * To run a query within a React component, call `useUserTeamsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useUserTeamsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTeamsQueryRemote({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserTeamsQueryRemote(baseOptions: Apollo.QueryHookOptions<RUserTeamsQuery, RUserTeamsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RUserTeamsQuery, RUserTeamsQueryVariables>(UserTeamsDocument, options);
}
export function useUserTeamsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RUserTeamsQuery, RUserTeamsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RUserTeamsQuery, RUserTeamsQueryVariables>(UserTeamsDocument, options);
}
export type UserTeamsQueryRemoteHookResult = ReturnType<typeof useUserTeamsQueryRemote>;
export type UserTeamsLazyQueryRemoteHookResult = ReturnType<typeof useUserTeamsLazyQueryRemote>;
export type UserTeamsQueryResult = Apollo.QueryResult<RUserTeamsQuery, RUserTeamsQueryVariables>;
export const ManagementTeamUsersEmptyDocument = gql`
  query managementTeamUsersEmpty {
    alias1: teamUsers(filter: { teamIdIN: [-1], withSubteams: false }, pagination: { limit: 0 }) {
      total
    }
  }
`;

/**
 * __useManagementTeamUsersEmptyQueryRemote__
 *
 * To run a query within a React component, call `useManagementTeamUsersEmptyQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useManagementTeamUsersEmptyQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagementTeamUsersEmptyQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useManagementTeamUsersEmptyQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RManagementTeamUsersEmptyQuery, RManagementTeamUsersEmptyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RManagementTeamUsersEmptyQuery, RManagementTeamUsersEmptyQueryVariables>(
    ManagementTeamUsersEmptyDocument,
    options,
  );
}
export function useManagementTeamUsersEmptyLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RManagementTeamUsersEmptyQuery, RManagementTeamUsersEmptyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RManagementTeamUsersEmptyQuery, RManagementTeamUsersEmptyQueryVariables>(
    ManagementTeamUsersEmptyDocument,
    options,
  );
}
export type ManagementTeamUsersEmptyQueryRemoteHookResult = ReturnType<typeof useManagementTeamUsersEmptyQueryRemote>;
export type ManagementTeamUsersEmptyLazyQueryRemoteHookResult = ReturnType<typeof useManagementTeamUsersEmptyLazyQueryRemote>;
export type ManagementTeamUsersEmptyQueryResult = Apollo.QueryResult<
  RManagementTeamUsersEmptyQuery,
  RManagementTeamUsersEmptyQueryVariables
>;
export const ManagementTeamUsersDocument = gql`
  query managementTeamUsers($teamIds: [Int!]!, $withSubTeams: Boolean, $activityFrom: Time, $activityTo: Time) {
    teamUsers(filter: { teamIdIN: $teamIds, withSubteams: $withSubTeams }, pagination: { limit: -1 }) {
      data {
        team {
          id
          name
        }
        user {
          id
          username
          email
          timestamp
          lastActive
          participationAggregate(filter: { activityFrom: $activityFrom, activityTo: $activityTo }) {
            total
            started
            completed
            effort
          }
        }
      }
    }
  }
`;

/**
 * __useManagementTeamUsersQueryRemote__
 *
 * To run a query within a React component, call `useManagementTeamUsersQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useManagementTeamUsersQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagementTeamUsersQueryRemote({
 *   variables: {
 *      teamIds: // value for 'teamIds'
 *      withSubTeams: // value for 'withSubTeams'
 *      activityFrom: // value for 'activityFrom'
 *      activityTo: // value for 'activityTo'
 *   },
 * });
 */
export function useManagementTeamUsersQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RManagementTeamUsersQuery, RManagementTeamUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RManagementTeamUsersQuery, RManagementTeamUsersQueryVariables>(ManagementTeamUsersDocument, options);
}
export function useManagementTeamUsersLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RManagementTeamUsersQuery, RManagementTeamUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RManagementTeamUsersQuery, RManagementTeamUsersQueryVariables>(ManagementTeamUsersDocument, options);
}
export type ManagementTeamUsersQueryRemoteHookResult = ReturnType<typeof useManagementTeamUsersQueryRemote>;
export type ManagementTeamUsersLazyQueryRemoteHookResult = ReturnType<typeof useManagementTeamUsersLazyQueryRemote>;
export type ManagementTeamUsersQueryResult = Apollo.QueryResult<RManagementTeamUsersQuery, RManagementTeamUsersQueryVariables>;
export const GetNotificationsDocument = gql`
  query getNotifications {
    notifications {
      ...NotificationFragment
    }
  }
  ${NotificationFragmentFragmentDoc}
`;

/**
 * __useGetNotificationsQueryRemote__
 *
 * To run a query within a React component, call `useGetNotificationsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetNotificationsQuery, RGetNotificationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetNotificationsQuery, RGetNotificationsQueryVariables>(GetNotificationsDocument, options);
}
export function useGetNotificationsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetNotificationsQuery, RGetNotificationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetNotificationsQuery, RGetNotificationsQueryVariables>(GetNotificationsDocument, options);
}
export type GetNotificationsQueryRemoteHookResult = ReturnType<typeof useGetNotificationsQueryRemote>;
export type GetNotificationsLazyQueryRemoteHookResult = ReturnType<typeof useGetNotificationsLazyQueryRemote>;
export type GetNotificationsQueryResult = Apollo.QueryResult<RGetNotificationsQuery, RGetNotificationsQueryVariables>;
export const MarkAllNotificationsAsSeenDocument = gql`
  mutation markAllNotificationsAsSeen {
    markAllNotificationsAsSeen {
      ...NotificationFragment
    }
  }
  ${NotificationFragmentFragmentDoc}
`;
export type RMarkAllNotificationsAsSeenMutationFn = Apollo.MutationFunction<
  RMarkAllNotificationsAsSeenMutation,
  RMarkAllNotificationsAsSeenMutationVariables
>;

/**
 * __useMarkAllNotificationsAsSeenMutationRemote__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsSeenMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsSeenMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsSeenMutationRemote, { data, loading, error }] = useMarkAllNotificationsAsSeenMutationRemote({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsAsSeenMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RMarkAllNotificationsAsSeenMutation, RMarkAllNotificationsAsSeenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RMarkAllNotificationsAsSeenMutation, RMarkAllNotificationsAsSeenMutationVariables>(
    MarkAllNotificationsAsSeenDocument,
    options,
  );
}
export type MarkAllNotificationsAsSeenMutationRemoteHookResult = ReturnType<typeof useMarkAllNotificationsAsSeenMutationRemote>;
export type MarkAllNotificationsAsSeenMutationResult = Apollo.MutationResult<RMarkAllNotificationsAsSeenMutation>;
export type MarkAllNotificationsAsSeenMutationOptions = Apollo.BaseMutationOptions<
  RMarkAllNotificationsAsSeenMutation,
  RMarkAllNotificationsAsSeenMutationVariables
>;
export const MarkNotificationAsSeenDocument = gql`
  mutation markNotificationAsSeen($postId: Int!) {
    markNotificationAsSeen(postId: $postId) {
      ...NotificationFragment
    }
  }
  ${NotificationFragmentFragmentDoc}
`;
export type RMarkNotificationAsSeenMutationFn = Apollo.MutationFunction<
  RMarkNotificationAsSeenMutation,
  RMarkNotificationAsSeenMutationVariables
>;

/**
 * __useMarkNotificationAsSeenMutationRemote__
 *
 * To run a mutation, you first call `useMarkNotificationAsSeenMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsSeenMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsSeenMutationRemote, { data, loading, error }] = useMarkNotificationAsSeenMutationRemote({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useMarkNotificationAsSeenMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RMarkNotificationAsSeenMutation, RMarkNotificationAsSeenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RMarkNotificationAsSeenMutation, RMarkNotificationAsSeenMutationVariables>(
    MarkNotificationAsSeenDocument,
    options,
  );
}
export type MarkNotificationAsSeenMutationRemoteHookResult = ReturnType<typeof useMarkNotificationAsSeenMutationRemote>;
export type MarkNotificationAsSeenMutationResult = Apollo.MutationResult<RMarkNotificationAsSeenMutation>;
export type MarkNotificationAsSeenMutationOptions = Apollo.BaseMutationOptions<
  RMarkNotificationAsSeenMutation,
  RMarkNotificationAsSeenMutationVariables
>;
export const GetProductOrdersFlatDocument = gql`
  query getProductOrdersFlat($productId: Int!, $stateIds: [Int]!, $page: Int, $pageSize: Int) {
    getProductOrdersFlat(productId: $productId, stateIds: $stateIds, page: $page, pageSize: $pageSize) {
      total
      totalPages
      productOrders {
        orderId
        productId
        productVariantId
        spaceId
        stateId
        userId
        username
        email
        realm
        profileImage
      }
    }
  }
`;

/**
 * __useGetProductOrdersFlatQueryRemote__
 *
 * To run a query within a React component, call `useGetProductOrdersFlatQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetProductOrdersFlatQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductOrdersFlatQueryRemote({
 *   variables: {
 *      productId: // value for 'productId'
 *      stateIds: // value for 'stateIds'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetProductOrdersFlatQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RGetProductOrdersFlatQuery, RGetProductOrdersFlatQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetProductOrdersFlatQuery, RGetProductOrdersFlatQueryVariables>(GetProductOrdersFlatDocument, options);
}
export function useGetProductOrdersFlatLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetProductOrdersFlatQuery, RGetProductOrdersFlatQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetProductOrdersFlatQuery, RGetProductOrdersFlatQueryVariables>(
    GetProductOrdersFlatDocument,
    options,
  );
}
export type GetProductOrdersFlatQueryRemoteHookResult = ReturnType<typeof useGetProductOrdersFlatQueryRemote>;
export type GetProductOrdersFlatLazyQueryRemoteHookResult = ReturnType<typeof useGetProductOrdersFlatLazyQueryRemote>;
export type GetProductOrdersFlatQueryResult = Apollo.QueryResult<RGetProductOrdersFlatQuery, RGetProductOrdersFlatQueryVariables>;
export const GetAllOrdersFilteredDocument = gql`
  query getAllOrdersFiltered($stateId: Int, $productId: Int, $pageSize: Int, $page: Int, $userId: Int) {
    getAllOrdersFiltered(stateId: $stateId, productId: $productId, pageSize: $pageSize, page: $page, userId: $userId) {
      total
      totalPages
      productOrders {
        created
        orderId
        productId
        productVariantId
        spaceId
        stateId
        stateName
        userId
        user {
          username
          id
          email
        }
        products {
          id
          label
          name
          productId
        }
      }
    }
  }
`;

/**
 * __useGetAllOrdersFilteredQueryRemote__
 *
 * To run a query within a React component, call `useGetAllOrdersFilteredQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrdersFilteredQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrdersFilteredQueryRemote({
 *   variables: {
 *      stateId: // value for 'stateId'
 *      productId: // value for 'productId'
 *      pageSize: // value for 'pageSize'
 *      page: // value for 'page'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAllOrdersFilteredQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetAllOrdersFilteredQuery, RGetAllOrdersFilteredQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetAllOrdersFilteredQuery, RGetAllOrdersFilteredQueryVariables>(GetAllOrdersFilteredDocument, options);
}
export function useGetAllOrdersFilteredLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetAllOrdersFilteredQuery, RGetAllOrdersFilteredQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetAllOrdersFilteredQuery, RGetAllOrdersFilteredQueryVariables>(
    GetAllOrdersFilteredDocument,
    options,
  );
}
export type GetAllOrdersFilteredQueryRemoteHookResult = ReturnType<typeof useGetAllOrdersFilteredQueryRemote>;
export type GetAllOrdersFilteredLazyQueryRemoteHookResult = ReturnType<typeof useGetAllOrdersFilteredLazyQueryRemote>;
export type GetAllOrdersFilteredQueryResult = Apollo.QueryResult<RGetAllOrdersFilteredQuery, RGetAllOrdersFilteredQueryVariables>;
export const GetApprovalsFilteredDocument = gql`
  query getApprovalsFiltered($stateId: Int, $productId: Int, $pageSize: Int, $page: Int, $userId: Int) {
    getApprovalsFiltered(stateId: $stateId, productId: $productId, pageSize: $pageSize, page: $page, userId: $userId) {
      total
      totalPages
      productOrders {
        created
        orderId
        productId
        productVariantId
        spaceId
        stateId
        stateName
        note
        userId
        user {
          username
          id
          email
        }
        products {
          id
          label
          name
          productId
        }
      }
    }
  }
`;

/**
 * __useGetApprovalsFilteredQueryRemote__
 *
 * To run a query within a React component, call `useGetApprovalsFilteredQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalsFilteredQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalsFilteredQueryRemote({
 *   variables: {
 *      stateId: // value for 'stateId'
 *      productId: // value for 'productId'
 *      pageSize: // value for 'pageSize'
 *      page: // value for 'page'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetApprovalsFilteredQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetApprovalsFilteredQuery, RGetApprovalsFilteredQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetApprovalsFilteredQuery, RGetApprovalsFilteredQueryVariables>(GetApprovalsFilteredDocument, options);
}
export function useGetApprovalsFilteredLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetApprovalsFilteredQuery, RGetApprovalsFilteredQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetApprovalsFilteredQuery, RGetApprovalsFilteredQueryVariables>(
    GetApprovalsFilteredDocument,
    options,
  );
}
export type GetApprovalsFilteredQueryRemoteHookResult = ReturnType<typeof useGetApprovalsFilteredQueryRemote>;
export type GetApprovalsFilteredLazyQueryRemoteHookResult = ReturnType<typeof useGetApprovalsFilteredLazyQueryRemote>;
export type GetApprovalsFilteredQueryResult = Apollo.QueryResult<RGetApprovalsFilteredQuery, RGetApprovalsFilteredQueryVariables>;
export const GetAllOrdersByStateDocument = gql`
  query getAllOrdersByState($stateId: Int!) {
    getAllOrdersByState(stateId: $stateId) {
      id
    }
  }
`;

/**
 * __useGetAllOrdersByStateQueryRemote__
 *
 * To run a query within a React component, call `useGetAllOrdersByStateQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrdersByStateQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrdersByStateQueryRemote({
 *   variables: {
 *      stateId: // value for 'stateId'
 *   },
 * });
 */
export function useGetAllOrdersByStateQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RGetAllOrdersByStateQuery, RGetAllOrdersByStateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetAllOrdersByStateQuery, RGetAllOrdersByStateQueryVariables>(GetAllOrdersByStateDocument, options);
}
export function useGetAllOrdersByStateLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetAllOrdersByStateQuery, RGetAllOrdersByStateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetAllOrdersByStateQuery, RGetAllOrdersByStateQueryVariables>(GetAllOrdersByStateDocument, options);
}
export type GetAllOrdersByStateQueryRemoteHookResult = ReturnType<typeof useGetAllOrdersByStateQueryRemote>;
export type GetAllOrdersByStateLazyQueryRemoteHookResult = ReturnType<typeof useGetAllOrdersByStateLazyQueryRemote>;
export type GetAllOrdersByStateQueryResult = Apollo.QueryResult<RGetAllOrdersByStateQuery, RGetAllOrdersByStateQueryVariables>;
export const UpdateOrderDocument = gql`
  mutation updateOrder($orderId: Int!, $stateId: Int!) {
    updateOrder(orderId: $orderId, stateId: $stateId) {
      orderId
    }
  }
`;
export type RUpdateOrderMutationFn = Apollo.MutationFunction<RUpdateOrderMutation, RUpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutationRemote__
 *
 * To run a mutation, you first call `useUpdateOrderMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutationRemote, { data, loading, error }] = useUpdateOrderMutationRemote({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      stateId: // value for 'stateId'
 *   },
 * });
 */
export function useUpdateOrderMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpdateOrderMutation, RUpdateOrderMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpdateOrderMutation, RUpdateOrderMutationVariables>(UpdateOrderDocument, options);
}
export type UpdateOrderMutationRemoteHookResult = ReturnType<typeof useUpdateOrderMutationRemote>;
export type UpdateOrderMutationResult = Apollo.MutationResult<RUpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<RUpdateOrderMutation, RUpdateOrderMutationVariables>;
export const ApplyOrderRulesDocument = gql`
  mutation applyOrderRules($orderId: Int!) {
    applyOrderRules(orderId: $orderId) {
      orderId
    }
  }
`;
export type RApplyOrderRulesMutationFn = Apollo.MutationFunction<RApplyOrderRulesMutation, RApplyOrderRulesMutationVariables>;

/**
 * __useApplyOrderRulesMutationRemote__
 *
 * To run a mutation, you first call `useApplyOrderRulesMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyOrderRulesMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyOrderRulesMutationRemote, { data, loading, error }] = useApplyOrderRulesMutationRemote({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useApplyOrderRulesMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RApplyOrderRulesMutation, RApplyOrderRulesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RApplyOrderRulesMutation, RApplyOrderRulesMutationVariables>(ApplyOrderRulesDocument, options);
}
export type ApplyOrderRulesMutationRemoteHookResult = ReturnType<typeof useApplyOrderRulesMutationRemote>;
export type ApplyOrderRulesMutationResult = Apollo.MutationResult<RApplyOrderRulesMutation>;
export type ApplyOrderRulesMutationOptions = Apollo.BaseMutationOptions<
  RApplyOrderRulesMutation,
  RApplyOrderRulesMutationVariables
>;
export const GetAllProductsShortDocument = gql`
  query getAllProductsShort {
    getAllProductsShort {
      id
      name
    }
  }
`;

/**
 * __useGetAllProductsShortQueryRemote__
 *
 * To run a query within a React component, call `useGetAllProductsShortQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductsShortQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductsShortQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProductsShortQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetAllProductsShortQuery, RGetAllProductsShortQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetAllProductsShortQuery, RGetAllProductsShortQueryVariables>(GetAllProductsShortDocument, options);
}
export function useGetAllProductsShortLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetAllProductsShortQuery, RGetAllProductsShortQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetAllProductsShortQuery, RGetAllProductsShortQueryVariables>(GetAllProductsShortDocument, options);
}
export type GetAllProductsShortQueryRemoteHookResult = ReturnType<typeof useGetAllProductsShortQueryRemote>;
export type GetAllProductsShortLazyQueryRemoteHookResult = ReturnType<typeof useGetAllProductsShortLazyQueryRemote>;
export type GetAllProductsShortQueryResult = Apollo.QueryResult<RGetAllProductsShortQuery, RGetAllProductsShortQueryVariables>;
export const GetOrderHistoryByIdDocument = gql`
  query getOrderHistoryById($orderId: Int) {
    getOrderHistoryById(orderId: $orderId) {
      orderRowId
      stateId
      stateName
      updatedAt
      updatedBy {
        id
        username
      }
      error
    }
  }
`;

/**
 * __useGetOrderHistoryByIdQueryRemote__
 *
 * To run a query within a React component, call `useGetOrderHistoryByIdQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderHistoryByIdQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderHistoryByIdQueryRemote({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderHistoryByIdQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetOrderHistoryByIdQuery, RGetOrderHistoryByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetOrderHistoryByIdQuery, RGetOrderHistoryByIdQueryVariables>(GetOrderHistoryByIdDocument, options);
}
export function useGetOrderHistoryByIdLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetOrderHistoryByIdQuery, RGetOrderHistoryByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetOrderHistoryByIdQuery, RGetOrderHistoryByIdQueryVariables>(GetOrderHistoryByIdDocument, options);
}
export type GetOrderHistoryByIdQueryRemoteHookResult = ReturnType<typeof useGetOrderHistoryByIdQueryRemote>;
export type GetOrderHistoryByIdLazyQueryRemoteHookResult = ReturnType<typeof useGetOrderHistoryByIdLazyQueryRemote>;
export type GetOrderHistoryByIdQueryResult = Apollo.QueryResult<RGetOrderHistoryByIdQuery, RGetOrderHistoryByIdQueryVariables>;
export const ProductParentsByIdDocument = gql`
  query productParentsById($id: Int!, $filter: ProductParentsFilter!, $userId: Int!) {
    getProduct(id: $id) {
      id
      learningContentUrnV2
      parents(filter: $filter) {
        id
        title
        userLastParticipation(userId: $userId) {
          id
        }
      }
    }
  }
`;

/**
 * __useProductParentsByIdQueryRemote__
 *
 * To run a query within a React component, call `useProductParentsByIdQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useProductParentsByIdQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductParentsByIdQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProductParentsByIdQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RProductParentsByIdQuery, RProductParentsByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RProductParentsByIdQuery, RProductParentsByIdQueryVariables>(ProductParentsByIdDocument, options);
}
export function useProductParentsByIdLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RProductParentsByIdQuery, RProductParentsByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RProductParentsByIdQuery, RProductParentsByIdQueryVariables>(ProductParentsByIdDocument, options);
}
export type ProductParentsByIdQueryRemoteHookResult = ReturnType<typeof useProductParentsByIdQueryRemote>;
export type ProductParentsByIdLazyQueryRemoteHookResult = ReturnType<typeof useProductParentsByIdLazyQueryRemote>;
export type ProductParentsByIdQueryResult = Apollo.QueryResult<RProductParentsByIdQuery, RProductParentsByIdQueryVariables>;
export const GetLearnifierCoursesDocument = gql`
  query getLearnifierCourses {
    getLearnifierCourses {
      name
      host
      organizationId
      projectId
      description
      title
      picture
      status
      adminLink
      locale
      timezone
      country
      resource
    }
  }
`;

/**
 * __useGetLearnifierCoursesQueryRemote__
 *
 * To run a query within a React component, call `useGetLearnifierCoursesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetLearnifierCoursesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearnifierCoursesQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useGetLearnifierCoursesQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetLearnifierCoursesQuery, RGetLearnifierCoursesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetLearnifierCoursesQuery, RGetLearnifierCoursesQueryVariables>(GetLearnifierCoursesDocument, options);
}
export function useGetLearnifierCoursesLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetLearnifierCoursesQuery, RGetLearnifierCoursesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetLearnifierCoursesQuery, RGetLearnifierCoursesQueryVariables>(
    GetLearnifierCoursesDocument,
    options,
  );
}
export type GetLearnifierCoursesQueryRemoteHookResult = ReturnType<typeof useGetLearnifierCoursesQueryRemote>;
export type GetLearnifierCoursesLazyQueryRemoteHookResult = ReturnType<typeof useGetLearnifierCoursesLazyQueryRemote>;
export type GetLearnifierCoursesQueryResult = Apollo.QueryResult<RGetLearnifierCoursesQuery, RGetLearnifierCoursesQueryVariables>;
export const EffortForRealmDocument = gql`
  query effortForRealm($realm: String!, $fromTime: timestamptz!, $toTime: timestamptz!) {
    reportingAggregationEffortForRealm(
      where: { realm: { _eq: $realm }, fromTime: { _gte: $fromTime }, toTime: { _gte: $toTime } }
      limit: 1
    ) {
      totalEffort
      averageEffort
      p90Effort
      p80Effort
      p70Effort
      p60Effort
      p50Effort
      fromTime
      toTime
    }
  }
`;

/**
 * __useEffortForRealmQueryRemote__
 *
 * To run a query within a React component, call `useEffortForRealmQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useEffortForRealmQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEffortForRealmQueryRemote({
 *   variables: {
 *      realm: // value for 'realm'
 *      fromTime: // value for 'fromTime'
 *      toTime: // value for 'toTime'
 *   },
 * });
 */
export function useEffortForRealmQueryRemote(
  baseOptions: Apollo.QueryHookOptions<REffortForRealmQuery, REffortForRealmQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<REffortForRealmQuery, REffortForRealmQueryVariables>(EffortForRealmDocument, options);
}
export function useEffortForRealmLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<REffortForRealmQuery, REffortForRealmQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<REffortForRealmQuery, REffortForRealmQueryVariables>(EffortForRealmDocument, options);
}
export type EffortForRealmQueryRemoteHookResult = ReturnType<typeof useEffortForRealmQueryRemote>;
export type EffortForRealmLazyQueryRemoteHookResult = ReturnType<typeof useEffortForRealmLazyQueryRemote>;
export type EffortForRealmQueryResult = Apollo.QueryResult<REffortForRealmQuery, REffortForRealmQueryVariables>;
export const GetRealmsDocument = gql`
  query getRealms {
    realms {
      realm
      name
    }
  }
`;

/**
 * __useGetRealmsQueryRemote__
 *
 * To run a query within a React component, call `useGetRealmsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetRealmsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRealmsQueryRemote({
 *   variables: {
 *   },
 * });
 */
export function useGetRealmsQueryRemote(baseOptions?: Apollo.QueryHookOptions<RGetRealmsQuery, RGetRealmsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetRealmsQuery, RGetRealmsQueryVariables>(GetRealmsDocument, options);
}
export function useGetRealmsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetRealmsQuery, RGetRealmsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetRealmsQuery, RGetRealmsQueryVariables>(GetRealmsDocument, options);
}
export type GetRealmsQueryRemoteHookResult = ReturnType<typeof useGetRealmsQueryRemote>;
export type GetRealmsLazyQueryRemoteHookResult = ReturnType<typeof useGetRealmsLazyQueryRemote>;
export type GetRealmsQueryResult = Apollo.QueryResult<RGetRealmsQuery, RGetRealmsQueryVariables>;
export const RealmConfigDocument = gql`
  query realmConfig($realm: String!) {
    realmConfig(realm: $realm) {
      heroImageUrl
      heroVideoUrl
    }
  }
`;

/**
 * __useRealmConfigQueryRemote__
 *
 * To run a query within a React component, call `useRealmConfigQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useRealmConfigQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealmConfigQueryRemote({
 *   variables: {
 *      realm: // value for 'realm'
 *   },
 * });
 */
export function useRealmConfigQueryRemote(baseOptions: Apollo.QueryHookOptions<RRealmConfigQuery, RRealmConfigQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RRealmConfigQuery, RRealmConfigQueryVariables>(RealmConfigDocument, options);
}
export function useRealmConfigLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RRealmConfigQuery, RRealmConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RRealmConfigQuery, RRealmConfigQueryVariables>(RealmConfigDocument, options);
}
export type RealmConfigQueryRemoteHookResult = ReturnType<typeof useRealmConfigQueryRemote>;
export type RealmConfigLazyQueryRemoteHookResult = ReturnType<typeof useRealmConfigLazyQueryRemote>;
export type RealmConfigQueryResult = Apollo.QueryResult<RRealmConfigQuery, RRealmConfigQueryVariables>;
export const CreateSelfTrackedLearningDocument = gql`
  mutation createSelfTrackedLearning($userSelfTrackedLearning: CreateSelfTrackedLearningInput!) {
    createSelfTrackedLearning(input: $userSelfTrackedLearning) {
      success
    }
  }
`;
export type RCreateSelfTrackedLearningMutationFn = Apollo.MutationFunction<
  RCreateSelfTrackedLearningMutation,
  RCreateSelfTrackedLearningMutationVariables
>;

/**
 * __useCreateSelfTrackedLearningMutationRemote__
 *
 * To run a mutation, you first call `useCreateSelfTrackedLearningMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSelfTrackedLearningMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSelfTrackedLearningMutationRemote, { data, loading, error }] = useCreateSelfTrackedLearningMutationRemote({
 *   variables: {
 *      userSelfTrackedLearning: // value for 'userSelfTrackedLearning'
 *   },
 * });
 */
export function useCreateSelfTrackedLearningMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCreateSelfTrackedLearningMutation, RCreateSelfTrackedLearningMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateSelfTrackedLearningMutation, RCreateSelfTrackedLearningMutationVariables>(
    CreateSelfTrackedLearningDocument,
    options,
  );
}
export type CreateSelfTrackedLearningMutationRemoteHookResult = ReturnType<typeof useCreateSelfTrackedLearningMutationRemote>;
export type CreateSelfTrackedLearningMutationResult = Apollo.MutationResult<RCreateSelfTrackedLearningMutation>;
export type CreateSelfTrackedLearningMutationOptions = Apollo.BaseMutationOptions<
  RCreateSelfTrackedLearningMutation,
  RCreateSelfTrackedLearningMutationVariables
>;
export const GetUserSelfTrackedLearningDocument = gql`
  query getUserSelfTrackedLearning($userSelfTrackedLearningId: Int!) {
    selfTrackedLearning(id: $userSelfTrackedLearningId) {
      id
      type
      title
      description
      effort
      link
    }
  }
`;

/**
 * __useGetUserSelfTrackedLearningQueryRemote__
 *
 * To run a query within a React component, call `useGetUserSelfTrackedLearningQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSelfTrackedLearningQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSelfTrackedLearningQueryRemote({
 *   variables: {
 *      userSelfTrackedLearningId: // value for 'userSelfTrackedLearningId'
 *   },
 * });
 */
export function useGetUserSelfTrackedLearningQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RGetUserSelfTrackedLearningQuery, RGetUserSelfTrackedLearningQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetUserSelfTrackedLearningQuery, RGetUserSelfTrackedLearningQueryVariables>(
    GetUserSelfTrackedLearningDocument,
    options,
  );
}
export function useGetUserSelfTrackedLearningLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetUserSelfTrackedLearningQuery, RGetUserSelfTrackedLearningQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetUserSelfTrackedLearningQuery, RGetUserSelfTrackedLearningQueryVariables>(
    GetUserSelfTrackedLearningDocument,
    options,
  );
}
export type GetUserSelfTrackedLearningQueryRemoteHookResult = ReturnType<typeof useGetUserSelfTrackedLearningQueryRemote>;
export type GetUserSelfTrackedLearningLazyQueryRemoteHookResult = ReturnType<typeof useGetUserSelfTrackedLearningLazyQueryRemote>;
export type GetUserSelfTrackedLearningQueryResult = Apollo.QueryResult<
  RGetUserSelfTrackedLearningQuery,
  RGetUserSelfTrackedLearningQueryVariables
>;
export const UpdateUserSelfTrackedLearningDocument = gql`
  mutation updateUserSelfTrackedLearning($userSelfTrackedLearning: UpdateSelfTrackedLearningInput!) {
    updateSelfTrackedLearning(input: $userSelfTrackedLearning) {
      success
    }
  }
`;
export type RUpdateUserSelfTrackedLearningMutationFn = Apollo.MutationFunction<
  RUpdateUserSelfTrackedLearningMutation,
  RUpdateUserSelfTrackedLearningMutationVariables
>;

/**
 * __useUpdateUserSelfTrackedLearningMutationRemote__
 *
 * To run a mutation, you first call `useUpdateUserSelfTrackedLearningMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSelfTrackedLearningMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSelfTrackedLearningMutationRemote, { data, loading, error }] = useUpdateUserSelfTrackedLearningMutationRemote({
 *   variables: {
 *      userSelfTrackedLearning: // value for 'userSelfTrackedLearning'
 *   },
 * });
 */
export function useUpdateUserSelfTrackedLearningMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RUpdateUserSelfTrackedLearningMutation,
    RUpdateUserSelfTrackedLearningMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpdateUserSelfTrackedLearningMutation, RUpdateUserSelfTrackedLearningMutationVariables>(
    UpdateUserSelfTrackedLearningDocument,
    options,
  );
}
export type UpdateUserSelfTrackedLearningMutationRemoteHookResult = ReturnType<
  typeof useUpdateUserSelfTrackedLearningMutationRemote
>;
export type UpdateUserSelfTrackedLearningMutationResult = Apollo.MutationResult<RUpdateUserSelfTrackedLearningMutation>;
export type UpdateUserSelfTrackedLearningMutationOptions = Apollo.BaseMutationOptions<
  RUpdateUserSelfTrackedLearningMutation,
  RUpdateUserSelfTrackedLearningMutationVariables
>;
export const RemoveUserSelfTrackedLearningDocument = gql`
  mutation removeUserSelfTrackedLearning($userSelfTrackedLearningId: Int!) {
    removeSelfTrackedLearning(id: $userSelfTrackedLearningId) {
      success
    }
  }
`;
export type RRemoveUserSelfTrackedLearningMutationFn = Apollo.MutationFunction<
  RRemoveUserSelfTrackedLearningMutation,
  RRemoveUserSelfTrackedLearningMutationVariables
>;

/**
 * __useRemoveUserSelfTrackedLearningMutationRemote__
 *
 * To run a mutation, you first call `useRemoveUserSelfTrackedLearningMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserSelfTrackedLearningMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserSelfTrackedLearningMutationRemote, { data, loading, error }] = useRemoveUserSelfTrackedLearningMutationRemote({
 *   variables: {
 *      userSelfTrackedLearningId: // value for 'userSelfTrackedLearningId'
 *   },
 * });
 */
export function useRemoveUserSelfTrackedLearningMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<
    RRemoveUserSelfTrackedLearningMutation,
    RRemoveUserSelfTrackedLearningMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RRemoveUserSelfTrackedLearningMutation, RRemoveUserSelfTrackedLearningMutationVariables>(
    RemoveUserSelfTrackedLearningDocument,
    options,
  );
}
export type RemoveUserSelfTrackedLearningMutationRemoteHookResult = ReturnType<
  typeof useRemoveUserSelfTrackedLearningMutationRemote
>;
export type RemoveUserSelfTrackedLearningMutationResult = Apollo.MutationResult<RRemoveUserSelfTrackedLearningMutation>;
export type RemoveUserSelfTrackedLearningMutationOptions = Apollo.BaseMutationOptions<
  RRemoveUserSelfTrackedLearningMutation,
  RRemoveUserSelfTrackedLearningMutationVariables
>;
export const SelfTrackedLearningsDocument = gql`
  query selfTrackedLearnings($idIN: [Int!], $pagination: Pagination) {
    selfTrackedLearnings(filter: { idIN: $idIN }, pagination: $pagination) {
      data {
        id
        type
        title
        description
        effort
        link
      }
      limit
      page
      total
    }
  }
`;

/**
 * __useSelfTrackedLearningsQueryRemote__
 *
 * To run a query within a React component, call `useSelfTrackedLearningsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useSelfTrackedLearningsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfTrackedLearningsQueryRemote({
 *   variables: {
 *      idIN: // value for 'idIN'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSelfTrackedLearningsQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RSelfTrackedLearningsQuery, RSelfTrackedLearningsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RSelfTrackedLearningsQuery, RSelfTrackedLearningsQueryVariables>(SelfTrackedLearningsDocument, options);
}
export function useSelfTrackedLearningsLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RSelfTrackedLearningsQuery, RSelfTrackedLearningsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RSelfTrackedLearningsQuery, RSelfTrackedLearningsQueryVariables>(
    SelfTrackedLearningsDocument,
    options,
  );
}
export type SelfTrackedLearningsQueryRemoteHookResult = ReturnType<typeof useSelfTrackedLearningsQueryRemote>;
export type SelfTrackedLearningsLazyQueryRemoteHookResult = ReturnType<typeof useSelfTrackedLearningsLazyQueryRemote>;
export type SelfTrackedLearningsQueryResult = Apollo.QueryResult<RSelfTrackedLearningsQuery, RSelfTrackedLearningsQueryVariables>;
export const SpaceMembersDocument = gql`
  query spaceMembers($filter: SpaceMemberFilter!, $pagination: Pagination!) {
    spaceMembers(filter: $filter, pagination: $pagination) {
      data {
        id
        email
        realm
        spaceId
        firstname
        lastname
        username
        profileImage
      }
    }
  }
`;

/**
 * __useSpaceMembersQueryRemote__
 *
 * To run a query within a React component, call `useSpaceMembersQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useSpaceMembersQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceMembersQueryRemote({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSpaceMembersQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RSpaceMembersQuery, RSpaceMembersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RSpaceMembersQuery, RSpaceMembersQueryVariables>(SpaceMembersDocument, options);
}
export function useSpaceMembersLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RSpaceMembersQuery, RSpaceMembersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RSpaceMembersQuery, RSpaceMembersQueryVariables>(SpaceMembersDocument, options);
}
export type SpaceMembersQueryRemoteHookResult = ReturnType<typeof useSpaceMembersQueryRemote>;
export type SpaceMembersLazyQueryRemoteHookResult = ReturnType<typeof useSpaceMembersLazyQueryRemote>;
export type SpaceMembersQueryResult = Apollo.QueryResult<RSpaceMembersQuery, RSpaceMembersQueryVariables>;
export const SpacesDocument = gql`
  query spaces($withPermissions: Boolean!, $withContentOrigins: Boolean!) {
    spaces(pagination: { limit: -1 }) {
      data {
        id
        realm
        label
        name
        permissions @include(if: $withPermissions) {
          hasWriteAccessToLearningContent
        }
        contentOrigins(pagination: { limit: -1 }) @include(if: $withContentOrigins) {
          data {
            id
            provider {
              id
              title
              type
            }
          }
        }
      }
    }
  }
`;

/**
 * __useSpacesQueryRemote__
 *
 * To run a query within a React component, call `useSpacesQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useSpacesQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpacesQueryRemote({
 *   variables: {
 *      withPermissions: // value for 'withPermissions'
 *      withContentOrigins: // value for 'withContentOrigins'
 *   },
 * });
 */
export function useSpacesQueryRemote(baseOptions: Apollo.QueryHookOptions<RSpacesQuery, RSpacesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RSpacesQuery, RSpacesQueryVariables>(SpacesDocument, options);
}
export function useSpacesLazyQueryRemote(baseOptions?: Apollo.LazyQueryHookOptions<RSpacesQuery, RSpacesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RSpacesQuery, RSpacesQueryVariables>(SpacesDocument, options);
}
export type SpacesQueryRemoteHookResult = ReturnType<typeof useSpacesQueryRemote>;
export type SpacesLazyQueryRemoteHookResult = ReturnType<typeof useSpacesLazyQueryRemote>;
export type SpacesQueryResult = Apollo.QueryResult<RSpacesQuery, RSpacesQueryVariables>;
export const TeamsDocument = gql`
  query teams($filter: TeamsFilter!, $pagination: Pagination!, $sort: TeamsSort!, $withSubTeams: Boolean!) {
    teams(filter: $filter, pagination: $pagination, sort: $sort) {
      data {
        ...TeamItemFragment
        subTeams(filter: { indirect: true }, sort: $sort, pagination: { limit: -1 }) @include(if: $withSubTeams) {
          data {
            ...TeamItemFragment
            members: teamUsers(filter: { role: member }) {
              total
            }
            managers: teamUsers(filter: { role: manager }) {
              total
            }
          }
        }
        members: teamUsers(filter: { role: member }) {
          total
        }
        managers: teamUsers(filter: { role: manager }) {
          total
        }
      }
      limit
      page
      total
    }
  }
  ${TeamItemFragmentFragmentDoc}
`;

/**
 * __useTeamsQueryRemote__
 *
 * To run a query within a React component, call `useTeamsQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQueryRemote({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      withSubTeams: // value for 'withSubTeams'
 *   },
 * });
 */
export function useTeamsQueryRemote(baseOptions: Apollo.QueryHookOptions<RTeamsQuery, RTeamsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RTeamsQuery, RTeamsQueryVariables>(TeamsDocument, options);
}
export function useTeamsLazyQueryRemote(baseOptions?: Apollo.LazyQueryHookOptions<RTeamsQuery, RTeamsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RTeamsQuery, RTeamsQueryVariables>(TeamsDocument, options);
}
export type TeamsQueryRemoteHookResult = ReturnType<typeof useTeamsQueryRemote>;
export type TeamsLazyQueryRemoteHookResult = ReturnType<typeof useTeamsLazyQueryRemote>;
export type TeamsQueryResult = Apollo.QueryResult<RTeamsQuery, RTeamsQueryVariables>;
export const TeamDocument = gql`
  query team($id: Int!, $withParentTeam: Boolean!, $withParentTeams: Boolean!) {
    team(id: $id) {
      ...TeamItemFragment
      parentTeam: parentTeams(filter: { indirect: false }, pagination: { page: 1, limit: 1 }) @include(if: $withParentTeam) {
        data {
          ...TeamItemFragment
        }
      }
      allParentTeams: parentTeams(filter: { indirect: true }, pagination: { page: 1, limit: -1 }) @include(if: $withParentTeams) {
        data {
          ...TeamItemFragment
        }
      }
    }
  }
  ${TeamItemFragmentFragmentDoc}
`;

/**
 * __useTeamQueryRemote__
 *
 * To run a query within a React component, call `useTeamQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useTeamQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQueryRemote({
 *   variables: {
 *      id: // value for 'id'
 *      withParentTeam: // value for 'withParentTeam'
 *      withParentTeams: // value for 'withParentTeams'
 *   },
 * });
 */
export function useTeamQueryRemote(baseOptions: Apollo.QueryHookOptions<RTeamQuery, RTeamQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RTeamQuery, RTeamQueryVariables>(TeamDocument, options);
}
export function useTeamLazyQueryRemote(baseOptions?: Apollo.LazyQueryHookOptions<RTeamQuery, RTeamQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RTeamQuery, RTeamQueryVariables>(TeamDocument, options);
}
export type TeamQueryRemoteHookResult = ReturnType<typeof useTeamQueryRemote>;
export type TeamLazyQueryRemoteHookResult = ReturnType<typeof useTeamLazyQueryRemote>;
export type TeamQueryResult = Apollo.QueryResult<RTeamQuery, RTeamQueryVariables>;
export const TeamCreateDocument = gql`
  mutation teamCreate($input: TeamCreateInput!) {
    teamCreate(input: $input) {
      id
      name
      parentTeamId
    }
  }
`;
export type RTeamCreateMutationFn = Apollo.MutationFunction<RTeamCreateMutation, RTeamCreateMutationVariables>;

/**
 * __useTeamCreateMutationRemote__
 *
 * To run a mutation, you first call `useTeamCreateMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamCreateMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamCreateMutationRemote, { data, loading, error }] = useTeamCreateMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeamCreateMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RTeamCreateMutation, RTeamCreateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RTeamCreateMutation, RTeamCreateMutationVariables>(TeamCreateDocument, options);
}
export type TeamCreateMutationRemoteHookResult = ReturnType<typeof useTeamCreateMutationRemote>;
export type TeamCreateMutationResult = Apollo.MutationResult<RTeamCreateMutation>;
export type TeamCreateMutationOptions = Apollo.BaseMutationOptions<RTeamCreateMutation, RTeamCreateMutationVariables>;
export const TeamUpdateDocument = gql`
  mutation teamUpdate($input: TeamUpdateInput!) {
    teamUpdate(input: $input) {
      id
      name
      parentTeamId
    }
  }
`;
export type RTeamUpdateMutationFn = Apollo.MutationFunction<RTeamUpdateMutation, RTeamUpdateMutationVariables>;

/**
 * __useTeamUpdateMutationRemote__
 *
 * To run a mutation, you first call `useTeamUpdateMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamUpdateMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamUpdateMutationRemote, { data, loading, error }] = useTeamUpdateMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeamUpdateMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RTeamUpdateMutation, RTeamUpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RTeamUpdateMutation, RTeamUpdateMutationVariables>(TeamUpdateDocument, options);
}
export type TeamUpdateMutationRemoteHookResult = ReturnType<typeof useTeamUpdateMutationRemote>;
export type TeamUpdateMutationResult = Apollo.MutationResult<RTeamUpdateMutation>;
export type TeamUpdateMutationOptions = Apollo.BaseMutationOptions<RTeamUpdateMutation, RTeamUpdateMutationVariables>;
export const TeamDeleteDocument = gql`
  mutation teamDelete($id: Int!) {
    teamDelete(id: $id)
  }
`;
export type RTeamDeleteMutationFn = Apollo.MutationFunction<RTeamDeleteMutation, RTeamDeleteMutationVariables>;

/**
 * __useTeamDeleteMutationRemote__
 *
 * To run a mutation, you first call `useTeamDeleteMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamDeleteMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamDeleteMutationRemote, { data, loading, error }] = useTeamDeleteMutationRemote({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamDeleteMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RTeamDeleteMutation, RTeamDeleteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RTeamDeleteMutation, RTeamDeleteMutationVariables>(TeamDeleteDocument, options);
}
export type TeamDeleteMutationRemoteHookResult = ReturnType<typeof useTeamDeleteMutationRemote>;
export type TeamDeleteMutationResult = Apollo.MutationResult<RTeamDeleteMutation>;
export type TeamDeleteMutationOptions = Apollo.BaseMutationOptions<RTeamDeleteMutation, RTeamDeleteMutationVariables>;
export const TeamUsersDocument = gql`
  query teamUsers($filter: TeamUsersFilter!, $pagination: Pagination, $sort: TeamUsersSort) {
    teamUsers(filter: $filter, pagination: $pagination, sort: $sort) {
      data {
        ...TeamUserFragment
        user {
          ...UserFragment
        }
      }
      limit
      page
      total
    }
  }
  ${TeamUserFragmentFragmentDoc}
  ${UserFragmentFragmentDoc}
`;

/**
 * __useTeamUsersQueryRemote__
 *
 * To run a query within a React component, call `useTeamUsersQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useTeamUsersQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamUsersQueryRemote({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTeamUsersQueryRemote(baseOptions: Apollo.QueryHookOptions<RTeamUsersQuery, RTeamUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RTeamUsersQuery, RTeamUsersQueryVariables>(TeamUsersDocument, options);
}
export function useTeamUsersLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RTeamUsersQuery, RTeamUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RTeamUsersQuery, RTeamUsersQueryVariables>(TeamUsersDocument, options);
}
export type TeamUsersQueryRemoteHookResult = ReturnType<typeof useTeamUsersQueryRemote>;
export type TeamUsersLazyQueryRemoteHookResult = ReturnType<typeof useTeamUsersLazyQueryRemote>;
export type TeamUsersQueryResult = Apollo.QueryResult<RTeamUsersQuery, RTeamUsersQueryVariables>;
export const TeamUsersAddDocument = gql`
  mutation teamUsersAdd($input: [TeamUsersAddInput!]!) {
    teamUsersAdd(input: $input) {
      ...TeamUserFragment
    }
  }
  ${TeamUserFragmentFragmentDoc}
`;
export type RTeamUsersAddMutationFn = Apollo.MutationFunction<RTeamUsersAddMutation, RTeamUsersAddMutationVariables>;

/**
 * __useTeamUsersAddMutationRemote__
 *
 * To run a mutation, you first call `useTeamUsersAddMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamUsersAddMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamUsersAddMutationRemote, { data, loading, error }] = useTeamUsersAddMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeamUsersAddMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RTeamUsersAddMutation, RTeamUsersAddMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RTeamUsersAddMutation, RTeamUsersAddMutationVariables>(TeamUsersAddDocument, options);
}
export type TeamUsersAddMutationRemoteHookResult = ReturnType<typeof useTeamUsersAddMutationRemote>;
export type TeamUsersAddMutationResult = Apollo.MutationResult<RTeamUsersAddMutation>;
export type TeamUsersAddMutationOptions = Apollo.BaseMutationOptions<RTeamUsersAddMutation, RTeamUsersAddMutationVariables>;
export const TeamUserChangeRoleDocument = gql`
  mutation teamUserChangeRole($input: TeamUserChangeRoleInput!) {
    teamUserChangeRole(input: $input) {
      ...TeamUserFragment
    }
  }
  ${TeamUserFragmentFragmentDoc}
`;
export type RTeamUserChangeRoleMutationFn = Apollo.MutationFunction<
  RTeamUserChangeRoleMutation,
  RTeamUserChangeRoleMutationVariables
>;

/**
 * __useTeamUserChangeRoleMutationRemote__
 *
 * To run a mutation, you first call `useTeamUserChangeRoleMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamUserChangeRoleMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamUserChangeRoleMutationRemote, { data, loading, error }] = useTeamUserChangeRoleMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeamUserChangeRoleMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RTeamUserChangeRoleMutation, RTeamUserChangeRoleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RTeamUserChangeRoleMutation, RTeamUserChangeRoleMutationVariables>(
    TeamUserChangeRoleDocument,
    options,
  );
}
export type TeamUserChangeRoleMutationRemoteHookResult = ReturnType<typeof useTeamUserChangeRoleMutationRemote>;
export type TeamUserChangeRoleMutationResult = Apollo.MutationResult<RTeamUserChangeRoleMutation>;
export type TeamUserChangeRoleMutationOptions = Apollo.BaseMutationOptions<
  RTeamUserChangeRoleMutation,
  RTeamUserChangeRoleMutationVariables
>;
export const TeamUserRemoveDocument = gql`
  mutation teamUserRemove($input: TeamUserRemoveInput!) {
    teamUserRemove(input: $input)
  }
`;
export type RTeamUserRemoveMutationFn = Apollo.MutationFunction<RTeamUserRemoveMutation, RTeamUserRemoveMutationVariables>;

/**
 * __useTeamUserRemoveMutationRemote__
 *
 * To run a mutation, you first call `useTeamUserRemoveMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamUserRemoveMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamUserRemoveMutationRemote, { data, loading, error }] = useTeamUserRemoveMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeamUserRemoveMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RTeamUserRemoveMutation, RTeamUserRemoveMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RTeamUserRemoveMutation, RTeamUserRemoveMutationVariables>(TeamUserRemoveDocument, options);
}
export type TeamUserRemoveMutationRemoteHookResult = ReturnType<typeof useTeamUserRemoveMutationRemote>;
export type TeamUserRemoveMutationResult = Apollo.MutationResult<RTeamUserRemoveMutation>;
export type TeamUserRemoveMutationOptions = Apollo.BaseMutationOptions<RTeamUserRemoveMutation, RTeamUserRemoveMutationVariables>;
export const TeamsWithUsersDocument = gql`
  query teamsWithUsers($filter: TeamsFilter) {
    teams(filter: $filter) {
      data {
        id
        name
        teamUsers {
          total
          data {
            userId
            user {
              firstname
              lastname
              profileImage
            }
          }
        }
      }
    }
  }
`;

/**
 * __useTeamsWithUsersQueryRemote__
 *
 * To run a query within a React component, call `useTeamsWithUsersQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useTeamsWithUsersQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsWithUsersQueryRemote({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTeamsWithUsersQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RTeamsWithUsersQuery, RTeamsWithUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RTeamsWithUsersQuery, RTeamsWithUsersQueryVariables>(TeamsWithUsersDocument, options);
}
export function useTeamsWithUsersLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RTeamsWithUsersQuery, RTeamsWithUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RTeamsWithUsersQuery, RTeamsWithUsersQueryVariables>(TeamsWithUsersDocument, options);
}
export type TeamsWithUsersQueryRemoteHookResult = ReturnType<typeof useTeamsWithUsersQueryRemote>;
export type TeamsWithUsersLazyQueryRemoteHookResult = ReturnType<typeof useTeamsWithUsersLazyQueryRemote>;
export type TeamsWithUsersQueryResult = Apollo.QueryResult<RTeamsWithUsersQuery, RTeamsWithUsersQueryVariables>;
export const UsersDocument = gql`
  query users($filter: UsersFilter, $pagination: Pagination, $sort: UsersSort, $withRealmRoleAssignments: Boolean!) {
    users(filter: $filter, pagination: $pagination, sort: $sort) {
      data {
        ...UserFragment
        realmRoleAssignments @include(if: $withRealmRoleAssignments) {
          realm
          role
        }
      }
      limit
      page
      total
    }
  }
  ${UserFragmentFragmentDoc}
`;

/**
 * __useUsersQueryRemote__
 *
 * To run a query within a React component, call `useUsersQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useUsersQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQueryRemote({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      withRealmRoleAssignments: // value for 'withRealmRoleAssignments'
 *   },
 * });
 */
export function useUsersQueryRemote(baseOptions: Apollo.QueryHookOptions<RUsersQuery, RUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RUsersQuery, RUsersQueryVariables>(UsersDocument, options);
}
export function useUsersLazyQueryRemote(baseOptions?: Apollo.LazyQueryHookOptions<RUsersQuery, RUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RUsersQuery, RUsersQueryVariables>(UsersDocument, options);
}
export type UsersQueryRemoteHookResult = ReturnType<typeof useUsersQueryRemote>;
export type UsersLazyQueryRemoteHookResult = ReturnType<typeof useUsersLazyQueryRemote>;
export type UsersQueryResult = Apollo.QueryResult<RUsersQuery, RUsersQueryVariables>;
export const UserChangeRealmRoleDocument = gql`
  mutation userChangeRealmRole($input: UserChangeRealmRoleInput!) {
    userChangeRealmRole(input: $input) {
      id
    }
  }
`;
export type RUserChangeRealmRoleMutationFn = Apollo.MutationFunction<
  RUserChangeRealmRoleMutation,
  RUserChangeRealmRoleMutationVariables
>;

/**
 * __useUserChangeRealmRoleMutationRemote__
 *
 * To run a mutation, you first call `useUserChangeRealmRoleMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangeRealmRoleMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangeRealmRoleMutationRemote, { data, loading, error }] = useUserChangeRealmRoleMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserChangeRealmRoleMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUserChangeRealmRoleMutation, RUserChangeRealmRoleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUserChangeRealmRoleMutation, RUserChangeRealmRoleMutationVariables>(
    UserChangeRealmRoleDocument,
    options,
  );
}
export type UserChangeRealmRoleMutationRemoteHookResult = ReturnType<typeof useUserChangeRealmRoleMutationRemote>;
export type UserChangeRealmRoleMutationResult = Apollo.MutationResult<RUserChangeRealmRoleMutation>;
export type UserChangeRealmRoleMutationOptions = Apollo.BaseMutationOptions<
  RUserChangeRealmRoleMutation,
  RUserChangeRealmRoleMutationVariables
>;
export const ChangePasswordDocument = gql`
  mutation changePassword {
    changePassword
  }
`;
export type RChangePasswordMutationFn = Apollo.MutationFunction<RChangePasswordMutation, RChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutationRemote__
 *
 * To run a mutation, you first call `useChangePasswordMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutationRemote, { data, loading, error }] = useChangePasswordMutationRemote({
 *   variables: {
 *   },
 * });
 */
export function useChangePasswordMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RChangePasswordMutation, RChangePasswordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RChangePasswordMutation, RChangePasswordMutationVariables>(ChangePasswordDocument, options);
}
export type ChangePasswordMutationRemoteHookResult = ReturnType<typeof useChangePasswordMutationRemote>;
export type ChangePasswordMutationResult = Apollo.MutationResult<RChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<RChangePasswordMutation, RChangePasswordMutationVariables>;
export const UserPreviewInviteImportDocument = gql`
  mutation userPreviewInviteImport($input: UserInviteImportPreviewInput!) {
    userPreviewInviteImport(input: $input) {
      success
      errorCause {
        code
      }
      data {
        stats {
          total
          willInvite
          alreadyInvited
          invalidEmail
          duplicateInFile
          missingRequiredField
          unknownRealm
          realmAccessDenied
        }
        rows {
          outcome
          row {
            email
            firstName
            lastName
            sourceLine
          }
        }
      }
    }
  }
`;
export type RUserPreviewInviteImportMutationFn = Apollo.MutationFunction<
  RUserPreviewInviteImportMutation,
  RUserPreviewInviteImportMutationVariables
>;

/**
 * __useUserPreviewInviteImportMutationRemote__
 *
 * To run a mutation, you first call `useUserPreviewInviteImportMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPreviewInviteImportMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPreviewInviteImportMutationRemote, { data, loading, error }] = useUserPreviewInviteImportMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserPreviewInviteImportMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUserPreviewInviteImportMutation, RUserPreviewInviteImportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUserPreviewInviteImportMutation, RUserPreviewInviteImportMutationVariables>(
    UserPreviewInviteImportDocument,
    options,
  );
}
export type UserPreviewInviteImportMutationRemoteHookResult = ReturnType<typeof useUserPreviewInviteImportMutationRemote>;
export type UserPreviewInviteImportMutationResult = Apollo.MutationResult<RUserPreviewInviteImportMutation>;
export type UserPreviewInviteImportMutationOptions = Apollo.BaseMutationOptions<
  RUserPreviewInviteImportMutation,
  RUserPreviewInviteImportMutationVariables
>;
export const UserConfirmInviteImportDocument = gql`
  mutation userConfirmInviteImport($input: UserInviteImportConfirmInput!) {
    userConfirmInviteImport(input: $input) {
      accepted
      batchId
      willInviteCount
    }
  }
`;
export type RUserConfirmInviteImportMutationFn = Apollo.MutationFunction<
  RUserConfirmInviteImportMutation,
  RUserConfirmInviteImportMutationVariables
>;

/**
 * __useUserConfirmInviteImportMutationRemote__
 *
 * To run a mutation, you first call `useUserConfirmInviteImportMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserConfirmInviteImportMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userConfirmInviteImportMutationRemote, { data, loading, error }] = useUserConfirmInviteImportMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserConfirmInviteImportMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUserConfirmInviteImportMutation, RUserConfirmInviteImportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUserConfirmInviteImportMutation, RUserConfirmInviteImportMutationVariables>(
    UserConfirmInviteImportDocument,
    options,
  );
}
export type UserConfirmInviteImportMutationRemoteHookResult = ReturnType<typeof useUserConfirmInviteImportMutationRemote>;
export type UserConfirmInviteImportMutationResult = Apollo.MutationResult<RUserConfirmInviteImportMutation>;
export type UserConfirmInviteImportMutationOptions = Apollo.BaseMutationOptions<
  RUserConfirmInviteImportMutation,
  RUserConfirmInviteImportMutationVariables
>;
export const UserInviteImportBatchStatusDocument = gql`
  query userInviteImportBatchStatus($batchId: ID!) {
    userInviteImportBatchStatus(batchId: $batchId) {
      batchId
      status
      totalRows
      processed
      invited
      skipped
      errorCount
    }
  }
`;

/**
 * __useUserInviteImportBatchStatusQueryRemote__
 *
 * To run a query within a React component, call `useUserInviteImportBatchStatusQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useUserInviteImportBatchStatusQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInviteImportBatchStatusQueryRemote({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useUserInviteImportBatchStatusQueryRemote(
  baseOptions: Apollo.QueryHookOptions<RUserInviteImportBatchStatusQuery, RUserInviteImportBatchStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RUserInviteImportBatchStatusQuery, RUserInviteImportBatchStatusQueryVariables>(
    UserInviteImportBatchStatusDocument,
    options,
  );
}
export function useUserInviteImportBatchStatusLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RUserInviteImportBatchStatusQuery, RUserInviteImportBatchStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RUserInviteImportBatchStatusQuery, RUserInviteImportBatchStatusQueryVariables>(
    UserInviteImportBatchStatusDocument,
    options,
  );
}
export type UserInviteImportBatchStatusQueryRemoteHookResult = ReturnType<typeof useUserInviteImportBatchStatusQueryRemote>;
export type UserInviteImportBatchStatusLazyQueryRemoteHookResult = ReturnType<
  typeof useUserInviteImportBatchStatusLazyQueryRemote
>;
export type UserInviteImportBatchStatusQueryResult = Apollo.QueryResult<
  RUserInviteImportBatchStatusQuery,
  RUserInviteImportBatchStatusQueryVariables
>;
export const GetUsersByEmailDocument = gql`
  query getUsersByEmail($emails: [String]) {
    getUsersByEmail(emails: $emails) {
      id
      username
      email
      realm
      profileImage
      status
    }
  }
`;

/**
 * __useGetUsersByEmailQueryRemote__
 *
 * To run a query within a React component, call `useGetUsersByEmailQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByEmailQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByEmailQueryRemote({
 *   variables: {
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useGetUsersByEmailQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RGetUsersByEmailQuery, RGetUsersByEmailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RGetUsersByEmailQuery, RGetUsersByEmailQueryVariables>(GetUsersByEmailDocument, options);
}
export function useGetUsersByEmailLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RGetUsersByEmailQuery, RGetUsersByEmailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RGetUsersByEmailQuery, RGetUsersByEmailQueryVariables>(GetUsersByEmailDocument, options);
}
export type GetUsersByEmailQueryRemoteHookResult = ReturnType<typeof useGetUsersByEmailQueryRemote>;
export type GetUsersByEmailLazyQueryRemoteHookResult = ReturnType<typeof useGetUsersByEmailLazyQueryRemote>;
export type GetUsersByEmailQueryResult = Apollo.QueryResult<RGetUsersByEmailQuery, RGetUsersByEmailQueryVariables>;
export const CreateUsersDocument = gql`
  mutation createUsers($payload: CreateUserInput) {
    createUsers(payload: $payload) {
      userId
      realm
    }
  }
`;
export type RCreateUsersMutationFn = Apollo.MutationFunction<RCreateUsersMutation, RCreateUsersMutationVariables>;

/**
 * __useCreateUsersMutationRemote__
 *
 * To run a mutation, you first call `useCreateUsersMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUsersMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUsersMutationRemote, { data, loading, error }] = useCreateUsersMutationRemote({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateUsersMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCreateUsersMutation, RCreateUsersMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCreateUsersMutation, RCreateUsersMutationVariables>(CreateUsersDocument, options);
}
export type CreateUsersMutationRemoteHookResult = ReturnType<typeof useCreateUsersMutationRemote>;
export type CreateUsersMutationResult = Apollo.MutationResult<RCreateUsersMutation>;
export type CreateUsersMutationOptions = Apollo.BaseMutationOptions<RCreateUsersMutation, RCreateUsersMutationVariables>;
export const VoidObjectDocument = gql`
  mutation voidObject($targetUserId: Int!, $objectId: String!, $registration: String!) {
    voidObject(targetUserId: $targetUserId, objectId: $objectId, registration: $registration)
  }
`;
export type RVoidObjectMutationFn = Apollo.MutationFunction<RVoidObjectMutation, RVoidObjectMutationVariables>;

/**
 * __useVoidObjectMutationRemote__
 *
 * To run a mutation, you first call `useVoidObjectMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidObjectMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidObjectMutationRemote, { data, loading, error }] = useVoidObjectMutationRemote({
 *   variables: {
 *      targetUserId: // value for 'targetUserId'
 *      objectId: // value for 'objectId'
 *      registration: // value for 'registration'
 *   },
 * });
 */
export function useVoidObjectMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RVoidObjectMutation, RVoidObjectMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RVoidObjectMutation, RVoidObjectMutationVariables>(VoidObjectDocument, options);
}
export type VoidObjectMutationRemoteHookResult = ReturnType<typeof useVoidObjectMutationRemote>;
export type VoidObjectMutationResult = Apollo.MutationResult<RVoidObjectMutation>;
export type VoidObjectMutationOptions = Apollo.BaseMutationOptions<RVoidObjectMutation, RVoidObjectMutationVariables>;
export const CompleteObjectDocument = gql`
  mutation completeObject($targetUserId: Int!, $objectId: String!, $registration: String!) {
    completeObject(targetUserId: $targetUserId, objectId: $objectId, registration: $registration)
  }
`;
export type RCompleteObjectMutationFn = Apollo.MutationFunction<RCompleteObjectMutation, RCompleteObjectMutationVariables>;

/**
 * __useCompleteObjectMutationRemote__
 *
 * To run a mutation, you first call `useCompleteObjectMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteObjectMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeObjectMutationRemote, { data, loading, error }] = useCompleteObjectMutationRemote({
 *   variables: {
 *      targetUserId: // value for 'targetUserId'
 *      objectId: // value for 'objectId'
 *      registration: // value for 'registration'
 *   },
 * });
 */
export function useCompleteObjectMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RCompleteObjectMutation, RCompleteObjectMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RCompleteObjectMutation, RCompleteObjectMutationVariables>(CompleteObjectDocument, options);
}
export type CompleteObjectMutationRemoteHookResult = ReturnType<typeof useCompleteObjectMutationRemote>;
export type CompleteObjectMutationResult = Apollo.MutationResult<RCompleteObjectMutation>;
export type CompleteObjectMutationOptions = Apollo.BaseMutationOptions<RCompleteObjectMutation, RCompleteObjectMutationVariables>;
export const DeleteXapiStateDocument = gql`
  mutation deleteXAPIState($targetUserId: Int!, $objectId: String!, $registration: String!) {
    deleteXAPIState(targetUserId: $targetUserId, objectId: $objectId, registration: $registration)
  }
`;
export type RDeleteXapiStateMutationFn = Apollo.MutationFunction<RDeleteXapiStateMutation, RDeleteXapiStateMutationVariables>;

/**
 * __useDeleteXapiStateMutationRemote__
 *
 * To run a mutation, you first call `useDeleteXapiStateMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteXapiStateMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteXapiStateMutationRemote, { data, loading, error }] = useDeleteXapiStateMutationRemote({
 *   variables: {
 *      targetUserId: // value for 'targetUserId'
 *      objectId: // value for 'objectId'
 *      registration: // value for 'registration'
 *   },
 * });
 */
export function useDeleteXapiStateMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RDeleteXapiStateMutation, RDeleteXapiStateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RDeleteXapiStateMutation, RDeleteXapiStateMutationVariables>(DeleteXapiStateDocument, options);
}
export type DeleteXapiStateMutationRemoteHookResult = ReturnType<typeof useDeleteXapiStateMutationRemote>;
export type DeleteXapiStateMutationResult = Apollo.MutationResult<RDeleteXapiStateMutation>;
export type DeleteXapiStateMutationOptions = Apollo.BaseMutationOptions<
  RDeleteXapiStateMutation,
  RDeleteXapiStateMutationVariables
>;
export const SearchSubordinateUsersByEmailDocument = gql`
  query searchSubordinateUsersByEmail($input: SearchSubordinateUsersInput, $limit: Int) {
    searchSubordinateUsersByEmail(payload: $input, limit: $limit) {
      id
      email
      username
    }
  }
`;

/**
 * __useSearchSubordinateUsersByEmailQueryRemote__
 *
 * To run a query within a React component, call `useSearchSubordinateUsersByEmailQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useSearchSubordinateUsersByEmailQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSubordinateUsersByEmailQueryRemote({
 *   variables: {
 *      input: // value for 'input'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchSubordinateUsersByEmailQueryRemote(
  baseOptions?: Apollo.QueryHookOptions<RSearchSubordinateUsersByEmailQuery, RSearchSubordinateUsersByEmailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RSearchSubordinateUsersByEmailQuery, RSearchSubordinateUsersByEmailQueryVariables>(
    SearchSubordinateUsersByEmailDocument,
    options,
  );
}
export function useSearchSubordinateUsersByEmailLazyQueryRemote(
  baseOptions?: Apollo.LazyQueryHookOptions<RSearchSubordinateUsersByEmailQuery, RSearchSubordinateUsersByEmailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RSearchSubordinateUsersByEmailQuery, RSearchSubordinateUsersByEmailQueryVariables>(
    SearchSubordinateUsersByEmailDocument,
    options,
  );
}
export type SearchSubordinateUsersByEmailQueryRemoteHookResult = ReturnType<typeof useSearchSubordinateUsersByEmailQueryRemote>;
export type SearchSubordinateUsersByEmailLazyQueryRemoteHookResult = ReturnType<
  typeof useSearchSubordinateUsersByEmailLazyQueryRemote
>;
export type SearchSubordinateUsersByEmailQueryResult = Apollo.QueryResult<
  RSearchSubordinateUsersByEmailQuery,
  RSearchSubordinateUsersByEmailQueryVariables
>;
export const SetUserStatusDocument = gql`
  mutation setUserStatus($input: SetUserStatusInput) {
    setUserStatus(payload: $input)
  }
`;
export type RSetUserStatusMutationFn = Apollo.MutationFunction<RSetUserStatusMutation, RSetUserStatusMutationVariables>;

/**
 * __useSetUserStatusMutationRemote__
 *
 * To run a mutation, you first call `useSetUserStatusMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserStatusMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserStatusMutationRemote, { data, loading, error }] = useSetUserStatusMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserStatusMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RSetUserStatusMutation, RSetUserStatusMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RSetUserStatusMutation, RSetUserStatusMutationVariables>(SetUserStatusDocument, options);
}
export type SetUserStatusMutationRemoteHookResult = ReturnType<typeof useSetUserStatusMutationRemote>;
export type SetUserStatusMutationResult = Apollo.MutationResult<RSetUserStatusMutation>;
export type SetUserStatusMutationOptions = Apollo.BaseMutationOptions<RSetUserStatusMutation, RSetUserStatusMutationVariables>;
export const UpdateUsersDocument = gql`
  mutation updateUsers($input: UserChangeInput!) {
    updateUser(input: $input) {
      id
    }
  }
`;
export type RUpdateUsersMutationFn = Apollo.MutationFunction<RUpdateUsersMutation, RUpdateUsersMutationVariables>;

/**
 * __useUpdateUsersMutationRemote__
 *
 * To run a mutation, you first call `useUpdateUsersMutationRemote` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsersMutationRemote` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsersMutationRemote, { data, loading, error }] = useUpdateUsersMutationRemote({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUsersMutationRemote(
  baseOptions?: Apollo.MutationHookOptions<RUpdateUsersMutation, RUpdateUsersMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RUpdateUsersMutation, RUpdateUsersMutationVariables>(UpdateUsersDocument, options);
}
export type UpdateUsersMutationRemoteHookResult = ReturnType<typeof useUpdateUsersMutationRemote>;
export type UpdateUsersMutationResult = Apollo.MutationResult<RUpdateUsersMutation>;
export type UpdateUsersMutationOptions = Apollo.BaseMutationOptions<RUpdateUsersMutation, RUpdateUsersMutationVariables>;
export const UserByIdDocument = gql`
  query userById($userId: Float!) {
    user(id: $userId) {
      id
      email
      realm
      firstname
      lastname
      username
      status
      statusV2
      profileImage
      lastPasswordUpdate
      language
      lastActive
      timestamp
      externalId
    }
  }
`;

/**
 * __useUserByIdQueryRemote__
 *
 * To run a query within a React component, call `useUserByIdQueryRemote` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQueryRemote` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQueryRemote({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserByIdQueryRemote(baseOptions: Apollo.QueryHookOptions<RUserByIdQuery, RUserByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RUserByIdQuery, RUserByIdQueryVariables>(UserByIdDocument, options);
}
export function useUserByIdLazyQueryRemote(baseOptions?: Apollo.LazyQueryHookOptions<RUserByIdQuery, RUserByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RUserByIdQuery, RUserByIdQueryVariables>(UserByIdDocument, options);
}
export type UserByIdQueryRemoteHookResult = ReturnType<typeof useUserByIdQueryRemote>;
export type UserByIdLazyQueryRemoteHookResult = ReturnType<typeof useUserByIdLazyQueryRemote>;
export type UserByIdQueryResult = Apollo.QueryResult<RUserByIdQuery, RUserByIdQueryVariables>;
